import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Inject, createComponent, Component, Optional, Input, Pipe, NgModule, Directive, createNgModule, ViewChild, ChangeDetectionStrategy, ViewChildren, inject, PLATFORM_ID, HostListener, EventEmitter, Output, Injector, ViewEncapsulation, ContentChild } from '@angular/core';
import * as i1 from '@angular/router';
import { ActivationEnd, ActivatedRouteSnapshot, Router, NavigationEnd, RoutesRecognized, ActivationStart, NavigationStart, RouterModule } from '@angular/router';
import { differenceInCalendarDays, startOfToday, startOfYesterday, startOfTomorrow, addDays, subDays, addMonths, subMonths, addYears, subYears } from 'date-fns';
import { EMPTY, take, Subject, Observable, ReplaySubject, of, map as map$1, takeUntil as takeUntil$1, catchError, fromEvent, timer, interval, switchMap, debounceTime as debounceTime$1, distinctUntilChanged, first as first$1, combineLatest, throwError, lastValueFrom, finalize as finalize$1 } from 'rxjs';
import * as i1$1 from '@angular/common/http';
import { HttpResponse, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import * as i1$2 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { filter, map, first, finalize, tap, takeUntil, take as take$1, debounceTime, mergeMap, catchError as catchError$1, switchMap as switchMap$1, startWith, combineLatestWith } from 'rxjs/operators';
import * as i3 from '@angular/common';
import { DOCUMENT, CommonModule, DatePipe, isPlatformServer, formatDate, isPlatformBrowser } from '@angular/common';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3$1 from '@angular/platform-browser';
import { makeStateKey } from '@angular/platform-browser';
import { v4 } from 'uuid';
import * as i3$3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i3$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import * as i5 from '@angular/material/expansion';
import { MatExpansionPanel, MatExpansionModule } from '@angular/material/expansion';
import * as i9$2 from '@angular/google-maps';
import { GoogleMapsModule, MapInfoWindow } from '@angular/google-maps';
import * as i14 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i16 from 'ngx-print';
import { NgxPrintModule } from 'ngx-print';
import * as i12 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i6 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i2 from '@angular/material/core';
import { MAT_DATE_LOCALE, NativeDateAdapter, MatNativeDateModule, DateAdapter } from '@angular/material/core';
import * as i1$4 from '@angular/material/datepicker';
import { MatCalendarHeader, MatDatepickerModule } from '@angular/material/datepicker';
import * as i10 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i12$1 from '@angular/material/input';
import { MatInput, MatInputModule } from '@angular/material/input';
import * as i8 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i6$1 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i4$1 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i9 from '@angular/material/select';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import * as i10$1 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i11 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import * as i5$1 from '@angular/forms';
import { UntypedFormControl, FormControl, UntypedFormGroup, FormGroup, UntypedFormArray, FormArray, AbstractControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as i13 from '@ngneat/input-mask';
import { createMask, InputMaskModule } from '@ngneat/input-mask';
import * as i11$1 from '@angular/cdk/text-field';
import * as i2$1 from '@swimlane/ngx-charts';
import { BarOrientation, PlacementTypes, StyleTypes, formatLabel, BaseChartComponent, LegendPosition, ScaleType, Orientation, calculateViewDimensions, ColorHelper, LineSeriesComponent, NgxChartsModule } from '@swimlane/ngx-charts';
import * as i6$2 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i4$2 from '@angular/cdk/overlay';
import * as i22 from '@angular/cdk/clipboard';
import * as i4$3 from 'ngx-dropzone';
import { NgxDropzonePreviewComponent, NgxDropzoneModule } from 'ngx-dropzone';
import { COMMA } from '@angular/cdk/keycodes';
import * as i6$3 from '@ckeditor/ckeditor5-angular';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import * as i9$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i8$1 from 'ngx-material-timepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import * as i7 from '@angular-slider/ngx-slider';
import { LabelType, NgxSliderModule } from '@angular-slider/ngx-slider';
import { curveLinear } from 'd3-shape';
import { scaleTime, scaleLinear, scalePoint, scaleBand } from 'd3-scale';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import SwiperCore, { Autoplay, Pagination, Navigation, Thumbs, Zoom } from 'swiper';
import * as i8$2 from 'swiper/angular';
import { SwiperModule } from 'swiper/angular';
import * as i10$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i11$2 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule, CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import * as i14$1 from 'ng-recaptcha';
import * as i6$4 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import * as i9$3 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i8$3 from '@angular/material/menu';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import * as i11$3 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i3$4 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i10$3 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDividerModule } from '@angular/material/divider';
import * as i11$4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i16$1 from '@angular/material/table';
import { MatTable, MatTableModule } from '@angular/material/table';
import { FlatTreeControl } from '@angular/cdk/tree';
import * as i13$1 from '@angular/material/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatTreeModule } from '@angular/material/tree';
import * as i10$4 from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import * as i2$2 from '@abacritt/angularx-social-login';
import { FacebookLoginProvider, SocialLoginModule } from '@abacritt/angularx-social-login';
import * as i4$4 from 'ngx-sharebuttons/button';
import { ShareButtonModule } from 'ngx-sharebuttons/button';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import * as i1$5 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

class HelperService {
    constructor(urlSerializer) {
        this.urlSerializer = urlSerializer;
    }
    /**
     * Set a value at a specific path in the result object
     *
     * @param path
     * @param value
     * @param result
     */
    setObjectPath(path, value, result) {
        path.split(".").reduce((obj, item, idx, pathSplit) => {
            if (idx === pathSplit.length - 1) {
                if (typeof value === "string" && value.indexOf(",") >= 0) {
                    value = value.split(",");
                }
                if (typeof value === 'undefined') {
                    delete obj[item];
                    return obj;
                }
                else {
                    return (obj[item] = value);
                }
            }
            if (typeof obj[item] === "undefined") {
                return (obj[item] = {});
            }
            else {
                return obj[item];
            }
        }, result);
    }
    /**
   * Simple object check.
   * @param item
   * @returns {boolean}
   */
    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    mergeDeep(target, ...sources) {
        if (!sources.length)
            return target;
        const source = sources.shift();
        if (this.isObject(target) && this.isObject(source)) {
            for (const key in source) {
                if (this.isObject(source[key])) {
                    if (!target[key])
                        Object.assign(target, { [key]: {} });
                    this.mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return this.mergeDeep(target, ...sources);
    }
    /**
     * parses date string according to an expected format
     *
     * @param value date string
     * @param format expected date format (Examples: yyyy-MM-dd, dd/mm/yyyy...)
     * @returns
     */
    parseDate(value, format) {
        const formatRegex = /(?:[d]+)|(?:[m]+)|(?:[y]+)/gi;
        const formatSequence = format.match(formatRegex);
        const valueRegex = /(?:[0-9]+)|(?:[0-9]+])|(?:[0-9]+)/g;
        const valueSequence = value.match(valueRegex);
        const dateSequence = { d: 0, m: 0, y: 0 };
        if (!valueSequence || !formatSequence) {
            throw new Error('date format: ' + format + ' does not match value: ' + value);
        }
        for (const i in formatSequence) {
            if (formatSequence[i].length > valueSequence[i].length + 1
                || formatSequence[i].length < valueSequence[i].length) {
                throw new Error('date format: ' + format + ' does not match value: ' + value);
            }
            const key = formatSequence[i][0].toLowerCase();
            dateSequence[key] = valueSequence[i];
        }
        return new Date(dateSequence.y, dateSequence.m - 1, dateSequence.d);
    }
    diffCalendarDays(earlierDate, laterDate) {
        if (typeof earlierDate === 'string') {
            earlierDate = new Date(earlierDate);
        }
        if (typeof laterDate === 'string') {
            laterDate = new Date(laterDate);
        }
        return Math.min(0, differenceInCalendarDays(laterDate, earlierDate));
    }
    urlToRoute(url) {
        let route;
        if (url.includes(';')) {
            const urlTree = this.urlSerializer.parse(url);
            route = ['/'];
            for (const segment of urlTree.root.children.primary.segments) {
                route.push(segment.path);
                route.push(segment.parameters);
            }
        }
        else {
            route = [url];
        }
        return route;
    }
}
HelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelperService, deps: [{ token: i1.UrlSerializer }], target: i0.ɵɵFactoryTarget.Injectable });
HelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelperService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: i1.UrlSerializer }]; } });

class CacheService {
    constructor(helper) {
        this.helper = helper;
        this.cache = {};
    }
    set(key, value) {
        this.helper.setObjectPath(key, value, this.cache);
    }
    get(key) {
        let path = key.split('.');
        let entry;
        entry = this.cache[path[0]];
        if (path.length > 1) {
            path.shift();
            for (const i of path) {
                let item = i;
                if (!isNaN(+i)) {
                    item = parseInt(i);
                }
                if (entry instanceof Array
                    && typeof item === 'string') {
                    if (entry.length === 0) {
                        return false;
                    }
                    const result = [];
                    entry.forEach((arrayItem) => {
                        if (arrayItem) {
                            result.push(arrayItem[item]);
                        }
                    });
                    entry = result;
                }
                else {
                    if (typeof entry === 'undefined') {
                        return false;
                    }
                    if (entry != null) {
                        entry = entry[item];
                    }
                }
            }
        }
        return entry;
    }
    getAll() {
        return this.cache;
    }
    remove(key) {
        this.helper.setObjectPath(key, undefined, this.cache);
    }
}
CacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CacheService, deps: [{ token: HelperService }], target: i0.ɵɵFactoryTarget.Injectable });
CacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HelperService }]; } });

function normalizeCommonJSImport(importPromise) {
    // CommonJS's `module.exports` is wrapped as `default` in ESModule.
    return importPromise.then((m) => (m.default || m));
}

const SESSION_STORAGE = new InjectionToken('Session Storage', {
    providedIn: 'root',
    factory: () => sessionStorage
});
class SessionService {
    constructor(helper, storage) {
        this.helper = helper;
        this.storage = storage;
        this.globalSession = {};
    }
    get(key) {
        let path = key.split('.');
        let entry;
        try {
            entry = JSON.parse(this.storage.getItem(path[0]));
        }
        catch (e) {
            entry = this.storage.getItem(path[0]);
        }
        if (path.length > 1) {
            path.shift();
            for (const i of path) {
                let item = i;
                if (!isNaN(+i)) {
                    item = parseInt(i);
                }
                if (entry instanceof Array
                    && typeof item === 'string') {
                    if (entry.length === 0) {
                        return undefined;
                    }
                    const result = [];
                    entry.forEach((arrayItem) => {
                        if (arrayItem) {
                            result.push(arrayItem[item]);
                        }
                    });
                    entry = result;
                }
                else {
                    if (typeof entry === 'undefined') {
                        return undefined;
                    }
                    if (entry != null) {
                        entry = entry[item];
                    }
                }
            }
        }
        return entry;
    }
    set(path, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        const pathSplit = path.split('.');
        let key = pathSplit.shift();
        if (key) {
            if (pathSplit.length > 0) {
                const storedValue = this.storage.getItem(key);
                let resultValue = {};
                if (storedValue) {
                    resultValue = JSON.parse(storedValue);
                }
                this.helper.setObjectPath(pathSplit.join('.'), value, resultValue);
                this.storage.setItem(key, JSON.stringify(resultValue));
            }
            else {
                this.storage.setItem(key, String(value));
            }
        }
    }
    getAll() {
        this.storage;
    }
    remove(path) {
        const pathSplit = path.split('.');
        let key = pathSplit.shift();
        if (key) {
            if (pathSplit.length > 0) {
                let data = this.storage.getItem(key);
                let resultData = {};
                if (data) {
                    resultData = JSON.parse(data);
                }
                let i = 1;
                for (const item of pathSplit) {
                    if (typeof resultData[item] !== 'undefined') {
                        if (i === pathSplit.length) {
                            delete resultData[item];
                        }
                        else {
                            resultData = resultData[item];
                        }
                    }
                    else {
                        break;
                    }
                    i++;
                }
                this.storage.setItem(key, JSON.stringify(resultData));
            }
            else {
                this.storage.removeItem(key);
            }
        }
    }
    setGlobalVar(key, value) {
        this.globalSession[key] = value;
    }
    getGlobalVar(key) {
        return this.globalSession[key];
    }
    removeGlobalVar(key) {
        delete this.globalSession[key];
    }
}
SessionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionService, deps: [{ token: HelperService }, { token: SESSION_STORAGE }], target: i0.ɵɵFactoryTarget.Injectable });
SessionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HelperService }, { type: Storage, decorators: [{
                    type: Inject,
                    args: [SESSION_STORAGE]
                }] }]; } });

const BROWSER_STORAGE = new InjectionToken('Local Storage', {
    providedIn: 'root',
    factory: () => localStorage
});
class StateService {
    constructor(storage) {
        this.storage = storage;
    }
    get(key) {
        let path = key.split('.');
        let entry;
        try {
            entry = JSON.parse(this.storage.getItem(path[0]));
        }
        catch (e) {
            entry = this.storage.getItem(path[0]);
        }
        if (path.length > 1) {
            path.shift();
            for (const i of path) {
                let item = i;
                if (!isNaN(+i)) {
                    item = parseInt(i);
                }
                if (entry instanceof Array
                    && typeof item === 'string') {
                    if (entry.length === 0) {
                        return undefined;
                    }
                    const result = [];
                    entry.forEach((arrayItem) => {
                        if (arrayItem) {
                            result.push(arrayItem[item]);
                        }
                    });
                    entry = result;
                }
                else {
                    if (typeof entry === 'undefined') {
                        return undefined;
                    }
                    if (entry != null) {
                        entry = entry[item];
                    }
                }
            }
        }
        return entry;
    }
    getAll() {
        return this.storage;
    }
    set(key, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.storage.setItem(key, value);
    }
    remove(key) {
        this.storage.removeItem(key);
    }
}
StateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StateService, deps: [{ token: BROWSER_STORAGE }], target: i0.ɵɵFactoryTarget.Injectable });
StateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Storage, decorators: [{
                    type: Inject,
                    args: [BROWSER_STORAGE]
                }] }]; } });

class GetArrayPathService {
    constructor(state, session, cache, helper, router) {
        this.state = state;
        this.session = session;
        this.cache = cache;
        this.helper = helper;
        this.router = router;
        this.router.events.subscribe((event) => {
            if (event instanceof ActivationEnd) {
                this.route = event.snapshot;
            }
        });
    }
    get(input, path = '') {
        let clonedPath;
        if ((path[0] === 'storage'
            || typeof input === 'undefined'
            || input === null)
            && Array.isArray(path)) {
            clonedPath = [...path];
            if (clonedPath[0] === 'storage') {
                clonedPath.shift();
            }
            const storage = this[clonedPath[0]];
            if (typeof storage === 'undefined') {
                return undefined;
            }
            clonedPath.shift();
            if (storage instanceof StateService
                || storage instanceof CacheService
                || storage instanceof SessionService) {
                if (clonedPath.length === 0) {
                    return storage.getAll();
                }
                const location = clonedPath.join('.');
                if (typeof storage.get !== 'undefined') {
                    return storage.get(location);
                }
                else {
                    return storage[location];
                }
            }
            if (storage instanceof ActivatedRouteSnapshot) {
                const parsedRouteParams = {};
                for (const paramKey in storage.params) {
                    if (paramKey.indexOf('.') >= 0) {
                        this.helper.setObjectPath(paramKey, storage.params[paramKey], parsedRouteParams);
                    }
                    else {
                        parsedRouteParams[paramKey] = storage.params[paramKey];
                    }
                }
                input = {
                    params: parsedRouteParams,
                    queryParams: storage.queryParams,
                    fragment: storage.fragment,
                    url: storage.routeConfig?.path
                };
            }
        }
        else {
            clonedPath = path;
        }
        if (clonedPath) {
            if (typeof clonedPath === 'string') {
                if (typeof input === 'undefined' || input === null) {
                    return undefined;
                }
                input = input[clonedPath];
            }
            else {
                for (const item of clonedPath) {
                    if (input instanceof Array
                        && typeof item === 'string'
                        && isNaN(+item)) {
                        if (input.length === 0) {
                            return undefined;
                        }
                        const result = [];
                        input.forEach((arrayItem) => {
                            if (arrayItem) {
                                result.push(arrayItem[item]);
                            }
                        });
                        input = result;
                    }
                    else {
                        if (typeof input === 'undefined') {
                            return undefined;
                        }
                        if (input != null) {
                            input = input[item];
                        }
                    }
                }
            }
        }
        return input;
    }
}
GetArrayPathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathService, deps: [{ token: StateService }, { token: SessionService }, { token: CacheService }, { token: HelperService }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
GetArrayPathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: StateService }, { type: SessionService }, { type: CacheService }, { type: HelperService }, { type: i1.Router }]; } });

class EvalService {
    constructor(getArrayPath) {
        this.getArrayPath = getArrayPath;
        this.fn = {
            '===': (a, b) => {
                if (typeof a === 'object' && typeof b === 'object') {
                    return JSON.stringify(a) === JSON.stringify(b);
                }
                else {
                    return a === b;
                }
            },
            '==': (a, b) => {
                if (typeof a === 'object' && typeof b === 'object') {
                    return JSON.stringify(a) == JSON.stringify(b);
                }
                else {
                    return a == b;
                }
            },
            '!==': (a, b) => {
                if (typeof a === 'object' && typeof b === 'object') {
                    return JSON.stringify(a) !== JSON.stringify(b);
                }
                else {
                    return a !== b;
                }
            },
            '!=': (a, b) => {
                if (typeof a === 'object' && typeof b === 'object') {
                    return JSON.stringify(a) != JSON.stringify(b);
                }
                else {
                    return a != b;
                }
            },
            '<': (a, b) => a < b,
            '>': (a, b) => a > b,
            '<=': (a, b) => a <= b,
            '>=': (a, b) => a >= b,
            between: (a, b) => a >= b[0] && a <= b[1],
            typeof: (a, b) => typeof a === b,
            in: (a, b) => b.indexOf(a) >= 0,
            notIn: (a, b) => b.indexOf(a) < 0,
            contains: (a, b) => a.indexOf(b) >= 0,
            excludes: (a, b) => a.indexOf(b) < 0,
            objNotInArr: (a, b) => {
                if (!Array.isArray(a)
                    || typeof b !== 'object') {
                    throw new Error('Condition objNotInArr expects an array and object as input');
                }
                if (a.find((e) => e.id === b.id)) {
                    return false;
                }
                else {
                    return true;
                }
            },
            keyExists: (a, b) => {
                if (typeof a === 'undefined') {
                    return false;
                }
                if (b.indexOf('*') < 0) {
                    return typeof a[b] !== 'undefined' && a[b] !== null;
                }
                else {
                    for (const k in a) {
                        if (k.startsWith(b.substring(0, b.indexOf('*')))) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            keyDoesntExist: (a, b) => {
                if (typeof a === 'undefined') {
                    return true;
                }
                return typeof a[b] === 'undefined' || a[b] === null;
            },
            isObjectNotEmpty: (a, b) => {
                return typeof a[b] !== 'undefined' &&
                    typeof a[b] !== null &&
                    a[b] !== null &&
                    Object.keys(a[b]).length > 0;
            },
            startsWith: (a, b) => typeof a === 'string' && a.startsWith(b),
            endsWith: (a, b) => typeof a === 'string' && a.endsWith(b),
            doesntEndWith: (a, b) => typeof a !== 'string' || !a.endsWith(b),
            isCountGt: (a, b) => {
                return Array.isArray(a) && a.length > b;
            },
            isCountGte: (a, b) => {
                return Array.isArray(a) && a.length >= b;
            },
            isCountLte: (a, b) => {
                return Array.isArray(a) && a.length <= b;
            },
            isCountLt: (a, b) => {
                return Array.isArray(a) && a.length < b;
            },
            isOlderThan: (a, b) => {
                a = new Date(a);
                const now = new Date();
                const interval = '-' + b;
                b = this.modifyDate(now, interval);
                return a.getTime() < b.getTime();
            },
            isNewerThan: (a, b) => {
                a = new Date(a);
                const now = new Date();
                const interval = '-' + b;
                b = this.modifyDate(now, interval);
                return a.getTime() >= b.getTime();
            }
        };
    }
    exec(data, conditions, bData) {
        if (Array.isArray(conditions)) {
            const stack = [];
            for (const idx in conditions) {
                if (Array.isArray(data)) {
                    stack.push(this.evalCondition(data[idx], conditions[idx], bData ? bData[idx] : undefined));
                }
                else {
                    stack.push(this.evalCondition(data, conditions[idx], bData));
                }
            }
            if (stack.indexOf(false) >= 0) {
                return false;
            }
            return true;
        }
        else {
            return this.evalCondition(data, conditions, bData);
        }
    }
    evalCondition(data, condition, bData) {
        if (typeof condition.any === 'undefined') {
            condition.any = false;
        }
        const a = this.getArrayPath.get(data, condition.path);
        let b;
        if (Array.isArray(condition.value)
            && ['in', 'notIn', 'between'].indexOf(condition.op) === -1) {
            if (typeof bData !== 'undefined') {
                b = this.getArrayPath.get(bData, condition.value);
            }
            else {
                b = this.getArrayPath.get(data, condition.value);
            }
        }
        else {
            if (condition.value === 'null') {
                b = null;
            }
            else {
                b = condition.value;
            }
        }
        let result;
        if (Array.isArray(a)
            && !condition.op.startsWith('isCount')
            && !condition.op.startsWith('keyExists')
            && !condition.op.startsWith('notIn')
            && !condition.op.startsWith('objNotInArr')) {
            const stack = [];
            for (const item of a) {
                stack.push(this.fn[condition.op](item, b));
            }
            if (condition.any) {
                result = false;
                if (stack.indexOf(true) >= 0) {
                    result = true;
                }
            }
            else {
                result = true;
                if (stack.indexOf(false) >= 0) {
                    result = false;
                }
            }
        }
        else {
            result = this.fn[condition.op](a, b);
        }
        return result;
    }
    modifyDate(date, offset) {
        const split = offset.split(' ');
        const capitalizedUnit = split[1].charAt(0).toUpperCase() + split[1].slice(1);
        const getter = 'get' + capitalizedUnit;
        const setter = 'set' + capitalizedUnit;
        const value = parseInt(split[0]);
        date[setter](date[getter]() + value);
        return date;
    }
}
EvalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EvalService, deps: [{ token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Injectable });
EvalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EvalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EvalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }]; } });

class ApiService {
    constructor(injector, evaluator, router, getArrayPath, helper, cache) {
        this.injector = injector;
        this.evaluator = evaluator;
        this.router = router;
        this.getArrayPath = getArrayPath;
        this.helper = helper;
        this.cache = cache;
        this.router.events.subscribe((event) => {
            if (event instanceof ActivationEnd) {
                this.route = event.snapshot;
            }
        });
    }
    async loadSdk(env) {
        this.env = env;
        const sdkLoader = normalizeCommonJSImport(env.sdk);
        this.sdk = await sdkLoader;
        const configService = this.injector.get(this.sdk.ConfigService);
        if (typeof env.accessPoints !== 'undefined') {
            for (const apName in env.accessPoints) {
                configService.setAccessPoint(env.accessPoints[apName], apName);
            }
        }
        else if (typeof env.apiAccessPoint !== 'undefined') {
            // deprecated
            const accessPoint = {
                url: env.apiAccessPoint,
            };
            if (typeof env.apiToken !== 'undefined') {
                accessPoint.token = env.apiToken;
            }
            configService.setAccessPoint(accessPoint);
        }
        else {
            throw 'No api access point configuration present in environment';
        }
    }
    getEnv() {
        return this.env;
    }
    getStatic(key) {
        return this.sdk[key];
    }
    getService(service) {
        return this.injector.get(this.sdk[service]);
    }
    prepServiceCallParams(params = {}) {
        // If params has dynamic params from route url - search and replace them
        const parsedParams = {};
        for (const param in this.route?.params) {
            if (param.indexOf('.') >= 0) {
                // if key is dot notation use it as destination path
                this.helper.setObjectPath(param, this.route.params[param], parsedParams);
            }
            else {
                parsedParams[param] = this.route.params[param];
            }
        }
        const stringParams = JSON.stringify(params);
        let replaced = stringParams;
        for (const key of Object.keys(parsedParams)) {
            let search = ':' + key;
            let value;
            if (typeof parsedParams[key] === 'object') {
                // if value to be set is an object
                // remote the quotes around the placeholder (:something)
                search = `\"${search}\"`;
                value = JSON.stringify(parsedParams[key]);
            }
            else {
                value = parsedParams[key];
            }
            replaced = replaced.replace(new RegExp(search, 'g'), value);
        }
        // match dot notation placeholders and process them as paths
        const dotNotRegex = /{[\w.-]+}/g;
        const matches = stringParams.match(dotNotRegex);
        if (Array.isArray(matches)) {
            for (const match of matches) {
                let value;
                const path = match.replace('{', '').replace('}', '').split('.');
                switch (path[0]) {
                    case 'route':
                    case 'state':
                    case 'session':
                    case 'cache':
                        value = this.getArrayPath.get(null, path);
                        break;
                    default:
                        value = this.getArrayPath.get(this.dataObject, path);
                        break;
                }
                if (typeof value === 'object') {
                    replaced = replaced.replace(`\"${match}\"`, JSON.stringify(value));
                }
                else {
                    replaced = replaced.replace(match, value);
                }
            }
        }
        if (replaced !== '') {
            params = { ...JSON.parse(replaced) };
        }
        const processedKeys = [];
        for (const param in params) {
            if (params[param]) {
                if ((typeof params[param] === "string"
                    && params[param].startsWith(":"))
                    || params[param] === 'undefined') {
                    // remove any remaining placeholders or undefined params
                    delete params[param];
                }
                if (param.indexOf(".") >= 0) {
                    // TODO make it work for recursuve nesting
                    const path = param.split('.');
                    path.pop();
                    const dest = this.getArrayPath.get(params, path);
                    if ((typeof dest === 'string' && dest.startsWith(':'))
                        || typeof dest === 'undefined') {
                        this.helper.setObjectPath(path.join('.'), {}, params);
                    }
                    else {
                        if (processedKeys.indexOf(path[0]) < 0) {
                            delete params[param];
                            continue;
                        }
                    }
                    // if key is still a dot notation use it as destination path
                    this.helper.setObjectPath(param, params[param], params);
                    delete params[param];
                }
                processedKeys.push(param);
            }
        }
        return params;
    }
    processConditionalParams(callDef, dataObject = null) {
        let params = {};
        if (typeof callDef.params !== 'undefined') {
            params = JSON.parse(JSON.stringify(callDef.params));
        }
        if (typeof callDef.conditionalParams !== 'undefined') {
            const conditionalParams = JSON.parse(JSON.stringify(callDef.conditionalParams));
            for (const item of conditionalParams) {
                if (item.condition) {
                    if (this.evaluator.exec(dataObject, item.condition)) {
                        delete item.condition;
                        Object.assign(params, item);
                    }
                }
                else {
                    throw new Error('Each conditionalParams object needs to contain' +
                        'at least one condition');
                }
            }
        }
        return params;
    }
    callServiceMethod(callDef, dataObject = null) {
        this.dataObject = dataObject;
        if (typeof callDef.condition !== "undefined" &&
            !this.evaluator.exec(null, callDef.condition)) {
            return EMPTY;
        }
        let page = 1;
        if (typeof this.route?.queryParams.page !== 'undefined') {
            // Set paging to query if comes from url
            page = this.route.queryParams.page;
        }
        let params = this.processConditionalParams(callDef, dataObject);
        params = this.prepServiceCallParams(params);
        return this.getService(callDef.service)[callDef.method](params, page);
    }
}
ApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ApiService, deps: [{ token: i0.Injector }, { token: EvalService }, { token: i1.Router }, { token: GetArrayPathService }, { token: HelperService }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Injectable });
ApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ApiService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: EvalService }, { type: i1.Router }, { type: GetArrayPathService }, { type: HelperService }, { type: CacheService }]; } });

class PermissionsService {
    constructor(api, state, cache) {
        this.api = api;
        this.state = state;
        this.cache = cache;
    }
    setPermissions(permissions) {
        this.permissions = permissions;
    }
    setRoles(roles) {
        this.roles = roles;
        this.state.set('roles', roles);
    }
    setSession(session) {
        this.setRoles(session.user.roles);
        this.setPermissions(session.permissions);
        const clonedResponse = JSON.parse(JSON.stringify(session));
        if (clonedResponse.permissions) {
            delete clonedResponse.permissions;
        }
        if (clonedResponse.status) {
            delete clonedResponse.status;
        }
        if (clonedResponse.user) {
            clonedResponse.userId = clonedResponse.user.id;
            delete clonedResponse.user;
        }
        this.state.set('session', clonedResponse);
        this.isSuperAdmin();
    }
    checkSession() {
        return new Promise((resolve) => {
            const userService = this.api.getService('UserService');
            userService.checkSession()
                .pipe(take(1))
                .subscribe((response) => {
                this.setSession(response.result);
                if (typeof response.result.user.id !== 'undefined') {
                    this.cache.set('auth', true);
                }
                else {
                    this.cache.set('auth', false);
                }
                resolve(response);
            });
        });
    }
    checkPermissions(object) {
        let result = true;
        if (this.isSuperAdmin()) {
            return true;
        }
        if (typeof object.requiredPermissions !== 'undefined') {
            if (typeof object.requireAnyPermission !== 'undefined'
                && object.requireAnyPermission === true) {
                // match any permission to allow access
                result = false;
                for (const element of object.requiredPermissions) {
                    if (typeof this.getPermissions(element) !== 'undefined') {
                        result = true;
                        break;
                    }
                }
            }
            else {
                // match all permissions to allow access
                result = object.requiredPermissions.every(element => {
                    return typeof this.getPermissions(element) !== 'undefined';
                });
            }
        }
        if (typeof object.absentPermissions !== 'undefined') {
            if (typeof object.anyAbsentPermissions !== 'undefined'
                && object.anyAbsentPermissions === true) {
                // match any permission to allow access
                result = false;
                for (const element of object.absentPermissions) {
                    if (typeof this.getPermissions(element) === 'undefined') {
                        result = true;
                        break;
                    }
                }
            }
            else {
                // match all permissions to allow access
                result = object.absentPermissions.every(element => {
                    return typeof this.getPermissions(element) === 'undefined';
                });
            }
        }
        return result;
    }
    getPermissions(key) {
        if (typeof key !== 'undefined' && key !== '') {
            return this.permissions[key];
        }
        return this.permissions;
    }
    isSuperAdmin() {
        this.superAdmin = false;
        if (typeof this.roles !== 'undefined') {
            this.roles.forEach(role => {
                if (role.key === 'super_admin') {
                    this.superAdmin = true;
                }
            });
        }
        return this.superAdmin;
    }
}
PermissionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, deps: [{ token: ApiService }, { token: StateService }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: StateService }, { type: CacheService }]; } });

class AuthGuard {
    constructor(router, cache, permissionService, api) {
        this.router = router;
        this.cache = cache;
        this.permissionService = permissionService;
        this.api = api;
    }
    canActivate(route) {
        let accessDeniedRedirect = '';
        if (typeof route.data.accessDeniedRedirect !== 'undefined') {
            accessDeniedRedirect = route.data.accessDeniedRedirect;
        }
        if (this.cache.get('auth') === true) {
            this.permissionService.checkSession().then((response) => {
                if (typeof response.result.user.roles === 'undefined' ||
                    typeof response.result.user.roles.find(item => item.key === 'guest') !== 'undefined') {
                    this.cache.set('auth', false);
                    this.router.navigate([accessDeniedRedirect]);
                }
                if (typeof response.result.user.status !== 'undefined') {
                    const environment = this.api.getEnv();
                    let userLockedRedirect = '';
                    if (typeof environment.defaultLockedRedirect !== 'undefined') {
                        userLockedRedirect = environment.defaultLockedRedirect;
                    }
                    if (typeof route.data.userLockedRedirect !== 'undefined') {
                        userLockedRedirect = route.data.userLockedRedirect;
                    }
                    if (userLockedRedirect) {
                        switch (response.result.user.status) {
                            case this.api.getStatic('USERSTATUS').LOCKED:
                                if (!Array.isArray(userLockedRedirect)) {
                                    userLockedRedirect = [userLockedRedirect];
                                }
                                this.router.navigate(userLockedRedirect);
                                break;
                        }
                    }
                }
            });
            if (this.permissionService.checkPermissions(route.routeConfig)) {
                return true;
            }
            else {
                this.router.navigate([accessDeniedRedirect]);
                return false;
            }
        }
        this.router.navigate([accessDeniedRedirect]);
        return false;
    }
}
AuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthGuard, deps: [{ token: i1.Router }, { token: CacheService }, { token: PermissionsService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: CacheService }, { type: PermissionsService }, { type: ApiService }]; } });

/**
 * DON'T USE PERMISSION GUARD FOR AUTHENTICATED USERS
 * USE AUTH GUARD INSTEAD
 */
class PermissionsGuard {
    constructor(router, permissionService) {
        this.router = router;
        this.permissionService = permissionService;
    }
    canActivate(next, state) {
        if (this.permissionService.checkPermissions(next.routeConfig)) {
            return true;
        }
        this.router.navigate(['']);
        return false;
    }
}
PermissionsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsGuard, deps: [{ token: i1.Router }, { token: PermissionsService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: PermissionsService }]; } });

class RoutingService {
    constructor(http, injector, api) {
        this.http = http;
        this.injector = injector;
        this.api = api;
        this.staticTypeMap = {
            AuthGuard, PermissionsGuard
        };
        this.components = {};
    }
    mapComponent(key, component) {
        this.components[key] = component;
    }
    getMappedComponent(key) {
        return this.components[key];
    }
    parseRoute(route) {
        if (route.canActivate) {
            // tslint:disable-next-line: forin
            for (const g in route.canActivate) {
                route.canActivate[g] = this.staticTypeMap[route.canActivate[g]];
            }
        }
        if (route.component) {
            const component = createComponent(this.components[route.component], {
                environmentInjector: this.injector
            });
            route.component = component.componentType;
        }
    }
    generateRoutes(locales) {
        const router = this.injector.get(Router);
        const factories = {};
        return new Promise((resolve, reject) => {
            const environment = this.api.getEnv();
            this.http.get('./assets/routing-mock.json?v=' + environment.version)
                .pipe(take(1))
                .subscribe((routing) => {
                const newRoutes = [];
                // tslint:disable-next-line: forin
                for (const i in routing) {
                    if (routing[i].path.indexOf(':locale') >= 0) {
                        for (const locale of locales) {
                            const newRoute = JSON.parse(JSON.stringify(routing[i]));
                            newRoute.path = newRoute.path.replace(':locale', locale);
                            const addedRoutes = this.generateOptionalRoutes(newRoute, newRoutes);
                            if (!addedRoutes) {
                                this.parseRoute(newRoute);
                                newRoutes.push(newRoute);
                            }
                        }
                        if (routing[i].path === ':locale') {
                            routing[i].path = "";
                        }
                        else {
                            routing.splice(parseInt(i), 1);
                        }
                    }
                    this.generateOptionalRoutes(routing[i], newRoutes);
                    this.parseRoute(routing[i]);
                }
                const notFoundRouteIdx = routing
                    .findIndex(route => route.path === '**');
                routing.splice(notFoundRouteIdx, 0, ...newRoutes);
                const routes = routing;
                router.resetConfig(routes);
                resolve();
            });
        });
    }
    generateOptionalRoutes(route, newRoutes) {
        const hasOptional = route.path.split('?');
        if (hasOptional.length > 1) {
            // if route path has optional parameters
            // (all after ? are considered optional
            // for example - products/:category/?:filter/:sort)
            // both filter and sort are optionals
            // create routes for all possible cases
            const optionalParams = hasOptional[1].split('/');
            let basePath;
            if (hasOptional[0].endsWith('/')) {
                basePath = hasOptional[0].slice(0, -1);
            }
            else {
                basePath = hasOptional[0];
            }
            route.path = basePath;
            for (const optional of optionalParams) {
                basePath += '/' + optional;
                const newRoute = JSON.parse(JSON.stringify(route));
                newRoute.path = basePath;
                this.parseRoute(newRoute);
                newRoutes.push(newRoute);
            }
            return true;
        }
        return false;
    }
}
RoutingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RoutingService, deps: [{ token: i1$1.HttpClient }, { token: i0.EnvironmentInjector }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
RoutingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RoutingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RoutingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i0.EnvironmentInjector }, { type: ApiService }]; } });

class LibrariesService {
    constructor(injector) {
        this.injector = injector;
        this.libraries = {};
    }
    async loadAll(env) {
        if (typeof env.libraries !== 'undefined') {
            Object.keys(env.libraries).forEach(key => {
                this.load(key, env.libraries[key]);
            });
        }
    }
    async load(name, library) {
        const loaded = normalizeCommonJSImport(library);
        this.libraries[name] = await loaded;
    }
    getService(library, service) {
        return this.injector.get(this.libraries[library][service]);
    }
}
LibrariesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LibrariesService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
LibrariesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LibrariesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LibrariesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class Event {
    constructor(name, data) {
        this.name = name;
        this.data = data;
    }
}

class EventBusService {
    constructor() {
        this.subject = new Subject();
    }
    fire(event) {
        this.subject.next(event);
    }
    on(eventName) {
        return this.subject.pipe(filter((e) => e.name === eventName), map((e) => e.data));
    }
}
EventBusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EventBusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EventBusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EventBusService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EventBusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class LanguageService {
    constructor(api, state, getArrayPath, eventBus, document) {
        this.api = api;
        this.state = state;
        this.getArrayPath = getArrayPath;
        this.eventBus = eventBus;
        this.document = document;
        this.labels = {};
        this.showLabelKeyIfNotFound = false;
    }
    setLanguage(locale) {
        if (this.state.get('languages.current')
            && this.state.get('language') !== this.state.get('languages.current')) {
            this.state.set('language', this.state.get('languages.current'));
        }
        let activeLanguage = this.state.get('language');
        if (typeof locale !== 'undefined') {
            activeLanguage = locale;
        }
        if (activeLanguage === null) {
            if (this.state.get('languages.current')) {
                activeLanguage = this.state.get('languages.current');
            }
            else {
                activeLanguage = this.state.get('languages.default');
            }
        }
        this.state.set('language', activeLanguage);
        this.getLabels({ locale: activeLanguage });
        this.activeLocale = activeLanguage;
        if (activeLanguage === 'ar') {
            this.document.body.setAttribute('dir', 'rtl');
        }
        else {
            this.document.body.setAttribute('dir', 'ltr');
        }
    }
    getLanguages() {
        const environment = this.api.getEnv();
        if (environment.showLabelKeyIfNotFound) {
            this.showLabelKeyIfNotFound = environment.showLabelKeyIfNotFound;
        }
        ;
        return new Promise((resolve, reject) => {
            const localeService = this.api.getService('LocaleService');
            localeService.getLocales()
                .pipe(take(1))
                .subscribe((response) => {
                response.result.full_locale_map = JSON.parse(JSON.stringify(response.result.full_locale_map).replace(/_/g, '-'));
                this.state.set('languages', response.result);
                resolve(response.result);
            });
        });
    }
    getFullLocale() {
        const map = this.state.get('languages.full_locale_map');
        return map[this.activeLocale];
    }
    getLabels(params) {
        const labelService = this.api.getService('LabelService');
        labelService.getPublished(params)
            .pipe(take(1))
            .subscribe((response) => {
            this.labels = response.result;
            // Fire labels loaded event
            this.eventBus.fire(new Event('labelsLoaded', this.labels));
        });
    }
    flatten(obj) {
        const flat = {};
        for (const i in obj) {
            if (obj.hasOwnProperty(i)) {
                if (typeof obj[i] === 'object' && obj[i] !== null && !Array.isArray(obj[i])) {
                    const flattened = this.flatten(obj[i]);
                    for (const ii in flattened) {
                        if (flattened.hasOwnProperty(ii)) {
                            flat[i + '.' + ii] = flattened[ii];
                        }
                    }
                }
                else {
                    flat[i] = obj[i];
                }
            }
        }
        return flat;
    }
    getLabel(label, params) {
        let key;
        let data;
        if (typeof label === 'object' && 'key' in label) {
            params = label.params;
            data = label.data;
            key = label.key;
        }
        else {
            key = label;
            data = null;
        }
        if (typeof key === 'undefined') {
            return this.showLabelKeyIfNotFound ? key : '';
        }
        for (const index in params) {
            if (key.search('{') < 0) {
                break;
            }
            else {
                let replacement;
                if (Array.isArray(params[index])) {
                    replacement = this.getArrayPath.get(data, params[index]);
                }
                else {
                    replacement = params[index];
                }
                key = key.replace('{' + index + '}', replacement);
            }
        }
        if (typeof this.labels[key] === 'undefined'
            && (this.showLabelKeyIfNotFound
                || (!key.includes('::') && !key.includes('_')) // return the key if it is not a label but and actual text
            )) {
            return key;
        }
        let text = this.labels[key];
        if (typeof params !== 'undefined' && typeof text !== 'undefined') {
            params = this.flatten(params);
            const placeholders = text.match('{.+?}');
            if (Array.isArray(placeholders)) {
                for (const p of placeholders) {
                    if (p.search('%') >= 0) {
                        // if placeholder is a sub label that varies by a param
                        // parse it and extract is text
                        let subLabel = p;
                        for (const index in params) {
                            if (subLabel.search('%') < 0) {
                                break;
                            }
                            else {
                                let replacement;
                                if (Array.isArray(params[index])) {
                                    replacement = this.getArrayPath.get(data, params[index]);
                                }
                                else {
                                    replacement = params[index];
                                }
                                subLabel = subLabel.replace('%' + index + '%', replacement)
                                    .replace('{', '')
                                    .replace('}', '');
                            }
                        }
                        // replace placeholder with the sub label text
                        const subLabelText = this.getLabel(subLabel, params);
                        text = text.replace(p, subLabelText);
                    }
                }
            }
            for (const index in params) {
                if (text.search('{') < 0) {
                    break;
                }
                else {
                    let replacement;
                    if (Array.isArray(params[index])) {
                        replacement = this.getArrayPath.get(data, params[index]);
                    }
                    else {
                        replacement = params[index];
                    }
                    text = text.replace('{' + index + '}', replacement);
                }
            }
        }
        return text;
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LanguageService, deps: [{ token: ApiService }, { token: StateService }, { token: GetArrayPathService }, { token: EventBusService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: StateService }, { type: GetArrayPathService }, { type: EventBusService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class ToastComponent {
    constructor(data, toast, language) {
        this.data = data;
        this.toast = toast;
        this.language = language;
    }
}
ToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ToastComponent, deps: [{ token: MAT_SNACK_BAR_DATA }, { token: i1$2.MatSnackBar }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
ToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ToastComponent, selector: "app-toast", ngImport: i0, template: "<p *ngFor=\"let message of data.messages\" [innerHTML]=\"language.getLabel(message)\"></p>\r\n<button mat-icon-button (click)=\"toast.dismiss()\">\r\n    <mat-icon>close</mat-icon>\r\n</button>\r\n", styles: ["button{position:absolute;top:0;right:0}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-toast', template: "<p *ngFor=\"let message of data.messages\" [innerHTML]=\"language.getLabel(message)\"></p>\r\n<button mat-icon-button (click)=\"toast.dismiss()\">\r\n    <mat-icon>close</mat-icon>\r\n</button>\r\n", styles: ["button{position:absolute;top:0;right:0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }, { type: i1$2.MatSnackBar }, { type: LanguageService }]; } });

class JsonRpcError extends Error {
    constructor(code, message, data) {
        super(message);
        this.code = code;
        this.name = 'JsonRpcError';
        this.data = data;
    }
}
class ErrorService {
    constructor(alert, zone, injector, state, cache, api) {
        this.alert = alert;
        this.zone = zone;
        this.injector = injector;
        this.state = state;
        this.cache = cache;
        this.api = api;
        this.customHandlers = {};
    }
    getRouter() {
        this.router = this.injector.get(Router);
    }
    showGeneralError(errors) {
        let messages = [];
        for (const i in errors) {
            if (errors[i] instanceof Array) {
                if (errors[i].length > 1) {
                    for (const ii of errors[i]) {
                        messages.push(ii);
                    }
                }
                else {
                    messages.push(errors[i]);
                }
            }
            else {
                messages = errors;
            }
        }
        const config = new MatSnackBarConfig();
        config.horizontalPosition = 'right';
        config.verticalPosition = 'top';
        config.panelClass = ['alert', 'alert-danger'];
        config.data = {
            messages
        };
        this.zone.run(() => {
            const toastRef = this.alert.openFromComponent(ToastComponent, config);
            this.router.events.pipe(first(event => event instanceof NavigationEnd))
                .subscribe((event) => {
                toastRef.dismiss();
            });
        });
    }
    401(error) {
        this.cache.set('auth', false);
        const environment = this.api.getEnv();
        if (typeof environment.errorRedirects[401] !== 'undefined') {
            if (environment.errorRedirects[401].type === 'external') {
                window.location.href = environment.errorRedirects[401].url;
            }
            else {
                this.router.navigate([environment.errorRedirects[401].url]);
            }
        }
        else {
            this.router.navigate(['login']);
        }
    }
    setCustomHandler(code, handler) {
        if (typeof this.customHandlers[code] !== 'undefined') {
            console.warn('ATTENTION: Custom handler (code: ' + code + ') already exists!');
        }
        this.customHandlers[code] = handler;
    }
    handleError(error) {
        this.getRouter();
        let messages = [];
        if (error instanceof Array) {
            for (const e of error) {
                if (e instanceof JsonRpcError) {
                    if (e.code === -32401) {
                        this.cache.set('auth', false);
                        this.router.navigate(['login']);
                    }
                    const errors = Object.values(e.data);
                    messages.push(...errors);
                }
            }
        }
        else if (error.name === 'JsonRpcError') {
            if (error.code === -32401) {
                this.cache.set('auth', false);
                this.router.navigate(['login']);
            }
            if (typeof error.data === 'string') {
                messages.push(error.data);
            }
            else if (typeof error.data === 'object' && error.data !== null) {
                messages = Object.values(error.data);
            }
            else {
                console.error(error);
            }
        }
        else if (typeof this.customHandlers[error.status] === 'function') {
            this.customHandlers[error.status](error);
        }
        else if (typeof this[error.status] !== 'undefined') {
            this[error.status](error);
        }
        else {
            console.error(error);
        }
        if (messages.length > 0) {
            this.showGeneralError(messages);
        }
    }
}
ErrorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ErrorService, deps: [{ token: i1$2.MatSnackBar }, { token: i0.NgZone }, { token: i0.Injector }, { token: StateService }, { token: CacheService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ErrorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ErrorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ErrorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.MatSnackBar }, { type: i0.NgZone }, { type: i0.Injector }, { type: StateService }, { type: CacheService }, { type: ApiService }]; } });

class SetupService {
    constructor(language, permissions, state, session, titleService, router, api) {
        this.language = language;
        this.permissions = permissions;
        this.state = state;
        this.session = session;
        this.titleService = titleService;
        this.router = router;
        this.api = api;
        this.router.events.subscribe(e => {
            if (e instanceof RoutesRecognized) {
                let lastUrlStack;
                try {
                    lastUrlStack = this.session.get('lastUrl');
                    if (lastUrlStack[lastUrlStack.length - 1] !== e.urlAfterRedirects) {
                        lastUrlStack.push(e.urlAfterRedirects);
                        if (lastUrlStack.length > 2) {
                            lastUrlStack.shift();
                        }
                        lastUrlStack = JSON.stringify(lastUrlStack);
                        this.session.set('lastUrl', lastUrlStack);
                    }
                }
                catch (err) {
                    lastUrlStack = JSON.stringify([e.urlAfterRedirects]);
                    this.session.set('lastUrl', lastUrlStack);
                }
            }
        });
    }
    init() {
        const environment = this.api.getEnv();
        this.state.set('light_logo', environment.light_logo);
        this.state.set('dark_logo', environment.dark_logo);
        this.titleService.setTitle(environment.title);
        this.language.setLanguage();
    }
}
SetupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SetupService, deps: [{ token: LanguageService }, { token: PermissionsService }, { token: StateService }, { token: SessionService }, { token: i3$1.Title }, { token: i1.Router }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
SetupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SetupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SetupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: PermissionsService }, { type: StateService }, { type: SessionService }, { type: i3$1.Title }, { type: i1.Router }, { type: ApiService }]; } });

class HotkeysService {
    constructor(eventManager, document) {
        this.eventManager = eventManager;
        this.document = document;
        this.defaults = {
            element: this.document
        };
    }
    addShortcut(options) {
        const merged = { ...this.defaults, ...options };
        const event = `keydown.${merged.keys}`;
        return new Observable(observer => {
            const handler = (e) => {
                e.preventDefault();
                observer.next(e);
            };
            const dispose = this.eventManager.addEventListener(merged.element, event, handler);
            return () => {
                dispose();
            };
        });
    }
}
HotkeysService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HotkeysService, deps: [{ token: i3$1.EventManager }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
HotkeysService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HotkeysService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HotkeysService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3$1.EventManager }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class CommunicationService {
    constructor(getArrayPath, evaluator, eventBus) {
        this.getArrayPath = getArrayPath;
        this.evaluator = evaluator;
        this.eventBus = eventBus;
        this.subjects = {};
    }
    buildChannel(definition, data) {
        let channel = '';
        if (Array.isArray(definition)) {
            for (const item of definition) {
                if (Array.isArray(item)) {
                    if (data) {
                        const dynamic = this.getArrayPath.get(data, item);
                        if (dynamic === undefined) {
                            console.warn('CHECK: Unable to build dynamic channel name. Verify this is not a problem!');
                            return v4();
                        }
                        channel += dynamic;
                    }
                    else {
                        throw new Error('Missing data request for channel name construction');
                    }
                }
                else {
                    channel += item;
                }
            }
        }
        else {
            channel = definition;
        }
        return channel;
    }
    getChannel(channelUidDef, recipient) {
        let channel = this.buildChannel(channelUidDef, recipient);
        if (typeof this.subjects[channel] === 'undefined') {
            this.subjects[channel] = new ReplaySubject();
            this.eventBus.fire(new Event('newChannelRegistered', channel));
        }
        return this.subjects[channel];
    }
    send(message) {
        const channel = this.buildChannel(message.channel, message.content.state);
        if (typeof this.subjects[channel] === 'undefined') {
            this.subjects[channel] = new ReplaySubject();
            this.eventBus.fire(new Event('newChannelRegistered', channel));
        }
        this.subjects[channel].next(message.content);
    }
    processMessage(message, recipient) {
        let i = 1;
        for (const key of message.target) {
            if (i < message.target.length) {
                recipient = recipient[key];
                i++;
            }
            else {
                switch (message.mode) {
                    case 'set':
                        let newValue;
                        if (typeof message.value !== 'undefined') {
                            // replace dot notation placeholders starting with state
                            // with the corresponding path in the message state
                            newValue = JSON.stringify(message.value);
                            const placeholders = newValue.match(/{[\w.-]+?}/g);
                            if (Array.isArray(placeholders)) {
                                for (const match of placeholders) {
                                    const path = match.replace('{', '').replace('}', '').split('.');
                                    // only if placeholder starts with "state."
                                    if (path[0] === 'state') {
                                        const replacement = this.getArrayPath.get(message, path);
                                        if (typeof replacement === 'object') {
                                            newValue = newValue.replace(`\"${match}\"`, JSON.stringify(replacement));
                                        }
                                        else {
                                            newValue = newValue.replace(match, replacement);
                                        }
                                    }
                                }
                            }
                            // if no change in the value, don't do anything else
                            if (JSON.stringify(recipient[key]) === newValue)
                                return;
                            newValue = JSON.parse(newValue);
                        }
                        else if (typeof message.valuePath !== 'undefined') {
                            newValue = this.getArrayPath.get(message.storageScope === 'storage' ? undefined : message.state, message.valuePath);
                        }
                        if (typeof newValue !== 'undefined') {
                            if (typeof message.condition !== 'undefined') {
                                let result;
                                if (message.condition.valueScope === 'messageValue') {
                                    result = this.evaluator.exec(recipient[key], message.condition, newValue);
                                }
                                else {
                                    result = this.evaluator.exec(recipient[key], message.condition);
                                }
                                // don't do anything else if condition is false
                                if (!result)
                                    return;
                            }
                            if (message.append) {
                                if (Array.isArray(recipient[key])) {
                                    recipient[key].push(newValue);
                                }
                                else {
                                    recipient[key] += +newValue;
                                }
                            }
                            else if (JSON.stringify(recipient[key]) !== JSON.stringify(newValue)) {
                                recipient[key] = newValue;
                            }
                        }
                        break;
                    case 'splice':
                        if (typeof message.position !== 'undefined') {
                            let value;
                            if (typeof message.value !== 'undefined') {
                                value = message.value;
                            }
                            if (typeof message.valuePath !== 'undefined') {
                                value = this.getArrayPath.get(message.state, message.valuePath);
                            }
                            if (typeof value === 'undefined' &&
                                typeof recipient[key][message.position] !== 'undefined') {
                                if (typeof message.condition !== 'undefined') {
                                    if (this.evaluator.exec(recipient[key][message.position], message.condition)) {
                                        recipient[key].splice(message.position, message.count ?? 1);
                                    }
                                }
                                else {
                                    recipient[key].splice(message.position, message.count ?? 1);
                                }
                            }
                            else {
                                if (typeof message.condition !== 'undefined') {
                                    if (message.condition.value == "{value}") {
                                        message.condition.value = value;
                                    }
                                    if (this.evaluator.exec(recipient[key], message.condition)) {
                                        value = Array.isArray(value) ? value : [value];
                                        recipient[key].splice(message.position, message.replace ?? 0, ...value);
                                    }
                                }
                                else {
                                    value = Array.isArray(value) ? value : [value];
                                    recipient[key].splice(message.position, message.replace ?? 0, ...value);
                                }
                            }
                        }
                        break;
                    case 'toggle':
                        const currentIndex = message.value.indexOf(recipient[key]);
                        recipient[key] = message.value[+!currentIndex];
                        break;
                    case 'call':
                        let params;
                        if (message.params === '$event') {
                            params = message.state.$event;
                            recipient[key](params);
                            break;
                        }
                        if (typeof message.params !== 'undefined') {
                            let value;
                            if (typeof message.valuePath !== 'undefined') {
                                value = JSON.stringify(this.getArrayPath.get(message.state, message.valuePath));
                            }
                            else {
                                value = JSON.stringify(message.state.value);
                            }
                            const clonedParams = JSON
                                .parse(JSON.stringify(message.params));
                            if (typeof clonedParams !== 'string') {
                                for (const p in clonedParams) {
                                    // properties that end in Path and have an array value are
                                    // considered as paths to the value
                                    if (p.endsWith('Path') && Array.isArray(clonedParams[p])) {
                                        const val = this.getArrayPath.get(message.state, clonedParams[p]);
                                        if (typeof val !== 'undefined') {
                                            clonedParams[p.replace('Path', '')] = val;
                                            delete clonedParams[p];
                                        }
                                    }
                                }
                            }
                            let replaced = JSON.stringify(clonedParams);
                            if (typeof value !== 'undefined') {
                                replaced = replaced.replace('"{value}"', value);
                            }
                            for (const stateParam in message.state) {
                                if (message.state[stateParam]) {
                                    if (isNaN(+message.state[stateParam])) {
                                        // prop 'target' is populated with DOM node
                                        // 'target' cannot be stringified, because there is
                                        // circular structure
                                        if (stateParam !== 'target'
                                            && stateParam !== 'control'
                                            && stateParam !== 'parentComponent'
                                            && stateParam !== 'parentForm') {
                                            replaced = replaced.replace('\":' + stateParam + '\"', JSON.stringify(message.state[stateParam]));
                                        }
                                    }
                                    else {
                                        replaced = replaced.replace('\":' + stateParam + '\"', message.state[stateParam]);
                                    }
                                }
                            }
                            if (replaced.indexOf('{value}') < 0) {
                                params = JSON.parse(replaced);
                            }
                        }
                        if (typeof params !== 'undefined') {
                            if (message.spreadParams) {
                                recipient[key](...Object.values(params));
                            }
                            else {
                                recipient[key](params);
                            }
                        }
                        else {
                            recipient[key]();
                        }
                        break;
                }
            }
        }
    }
    resetChannels(channelsToDestroy, data) {
        if (channelsToDestroy) {
            for (const item of channelsToDestroy) {
                let channel;
                if (typeof item === 'object') {
                    channel = this.buildChannel(item, data);
                }
                else {
                    channel = item;
                }
                if (this.subjects[channel]) {
                    this.subjects[channel].complete();
                    delete this.subjects[channel];
                }
            }
        }
        else {
            for (const k in this.subjects) {
                if (this.subjects[k]) {
                    this.subjects[k].complete();
                }
            }
            this.subjects = {};
        }
    }
}
CommunicationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CommunicationService, deps: [{ token: GetArrayPathService }, { token: EvalService }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Injectable });
CommunicationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CommunicationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CommunicationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }, { type: EvalService }, { type: EventBusService }]; } });

class LoaderComponent {
    constructor(dialogData, language) {
        this.dialogData = dialogData;
        this.language = language;
        this.diameter = 40;
        this.color = 'accent';
    }
    ngOnInit() {
        if (this.data?.diameter) {
            this.diameter = this.data.diameter;
        }
        if (this.data?.color) {
            this.color = this.data.color;
        }
        if (this.dialogData?.label) {
            this.label = this.dialogData.label;
        }
    }
}
LoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderComponent, deps: [{ token: MAT_DIALOG_DATA, optional: true }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
LoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: LoaderComponent, selector: "app-loader", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"d-flex align-items-center justyfy-content-center flex-column\">\r\n    <mat-spinner [diameter]=\"diameter\" [color]=\"color\"></mat-spinner>\r\n    <div *ngIf=\"label\" class=\"text-center p-2\"> {{ this.language.getLabel(label) }}</div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-loader', template: "<div class=\"d-flex align-items-center justyfy-content-center flex-column\">\r\n    <mat-spinner [diameter]=\"diameter\" [color]=\"color\"></mat-spinner>\r\n    <div *ngIf=\"label\" class=\"text-center p-2\"> {{ this.language.getLabel(label) }}</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class LoaderService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    show(label) {
        this.loader = this.dialog.open(LoaderComponent, {
            data: {
                label: label
            },
            hasBackdrop: true,
            disableClose: true,
        });
    }
    hide() {
        this.loader.close();
    }
}
LoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderService, deps: [{ token: i3$3.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
LoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3$3.MatDialog }]; } });

class GetQueryParamsAsObjectPipe {
    constructor() { }
    transform(params) {
        const queryParamsObject = {};
        for (const group in params) {
            if (typeof params[group] !== 'undefined') {
                const paramsObject = {};
                const groupParams = params[group].split(';');
                groupParams.forEach(element => {
                    const subGroupObjects = [];
                    const values = element.match(/\((.*)\)/);
                    if (values && values[1]) {
                        const splitSubGroup = values[1].split(':');
                        if (splitSubGroup.length > 1) {
                            this.parseGroup(values[1], subGroupObjects);
                            element = element.replace(values[0], '');
                            this.parseGroup(element, paramsObject, subGroupObjects);
                        }
                        else {
                            this.parseGroup(element, paramsObject);
                        }
                    }
                });
                queryParamsObject[group] = paramsObject;
            }
        }
        return queryParamsObject;
    }
    parseGroup(element, paramsObject, subGroup = null) {
        const splitGroup = element.split(':');
        if (splitGroup.length === 2) {
            paramsObject[splitGroup[0]] = splitGroup[1].replace(/[()]/g, '');
        }
        else if (splitGroup.length >= 3) {
            let values = '';
            let operator = '';
            let valuesSplit = [];
            // detect if there is an operator present
            if (splitGroup[2].startsWith('(')) {
                values = splitGroup[2];
            }
            else {
                values = splitGroup[3];
                operator = splitGroup[2];
            }
            // extract values
            if (!subGroup) {
                const result = values.match(/\((.*?)\)/);
                if (typeof result[1] !== 'undefined') {
                    valuesSplit = result[1].split(',');
                }
                paramsObject[splitGroup[0]] = {
                    constraint: splitGroup[1],
                    column: splitGroup[0],
                    operator,
                    values: valuesSplit
                };
            }
            else {
                paramsObject[splitGroup[0]] = {
                    constraint: splitGroup[1],
                    column: splitGroup[0],
                    subGroup
                };
            }
        }
        return paramsObject;
    }
}
GetQueryParamsAsObjectPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetQueryParamsAsObjectPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
GetQueryParamsAsObjectPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GetQueryParamsAsObjectPipe, name: "getQueryParamsAsObject" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetQueryParamsAsObjectPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'getQueryParamsAsObject',
                    pure: true
                }]
        }], ctorParameters: function () { return []; } });

class ObjectToQueryParamsPipe {
    transform(queryObject) {
        // tslint:disable-next-line: forin
        for (const group in queryObject) {
            let result = '';
            let count = 0;
            // tslint:disable-next-line: forin
            for (const param in queryObject[group]) {
                count++;
                if (typeof queryObject[group][param] === 'object') {
                    let tmpResult = param + ':' + queryObject[group][param].constraint;
                    if (typeof queryObject[group][param].values !== 'undefined') {
                        let values = queryObject[group][param].values;
                        if (Array.isArray(values)) {
                            values = values.join(',');
                        }
                        else if (typeof values === 'object') {
                            if (values.values === '()') {
                                continue;
                            }
                            values = Object.values(values).join(':');
                        }
                        let operator = '';
                        if (queryObject[group][param].operator) {
                            operator = ':' + queryObject[group][param].operator;
                        }
                        tmpResult += operator + ':(' + values + ')';
                    }
                    else if (typeof queryObject[group][param].subGroup !== 'undefined') {
                        tmpResult += ':';
                        // tslint:disable-next-line: forin
                        for (const subGroup in queryObject[group][param].subGroup) {
                            let values = queryObject[group][param].subGroup[subGroup].values;
                            if (Array.isArray(values)) {
                                values = values.join(',');
                            }
                            else if (typeof values === 'object') {
                                values = Object.values(values).join(':');
                            }
                            let operator = '';
                            if (queryObject[group][param].subGroup[subGroup].operator) {
                                operator = ':' + queryObject[group][param].subGroup[subGroup].operator;
                            }
                            tmpResult += '(' + subGroup + operator + ':';
                            tmpResult += queryObject[group][param].subGroup[subGroup].constraint;
                            tmpResult += ':(' + values + '))';
                        }
                    }
                    result += tmpResult;
                }
                else {
                    result += param + ':(' + queryObject[group][param] + ')';
                }
                if (Object.keys(queryObject[group]).length !== count) {
                    // if not last group
                    result += ';';
                }
            }
            queryObject[group] = result;
        }
        return queryObject;
    }
}
ObjectToQueryParamsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ObjectToQueryParamsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ObjectToQueryParamsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ObjectToQueryParamsPipe, name: "getObjectToQueryParams" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ObjectToQueryParamsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'getObjectToQueryParams',
                    pure: true
                }]
        }] });

class QueryPipesModule {
}
QueryPipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
QueryPipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: QueryPipesModule, declarations: [GetQueryParamsAsObjectPipe,
        ObjectToQueryParamsPipe], imports: [CommonModule], exports: [GetQueryParamsAsObjectPipe,
        ObjectToQueryParamsPipe] });
QueryPipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryPipesModule, providers: [
        GetQueryParamsAsObjectPipe,
        ObjectToQueryParamsPipe
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GetQueryParamsAsObjectPipe,
                        ObjectToQueryParamsPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        GetQueryParamsAsObjectPipe,
                        ObjectToQueryParamsPipe
                    ],
                    providers: [
                        GetQueryParamsAsObjectPipe,
                        ObjectToQueryParamsPipe
                    ]
                }]
        }] });

class LinkPipe {
    constructor(getArrayPath, urlSerializer) {
        this.getArrayPath = getArrayPath;
        this.urlSerializer = urlSerializer;
    }
    transform(input, linkDef = null) {
        if (!linkDef) {
            return null;
        }
        // if definition is only url return it
        if (!Array.isArray(linkDef)) {
            return linkDef;
        }
        // if definition is not only url
        if (Array.isArray(linkDef) && Array.isArray(linkDef[1])) {
            // if second key of definition is array use first as url
            linkDef = JSON.parse(JSON.stringify(linkDef));
            if (linkDef !== null) {
                const link = [linkDef[0]];
                if (linkDef.length > 1) {
                    // if definition has at least 2 keys remove first (url)
                    linkDef.shift();
                    // use second as array of parameter paths and append to url
                    for (const paramKey in linkDef) {
                        if (typeof linkDef[paramKey] !== 'undefined') {
                            const placeholder = '{' + paramKey + '}';
                            if (link[0].indexOf(placeholder) >= 0) {
                                link[0] = link[0].replace(placeholder, this.getArrayPath.get(input, linkDef[paramKey]));
                            }
                            else {
                                link.push(this.getArrayPath.get(input, linkDef[paramKey]));
                            }
                        }
                    }
                }
                return this.parseUrl(link.join('/'));
            }
            return null;
        }
        else {
            return this.parseUrl(this.getArrayPath.get(input, linkDef));
        }
    }
    parseUrl(url) {
        if (typeof url !== 'undefined' && url.includes(';')) {
            const urlTree = this.urlSerializer.parse(url);
            let route = ['/'];
            for (const segment of urlTree.root.children.primary.segments) {
                if (segment.path) {
                    route.push(segment.path);
                }
                if (Object.keys(segment.parameters).length > 0) {
                    route.push(segment.parameters);
                }
            }
            return route;
        }
        else {
            return url;
        }
    }
}
LinkPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LinkPipe, deps: [{ token: GetArrayPathService }, { token: i1.UrlSerializer }], target: i0.ɵɵFactoryTarget.Pipe });
LinkPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: LinkPipe, name: "link" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LinkPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'link',
                    pure: true
                }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }, { type: i1.UrlSerializer }]; } });

class LoaderInterceptor {
    constructor(loader, state, api, router) {
        this.loader = loader;
        this.state = state;
        this.api = api;
        this.router = router;
        this.router.events.subscribe((event) => {
            if (event instanceof ActivationStart) {
                this.route = event.snapshot;
            }
        });
        this.activeRequests = +this.state.get('activeRequest');
    }
    intercept(req, next) {
        let showLoader = true;
        if (typeof this.route?.data?.showLoader !== 'undefined') {
            showLoader = this.route.data.showLoader;
        }
        const environment = this.api.getEnv();
        if (showLoader && typeof environment.noLoaderRequests !== 'undefined') {
            for (const noLoader of environment.noLoaderRequests) {
                if (req.url.endsWith(noLoader.url)) {
                    if (typeof noLoader.body !== 'undefined') {
                        let bodyMatch = true;
                        for (const i in noLoader.body) {
                            if (typeof noLoader.body[i] !== 'object') {
                                if (req.body[i] !== noLoader.body[i]) {
                                    bodyMatch = false;
                                }
                            }
                            else {
                                if (!Array.isArray(noLoader.body[i])
                                    && typeof req.body[i] !== 'undefined') {
                                    for (const p in noLoader.body[i]) {
                                        if (typeof req.body[i][p] !== 'undefined'
                                            && req.body[i][p] !== noLoader.body[i][p]) {
                                            bodyMatch = false;
                                        }
                                    }
                                }
                            }
                        }
                        if (bodyMatch) {
                            showLoader = false;
                        }
                    }
                    else {
                        showLoader = false;
                    }
                }
            }
        }
        if (typeof req.body?.params?.noLoader !== "undefined") {
            showLoader = !req.body.params.noLoader;
            delete req.body.params.noLoader;
        }
        if (showLoader) {
            this.activeRequests++;
            this.state.set('activeRequests', this.activeRequests.toString());
            if (this.activeRequests === 1) {
                let label;
                if (typeof req.body?.params?.loaderLabel !== "undefined") {
                    label = req.body.params.loaderLabel;
                    delete req.body.params.loaderLabel;
                }
                this.loader.show(label);
            }
            return next.handle(req).pipe(finalize(() => {
                this.activeRequests--;
                this.state.set('activeRequests', this.activeRequests.toString());
                if (this.activeRequests === 0) {
                    this.loader.hide();
                }
            }));
        }
        else {
            return next.handle(req);
        }
    }
}
LoaderInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderInterceptor, deps: [{ token: LoaderService }, { token: StateService }, { token: ApiService }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
LoaderInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: LoaderService }, { type: StateService }, { type: ApiService }, { type: i1.Router }]; } });

class ServerStateInterceptor {
    constructor(transferState, request) {
        this.transferState = transferState;
        this.request = request;
    }
    intercept(req, next) {
        if (this.request?.headers?.cookie) //If optional request is provided, we are server side
         {
            req = req.clone({
                setHeaders: {
                    Cookie: this.request.headers.cookie
                }
            });
        }
        return next.handle(req).pipe(tap(event => {
            if ((event instanceof HttpResponse && (event.status === 200 || event.status === 202))) {
                const key = JSON.stringify({
                    url: req.url,
                    body: req.body
                });
                this.transferState.set(makeStateKey(key), event.body);
            }
        }));
    }
}
ServerStateInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ServerStateInterceptor, deps: [{ token: i3$1.TransferState }, { token: REQUEST }], target: i0.ɵɵFactoryTarget.Injectable });
ServerStateInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ServerStateInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ServerStateInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i3$1.TransferState }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REQUEST]
                }] }]; } });

class BrowserStateInterceptor {
    constructor(transferState, state, cache) {
        this.transferState = transferState;
        this.state = state;
        this.cache = cache;
    }
    intercept(req, next) {
        if (!this.cache.get('auth')) {
            const key = makeStateKey(JSON.stringify({
                url: req.url,
                body: req.body
            }));
            const storedResponse = this.transferState.get(key, null);
            if (storedResponse) {
                const response = new HttpResponse({ body: storedResponse, status: 200 });
                this.transferState.remove(key);
                return of(response);
            }
        }
        return next.handle(req);
    }
}
BrowserStateInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BrowserStateInterceptor, deps: [{ token: i3$1.TransferState }, { token: StateService }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Injectable });
BrowserStateInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BrowserStateInterceptor, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BrowserStateInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3$1.TransferState }, { type: StateService }, { type: CacheService }]; } });

const GOOGLE_TRANSLATE_API_KEY = new InjectionToken('google-key');
class GoogleTranslateService {
    constructor(http, apiKey) {
        this.http = http;
        this.apiKey = apiKey;
        this.googleEndPoint = 'https://translation.googleapis.com/language/translate/v2';
    }
    translate(sourceLang, targetLang, text) {
        return this.http.post(`${this.googleEndPoint}?key=${this.apiKey}`, {
            source: sourceLang,
            target: targetLang,
            q: text
        }).pipe(map$1(response => response.data.translations[0].translatedText));
    }
}
GoogleTranslateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleTranslateService, deps: [{ token: i1$1.HttpClient }, { token: GOOGLE_TRANSLATE_API_KEY }], target: i0.ɵɵFactoryTarget.Injectable });
GoogleTranslateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleTranslateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleTranslateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GOOGLE_TRANSLATE_API_KEY]
                }] }]; } });

class RelativeDateService {
    parse(expression) {
        let arg;
        let method = '';
        for (const word of expression.toLowerCase().split(' ')) {
            if (isNaN(Number(word))) {
                if (method === '') {
                    method += word;
                }
                else {
                    method += word[0].toUpperCase() + word.slice(1);
                }
            }
            else {
                arg = Number(word);
            }
        }
        if (typeof this[method] === 'function') {
            return this[method](arg);
        }
        else {
            throw new Error('Cannot understand expression: ' + expression +
                ' supported expressions are: ' +
                'now, today, tomorrow, yesterday, ' +
                'X days, X days ago, X months, X months ago, ' +
                'X years, X years ago');
        }
    }
    now() {
        return new Date();
    }
    today() {
        return startOfToday();
    }
    yesterday() {
        return startOfYesterday();
    }
    tomorrow() {
        return startOfTomorrow();
    }
    days(days) {
        return addDays(new Date(), days);
    }
    daysAgo(days) {
        return subDays(new Date(), days);
    }
    months(months) {
        return addMonths(new Date(), months);
    }
    monthsAgo(months) {
        return subMonths(new Date(), months);
    }
    years(years) {
        return addYears(new Date(), years);
    }
    yearsAgo(years) {
        return subYears(new Date(), years);
    }
}
RelativeDateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RelativeDateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RelativeDateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RelativeDateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RelativeDateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class SlotDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
SlotDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
SlotDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: SlotDirective, selector: "[appSlotHost]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appSlotHost]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class SlotComponent {
    constructor(injector, routing, permissionSevice, getArrayPath, http, cache, api) {
        this.injector = injector;
        this.routing = routing;
        this.permissionSevice = permissionSevice;
        this.getArrayPath = getArrayPath;
        this.http = http;
        this.cache = cache;
        this.api = api;
        this.componentRefs = [];
    }
    ngOnInit() {
        if (!this.detectChanges) {
            this.loadComponents();
        }
    }
    ngOnChanges(changes) {
        if (typeof changes.componentValue !== 'undefined'
            && typeof changes.componentValue.currentValue !== 'undefined') {
            // tslint:disable-next-line: forin
            if (Array.isArray(this.items)) {
                for (const item in this.items) {
                    const itemData = { ...this.items[item].data };
                    for (const k in itemData) {
                        if (itemData[k] === '{value}') {
                            itemData[k] = changes.componentValue.currentValue;
                            break;
                        }
                    }
                    if (typeof this.componentRefs[+item] !== 'undefined') {
                        this.componentRefs[item].instance.data = itemData;
                        if (typeof this.componentRefs[item].instance['update'] === 'function') {
                            this.componentRefs[item].instance['update']();
                        }
                    }
                }
            }
        }
        if (this.detectChanges
            &&
                ((changes.items && JSON.stringify(changes.items.currentValue) !== JSON.stringify(changes.items.previousValue))
                    ||
                        (changes.componentValue && JSON.stringify(changes.componentValue.currentValue) !== JSON.stringify(changes.componentValue.previousValue)))) {
            this.loadComponents();
        }
    }
    async loadComponents() {
        const viewContainerRef = this.slotHost.viewContainerRef;
        viewContainerRef.clear();
        if (this.items) {
            if (Array.isArray(this.items)) {
                await this.renderItems(viewContainerRef, this.items);
            }
            else if (typeof this.items === 'string') {
                const filePath = this.items;
                if (!this.cache.get(filePath)) {
                    await this.http
                        .get('./assets/components/' + filePath + '?v=' + this.api.getEnv().version)
                        .pipe(take(1))
                        .subscribe(async (items) => {
                        await this.renderItems(viewContainerRef, items);
                        this.cache.set(filePath, items);
                    });
                }
                else {
                    await this.renderItems(viewContainerRef, this.cache.get(filePath));
                }
            }
        }
    }
    async renderItems(viewContainerRef, items) {
        for (const item of items) {
            if (!this.permissionSevice.checkPermissions(item)) {
                continue;
            }
            if (SlotComponent.registry[item.component]) {
                await SlotComponent.registry[item.component].loadChildren()
                    .then((module) => {
                    const moduleRef = createNgModule(module, this.injector);
                    let componentRef;
                    try {
                        componentRef = viewContainerRef.createComponent(this.routing.getMappedComponent(item.component), {
                            injector: this.injector,
                            ngModuleRef: moduleRef
                        });
                    }
                    catch (error) {
                        console.error('cannot find ' + item.component);
                        throw error;
                    }
                    if (!item.data) {
                        item.data = {};
                    }
                    item.data.instanceId = (Date.now() + Math.random()) * 10000;
                    const itemData = { ...item.data };
                    if (typeof this.componentValue !== 'undefined') {
                        for (const k in itemData) {
                            if (typeof itemData[k] === 'string'
                                && itemData[k] === '{value}') {
                                itemData[k] = this.componentValue;
                                break;
                            }
                        }
                    }
                    else {
                        const contentRegex = /{([^.]+)\.(?:([^.]+)\.)*([^.]+)}/g;
                        for (const k in itemData) {
                            if (typeof itemData[k] === 'string') {
                                const content = itemData[k]
                                    .matchAll(contentRegex)
                                    .next()
                                    .value;
                                if (content) {
                                    const storagePath = content.filter((v, i) => i > 0 && v);
                                    itemData[k] = this.getArrayPath.get(undefined, storagePath);
                                    break;
                                }
                            }
                        }
                    }
                    componentRef.instance.data = itemData;
                    componentRef.instance.parentForm = this.parentForm;
                    componentRef.instance
                        .parentComponent = this.parentComponent;
                    this.componentRefs.push(componentRef);
                });
            }
            else {
                let componentRef;
                try {
                    componentRef = viewContainerRef.createComponent(this.routing.getMappedComponent(item.component));
                }
                catch (error) {
                    console.error('cannot find ' + item.component);
                    throw error;
                }
                const itemData = { ...item.data };
                itemData.instanceId = (Date.now() + Math.random()) * 10000;
                if (typeof this.componentValue !== 'undefined') {
                    for (const k in itemData) {
                        if (typeof itemData[k] === 'string'
                            && itemData[k] === '{value}') {
                            itemData[k] = this.componentValue;
                            break;
                        }
                    }
                }
                else {
                    const contentRegex = /{([^.]+)\.(?:([^.]+)\.)*([^.]+)}/g;
                    for (const k in itemData) {
                        if (typeof itemData[k] === 'string') {
                            const content = itemData[k]
                                .matchAll(contentRegex)
                                .next()
                                .value;
                            if (content) {
                                const storagePath = content.filter((v, i) => i > 0 && v);
                                itemData[k] = this.getArrayPath.get(undefined, storagePath);
                                break;
                            }
                        }
                    }
                }
                componentRef.instance.data = itemData;
                componentRef.instance.parentForm = this.parentForm;
                componentRef.instance
                    .parentComponent = this.parentComponent;
                this.componentRefs.push(componentRef);
            }
        }
    }
}
SlotComponent.registry = {
    SidenavComponent: {
        loadChildren: () => Promise.resolve().then(function () { return sidenav_module; })
            .then(m => m.SidenavModule)
    },
    TopnavComponent: {
        loadChildren: () => Promise.resolve().then(function () { return topnav_module; })
            .then(m => m.TopnavModule)
    },
    TableListComponent: {
        loadChildren: () => Promise.resolve().then(function () { return tableList_module; })
            .then(m => m.TableListModule)
    },
    GridListComponent: {
        loadChildren: () => Promise.resolve().then(function () { return gridList_module; })
            .then(m => m.GridListModule)
    },
    TreeListComponent: {
        loadChildren: () => Promise.resolve().then(function () { return treeList_module; })
            .then(m => m.TreeListModule)
    },
    CardListComponent: {
        loadChildren: () => Promise.resolve().then(function () { return cardList_module; })
            .then(m => m.CardListModule)
    },
    FormComponent: {
        loadChildren: () => Promise.resolve().then(function () { return form_module; })
            .then(m => m.FormModule)
    },
    ActionBarComponent: {
        loadChildren: () => Promise.resolve().then(function () { return actionBar_module; })
            .then(m => m.ActionBarModule)
    },
    MenuComponent: {
        loadChildren: () => Promise.resolve().then(function () { return menu_module; })
            .then(m => m.MenuModule)
    },
    HorizontalMenuComponent: {
        loadChildren: () => Promise.resolve().then(function () { return horizontalMenu_module; })
            .then(m => m.HorizontalMenuModule)
    },
    MobileMenuComponent: {
        loadChildren: () => Promise.resolve().then(function () { return mobileMenu_module; })
            .then(m => m.MobileMenuModule)
    },
    TabbedComponent: {
        loadChildren: () => Promise.resolve().then(function () { return tabbed_module; })
            .then(m => m.TabbedModule)
    },
    CarouselComponent: {
        loadChildren: () => Promise.resolve().then(function () { return carousel_module; })
            .then(m => m.CarouselModule)
    },
    MapComponent: {
        loadChildren: () => Promise.resolve().then(function () { return map_module; })
            .then(m => m.MapModule)
    },
    AddressAutocompleteComponent: {
        loadChildren: () => Promise.resolve().then(function () { return addressAutocomplete_module; })
            .then(m => m.AddressAutocompleteModule)
    },
    GalleryComponent: {
        loadChildren: () => Promise.resolve().then(function () { return gallery_module; })
            .then(m => m.GalleryModule)
    },
    StepperComponent: {
        loadChildren: () => Promise.resolve().then(function () { return stepper_module; })
            .then(m => m.StepperModule)
    },
    LogoutComponent: {
        loadChildren: () => Promise.resolve().then(function () { return logout_module; })
            .then(m => m.LogoutModule)
    },
    AccordionComponent: {
        loadChildren: () => Promise.resolve().then(function () { return accordion_module; })
            .then(m => m.AccordionModule)
    },
    OverlayComponent: {
        loadChildren: () => Promise.resolve().then(function () { return overlay_module; })
            .then(m => m.OverlayModule)
    },
    ProgressBarComponent: {
        loadChildren: () => Promise.resolve().then(function () { return progressBar_module; })
            .then(m => m.ProgressBarModule)
    },
    ProgressCircleComponent: {
        loadChildren: () => Promise.resolve().then(function () { return progressCircle_module; })
            .then(m => m.ProgressCircleModule)
    },
    FacebookLoginComponent: {
        loadChildren: () => Promise.resolve().then(function () { return facebookLogin_module; })
            .then(m => m.FacebookLoginModule)
    },
    GoogleLoginComponent: {
        loadChildren: () => Promise.resolve().then(function () { return googleLogin_module; })
            .then(m => m.GoogleLoginModule)
    },
    SocialSharingComponent: {
        loadChildren: () => Promise.resolve().then(function () { return socialSharing_module; })
            .then(m => m.SocialSharingModule)
    },
    BreadcrumbsComponent: {
        loadChildren: () => Promise.resolve().then(function () { return breadcrumbs_module; })
            .then(m => m.BreadcrumbsModule)
    },
    RemoteSlotComponent: {
        loadChildren: () => Promise.resolve().then(function () { return remoteSlot_module; })
            .then(m => m.RemoteSlotModule)
    },
    NestedMenuComponent: {
        loadChildren: () => Promise.resolve().then(function () { return nestedMenu_module; })
            .then(m => m.NestedMenuModule)
    },
    TimeLineComponent: {
        loadChildren: () => Promise.resolve().then(function () { return timeLine_module; })
            .then(m => m.TimeLineModule)
    },
    FetchDataComponent: {
        loadChildren: () => Promise.resolve().then(function () { return fetchData_module; })
            .then(m => m.DataCallModule)
    },
    CountdownComponent: {
        loadChildren: () => Promise.resolve().then(function () { return countdown_module; })
            .then(m => m.CountDownModule)
    },
    PinComponent: {
        loadChildren: () => Promise.resolve().then(function () { return pin_module; })
            .then(m => m.PinModule)
    },
    IconPickerComponent: {
        loadChildren: () => Promise.resolve().then(function () { return iconPicker_module; })
            .then(m => m.IconPickerModule)
    },
    PullToRefreshComponent: {
        loadChildren: () => Promise.resolve().then(function () { return pullToRefresh_module; })
            .then(m => m.PullToRefreshModule)
    },
    PdfViewerComponent: {
        loadChildren: () => Promise.resolve().then(function () { return pdfViewer_module; })
            .then(m => m.ViewPdfModule)
    },
    FlixMediaComponent: {
        loadChildren: () => Promise.resolve().then(function () { return flixMedia_module; })
            .then(m => m.FlixMediaExternal)
    }
};
SlotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotComponent, deps: [{ token: i0.Injector }, { token: RoutingService }, { token: PermissionsService }, { token: GetArrayPathService }, { token: i1$1.HttpClient }, { token: CacheService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Component });
SlotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SlotComponent, selector: "app-slot", inputs: { items: "items", detectChanges: "detectChanges", componentValue: "componentValue", parentForm: "parentForm", parentComponent: "parentComponent" }, viewQueries: [{ propertyName: "slotHost", first: true, predicate: SlotDirective, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<ng-template appSlotHost></ng-template>", styles: [""], dependencies: [{ kind: "directive", type: SlotDirective, selector: "[appSlotHost]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-slot', template: "<ng-template appSlotHost></ng-template>" }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: RoutingService }, { type: PermissionsService }, { type: GetArrayPathService }, { type: i1$1.HttpClient }, { type: CacheService }, { type: ApiService }]; }, propDecorators: { items: [{
                type: Input
            }], detectChanges: [{
                type: Input
            }], componentValue: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }], slotHost: [{
                type: ViewChild,
                args: [SlotDirective, { static: true }]
            }] } });

class SlotModule {
}
SlotModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SlotModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SlotModule, declarations: [SlotDirective,
        SlotComponent], imports: [CommonModule], exports: [SlotComponent,
        SlotDirective] });
SlotModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SlotDirective,
                        SlotComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        SlotComponent,
                        SlotDirective
                    ]
                }]
        }] });

class GetArrayPathPipe {
    constructor(getArrayPath) {
        this.getArrayPath = getArrayPath;
    }
    transform(input, path = '') {
        return this.getArrayPath.get(input, path);
    }
}
GetArrayPathPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathPipe, deps: [{ token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Pipe });
GetArrayPathPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathPipe, name: "getArrayPath" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetArrayPathPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'getArrayPath',
                    pure: true
                }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }]; } });

class JoinPipe {
    transform(input, separator = '_') {
        if (!Array.isArray(input)) {
            return input;
        }
        return input.join(separator);
    }
}
JoinPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JoinPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
JoinPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: JoinPipe, name: "join" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JoinPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'join',
                    pure: true
                }]
        }] });

class TooltipContentPipe {
    constructor(getArrayPath) {
        this.getArrayPath = getArrayPath;
    }
    transform(input, path, format = null) {
        if (Array.isArray(path)) {
            let content;
            if (Array.isArray(path[0])) {
                content = [];
                for (const p of path) {
                    const tmp = this.getArrayPath.get(input, p);
                    if (Array.isArray(tmp)) {
                        content = content.concat(tmp);
                    }
                    else if (tmp) {
                        content.push(tmp);
                    }
                }
            }
            else {
                content = this.getArrayPath.get(input, path);
            }
            if (Array.isArray(content)) {
                let result;
                if (format !== null) {
                    result = content.map(i => {
                        const str = [];
                        for (const field in format) {
                            if (typeof i[field] !== 'undefined') {
                                switch (field) {
                                    case 'date':
                                        if (format[field] !== null) {
                                            str.push(new DatePipe('en-GB').transform(i[field].replace(' ', 'T'), format[field]));
                                        }
                                        break;
                                    default:
                                        str.push(i[field]);
                                        break;
                                }
                            }
                        }
                        return str.join(' ');
                    });
                }
                else {
                    result = content.map(i => {
                        if (typeof i === 'string') {
                            return i;
                        }
                        else {
                            return Object.values(i).join(' ');
                        }
                    });
                }
                return result.join('\n');
            }
            else {
                return content;
            }
        }
        else {
            return path;
        }
    }
}
TooltipContentPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TooltipContentPipe, deps: [{ token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Pipe });
TooltipContentPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TooltipContentPipe, name: "tooltipContent" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TooltipContentPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tooltipContent'
                }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }]; } });

class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i3$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SafeHtmlPipe, name: "safeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeHtml'
                }]
        }], ctorParameters: function () { return [{ type: i3$1.DomSanitizer }]; } });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: PipesModule, declarations: [GetArrayPathPipe,
        JoinPipe,
        TooltipContentPipe,
        LinkPipe,
        SafeHtmlPipe], imports: [CommonModule], exports: [GetArrayPathPipe,
        JoinPipe,
        TooltipContentPipe,
        LinkPipe,
        SafeHtmlPipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PipesModule, providers: [
        GetArrayPathPipe,
        JoinPipe,
        TooltipContentPipe,
        LinkPipe,
        SafeHtmlPipe
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GetArrayPathPipe,
                        JoinPipe,
                        TooltipContentPipe,
                        LinkPipe,
                        SafeHtmlPipe
                    ],
                    exports: [
                        GetArrayPathPipe,
                        JoinPipe,
                        TooltipContentPipe,
                        LinkPipe,
                        SafeHtmlPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [
                        GetArrayPathPipe,
                        JoinPipe,
                        TooltipContentPipe,
                        LinkPipe,
                        SafeHtmlPipe
                    ]
                }]
        }] });

class AccordionComponent {
    constructor(api, comm, arrayPathService, cdr) {
        this.api = api;
        this.comm = comm;
        this.arrayPathService = arrayPathService;
        this.cdr = cdr;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        this.selfRef = this;
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => {
                this.comm.processMessage(message, this);
                // detectChanges must be called for the accordion to be rerendered,
                // because the component uses onPush change detection strategy
                this.cdr.detectChanges();
            });
        }
        this.load();
    }
    isExpanded(i) {
        if (this.allPanels) {
            return this.allPanels.get(i).expanded;
        }
        else {
            return this.data.expanded;
        }
    }
    load() {
        let params = {};
        if (typeof this.data.dataSource === 'undefined') {
            if (!Array.isArray(this.data.dataObject)) {
                this.data.dataObject = [this.data.dataObject];
            }
            return;
        }
        if (typeof this.data.dataSource.params !== 'undefined') {
            params = { ...this.data.dataSource.params };
        }
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            if (!Array.isArray(response.result.data)) {
                this.data.dataObject = [response.result.data];
            }
            else {
                this.data.dataObject = response.result.data;
            }
            // detectChanges must be called for the accordion to be rerendered,
            // because the component uses onPush change detection strategy
            this.cdr.detectChanges();
        });
    }
    removePanel(id) {
        const allPanels = this.arrayPathService.get(this.data.dataObject, this.data.path);
        const index = allPanels.findIndex(panel => {
            return panel.id === id;
        });
        allPanels.splice(index, 1);
    }
    addRule(newRule) {
        const allPanels = this.arrayPathService.get(this.data.dataObject, this.data.path);
        const index = allPanels.findIndex(panel => {
            return panel.id === newRule.carrier_id;
        });
        if (newRule.default) {
            allPanels[index].rules.forEach((rule, idx, arr) => {
                arr[idx].default = false;
            });
        }
        allPanels[index].rules.push(newRule);
        this.data.dataObject[index] = { ...this.data.dataObject[index] };
    }
    updateRule(updatedRule) {
        const allPanels = this.arrayPathService.get(this.data.dataObject, this.data.path);
        const index = allPanels.findIndex(panel => {
            return panel.id === updatedRule.carrier_id;
        });
        const ruleIndex = allPanels[index].rules.findIndex(rule => {
            return rule.id === updatedRule.id;
        });
        allPanels[index].rules[ruleIndex] = updatedRule;
    }
    removeRule(deletedRule) {
        const allPanels = this.arrayPathService.get(this.data.dataObject, this.data.path);
        const index = allPanels.findIndex(panel => {
            return panel.id === deletedRule.carrier_id;
        });
        const ruleIndex = allPanels[index].rules.findIndex(rule => {
            return rule.id === deletedRule.id;
        });
        allPanels[index].rules.splice(ruleIndex, 1);
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
AccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AccordionComponent, deps: [{ token: ApiService }, { token: CommunicationService }, { token: GetArrayPathService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AccordionComponent, selector: "ng-component", inputs: { data: "data" }, viewQueries: [{ propertyName: "allPanels", predicate: MatExpansionPanel, descendants: true }], ngImport: i0, template: "<mat-accordion\r\n  [multi]=\"data.multi\"\r\n  [togglePosition]=\"data.togglePosition\"\r\n  [hideToggle]=\"data.hideToggleIcon\">\r\n  <mat-expansion-panel\r\n    [class]=\"data.class\"\r\n    [expanded]=\"data.expanded\"\r\n    *ngFor=\"let obj of data.dataObject | getArrayPath: data.path; let i=index;\"\r\n  >\r\n    <mat-expansion-panel-header [class]=\"data.headerClasses\">\r\n      <ng-container>\r\n        <app-slot\r\n          [items]=\"data.header\"\r\n          [componentValue]=\"obj\"\r\n          [parentComponent]=\"selfRef\"\r\n          class=\"w-100\"\r\n        ></app-slot>\r\n      </ng-container>\r\n      <mat-icon *ngIf=\"data.hideToggleIcon && data.openIcon && !isExpanded(i)\">{{data.openIcon}}</mat-icon>\r\n      <mat-icon *ngIf=\"data.hideToggleIcon && data.closeIcon && isExpanded(i)\">{{data.closeIcon}}</mat-icon>\r\n    </mat-expansion-panel-header>\r\n\r\n    <ng-container>\r\n      <app-slot\r\n        [items]=\"data.content\"\r\n        [componentValue]=\"obj\"\r\n        [parentComponent]=\"selfRef\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n\r\n  </mat-expansion-panel>\r\n\r\n\r\n\r\n</mat-accordion>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i5.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i5.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-accordion\r\n  [multi]=\"data.multi\"\r\n  [togglePosition]=\"data.togglePosition\"\r\n  [hideToggle]=\"data.hideToggleIcon\">\r\n  <mat-expansion-panel\r\n    [class]=\"data.class\"\r\n    [expanded]=\"data.expanded\"\r\n    *ngFor=\"let obj of data.dataObject | getArrayPath: data.path; let i=index;\"\r\n  >\r\n    <mat-expansion-panel-header [class]=\"data.headerClasses\">\r\n      <ng-container>\r\n        <app-slot\r\n          [items]=\"data.header\"\r\n          [componentValue]=\"obj\"\r\n          [parentComponent]=\"selfRef\"\r\n          class=\"w-100\"\r\n        ></app-slot>\r\n      </ng-container>\r\n      <mat-icon *ngIf=\"data.hideToggleIcon && data.openIcon && !isExpanded(i)\">{{data.openIcon}}</mat-icon>\r\n      <mat-icon *ngIf=\"data.hideToggleIcon && data.closeIcon && isExpanded(i)\">{{data.closeIcon}}</mat-icon>\r\n    </mat-expansion-panel-header>\r\n\r\n    <ng-container>\r\n      <app-slot\r\n        [items]=\"data.content\"\r\n        [componentValue]=\"obj\"\r\n        [parentComponent]=\"selfRef\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n\r\n  </mat-expansion-panel>\r\n\r\n\r\n\r\n</mat-accordion>\r\n" }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: CommunicationService }, { type: GetArrayPathService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { allPanels: [{
                type: ViewChildren,
                args: [MatExpansionPanel]
            }], data: [{
                type: Input
            }] } });

class AccordionModule {
    constructor(routing) {
        routing.mapComponent('AccordionComponent', AccordionComponent);
    }
}
AccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AccordionModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
AccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: AccordionModule, declarations: [AccordionComponent], imports: [CommonModule,
        MatExpansionModule,
        SlotModule,
        PipesModule,
        MatIconModule] });
AccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AccordionModule, imports: [CommonModule,
        MatExpansionModule,
        SlotModule,
        PipesModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AccordionComponent],
                    imports: [
                        CommonModule,
                        MatExpansionModule,
                        SlotModule,
                        PipesModule,
                        MatIconModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var accordion_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   AccordionModule: AccordionModule
});

class QueryService {
    constructor(queryParamsAsObject, objectToQueryParams, activatedRoute) {
        this.queryParamsAsObject = queryParamsAsObject;
        this.objectToQueryParams = objectToQueryParams;
        this.activatedRoute = activatedRoute;
        this.updateQueryUrl(activatedRoute);
    }
    // Record an object from current page query params
    updateQueryUrl(activatedRoute) {
        if (typeof activatedRoute.snapshot !== 'undefined') {
            this.queryUrl = this.queryParamsAsObject.transform(activatedRoute.snapshot.queryParams);
        }
        else {
            this.queryUrl = this.queryParamsAsObject.transform(activatedRoute.queryParams);
        }
    }
    // Transforms query params into a object for further manipulations
    getQueryParamsAsObject() {
        let queryObject = {};
        const snapshot = this.activatedRoute.snapshot.queryParams;
        queryObject = this.queryParamsAsObject.transform(snapshot);
        return queryObject;
    }
    // Return query parameters to be used in url
    prepareQueryParams(type, params = null) {
        const queryObject = this.getQueryParamsAsObject();
        if (type !== 'sort') {
            // Replace whole mutation group in url if different than sort
            delete queryObject[type];
        }
        if (typeof queryObject[type] === 'undefined') {
            // Create ff current query type is missing
            queryObject[type] = [];
        }
        for (const k in params) {
            if (k === 'mutations') {
                // tslint:disable-next-line: forin
                for (const i in params[k]) {
                    let operator = '';
                    let values = null;
                    if (Array.isArray(params[k][i].params[2])
                        || typeof params[k][i].params[2] === 'string') {
                        operator = params[k][i].params[1];
                        values = params[k][i].params[2];
                    }
                    else if (typeof params[k][i].params[1] === 'object'
                        && !Array.isArray(params[k][i].params[1])) {
                        if (params[k][i].params[1].params.length > 2) {
                            values = {
                                column: params[k][i].params[1].params[0],
                                constraint: params[k][i].params[1].constraint,
                                operator: params[k][i].params[1].params[1],
                                values: '(' + params[k][i].params[1].params[2] + ')'
                            };
                        }
                        else {
                            values = {
                                column: params[k][i].params[1].params[0],
                                constraint: params[k][i].params[1].constraint,
                                values: '(' + params[k][i].params[1].params[1] + ')'
                            };
                        }
                    }
                    else if (typeof params[k][i].params[2] === 'undefined') {
                        values = params[k][i].params[1];
                    }
                    if (typeof values === 'string') {
                        if (values === '' || values === '%%') {
                            delete queryObject[type][params[k][i].params[0]];
                            continue;
                        }
                        values = [values];
                    }
                    if (typeof values === 'undefined') {
                        // if mutation has was passed without value
                        // it should be deleted
                        delete queryObject[type][params[k][i].params[0]];
                    }
                    else {
                        queryObject[type][params[k][i].params[0]] = {
                            constraint: params[k][i].constraint,
                            column: params[k][i].params[0],
                            operator,
                            values
                        };
                    }
                }
            }
            else {
                queryObject[type][k] = params[k];
            }
        }
        if (Object.keys(queryObject[type]).length === 0) {
            // if group is empty remove it
            delete queryObject[type];
        }
        // Transforms and returns manipulated object into two dimensional query object
        return this.objectToQueryParams.transform(queryObject);
    }
    getCurrentSortDir(column) {
        if (typeof this.queryUrl.sort !== 'undefined'
            && typeof this.queryUrl.sort[column] !== 'undefined') {
            return this.queryUrl.sort[column].values[0];
        }
    }
    // Returns the sort durection
    getSortDirection(column, sortingDefinition) {
        if (typeof this.queryUrl.sort !== 'undefined'
            && typeof this.queryUrl.sort[column] !== 'undefined') {
            if (this.queryUrl.sort[column].values[0] === 'desc') {
                return 'asc';
            }
            else {
                return 'desc';
            }
        }
        else {
            if (sortingDefinition.starting) {
                if (sortingDefinition.direction === 'desc') {
                    return 'asc';
                }
                else {
                    return 'desc';
                }
            }
            else {
                return sortingDefinition.direction;
            }
        }
    }
    // Returns generated params from queries in url for post params
    prepareParams() {
        const preparedParams = {
            mutations: []
        };
        for (const group in this.queryUrl) {
            if (group) {
                const elements = this.queryUrl[group];
                for (const param in elements) {
                    if (typeof elements[param] === 'object') {
                        if (typeof elements[param].values !== 'undefined') {
                            let params = [];
                            let values;
                            if (elements[param].values.length === 1) {
                                values = elements[param].values[0];
                            }
                            else {
                                values = elements[param].values;
                            }
                            if (elements[param].operator !== '') {
                                params = [param, elements[param].operator, values];
                            }
                            else {
                                params = [param, values];
                            }
                            // const splitedName = param.split(';');
                            // if (splitedName.length > 1) {
                            // preparedParams.mutations.push({
                            //     constraint: 'whereHas',
                            //     params: [splitedName[0], {
                            //         constraint: elements[param].constraint,
                            //         params: [splitedName[1], values]
                            //     }]
                            // });
                            // } else {
                            preparedParams.mutations.push({
                                constraint: elements[param].constraint,
                                params
                            });
                            // }
                        }
                        if (typeof elements[param].subGroup !== 'undefined') {
                            const mutationParams = [
                                elements[param].column
                            ];
                            // tslint:disable-next-line: forin
                            for (const i in elements[param].subGroup) {
                                const subParams = [
                                    elements[param].subGroup[i].column
                                ];
                                if (typeof elements[param].subGroup[i].operator !== 'undefined'
                                    && elements[param].subGroup[i].operator !== '') {
                                    subParams.push(elements[param].subGroup[i].operator);
                                }
                                subParams.push(elements[param].subGroup[i].values);
                                const mutationSubParams = {
                                    constraint: elements[param].subGroup[i].constraint,
                                    params: subParams
                                };
                                mutationParams.push(mutationSubParams);
                            }
                            preparedParams.mutations.push({
                                constraint: elements[param].constraint,
                                params: mutationParams
                            });
                        }
                    }
                    else {
                        preparedParams[param] = elements[param];
                    }
                }
            }
        }
        if (preparedParams.mutations.length === 0) {
            delete preparedParams.mutations;
        }
        return preparedParams;
    }
    /* Merge default mutations from the json config with query mutations
    if they are for different column and constraint
    */
    mergeMutations(defaultMutations, queryMutations) {
        let orderByInQuery = false;
        const mergedMutationsObject = {};
        const clonedMutations = [...queryMutations];
        for (const queryMutation of clonedMutations) {
            if (queryMutation.constraint.startsWith('orderBy')) {
                orderByInQuery = true;
                break;
            }
        }
        for (const mutation of defaultMutations) {
            if (!mutation.constraint.startsWith('orderBy') || !orderByInQuery) {
                mergedMutationsObject[mutation.params[0] + '-' + mutation.constraint]
                    = mutation;
            }
        }
        for (const queryMutation of clonedMutations) {
            if (queryMutation.constraint.startsWith('orderBy')) {
                orderByInQuery = true;
            }
            mergedMutationsObject[queryMutation.params[0] + '-' + queryMutation.constraint]
                = queryMutation;
        }
        return Object.values(mergedMutationsObject);
    }
}
QueryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryService, deps: [{ token: GetQueryParamsAsObjectPipe }, { token: ObjectToQueryParamsPipe }, { token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
QueryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: QueryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: GetQueryParamsAsObjectPipe }, { type: ObjectToQueryParamsPipe }, { type: i1.ActivatedRoute }]; } });

class ActionBarComponent {
    constructor(eventBus, query, elRef) {
        this.eventBus = eventBus;
        this.query = query;
        this.elRef = elRef;
        this.values = {};
        this.constraints = {};
        this.controls = {};
        this.slots = {};
        this.destroyed$ = new Subject();
        this.inline = 'action-bar';
        this.eventBus.on('emptyActionBar')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe(() => {
            for (const slot in this.slots) {
                this.slots[slot] = [];
                this.controls = {};
            }
        });
        this.eventBus.on('addToActionBar')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((data) => {
            if (this.data.id === data.actionBar.id) {
                data = JSON.parse(JSON.stringify(data));
                data.actionBar.data.inActionBar = true;
                if (!this.slots[data.actionBar.slot]) {
                    this.slots[data.actionBar.slot] = [];
                }
                this[data.actionBar.component](data);
                data.actionBar.data.actionId = data.id;
                this.updateValue(data);
                const control = {
                    component: data.actionBar.component,
                    data: data.actionBar.data,
                    requiredPermissions: data.actionBar.requiredPermissions
                };
                this.slots[data.actionBar.slot]
                    .push(control);
                this.slots[data.actionBar.slot] = this.slots[data.actionBar.slot].slice();
                this.controls[control.data.actionId] = control;
            }
            // this.subsc.push(this.eventBus.on('actionBarControlReset', (actionData) => {
            // TODO reset control
            // }));
        });
        this.eventBus.on('actionBarEnterKey')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((control) => {
            if (typeof this.controls[control].data.click === 'function') {
                if (typeof this.controls[control].data.clickParams !== 'undefined') {
                    this.controls[control].data.click(this.controls[control].data.clickParams);
                }
                else {
                    this.controls[control].data.click();
                }
            }
        });
    }
    ngOnInit() {
        if (typeof this.data.inline !== 'undefined' && this.data.inline) {
            this.inline = '';
        }
    }
    CheckboxComponent(data) {
        this.prepAction('change', data);
    }
    SlideToggleComponent(data) {
        this.prepAction('change', data);
    }
    AutocompleteComponent(data) {
        this.prepAction('change', data);
    }
    DatepickerComponent(data) {
        this.prepAction('change', data);
    }
    DaterangeComponent(data) {
        this.prepAction('change', data);
    }
    SliderRangeComponent(data) {
        this.prepAction('change', data);
    }
    RadiobuttonComponent(data) {
        this.prepAction('change', data);
    }
    SelectComponent(data) {
        this.prepAction('change', data);
        if (typeof data.actionBar.data.dataSource !== 'undefined') {
            if (typeof data.actionBar.data.dataSource.params === 'undefined') {
                data.actionBar.data.dataSource.params = {};
            }
        }
    }
    ButtonComponent(data) {
        this.prepAction('click', data);
    }
    InputComponent(data) {
        this.prepAction('click', data);
        this.prepAction('valueChanges', data);
    }
    prepAction(action, data) {
        data.actionBar.data[action + 'Params'] = {
            event: data.event,
            id: data.id,
            label: data.label
        };
        if (typeof data.require !== 'undefined') {
            data.actionBar.data[action + 'Params'].require = data.require;
        }
        if (typeof data.actionParams !== 'undefined') {
            data.actionBar.data[action + 'Params'].actionParams = data.actionParams;
        }
        if (typeof data.apiCall !== 'undefined') {
            data.actionBar.data[action + 'Params'].apiCall = data.apiCall;
        }
        if (typeof data.confirmDialog !== 'undefined') {
            data.actionBar.data[action + 'Params'].confirmDialog = data.confirmDialog;
        }
        if (typeof data.actionBar.data.checked !== 'undefined') {
            data.actionBar.data[action + 'Params'].checked = data.actionBar.data.checked;
        }
        data.actionBar.data[action] = this.doAction.bind(this);
    }
    doAction(params) {
        if (typeof this.controls[params.id].data.toggle !== 'undefined') {
            // toggle a class on the specified in the configuration selectors
            const toggleConf = this.controls[params.id].data.toggle;
            const htmlEl = this.elRef.nativeElement;
            for (const selector of toggleConf.selectors) {
                const elements = htmlEl.getElementsByClassName(selector);
                for (const el of Array.from(elements)) {
                    el.classList.toggle(toggleConf.class);
                }
            }
        }
        if (typeof params.value !== 'undefined') {
            if (typeof params.value.min !== 'undefined' && params.value.max !== 'undefined') {
                this.values[params.id] = Object.values(params.value);
            }
            else {
                this.values[params.id] = params.value;
            }
            if (typeof params.options !== 'undefined') {
                // If we want to change the constraint based on other field
                params.options.filter(option => {
                    if (typeof option.constraint !== 'undefined'
                        && option.value === params.value) {
                        this.constraints[params.id] = option.constraint;
                    }
                });
            }
        }
        else {
            delete this.values[params.id];
            delete this.constraints[params.id];
        }
        let clonedParams;
        if (typeof params.actionParams !== 'undefined') {
            clonedParams = JSON.parse(JSON.stringify(params));
            // tslint:disable-next-line: forin
            for (const k in clonedParams.actionParams) {
                if (typeof this['prep_' + k] === 'function') {
                    this['prep_' + k](clonedParams.actionParams[k]);
                }
                else {
                    if (typeof clonedParams.actionParams[k] === 'string'
                        && clonedParams.actionParams[k].search(/{.+}/g) >= 0) {
                        const valueKey = clonedParams.actionParams[k].replace(/[{}]/g, '');
                        if (this.values[valueKey]) {
                            clonedParams.actionParams[k] = this.values[valueKey];
                        }
                        else {
                            delete clonedParams.actionParams[k];
                        }
                    }
                }
            }
        }
        else {
            clonedParams = params;
        }
        this.eventBus.fire(new Event(clonedParams.event, clonedParams));
        if (params.id === 'reset') {
            this.eventBus.fire(new Event('actionBarControlReset', clonedParams));
        }
    }
    prep_mutations(mutations) {
        const pattern = /{(.*)}/i;
        mutationsLoop: for (const k in mutations) {
            if (mutations[k].constraint.startsWith('{')) {
                const constraintKey = mutations[k].constraint.replace('{', '').replace('}', '');
                if (typeof this.constraints[constraintKey] !== 'undefined') {
                    mutations[k].constraint = this.constraints[constraintKey];
                }
            }
            if (mutations[k].params) {
                // tslint:disable-next-line: forin
                for (const i in mutations[k].params) {
                    let mutationParamsStr;
                    let complex;
                    if (typeof mutations[k].params[i] !== 'string') {
                        mutationParamsStr = JSON.stringify(mutations[k].params[i]);
                        mutationParamsStr = mutationParamsStr.substr(1, (mutationParamsStr.length - 2));
                        complex = true;
                    }
                    else {
                        mutationParamsStr = mutations[k].params[i];
                        complex = false;
                    }
                    const valueKey = pattern.exec(mutationParamsStr);
                    if (valueKey && valueKey[1]) {
                        const value = this.values[valueKey[1]];
                        if (typeof value === 'undefined'
                            || (Array.isArray(value) && value.length === 0)) {
                            delete mutations[k];
                            continue mutationsLoop;
                        }
                        if (complex) {
                            mutationParamsStr = '{' + mutationParamsStr + '}';
                            const res = mutationParamsStr.replace('{' + valueKey[1] + '}', value);
                            mutations[k].params[i] = JSON.parse(res);
                        }
                        else {
                            const res = mutationParamsStr.replace('{' + valueKey[1] + '}', value);
                            mutations[k].params[i] = res;
                        }
                    }
                }
            }
        }
    }
    updateValue(data) {
        const queryObject = this.query.getQueryParamsAsObject();
        for (const key in queryObject) {
            if (typeof queryObject[key] !== 'undefined' && key !== 'sort') {
                for (const field in queryObject[key]) {
                    if (data.actionBar.data.name === field) {
                        let values = [];
                        if (typeof queryObject[key][field].values !== 'undefined') {
                            values = queryObject[key][field].values;
                        }
                        else if (typeof queryObject[key][field].subGroup !== 'undefined') {
                            // tslint:disable-next-line: forin
                            for (const i in queryObject[key][field].subGroup) {
                                values = queryObject[key][field].subGroup[i].values;
                            }
                        }
                        else {
                            values.push(queryObject[key][field]);
                        }
                        if (values.length === 1) {
                            let value = values[0].replace(/%/g, '');
                            switch (data.actionBar.component) {
                                // Switch by field type
                                case 'SelectComponent':
                                    const casted = Number(value);
                                    if (!isNaN(value)) {
                                        value = casted;
                                    }
                                    data.actionBar.data.originalSelected = data.actionBar.data.value;
                                    data.actionBar.data.value = value;
                                    this.values[data.actionBar.data.actionId] = value;
                                    break;
                                default:
                                    data.actionBar.data.originalValue = data.actionBar.data.value;
                                    data.actionBar.data.value = value;
                                    this.values[data.actionBar.data.actionId] = value;
                                    break;
                            }
                        }
                        else {
                            // If multiple values
                            switch (data.actionBar.component) {
                                case 'SelectComponent':
                                    if (data.actionBar.data.multiple) {
                                        data.actionBar.data.originalSelected = data.actionBar.data.value;
                                        data.actionBar.data.value = [];
                                        for (let value of values) {
                                            const casted = Number(value);
                                            if (!isNaN(value)) {
                                                value = casted;
                                            }
                                            data.actionBar.data.value.push(value);
                                            if (Array.isArray(this.values[data.actionBar.data.actionId])) {
                                                this.values[data.actionBar.data.actionId].push(value);
                                            }
                                            else {
                                                this.values[data.actionBar.data.actionId] = [value];
                                            }
                                        }
                                    }
                                    break;
                                case 'DaterangeComponent':
                                    data.actionBar.data.from.originalValue = data.actionBar.data.from.value;
                                    data.actionBar.data.to.originalValue = data.actionBar.data.to.value;
                                    data.actionBar.data.from.value = values[0];
                                    data.actionBar.data.to.value = values[1];
                                    this.values[data.actionBar.data.actionId] = values.join(',');
                                    break;
                            }
                        }
                    }
                }
            }
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
ActionBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionBarComponent, deps: [{ token: EventBusService }, { token: QueryService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ActionBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ActionBarComponent, selector: "app-action-bar", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"{{inline}} {{data.id}} row {{data.class}}\">\r\n  <div [class]=\"slot.style\" *ngFor=\"let slot of data.slots\">\r\n    <app-slot\r\n      [items]=\"slots[slot.name]\"\r\n      [detectChanges]=\"true\"\r\n    ></app-slot>\r\n  </div>\r\n</div>\r\n", styles: [".action-bar{padding:10px;background:#ffffff;box-shadow:0 2px 4px -1px #0000001a,0 4px 5px #00000024,0 1px 10px #0000001f}:host-context(.mat-dialog-content) .action-bar{margin:0}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-action-bar', template: "<div class=\"{{inline}} {{data.id}} row {{data.class}}\">\r\n  <div [class]=\"slot.style\" *ngFor=\"let slot of data.slots\">\r\n    <app-slot\r\n      [items]=\"slots[slot.name]\"\r\n      [detectChanges]=\"true\"\r\n    ></app-slot>\r\n  </div>\r\n</div>\r\n", styles: [".action-bar{padding:10px;background:#ffffff;box-shadow:0 2px 4px -1px #0000001a,0 4px 5px #00000024,0 1px 10px #0000001f}:host-context(.mat-dialog-content) .action-bar{margin:0}\n"] }]
        }], ctorParameters: function () { return [{ type: EventBusService }, { type: QueryService }, { type: i0.ElementRef }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ActionBarModule {
    constructor(routing) {
        routing.mapComponent('ActionBarComponent', ActionBarComponent);
    }
}
ActionBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionBarModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
ActionBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ActionBarModule, declarations: [ActionBarComponent], imports: [CommonModule,
        SlotModule,
        PipesModule] });
ActionBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionBarModule, imports: [CommonModule,
        SlotModule,
        PipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ActionBarComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var actionBar_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   ActionBarModule: ActionBarModule
});

class AddressAutocompleteComponent {
    constructor(httpClient, api) {
        const environment = api.getEnv();
        httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key='
            + environment.mapApiToken + '&libraries=places', 'callback')
            .pipe(take(1), map$1(() => {
            if (this.data) {
                this.initAutocomplete();
            }
        }), catchError(() => of(false))).subscribe(() => { });
    }
    ngOnInit() {
    }
    initAutocomplete() {
        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
            types: ['establishment'],
            componentRestrictions: { country: this.data.searchByCountries },
            fields: ['place_id', 'geometry', 'name']
        });
        google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
            const place = this.autocomplete.getPlace();
            const myLatlng = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
            this.parentForm.get(this.data.name).setValue(myLatlng);
        });
    }
}
AddressAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteComponent, deps: [{ token: i1$1.HttpClient }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Component });
AddressAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AddressAutocompleteComponent, selector: "app-address-autocomplete", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<div id=\"pac-container\">\r\n  <input id=\"autocomplete\" placeholder=\"data.placeholder\">\r\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-address-autocomplete', template: "<div id=\"pac-container\">\r\n  <input id=\"autocomplete\" placeholder=\"data.placeholder\">\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: ApiService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class ScrollService {
    constructor() {
        this.scroll$ = fromEvent(window, 'scroll');
    }
    subscribe(until$, callback) {
        this.scroll$.pipe(takeUntil$1(until$)).subscribe(callback);
    }
    scrollToElement(item) {
        setTimeout(() => {
            document?.getElementById(item.replace("#", ""))?.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }, 100);
    }
    scrollTo(object) {
        setTimeout(() => {
            const clone = { ...object };
            //delete object.item;
            document.body.scrollTo(object);
        }, 100);
    }
}
ScrollService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ScrollService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScrollService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ScrollService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ScrollService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class TransformService {
    constructor(currencyPipe, decimalPipe, getArrayPath, language) {
        this.currencyPipe = currencyPipe;
        this.decimalPipe = decimalPipe;
        this.getArrayPath = getArrayPath;
        this.language = language;
    }
    transform(data, params) {
        if (typeof data === 'undefined' &&
            typeof params?.path !== 'undefined' &&
            ['state', 'session', 'cache'].indexOf(params.path[0]) < 0) {
            return;
        }
        let value;
        if (typeof params !== 'undefined') {
            value = this.getArrayPath.get(data, params.path);
            // extract transformation params
            params = { ...params };
        }
        else {
            // backword compatibility
            value = data;
        }
        let pipeParams = [];
        if (typeof params.transform !== 'undefined') {
            if (Array.isArray(params.transform)) {
                pipeParams = params.transform;
            }
            else {
                pipeParams.push(params.transform);
            }
        }
        else {
            pipeParams.push(params);
        }
        let dataTransformed = value;
        for (const p of pipeParams) {
            dataTransformed = this.execute(dataTransformed, p, data);
        }
        return dataTransformed;
    }
    execute(data, params, originalValue) {
        let value;
        if (typeof params !== 'undefined') {
            value = this.getArrayPath.get(data, params.path);
            // extract transformation params
            params = { ...params };
        }
        else {
            // backword compatibility
            value = data;
        }
        let formatedData;
        switch (params.type) {
            case 'date':
                if (value === null || value === '') {
                    return value;
                }
                formatedData = new DatePipe('en-GB')
                    .transform(value.replace(' ', 'T'), params.format);
                break;
            case 'currency':
                if (typeof originalValue === 'string') {
                    return;
                }
                if (typeof value === 'undefined' || value === null) {
                    value = 0;
                }
                if (typeof params.currency === 'undefined'
                    && typeof params.currencyPath !== 'undefined') {
                    // extract currency from currency path if provided
                    params.currency = this.getArrayPath.get(originalValue, params.currencyPath);
                }
                if (typeof params.currency !== 'undefined' && params.currency !== null) {
                    const locale = this.language.getFullLocale();
                    const symbols = new Map();
                    symbols.set(['bg-BG', 'BGN', 'symbol'], 'лв.');
                    const displayFormatted = symbols.get([locale, params.currency, params.display]);
                    formatedData = this.currencyPipe
                        .transform(value, params.currency, displayFormatted || params.display, params.digits, locale || params.locale);
                }
                else {
                    formatedData = parseFloat(value).toFixed(2);
                }
                break;
            case 'number':
                if (typeof value === 'undefined' || value === null) {
                    value = 0;
                }
                formatedData = this.decimalPipe.transform(value, params.digits);
                break;
            case 'castToInt':
                if (typeof value === 'undefined' || value === null) {
                    value = 0;
                }
                formatedData = parseInt(value, params.radix);
                break;
            case 'percent':
                formatedData = value + '%';
                break;
            case 'timeFormat': {
                if (value === 0) {
                    formatedData = 'N/A';
                    break;
                }
                switch (params.timeValueType) {
                    case 'minutes': {
                        value *= 60;
                        break;
                    }
                    case 'miliseconds': {
                        value /= 1000;
                        break;
                    }
                }
                const d = String(Math.floor(value / (3600 * 24)));
                const h = String(Math.floor(value % (3600 * 24) / 3600));
                const m = String(Math.floor(value % 3600 / 60));
                if (typeof params.format === 'undefined') {
                    formatedData = `${d}d ${h}h ${m}m`;
                }
                else {
                    formatedData = params.format.replace('${d}', d);
                    formatedData = formatedData.replace('${h}', h);
                    formatedData = formatedData.replace('${m}', m);
                }
                break;
            }
            case 'calculate':
                let expr = params.expression;
                const components = params.expression.match(/{[\w.]+}/g);
                for (const item of components) {
                    const matched = item.replace(/[{}]/g, '').split('.');
                    const matchedValue = this.getArrayPath.get(value, matched);
                    expr = expr.replace(new RegExp(item), matchedValue);
                }
                formatedData = new Function(`return ${expr};`)().toFixed(params.precision);
                if (!Number.isFinite(+formatedData)
                    || Number.isNaN(+formatedData)) {
                    formatedData = 0;
                }
                break;
        }
        return formatedData;
    }
}
TransformService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformService, deps: [{ token: i3.CurrencyPipe }, { token: i3.DecimalPipe }, { token: GetArrayPathService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Injectable });
TransformService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.CurrencyPipe }, { type: i3.DecimalPipe }, { type: GetArrayPathService }, { type: LanguageService }]; } });

class CustomRouterLinkDirective {
    constructor(el) {
        el.nativeElement.classList.add('app-custom-link');
    }
}
CustomRouterLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomRouterLinkDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
CustomRouterLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: CustomRouterLinkDirective, isStandalone: true, selector: "[routerLink]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomRouterLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[routerLink]',
                    standalone: true
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class IconComponent {
    constructor(registry, sanitizer) {
        this.registry = registry;
        this.sanitizer = sanitizer;
        this.type = 'inline';
    }
    ngOnInit() {
        if (this.data.icon.endsWith('.svg')) {
            this.name = this.data.icon.substring(this.data.icon.lastIndexOf('/') + 1, this.data.icon.lastIndexOf('.'));
            this.registry.addSvgIcon(this.name, this.sanitizer.bypassSecurityTrustResourceUrl(this.data.icon));
            this.type = 'svg';
        }
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconComponent, deps: [{ token: i1$3.MatIconRegistry }, { token: i3$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: IconComponent, selector: "app-icon", inputs: { data: "data" }, ngImport: i0, template: "<mat-icon *ngIf=\"data.icon && type === 'inline'\" [class]=\"data.class\" [color]=\"data.color\">{{\r\n  data.icon\r\n}}</mat-icon>\r\n<mat-icon *ngIf=\"data.icon && type === 'svg'\" [class]=\"data.class\" [color]=\"data.color\" [svgIcon]=\"name\">\r\n</mat-icon>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-icon', template: "<mat-icon *ngIf=\"data.icon && type === 'inline'\" [class]=\"data.class\" [color]=\"data.color\">{{\r\n  data.icon\r\n}}</mat-icon>\r\n<mat-icon *ngIf=\"data.icon && type === 'svg'\" [class]=\"data.class\" [color]=\"data.color\" [svgIcon]=\"name\">\r\n</mat-icon>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1$3.MatIconRegistry }, { type: i3$1.DomSanitizer }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ButtonComponent {
    constructor(language, 
    // private activatedRoute: ActivatedRoute,
    arrayPathService, router, comm, hotkeys, linkPipe, scrollService, transformData, evaluator, state, eventBus) {
        this.language = language;
        this.arrayPathService = arrayPathService;
        this.router = router;
        this.comm = comm;
        this.hotkeys = hotkeys;
        this.linkPipe = linkPipe;
        this.scrollService = scrollService;
        this.transformData = transformData;
        this.evaluator = evaluator;
        this.state = state;
        this.eventBus = eventBus;
        this.badgeValue = null;
        this.disabled = false;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.label !== 'undefined') {
            this.label = this.data.label;
        }
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (typeof this.data.buttonType === 'undefined') {
            this.data.buttonType = 'button';
        }
        // bind hotkey if configured
        if (this.data.hotkey) {
            this.hotkeys.addShortcut({ keys: this.data.hotkey })
                .pipe(takeUntil(this.destroyed))
                .subscribe((e) => {
                if (!this.data.disabled) {
                    if (this.data.link) {
                        this.router.navigate([
                            this.linkPipe.transform(this.data.dataObject, this.data.link)
                        ]);
                    }
                    else {
                        this.onEvent(e, 'click');
                    }
                }
            });
        }
        if (!this.parentForm) {
            if (typeof this.data.disabled === 'boolean') {
                this.disabled = this.data.disabled;
            }
            else if (typeof this.data.disabled === 'object') {
                this.disabled = this.evaluator.exec(this.data.dataObject, this.data.disabled);
            }
        }
        this.loadBadge();
        this.loadConditionalIcons();
        this.loadConditionalIconColor();
        this.loadConditionalColor();
        this.loadConditionalLabel();
        this.addDynamicIcon();
    }
    ngOnChanges(changes) {
        if (changes.disabled
            && changes.disabled.currentValue !== changes.disabled.previousValue) {
            this.data.disabled = this.disabled;
        }
    }
    addDynamicIcon() {
        if (typeof this.data.dynamicIcon === 'undefined') {
            return;
        }
        let dynamicDataScope;
        switch (this.data.dynamicIcon.scope) {
            case 'storage':
                dynamicDataScope = null;
                break;
            default:
                dynamicDataScope = this.data.dataObject;
        }
        const dynamicName = this.arrayPathService.get(dynamicDataScope, this.data.dynamicIcon.dynamicPartPath);
        this.data.icon = this.data.dynamicIcon.prefix
            + dynamicName
            + this.data.dynamicIcon.suffix;
    }
    loadConditionalIcons() {
        if (this.data.conditionalIcon) {
            let conditionData;
            let dataObject = null;
            if (typeof this.data.dataObject === 'object') {
                dataObject = this.data.dataObject;
            }
            if (this.data.conditionalIcon.dataScope
                && this.data.conditionalIcon.dataScope === 'state') {
                conditionData = this.state.get(this.data.conditionalIcon.stateKey);
            }
            else {
                if (this.data.conditionalIcon.dataPath) {
                    conditionData = this.arrayPathService.get(dataObject, this.data.conditionalIcon.dataPath);
                }
                else {
                    conditionData = dataObject;
                }
            }
            if (this.data.conditionalIcon.valuePath) {
                this.data.conditionalIcon.value = this.arrayPathService.get(dataObject, this.data.conditionalIcon.valuePath);
            }
            if (this.evaluator.exec(conditionData, this.data.conditionalIcon)) {
                this.data.icon = this.data.conditionalIcon.icon;
            }
        }
    }
    prepareCondition(object) {
        let conditionData;
        switch (object.scope) {
            case 'storage':
                conditionData = this.arrayPathService.get(undefined, object.dataPath);
                break;
            case 'state':
                let dataObject = null;
                if (typeof this.data.dataObject === 'object') {
                    dataObject = this.data.dataObject;
                }
                conditionData = this.arrayPathService.get(dataObject, object.dataPath);
                break;
            case 'route':
                conditionData = this.router;
                break;
        }
        return conditionData;
    }
    loadConditionalIconColor() {
        if (this.data.conditionalIconColor) {
            const conditionData = this.prepareCondition(this.data.conditionalIconColor);
            if (this.evaluator.exec(conditionData, this.data.conditionalIconColor)) {
                this.data.iconColor = this.data.conditionalIconColor.color;
            }
        }
    }
    loadConditionalColor() {
        if (this.data.conditionalColor) {
            const conditionData = this.prepareCondition(this.data.conditionalColor);
            if (this.evaluator.exec(conditionData, this.data.conditionalColor)) {
                this.data.color = this.data.conditionalColor.color;
            }
        }
    }
    loadConditionalLabel() {
        if (this.data.conditionalLabel) {
            let conditionData;
            let dataObject = null;
            if (typeof this.data.dataObject === 'object') {
                dataObject = this.data.dataObject;
            }
            if (this.data.conditionalLabel.dataScope
                && this.data.conditionalLabel.dataScope === 'state') {
                conditionData = this.state.get(this.data.conditionalLabel.stateKey);
            }
            else {
                if (this.data.conditionalLabel.dataPath) {
                    conditionData = this.arrayPathService.get(dataObject, this.data.conditionalLabel.dataPath);
                }
                else {
                    conditionData = dataObject;
                }
            }
            if (this.data.conditionalLabel.valuePath) {
                this.data.conditionalLabel.value = this.arrayPathService.get(dataObject, this.data.conditionalLabel.valuePath);
            }
            if (this.evaluator.exec(conditionData, this.data.conditionalLabel)) {
                this.label = this.data.conditionalLabel.label;
            }
        }
    }
    loadBadge() {
        if (this.data.badge) {
            let show = true;
            let dataObject = null;
            if (typeof this.data.dataObject === 'object') {
                dataObject = this.data.dataObject;
            }
            if (this.data.badge.condition) {
                show = this.evaluator.exec(dataObject, this.data.badge.condition);
            }
            if (show) {
                if (this.data.badge.valuePath) {
                    this.badgeValue = this.arrayPathService.get(dataObject, this.data.badge.valuePath);
                }
                else {
                    this.badgeValue = this.data.badge.value;
                }
            }
        }
    }
    // Deprecated - use onEvent function
    click($event) {
        this.onEvent($event, 'click');
    }
    onEvent($event, type) {
        if (typeof this.data[type] === 'function') {
            $event.preventDefault();
            if (this.data.stopPropagation) {
                $event.stopPropagation();
            }
            const paramsName = `${type}Params`;
            if (!this.data[paramsName]) {
                this.data[paramsName] = {};
                this.data[paramsName].event = type;
                this.data[paramsName].$event = $event;
                // Attach $event.target (the button that was clicked) to the action state
                if ($event.target.closest('svg')) {
                    this.data[paramsName].target = $event.target.closest('button');
                }
                else {
                    this.data[paramsName].target = $event.target;
                }
                if (this.data.dataObject) {
                    this.data[paramsName].dataObject = this.data.dataObject;
                }
                if (this.parentComponent) {
                    this.data[paramsName].parentComponent = this.parentComponent;
                }
            }
            if (this.parentForm) {
                if (this.data.name) {
                    this.data[paramsName].control = this.parentForm.get(this.data.name);
                    if (this.data[paramsName].control.disabled) {
                        return;
                    }
                }
                this.data[paramsName].parentForm = this.parentForm;
            }
            else if (this.disabled) {
                return;
            }
            const result = this.data[type](this.data[paramsName]);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    toggle(side) {
        this.eventBus.fire(new Event('toggleSidenav', { side }));
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ButtonComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }, { token: i1.Router }, { token: CommunicationService }, { token: HotkeysService }, { token: LinkPipe }, { token: ScrollService }, { token: TransformService }, { token: EvalService }, { token: StateService }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ButtonComponent, selector: "app-button", inputs: { data: "data", parentForm: "parentForm", parentComponent: "parentComponent" }, providers: [LinkPipe], usesOnChanges: true, ngImport: i0, template: "<!-- ANCHORS -->\r\n<ng-container *ngIf=\"!data.print && data.link\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n</ng-container>\r\n<!-- BUTTONS -->\r\n<ng-container *ngIf=\"!data.print && !data.link && !data.scrollToElement\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      >{{ data.icon }}</app-icon\r\n    >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n</ng-container>\r\n<!-- PRINT BUTTONS -->\r\n<ng-container *ngIf=\"data.print && !data.link\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-raised-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-stroked-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-flat-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-icon-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      >{{ data.icon }}</app-icon\r\n    >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.scrollToElement\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n</ng-container>", styles: [".full-width{width:100%}.left-align{text-align:left}.hover-highlight:hover{color:#fff}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i14.MatBadge, selector: "[matBadge]", inputs: ["matBadgeDisabled", "matBadgeColor", "matBadgeOverlap", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: i16.NgxPrintDirective, selector: "button[ngxPrint]", inputs: ["useExistingCss", "printDelay", "printStyle", "styleSheetFile", "printSectionId", "printTitle"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: IconComponent, selector: "app-icon", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: LinkPipe, name: "link" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-button', providers: [LinkPipe], template: "<!-- ANCHORS -->\r\n<ng-container *ngIf=\"!data.print && data.link\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [routerLink]=\"data.dataObject | link : data.link\"\r\n    type=\"button\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n</ng-container>\r\n<!-- BUTTONS -->\r\n<ng-container *ngIf=\"!data.print && !data.link && !data.scrollToElement\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n      >{{ data.icon }}</app-icon\r\n    >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"click($event)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    [type]=\"data.buttonType\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n</ng-container>\r\n<!-- PRINT BUTTONS -->\r\n<ng-container *ngIf=\"data.print && !data.link\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-raised-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-stroked-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-flat-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"!data.components && data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    mat-icon-button\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    [printSectionId]=\"data.print\"\r\n    [useExistingCss]=\"true\"\r\n    ngxPrint\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"!data.components && data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      >{{ data.icon }}</app-icon\r\n    >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data.dataObject | getArrayPath : data.path\"\r\n      [parentForm]=\"parentForm\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </button>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.scrollToElement\">\r\n  <!-- mat-button -->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-raised-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-raised-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-raised-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-stroked-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-stroked-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-stroked-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-flat-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-flat-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-flat-button\r\n  >\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'before'\"\r\n    ></app-icon>\r\n    <span>{{ language.getLabel(label) }}</span>\r\n    <app-icon\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n      *ngIf=\"data.icon && data.iconPosition === 'after'\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-icon-button-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-icon-button'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-icon-button\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor,\r\n        class: data.iconClass\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n  <!--mat-mini-fab-->\r\n  <button\r\n    *ngIf=\"data.type == 'mat-mini-fab'\"\r\n    [ngClass]=\"data.class\"\r\n    [color]=\"data.color\"\r\n    [disableRipple]=\"!data.ripple\"\r\n    [disabled]=\"disabled\"\r\n    [matBadge]=\"badgeValue\"\r\n    [matBadgePosition]=\"data.badge ? data.badge.position : 'above after'\"\r\n    [matBadgeColor]=\"data.badge ? data.badge.color : null\"\r\n    [matBadgeOverlap]=\"data.badge ? data.badge.overlap : null\"\r\n    [matBadgeSize]=\"data.badge ? data.badge.size : null\"\r\n    [attr.alt]=\"language.getLabel(label)\"\r\n    [attr.title]=\"language.getLabel(label)\"\r\n    (click)=\"scrollService.scrollToElement(data.scrollToElement)\"\r\n    (mouseover)=\"onEvent($event, 'mouseover')\"\r\n    type=\"button\"\r\n    mat-mini-fab\r\n  >\r\n    <app-icon\r\n      *ngIf=\"data.icon\"\r\n      [data]=\"{\r\n        icon: data.icon,\r\n        color: data.iconColor\r\n      }\"\r\n    ></app-icon>\r\n  </button>\r\n</ng-container>", styles: [".full-width{width:100%}.left-align{text-align:left}.hover-highlight:hover{color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }, { type: i1.Router }, { type: CommunicationService }, { type: HotkeysService }, { type: LinkPipe }, { type: ScrollService }, { type: TransformService }, { type: EvalService }, { type: StateService }, { type: EventBusService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }] } });

class BaseComponent {
    constructor() {
        this.destroyed = new Subject();
        this.pauseInterval = false;
        this.language = inject(LanguageService);
        this.scroll = inject(ScrollService);
        this.api = inject(ApiService);
        this.comm = inject(CommunicationService);
        this.link = inject(LinkPipe);
        this.platformId = inject(PLATFORM_ID);
    }
    ngOnInit() {
        this.subscribeToCommChannel();
    }
    getLabel(label, data) {
        if (label.data) {
            label.data = data;
        }
        return this.language.getLabel(label);
    }
    bindScrollTop() {
        if (typeof this.data.scrollTop === 'function') {
            this.scroll.subscribe(this.destroyed, (e) => {
                if (!this.data.scrollTopParams) {
                    this.data.scrollTopParams = {};
                }
                this.data.scrollTopParams.event = 'scrollTop';
                this.data.scrollTopParams.value = document.documentElement.scrollTop;
                const result = this.data.scrollTop(this.data.scrollTopParams);
                if (result instanceof Observable) {
                    result.subscribe();
                }
            });
        }
    }
    getRouterLink(item) {
        if (item.url) {
            return item.url;
        }
        else if (typeof this.data.link !== 'undefined') {
            return this.link.transform(item, this.data.link);
        }
    }
    load(successCallback, errorCallback, params) {
        let trigger;
        if (typeof this.data.dataSource.interval === 'number'
            && !isPlatformServer(this.platformId)) {
            if (typeof this.data.dataSource.immediate) {
                trigger = timer(0, this.data.dataSource.interval);
            }
            else {
                trigger = interval(this.data.dataSource.interval);
            }
        }
        else {
            trigger = of(1);
        }
        if (this.trigger) {
            this.trigger.unsubscribe();
        }
        this.trigger = trigger.pipe(takeUntil$1(this.destroyed), switchMap(value => this.pauseInterval ? EMPTY : of(value))).subscribe(() => {
            const dataSource = JSON.parse(JSON.stringify(this.data.dataSource));
            if (typeof params !== 'undefined') {
                dataSource.params = this.api.prepServiceCallParams(dataSource.params);
                dataSource.params = Object.assign(dataSource.params, params);
            }
            this.api.callServiceMethod(dataSource)
                .pipe(take(1))
                .subscribe({
                next: (response) => {
                    this.data.dataObject = response.result.data;
                    if (typeof successCallback !== 'undefined') {
                        successCallback(response.result);
                    }
                },
                error: (err) => {
                    if (typeof errorCallback !== 'undefined') {
                        errorCallback(err);
                    }
                }
            });
            if (dataSource.interval && dataSource.intervalLoader === false) {
                dataSource.params.noLoader = true;
            }
        });
    }
    subscribeToCommChannel() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel, this)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
    }
    resetChannels(channels, data) {
        if (channels) {
            if (channels === 'all') {
                this.comm.resetChannels();
            }
        }
        else if (this.data.channel) {
            this.comm.resetChannels(new Set([this.data.channel]), data || this);
        }
    }
    ngOnDestroy() {
        this.resetChannels();
        this.destroyed.next();
        this.destroyed.complete();
    }
}
BaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BaseComponent, selector: "app-base", inputs: { data: "data" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-base', template: '' }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class ObjectMergerService {
    constructor() { }
    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    deep(target, source) {
        const output = JSON.parse(JSON.stringify(target));
        if (this.isObject(target) && this.isObject(source)) {
            Object.keys(source).forEach(key => {
                if (this.isObject(source[key])) {
                    if (!(key in target)) {
                        if (source[key] === null) {
                            delete output[key];
                        }
                        else {
                            Object.assign(output, { [key]: source[key] });
                        }
                    }
                    else {
                        output[key] = this.deep(target[key], source[key]);
                    }
                }
                else if (Array.isArray(source[key])) {
                    if (typeof output[key] === 'undefined') {
                        output[key] = [];
                    }
                    output[key].push(...source[key]);
                }
                else {
                    if (source[key] === null) {
                        delete output[key];
                    }
                    else {
                        Object.assign(output, { [key]: source[key] });
                    }
                }
            });
        }
        return output;
    }
}
ObjectMergerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ObjectMergerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ObjectMergerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ObjectMergerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ObjectMergerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class SelectComponent extends BaseComponent {
    constructor(eventBus, getArrayPath, route, objectMerger, evaluator) {
        super();
        this.eventBus = eventBus;
        this.getArrayPath = getArrayPath;
        this.route = route;
        this.objectMerger = objectMerger;
        this.evaluator = evaluator;
        this.searchOptionsCtrl = new UntypedFormControl();
        this.options = [];
        this.filteredOptions = new ReplaySubject(1);
    }
    ngOnInit() {
        this.selfRef = this;
        this.label = this.data.label;
        this.placeholder = this.data.placeholder;
        if (typeof this.parentForm !== 'undefined') {
            this.control = this.parentForm.get(String(this.data.name));
        }
        else {
            let value;
            if (this.data.multiple) {
                value = [];
            }
            else {
                value = '';
            }
            let disabled = false;
            if (typeof this.data.disabled === 'boolean') {
                disabled = this.data.disabled;
            }
            else if (typeof this.data.disabled === 'object') {
                disabled = this.evaluator.exec(this.data.dataObject, this.data.disabled);
            }
            this.control = new FormControl({ value, disabled });
        }
        super.ngOnInit();
        this.control.valueChanges.pipe(takeUntil(this.destroyed)).subscribe((value) => {
            if (this.data.optgroups) {
                if (Array.isArray(value)) {
                    const triggerText = [];
                    for (const val of value) {
                        const text = this.getTriggerText(val, this.options);
                        if (text) {
                            triggerText.push(text.join(' '));
                        }
                    }
                    this.triggerText = triggerText.join(', ');
                }
                else {
                    const text = this.getTriggerText(value, this.options);
                    if (text) {
                        this.triggerText = text.join(', ');
                    }
                }
            }
            if (typeof this.data.valueChanges === 'function') {
                if (!this.data.valueChangesParams) {
                    this.data.valueChangesParams = {};
                }
                this.data.valueChangesParams.event = 'valueChanges';
                this.data.valueChangesParams.value = this.control.value;
                this.data.valueChangesParams.option = this.options
                    .find((option) => option.value === this.control.value);
                this.data.valueChangesParams.options = this.options;
                const result = this.data.valueChanges(this.data.valueChangesParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
        if (this.data.dataSource) {
            this.load();
        }
        else {
            this.initOptions();
        }
        if (typeof this.data.selectedPath !== 'undefined') {
            if (typeof this.data.dataObject !== 'undefined') {
                let value = this.data.dataObject;
                if (typeof this.data.dataObject === 'object') {
                    value = this.getArrayPath.transform(this.data.dataObject, this.data.selectedPath);
                }
                this.control.setValue(value);
            }
            else {
                let value = this.getArrayPath.transform(undefined, this.data.selectedPath);
                if (this.data.multiple &&
                    !Array.isArray(value)) {
                    value = isNaN(+value) ? [value] : [+value];
                }
                else if (this.data.multiple &&
                    Array.isArray(value)) {
                    value = value.map(v => {
                        return isNaN(+v) ? v : +v;
                    });
                }
                this.control.setValue(value);
            }
        }
        else if (typeof this.data.value !== 'undefined') {
            if (typeof this.data.value === 'string'
                && this.data.value.startsWith(':')
                && this.parentForm) {
            }
            else {
                this.control.setValue(this.data.value);
            }
        }
        if (this.data.searchable) {
            this.searchOptionsCtrl.valueChanges
                .pipe(takeUntil(this.destroyed))
                .subscribe(() => {
                if (!this.options) {
                    return;
                }
                let search = this.searchOptionsCtrl.value;
                if (!search) {
                    this.filteredOptions.next(this.options.slice());
                }
                else {
                    search = search.toLowerCase();
                    this.filteredOptions.next(this.options.map(option => {
                        const optionText = String(option.text);
                        if (optionText.toLowerCase().indexOf(search) > -1
                            || typeof option.children !== 'undefined') {
                            const foundOption = { ...option };
                            if (typeof foundOption.children !== 'undefined') {
                                foundOption.children = foundOption.children.filter((option) => {
                                    const optionText = String(option.text);
                                    return optionText.toLowerCase().indexOf(search) > -1;
                                });
                                if (foundOption.children.length > 0) {
                                    return foundOption;
                                }
                            }
                            else {
                                return foundOption;
                            }
                        }
                    }).filter(option => option !== undefined));
                }
            });
        }
        if (this.data.inActionBar) {
            this.eventBus.on('actionBarControlReset')
                .pipe(takeUntil(this.destroyed))
                .subscribe((data) => {
                if (typeof data.actionParams === 'undefined'
                    || typeof data.actionParams.controls === 'undefined'
                    || (typeof data.actionParams !== 'undefined'
                        && typeof data.actionParams.controls !== 'undefined'
                        && data.actionParams.controls.indexOf(this.data.actionId) >= 0)) {
                    this.control.setValue(this.data.selected);
                    if (typeof this.data.change === 'function') {
                        const result = this.data.change({
                            id: this.data.actionId,
                            value: this.control.value
                        });
                        if (result instanceof Observable) {
                            result.pipe(take$1(1)).subscribe();
                        }
                    }
                }
            });
        }
        if (this.data.selected) {
            if (typeof this.data.selected === 'object') {
                if (Array.isArray(this.data.selected)
                    && typeof this.data.selected[0] === 'object'
                    && 'op' in this.data.selected[0]) {
                }
                else if (typeof this.data.selected !== 'number'
                    && typeof this.data.selected !== 'string') {
                    const condition = this.data.selected;
                    this.filteredOptions.pipe(take$1(1)).subscribe((options) => {
                        const selected = options.find((option) => this.evaluator.exec(option, condition));
                        if (typeof selected !== 'undefined') {
                            if (typeof this.data.optionValuePath !== 'undefined') {
                                this.control.setValue(this.getArrayPath.transform(selected, this.data.optionValuePath));
                            }
                            else if (typeof this.data.dataSource.valuePath !== 'undefined') {
                                this.control.setValue(this.getArrayPath.transform(selected, this.data.dataSource.valuePath));
                            }
                        }
                    });
                }
            }
            else {
                this.control.setValue(this.data.selected);
            }
        }
        if (this.data.optgroups) {
            if (Array.isArray(this.control.value)) {
                const triggerText = [];
                for (const val of this.control.value) {
                    const text = this.getTriggerText(val, this.options);
                    if (text) {
                        triggerText.push(text.join(' '));
                    }
                }
                this.triggerText = triggerText.join(', ');
            }
            else {
                const text = this.getTriggerText(this.control.value, this.options);
                if (text) {
                    this.triggerText = text.join(', ');
                }
            }
        }
    }
    load(params = {}) {
        if (typeof this.data.value !== 'undefined') {
            if (typeof this.data.value === 'string'
                && this.data.value.startsWith(':')
                && this.parentForm) {
            }
            else {
                this.value = this.data.value;
            }
        }
        // load options if datasource is provided
        if (typeof this.data.dataSource.params !== 'undefined') {
            if (Object.keys(params).length > 0) {
                params = this.objectMerger.deep(this.data.dataSource.params, params);
            }
            else {
                params = { ...this.data.dataSource.params };
            }
        }
        this.route.params.pipe(take$1(1)).subscribe(urlParams => {
            // If params or value has dynamic params from route url - search and replace them
            const stringParams = JSON.stringify(params);
            let replaced = stringParams;
            for (const key of Object.keys(urlParams)) {
                const search = ':' + key;
                replaced = replaced.replace(new RegExp(search, 'g'), urlParams[key]);
                if (typeof this.value === 'string') {
                    this.value = this.value.replace(new RegExp(search, 'g'), urlParams[key]);
                }
                if (!isNaN(this.value)) {
                    this.value = Number(this.value);
                }
            }
            if (replaced !== '') {
                params = { ...JSON.parse(replaced) };
            }
        });
        const dataService = this.api.getService(this.data.dataSource.service);
        dataService[this.data.dataSource.method](params)
            .pipe(take$1(1))
            .subscribe((response) => {
            this.data.options = [];
            let optionRes = response.result.data;
            if (this.data.optionsPath) {
                optionRes = this.getArrayPath.transform(optionRes, this.data.optionsPath);
            }
            optionRes.forEach((item) => {
                const option = this.prepOption(item);
                this.data.options.push(option);
                if (this.value) {
                    if (this.data.multiple && typeof this.value === 'string') {
                        this.value = this.value.split(',');
                    }
                    this.control.setValue(this.value);
                }
            });
            this.options = this.data.options;
            if (this.data.labelPath) {
                this.label = this.getArrayPath.transform(response.result.data, this.data.labelPath);
            }
            if (this.data.placeholderPath) {
                this.placeholder = this.getArrayPath.transform(response.result.data, this.data.placeholderPath);
            }
            if (typeof this.data.loaded === 'function') {
                if (!this.data.loadedParams) {
                    this.data.loadedParams = {};
                }
                this.data.loadedParams.event = 'loaded';
                this.data.loadedParams.options = this.options;
                const result = this.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
            this.filteredOptions.next(this.data.options.slice());
        });
    }
    prepOption(item) {
        const value = this.getArrayPath.transform(item, this.data.dataSource.valuePath);
        let label;
        if (this.data.dataSource.labelPath) {
            label = this.getArrayPath.transform(item, this.data.dataSource.labelPath);
        }
        if (this.data.dataSource.multiLabelPath) {
            const labelParts = [];
            for (const path of this.data.dataSource.multiLabelPath) {
                labelParts.push(this.getArrayPath.transform(item, path));
            }
            if (typeof this.data.dataSource.multiPathGlue !== 'undefined') {
                label = labelParts.join(this.data.dataSource.multiPathGlue);
            }
            else {
                label = labelParts.join(' ');
            }
        }
        const option = {
            value,
            text: label,
            level: item.depth
        };
        if (typeof this.data.dataSource.extraOptionData !== 'undefined'
            && Object.keys(this.data.dataSource.extraOptionData).length > 0) {
            for (const extraProp in this.data.dataSource.extraOptionData) {
                option[extraProp] = this.getArrayPath.transform(item, this.data.dataSource.extraOptionData[extraProp]);
            }
        }
        if (typeof item.facetCount !== 'undefined') {
            option.facetCount = item.facetCount;
        }
        if (typeof item.children !== 'undefined') {
            if (typeof option.children === 'undefined') {
                option.children = [];
            }
            for (const childItem of item.children) {
                const childOption = this.prepOption(childItem);
                option.children.push(childOption);
            }
        }
        return option;
    }
    setOptions(options, filter) {
        if (Object.keys(options).length === 0)
            return;
        if (typeof options !== 'undefined' && typeof this.data.optionsSortBy !== 'undefined') {
            options.sort((a, b) => {
                return a[this.data.optionsSortBy] - b[this.data.optionsSortBy];
            });
        }
        if (Array.isArray(options)
            &&
                ((typeof options[0].value === 'undefined'
                    && typeof this.data.optionValuePath !== 'undefined')
                    ||
                        (typeof options[0].text === 'undefined'
                            && typeof this.data.optionTextPath !== 'undefined'))
            ||
                (typeof options[0].facetCount === 'undefined'
                    && typeof this.data.optionFacetPath !== 'undefined')) {
            options = options.map((option) => {
                const newOption = { ...option };
                if (typeof this.data.optionValuePath !== 'undefined') {
                    newOption.value = this.getArrayPath
                        .transform(option, this.data.optionValuePath);
                }
                if (typeof this.data.optionTextPath !== 'undefined') {
                    if (Array.isArray(this.data.optionTextPath[0])) {
                        let text = [];
                        for (const path of this.data.optionTextPath) {
                            text.push(this.getArrayPath.transform(option, path));
                        }
                        if (typeof this.data.optionTextGlue === 'undefined') {
                            this.data.optionTextGlue = ' ';
                        }
                        newOption.text = text.join(this.data.optionTextGlue);
                    }
                    else {
                        newOption.text = this.getArrayPath.transform(option, this.data.optionTextPath);
                    }
                }
                if (typeof this.data.optionFacetPath !== 'undefined') {
                    newOption.facetCount = this.getArrayPath
                        .transform(option, this.data.optionFacetPath);
                }
                return newOption;
            }, this);
        }
        this.options = options;
        if (typeof filter !== 'undefined') {
            this.filterOptions(filter);
        }
        else {
            this.filteredOptions.next(options.slice());
        }
    }
    filterOptions(filter) {
        this.filteredOptions.next(this.options.filter((item) => {
            for (const key in filter) {
                if (item[key] !== filter[key]) {
                    return false;
                }
            }
            return true;
        }));
    }
    change(event, options) {
        if (!this.data.emptyOption && event.value === '') {
            return;
        }
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {};
            }
            this.data.changeParams.event = 'change';
            this.data.changeParams.value = event.value;
            this.data.changeParams.option = options.find((option) => option.value === event.value);
            this.data.changeParams.options = options;
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    toggled(opened) {
        if (typeof this.data.toggled === 'function') {
            const eventParams = {
                event: "toggled",
                opened,
                dataObject: this.data.dataObject
            };
            const result = this.data.toggled(eventParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    initOptions() {
        if (!this.data.options && this.data.optionsPath) {
            let options = this.getArrayPath
                .transform(this.data.dataObject, this.data.optionsPath);
            if (typeof options === 'object' && !Array.isArray(options)) {
                this.data.options = [];
                for (const key in options) {
                    if (options[key]) {
                        this.data.options.push({
                            text: options[key],
                            value: key
                        });
                    }
                }
                this.setOptions(this.data.options);
                return;
            }
            else if (typeof options === 'string') {
                options = options.split(',');
            }
            if (Array.isArray(options)
                && options.every(option => typeof option !== 'object')) {
                this.data.options = options.map(option => {
                    return {
                        text: this.preOptionText(option),
                        value: option
                    };
                });
            }
            else {
                this.data.options = options;
            }
        }
        if (Array.isArray(this.data.options)) {
            this.setOptions(this.data.options);
        }
    }
    clearOptions() {
        this.options = [];
        this.data.options = [];
        this.data.changeParams = {};
        this.filteredOptions.next(this.options.slice());
    }
    preOptionText(text) {
        if (typeof this.data.optionTextPrefix !== 'undefined') {
            text = this.data.optionTextPrefix + text;
        }
        return text;
    }
    getTriggerText(value, options, group = "") {
        let result = [];
        if (group) {
            result.push(group);
        }
        for (const option of options) {
            if (value === option.value) {
                result.push(option.text);
                return result;
            }
            else if (option.children?.length > 0) {
                const outcome = this.getTriggerText(value, option.children, option.text);
                if (outcome) {
                    result = outcome;
                    return result;
                }
            }
        }
    }
    // Programatically toggle the dropdown with the options
    toggleDropdown() {
        setTimeout(() => {
            this.matSelect.toggle();
        }, 0);
    }
    openDropdown() {
        setTimeout(() => {
            this.matSelect.open();
        }, 0);
    }
}
SelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SelectComponent, deps: [{ token: EventBusService }, { token: GetArrayPathPipe }, { token: i1.ActivatedRoute }, { token: ObjectMergerService }, { token: EvalService }], target: i0.ɵɵFactoryTarget.Component });
SelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SelectComponent, selector: "app-select", inputs: { data: "data", parentForm: "parentForm" }, providers: [GetArrayPathPipe], viewQueries: [{ propertyName: "matSelect", first: true, predicate: MatSelect, descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-form-field\r\n  [class]=\"data.class\"\r\n  appearance=\"fill\"\r\n  *ngIf=\"parentForm\"\r\n  [formGroup]=\"parentForm\"\r\n>\r\n  <mat-label>{{ language.getLabel(label) }}</mat-label>\r\n  <mat-select\r\n    #sl\r\n    [id]=\"data.id ? data.id : null\"\r\n    [formControl]=\"control\"\r\n    [multiple]=\"data.multiple\"\r\n    [placeholder]=\"language.getLabel(placeholder)\"\r\n    (selectionChange)=\"change($event, options)\"\r\n    [panelClass]=\"data.panelClass\"\r\n    (openedChange)=\"toggled($event)\"\r\n  >\r\n    <mat-select-trigger *ngIf=\"data.optgroups\">{{ triggerText }}</mat-select-trigger>\r\n    <mat-option *ngIf=\"data.searchable\">\r\n      <ngx-mat-select-search\r\n        [formControl]=\"searchOptionsCtrl\"\r\n        [placeholderLabel]=\"language.getLabel(data.searchPlaceholder)\"\r\n        [noEntriesFoundLabel]=\"language.getLabel(data.searchNotFound)\"\r\n      ></ngx-mat-select-search>\r\n    </mat-option>\r\n    <mat-option *ngIf=\"data.emptyOption\" value=\"\">\r\n      {{ language.getLabel(data.emptyOption) }}\r\n    </mat-option>\r\n    <ng-container *ngIf=\"(filteredOptions | async)?.length > 0; else notFound\">\r\n      <ng-container *ngFor=\"let option of filteredOptions | async\">\r\n        <mat-optgroup *ngIf=\"data.optgroups === true && option.children\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n          <mat-option\r\n            *ngFor=\"let childOption of option.children\"\r\n            [value]=\"childOption.value\"\r\n          >\r\n            {{ language.getLabel(childOption.text) }}\r\n            <span class=\"facetCount\" *ngIf=\"childOption.facetCount\">\r\n              [{{ childOption.facetCount }}]\r\n            </span>\r\n          </mat-option>\r\n        </mat-optgroup>\r\n        <mat-option *ngIf=\"!data.optgroups\"\r\n                    [value]=\"option.value\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n        <mat-option *ngIf=\"data.optgroups === 'flatTree'\"\r\n                    [value]=\"option.value\"\r\n                    [ngClass]=\"{ 'isTop': option.level === 0,\r\n                                 'isChild': option.level > 0 }\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n      </ng-container>\r\n    </ng-container>\r\n    <app-icon \r\n      *ngIf=\"data.multiple\" \r\n      [ngClass]=\"data.searchable ? 'closeIconSearch' : 'closeIcon' \"\r\n      mat-icon-button\r\n      [data]=\"{\r\n        'icon': 'search',\r\n        'color': 'primary'\r\n      }\"\r\n      (click)=\"sl.close()\"\r\n    ></app-icon>\r\n  </mat-select>\r\n</mat-form-field>\r\n<mat-form-field [class]=\"data.class\" appearance=\"fill\" *ngIf=\"!parentForm\">\r\n  <mat-label>{{ language.getLabel(label) }}</mat-label>\r\n  <mat-select\r\n    #sl\r\n    [id]=\"data.id ? data.id : null\"\r\n    [formControl]=\"control\"\r\n    [multiple]=\"data.multiple\"\r\n    [placeholder]=\"language.getLabel(placeholder)\"\r\n    [required]=\"data.required\"\r\n    (selectionChange)=\"change($event, options)\"\r\n    [panelClass]=\"data.panelClass\"\r\n    (openedChange)=\"toggled($event)\"\r\n  >\r\n    <mat-select-trigger *ngIf=\"data.optgroups\">{{ triggerText }}</mat-select-trigger>\r\n    <mat-option *ngIf=\"data.searchable\">\r\n      <ngx-mat-select-search\r\n        [formControl]=\"searchOptionsCtrl\"\r\n        [placeholderLabel]=\"language.getLabel(data.searchPlaceholder)\"\r\n        [noEntriesFoundLabel]=\"language.getLabel(data.searchNotFound)\"\r\n      ></ngx-mat-select-search>\r\n    </mat-option>\r\n    <mat-option *ngIf=\"data.emptyOption\" value=\"\">\r\n      {{ language.getLabel(data.emptyOption) }}\r\n    </mat-option>\r\n    <ng-container *ngIf=\"(filteredOptions | async)?.length > 0; else notFound\">\r\n      <ng-container *ngFor=\"let option of filteredOptions | async\">\r\n        <mat-optgroup *ngIf=\"data.optgroups === true && option.children\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n          <mat-option\r\n            *ngFor=\"let childOption of option.children\"\r\n            [value]=\"childOption.value\"\r\n          >\r\n            {{ language.getLabel(childOption.text) }}\r\n            <span class=\"facetCount\" *ngIf=\"childOption.facetCount\">\r\n              [{{ childOption.facetCount }}]\r\n            </span>\r\n          </mat-option>\r\n        </mat-optgroup>\r\n        <mat-option *ngIf=\"!data.optgroups\"\r\n                    [value]=\"option.value\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n        <mat-option *ngIf=\"data.optgroups === 'flatTree'\"\r\n                    [value]=\"option.value\"\r\n                    [ngClass]=\"{ 'isTop': option.level === 0,\r\n                                 'isChild': option.level > 0 }\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n      </ng-container>\r\n    </ng-container>\r\n    <app-icon \r\n      *ngIf=\"data.multiple\" \r\n      [ngClass]=\"data.searchable ? 'closeIconSearch' : 'closeIcon' \"\r\n      mat-icon-button\r\n      [data]=\"{\r\n        'icon': 'search',\r\n        'color': 'primary'\r\n      }\"\r\n      (click)=\"sl.close()\"\r\n    ></app-icon>\r\n  </mat-select>\r\n</mat-form-field>\r\n\r\n<ng-template #notFound>\r\n  <mat-option *ngIf=\"data.notFoundComponents\" [ngClass]=\"data.notFoundSlotClass\">\r\n    <app-slot\r\n      *ngIf=\"data.notFoundComponents\"\r\n      [parentComponent]=\"selfRef\"\r\n      [items]=\"data.notFoundComponents\"\r\n      [parentForm]=\"parentForm\"\r\n      [componentValue]=\"data.dataObject\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </mat-option>\r\n</ng-template>\r\n", styles: [":host{width:100%}:host mat-form-field{width:100%}.mat-option.isTop{font-weight:700;font-style:italic}.mat-option.isChild{margin-left:15px!important}.closeIconSearch{position:absolute;right:-40px;top:12px;cursor:pointer;z-index:100}.closeIcon{position:absolute;right:5px;top:12px;cursor:pointer;z-index:100}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "component", type: i9.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "directive", type: i9.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "component", type: i2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i2.MatOptgroup, selector: "mat-optgroup", inputs: ["disabled"], exportAs: ["matOptgroup"] }, { kind: "component", type: i11.MatSelectSearchComponent, selector: "ngx-mat-select-search", inputs: ["placeholderLabel", "type", "closeIcon", "closeSvgIcon", "noEntriesFoundLabel", "clearSearchInput", "searching", "disableInitialFocus", "enableClearOnEscapePressed", "preventHomeEndKeyPropagation", "disableScrollToActiveOnOptionsChanged", "ariaLabel", "showToggleAllCheckbox", "toggleAllCheckboxChecked", "toggleAllCheckboxIndeterminate", "toggleAllCheckboxTooltipMessage", "toggleAllCheckboxTooltipPosition", "hideClearSearchButton", "alwaysRestoreSelectedOptionsMulti"], outputs: ["toggleAll"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: IconComponent, selector: "app-icon", inputs: ["data"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-select', providers: [GetArrayPathPipe], template: "<mat-form-field\r\n  [class]=\"data.class\"\r\n  appearance=\"fill\"\r\n  *ngIf=\"parentForm\"\r\n  [formGroup]=\"parentForm\"\r\n>\r\n  <mat-label>{{ language.getLabel(label) }}</mat-label>\r\n  <mat-select\r\n    #sl\r\n    [id]=\"data.id ? data.id : null\"\r\n    [formControl]=\"control\"\r\n    [multiple]=\"data.multiple\"\r\n    [placeholder]=\"language.getLabel(placeholder)\"\r\n    (selectionChange)=\"change($event, options)\"\r\n    [panelClass]=\"data.panelClass\"\r\n    (openedChange)=\"toggled($event)\"\r\n  >\r\n    <mat-select-trigger *ngIf=\"data.optgroups\">{{ triggerText }}</mat-select-trigger>\r\n    <mat-option *ngIf=\"data.searchable\">\r\n      <ngx-mat-select-search\r\n        [formControl]=\"searchOptionsCtrl\"\r\n        [placeholderLabel]=\"language.getLabel(data.searchPlaceholder)\"\r\n        [noEntriesFoundLabel]=\"language.getLabel(data.searchNotFound)\"\r\n      ></ngx-mat-select-search>\r\n    </mat-option>\r\n    <mat-option *ngIf=\"data.emptyOption\" value=\"\">\r\n      {{ language.getLabel(data.emptyOption) }}\r\n    </mat-option>\r\n    <ng-container *ngIf=\"(filteredOptions | async)?.length > 0; else notFound\">\r\n      <ng-container *ngFor=\"let option of filteredOptions | async\">\r\n        <mat-optgroup *ngIf=\"data.optgroups === true && option.children\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n          <mat-option\r\n            *ngFor=\"let childOption of option.children\"\r\n            [value]=\"childOption.value\"\r\n          >\r\n            {{ language.getLabel(childOption.text) }}\r\n            <span class=\"facetCount\" *ngIf=\"childOption.facetCount\">\r\n              [{{ childOption.facetCount }}]\r\n            </span>\r\n          </mat-option>\r\n        </mat-optgroup>\r\n        <mat-option *ngIf=\"!data.optgroups\"\r\n                    [value]=\"option.value\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n        <mat-option *ngIf=\"data.optgroups === 'flatTree'\"\r\n                    [value]=\"option.value\"\r\n                    [ngClass]=\"{ 'isTop': option.level === 0,\r\n                                 'isChild': option.level > 0 }\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n      </ng-container>\r\n    </ng-container>\r\n    <app-icon \r\n      *ngIf=\"data.multiple\" \r\n      [ngClass]=\"data.searchable ? 'closeIconSearch' : 'closeIcon' \"\r\n      mat-icon-button\r\n      [data]=\"{\r\n        'icon': 'search',\r\n        'color': 'primary'\r\n      }\"\r\n      (click)=\"sl.close()\"\r\n    ></app-icon>\r\n  </mat-select>\r\n</mat-form-field>\r\n<mat-form-field [class]=\"data.class\" appearance=\"fill\" *ngIf=\"!parentForm\">\r\n  <mat-label>{{ language.getLabel(label) }}</mat-label>\r\n  <mat-select\r\n    #sl\r\n    [id]=\"data.id ? data.id : null\"\r\n    [formControl]=\"control\"\r\n    [multiple]=\"data.multiple\"\r\n    [placeholder]=\"language.getLabel(placeholder)\"\r\n    [required]=\"data.required\"\r\n    (selectionChange)=\"change($event, options)\"\r\n    [panelClass]=\"data.panelClass\"\r\n    (openedChange)=\"toggled($event)\"\r\n  >\r\n    <mat-select-trigger *ngIf=\"data.optgroups\">{{ triggerText }}</mat-select-trigger>\r\n    <mat-option *ngIf=\"data.searchable\">\r\n      <ngx-mat-select-search\r\n        [formControl]=\"searchOptionsCtrl\"\r\n        [placeholderLabel]=\"language.getLabel(data.searchPlaceholder)\"\r\n        [noEntriesFoundLabel]=\"language.getLabel(data.searchNotFound)\"\r\n      ></ngx-mat-select-search>\r\n    </mat-option>\r\n    <mat-option *ngIf=\"data.emptyOption\" value=\"\">\r\n      {{ language.getLabel(data.emptyOption) }}\r\n    </mat-option>\r\n    <ng-container *ngIf=\"(filteredOptions | async)?.length > 0; else notFound\">\r\n      <ng-container *ngFor=\"let option of filteredOptions | async\">\r\n        <mat-optgroup *ngIf=\"data.optgroups === true && option.children\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n          <mat-option\r\n            *ngFor=\"let childOption of option.children\"\r\n            [value]=\"childOption.value\"\r\n          >\r\n            {{ language.getLabel(childOption.text) }}\r\n            <span class=\"facetCount\" *ngIf=\"childOption.facetCount\">\r\n              [{{ childOption.facetCount }}]\r\n            </span>\r\n          </mat-option>\r\n        </mat-optgroup>\r\n        <mat-option *ngIf=\"!data.optgroups\"\r\n                    [value]=\"option.value\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n        <mat-option *ngIf=\"data.optgroups === 'flatTree'\"\r\n                    [value]=\"option.value\"\r\n                    [ngClass]=\"{ 'isTop': option.level === 0,\r\n                                 'isChild': option.level > 0 }\">\r\n          {{ language.getLabel(option.text) }}\r\n          <span class=\"facetCount\" *ngIf=\"option.facetCount\"\r\n            >[{{ option.facetCount }}]</span\r\n          >\r\n        </mat-option>\r\n      </ng-container>\r\n    </ng-container>\r\n    <app-icon \r\n      *ngIf=\"data.multiple\" \r\n      [ngClass]=\"data.searchable ? 'closeIconSearch' : 'closeIcon' \"\r\n      mat-icon-button\r\n      [data]=\"{\r\n        'icon': 'search',\r\n        'color': 'primary'\r\n      }\"\r\n      (click)=\"sl.close()\"\r\n    ></app-icon>\r\n  </mat-select>\r\n</mat-form-field>\r\n\r\n<ng-template #notFound>\r\n  <mat-option *ngIf=\"data.notFoundComponents\" [ngClass]=\"data.notFoundSlotClass\">\r\n    <app-slot\r\n      *ngIf=\"data.notFoundComponents\"\r\n      [parentComponent]=\"selfRef\"\r\n      [items]=\"data.notFoundComponents\"\r\n      [parentForm]=\"parentForm\"\r\n      [componentValue]=\"data.dataObject\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n  </mat-option>\r\n</ng-template>\r\n", styles: [":host{width:100%}:host mat-form-field{width:100%}.mat-option.isTop{font-weight:700;font-style:italic}.mat-option.isChild{margin-left:15px!important}.closeIconSearch{position:absolute;right:-40px;top:12px;cursor:pointer;z-index:100}.closeIcon{position:absolute;right:5px;top:12px;cursor:pointer;z-index:100}\n"] }]
        }], ctorParameters: function () { return [{ type: EventBusService }, { type: GetArrayPathPipe }, { type: i1.ActivatedRoute }, { type: ObjectMergerService }, { type: EvalService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], matSelect: [{
                type: ViewChild,
                args: [MatSelect]
            }] } });

class CheckboxComponent {
    constructor(language, eventBus, comm) {
        this.language = language;
        this.eventBus = eventBus;
        this.comm = comm;
        this.destroyed$ = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed$))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.init();
    }
    init() {
        if (this.data.inActionBar) {
            this.eventBus.on('actionBarControlReset')
                .pipe(takeUntil$1(this.destroyed$))
                .subscribe((data) => {
                if (typeof data.actionParams === 'undefined'
                    || typeof data.actionParams.controls === 'undefined'
                    || (typeof data.actionParams !== 'undefined'
                        && typeof data.actionParams.controls !== 'undefined'
                        && data.actionParams.controls.indexOf(this.data.actionId) >= 0)) {
                    this.data.checked = this.data.originalValue;
                    if (typeof this.data.change === 'function') {
                        const result = this.data.change({
                            id: this.data.actionId,
                            event: 'change',
                            checked: this.data.checked
                        });
                        if (result instanceof Observable) {
                            result.pipe(take(1)).subscribe();
                        }
                    }
                }
            });
        }
        // Set checked options when data.options exists
        if (typeof this.data.options !== 'undefined') {
            const val = this.parentForm.get(this.data.name).value;
            const splitted = val.split(',');
            for (const i in this.data.options) {
                // tslint:disable-next-line: forin
                for (const splitValue of splitted) {
                    if (this.data.options[i].value === splitValue) {
                        this.data.options[i].checked = true;
                    }
                }
            }
        }
    }
    change(option) {
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {
                    event: "change"
                };
            }
            if (typeof this.data.options !== 'undefined') {
                this.data.changeParams.value = this.data.options;
            }
            else {
                if (typeof this.data.name !== 'undefined') {
                    this.data.changeParams.value = this.data.name;
                }
                this.data.changeParams.checked = this.data.checked;
            }
            if (typeof this.data.dataObject !== 'undefined') {
                this.data.changeParams.dataObject = this.data.dataObject;
            }
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
        // Set value on change when data.options exists
        if (typeof this.data.options !== 'undefined') {
            if (option.checked) {
                option.checked = false;
            }
            else {
                option.checked = true;
            }
            let val = '';
            for (const i in this.data.options) {
                if (this.data.options[i].checked) {
                    val += this.data.options[i].value + ',';
                }
            }
            if (val.endsWith(',')) {
                val = val.substring(0, val.length - 1);
            }
            this.parentForm.get(this.data.name).setValue(val);
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
CheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CheckboxComponent, deps: [{ token: LanguageService }, { token: EventBusService }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
CheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CheckboxComponent, selector: "app-checkbox", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<div *ngIf=\"parentForm\" [formGroup]=\"parentForm\" [class]=\"data.class\">\r\n  <ng-container *ngIf=\"!data.options; else optionsTemplate\">\r\n    <mat-checkbox\r\n      [color]=\"data.color\"\r\n      [labelPosition]=\"data.labelPosition\"\r\n      [formControlName]=\"data.name\"\r\n      (change)=\"change()\"\r\n    >\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"data\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n      <ng-container *ngIf=\"data.label\">\r\n        {{ language.getLabel(data.label) }}\r\n      </ng-container>\r\n    </mat-checkbox>\r\n  </ng-container>\r\n</div>\r\n<ng-container *ngIf=\"!parentForm\">\r\n  <mat-checkbox\r\n    [color]=\"data.color\"\r\n    [(ngModel)]=\"data.checked\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    (change)=\"change()\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </mat-checkbox>\r\n</ng-container>\r\n\r\n<ng-template #optionsTemplate>\r\n  <div [class]=\"data.labelClass\">{{ language.getLabel(data.label) }}</div>\r\n  <input type=\"hidden\" [formControlName]=\"data.name\" />\r\n  <mat-checkbox\r\n    *ngFor=\"let option of data.options\"\r\n    [color]=\"option.color\"\r\n    [labelPosition]=\"option.labelPosition\"\r\n    [disabled]=\"option.disabled\"\r\n    [value]=\"option.value\"\r\n    [checked]=\"option.checked\"\r\n    [class]=\"option.class\"\r\n    (change)=\"change(option)\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"option.components\"\r\n      [items]=\"option.components\"\r\n      [componentValue]=\"option\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n    <ng-container *ngIf=\"option.label\">\r\n      {{ language.getLabel(option.label) }}\r\n    </ng-container>\r\n    <span class=\"facetCount\" *ngIf=\"option.facetCount\">[{{ option.facetCount }}]</span>\r\n  </mat-checkbox>\r\n</ng-template>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-checkbox', template: "<div *ngIf=\"parentForm\" [formGroup]=\"parentForm\" [class]=\"data.class\">\r\n  <ng-container *ngIf=\"!data.options; else optionsTemplate\">\r\n    <mat-checkbox\r\n      [color]=\"data.color\"\r\n      [labelPosition]=\"data.labelPosition\"\r\n      [formControlName]=\"data.name\"\r\n      (change)=\"change()\"\r\n    >\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"data\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n      <ng-container *ngIf=\"data.label\">\r\n        {{ language.getLabel(data.label) }}\r\n      </ng-container>\r\n    </mat-checkbox>\r\n  </ng-container>\r\n</div>\r\n<ng-container *ngIf=\"!parentForm\">\r\n  <mat-checkbox\r\n    [color]=\"data.color\"\r\n    [(ngModel)]=\"data.checked\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    (change)=\"change()\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n      [componentValue]=\"data\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </mat-checkbox>\r\n</ng-container>\r\n\r\n<ng-template #optionsTemplate>\r\n  <div [class]=\"data.labelClass\">{{ language.getLabel(data.label) }}</div>\r\n  <input type=\"hidden\" [formControlName]=\"data.name\" />\r\n  <mat-checkbox\r\n    *ngFor=\"let option of data.options\"\r\n    [color]=\"option.color\"\r\n    [labelPosition]=\"option.labelPosition\"\r\n    [disabled]=\"option.disabled\"\r\n    [value]=\"option.value\"\r\n    [checked]=\"option.checked\"\r\n    [class]=\"option.class\"\r\n    (change)=\"change(option)\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"option.components\"\r\n      [items]=\"option.components\"\r\n      [componentValue]=\"option\"\r\n      style=\"display: block; width: 100%; height: 100%\"\r\n    ></app-slot>\r\n    <ng-container *ngIf=\"option.label\">\r\n      {{ language.getLabel(option.label) }}\r\n    </ng-container>\r\n    <span class=\"facetCount\" *ngIf=\"option.facetCount\">[{{ option.facetCount }}]</span>\r\n  </mat-checkbox>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: EventBusService }, { type: CommunicationService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class SlideToggleComponent {
    constructor(language, getArrPath, evaluator) {
        this.language = language;
        this.getArrPath = getArrPath;
        this.evaluator = evaluator;
        this.checked = false;
    }
    ngOnInit() {
        if (typeof this.data.path !== 'undefined') {
            this.checked = !!this.getArrPath.get(this.data.dataObject, this.data.path);
        }
        else {
            if (typeof this.data.checked === 'object'
                && ('op' in this.data.checked
                    || (Array.isArray(this.data.checked)
                        && 'op' in this.data.checked))) {
                this.checked = this.evaluator.exec(this.data.dataObject, this.data.checked);
            }
            else {
                this.checked = Boolean(this.data.checked);
            }
        }
    }
    change(slideToggle) {
        if (typeof this.data.change === 'function') {
            this.data.checked = slideToggle.checked;
            this.data.changeParams = {
                value: slideToggle.checked,
                event: 'change',
                dataObject: this.data.dataObject
            };
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
        if (typeof this.data.check === 'function' && slideToggle.checked) {
            this.data.checked = slideToggle.checked;
            this.data.checkParams = {
                value: slideToggle.checked,
                event: 'check',
                dataObject: this.data.dataObject
            };
            const result = this.data.check(this.data.checkParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
        if (typeof this.data.uncheck === 'function' && !slideToggle.checked) {
            this.data.checked = slideToggle.checked;
            this.data.uncheckParams = {
                value: slideToggle.checked,
                event: 'uncheck',
                dataObject: this.data.dataObject
            };
            const result = this.data.uncheck(this.data.uncheckParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
}
SlideToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlideToggleComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }, { token: EvalService }], target: i0.ɵɵFactoryTarget.Component });
SlideToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SlideToggleComponent, selector: "app-slide-toggle", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n  <mat-slide-toggle\r\n    [color]=\"data.color\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    [checked]=\"checked\"\r\n    (change)=\"change($event)\"\r\n    [formControlName]=\"data.name\"\r\n  >\r\n    {{ language.getLabel(data.label) }}\r\n  </mat-slide-toggle>\r\n</ng-container>\r\n<ng-container *ngIf=\"!parentForm\">\r\n  <mat-slide-toggle\r\n    [color]=\"data.color\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    [checked]=\"checked\"\r\n    (change)=\"change($event)\"\r\n  >\r\n    {{ language.getLabel(data.label) }}\r\n  </mat-slide-toggle>\r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6$1.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlideToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-slide-toggle', template: "<ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n  <mat-slide-toggle\r\n    [color]=\"data.color\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    [checked]=\"checked\"\r\n    (change)=\"change($event)\"\r\n    [formControlName]=\"data.name\"\r\n  >\r\n    {{ language.getLabel(data.label) }}\r\n  </mat-slide-toggle>\r\n</ng-container>\r\n<ng-container *ngIf=\"!parentForm\">\r\n  <mat-slide-toggle\r\n    [color]=\"data.color\"\r\n    [labelPosition]=\"data.labelPosition\"\r\n    [disabled]=\"data.disabled\"\r\n    [checked]=\"checked\"\r\n    (change)=\"change($event)\"\r\n  >\r\n    {{ language.getLabel(data.label) }}\r\n  </mat-slide-toggle>\r\n</ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }, { type: EvalService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class ImageComponent {
    constructor(language, getArrayPath, comm, api) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.comm = comm;
        this.api = api;
        this.onlyOriginal = true;
        this.size = '';
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.load();
    }
    load() {
        if (typeof this.data.displaySize !== 'undefined') {
            this.size = this.data.displaySize + '_';
        }
        if (typeof this.data.srcPath !== 'undefined') {
            // url comes from data object
            this.src = this.getArrayPath.get(this.data.dataObject, this.data.srcPath);
            this.onlyOriginal = (typeof this.src !== 'object');
        }
        else {
            // direct url configured
            this.src = this.data.src;
        }
        if (typeof this.data.base !== 'undefined') {
            switch (this.data.base) {
                case 'apiAccessPointHost':
                    const config = this.api.getService('ConfigService').getAccessPoint();
                    let apiAccessPointUrl = config.url.protocol + '://';
                    apiAccessPointUrl += config.url.hostname;
                    this.src = apiAccessPointUrl + this.src;
                    break;
                default:
                    this.src = this.data.base + this.src;
                    break;
            }
        }
    }
}
ImageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }, { token: CommunicationService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Component });
ImageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ImageComponent, selector: "app-image", inputs: { data: "data" }, ngImport: i0, template: "<ng-container *ngIf=\"src\">\r\n  <ng-container *ngIf=\"onlyOriginal\">\r\n    <img\r\n      [src]=\"src\"\r\n      [attr.class]=\"data.class\"\r\n      [attr.alt]=\"language.getLabel(data.alt)\"\r\n      [attr.title]=\"language.getLabel(data.title)\"\r\n    />\r\n  </ng-container>\r\n  <picture *ngIf=\"!onlyOriginal\">\r\n    <source srcset=\"{{src[size + 'webp']}}\" type=\"image/webp\" />\r\n    <source\r\n      *ngIf=\"\r\n        src[size + 'original'].endsWith('.jpg') ||\r\n        src[size + 'original'].endsWith('.jpeg')\r\n      \"\r\n      srcset=\"{{src[size + 'original']}}\"\r\n      type=\"image/jpeg\"\r\n    />\r\n    <source\r\n      *ngIf=\"src[size + 'original'].endsWith('.png')\"\r\n      srcset=\"{{src[size + 'original']}}\"\r\n      type=\"image/png\"\r\n    />\r\n    <img\r\n      [src]=\"src[size + 'original']\"\r\n      [attr.class]=\"data.class\"\r\n      [attr.alt]=\"language.getLabel(data.alt)\"\r\n      [attr.title]=\"language.getLabel(data.title)\"\r\n    />\r\n  </picture>\r\n</ng-container>", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-image', template: "<ng-container *ngIf=\"src\">\r\n  <ng-container *ngIf=\"onlyOriginal\">\r\n    <img\r\n      [src]=\"src\"\r\n      [attr.class]=\"data.class\"\r\n      [attr.alt]=\"language.getLabel(data.alt)\"\r\n      [attr.title]=\"language.getLabel(data.title)\"\r\n    />\r\n  </ng-container>\r\n  <picture *ngIf=\"!onlyOriginal\">\r\n    <source srcset=\"{{src[size + 'webp']}}\" type=\"image/webp\" />\r\n    <source\r\n      *ngIf=\"\r\n        src[size + 'original'].endsWith('.jpg') ||\r\n        src[size + 'original'].endsWith('.jpeg')\r\n      \"\r\n      srcset=\"{{src[size + 'original']}}\"\r\n      type=\"image/jpeg\"\r\n    />\r\n    <source\r\n      *ngIf=\"src[size + 'original'].endsWith('.png')\"\r\n      srcset=\"{{src[size + 'original']}}\"\r\n      type=\"image/png\"\r\n    />\r\n    <img\r\n      [src]=\"src[size + 'original']\"\r\n      [attr.class]=\"data.class\"\r\n      [attr.alt]=\"language.getLabel(data.alt)\"\r\n      [attr.title]=\"language.getLabel(data.title)\"\r\n    />\r\n  </picture>\r\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }, { type: CommunicationService }, { type: ApiService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class AutocompleteComponent {
    constructor(api, getArrayPath, language, eventBus, libraries) {
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.language = language;
        this.eventBus = eventBus;
        this.libraries = libraries;
        this.objectValue = {};
        this.filteredOptions = [];
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.options === 'undefined') {
            if (this.data.load) {
                this.load();
            }
            if (this.parentForm) {
                this.formControl = this.parentForm.controls[this.data.name];
            }
            else {
                this.formControl = new UntypedFormControl();
            }
            if (!this.data.dueTime) {
                this.data.dueTime = 1500;
            }
            this.formControl.valueChanges
                .pipe(debounceTime(this.data.dueTime), takeUntil(this.destroy$))
                .subscribe(selectedValue => {
                this.inputChange(selectedValue);
                if (selectedValue === null || typeof selectedValue === 'undefined') {
                    return;
                }
                let text;
                if (typeof selectedValue === 'string') {
                    text = selectedValue;
                    if (text === this.lastValue) {
                        return;
                    }
                    if (text !== '' && typeof text === 'string' && text.length > 1) {
                        this.load(text);
                    }
                }
                else {
                    if (Array.isArray(selectedValue)) {
                        selectedValue = selectedValue[0];
                    }
                    if (selectedValue.value === this.lastValue) {
                        return;
                    }
                    text = selectedValue.text;
                }
            });
            if (this.data.inActionBar) {
                this.eventBus.on('actionBarControlReset')
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((data) => {
                    if (typeof data.actionParams === 'undefined'
                        || typeof data.actionParams.controls === 'undefined'
                        || (typeof data.actionParams !== 'undefined'
                            && typeof data.actionParams.controls !== 'undefined'
                            && data.actionParams.controls.indexOf(this.data.actionId) >= 0)) {
                        if (typeof this.data.value !== 'undefined' && this.data.value === '') {
                            let val = this.data.value;
                            if (typeof this.formControl.value === 'object' && this.formControl.value !== null) {
                                // If value comes from response or is set outside of the component
                                val = this.formControl.value;
                                this.filteredOptions.push(val);
                            }
                            if (val) {
                                this.formControl.setValue(val);
                            }
                        }
                        else {
                            this.formControl.reset();
                        }
                        if (typeof this.data.change === 'function') {
                            const result = this.data.change({
                                id: this.data.actionId,
                                value: this.data.value,
                                event: 'change'
                            });
                            if (result instanceof Observable) {
                                result.pipe(take$1(1)).subscribe();
                            }
                        }
                    }
                });
            }
            let val = this.data.value;
            if (typeof this.formControl.value === 'object' && this.formControl.value !== null) {
                // If value comes from response or is set outside of the component
                val = this.formControl.value;
                this.filteredOptions.push(val);
            }
            if (typeof this.data.dataObject !== 'undefined' &&
                typeof this.data.labelPath !== 'undefined' &&
                typeof this.data.valuePath !== 'undefined') {
                const label = this.getArrayPath.transform(this.data.dataObject, this.data.labelPath);
                const value = this.getArrayPath.transform(this.data.dataObject, this.data.valuePath);
                val = {
                    text: label,
                    value
                };
            }
            if (val) {
                this.formControl.setValue(val);
            }
        }
        else {
            this.filteredOptions = this.data.options;
        }
    }
    load(search) {
        let dataService;
        if (typeof this.data.dataSource.lib !== 'undefined') {
            dataService = this.libraries.getService(this.data.dataSource.lib, this.data.dataSource.service);
        }
        else {
            dataService = this.api.getService(this.data.dataSource.service);
        }
        let params = {
            mutations: []
        };
        let isReplaced = false;
        if (this.data.dataSource.params) {
            let stringParams = JSON.stringify({ ...this.data.dataSource.params });
            if (typeof this.parentForm !== 'undefined') {
                const rootForm = this.parentForm.root;
                const formValues = rootForm.getRawValue();
                for (const p in formValues) {
                    if (typeof formValues[p] !== 'undefined') {
                        stringParams = stringParams.replace('{' + p + '}', formValues[p]);
                    }
                }
            }
            const modifyWhereClauses = stringParams.replace(/{term}/g, search);
            if (modifyWhereClauses !== stringParams) {
                isReplaced = true;
            }
            params = JSON.parse(modifyWhereClauses);
        }
        if (typeof search !== 'undefined' && !isReplaced) {
            if (typeof this.data.termKey === 'undefined') {
                this.data.termKey = 'name';
            }
            if (typeof this.data.dataSource?.params?.query === 'undefined') {
                search = '%' + search + '%';
            }
            const mutation = {
                constraint: this.data.defaultConstraint || 'whereTranslation',
                params: [this.data.termKey, 'like', search]
            };
            params.mutations.push(mutation);
        }
        dataService[this.data.dataSource.method](params)
            .pipe(take$1(1))
            .subscribe((response) => {
            this.filteredOptions = [];
            this.responseData = response.result.data;
            let loopData = response.result.data;
            if (typeof this.data.path !== 'undefined') {
                loopData = this.getArrayPath.transform(response.result.data, this.data.path);
            }
            loopData.forEach((item) => {
                const value = this.getArrayPath.transform(item, this.data.dataSource.valuePath);
                let label = '';
                if (this.data.dataSource.multiLabelPath) {
                    for (const path of this.data.dataSource.multiLabelPath) {
                        const lab = this.getArrayPath.transform(item, path);
                        if (lab) {
                            label += lab + (this.data.dataSource.multiPathGlue || ' | ');
                        }
                    }
                }
                else {
                    label = this.getArrayPath.transform(item, this.data.dataSource.labelPath);
                }
                const optionObject = {
                    value,
                    text: label
                };
                if (this.data.showOptionImage) {
                    optionObject.image = this.getArrayPath.transform(item, this.data.imagePath);
                }
                this.filteredOptions.push(optionObject);
            });
            /*
            If autoSelect flag is true and there is only
            one option left - select it automatically
            */
            if (this.data.autoSelect && this.filteredOptions.length === 1) {
                this.formControl.setValue(this.filteredOptions[0]);
                const item = Object.assign({}, this.filteredOptions[0]);
                this.change({ option: item });
                this.filteredOptions = [];
            }
        });
    }
    getValue(object, path) {
        let value = this.getArrayPath.transform(object, path);
        if (Array.isArray(value)) {
            value = value[0];
        }
        return value;
    }
    getLabel(object, path) {
        let label = this.getArrayPath.transform(object, path);
        if (Array.isArray(label)) {
            label = label[0];
        }
        return label;
    }
    displayFn(option) {
        if (Array.isArray(option)) {
            option = option[0];
        }
        if (typeof option === 'object' && option !== null && option.text !== 'undefined') {
            return option.text;
        }
        let returnValue = [];
        if (typeof this.filteredOptions !== 'undefined'
            && this.filteredOptions.length > 0) {
            returnValue = this.filteredOptions.filter(object => {
                return object.value === option;
            });
        }
        if (returnValue.length > 0) {
            return returnValue[0].text;
        }
        return '';
    }
    change(event) {
        const value = event.option.value;
        this.lastValue = value;
        if (typeof this.data.oneTimeSelection !== 'undefined'
            && this.data.oneTimeSelection === true) {
            this.formControl.disable();
        }
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {
                    value
                };
            }
            else {
                this.data.changeParams.value = value;
            }
            this.data.changeParams.event = 'change';
            if (this.formControl) {
                this.data.changeParams.control = this.formControl;
            }
            if (this.responseData.length === 1) {
                this.data.changeParams.dataObject = this.responseData[0];
            }
            else if (this.responseData.length > 1) {
                this.responseData.forEach((item) => {
                    if (Array.isArray(this.data.dataSource.valuePath)) {
                        if (this.getArrayPath.transform(item, this.data.dataSource.valuePath) === event.option.value) {
                            this.data.changeParams.dataObject = item;
                        }
                    }
                    else {
                        if (item[this.data.dataSource.valuePath] === event.option.value) {
                            this.data.changeParams.dataObject = item;
                        }
                    }
                });
            }
            else {
                this.data.changeParams.dataObject = value;
            }
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(takeUntil(this.destroy$)).subscribe();
            }
        }
    }
    blur($event) {
        if (typeof this.data.blur === 'function') {
            if (!this.data.blurParams) {
                this.data.blurParams = {
                    value: this.formControl.value
                };
            }
            else {
                this.data.blurParams.value = this.formControl.value;
            }
            this.data.blurParams.event = 'blur';
            if (this.formControl) {
                this.data.blurParams.control = this.formControl;
            }
            if (this.responseData?.length > 0) {
                this.responseData.forEach((item) => {
                    if (Array.isArray(this.data.dataSource.valuePath)) {
                        if (this.getArrayPath.transform(item, this.data.dataSource.valuePath) === this.formControl.value) {
                            this.data.blurParams.dataObject = item;
                        }
                    }
                    else {
                        if (item[this.data.dataSource.valuePath] === this.formControl.value) {
                            this.data.blurParams.dataObject = item;
                        }
                    }
                });
            }
            else {
                this.data.blurParams.dataObject = this.formControl.value;
            }
            const result = this.data.blur(this.data.blurParams);
            if (result instanceof Observable) {
                result.pipe(takeUntil(this.destroy$)).subscribe();
            }
        }
    }
    inputChange(value) {
        if (typeof this.data.inputChange === 'function') {
            if (!this.data.inputChangeParams) {
                this.data.inputChangeParams = {
                    value
                };
            }
            else {
                this.data.inputChangeParams.value = value;
            }
            this.data.inputChangeParams.event = 'inputChange';
            if (this.formControl) {
                this.data.inputChangeParams.control = this.formControl;
            }
            if (this.responseData?.length > 0) {
                this.responseData.forEach((item) => {
                    if (Array.isArray(this.data.dataSource.valuePath)) {
                        if (this.getArrayPath.transform(item, this.data.dataSource.valuePath) === value) {
                            this.data.inputChangeParams.dataObject = item;
                        }
                    }
                    else {
                        if (item[this.data.dataSource.valuePath] === value) {
                            this.data.inputChangeParams.dataObject = item;
                        }
                    }
                });
            }
            else {
                this.data.inputChangeParams.dataObject = value;
            }
            const result = this.data.inputChange(this.data.inputChangeParams);
            if (result instanceof Observable) {
                result.pipe(takeUntil(this.destroy$)).subscribe();
            }
        }
    }
    select($event) {
        if (typeof this.data.select === 'function') {
            $event.preventDefault();
            if (!this.data.selectParams
                || this.data.selectParams.value !== this.formControl.value) {
                this.data.selectParams = {};
                this.data.selectParams.event = 'select';
                this.data.selectParams.$event = $event;
                this.data.selectParams.value = this.formControl.value;
                if (this.responseData) {
                    this.data.selectParams.responseData = this.responseData;
                }
            }
            if (this.parentForm) {
                if (this.data.name) {
                    this.data.selectParams.control = this.formControl;
                    if (this.data.selectParams.control.disabled) {
                        return;
                    }
                }
            }
            const result = this.data.select(this.data.selectParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
AutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AutocompleteComponent, deps: [{ token: ApiService }, { token: GetArrayPathPipe }, { token: LanguageService }, { token: EventBusService }, { token: LibrariesService }], target: i0.ɵɵFactoryTarget.Component });
AutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AutocompleteComponent, selector: "app-autocomplete", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<mat-form-field appearance=\"fill\" [formGroup]=\"parentForm\" *ngIf=\"parentForm\" [class]=\"data.class\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [id]=\"data.id ? data.id : null\"\r\n    [placeholder]=\"language.getLabel(data.label)\"\r\n    [formControlName]=\"data.name\"\r\n    name=\"{{ data.name }}\"\r\n    [type]=\"data.inputType\"\r\n    [matAutocomplete]=\"auto\"\r\n    (blur)=\"blur($event)\"\r\n  />\r\n  <mat-icon *ngIf=\"data.suffixIcon\" matSuffix (click)=\"select($event)\">{{ data.suffixIcon }}</mat-icon>\r\n\r\n  <mat-autocomplete\r\n    #auto=\"matAutocomplete\"\r\n    [autoActiveFirstOption]=\"\r\n      data.autoActiveFirstOption ? data.autoActiveFirstOption : false\r\n    \"\r\n    [displayWith]=\"displayFn.bind(this)\"\r\n    (optionSelected)=\"change($event)\"\r\n  >\r\n    <div *ngIf=\"data.optionsTitle\" [class]=\"data.optionsTitleClasses\">{{ data.optionsTitle }}</div>\r\n    <mat-option\r\n      *ngFor=\"let option of filteredOptions\"\r\n      [value]=\"option.value\"\r\n      [class]=\"data.optionClasses\">\r\n        <span *ngIf=\"!data.baseRedirectRoute\" [class]=\"data.optionTextClasses\">{{ option.text }}</span>\r\n        <a\r\n          *ngIf=\"data.baseRedirectRoute\"\r\n          [routerLink]=\"[data.baseRedirectRoute, option.value]\"\r\n          [class]=\"data.itemRowClasses\">\r\n            <app-image\r\n              *ngIf=\"data.showOptionImage && option.image\"\r\n              [class]=\"data.imageClasses\"\r\n              [data]=\"\r\n                {\r\n                  class: 'w-100',\r\n                  dataObject: option.image,\r\n                  srcPath: '',\r\n                  displaySize: 400\r\n                }\r\n              \">\r\n            </app-image>\r\n            <span *ngIf=\"data.showOptionImage && !option.image\" class=\"noImageFoundContainer\"></span>\r\n            <span [class]=\"data.optionTextClasses\">\r\n              {{ option.text }}\r\n            </span>\r\n        </a>\r\n    </mat-option>\r\n\r\n    <ng-container *ngIf=\"data.additionalOptionsComponents\">\r\n      <app-slot\r\n        [items]=\"data.additionalOptionsComponents\"\r\n        [componentValue]=\"responseData | getArrayPath: data.additionalOptionsPath\"\r\n        [detectChanges]=\"true\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n\r\n<mat-form-field appearance=\"fill\" *ngIf=\"!parentForm\" [class]=\"data.class\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [id]=\"data.id ? data.id : null\"\r\n    [placeholder]=\"language.getLabel(data.label)\"\r\n    [formControl]=\"formControl\"\r\n    name=\"no-name\"\r\n    [type]=\"data.inputType\"\r\n    [matAutocomplete]=\"auto\"\r\n    (keyup.enter)=\"select($event)\"\r\n  />\r\n  <mat-icon *ngIf=\"data.suffixIcon\" matSuffix (click)=\"select($event)\">{{ data.suffixIcon }}</mat-icon>\r\n\r\n  <mat-autocomplete\r\n    #auto=\"matAutocomplete\"\r\n    [autoActiveFirstOption]=\"\r\n      data.autoActiveFirstOption ? data.autoActiveFirstOption : false\r\n    \"\r\n    [displayWith]=\"displayFn.bind(this)\"\r\n    (optionSelected)=\"change($event)\"\r\n  >\r\n  <div *ngIf=\"data.optionsTitle\" [class]=\"data.optionsTitleClasses\">{{ data.optionsTitle }}</div>\r\n  <mat-option\r\n    *ngFor=\"let option of filteredOptions\"\r\n    [value]=\"option.value\"\r\n    [class]=\"data.optionClasses\">\r\n      <span *ngIf=\"!data.baseRedirectRoute\" [class]=\"data.optionTextClasses\">{{ option.text }}</span>\r\n      <a\r\n        *ngIf=\"data.baseRedirectRoute\"\r\n        [routerLink]=\"[data.baseRedirectRoute, option.value]\"\r\n        [class]=\"data.itemRowClasses\">\r\n          <app-image\r\n            *ngIf=\"data.showOptionImage && option.image\"\r\n            [class]=\"data.imageClasses\"\r\n            [data]=\"\r\n              {\r\n                class: 'w-100',\r\n                dataObject: option.image,\r\n                srcPath: '',\r\n                displaySize: 400\r\n              }\r\n            \">\r\n          </app-image>\r\n          <span *ngIf=\"data.showOptionImage && !option.image\" class=\"noImageFoundContainer\"></span>\r\n          <span [class]=\"data.optionTextClasses\">\r\n            {{ option.text }}\r\n          </span>\r\n      </a>\r\n  </mat-option>\r\n\r\n  <ng-container *ngIf=\"data.additionalOptionsComponents\">\r\n    <app-slot\r\n      [items]=\"data.additionalOptionsComponents\"\r\n      [componentValue]=\"responseData | getArrayPath: data.additionalOptionsPath\"\r\n      [detectChanges]=\"true\"\r\n      class=\"w-100\"\r\n    ></app-slot>\r\n  </ng-container>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix]" }, { kind: "component", type: i2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i12.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i12.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "directive", type: i12$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: ImageComponent, selector: "app-image", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-autocomplete', template: "<mat-form-field appearance=\"fill\" [formGroup]=\"parentForm\" *ngIf=\"parentForm\" [class]=\"data.class\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [id]=\"data.id ? data.id : null\"\r\n    [placeholder]=\"language.getLabel(data.label)\"\r\n    [formControlName]=\"data.name\"\r\n    name=\"{{ data.name }}\"\r\n    [type]=\"data.inputType\"\r\n    [matAutocomplete]=\"auto\"\r\n    (blur)=\"blur($event)\"\r\n  />\r\n  <mat-icon *ngIf=\"data.suffixIcon\" matSuffix (click)=\"select($event)\">{{ data.suffixIcon }}</mat-icon>\r\n\r\n  <mat-autocomplete\r\n    #auto=\"matAutocomplete\"\r\n    [autoActiveFirstOption]=\"\r\n      data.autoActiveFirstOption ? data.autoActiveFirstOption : false\r\n    \"\r\n    [displayWith]=\"displayFn.bind(this)\"\r\n    (optionSelected)=\"change($event)\"\r\n  >\r\n    <div *ngIf=\"data.optionsTitle\" [class]=\"data.optionsTitleClasses\">{{ data.optionsTitle }}</div>\r\n    <mat-option\r\n      *ngFor=\"let option of filteredOptions\"\r\n      [value]=\"option.value\"\r\n      [class]=\"data.optionClasses\">\r\n        <span *ngIf=\"!data.baseRedirectRoute\" [class]=\"data.optionTextClasses\">{{ option.text }}</span>\r\n        <a\r\n          *ngIf=\"data.baseRedirectRoute\"\r\n          [routerLink]=\"[data.baseRedirectRoute, option.value]\"\r\n          [class]=\"data.itemRowClasses\">\r\n            <app-image\r\n              *ngIf=\"data.showOptionImage && option.image\"\r\n              [class]=\"data.imageClasses\"\r\n              [data]=\"\r\n                {\r\n                  class: 'w-100',\r\n                  dataObject: option.image,\r\n                  srcPath: '',\r\n                  displaySize: 400\r\n                }\r\n              \">\r\n            </app-image>\r\n            <span *ngIf=\"data.showOptionImage && !option.image\" class=\"noImageFoundContainer\"></span>\r\n            <span [class]=\"data.optionTextClasses\">\r\n              {{ option.text }}\r\n            </span>\r\n        </a>\r\n    </mat-option>\r\n\r\n    <ng-container *ngIf=\"data.additionalOptionsComponents\">\r\n      <app-slot\r\n        [items]=\"data.additionalOptionsComponents\"\r\n        [componentValue]=\"responseData | getArrayPath: data.additionalOptionsPath\"\r\n        [detectChanges]=\"true\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n\r\n<mat-form-field appearance=\"fill\" *ngIf=\"!parentForm\" [class]=\"data.class\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [id]=\"data.id ? data.id : null\"\r\n    [placeholder]=\"language.getLabel(data.label)\"\r\n    [formControl]=\"formControl\"\r\n    name=\"no-name\"\r\n    [type]=\"data.inputType\"\r\n    [matAutocomplete]=\"auto\"\r\n    (keyup.enter)=\"select($event)\"\r\n  />\r\n  <mat-icon *ngIf=\"data.suffixIcon\" matSuffix (click)=\"select($event)\">{{ data.suffixIcon }}</mat-icon>\r\n\r\n  <mat-autocomplete\r\n    #auto=\"matAutocomplete\"\r\n    [autoActiveFirstOption]=\"\r\n      data.autoActiveFirstOption ? data.autoActiveFirstOption : false\r\n    \"\r\n    [displayWith]=\"displayFn.bind(this)\"\r\n    (optionSelected)=\"change($event)\"\r\n  >\r\n  <div *ngIf=\"data.optionsTitle\" [class]=\"data.optionsTitleClasses\">{{ data.optionsTitle }}</div>\r\n  <mat-option\r\n    *ngFor=\"let option of filteredOptions\"\r\n    [value]=\"option.value\"\r\n    [class]=\"data.optionClasses\">\r\n      <span *ngIf=\"!data.baseRedirectRoute\" [class]=\"data.optionTextClasses\">{{ option.text }}</span>\r\n      <a\r\n        *ngIf=\"data.baseRedirectRoute\"\r\n        [routerLink]=\"[data.baseRedirectRoute, option.value]\"\r\n        [class]=\"data.itemRowClasses\">\r\n          <app-image\r\n            *ngIf=\"data.showOptionImage && option.image\"\r\n            [class]=\"data.imageClasses\"\r\n            [data]=\"\r\n              {\r\n                class: 'w-100',\r\n                dataObject: option.image,\r\n                srcPath: '',\r\n                displaySize: 400\r\n              }\r\n            \">\r\n          </app-image>\r\n          <span *ngIf=\"data.showOptionImage && !option.image\" class=\"noImageFoundContainer\"></span>\r\n          <span [class]=\"data.optionTextClasses\">\r\n            {{ option.text }}\r\n          </span>\r\n      </a>\r\n  </mat-option>\r\n\r\n  <ng-container *ngIf=\"data.additionalOptionsComponents\">\r\n    <app-slot\r\n      [items]=\"data.additionalOptionsComponents\"\r\n      [componentValue]=\"responseData | getArrayPath: data.additionalOptionsPath\"\r\n      [detectChanges]=\"true\"\r\n      class=\"w-100\"\r\n    ></app-slot>\r\n  </ng-container>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: GetArrayPathPipe }, { type: LanguageService }, { type: EventBusService }, { type: LibrariesService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class InputComponent {
    constructor(language, eventBus, comm, getArrayPath, evaluator) {
        this.language = language;
        this.eventBus = eventBus;
        this.comm = comm;
        this.getArrayPath = getArrayPath;
        this.evaluator = evaluator;
        this.inputMask = null;
        this.disabled = false;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.data.inputMask) {
            this.inputMask = createMask({
                mask: this.data.inputMask,
                placeholder: this.data.maskPlaceholder
            });
        }
        if (this.parentForm) {
            this.control = this.parentForm.get(String(this.data.name));
            this.internalValue = this.control.value;
        }
        else {
            this.internalValue = this.data.value;
            if (typeof this.data.disabled === 'object') {
                this.disabled = this.evaluator.exec(this.data.dataObject, this.data.disabled);
            }
            this.control = new FormControl({
                value: this.internalValue,
                disabled: this.disabled
            });
        }
        if (typeof this.data.channel !== "undefined") {
            this.comm
                .getChannel(this.data.channel, this)
                .pipe(takeUntil$1(this.destroy$))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (!this.parentForm && this.data.valuePath) {
            this.internalValue = this.getArrayPath.get(this.data.dataObject, this.data.valuePath);
        }
        if (typeof this.data.suffixAction !== "undefined") {
            this.suffixAction = this[this.data.suffixAction];
        }
        if (typeof this.data.suffixIcon !== "undefined") {
            this.suffixIcon = this.data.suffixIcon;
        }
        if (typeof this.data.suffixText !== "undefined") {
            this.suffixText = this.language.getLabel(this.data.suffixText);
        }
        if (this.data.inActionBar) {
            this.eventBus
                .on("actionBarControlReset")
                .pipe(takeUntil$1(this.destroy$))
                .subscribe((data) => {
                if (typeof data.actionParams === "undefined" ||
                    typeof data.actionParams.controls === "undefined" ||
                    (typeof data.actionParams !== "undefined" &&
                        typeof data.actionParams.controls !== "undefined" &&
                        data.actionParams.controls.indexOf(this.data.actionId) >= 0)) {
                    this.internalValue = this.data.originalValue;
                    if (typeof this.data.change === "function") {
                        const result = this.data.change({
                            id: this.data.actionId,
                            value: this.internalValue,
                            event: "change",
                        });
                        if (result instanceof Observable) {
                            result.pipe(take(1)).subscribe();
                        }
                    }
                }
            });
        }
        if (typeof this.data.maxLength === "undefined") {
            this.data.maxLength = null;
        }
        if (typeof this.data.disabled === 'boolean') {
            this.disabled = this.data.disabled;
        }
        this.control.valueChanges
            .pipe(takeUntil$1(this.destroy$))
            .subscribe((value) => {
            let newValue;
            if (this.data.type === 'input'
                && this.data.inputType === "number"
                && value !== '') {
                newValue = this.limitValue(+value);
            }
            else {
                newValue = value;
            }
            this.internalValue = newValue;
            if (typeof this.data.valueChanges === "function") {
                if (!this.data.valueChangesParams) {
                    this.data.valueChangesParams = {};
                }
                this.data.valueChangesParams.value = this.internalValue;
                this.data.valueChangesParams.event = "valueChanges";
                if (this.parentForm) {
                    this.data.valueChangesParams.control = this.parentForm.get(this.data.name);
                }
                const result = this.data.valueChanges(this.data.valueChangesParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            }
        });
        this.control.statusChanges
            .pipe(takeUntil$1(this.destroy$), debounceTime$1(750))
            .subscribe(status => {
            this.status(status.toLowerCase());
        });
    }
    limitValue(value) {
        if (typeof this.data.min !== "undefined" && value < this.data.min) {
            value = this.data.min;
        }
        if (typeof this.data.max !== "undefined" && value > this.data.max) {
            value = this.data.max;
        }
        return +value;
    }
    status(type) {
        const status = `${type}Status`;
        if (typeof this.data[status] === "function") {
            if (!this.data[`${status}Params`]) {
                this.data[`${status}Params`] = {};
            }
            this.data[`${status}Params`].event = `${status}`;
            // tslint:disable-next-line:no-string-literal
            this.data[`${status}Params`].target =
                this.inputField["_elementRef"].nativeElement;
            const result = this.data[status](this.data[`${status}Params`]);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    enter() {
        if (typeof this.data.onEnter !== "undefined") {
            setTimeout(() => {
                this.eventBus.fire(new Event("actionBarEnterKey", this.data.onEnter));
            }, 0);
        }
    }
    togglePassword() {
        if (this.data.type === "input") {
            const inputTypes = {
                password: "text",
                text: "password",
            };
            if (typeof inputTypes[this.data.inputType] !== "undefined") {
                this.data.inputType = inputTypes[this.data.inputType];
            }
            if (typeof this.data.suffixIcon !== "undefined" &&
                typeof this.data.suffixIconToggle !== "undefined") {
                switch (this.suffixIcon) {
                    case this.data.suffixIcon:
                        this.suffixIcon = this.data.suffixIconToggle;
                        break;
                    case this.data.suffixIconToggle:
                        this.suffixIcon = this.data.suffixIcon;
                        break;
                }
            }
        }
    }
    change() {
        if (typeof this.data.change === "function") {
            if (!this.data.changeParams) {
                this.data.changeParams = {};
            }
            this.data.changeParams.value = this.internalValue;
            this.data.changeParams.event = "change";
            if (this.data.dataObject) {
                this.data.changeParams.dataObject = this.data.dataObject;
            }
            if (this.data.actionId) {
                this.data.changeParams.id = this.data.actionId;
            }
            if (this.parentForm) {
                this.data.changeParams.control = this.parentForm.get(this.data.name);
            }
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    focused() {
        if (typeof this.data.focused === 'function') {
            const eventParams = {
                event: "focused",
                dataObject: this.data.dataObject
            };
            const result = this.data.focused(eventParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    numberIncr() {
        let newValue;
        if (this.parentForm) {
            const formControl = this.parentForm.get(String(this.data.name));
            formControl.setValue(this.limitValue(+formControl.value + 1));
            newValue = formControl.value;
        }
        else {
            this.internalValue = this.limitValue(this.internalValue + 1);
            newValue = this.internalValue;
            this.control.setValue(newValue);
        }
        this.change();
    }
    numberDecr() {
        let newValue;
        if (this.parentForm) {
            const formControl = this.parentForm.get(String(this.data.name));
            formControl.setValue(this.limitValue(+formControl.value - 1));
            newValue = formControl.value;
        }
        else {
            this.internalValue = this.limitValue(this.internalValue - 1);
            newValue = this.internalValue;
            this.control.setValue(newValue);
        }
        this.change();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    select(target) {
        target.select();
    }
}
InputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: InputComponent, deps: [{ token: LanguageService }, { token: EventBusService }, { token: CommunicationService }, { token: GetArrayPathService }, { token: EvalService }], target: i0.ɵɵFactoryTarget.Component });
InputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: InputComponent, selector: "app-input", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "inputField", first: true, predicate: MatInput, descendants: true }, { propertyName: "autosize", first: true, predicate: ["autosize"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"data.type == 'input'\">\r\n  <!-- hidden input -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"parentForm && data.inputType === 'hidden'\"\r\n    [formGroup]=\"parentForm\"\r\n    [hidden]=\"true\">\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\" />\r\n  </mat-form-field>\r\n  <!-- input in form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly, number: data.inputType === 'number' }\"\r\n    *ngIf=\"parentForm && data.inputType !== 'hidden'\"\r\n    [formGroup]=\"parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <button\r\n      *ngIf=\"\r\n        data.inputType === 'number' &&\r\n        !data.hideNumberActons &&\r\n        !data.readonly &&\r\n        !disabled\r\n      \"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberDecr()\"\r\n      matPrefix>\r\n      <mat-icon>remove</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.inputType !== 'number' && data.prefixText\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [type]=\"data.inputType\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\"\r\n      [attr.maxlength]=\"data.maxLength\" />\r\n\r\n    <span *ngIf=\"data.inputType == 'number' && suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n\r\n    <button\r\n      *ngIf=\"\r\n        data.inputType === 'number' &&\r\n        !data.hideNumberActons &&\r\n        !data.readonly &&\r\n        !disabled\r\n      \"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberIncr()\"\r\n      matSuffix>\r\n      <mat-icon>add</mat-icon>\r\n    </button>\r\n\r\n    <button\r\n      *ngIf=\"data.inputType !== 'number' && data.suffixAction\"\r\n      type=\"button\"\r\n      matSuffix\r\n      mat-icon-button\r\n      (click)=\"suffixAction()\">\r\n      <mat-icon>{{ suffixIcon }}</mat-icon>\r\n    </button>\r\n    <mat-icon\r\n      *ngIf=\"data.inputType !== 'number' && !data.suffixAction && suffixIcon\"\r\n      matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.inputType !== 'number' && suffixText\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n  </mat-form-field>\r\n  <!-- input outside form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly, number: data.inputType === 'number' }\"\r\n    *ngIf=\"!parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <button\r\n      *ngIf=\"data.inputType === 'number' && !data.readonly && !disabled\"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberDecr()\"\r\n      matPrefix>\r\n      <mat-icon>remove</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" class=\"prefix-text\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      (click)=\"data.inputType === 'number' && select($event.target)\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [type]=\"data.inputType\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\"\r\n      [formControl]=\"control\"\r\n      (keyup.enter)=\"enter()\"\r\n      [attr.maxlength]=\"data.maxLength\" />\r\n    <button\r\n      *ngIf=\"data.inputType === 'number' && !data.readonly && !disabled\"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberIncr()\"\r\n      matSuffix>\r\n      <mat-icon>add</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n    <span class=\"characters-left\" *ngIf=\"data.maxLength\">\r\n      {{ internalValue?.length ? data.maxLength - internalValue.length : data.maxLength }}\r\n    </span>\r\n  </mat-form-field>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.type == 'textarea'\">\r\n  <!-- textarea in form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"parentForm\"\r\n    [formGroup]=\"parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <mat-icon *ngIf=\"data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <textarea\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [attr.maxlength]=\"data.maxLength\"\r\n      cdkTextareaAutosize\r\n      [cdkAutosizeMinRows]=\"data.minRows || 4\"\r\n      cdkAutosizeMaxRows=\"10\">\r\n    </textarea>\r\n    <button\r\n      *ngIf=\"data.suffixAction\"\r\n      type=\"button\"\r\n      matSuffix\r\n      mat-icon-button\r\n      (click)=\"suffixAction()\">\r\n      <mat-icon>{{ suffixIcon }}</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"!data.suffixAction && suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n  </mat-form-field>\r\n  <!-- textarea outside form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"!parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <mat-icon *ngIf=\"data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" class=\"prefix-text\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <textarea\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [readonly]=\"data.readonly\"\r\n      [attr.maxlength]=\"data.maxLength\"\r\n      [formControl]=\"control\"\r\n      cdkTextareaAutosize\r\n      [cdkAutosizeMinRows]=\"data.minRows || 4\"\r\n      cdkAutosizeMaxRows=\"10\">\r\n    </textarea>\r\n    <mat-icon *ngIf=\"suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n    <span class=\"characters-left\" *ngIf=\"data.maxLength\">\r\n      {{ internalValue?.length ? data.maxLength - internalValue.length : data.maxLength }}\r\n    </span>\r\n  </mat-form-field>\r\n</ng-container>\r\n", styles: [":host{width:100%}:host mat-form-field{position:relative;width:100%}:host mat-form-field input{width:100%}:host mat-form-field input::-webkit-outer-spin-button,:host mat-form-field input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host mat-form-field input[type=number]{text-align:center;-moz-appearance:textfield}:host mat-form-field .characters-left{position:absolute;bottom:-5px;right:34px;padding:0 6px;background-color:var(--primary-color);color:var(--text-primary-color)}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i11$1.CdkTextareaAutosize, selector: "textarea[cdkTextareaAutosize]", inputs: ["cdkAutosizeMinRows", "cdkAutosizeMaxRows", "cdkTextareaAutosize", "placeholder"], exportAs: ["cdkTextareaAutosize"] }, { kind: "directive", type: i12$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i13.InputMaskDirective, selector: "[inputMask]", inputs: ["inputMask"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-input", template: "<ng-container *ngIf=\"data.type == 'input'\">\r\n  <!-- hidden input -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"parentForm && data.inputType === 'hidden'\"\r\n    [formGroup]=\"parentForm\"\r\n    [hidden]=\"true\">\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\" />\r\n  </mat-form-field>\r\n  <!-- input in form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly, number: data.inputType === 'number' }\"\r\n    *ngIf=\"parentForm && data.inputType !== 'hidden'\"\r\n    [formGroup]=\"parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <button\r\n      *ngIf=\"\r\n        data.inputType === 'number' &&\r\n        !data.hideNumberActons &&\r\n        !data.readonly &&\r\n        !disabled\r\n      \"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberDecr()\"\r\n      matPrefix>\r\n      <mat-icon>remove</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.inputType !== 'number' && data.prefixText\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [type]=\"data.inputType\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\"\r\n      [attr.maxlength]=\"data.maxLength\" />\r\n\r\n    <span *ngIf=\"data.inputType == 'number' && suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n\r\n    <button\r\n      *ngIf=\"\r\n        data.inputType === 'number' &&\r\n        !data.hideNumberActons &&\r\n        !data.readonly &&\r\n        !disabled\r\n      \"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberIncr()\"\r\n      matSuffix>\r\n      <mat-icon>add</mat-icon>\r\n    </button>\r\n\r\n    <button\r\n      *ngIf=\"data.inputType !== 'number' && data.suffixAction\"\r\n      type=\"button\"\r\n      matSuffix\r\n      mat-icon-button\r\n      (click)=\"suffixAction()\">\r\n      <mat-icon>{{ suffixIcon }}</mat-icon>\r\n    </button>\r\n    <mat-icon\r\n      *ngIf=\"data.inputType !== 'number' && !data.suffixAction && suffixIcon\"\r\n      matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.inputType !== 'number' && suffixText\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n  </mat-form-field>\r\n  <!-- input outside form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly, number: data.inputType === 'number' }\"\r\n    *ngIf=\"!parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <button\r\n      *ngIf=\"data.inputType === 'number' && !data.readonly && !disabled\"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberDecr()\"\r\n      matPrefix>\r\n      <mat-icon>remove</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" class=\"prefix-text\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n\r\n    <input\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      (click)=\"data.inputType === 'number' && select($event.target)\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [type]=\"data.inputType\"\r\n      [readonly]=\"data.readonly\"\r\n      [step]=\"data.step\"\r\n      [formControl]=\"control\"\r\n      (keyup.enter)=\"enter()\"\r\n      [attr.maxlength]=\"data.maxLength\" />\r\n    <button\r\n      *ngIf=\"data.inputType === 'number' && !data.readonly && !disabled\"\r\n      type=\"button\"\r\n      mat-icon-button\r\n      (click)=\"numberIncr()\"\r\n      matSuffix>\r\n      <mat-icon>add</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"data.inputType !== 'number' && suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n    <span class=\"characters-left\" *ngIf=\"data.maxLength\">\r\n      {{ internalValue?.length ? data.maxLength - internalValue.length : data.maxLength }}\r\n    </span>\r\n  </mat-form-field>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.type == 'textarea'\">\r\n  <!-- textarea in form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"parentForm\"\r\n    [formGroup]=\"parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <mat-icon *ngIf=\"data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <textarea\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [value]=\"internalValue\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [formControl]=\"control\"\r\n      [readonly]=\"data.readonly\"\r\n      [attr.maxlength]=\"data.maxLength\"\r\n      cdkTextareaAutosize\r\n      [cdkAutosizeMinRows]=\"data.minRows || 4\"\r\n      cdkAutosizeMaxRows=\"10\">\r\n    </textarea>\r\n    <button\r\n      *ngIf=\"data.suffixAction\"\r\n      type=\"button\"\r\n      matSuffix\r\n      mat-icon-button\r\n      (click)=\"suffixAction()\">\r\n      <mat-icon>{{ suffixIcon }}</mat-icon>\r\n    </button>\r\n    <mat-icon *ngIf=\"!data.suffixAction && suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n  </mat-form-field>\r\n  <!-- textarea outside form -->\r\n  <mat-form-field\r\n    appearance=\"fill\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{ readonly: data.readonly }\"\r\n    *ngIf=\"!parentForm\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n    <mat-icon *ngIf=\"data.prefixIcon\" matPrefix>\r\n      {{ data.prefixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"data.prefixText\" class=\"prefix-text\" matPrefix>\r\n      {{ data.prefixText }}\r\n    </span>\r\n    <textarea\r\n      matInput\r\n      (change)=\"change()\"\r\n      (focus)=\"focused()\"\r\n      [inputMask]=\"inputMask\"\r\n      [id]=\"data.id\"\r\n      [placeholder]=\"language.getLabel(data.placeholder)\"\r\n      [readonly]=\"data.readonly\"\r\n      [attr.maxlength]=\"data.maxLength\"\r\n      [formControl]=\"control\"\r\n      cdkTextareaAutosize\r\n      [cdkAutosizeMinRows]=\"data.minRows || 4\"\r\n      cdkAutosizeMaxRows=\"10\">\r\n    </textarea>\r\n    <mat-icon *ngIf=\"suffixIcon\" matSuffix>\r\n      {{ suffixIcon }}\r\n    </mat-icon>\r\n    <span *ngIf=\"suffixText\" class=\"suffix-text\" matSuffix>\r\n      {{ suffixText }}\r\n    </span>\r\n    <span class=\"characters-left\" *ngIf=\"data.maxLength\">\r\n      {{ internalValue?.length ? data.maxLength - internalValue.length : data.maxLength }}\r\n    </span>\r\n  </mat-form-field>\r\n</ng-container>\r\n", styles: [":host{width:100%}:host mat-form-field{position:relative;width:100%}:host mat-form-field input{width:100%}:host mat-form-field input::-webkit-outer-spin-button,:host mat-form-field input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host mat-form-field input[type=number]{text-align:center;-moz-appearance:textfield}:host mat-form-field .characters-left{position:absolute;bottom:-5px;right:34px;padding:0 6px;background-color:var(--primary-color);color:var(--text-primary-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: EventBusService }, { type: CommunicationService }, { type: GetArrayPathService }, { type: EvalService }]; }, propDecorators: { inputField: [{
                type: ViewChild,
                args: [MatInput, { static: false }]
            }], autosize: [{
                type: ViewChild,
                args: ["autosize"]
            }], data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class YearHeader {
    constructor(calendar, dateAdapter, cdr) {
        this.calendar = calendar;
        this.dateAdapter = dateAdapter;
        this.destroyed = new Subject();
        calendar.stateChanges.pipe(takeUntil$1(this.destroyed))
            .subscribe(() => cdr.markForCheck());
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
    previousClicked() {
        this.calendar.activeDate = this.dateAdapter
            .addCalendarYears(this.calendar.activeDate, -24);
    }
    nextClicked() {
        this.calendar.activeDate = this.dateAdapter
            .addCalendarYears(this.calendar.activeDate, 24);
    }
}
YearHeader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: YearHeader, deps: [{ token: i1$4.MatCalendar }, { token: i2.DateAdapter }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
YearHeader.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: YearHeader, selector: "year-header", ngImport: i0, template: `
    <div class="mat-calendar-header">
      <div class="mat-calendar-controls">
        <button
          mat-icon-button
          type="button"
          class="mat-focus-indicator mat-calendar-previous-button mat-icon-button mat-button-base"
          aria-label="Previous 24 years"
          (click)="previousClicked()"
        >
          <span class="mat-button-wrapper"></span>
          <span class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
          <span class="mat-button-focus-overlay"></span>
        </button>
        <div class="mat-calendar-spacer"></div>
        <button
          mat-icon-button
          type="button"
          class="mat-focus-indicator mat-calendar-next-button mat-icon-button mat-button-base"
          aria-label="Next 24 years"
          (click)="nextClicked()"
        >
          <span class="mat-button-wrapper"></span
          ><span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span
          ><span class="mat-button-focus-overlay"></span>
        </button>
      </div>
    </div>
  `, isInline: true, styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: YearHeader, decorators: [{
            type: Component,
            args: [{ selector: "year-header", template: `
    <div class="mat-calendar-header">
      <div class="mat-calendar-controls">
        <button
          mat-icon-button
          type="button"
          class="mat-focus-indicator mat-calendar-previous-button mat-icon-button mat-button-base"
          aria-label="Previous 24 years"
          (click)="previousClicked()"
        >
          <span class="mat-button-wrapper"></span>
          <span class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
          <span class="mat-button-focus-overlay"></span>
        </button>
        <div class="mat-calendar-spacer"></div>
        <button
          mat-icon-button
          type="button"
          class="mat-focus-indicator mat-calendar-next-button mat-icon-button mat-button-base"
          aria-label="Next 24 years"
          (click)="nextClicked()"
        >
          <span class="mat-button-wrapper"></span
          ><span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span
          ><span class="mat-button-focus-overlay"></span>
        </button>
      </div>
    </div>
  ` }]
        }], ctorParameters: function () { return [{ type: i1$4.MatCalendar }, { type: i2.DateAdapter }, { type: i0.ChangeDetectorRef }]; } });
class DatepickerComponent {
    constructor(language, dateAdapter, relDate, helper, getArrayPath, evaluator, _locale) {
        this.language = language;
        this.dateAdapter = dateAdapter;
        this.relDate = relDate;
        this.helper = helper;
        this.getArrayPath = getArrayPath;
        this.evaluator = evaluator;
        this._locale = _locale;
        this.destroyed = new Subject();
        this.internalControl = new FormControl();
        this.dateFormat = 'yyyy-MM-dd';
        this.min = null;
        this.max = null;
        this._locale = language.getFullLocale();
        this.dateAdapter.setLocale(this._locale);
    }
    ngOnInit() {
        if (this.data.pick === 'year') {
            this.header = YearHeader;
        }
        else {
            this.header = MatCalendarHeader;
        }
        if (this.data.inputMask) {
            this.dateInputMask = createMask({
                alias: 'datetime',
                inputFormat: this.data.inputMask,
                parser: (value) => {
                    const date = this.helper.parseDate(value, this.data.inputMask);
                    return formatDate(date, this.dateFormat, this._locale);
                }
            });
        }
        else {
            this.dateInputMask = null;
            if (typeof this.data.min !== 'undefined') {
                this.min = new Date(this.data.min);
                if (this.min.toString() === 'Invalid Date') {
                    this.min = this.relDate.parse(this.data.min);
                }
            }
            if (typeof this.data.max !== 'undefined') {
                this.max = new Date(this.data.max);
                if (this.max.toString() === 'Invalid Date') {
                    this.max = this.relDate.parse(this.data.max);
                }
            }
        }
        switch (this.data.pick) {
            case 'year':
                this.data.startView = 'multi-year';
                break;
            default:
                this.data.startView = 'month';
                break;
        }
        if (this.parentForm) {
            this.formControl = this.parentForm.get(String(this.data.name));
            this.internalControl.setValue(this.formControl.value);
            this.formControl.valueChanges
                .pipe(takeUntil$1(this.destroyed)).subscribe(val => {
                if (val instanceof Date && val) {
                    val = new Date(val);
                }
                this.internalControl.setValue(val);
            });
            setTimeout(() => {
                if (this.data.pick === 'year') {
                    if (this.internalControl.value instanceof Date) {
                        this.input.nativeElement.value = this.internalControl.value.getFullYear();
                    }
                    else if (typeof this.internalControl.value === 'string') {
                        this.input.nativeElement.value = this.internalControl.value;
                    }
                }
            });
        }
        if (typeof this.data.inputDisabled === 'boolean' && this.data.inputDisabled) {
            this.internalControl.disable();
        }
        else if (typeof this.data.inputDisabled === 'object') {
            if (this.evaluator.exec(this.data.dataObject, this.data.inputDisabled)) {
                this.internalControl.disable();
            }
        }
        let value;
        if (!this.parentForm && this.data.valuePath) {
            this.data.value = this.getArrayPath.get(this.data.dataObject, this.data.valuePath);
        }
        if (this.data.value && !this.internalControl.value) {
            if (this.data.value.startsWith('today')) {
                value = new Date();
            }
            else {
                value = new Date(this.data.value);
            }
        }
        if (this.data.pick === 'year') {
            this.internalControl.valueChanges.pipe(takeUntil$1(this.destroyed))
                .subscribe(val => {
                if (typeof val === 'string') {
                    this.input.nativeElement.value = val;
                }
                else if (val instanceof Date && !isNaN(val.getTime())) {
                    this.input.nativeElement.value = val.getFullYear();
                }
            });
        }
        if (!isNaN(value?.getDate())) {
            this.internalControl.setValue(value);
            if (this.parentForm) {
                this.formControl.setValue(value);
            }
        }
    }
    change(event) {
        const format = (this.data.pick === 'year') ? 'yyyy' : 'yyyy-MM-dd';
        let value;
        if (event.target.value && this.dateInputMask) {
            value = this.helper.parseDate(event.target.value, this.data.inputMask);
        }
        else {
            value = new DatePipe(this.language.getFullLocale())
                .transform(event.target.value, format);
        }
        if (this.parentForm && value !== this.formControl.value) {
            this.formControl.setValue(value);
            this.formControl.markAsTouched();
        }
        if (typeof this.data.change === 'function') {
            this.data.changeParams = {
                event: 'change',
                value
            };
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    focused(event) {
        if (typeof this.data.focused === 'function') {
            const eventParams = {
                event: "focused",
                dataObject: this.data.dataObject
            };
            const result = this.data.focused(eventParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    yearSelected(normalizedYear, datepicker) {
        if (this.data.pick === 'year') {
            this.internalControl.setValue(normalizedYear);
            this.change({
                target: {
                    value: normalizedYear
                }
            });
            datepicker.close();
        }
    }
    clearDate() {
        this.formControl.setValue(null);
        this.internalControl.setValue(null);
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
DatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DatepickerComponent, deps: [{ token: LanguageService }, { token: i2.DateAdapter }, { token: RelativeDateService }, { token: HelperService }, { token: GetArrayPathService }, { token: EvalService }, { token: MAT_DATE_LOCALE }], target: i0.ɵɵFactoryTarget.Component });
DatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: DatepickerComponent, selector: "app-datepicker", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<!-- in form -->\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"parentForm && dateInputMask\"\r\n  [formGroup]=\"parentForm\">\r\n  <!-- input mask -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (change)=\"change($event)\"\r\n    (focus)=\"focused($event)\"\r\n    [inputMask]=\"dateInputMask\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-icon matSuffix>today</mat-icon>\r\n</mat-form-field>\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"auto\"\r\n  *ngIf=\"parentForm && !dateInputMask\"\r\n  [formGroup]=\"parentForm\"\r\n  (click)=\"datepicker.open()\"\r\n  [class]=\"data.pick\">\r\n  <!-- datepicker -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [matDatepicker]=\"datepicker\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (dateChange)=\"change($event)\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\"\r\n    [min]=\"min\"\r\n    [max]=\"max\" />\r\n\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n\r\n  <mat-datepicker\r\n    #datepicker\r\n    [color]=\"data.color\"\r\n    [opened]=\"data.opened\"\r\n    [disabled]=\"data.disabled\"\r\n    [startView]=\"data.startView\"\r\n    (yearSelected)=\"yearSelected($event, datepicker)\"\r\n    (opened)=\"focused($event)\"\r\n    [touchUi]=\"data.touchUi\"\r\n    [calendarHeaderComponent]=\"header\">\r\n  </mat-datepicker>\r\n</mat-form-field>\r\n\r\n<!-- not in form -->\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"!parentForm && dateInputMask\">\r\n  <!-- input mask -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (change)=\"change($event)\"\r\n    (focus)=\"focused($event)\"\r\n    [inputMask]=\"dateInputMask\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-icon matSuffix>today</mat-icon>\r\n</mat-form-field>\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"!parentForm && !dateInputMask\"\r\n  (click)=\"datepicker.open()\"\r\n  [class]=\"data.pick\">\r\n  <!-- datepicker -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [matDatepicker]=\"datepicker\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (dateChange)=\"change($event)\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\"\r\n    [min]=\"min\"\r\n    [max]=\"max\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n\r\n  <mat-datepicker\r\n    #datepicker\r\n    [color]=\"data.color\"\r\n    [opened]=\"data.opened\"\r\n    [disabled]=\"data.disabled\"\r\n    [startView]=\"data.startView\"\r\n    (yearSelected)=\"yearSelected($event, datepicker)\"\r\n    (opened)=\"focused($event)\"\r\n    [touchUi]=\"data.touchUi\"\r\n    [calendarHeaderComponent]=\"header\">\r\n  </mat-datepicker>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}mat-form-field.year.mat-form-field-disabled ::ng-deep .mat-form-field-label{color:#0009}mat-form-field.year.mat-form-field-disabled ::ng-deep .mat-form-field-underline:before{background-color:#0000006b}mat-form-field.year.mat-form-field-disabled .mat-input-element:disabled{color:#000000de}mat-form-field .mat-input-element{width:80%}mat-form-field .clear-icon{position:relative;float:right;top:-8px;cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix]" }, { kind: "component", type: i1$4.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i1$4.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i1$4.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "directive", type: i12$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i13.InputMaskDirective, selector: "[inputMask]", inputs: ["inputMask"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-datepicker', template: "<!-- in form -->\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"parentForm && dateInputMask\"\r\n  [formGroup]=\"parentForm\">\r\n  <!-- input mask -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (change)=\"change($event)\"\r\n    (focus)=\"focused($event)\"\r\n    [inputMask]=\"dateInputMask\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-icon matSuffix>today</mat-icon>\r\n</mat-form-field>\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"auto\"\r\n  *ngIf=\"parentForm && !dateInputMask\"\r\n  [formGroup]=\"parentForm\"\r\n  (click)=\"datepicker.open()\"\r\n  [class]=\"data.pick\">\r\n  <!-- datepicker -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [matDatepicker]=\"datepicker\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (dateChange)=\"change($event)\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\"\r\n    [min]=\"min\"\r\n    [max]=\"max\" />\r\n\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n\r\n  <mat-datepicker\r\n    #datepicker\r\n    [color]=\"data.color\"\r\n    [opened]=\"data.opened\"\r\n    [disabled]=\"data.disabled\"\r\n    [startView]=\"data.startView\"\r\n    (yearSelected)=\"yearSelected($event, datepicker)\"\r\n    (opened)=\"focused($event)\"\r\n    [touchUi]=\"data.touchUi\"\r\n    [calendarHeaderComponent]=\"header\">\r\n  </mat-datepicker>\r\n</mat-form-field>\r\n\r\n<!-- not in form -->\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"!parentForm && dateInputMask\">\r\n  <!-- input mask -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (change)=\"change($event)\"\r\n    (focus)=\"focused($event)\"\r\n    [inputMask]=\"dateInputMask\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-icon matSuffix>today</mat-icon>\r\n</mat-form-field>\r\n<mat-form-field\r\n  appearance=\"fill\"\r\n  floatLabel=\"always\"\r\n  *ngIf=\"!parentForm && !dateInputMask\"\r\n  (click)=\"datepicker.open()\"\r\n  [class]=\"data.pick\">\r\n  <!-- datepicker -->\r\n  <mat-label>{{ language.getLabel(data.label ?? data.placeholder) }}</mat-label>\r\n  <input\r\n    matInput\r\n    #input\r\n    [matDatepicker]=\"datepicker\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    (dateChange)=\"change($event)\"\r\n    [readonly]=\"data.inputReadonly\"\r\n    [formControl]=\"internalControl\"\r\n    [min]=\"min\"\r\n    [max]=\"max\" />\r\n  <mat-icon\r\n    class=\"clear-icon\"\r\n    *ngIf=\"internalControl.value && !data.hideReset\"\r\n    (click)=\"clearDate()\"\r\n    >clear</mat-icon\r\n  >\r\n  <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n\r\n  <mat-datepicker\r\n    #datepicker\r\n    [color]=\"data.color\"\r\n    [opened]=\"data.opened\"\r\n    [disabled]=\"data.disabled\"\r\n    [startView]=\"data.startView\"\r\n    (yearSelected)=\"yearSelected($event, datepicker)\"\r\n    (opened)=\"focused($event)\"\r\n    [touchUi]=\"data.touchUi\"\r\n    [calendarHeaderComponent]=\"header\">\r\n  </mat-datepicker>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}mat-form-field.year.mat-form-field-disabled ::ng-deep .mat-form-field-label{color:#0009}mat-form-field.year.mat-form-field-disabled ::ng-deep .mat-form-field-underline:before{background-color:#0000006b}mat-form-field.year.mat-form-field-disabled .mat-input-element:disabled{color:#000000de}mat-form-field .mat-input-element{width:80%}mat-form-field .clear-icon{position:relative;float:right;top:-8px;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2.DateAdapter }, { type: RelativeDateService }, { type: HelperService }, { type: GetArrayPathService }, { type: EvalService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DATE_LOCALE]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class RadiobuttonComponent {
    constructor(language, getArrayPath, comm, api) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.comm = comm;
        this.api = api;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.load();
    }
    removeSelected() {
        this.selected = null;
    }
    load(selected = null) {
        if (typeof this.data.dataSource !== 'undefined') {
            this.api.callServiceMethod(this.data.dataSource)
                .pipe(take$1(1))
                .subscribe((response) => {
                this.dataObject = response.result.data;
                this.data.options = this.getArrayPath.get(this.dataObject, this.data.optionsPath);
                if (selected !== null) {
                    this.selected = selected;
                }
                else if (typeof this.data.group.selected !== 'undefined') {
                    if (this.data.group.selected === 'first') {
                        this.selected = this.getValue(this.data.options[0]);
                    }
                    else {
                        this.selected = this.data.group.selected;
                    }
                }
            });
        }
        else if (typeof this.data.dataObject !== 'undefined') {
            // if options come from dataObject of the parent component
            this.data.options = this.getArrayPath.get(this.data.dataObject, this.data.optionsPath);
            // if selected is an array keys that point to the 
            // property that has a true value select the option
            if (Array.isArray(this.data.group.selected)) {
                const selectedOption = this.data.options.find(option => {
                    if (this.getArrayPath.get(option, this.data.group.selected)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                // selected is the value of the option that has the truthful property
                this.selected = this.getArrayPath.get(selectedOption, this.data.valuePath);
            }
            else if (typeof this.data.group.selected === 'number' ||
                typeof this.data.group.selected === 'string') {
                // if selected is hardcoded string or number, that is 
                // the value of the checked radio button
                this.selected = this.data.group.selected;
            }
        }
        else {
            if (this.data.group?.selected) {
                this.selected = this.data.group.selected;
            }
        }
    }
    change(event) {
        if (typeof this.data.change === 'function') {
            this.data.changeParams = {
                value: event.value,
                event: 'change'
            };
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    getValue(option) {
        if (typeof option.option !== 'undefined') {
            return option.option;
        }
        if (typeof this.data.valuePath !== 'undefined') {
            return this.getArrayPath.get(option, this.data.valuePath);
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
RadiobuttonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RadiobuttonComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }, { token: CommunicationService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Component });
RadiobuttonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: RadiobuttonComponent, selector: "app-radiobutton", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<div *ngIf=\"parentForm\" [formGroup]=\"parentForm\" class=\"d-flex {{ data.class }}\">\r\n  <mat-label *ngIf=\"data.group.label\" class=\"margin-bottom-10-block\">\r\n    {{ language.getLabel(data.group.label) }}\r\n  </mat-label>\r\n  <mat-radio-group\r\n    [class]=\"data.group.class\"\r\n    [color]=\"data.group.color\"\r\n    [labelPosition]=\"data.group.labelPosition\"\r\n    [formControlName]=\"data.group.name\"\r\n  >\r\n    <mat-radio-button\r\n      *ngFor=\"let option of data.options\"\r\n      [value]=\"getValue(option)\"\r\n      [disabled]=\"option.disabled\"\r\n      [color]=\"option.color\"\r\n      [class]=\"option.class\"\r\n      (change)=\"change($event)\"\r\n    >\r\n      <ng-container *ngIf=\"option.name\">\r\n        {{ language.getLabel(option.name) }}\r\n        <div *ngIf=\"option.subtitle\" [innerHTML]=\"language.getLabel(option.subtitle)\"></div>\r\n      </ng-container>\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"option\"\r\n        [parentForm]=\"parentForm\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n<div *ngIf=\"!parentForm\" class=\"d-flex {{ data.class }}\">\r\n  <mat-label *ngIf=\"data.group.label\" class=\"margin-bottom-10-block\">\r\n    {{ language.getLabel(data.group.label) }}\r\n  </mat-label>\r\n  <mat-radio-group\r\n    [class]=\"data.group.class\"\r\n    [color]=\"data.group.color\"\r\n    [labelPosition]=\"data.group.labelPosition\"\r\n    [required]=\"data.group.required\"\r\n    [(ngModel)]=\"selected\"\r\n  >\r\n    <mat-radio-button\r\n      *ngFor=\"let option of data.options\"\r\n      [checked]=\"option.checked\"\r\n      [value]=\"getValue(option)\"\r\n      [disabled]=\"option.disabled\"\r\n      [color]=\"option.color\"\r\n      [class]=\"option.class\"\r\n      (change)=\"change($event)\"\r\n    >\r\n      <ng-container *ngIf=\"!data.components\">\r\n        {{ language.getLabel(option.name) }}\r\n      </ng-container>\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"option\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n", styles: [".margin-bottom-10-block{margin-right:40px;display:flex;align-items:center;margin-bottom:10px}:host ::ng-deep .mat-radio-container{margin-left:10px}.mat-radio-group.w-100 ::ng-deep .mat-radio-label-content{width:100%}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i8.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i8.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RadiobuttonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-radiobutton', template: "<div *ngIf=\"parentForm\" [formGroup]=\"parentForm\" class=\"d-flex {{ data.class }}\">\r\n  <mat-label *ngIf=\"data.group.label\" class=\"margin-bottom-10-block\">\r\n    {{ language.getLabel(data.group.label) }}\r\n  </mat-label>\r\n  <mat-radio-group\r\n    [class]=\"data.group.class\"\r\n    [color]=\"data.group.color\"\r\n    [labelPosition]=\"data.group.labelPosition\"\r\n    [formControlName]=\"data.group.name\"\r\n  >\r\n    <mat-radio-button\r\n      *ngFor=\"let option of data.options\"\r\n      [value]=\"getValue(option)\"\r\n      [disabled]=\"option.disabled\"\r\n      [color]=\"option.color\"\r\n      [class]=\"option.class\"\r\n      (change)=\"change($event)\"\r\n    >\r\n      <ng-container *ngIf=\"option.name\">\r\n        {{ language.getLabel(option.name) }}\r\n        <div *ngIf=\"option.subtitle\" [innerHTML]=\"language.getLabel(option.subtitle)\"></div>\r\n      </ng-container>\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"option\"\r\n        [parentForm]=\"parentForm\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n<div *ngIf=\"!parentForm\" class=\"d-flex {{ data.class }}\">\r\n  <mat-label *ngIf=\"data.group.label\" class=\"margin-bottom-10-block\">\r\n    {{ language.getLabel(data.group.label) }}\r\n  </mat-label>\r\n  <mat-radio-group\r\n    [class]=\"data.group.class\"\r\n    [color]=\"data.group.color\"\r\n    [labelPosition]=\"data.group.labelPosition\"\r\n    [required]=\"data.group.required\"\r\n    [(ngModel)]=\"selected\"\r\n  >\r\n    <mat-radio-button\r\n      *ngFor=\"let option of data.options\"\r\n      [checked]=\"option.checked\"\r\n      [value]=\"getValue(option)\"\r\n      [disabled]=\"option.disabled\"\r\n      [color]=\"option.color\"\r\n      [class]=\"option.class\"\r\n      (change)=\"change($event)\"\r\n    >\r\n      <ng-container *ngIf=\"!data.components\">\r\n        {{ language.getLabel(option.name) }}\r\n      </ng-container>\r\n      <app-slot\r\n        *ngIf=\"data.components\"\r\n        [items]=\"data.components\"\r\n        [componentValue]=\"option\"\r\n        style=\"display: block; width: 100%; height: 100%\"\r\n      ></app-slot>\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n", styles: [".margin-bottom-10-block{margin-right:40px;display:flex;align-items:center;margin-bottom:10px}:host ::ng-deep .mat-radio-container{margin-left:10px}.mat-radio-group.w-100 ::ng-deep .mat-radio-label-content{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }, { type: CommunicationService }, { type: ApiService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class SliderComponent {
    constructor(language, platformId) {
        this.language = language;
        this.platformId = platformId;
        this.isBrowser = true;
        if (!isPlatformBrowser(this.platformId)) {
            this.isBrowser = false;
        }
    }
    ngOnInit() { }
    change(slider) {
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {};
            }
            this.data.changeParams.value = slider.value;
            this.data.changeParams.event = 'change';
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
}
SliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SliderComponent, deps: [{ token: LanguageService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
SliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SliderComponent, selector: "app-slider", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<ng-container *ngIf=\"isBrowser\">\r\n  <ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n    <mat-slider\r\n      [disabled]=\"data.disabled\"\r\n      [invert]=\"data.invert\"\r\n      [vertical]=\"data.vertical\"\r\n      [max]=\"data.max ? data.max : null\"\r\n      [min]=\"data.min ? data.min : null\"\r\n      [value]=\"data.value\"\r\n      [formControlName]=\"data.name\"\r\n      (change)=\"change($event)\"\r\n    >\r\n    </mat-slider>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!parentForm\">\r\n    <mat-slider\r\n      [disabled]=\"data.disabled\"\r\n      [invert]=\"data.invert\"\r\n      [vertical]=\"data.vertical\"\r\n      [max]=\"data.max ? data.max : null\"\r\n      [min]=\"data.min ? data.min : null\"\r\n      [value]=\"data.value\"\r\n      (change)=\"change($event)\"\r\n    >\r\n    </mat-slider>\r\n  </ng-container>\r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4$1.MatSlider, selector: "mat-slider", inputs: ["disabled", "color", "tabIndex", "invert", "max", "min", "step", "thumbLabel", "tickInterval", "value", "displayWith", "valueText", "vertical"], outputs: ["change", "input", "valueChange"], exportAs: ["matSlider"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-slider', template: "<ng-container *ngIf=\"isBrowser\">\r\n  <ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n    <mat-slider\r\n      [disabled]=\"data.disabled\"\r\n      [invert]=\"data.invert\"\r\n      [vertical]=\"data.vertical\"\r\n      [max]=\"data.max ? data.max : null\"\r\n      [min]=\"data.min ? data.min : null\"\r\n      [value]=\"data.value\"\r\n      [formControlName]=\"data.name\"\r\n      (change)=\"change($event)\"\r\n    >\r\n    </mat-slider>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!parentForm\">\r\n    <mat-slider\r\n      [disabled]=\"data.disabled\"\r\n      [invert]=\"data.invert\"\r\n      [vertical]=\"data.vertical\"\r\n      [max]=\"data.max ? data.max : null\"\r\n      [min]=\"data.min ? data.min : null\"\r\n      [value]=\"data.value\"\r\n      (change)=\"change($event)\"\r\n    >\r\n    </mat-slider>\r\n  </ng-container>\r\n</ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class ColorboxComponent {
    constructor() { }
    ngOnInit() {
        this.cursor = 'initial';
        if (this.data.value > 1) {
            this.data.color = this.data.colors[2];
            this.cursor = 'pointer';
        }
        else if (this.data.value > 0) {
            this.data.color = this.data.colors[1];
            this.cursor = 'pointer';
        }
        else if (this.data.value < 0) {
            this.data.color = this.data.colors[0];
            this.cursor = 'pointer';
        }
        else {
            this.data.color = '#fff';
        }
    }
    click(e) {
        if (typeof this.data.click === 'function') {
            if (!this.data.clickParams) {
                this.data.clickParams = {};
            }
            this.data.clickParams.event = 'click';
            const result = this.data.click(this.data.clickParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
}
ColorboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ColorboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ColorboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ColorboxComponent, selector: "app-colorbox", inputs: { data: "data" }, ngImport: i0, template: "<div\r\n  class=\"colorbox\"\r\n  [ngStyle]=\"{ 'background-color': data.color, 'cursor': cursor }\"\r\n  (click)=\"click($event)\"\r\n></div>\r\n", styles: [".colorbox{width:47px;height:47px;text-align:center;line-height:47xp;background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ColorboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-colorbox', template: "<div\r\n  class=\"colorbox\"\r\n  [ngStyle]=\"{ 'background-color': data.color, 'cursor': cursor }\"\r\n  (click)=\"click($event)\"\r\n></div>\r\n", styles: [".colorbox{width:47px;height:47px;text-align:center;line-height:47xp;background-color:#fff}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class DaterangeComponent {
    constructor(dateAdapter, language, getArrayPath, eventBus, helper, relDate, _locale) {
        this.dateAdapter = dateAdapter;
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.eventBus = eventBus;
        this.helper = helper;
        this.relDate = relDate;
        this._locale = _locale;
        this.dateFormat = 'yyyy-MM-dd';
        this.destroyed$ = new Subject();
        this._locale = language.getFullLocale();
        this.dateAdapter.setLocale(this._locale);
    }
    ngOnInit() {
        if (this.data.inputMask) {
            this.dateInputMask = createMask({
                alias: 'datetime',
                inputFormat: this.data.inputMask,
                placeholder: this.data.placeholder,
                formatter: (value) => {
                    let result;
                    try {
                        result = this.helper.parseDate(value, this.dateFormat);
                    }
                    catch {
                        result = this.relDate.parse(value);
                    }
                    return result;
                },
                parser: (value) => {
                    const date = this.helper.parseDate(value, this.data.inputMask);
                    return formatDate(date, this.dateFormat, this._locale);
                },
            });
        }
        if (this.parentForm) {
            this.inputFromControl = this.parentForm.get(String(this.data.name + '_from'));
            this.inputToControl = this.parentForm.get(String(this.data.name + '_to'));
        }
        else {
            this.inputFromControl = new FormControl({ disabled: this.data.from.inputDisabled });
            this.inputToControl = new FormControl({ disabled: this.data.to.inputDisabled });
        }
        if (this.data.inActionBar) {
            this.eventBus.on('actionBarControlReset')
                .pipe(takeUntil$1(this.destroyed$))
                .subscribe((data) => {
                if (typeof data.actionParams === 'undefined'
                    || typeof data.actionParams.controls === 'undefined'
                    || (typeof data.actionParams !== 'undefined'
                        && typeof data.actionParams.controls !== 'undefined'
                        && data.actionParams.controls.indexOf(this.data.actionId) >= 0)) {
                    this.from = this.data.from.originalValue;
                    this.to = this.data.to.originalValue;
                    this.inputFromControl.setValue(this.from);
                    this.inputToControl.setValue(this.to);
                    this.prepValues();
                    if (typeof this.data.change === 'function') {
                        this.data.change({
                            id: this.data.actionId,
                            value: (this.from && this.to) ? this.from + ',' + this.to : undefined
                        });
                    }
                }
            });
        }
        this.prepValues();
        if (typeof this.data.from.originalValue === 'undefined') {
            this.data.from.originalValue = this.from;
        }
        if (typeof this.data.to.originalValue === 'undefined') {
            this.data.to.originalValue = this.to;
        }
    }
    prepValues() {
        if (typeof this.data.value !== 'undefined') {
            if (this.data.from.value instanceof Array) {
                this.data.from.value = this.getArrayPath.transform(this.data.value, this.data.from.value);
            }
            if (this.data.to.value instanceof Array) {
                this.data.to.value = this.getArrayPath.transform(this.data.value, this.data.to.value);
            }
        }
        let from;
        let when;
        if (typeof this.data.from.value === 'string') {
            if (this.data.from.value.startsWith('now')) {
                when = 'now';
            }
            if (this.data.from.value.startsWith('today')) {
                when = 'today';
            }
            if (when) {
                let interval = parseInt(this.data.from.value.replace(when, ''));
                from = new Date();
                interval = +interval;
                if (interval) {
                    from.setHours(from.getHours() + interval);
                }
            }
            else {
                from = new Date(this.data.from.value);
            }
            let to;
            if (typeof this.data.to.value === 'number') {
                to = new Date(from.getTime());
                to.setHours(to.getHours() + this.data.to.value);
            }
            else {
                to = new Date(this.data.to.value);
            }
            this.from = formatDate(from, this.dateFormat, this.language.getFullLocale());
            this.to = formatDate(to, this.dateFormat, this.language.getFullLocale());
        }
    }
    change(event, key) {
        if (!event.target.value) {
            return;
        }
        let date;
        if (typeof event.target !== 'undefined') {
            // shortDate = formatDate(event.target.value, this.dateFormat, this.language.getFullLocale());
            date = event.target.value;
        }
        else {
            // shortDate = formatDate(event, this.dateFormat, this.language.getFullLocale());
            date = event;
        }
        const shortDate = formatDate(date, this.dateFormat, this._locale);
        if (key === 'from') {
            this.inputFromControl.setValue(shortDate);
            this.from = shortDate;
        }
        if (key === 'to') {
            this.inputToControl.setValue(shortDate);
            this.to = shortDate;
        }
        if (typeof this.data.change === 'function') {
            if (typeof this.from !== 'undefined'
                && typeof this.to !== 'undefined'
                && this.from !== null
                && this.to !== null
                && this.from !== ''
                && this.to !== '') {
                if (!this.data.changeParams) {
                    this.data.changeParams = {
                        value: this.from + ',' + this.to
                    };
                }
                else {
                    this.data.changeParams.value = this.from + ',' + this.to;
                }
                const result = this.data.change(this.data.changeParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            }
        }
    }
    // Changes the date range with the difference between start and end date
    changePeriod(type) {
        const from = new Date(this.from).getTime();
        const to = new Date(this.to).getTime();
        const diff = (to - from) || 24 * 60 * 60 * 1000;
        let fromDate;
        let toDate;
        switch (type) {
            case 'next':
                fromDate = new Date(from + diff);
                toDate = new Date(to + diff);
                break;
            case 'prev':
                fromDate = new Date(from - diff);
                toDate = new Date(to - diff);
                break;
        }
        this.change(fromDate, 'from');
        this.change(toDate, 'to');
    }
    click(event) { }
    onEnter(event, key) {
        if (!event.target.value) {
            return;
        }
        const [day, month, year] = event.target.value.split("/").map(Number);
        const val = new Date(Date.UTC(year, month - 1, day));
        this.change({ target: { value: val } }, key);
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
DaterangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DaterangeComponent, deps: [{ token: i2.DateAdapter }, { token: LanguageService }, { token: GetArrayPathPipe }, { token: EventBusService }, { token: HelperService }, { token: RelativeDateService }, { token: MAT_DATE_LOCALE }], target: i0.ɵɵFactoryTarget.Component });
DaterangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: DaterangeComponent, selector: "app-daterange", inputs: { data: "data", parentForm: "parentForm" }, providers: [GetArrayPathPipe], ngImport: i0, template: "<div class=\"d-flex flex-wrap\">\r\n  <ng-container *ngIf=\"parentForm\">\r\n    <!-- in form -->\r\n    <!-- from field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\"\r\n      (click)=\"pickerFrom.open()\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerFrom\"\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerFrom\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerFrom\r\n        [color]=\"data.from.color\"\r\n        [opened]=\"data.from.opened\"\r\n        [disabled]=\"data.from.disabled\"\r\n        [startView]=\"data.from.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n\r\n    <!-- to field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\"\r\n      (click)=\"pickerTo.open()\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerTo\"\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerTo\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerTo\r\n        [color]=\"data.to.color\"\r\n        [opened]=\"data.to.opened\"\r\n        [disabled]=\"data.to.disabled\"\r\n        [startView]=\"data.to.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!parentForm\">\r\n    <!-- not in form -->\r\n    <!-- from field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      (click)=\"pickerFrom.open()\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerFrom\"\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerFrom\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerFrom\r\n        [color]=\"data.from.color\"\r\n        [opened]=\"data.from.opened\"\r\n        [disabled]=\"data.from.disabled\"\r\n        [startView]=\"data.from.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n\r\n    <!-- to field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      (click)=\"pickerTo.open()\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerTo\"\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerTo\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerTo\r\n        [color]=\"data.to.color\"\r\n        [opened]=\"data.to.opened\"\r\n        [disabled]=\"data.to.disabled\"\r\n        [startView]=\"data.to.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n  </ng-container>\r\n\r\n  <button\r\n    (click)=\"changePeriod('prev')\"\r\n    *ngIf=\"from && to && data.showPrevButton\"\r\n    mat-mini-fab\r\n    color=\"primary\">\r\n    <mat-icon>navigate_before</mat-icon>\r\n  </button>\r\n  <button\r\n    (click)=\"changePeriod('next')\"\r\n    *ngIf=\"from && to && data.showNextButton\"\r\n    mat-mini-fab\r\n    color=\"primary\">\r\n    <mat-icon>navigate_next</mat-icon>\r\n  </button>\r\n</div>\r\n", styles: ["mat-form-field ::ng-deep .mat-form-field-infix{width:-moz-min-content;width:min-content}button{margin-right:5px}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix]" }, { kind: "component", type: i1$4.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i1$4.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i1$4.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "directive", type: i12$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i13.InputMaskDirective, selector: "[inputMask]", inputs: ["inputMask"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DaterangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-daterange', providers: [GetArrayPathPipe], template: "<div class=\"d-flex flex-wrap\">\r\n  <ng-container *ngIf=\"parentForm\">\r\n    <!-- in form -->\r\n    <!-- from field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\"\r\n      (click)=\"pickerFrom.open()\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerFrom\"\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerFrom\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerFrom\r\n        [color]=\"data.from.color\"\r\n        [opened]=\"data.from.opened\"\r\n        [disabled]=\"data.from.disabled\"\r\n        [startView]=\"data.from.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n\r\n    <!-- to field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      [formGroup]=\"parentForm\"\r\n      (click)=\"pickerTo.open()\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerTo\"\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerTo\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerTo\r\n        [color]=\"data.to.color\"\r\n        [opened]=\"data.to.opened\"\r\n        [disabled]=\"data.to.disabled\"\r\n        [startView]=\"data.to.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!parentForm\">\r\n    <!-- not in form -->\r\n    <!-- from field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      (click)=\"pickerFrom.open()\">\r\n      <mat-label>{{ language.getLabel(data.from.label ?? data.from.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerFrom\"\r\n        [placeholder]=\"language.getLabel(data.from.placeholder)\"\r\n        (dateChange)=\"change($event, 'from')\"\r\n        (change)=\"onEnter($event, 'from')\"\r\n        [formControl]=\"inputFromControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerFrom\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerFrom\r\n        [color]=\"data.from.color\"\r\n        [opened]=\"data.from.opened\"\r\n        [disabled]=\"data.from.disabled\"\r\n        [startView]=\"data.from.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n\r\n    <!-- to field -->\r\n    <mat-form-field\r\n      *ngIf=\"dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"always\"\r\n      class=\"flex-fill\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- input mask -->\r\n      <input\r\n        matInput\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [inputMask]=\"dateInputMask\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n    </mat-form-field>\r\n    <mat-form-field\r\n      *ngIf=\"!dateInputMask\"\r\n      appearance=\"fill\"\r\n      floatLabel=\"auto\"\r\n      class=\"flex-fill\"\r\n      (click)=\"pickerTo.open()\">\r\n      <mat-label>{{ language.getLabel(data.to.placeholder) }}</mat-label>\r\n      <!-- datepicker -->\r\n      <input\r\n        matInput\r\n        [matDatepicker]=\"pickerTo\"\r\n        [placeholder]=\"language.getLabel(data.to.placeholder)\"\r\n        (dateChange)=\"change($event, 'to')\"\r\n        (change)=\"onEnter($event, 'to')\"\r\n        [formControl]=\"inputToControl\"\r\n        (click)=\"click($event)\" />\r\n\r\n      <mat-datepicker-toggle matSuffix [for]=\"pickerTo\"></mat-datepicker-toggle>\r\n\r\n      <mat-datepicker\r\n        #pickerTo\r\n        [color]=\"data.to.color\"\r\n        [opened]=\"data.to.opened\"\r\n        [disabled]=\"data.to.disabled\"\r\n        [startView]=\"data.to.startView\">\r\n      </mat-datepicker>\r\n    </mat-form-field>\r\n  </ng-container>\r\n\r\n  <button\r\n    (click)=\"changePeriod('prev')\"\r\n    *ngIf=\"from && to && data.showPrevButton\"\r\n    mat-mini-fab\r\n    color=\"primary\">\r\n    <mat-icon>navigate_before</mat-icon>\r\n  </button>\r\n  <button\r\n    (click)=\"changePeriod('next')\"\r\n    *ngIf=\"from && to && data.showNextButton\"\r\n    mat-mini-fab\r\n    color=\"primary\">\r\n    <mat-icon>navigate_next</mat-icon>\r\n  </button>\r\n</div>\r\n", styles: ["mat-form-field ::ng-deep .mat-form-field-infix{width:-moz-min-content;width:min-content}button{margin-right:5px}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.DateAdapter }, { type: LanguageService }, { type: GetArrayPathPipe }, { type: EventBusService }, { type: HelperService }, { type: RelativeDateService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DATE_LOCALE]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class ChartBarHorizontalComponent {
    constructor(language, getArrayPath, transformService) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.transformService = transformService;
        this.data = {};
    }
    ngOnInit() {
        if (typeof this.data.bars !== 'undefined') {
            const barsArray = [];
            // tslint:disable-next-line: forin
            for (const name in this.data.bars) {
                let labelValue = this.getArrayPath.transform(this.data.value, this.data.bars[name]);
                if (typeof this.data.transform !== 'undefined') {
                    labelValue = this.transformService.transform(this.getArrayPath.transform(this.data.value, this.data.bars[name]), this.data.transform);
                }
                barsArray.push({
                    name: this.language.getLabel(name) + ' (' + labelValue + ')',
                    value: this.getArrayPath.transform(this.data.value, this.data.bars[name])
                });
            }
            this.data.value = barsArray;
        }
        else if (typeof this.data.transform !== 'undefined') {
            for (const key in this.data.value) {
                this.data.value[key].name = this.transformService.transform(this.data.value[key].name, this.data.transform);
            }
        }
    }
    onSelect(data) {
    }
    onActivate(data) {
    }
    onDeactivate(data) {
    }
}
ChartBarHorizontalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarHorizontalComponent, deps: [{ token: LanguageService }, { token: GetArrayPathPipe }, { token: TransformService }], target: i0.ɵɵFactoryTarget.Component });
ChartBarHorizontalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ChartBarHorizontalComponent, selector: "app-chart-bar-horizontal", inputs: { data: "data" }, ngImport: i0, template: "<ngx-charts-bar-horizontal\r\n  [view]=\"data.view\"\r\n  [scheme]=\"data.colorScheme\"\r\n  [results]=\"data.value\"\r\n  [gradient]=\"data.gradient\"\r\n  [xAxis]=\"data.showXAxis\"\r\n  [yAxis]=\"data.showYAxis\"\r\n  [legend]=\"data.showLegend\"\r\n  [showXAxisLabel]=\"data.showXAxisLabel\"\r\n  [showYAxisLabel]=\"data.showYAxisLabel\"\r\n  [xAxisLabel]=\"data.xAxisLabel\"\r\n  [yAxisLabel]=\"data.yAxisLabel\"\r\n  (select)=\"onSelect($event)\"\r\n  (activate)=\"onActivate($event)\"\r\n  (deactivate)=\"onDeactivate($event)\">\r\n</ngx-charts-bar-horizontal>", styles: [":host{width:100%;height:100%;display:block}\n"], dependencies: [{ kind: "component", type: i2$1.BarHorizontalComponent, selector: "ngx-charts-bar-horizontal", inputs: ["legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "tooltipDisabled", "gradient", "showGridLines", "activeEntries", "schemeType", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "barPadding", "roundDomains", "roundEdges", "xScaleMax", "xScaleMin", "showDataLabel", "dataLabelFormatting", "noBarWhenZero", "wrapTicks"], outputs: ["activate", "deactivate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarHorizontalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-chart-bar-horizontal', template: "<ngx-charts-bar-horizontal\r\n  [view]=\"data.view\"\r\n  [scheme]=\"data.colorScheme\"\r\n  [results]=\"data.value\"\r\n  [gradient]=\"data.gradient\"\r\n  [xAxis]=\"data.showXAxis\"\r\n  [yAxis]=\"data.showYAxis\"\r\n  [legend]=\"data.showLegend\"\r\n  [showXAxisLabel]=\"data.showXAxisLabel\"\r\n  [showYAxisLabel]=\"data.showYAxisLabel\"\r\n  [xAxisLabel]=\"data.xAxisLabel\"\r\n  [yAxisLabel]=\"data.yAxisLabel\"\r\n  (select)=\"onSelect($event)\"\r\n  (activate)=\"onActivate($event)\"\r\n  (deactivate)=\"onDeactivate($event)\">\r\n</ngx-charts-bar-horizontal>", styles: [":host{width:100%;height:100%;display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathPipe }, { type: TransformService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class SlotDialogComponent {
    constructor(data, language, eventBus, comm) {
        this.data = data;
        this.language = language;
        this.eventBus = eventBus;
        this.comm = comm;
        this.channels = new Set();
        this.destroyed$ = new Subject();
    }
    backDropClick(event) {
    }
    ngOnInit() {
        this.selfRef = this;
        if (typeof this.data.close === 'undefined') {
            this.data.close = true;
        }
        this.eventBus.on('newChannelRegistered')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((channelUid) => this.registerChannel(channelUid));
    }
    registerChannel(channel) {
        this.channels.add(channel);
    }
    ngOnDestroy() {
        this.comm.resetChannels(this.channels);
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
SlotDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: LanguageService }, { token: EventBusService }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
SlotDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SlotDialogComponent, selector: "app-slot-dialog", host: { listeners: { "document:click": "backDropClick($event)" } }, ngImport: i0, template: "<h1 mat-dialog-title *ngIf=\"data.title\">\r\n  {{ language.getLabel(data.title) }}\r\n</h1>\r\n<mat-dialog-content>\r\n  <app-slot\r\n    *ngIf=\"!data.parentForm\"\r\n    [items]=\"data.items\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n  <app-slot\r\n    *ngIf=\"data.parentForm\"\r\n    [items]=\"data.items\"\r\n    [parentForm]=\"data.parentForm\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n</mat-dialog-content>\r\n<mat-dialog-actions *ngIf=\"data.close\" align=\"end\">\r\n  <button *ngIf=\"data.close\" mat-button matDialogClose=\"cancel\" color=\"primary\">\r\n    <mat-icon *ngIf=\"data.closeIcon\">{{data.closeIcon}}</mat-icon>\r\n    <span *ngIf=\"!data.closeLabel\">\r\n      {{ language.getLabel(\"App_close\") }}\r\n    </span>\r\n    <span *ngIf=\"data.closeLabel\">\r\n      {{ language.getLabel(data.closeLabel) }}\r\n    </span>\r\n  </button>\r\n</mat-dialog-actions>\r\n", styles: ["mat-dialog-content{padding:0;max-height:90vh}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: i3$3.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i3$3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i3$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i3$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-slot-dialog', template: "<h1 mat-dialog-title *ngIf=\"data.title\">\r\n  {{ language.getLabel(data.title) }}\r\n</h1>\r\n<mat-dialog-content>\r\n  <app-slot\r\n    *ngIf=\"!data.parentForm\"\r\n    [items]=\"data.items\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n  <app-slot\r\n    *ngIf=\"data.parentForm\"\r\n    [items]=\"data.items\"\r\n    [parentForm]=\"data.parentForm\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n</mat-dialog-content>\r\n<mat-dialog-actions *ngIf=\"data.close\" align=\"end\">\r\n  <button *ngIf=\"data.close\" mat-button matDialogClose=\"cancel\" color=\"primary\">\r\n    <mat-icon *ngIf=\"data.closeIcon\">{{data.closeIcon}}</mat-icon>\r\n    <span *ngIf=\"!data.closeLabel\">\r\n      {{ language.getLabel(\"App_close\") }}\r\n    </span>\r\n    <span *ngIf=\"data.closeLabel\">\r\n      {{ language.getLabel(data.closeLabel) }}\r\n    </span>\r\n  </button>\r\n</mat-dialog-actions>\r\n", styles: ["mat-dialog-content{padding:0;max-height:90vh}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: LanguageService }, { type: EventBusService }, { type: CommunicationService }]; }, propDecorators: { backDropClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class CustomValidators {
    constructor(evaluator, getArrayPath, api) {
        this.evaluator = evaluator;
        this.getArrayPath = getArrayPath;
        this.api = api;
    }
    match(matchTo) {
        return (control) => {
            if (control.parent &&
                control.parent.value &&
                control.value === control.parent.value[matchTo]) {
                return null;
            }
            else {
                return { match: control.value };
            }
        };
    }
    doesntMatch(doesntMatchTo) {
        return (control) => {
            let definedScope;
            if (control.parent &&
                control.parent.value) {
                if (typeof doesntMatchTo === 'string') {
                    definedScope = control.parent.value[doesntMatchTo];
                }
                if (Array.isArray(doesntMatchTo)) {
                    if (doesntMatchTo[0] === 'storage') {
                        // Check for a value in local storage
                        let path = doesntMatchTo[1].split('.');
                        try {
                            definedScope = JSON.parse(localStorage.getItem(path[0]));
                        }
                        catch (e) {
                            definedScope = localStorage.getItem(path[0]);
                        }
                    }
                }
                if (
                // Don't check the value type
                control.value == definedScope) {
                    return { doesntMatch: control.value };
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        };
    }
    requireIf(condition) {
        return (control) => {
            if (control.parent) {
                if (this.evaluator.exec(control.parent.value, condition) && !control.value) {
                    return { requireIf: false };
                }
                return null;
            }
            else {
                throw new Error('Control needs to have a parent to use requireIf validation rule');
            }
        };
    }
    /** @deprecated use requireIf */
    requireIfFilled(field) {
        return (control) => {
            if (control.parent &&
                control.parent.value &&
                control.parent.value[field] === '') {
                return null;
            }
            else {
                return { requireIfFilled: false };
            }
        };
    }
    /** @deprecated use requireIf */
    requireIfNotFilled(field) {
        return (control) => {
            if ((control.parent &&
                control.parent.value &&
                control.parent.value[field]) || control.value) {
                return null;
            }
            else {
                return { requireIfNotFilled: false };
            }
        };
    }
    uniqueInArray(element) {
        return (control) => {
            const value = control.value;
            if (typeof control.parent !== "undefined" && control.parent !== null) {
                const group = control.parent;
                if (group.parent
                    && group.parent !== null
                    && typeof group.parent.controls[Symbol.iterator] === 'function') {
                    const formArrayObject = group.parent;
                    for (const arrayGroup of formArrayObject.controls) {
                        if (arrayGroup !== group &&
                            arrayGroup["controls"][element].value === value) {
                            return {
                                uniqueInArray: control.value,
                            };
                        }
                    }
                }
            }
            return null;
        };
    }
    uniqueInEntireForm(element) {
        function hasValue(object, value) {
            return Object.values(object).some((val) => {
                if (val === value) {
                    return true;
                }
                if (val && typeof val === "object" && !Array.isArray(val)) {
                    return hasValue(val, value);
                }
                if (val && Array.isArray(val)) {
                    return val.some((obj) => {
                        return hasValue(obj, value);
                    });
                }
            });
        }
        return (control) => {
            const value = control.value;
            let formGroup = control.parent;
            if (typeof formGroup !== "undefined" && formGroup !== null) {
                while (formGroup.parent) {
                    formGroup = formGroup.parent;
                }
            }
            if (formGroup) {
                const form = formGroup.value;
                const formKeys = Object.keys(form);
                if (formKeys.length === 1 && typeof form[formKeys[0]] !== 'object') {
                    return null;
                }
                if (hasValue(form, value)) {
                    return {
                        uniqueInEntireForm: control.value,
                    };
                }
                else {
                    return null;
                }
            }
            return null;
        };
    }
    greaterThan(value) {
        return (control) => {
            let checkValue = value;
            if (control.parent && control.parent.value && typeof checkValue !== 'number') {
                checkValue = control.parent.value[value];
            }
            if (control.parent && control.parent.value && control.value > checkValue) {
                return null;
            }
            else {
                return { greaterThan: checkValue };
            }
        };
    }
    greaterThanOrEqual(value) {
        return (control) => {
            let checkValue = value;
            if (control.parent && control.parent.value && Array.isArray(value)) {
                if (checkValue[0] === 'root') {
                    checkValue = [...value];
                    checkValue.shift();
                    checkValue = this.getArrayPath.get(control.root.value, checkValue);
                }
                else {
                    checkValue = this.getArrayPath.get(control.parent.value, value);
                }
            }
            if (control.parent && control.parent.value && control.value >= +checkValue) {
                return null;
            }
            else {
                return { greaterThanOrEqual: checkValue };
            }
        };
    }
    /**
     * The sum of all the sibling fields in the form array
     * (having the same groupBy value if provided)
     * should be greater than or equal to the threshold.
     * The threshold can be array of number.
     * *If array
     * - when first element is 'root' the threshold is equal to the control
     *  value at the provided with the array path from the root of the form
     * - from parent form group otherwise
     */
    ArrayFieldSumGTE(params) {
        return (control) => {
            if (control === null) {
                return null;
            }
            let threshold;
            if (Array.isArray(params.threshold)) {
                threshold = [...params.threshold];
                if (threshold[0] === 'root') {
                    threshold.shift();
                    threshold = +this.getArrayPath.get(control.root.value, threshold);
                }
                else {
                    threshold = +this.getArrayPath.get(control.parent?.value, threshold);
                }
            }
            else {
                threshold = params.threshold;
            }
            if (typeof threshold === 'number') {
                let sum = 0;
                let groupByValue;
                if (typeof params.groupBy !== 'undefined'
                    && typeof control.dataObject !== 'undefined') {
                    groupByValue = this.getArrayPath.get(control.dataObject, params.groupBy);
                }
                for (const idx in control.parent?.parent?.controls) {
                    const ctrl = control.parent?.parent?.get(idx)?.get(control.def.name);
                    if (ctrl) {
                        if (typeof params.groupBy !== 'undefined'
                            && typeof ctrl?.dataObject !== 'undefined') {
                            const ctrlGroupByValue = this.getArrayPath.get(ctrl?.dataObject, params.groupBy);
                            if (groupByValue === ctrlGroupByValue) {
                                sum += ctrl.value;
                            }
                        }
                        else {
                            sum += ctrl.value;
                        }
                    }
                }
                if (sum >= threshold) {
                    return null;
                }
                else {
                    const error = {
                        group: null,
                        threshold
                    };
                    if (typeof params.groupBy !== 'undefined') {
                        error.group = groupByValue;
                    }
                    return {
                        ArrayFieldSumGTE: {
                            field: control.def?.name,
                            threshold
                        }
                    };
                }
            }
            else {
                if (typeof threshold === 'undefined') {
                    return null;
                }
                else {
                    throw new Error('limit value needs to be a number');
                }
            }
        };
    }
    lessThanOrEqual(value) {
        return (control) => {
            let checkValue = value;
            if (control.parent && control.parent.value && typeof checkValue !== 'number') {
                checkValue = control.parent.value[value];
            }
            if (control.parent && control.parent.value && control.value <= checkValue) {
                return null;
            }
            else {
                return { lessThanOrEqual: checkValue };
            }
        };
    }
    lessThan(value) {
        return (control) => {
            let checkValue = value;
            if (control.parent && control.parent.value && typeof checkValue !== 'number') {
                checkValue = control.parent.value[value];
            }
            if (control.parent && control.parent.value && control.value < checkValue) {
                return null;
            }
            else {
                return { lessThan: checkValue };
            }
        };
    }
    newerThan(value) {
        function modifyDate(date, offset) {
            const split = offset.split(' ');
            const capitalizedUnit = split[1].charAt(0).toUpperCase() + split[1].slice(1);
            const getter = 'get' + capitalizedUnit;
            const setter = 'set' + capitalizedUnit;
            const value = parseInt(split[0]);
            date[setter](date[getter]() + value);
            return date;
        }
        function aLowerb(a, b) {
            return a.getTime() < b.getTime();
        }
        function bLowera(a, b) {
            return a.getTime() > b.getTime();
        }
        return (control) => {
            if (control.value !== "") {
                let valid;
                const a = new Date(control.value);
                let b;
                if (typeof value === 'string') {
                    const split = value.split(' ');
                    if (typeof split[1] !== 'undefined') {
                        const now = new Date();
                        const interval = value;
                        b = modifyDate(now, interval);
                        if (split[0].startsWith('-')) {
                            valid = aLowerb(a, b);
                        }
                        else if (split[0].startsWith('+')) {
                            valid = bLowera(a, b);
                        }
                    }
                    else if (control.parent && control.parent.value[value] != "") {
                        b = new Date(control.parent.value[value]);
                        valid = bLowera(a, b);
                    }
                    else {
                        return null;
                    }
                }
                else if (Array.isArray(value)) {
                    const path = [...value];
                    if (path[0] === 'root') {
                        path.shift();
                        b = this.getArrayPath.get(control.root.value, path);
                    }
                    else {
                        b = this.getArrayPath.get(control.parent?.value);
                    }
                    valid = bLowera(a, b);
                }
                if (control.parent
                    && control.parent.value
                    && valid) {
                    return null;
                }
                else {
                    return { newerThan: value };
                }
            }
            return null;
        };
    }
    // THESE DON'T WORK ANYMORE IF YOU USE THEM FIX THEM
    // formArraySumLtEq(
    //   controlName: string,
    //   limit: number,
    //   filter: FormArrayValidationFilter
    // ): ValidatorFn {
    //   return (control: AbstractControl): ValidationErrors | null => {
    //     if (control.parent) {
    //       const formArray = control.parent.parent;
    //       if (formArray instanceof UntypedFormArray) {
    //         let sum = 0;
    //         const rows = formArray.controls;
    //         for (const row of rows) {
    //           const filterValue = row.get(filter.controlName)?.value;
    //           if (
    //             filter.controlValues.indexOf(filterValue) >= 0
    //             && row["groupUid"] === control.parent["groupUid"]
    //           ) {
    //             sum += parseInt(row.get(controlName)?.value, 10);
    //           }
    //         }
    //         if (sum > limit) {
    //           return {
    //             formArraySumLtEq: limit,
    //           };
    //         } else {
    //           for (const row of rows) {
    //             const filterValue = row.get(filter.controlName)?.value;
    //             if (
    //               filter.controlValues.indexOf(filterValue) >= 0 &&
    //               row["groupUid"] === control.parent["groupUid"]
    //             ) {
    //               row.get(controlName)?.setErrors(null);
    //             }
    //           }
    //         }
    //       }
    //     }
    //     return null;
    //   };
    // }
    // formArraySumGtEq(
    //   controlName: string,
    //   limit: number,
    //   filter: FormArrayValidationFilter
    // ): ValidatorFn {
    //   return (control: AbstractControl): ValidationErrors | null => {
    //     if (control.parent) {
    //       const formArray = control.parent.parent;
    //       if (formArray instanceof UntypedFormArray) {
    //         let sum = 0;
    //         const rows = formArray.controls;
    //         for (const row of rows) {
    //           const filterValue = row.get(filter.controlName)?.value;
    //           if (
    //             filter.controlValues.indexOf(filterValue) >= 0 &&
    //             row["groupUid"] === control.parent["groupUid"]
    //           ) {
    //             sum += parseInt(row.get(controlName)?.value, 10);
    //           }
    //         }
    //         if (sum < limit) {
    //           return {
    //             formArraySumGtEq: limit,
    //           };
    //         } else {
    //           for (const row of rows) {
    //             const filterValue = row.get(filter.controlName)?.value;
    //             if (
    //               filter.controlValues.indexOf(filterValue) >= 0 &&
    //               row["groupUid"] === control.parent["groupUid"]
    //             ) {
    //               row.get(controlName)?.setErrors(null);
    //             }
    //           }
    //         }
    //       }
    //     }
    //     return null;
    //   };
    // }
    // formArraySumEq(
    //   controlName: string,
    //   limit: number,
    //   filter: FormArrayValidationFilter,
    //   deviation: number | null
    // ): ValidatorFn {
    //   return (control: AbstractControl): ValidationErrors | null => {
    //     if (control.parent) {
    //       const formArray = control.parent.parent;
    //       if (formArray instanceof UntypedFormArray) {
    //         let sum = 0;
    //         const rows = formArray.controls;
    //         for (const row of rows) {
    //           const filterValue = row.get(filter.controlName)?.value;
    //           if (
    //             filter.controlValues.indexOf(filterValue) >= 0 &&
    //             row["groupUid"] === control.parent["groupUid"]
    //           ) {
    //             sum += parseInt(row.get(controlName)?.value, 10);
    //           }
    //         }
    //         let valid = false;
    //         if (deviation !== null) {
    //           if (sum >= limit - deviation && sum <= limit + deviation) {
    //             valid = true;
    //           }
    //         } else {
    //           if (sum === limit) {
    //             valid = true;
    //           }
    //         }
    //         for (const row of rows) {
    //           const filterValue = row.get(filter.controlName)?.value;
    //           if (
    //             filter.controlValues.indexOf(filterValue) >= 0 &&
    //             row["groupUid"] === control.parent["groupUid"]
    //           ) {
    //             row.get(controlName)?.setErrors(null);
    //           }
    //         }
    //         if (!valid) {
    //           return {
    //             formArraySumEq: {
    //               limit,
    //               sum,
    //             },
    //           };
    //         }
    //       }
    //     }
    //     return null;
    //   };
    // }
    formGroupNotEmpty(skipKeys) {
        function hasAnyValue(object) {
            return Object.entries(object).some((item) => {
                if (skipKeys.indexOf(item[0]) < 0) {
                    if (item[1] && typeof item[1] === "object" && !Array.isArray(item[1])) {
                        return hasAnyValue(item[1]);
                    }
                    if (item[1] && Array.isArray(item[1])) {
                        return item[1].some((obj) => {
                            return hasAnyValue(obj);
                        });
                    }
                    if (item[1]) {
                        return true;
                    }
                }
            });
        }
        return (formGroup) => {
            if (!hasAnyValue(formGroup.value)) {
                return {
                    formGroupNotEmpty: formGroup.value
                };
            }
            return null;
        };
    }
    formGroupMaxValuesCount(params) {
        let count = 0;
        function countValues(object) {
            if (count > 0) {
                count = 0;
            }
            Object.entries(object).some((item) => {
                if (params.skipKeys.indexOf(item[0]) < 0) {
                    if (item[1] && typeof item[1] === "object" && !Array.isArray(item[1])) {
                        return countValues(item[1]);
                    }
                    if (item[1] && Array.isArray(item[1])) {
                        return item[1].some((obj) => {
                            return countValues(obj);
                        });
                    }
                    if (item[1]) {
                        count++;
                    }
                }
            });
            return count;
        }
        return (formGroup) => {
            if (countValues(formGroup.value) > params.count) {
                return {
                    formGroupMaxValuesCount: formGroup.value
                };
            }
            return null;
        };
    }
    validUicEgn() {
        return (control) => {
            let uic = control.value;
            let matches;
            if (uic.match(/^(BG)(\d{9,})/)) {
                uic = uic.slice(2);
            }
            if (!(matches = uic.match(/^((\d{9})(\d{1})?(\d{4})?)$/)))
                return { validUicEgn: control.value };
            // if EIK is EGN
            if (uic.length === 10) {
                let egnLgth = matches[1].split("").map((i) => parseInt(i, 10));
                let egnLgth10 = egnLgth[0] * 2 +
                    egnLgth[1] * 4 +
                    egnLgth[2] * 8 +
                    egnLgth[3] * 5 +
                    egnLgth[4] * 10 +
                    egnLgth[5] * 9 +
                    egnLgth[6] * 7 +
                    egnLgth[7] * 3 +
                    egnLgth[8] * 6;
                egnLgth10 = egnLgth10 % 11;
                egnLgth10 = egnLgth10 == 10 ? 0 : egnLgth10;
                return egnLgth10 == egnLgth[9] ? null : { validUicEgn: control.value };
            }
            // if EIK has length 9 numbers and number from VAT
            //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
            let uicLgth = matches[2].split("").map((i) => parseInt(i, 10));
            let uicLgth9 = uicLgth[0] * 1 +
                uicLgth[1] * 2 +
                uicLgth[2] * 3 +
                uicLgth[3] * 4 +
                uicLgth[4] * 5 +
                uicLgth[5] * 6 +
                uicLgth[6] * 7 +
                uicLgth[7] * 8;
            uicLgth9 = uicLgth9 % 11;
            if (uicLgth9 == 10) {
                //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
                uicLgth9 =
                    uicLgth[0] * 3 +
                        uicLgth[1] * 4 +
                        uicLgth[2] * 5 +
                        uicLgth[3] * 6 +
                        uicLgth[4] * 7 +
                        uicLgth[5] * 8 +
                        uicLgth[6] * 9 +
                        uicLgth[7] * 10;
                uicLgth9 = uicLgth9 % 11;
            }
            uicLgth9 = uicLgth9 == 10 ? 0 : uicLgth9;
            if (uicLgth9 != uicLgth[8])
                return { validUicEgn: control.value };
            if (!matches[4])
                return null;
            // if EIK has length 13
            //2*а9 + 7*а10 + 3*а11 +5*а12
            uicLgth = matches[4].split("").map((i) => parseInt(i, 10));
            let uicLgth13 = uicLgth9 * 2 + uicLgth[0] * 7 + uicLgth[1] * 3 + uicLgth[2] * 5;
            uicLgth13 = uicLgth13 % 11;
            //4*а9+9*а10+5*а11+7*а12
            if (uicLgth13 == 10) {
                uicLgth13 = uicLgth9 * 4 + uicLgth[0] * 9 + uicLgth[1] * 5 + uicLgth[2] * 7;
                uicLgth13 = uicLgth13 % 11;
            }
            uicLgth13 = uicLgth13 == 10 ? 0 : uicLgth13;
            return uicLgth13 == uicLgth[3] ? null : { validUicEgn: control.value };
        };
    }
    validUic() {
        return (control) => {
            let uic = control.value;
            let matches;
            if (!(matches = uic.match(/^((\d{9})(\d{4})?)$/)))
                return { validUic: control.value };
            // if EIK has length 9 numbers and number from VAT
            //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
            let uicLgth = matches[2].split("").map((i) => parseInt(i, 10));
            let uicLgth9 = uicLgth[0] * 1 +
                uicLgth[1] * 2 +
                uicLgth[2] * 3 +
                uicLgth[3] * 4 +
                uicLgth[4] * 5 +
                uicLgth[5] * 6 +
                uicLgth[6] * 7 +
                uicLgth[7] * 8;
            uicLgth9 = uicLgth9 % 11;
            if (uicLgth9 == 10) {
                //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
                uicLgth9 =
                    uicLgth[0] * 3 +
                        uicLgth[1] * 4 +
                        uicLgth[2] * 5 +
                        uicLgth[3] * 6 +
                        uicLgth[4] * 7 +
                        uicLgth[5] * 8 +
                        uicLgth[6] * 9 +
                        uicLgth[7] * 10;
                uicLgth9 = uicLgth9 % 11;
            }
            uicLgth9 = uicLgth9 == 10 ? 0 : uicLgth9;
            if (uicLgth9 != uicLgth[8])
                return { validUic: control.value };
            if (!matches[4])
                return null;
            // if EIK has length 13
            //2*а9 + 7*а10 + 3*а11 +5*а12
            uicLgth = matches[4].split("").map((i) => parseInt(i, 10));
            let uicLgth13 = uicLgth9 * 2 + uicLgth[0] * 7 + uicLgth[1] * 3 + uicLgth[2] * 5;
            uicLgth13 = uicLgth13 % 11;
            //4*а9+9*а10+5*а11+7*а12
            if (uicLgth13 == 10) {
                uicLgth13 = uicLgth9 * 4 + uicLgth[0] * 9 + uicLgth[1] * 5 + uicLgth[2] * 7;
                uicLgth13 = uicLgth13 % 11;
            }
            uicLgth13 = uicLgth13 == 10 ? 0 : uicLgth13;
            return uicLgth13 == uicLgth[3] ? null : { validUic: control.value };
        };
    }
    validEgn() {
        return (control) => {
            let egn = control.value;
            let matches;
            if (!(matches = egn.match(/^((\d{10})?)$/))) {
                return { validEgn: control.value };
            }
            if (egn.length === 10) {
                let egnLgth = matches[1].split("").map((i) => parseInt(i, 10));
                let egnLgth10 = egnLgth[0] * 2 +
                    egnLgth[1] * 4 +
                    egnLgth[2] * 8 +
                    egnLgth[3] * 5 +
                    egnLgth[4] * 10 +
                    egnLgth[5] * 9 +
                    egnLgth[6] * 7 +
                    egnLgth[7] * 3 +
                    egnLgth[8] * 6;
                egnLgth10 = egnLgth10 % 11;
                egnLgth10 = egnLgth10 == 10 ? 0 : egnLgth10;
                return egnLgth10 == egnLgth[9] ? null : { validEgn: control.value };
            }
            else {
                return { validEgn: control.value };
            }
        };
    }
    validVat() {
        return (control) => {
            let vat = control.value;
            let matches;
            if (vat.match(/^(BG)((\d{9})(\d{4})?)$/)) {
                vat = vat.slice(2);
                matches = vat.match(/^((\d{9})(\d{4})?)$/);
            }
            else {
                return { validVat: control.value };
            }
            // if vat has length 9 numbers
            //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
            let vatLgth = matches[2].split("").map((i) => parseInt(i, 10));
            let vatLgth9 = vatLgth[0] * 1 +
                vatLgth[1] * 2 +
                vatLgth[2] * 3 +
                vatLgth[3] * 4 +
                vatLgth[4] * 5 +
                vatLgth[5] * 6 +
                vatLgth[6] * 7 +
                vatLgth[7] * 8;
            vatLgth9 = vatLgth9 % 11;
            if (vatLgth9 == 10) {
                //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
                vatLgth9 =
                    vatLgth[0] * 3 +
                        vatLgth[1] * 4 +
                        vatLgth[2] * 5 +
                        vatLgth[3] * 6 +
                        vatLgth[4] * 7 +
                        vatLgth[5] * 8 +
                        vatLgth[6] * 9 +
                        vatLgth[7] * 10;
                vatLgth9 = vatLgth9 % 11;
            }
            vatLgth9 = vatLgth9 == 10 ? 0 : vatLgth9;
            if (vatLgth9 != vatLgth[8])
                return { validVat: control.value };
            if (!matches[4])
                return null;
            // if vat has length 13
            //2*а9 + 7*а10 + 3*а11 +5*а12
            vatLgth = matches[4].split("").map((i) => parseInt(i, 10));
            let vatLgth13 = vatLgth9 * 2 + vatLgth[0] * 7 + vatLgth[1] * 3 + vatLgth[2] * 5;
            vatLgth13 = vatLgth13 % 11;
            //4*а9+9*а10+5*а11+7*а12
            if (vatLgth13 == 10) {
                vatLgth13 = vatLgth9 * 4 + vatLgth[0] * 9 + vatLgth[1] * 5 + vatLgth[2] * 7;
                vatLgth13 = vatLgth13 % 11;
            }
            vatLgth13 = vatLgth13 == 10 ? 0 : vatLgth13;
            return vatLgth13 == vatLgth[3] ? null : { validVat: control.value };
        };
    }
    asyncApiCall(dataSource) {
        return control => control.valueChanges.pipe(debounceTime$1(500), distinctUntilChanged(), switchMap(value => {
            control.root.updateValueAndValidity();
            return this.api.callServiceMethod(dataSource, control.root.value);
        }), map$1(response => response.result ? null : { asyncApiCall: control.value }), first$1());
    }
}
CustomValidators.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomValidators, deps: [{ token: EvalService }, { token: GetArrayPathService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
CustomValidators.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomValidators });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomValidators, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: EvalService }, { type: GetArrayPathService }, { type: ApiService }]; } });

const OVERLAY_TOKEN = new InjectionToken('overlay-data');
class OverlayComponent {
    constructor(data, eventBus, comm) {
        this.data = data;
        this.eventBus = eventBus;
        this.comm = comm;
        this.closeOverlay = new EventEmitter();
        this.channels = new Set();
        this.destroyed$ = new Subject();
    }
    ngOnInit() {
        this.selfRef = this;
        this.eventBus.on('newChannelRegistered')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((channelUid) => this.registerChannel(channelUid));
    }
    close() {
        if (this.data.disableMouseLeave) {
            return;
        }
        this.closeOverlay.emit();
    }
    registerChannel(channel) {
        this.channels.add(channel);
    }
    ngOnDestroy() {
        this.comm.resetChannels(this.channels);
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
OverlayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayComponent, deps: [{ token: OVERLAY_TOKEN }, { token: EventBusService }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
OverlayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: OverlayComponent, selector: "app-overlay", outputs: { closeOverlay: "closeOverlay" }, ngImport: i0, template: "<div (mouseleave)=\"close()\">\r\n  <app-slot\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n</div>\r\n\r\n\r\n\r\n", styles: [""], dependencies: [{ kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-overlay', template: "<div (mouseleave)=\"close()\">\r\n  <app-slot\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n    style=\"display: block; width: 100%; height: 100%\"\r\n  ></app-slot>\r\n</div>\r\n\r\n\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [OVERLAY_TOKEN]
                }] }, { type: EventBusService }, { type: CommunicationService }]; }, propDecorators: { closeOverlay: [{
                type: Output
            }] } });

class CloneAbstractControlService {
    clone(control, withDataObject = false) {
        let newControl;
        if (control instanceof UntypedFormGroup
            || control instanceof FormGroup) {
            const formGroup = new UntypedFormGroup({}, control.validator, control.asyncValidator);
            const controls = control.controls;
            Object.keys(controls).forEach(key => {
                formGroup.addControl(key, this.clone(controls[key], withDataObject));
            });
            newControl = formGroup;
        }
        else if (control instanceof UntypedFormArray
            || control instanceof FormArray) {
            const formArray = new UntypedFormArray([], control.validator, control.asyncValidator);
            control.controls.forEach(formControl => formArray.push(this.clone(formControl, withDataObject)));
            newControl = formArray;
        }
        else if (control instanceof UntypedFormControl
            || control instanceof FormControl) {
            newControl = new UntypedFormControl(control.value, control.validator, control.asyncValidator);
            if (typeof control['def'] !== 'undefined') {
                newControl['def'] = JSON.parse(JSON.stringify(control['def']));
            }
        }
        else {
            throw new Error('Error: unexpected control value');
        }
        if (withDataObject && control['dataObject']) {
            newControl['dataObject'] = control['dataObject'];
        }
        if (control.disabled) {
            newControl.disable({ emitEvent: false });
        }
        return newControl;
    }
}
CloneAbstractControlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CloneAbstractControlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CloneAbstractControlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CloneAbstractControlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CloneAbstractControlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class GetControlByPathService {
    get(control, path = '', getValue = true) {
        let resultControl = control;
        if (path) {
            if (typeof path === 'string') {
                if (typeof resultControl === 'undefined') {
                    return undefined;
                }
                resultControl = resultControl.get(path);
            }
            else {
                for (const item of path) {
                    if (item === 'parent') {
                        resultControl = resultControl.parent;
                    }
                    else {
                        if (resultControl instanceof UntypedFormArray
                            && typeof item === 'string') {
                            const result = [];
                            for (const row of resultControl.controls) {
                                result.push(row.get(item));
                            }
                            resultControl = result;
                        }
                        else {
                            if (typeof resultControl === 'undefined') {
                                return undefined;
                            }
                            resultControl = resultControl.get(item);
                        }
                    }
                }
            }
        }
        if (getValue) {
            if (Array.isArray(resultControl)) {
                const resultValues = [];
                for (const ctrl of resultControl) {
                    resultValues.push(ctrl.value);
                }
                return resultValues;
            }
            else {
                if (resultControl !== null) {
                    return resultControl.value;
                }
            }
        }
        else {
            return resultControl;
        }
    }
}
GetControlByPathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetControlByPathService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GetControlByPathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetControlByPathService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetControlByPathService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class LoginService {
    constructor(state, session, language, permissionSevice, cache, router) {
        this.state = state;
        this.session = session;
        this.language = language;
        this.permissionSevice = permissionSevice;
        this.cache = cache;
        this.router = router;
    }
    login(response, params) {
        this.cache.set('auth', true);
        if (this.state.get('language') !== response.result.locale) {
            this.language.setLanguage(response.result.locale);
        }
        this.permissionSevice.setSession(response.result);
        if (typeof params === 'undefined') {
            params = {};
        }
        if (typeof params.redirect !== 'undefined') {
            // if redirect is present use it
            if (!params.redirect) {
                return;
            }
            else {
                this.router.navigate([params.redirect]);
            }
        }
        else {
            // if redirect is not present redirect to last url
            if (!params.excludeLastUrl) {
                // list of urls to not redirect to when redirecting to last url
                params.excludeLastUrl = [
                    '/login',
                    '/logout',
                    '/init-password-reset',
                    '/reset-password'
                ];
            }
            let lastUrl = this.session.get('lastUrl');
            if (lastUrl) {
                if (params.excludeLastUrl.some(path => lastUrl[0].startsWith(path))) {
                    // if last url is present and is excluded go to homepage
                    this.router.navigate(['']);
                }
                else {
                    // if last url is present and is not excluded
                    this.router.navigateByUrl(decodeURI(lastUrl[0]));
                }
            }
            else {
                // if last url doesn't exist redirect to home page
                this.router.navigate(['']);
            }
        }
    }
}
LoginService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoginService, deps: [{ token: StateService }, { token: SessionService }, { token: LanguageService }, { token: PermissionsService }, { token: CacheService }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
LoginService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoginService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoginService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: StateService }, { type: SessionService }, { type: LanguageService }, { type: PermissionsService }, { type: CacheService }, { type: i1.Router }]; } });

class FileService {
    constructor(document) {
        this.document = document;
    }
    download(data) {
        const blob = this.b64toBlob(data.result.content, data.result.mimetype);
        const link = this.document.createElement('a');
        // Browsers that support HTML5 download attribute
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', data.result.filename);
            link.style.visibility = 'hidden';
            this.document.body.appendChild(link);
            link.click();
            this.document.body.removeChild(link);
        }
    }
    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
FileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FileService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
FileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class HashService {
    constructor(state) {
        this.state = state;
    }
    saveHash(response) {
        this.state.set('cartHash', response.result.data.hash);
    }
}
HashService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HashService, deps: [{ token: StateService }], target: i0.ɵɵFactoryTarget.Injectable });
HashService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HashService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HashService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: StateService }]; } });

class UrlService {
    constructor(router) {
        this.router = router;
    }
    /**
     * Adds parameters to the url, removes top level params if they already exist
     * @param params the array of parameters to be added, may contain base url
     * @param action add | toggle
     */
    toUrl(params, action = 'add') {
        let baseSegments = [];
        let newUrl;
        let querySplit;
        const clonedParams = Object.assign({}, params);
        if (typeof clonedParams.baseUrl !== 'undefined') {
            newUrl = [clonedParams.baseUrl];
            delete clonedParams.baseUrl;
        }
        else {
            querySplit = this.router.routerState.snapshot.url.split('?');
            const urlSplit = querySplit[0].split(';');
            newUrl = [urlSplit.shift()];
            baseSegments.push(...urlSplit.filter(segment => {
                if (action === 'add') {
                    const keyValueSplit = segment.split('=');
                    const path = keyValueSplit[0].split('.');
                    let self = clonedParams;
                    let i = 1;
                    for (const key of path) {
                        if (typeof self[key] !== 'undefined'
                            || typeof self[key + '_from'] !== 'undefined') {
                            if (i < path.length) {
                                self = self[key];
                                i++;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                }
                else {
                    for (const group in clonedParams) {
                        if (segment.startsWith(group)) {
                            if (action === 'toggleGroup') {
                                delete clonedParams[group];
                            }
                            return false;
                        }
                    }
                }
                return true;
            }));
        }
        const filter = this.objectToUrlString(clonedParams).split(';');
        baseSegments = baseSegments.concat(filter).sort().reverse();
        newUrl = newUrl.concat(baseSegments);
        let url = newUrl.join(';');
        if (typeof querySplit !== 'undefined' && typeof querySplit[1] !== 'undefined') {
            url += '?' + querySplit[1];
        }
        this.router.navigateByUrl(url);
    }
    objectToUrlString(obj, group = null) {
        const segments = [];
        for (let key in obj) {
            if (obj[key] !== '') {
                let pair = '';
                let keyBase;
                if (key.endsWith('_from')) {
                    keyBase = key.replace('_from', '');
                    const toKey = keyBase + '_to';
                    if (typeof obj[toKey] !== 'undefined') {
                        key = keyBase;
                    }
                    else {
                        keyBase = undefined;
                    }
                }
                else if (key.endsWith('_to')) {
                    keyBase = key.replace('_to', '');
                    const fromKey = keyBase + '_from';
                    if (typeof obj[fromKey] !== 'undefined') {
                        key = keyBase;
                    }
                    else {
                        keyBase = undefined;
                    }
                }
                if (group !== null) {
                    pair += group + '.' + key;
                }
                if (typeof obj[key] === 'object') {
                    if (Array.isArray(obj[key])) {
                        if (obj[key].length === 0) {
                            continue;
                        }
                        pair += '=' + obj[key].join(',');
                    }
                    else if (typeof obj[key].min !== 'undefined'
                        && !isNaN(obj[key].min)
                        && typeof obj[key].max !== 'undefined'
                        && !isNaN(obj[key].max)) {
                        pair += '=' + Object.values(obj[key]).join('..');
                    }
                    else {
                        let rightSide;
                        if (group === null) {
                            rightSide = this.objectToUrlString(obj[key], key);
                        }
                        else {
                            rightSide = this.objectToUrlString(obj[key], group);
                        }
                        if (rightSide) {
                            pair += rightSide;
                        }
                        else {
                            continue;
                        }
                    }
                }
                else {
                    if (pair === '') {
                        pair += key;
                    }
                    if (typeof keyBase !== 'undefined') {
                        obj[key] = obj[key + '_from'] + '..' + obj[key + '_to'];
                        delete obj[key + '_from'];
                        delete obj[key + '_to'];
                    }
                    pair += '=' + obj[key];
                }
                segments.push(pair);
            }
        }
        return segments.join(';');
    }
}
UrlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UrlService, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
UrlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UrlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UrlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; } });

var executables = /*#__PURE__*/Object.freeze({
   __proto__: null,
   LoginService: LoginService,
   FileService: FileService,
   HashService: HashService,
   UrlService: UrlService
});

class OverlayService {
    constructor() {
        this.overlayRegistry = new Map();
    }
    registerOverlay(id, ref) {
        this.overlayRegistry.set(id, ref);
    }
    removeOverlay(id) {
        this.overlayRegistry.delete(id);
    }
    isOverlayRegistered(id) {
        return this.overlayRegistry.has(id);
    }
    getOverlayRef(id) {
        return this.overlayRegistry.get(id);
    }
}
OverlayService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OverlayService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class ActionComponent {
    constructor(document, api, libraries, dialog, overlay, alert, cloner, getArrayPath, getControlByPath, session, state, breakpointObserver, evaluator, language, urlService, comm, router, overlayService, route, location, helper, cache, loader, clipboard) {
        this.document = document;
        this.api = api;
        this.libraries = libraries;
        this.dialog = dialog;
        this.overlay = overlay;
        this.alert = alert;
        this.cloner = cloner;
        this.getArrayPath = getArrayPath;
        this.getControlByPath = getControlByPath;
        this.session = session;
        this.state = state;
        this.breakpointObserver = breakpointObserver;
        this.evaluator = evaluator;
        this.language = language;
        this.urlService = urlService;
        this.comm = comm;
        this.router = router;
        this.overlayService = overlayService;
        this.route = route;
        this.location = location;
        this.helper = helper;
        this.cache = cache;
        this.loader = loader;
        this.clipboard = clipboard;
        this.events = {};
        this.destroyed = new Subject();
        this.scrollTop = 0;
        this.sizeObserver = this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge
        ]);
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (typeof this.data.events !== 'undefined') {
            this.events = JSON.parse(JSON.stringify(this.data.events));
            for (const event in this.events) {
                if (this.data.control) {
                    this.data.control.data[event] = this.doAction.bind(this);
                }
            }
        }
    }
    doAction(state) {
        const observables = [];
        // tslint:disable-next-line: forin
        let lastAction;
        for (const key in this.events[state.event]) {
            if (typeof this.events[state.event][key].action !== 'undefined') {
                const actionMethod = this.events[state.event][key].action;
                const actionDef = this.events[state.event][key];
                observables.push(this[actionMethod](state, actionDef, this.parentForm));
                lastAction = actionDef;
            }
            else {
                // DEPRECATED USE "action" property rather then key to define action
                // see case above
                if (Array.isArray(this.events[state.event][key])) {
                    for (const def of this.events[state.event][key]) {
                        observables.push(this[key](state, def, this.parentForm));
                        lastAction = def;
                    }
                }
                else {
                    observables.push(this[key](state, this.events[state.event][key], this.parentForm));
                    lastAction = this.events[state.event][key];
                }
            }
        }
        if (observables.length > 0) {
            const initValue = 1;
            if (typeof lastAction.subscribable !== 'undefined'
                && lastAction.subscribable) {
                return of({
                    initValue,
                    sequence: observables
                }).pipe(mergeMap(({ initValue, sequence }) => {
                    initValue = of(initValue);
                    return initValue.pipe(...sequence.map(action => mergeMap(action)));
                }));
            }
            else {
                of({
                    initValue,
                    sequence: observables
                }).pipe(takeUntil(this.destroyed), mergeMap(({ initValue, sequence }) => {
                    initValue = of(initValue);
                    return initValue.pipe(...sequence.map(action => mergeMap(action)));
                })).subscribe((value) => { });
            }
        }
    }
    prepCallParamsRecursive(params, state, data, parentForm) {
        const paramRegex = /^{.+}$/;
        for (const param in params) {
            if (typeof params[param] === 'object') {
                if (Array.isArray(params[param]) && typeof params[param][0] !== 'object') {
                    let scope;
                    switch (params[param][0]) {
                        case "data":
                            params[param].shift();
                            scope = data;
                            break;
                        case "state":
                        case "cache":
                            scope = null;
                            break;
                        case 'componentState':
                            params[param].shift();
                            scope = state;
                            break;
                        default:
                            scope = this.data.dataObject;
                            break;
                    }
                    params[param] = this.getArrayPath.get(scope, params[param]);
                }
                else {
                    params[param] = this.prepCallParamsRecursive(params[param], state, data);
                }
            }
            else if (params[param] === '{value}') {
                params[param] = state.value;
            }
            else if (params[param] === '{routeUrl}') {
                params[param] = this.router.url;
            }
            else if (paramRegex.test(params[param])) {
                if (parentForm) {
                    if (params[param].replace(/[{}]/g, '').startsWith('parentForm.')) {
                        let path = params[param].replace(/[{}]/g, '').split('.');
                        // Remove parentForm from params array
                        path.shift();
                        if (path[0] === 'parent') {
                            // If you need to search in the parent of the form group
                            // FIXME find a way to search recursively
                            let clonedForm = { ...parentForm };
                            clonedForm = parentForm.parent;
                            path.shift();
                            params[param] = this.getArrayPath.get(clonedForm, path);
                        }
                        else {
                            params[param] = this.getArrayPath.get(parentForm.getRawValue(), path);
                        }
                    }
                    else {
                        params[param] = parentForm.dataObject[params[param].replace(/[{}]/g, '')];
                    }
                }
                else {
                    const path = params[param].replace(/[{}]/g, '').split('.');
                    params[param] = state;
                    for (const p of path) {
                        params[param] = params[param][p];
                    }
                }
            }
            else if (typeof params[param] === 'string' && params[param].startsWith(':')) {
                params[param] = this.getArrayPath.get(null, [
                    'route',
                    'params',
                    params[param].replace(':', '')
                ]);
            }
        }
        for (const param in params) {
            if (params[param]) {
                if (typeof params[param] === "string" &&
                    params[param].startsWith(":")) {
                    // remove any remaining placeholders
                    delete params[param];
                }
                if (param.indexOf(".") >= 0) {
                    // if key is still a dot notation use it as destination path
                    this.helper.setObjectPath(param, params[param], params);
                    delete params[param];
                }
            }
        }
        return params;
    }
    evalConditions(state, data, action, parentForm) {
        let conditions = [];
        let evalData = [];
        let evalValueData = [];
        if (Array.isArray(action.condition)) {
            conditions = action.condition;
        }
        else {
            conditions.push(action.condition);
        }
        for (const condition of conditions) {
            switch (condition.scope) {
                case 'lastUrl':
                    evalData.push(this.session.get('lastUrl')[0]);
                    break;
                case 'urlParams':
                    evalData.push(this.route.snapshot.params);
                    break;
                case 'state':
                    evalData.push(state);
                    break;
                case 'data':
                    evalData.push(data);
                    break;
                case 'storage':
                    evalData.push(null);
                    break;
                case 'parentForm':
                    evalData.push(this.parentForm.getRawValue());
                    break;
                default:
                    evalData.push(this.data.dataObject);
            }
            if (condition.valueScope) {
                switch (condition.valueScope) {
                    case 'lastUrl':
                        evalValueData.push(this.session.get('lastUrl')[0]);
                        break;
                    case 'urlParams':
                        evalValueData.push(this.route.snapshot.params);
                        break;
                    case 'state':
                        evalValueData.push(state);
                        break;
                    case 'data':
                        evalValueData.push(data);
                        break;
                    case 'storage':
                        evalValueData.push(null);
                        break;
                    case 'parentForm':
                        evalValueData.push(this.parentForm.getRawValue());
                        break;
                    default:
                        evalValueData.push(this.data.dataObject);
                }
            }
            else {
                evalValueData.push(condition.value);
            }
        }
        return this.evaluator.exec(evalData, conditions, evalValueData);
    }
    call(state, action, parentForm) {
        return (data) => {
            let service;
            const clonedObject = JSON.parse(JSON.stringify({ ...action.params }));
            const params = clonedObject;
            if (typeof action.lib !== 'undefined') {
                service = this.libraries.getService(action.lib, action.service);
            }
            else {
                service = this.api.getService(action.service);
            }
            this.prepCallParamsRecursive(params, state, data, parentForm);
            if (typeof action.condition !== 'undefined') {
                if (this.evalConditions(state, data, action, parentForm)) {
                    return service[action.method](params)
                        .pipe(catchError$1((err) => {
                        if (action.continueOnError) {
                            return of(err);
                        }
                        throw err;
                    }), take$1(1));
                }
                else {
                    return of(data);
                }
            }
            else {
                return service[action.method](params)
                    .pipe(catchError$1((err) => {
                    if (action.continueOnError) {
                        return of(err);
                    }
                    throw err;
                }), take$1(1));
            }
        };
    }
    redirect(state, action) {
        return (data) => {
            let redirect;
            if (typeof action.route !== 'undefined') {
                // direct redirect to route
                redirect = action.route;
            }
            else if (typeof action.urlPath !== 'undefined') {
                // extract redirect from data or state.data path
                redirect = this.getArrayPath.get((data === 1) ? state : data, action.urlPath);
            }
            // conditional redirect
            if (typeof action.condition !== 'undefined') {
                if (!this.evalConditions(state, data, action)) {
                    if (typeof action.falseRoute !== 'undefined') {
                        redirect = action.falseRoute;
                    }
                    else if (typeof action.falseUrlPath !== 'undefined') {
                        redirect = this.getArrayPath.get((data === 1) ? state : data, action.falseUrlPath);
                    }
                    else {
                        // if no false route don't redirect
                        return of(data);
                    }
                }
            }
            // add subdomain for relative redirects if configured
            let url;
            if (typeof action.subDomainPath !== 'undefined') {
                const subDomain = this.getArrayPath.get((data === 1) ? state : data, action.subDomainPath);
                if (!this.document.location.hostname.startsWith(subDomain)) {
                    url = this.document.location.protocol + '//';
                    url += subDomain + '.' + this.document.location.hostname;
                }
            }
            if (typeof url !== 'undefined') {
                if (Array.isArray(redirect)) {
                    redirect = url + '/' + redirect.join('/');
                }
                if (redirect.startsWith('/')) {
                    redirect = url + redirect;
                }
            }
            if (Array.isArray(redirect)) {
                // replace {.+} placeholders with the corresponding values from the defined scope
                let scope = this.data.dataObject;
                switch (action.scope) {
                    case 'state':
                        scope = state;
                        break;
                    case 'data':
                        scope = data;
                        break;
                    case 'storage':
                        scope = null;
                        break;
                }
                redirect = redirect.map(r => {
                    if (/{.+}/.test(r)) {
                        const path = r.slice(1, -1).split('.');
                        return this.getArrayPath.get(scope, path).toString();
                    }
                    else {
                        return r.toString();
                    }
                });
                // replace :key placeholders with corresponding url params
                const urlParams = this.route.snapshot.params;
                for (const key of Object.keys(urlParams)) {
                    if (typeof urlParams[key] !== 'undefined') {
                        const paramRgx = new RegExp(`:${key}`);
                        redirect = redirect.map(r => r.replace(paramRgx, urlParams[key]));
                    }
                }
            }
            else {
                // TODO make it work if the redirect is not an array
            }
            if (!Array.isArray(redirect) && redirect.startsWith('http')) {
                this.document.location.href = redirect;
            }
            else {
                if (Array.isArray(redirect) && redirect[0].startsWith('http')) {
                    this.document.location.href = redirect[0];
                }
                else {
                    if (!Array.isArray(redirect)) {
                        redirect = this.helper.urlToRoute(redirect);
                        if (!Array.isArray(redirect)) {
                            redirect = [redirect];
                        }
                    }
                    this.router.navigate(redirect);
                }
            }
            return EMPTY;
        };
    }
    goBack(state, action) {
        return (data) => {
            const lastUrlStack = this.session.get('lastUrl');
            const lastUrl = lastUrlStack[0];
            if (action.excludeLastUrl &&
                action.excludeLastUrl.some(path => lastUrl.startsWith(path))) {
                this.router.navigate(['']);
            }
            else {
                this.location.back();
            }
            return of(data);
        };
    }
    show(state, action, parentForm) {
        return (data) => {
            // if condition defined
            if (typeof action.condition !== 'undefined') {
                if (!this.evalConditions(state, data, action, parentForm)) {
                    return of(data);
                }
            }
            const pos = action.relativePosition;
            let rect;
            let dialogPosition;
            if (typeof pos !== 'undefined') {
                const triggeredElement = state.target;
                rect = triggeredElement.getBoundingClientRect();
                dialogPosition = {
                    left: pos.offsetLeft && `${rect.left + pos.offsetLeft}px`,
                    top: pos.offsetTop && `${rect.top + pos.offsetTop}px`,
                    right: pos.offsetRight && `${rect.right + pos.offsetRight}px`,
                    bottom: pos.offsetBottom && `${rect.bottom + pos.offsetBottom}px`,
                };
                Object.keys(dialogPosition).forEach(p => {
                    if (!dialogPosition[p]) {
                        delete dialogPosition[p];
                    }
                });
            }
            let dataObject;
            if (typeof this.data.dataObject === 'undefined') {
                dataObject = state;
            }
            else if (typeof this.data.dataObject === 'object'
                && !Array.isArray(this.data.dataObject)) {
                dataObject = { ...this.data.dataObject };
            }
            else if (typeof this.data.dataObject === 'object'
                && Array.isArray(this.data.dataObject)) {
                dataObject = [...this.data.dataObject];
            }
            if (typeof action.scope !== 'undefined') {
                switch (action.scope) {
                    case 'state':
                        dataObject = state;
                        break;
                    case 'data':
                        dataObject = data;
                        break;
                    case 'storage':
                        dataObject = null;
                        break;
                }
            }
            action.data.dataObject = this.getArrayPath.get(dataObject, action.path);
            if (typeof action.dialogResponsive === 'undefined') {
                action.dialogResponsive = true;
            }
            const dir = this.document.body.getAttribute('dir');
            const params = {
                maxWidth: '100vw',
                data: {
                    title: action.dialogTitle || null,
                    items: [action],
                    parentForm,
                    close: action.dialogClose,
                    closeLabel: action.closeLabel,
                    closeIcon: action.closeIcon,
                },
                backdropClass: action.backdropClass,
                closeOnNavigation: action.closeOnNavigation || true,
                width: '80vw',
                disableClose: !!action.disableClose,
                panelClass: action.panelClass,
                position: typeof pos !== 'undefined' && dialogPosition,
                direction: dir
            };
            if (typeof action.dialogWidth !== 'undefined') {
                params.width = action.dialogWidth;
            }
            if (typeof action.panelClass !== 'undefined') {
                params.panelClass = action.panelClass;
            }
            this.alertDialog = this.dialog.open(SlotDialogComponent, params);
            if (action.dialogResponsive) {
                const smallDialogSubscription = this.sizeObserver
                    .pipe(takeUntil(this.destroyed)).subscribe(size => {
                    let width;
                    let height;
                    if (typeof action.dialogWidth !== 'undefined') {
                        width = parseInt(action.dialogWidth || 80, 10);
                    }
                    else {
                        width = 80;
                    }
                    if (size.breakpoints[Breakpoints.XSmall]) {
                        width = 100;
                        height = 100;
                    }
                    else if (size.breakpoints[Breakpoints.Small]) {
                        height = '';
                    }
                    else if (size.breakpoints[Breakpoints.Medium]) {
                        width *= 0.8;
                    }
                    else if (size.breakpoints[Breakpoints.Large]) {
                        width *= 0.6;
                    }
                    else if (size.breakpoints[Breakpoints.XLarge]) {
                        width *= 0.4;
                    }
                    if (height !== '') {
                        height += 'vh';
                    }
                    this.alertDialog.updateSize(width + 'vw', height);
                });
                this.alertDialog.afterClosed().pipe(take$1(1))
                    .subscribe(() => {
                    smallDialogSubscription.unsubscribe();
                    this.session.removeGlobalVar('modal');
                    this.session.removeGlobalVar('modalRef');
                });
            }
            this.session.setGlobalVar('modal', state);
            this.session.setGlobalVar('modalRef', this.alertDialog);
            return of(data);
        };
    }
    catchError(state, action, parentForm) {
        return (data) => {
            if (this.getArrayPath.get(data, action.errorPropPath) !== undefined) {
                this.show(state, action, parentForm)(data);
                return EMPTY;
            }
            else if (this.getArrayPath.get(state, action.errorPropPath) !== undefined) {
                this.show(state, action, parentForm)(data);
                return EMPTY;
            }
            else {
                return of(data);
            }
        };
    }
    showOverlay(state, action, parentForm) {
        return (data) => {
            if (typeof action.condition !== 'undefined') {
                if (!this.evalConditions(state, data, action)) {
                    return of(data);
                }
            }
            // if overlay is already shown
            if (this.overlayService.isOverlayRegistered(action.overlayId)) {
                return of(data);
            }
            if (typeof action.elementToAttach !== 'undefined') {
                state.target = state.target.closest(action.elementToAttach);
            }
            // The default position of the overlay is to the bottom right corner of the target
            const positionStrategy = this.overlay.position()
                .flexibleConnectedTo(state.target)
                .withPositions([{
                    originX: action.originX || 'end',
                    originY: action.originY || 'bottom',
                    overlayX: action.overlayX || 'end',
                    overlayY: action.overlayY || 'top'
                }]);
            // The default scrolling strategy is 'noop'
            const scrollStrategy = this.overlay
                .scrollStrategies[action.scrollStrategy || 'noop']();
            const overlayRef = this.overlay.create({
                hasBackdrop: action.hasBackdrop || false,
                disposeOnNavigation: action.disposeOnNavigation || true,
                positionStrategy,
                scrollStrategy,
                panelClass: action.panelClass,
                backdropClass: action.backdropClass,
                maxWidth: action.maxWidth,
                minWidth: action.minWidth,
                maxHeight: action.maxHeight,
                minHeight: action.minHeight,
                width: action.width
            });
            const portalInjector = Injector.create({
                providers: [{
                        provide: OVERLAY_TOKEN,
                        useValue: {
                            components: action.components,
                            dataObject: this.data.dataObject,
                            path: action.path,
                            parentForm,
                            disableMouseLeave: !!action.disableMouseLeave
                        }
                    }]
            });
            const overlayPortal = new ComponentPortal(OverlayComponent, null, portalInjector);
            const ref = overlayRef.attach(overlayPortal);
            this.overlayService.registerOverlay(action.overlayId, overlayRef);
            // Unsubscribe from events when overlay is detached
            overlayRef.detachments().pipe(take$1(1))
                .subscribe(() => {
                backDropSubscription$.unsubscribe();
                closeOverlaySubscription$.unsubscribe();
                routerSubscription$.unsubscribe();
                this.overlayService.removeOverlay(action.overlayId);
            });
            // Close overlay on backdrop click
            const backDropSubscription$ = overlayRef.backdropClick()
                .pipe(take$1(1))
                .subscribe(() => {
                overlayRef.detach();
            });
            // Close overlay from internal function
            const closeOverlaySubscription$ = ref.instance.closeOverlay
                .pipe(take$1(1))
                .subscribe(() => {
                overlayRef.detach();
            });
            // Close overlay on redirect to new route
            const routerSubscription$ = this.router.events
                .pipe(take$1(1), filter(event => event instanceof NavigationStart))
                .subscribe(() => {
                overlayRef.detach();
            });
            overlayRef.detachments()
                .pipe(take$1(1))
                .subscribe(() => {
                this.doAction({ event: 'overlayDetach' });
            });
            return of(data);
        };
    }
    _callClassListMethod(classList, method, cls) {
        switch (method) {
            case 'toggle':
                classList.toggle(cls);
                break;
            case 'add':
                classList.add(cls);
                break;
            case 'remove':
                classList.remove(cls);
                break;
        }
    }
    // can be used multiple times in the same action,
    // however it cannot be set to subscribable as it
    // uses tap instead of switchMap
    modifyClassList(state, action) {
        return (data) => {
            // Get the target Element that triggered the action
            const actionTarget = state.target;
            const modify = () => {
                if (typeof action.mode === 'undefined') {
                    action.mode = 'toggle';
                }
                for (const i in action.selectors) {
                    if (action.selectors[i]) {
                        let elements;
                        // if scopeClass get the elements, whose class list will be modified, from the scope element
                        // Otherwise search the elements in the entire document
                        if (action.scopeClass) {
                            const scopeElement = actionTarget.closest(action.scopeClass);
                            elements = scopeElement.getElementsByClassName(action.selectors[i]);
                        }
                        else {
                            elements = this.document.getElementsByClassName(action.selectors[i]);
                        }
                        for (const el of Array.from(elements)) {
                            if (Array.isArray(action.class)) {
                                for (const cls of action.class[i].split(' ')) {
                                    this._callClassListMethod(el.classList, action.mode, cls);
                                }
                            }
                            else {
                                for (const cls of action.class.split(' ')) {
                                    this._callClassListMethod(el.classList, action.mode, cls);
                                }
                            }
                        }
                    }
                }
            };
            if (typeof action.condition !== 'undefined') {
                let conditionScope = null;
                switch (action.condition.scope) {
                    case 'state':
                        conditionScope = state;
                        break;
                    case 'data':
                        conditionScope = data;
                        break;
                }
                if (this.evaluator.exec(conditionScope, action.condition)) {
                    modify();
                }
            }
            else {
                modify();
            }
            return of(data);
        };
    }
    _toFlatArray(subject) {
        let result = [];
        for (const key in subject) {
            if (subject[key] !== null) {
                if (typeof subject[key] === 'object') {
                    result = result.concat(this._toFlatArray(subject[key]));
                }
                else {
                    result.push(subject[key]);
                }
            }
        }
        return result;
    }
    _processNestedObjectPaths(obj, data) {
        for (const key in obj) {
            if (typeof obj[key] === 'object') {
                if (typeof obj[key].path !== 'undefined') {
                    let value = this.getArrayPath.get(data, obj[key].path);
                    if (obj[key].flatten) {
                        value = this._toFlatArray(value);
                    }
                    obj[key] = value;
                }
                else {
                    if (Array.isArray(obj[key])) {
                        obj[key] = this.getArrayPath.get(data, obj[key]);
                    }
                    else {
                        this._processNestedObjectPaths(obj[key], data);
                    }
                }
            }
        }
    }
    toUrl(state, action) {
        return (data) => {
            const actionClone = JSON.parse(JSON.stringify(action));
            this._processNestedObjectPaths(actionClone, state);
            this.urlService.toUrl(actionClone);
            return of(data);
        };
    }
    toggleUrlGroup(state, action) {
        return (data) => {
            this.urlService.toUrl(action, 'toggleGroup');
            return of(data);
        };
    }
    showLoading(state, action) {
        return (data) => {
            this.loader.show();
            return of(data);
        };
    }
    hideLoading(state, action) {
        return (data) => {
            this.loader.hide();
            return of(data);
        };
    }
    message(state, message, parentForm) {
        return (data) => {
            function execute(that) {
                let items;
                let scope;
                if (message.iterate) {
                    // Multiple messages will be sent for each item in the
                    // provided in iterate path
                    if (Array.isArray(message.iterate)) {
                        const iteratePath = [...message.iterate];
                        scope = iteratePath.shift();
                        switch (scope) {
                            case 'state':
                                items = that.getArrayPath.get(state, iteratePath);
                                break;
                            case 'data':
                                items = that.getArrayPath.get(data, iteratePath);
                                break;
                        }
                    }
                    else {
                        throw new Error('Iterate must be an Array');
                    }
                }
                if (typeof items === 'undefined') {
                    // Single message will be sent with the prev action data in state.prev
                    state.prev = data;
                    items = [state];
                }
                for (const i in items) {
                    const messageClone = JSON.parse(JSON.stringify(message));
                    messageClone.content.state = JSON.parse(JSON.stringify(items[i], (key, value) => {
                        if (['target', 'control', 'parentForm', 'parentComponent'].indexOf(key) < 0) {
                            return value;
                        }
                        return;
                    }));
                    if (parentForm) {
                        messageClone.content.state.parentForm = parentForm.getRawValue();
                    }
                    that.comm.send(messageClone);
                }
            }
            if (typeof message.condition !== 'undefined') {
                if (this.evalConditions(state, data, message, parentForm)) {
                    execute(this);
                }
            }
            else {
                execute(this);
            }
            return of(data);
        };
    }
    toStorage(state, action) {
        return (data) => {
            if (['session', 'state', 'cache'].indexOf(action.storage) >= 0) {
                function execute(that) {
                    let scope = null;
                    switch (action.scope) {
                        case 'state':
                            scope = state;
                            break;
                        case 'data':
                            scope = data;
                            break;
                    }
                    let key;
                    if (Array.isArray(action.key)) {
                        const keySegments = [];
                        for (const item of action.key) {
                            if (Array.isArray(item)) {
                                keySegments.push(that.getArrayPath.get(that.data.dataObject, item));
                            }
                            else {
                                keySegments.push(item);
                            }
                        }
                        key = keySegments.join('.');
                    }
                    else {
                        key = action.key;
                    }
                    switch (action.mode) {
                        case 'set':
                            if (typeof action.valuePath !== 'undefined') {
                                that[action.storage].set(key, that.getArrayPath.get(scope, action.valuePath));
                            }
                            else if (typeof action.value !== 'undefined') {
                                that[action.storage].set(key, action.value);
                            }
                            break;
                        case 'toggle':
                            const currentIndex = action.value.indexOf(that[action.storage].get(key));
                            // TODO implement valuePath and scope
                            let value = action.value[0];
                            if (currentIndex >= 0) {
                                value = action.value[+!currentIndex];
                            }
                            that[action.storage].set(key, value);
                            break;
                        case 'remove':
                            that[action.storage].remove(key);
                            break;
                        case 'append':
                            const storageArray = that[action.storage].get(key) || [];
                            if (typeof action.maxSize !== 'undefined' && storageArray.length >= action.maxSize) {
                                console.log('Max items in storage array exceeded');
                                return;
                            }
                            if (!Array.isArray(storageArray)) {
                                console.log('Storage item is not an array');
                                return;
                            }
                            let newValue;
                            if (typeof action.valuePath !== 'undefined') {
                                newValue = that.getArrayPath.get(scope, action.valuePath);
                            }
                            else {
                                newValue = action.value;
                            }
                            if (action.unique) {
                                const val = storageArray.findIndex(el => {
                                    return JSON.stringify(el) === JSON.stringify(newValue);
                                });
                                if (val !== -1) {
                                    console.log('Storage items must be unique');
                                    return;
                                }
                            }
                            storageArray.push(newValue);
                            that[action.storage].set(key, storageArray);
                            break;
                        case 'splice':
                            const spliceStorageArray = that[action.storage].get(key) || [];
                            let valueToRemove;
                            if (typeof action.valuePath !== 'undefined') {
                                valueToRemove = that.getArrayPath.get(scope, action.valuePath);
                            }
                            else {
                                valueToRemove = action.value;
                            }
                            let index;
                            spliceStorageArray.forEach((item, idx) => {
                                if (JSON.stringify(item) === JSON.stringify(valueToRemove)) {
                                    index = idx;
                                }
                            });
                            spliceStorageArray.splice(index, 1);
                            that[action.storage].set(key, spliceStorageArray);
                            break;
                    }
                }
                if (typeof action.condition !== 'undefined') {
                    let conditionScope = null;
                    switch (action.condition.scope) {
                        case 'state':
                            conditionScope = state;
                            break;
                        case 'data':
                            conditionScope = data;
                            break;
                        case 'storage':
                            conditionScope = null;
                            break;
                    }
                    const result = this.getArrayPath.get(conditionScope, action.condition.path);
                    if (result instanceof Observable) {
                        const that = this;
                        result.pipe(takeUntil(this.destroyed), map(d => {
                            return this.evaluator.exec(d, action.condition);
                        }), filter((d) => d), tap(() => {
                            execute(that);
                        })).subscribe(() => { });
                    }
                    else if (this.evalConditions(state, data, action)) {
                        execute(this);
                    }
                }
                else {
                    execute(this);
                }
            }
            return of(data);
        };
    }
    // DEPRECATED use modifyFields
    modifyPrices(state, action) {
        return (data) => {
            const form = state.control.parent;
            const items = form.get('items');
            const itemIds = [];
            for (const item of items.controls) {
                if (item.controls.product_id !== ''
                    && item.controls.product_id.value !== '') {
                    itemIds.push(item.controls.product_id.value);
                }
            }
            if (itemIds.length > 0) {
                const params = {
                    with: ['prices.pricelist'],
                    mutations: [
                        {
                            constraint: 'whereIn',
                            params: ['id', itemIds]
                        }
                    ]
                };
                const dataService = this.api.getService('ProductService');
                const prices = {};
                dataService.list(params)
                    .pipe(take$1(1))
                    .subscribe((response) => {
                    response.result.data.forEach((product) => {
                        let price;
                        for (const productPrice of product.prices) {
                            if (productPrice.pricelist.code === state.value) {
                                price = productPrice.value;
                            }
                        }
                        prices[product.id] = price;
                    });
                    let orderTotalAmount = 0;
                    let orderTotalDiscount = 0;
                    for (const item of items.controls) {
                        const priceItem = item.get('sell_price');
                        const idItem = item.get('product_id').value;
                        priceItem.setValue(prices[idItem]);
                        // Total row price
                        const total = priceItem.value * item.get('quantity').value;
                        item.get('total').setValue(total.toFixed(2));
                        // Total discount price
                        const totalDiscount = priceItem.value * item.get('discount_quantity').value;
                        item.get('discount_amount').setValue(totalDiscount.toFixed(2));
                        orderTotalAmount += total;
                        orderTotalDiscount += totalDiscount;
                    }
                    // Set order totals
                    form.get('total_amount').setValue(orderTotalAmount.toFixed(2));
                    form.get('total_discount').setValue(orderTotalDiscount.toFixed(2));
                    const percent = (orderTotalDiscount / orderTotalAmount) * 100;
                    form.get('amount_discount_percent').setValue(percent.toFixed(2));
                });
            }
            return of(data);
        };
    }
    // DEPRECATED user modifyFields
    setRowValues(state, action, parentForm) {
        return (data) => {
            if (!state.control && action.global) {
                state.control = this.session.getGlobalVar(action.global).control;
            }
            if (state.control) {
                const group = state.control.parent;
                Object.keys(action).forEach((key) => {
                    switch (action[key].type) {
                        case 'control':
                            let value;
                            if (action[key].value) {
                                value = action[key].value;
                            }
                            else {
                                value = this.getArrayPath.get(state.dataObject, action[key].valuePath);
                            }
                            group.get(key).setValue(value);
                            break;
                        case 'price':
                            const element = group.get(key);
                            const parentGroup = state.control.parent;
                            const parentArray = parentGroup.parent;
                            const form = parentArray.parent;
                            const relation = form.get(action[key].relation).value;
                            if (typeof state.dataObject !== 'undefined'
                                && typeof relation !== 'undefined'
                                && relation) {
                                element.setValue(state.dataObject.prices[relation][0].value);
                            }
                            break;
                        case 'calculate':
                            let total = 0;
                            let quantity = group.get('quantity').value;
                            if (key === 'discount_amount') {
                                quantity = group.get('discount_quantity').value;
                            }
                            total = group.get('sell_price').value * quantity;
                            group.get(key).setValue(total.toFixed(2));
                            break;
                        case 'calculate_total':
                            const formArray = group.parent;
                            let totalAmount = 0;
                            for (const row of formArray.controls) {
                                totalAmount += Number(row.controls[action[key].field].value);
                            }
                            formArray.parent.get(key).setValue(totalAmount.toFixed(2));
                            break;
                        case 'calculate_discount_percent':
                            const array = group.parent;
                            let percent = 0;
                            const orderTotalAmount = array.parent.get('total_amount').value;
                            const orderTotalDiscount = array.parent.get('total_discount').value;
                            percent = (orderTotalDiscount / orderTotalAmount) * 100;
                            array.parent.get(key).setValue(percent.toFixed(2));
                            break;
                    }
                });
            }
            return of(data);
        };
    }
    // DEPRECATED user modifyFields
    modifyField(state, action) {
        return (data) => {
            const global = this.session.getGlobalVar(action.global); // TODO: should be extracted in seperate object sessionStorage
            if (global.control) {
                // TODO. Should be changed with some path to the form
                const form = global.control.parent;
                const field = form.get(action.field);
                const value = this.getArrayPath.get(state.dataObject, action.valuePath);
                switch (action.fieldType) {
                    case 'autocomplete':
                        const label = this.getArrayPath.get(state.dataObject, action.labelPath);
                        field.setValue({
                            text: label,
                            value
                        });
                        break;
                }
            }
            return of(data);
        };
    }
    // generate all combination of multiple arrays
    cartesian(...args) {
        const r = [];
        const max = args.length - 1;
        function helper(arr, i) {
            for (let j = 0, l = args[i].length; j < l; j++) {
                const a = arr.slice(0); // clone arr
                a.push(args[i][j]);
                if (i === max) {
                    r.push(a);
                }
                else {
                    helper(a, i + 1);
                }
            }
        }
        helper([], 0);
        return r;
    }
    prepDataSourceParams(dataSourceParams, state, parentForm) {
        const params = {};
        for (const param in dataSourceParams) {
            if (typeof dataSourceParams[param] === 'string'
                && dataSourceParams[param].startsWith(':')) {
                // if value is ':any' look for it in state
                const key = dataSourceParams[param].replace(':', '');
                params[param] = state[key];
                // TODO look for it in form???
            }
            else if (Array.isArray(dataSourceParams[param]) && typeof parentForm.dataObject === 'undefined') {
                params[param] = this.getArrayPath.get(state, dataSourceParams[param]);
            }
            else if (Array.isArray(dataSourceParams[param]) && parentForm.dataObject) {
                // TODO It appears this doesn't work as dataSourceParams[param] is an array, but it is used as a key
                params[param] = parentForm.dataObject[dataSourceParams[param]];
            }
            else if (param === 'mutations') {
                const mutations = dataSourceParams[param];
                const newMutations = [];
                for (const mutation in mutations) {
                    if (mutation) {
                        const newMutation = {
                            constraint: mutations[mutation].constraint,
                            params: []
                        };
                        for (const mParam in mutations[mutation].params) {
                            if (typeof mutations[mutation].params[mParam] === 'string'
                                && mutations[mutation].params[mParam].startsWith(':')) {
                                // if value is ':any' look for it in state
                                const key = mutations[mutation].params[mParam].replace(':', '');
                                newMutation.params[mParam] = state[key];
                                // TODO look for param in form???
                            }
                            else if (Array.isArray(mutations[mutation].params[mParam])) {
                                // TODO look for param in the state
                                // if value is an array, split each value by |
                                const splits = [];
                                for (const segment of mutations[mutation].params[mParam]) {
                                    splits.push(segment.split('|'));
                                }
                                // generate all possible combinations of the splits of each segment
                                const controlPaths = this.cartesian(...splits);
                                // extract paths and combine the results
                                const results = [];
                                for (const controlPath of controlPaths) {
                                    results.push(...this.getControlByPath.get(parentForm, controlPath));
                                }
                                newMutation.params[mParam] = results.filter((e) => e);
                            }
                            else {
                                // handle static params
                                newMutation.params[mParam] = mutations[mutation].params[mParam];
                            }
                        }
                        newMutations.push(newMutation);
                    }
                }
                params[param] = newMutations;
            }
            else {
                // handle static params
                params[param] = dataSourceParams[param];
            }
        }
        return params;
    }
    evaluateExpression(expression, precision, scope, singleResult = false) {
        let componentMap = {};
        const components = expression.match(/{[\w/\+-]+}/g);
        if (components) {
            for (const item of components) {
                const matched = item.replace(/[{}]/g, '').split('/');
                switch (matched[0]) {
                    case 'self':
                        // if scope of component is the current row
                        expression = expression.replace('{' + matched.join('/') + '}', parseFloat(scope.self.get(matched[1]).value));
                        break;
                    case 'form':
                        const placeholder = '{' + matched.join('/') + '}';
                        matched.shift();
                        let values;
                        if (matched[matched.length - 1].startsWith('length')) {
                            const last = matched.pop();
                            values = this.getControlByPath.get(scope.form, matched);
                            if (!Array.isArray(values)) {
                                throw new Error(`Control '${matched[matched.length - 1]}' must be FormArray`);
                            }
                            values = last.replace('length', values.length);
                            values = new Function(`return ${values};`).call(this);
                        }
                        else {
                            values = this.getControlByPath.get(scope.form, matched);
                        }
                        componentMap[placeholder] = [];
                        if (Array.isArray(values)) {
                            for (let val of values) {
                                if (isNaN(val) || val === '' || val == null) {
                                    val = 0;
                                }
                                componentMap[placeholder].push(val);
                            }
                        }
                        else {
                            if (isNaN(values) || values === '' || values == null) {
                                values = 0;
                            }
                            componentMap[placeholder].push(values);
                        }
                        break;
                    case 'dataSource':
                        // TODO if scope of component is the data source response
                        expression = expression.replace('{' + matched.join('/') + '}', parseFloat(scope.dataSource[matched[1]]));
                        break;
                    case 'storage':
                        expression = expression.replace('{' + matched.join('/') + '}', parseFloat(this.getArrayPath.get(null, matched)));
                        break;
                }
            }
            let result;
            if (Object.keys(componentMap).length > 0) {
                if (singleResult) {
                    const newComponentMap = {};
                    for (const i in componentMap) {
                        if (i) {
                            newComponentMap[i] = [];
                            newComponentMap[i].push(componentMap[i].reduce((total, val) => parseFloat(total) + parseFloat(val)));
                        }
                    }
                    componentMap = newComponentMap;
                }
                result = [];
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < componentMap[components[0]].length; i++) {
                    let expr = expression;
                    for (const placeholder of components) {
                        if (componentMap[placeholder]) {
                            expr = expr.replace(placeholder, componentMap[placeholder][i]);
                        }
                    }
                    // tslint:disable-next-line: no-eval
                    result.push(parseFloat(new Function('helper', `return ${expr};`)(this.helper))
                        .toFixed(precision));
                }
            }
            else {
                // tslint:disable-next-line: no-eval
                result = parseFloat(new Function('helper', `return ${expression};`)(this.helper))
                    .toFixed(precision);
            }
            return result;
        }
    }
    addRows(state, action, parentForm) {
        return (data) => {
            if (typeof action.dataSource !== 'undefined') {
                const dataService = this.api.getService(action.dataSource.service);
                const params = this.prepDataSourceParams(action.dataSource.params, state, parentForm);
                return dataService[action.dataSource.method](params)
                    .pipe(take$1(1))
                    .pipe(tap((response) => {
                    if (response.result.data.length > 0) {
                        let rowCounter = 0;
                        const groupUid = Date.now();
                        let validation;
                        if (typeof action.conditions !== 'undefined') {
                            const failedConditions = [];
                            for (const condition of action.conditions) {
                                let replaced = JSON.stringify(condition.path);
                                const rootForm = this.parentForm.root;
                                const formValues = rootForm.getRawValue();
                                for (const p in formValues) {
                                    if (typeof formValues[p] !== 'undefined') {
                                        replaced = replaced.replace('{' + p + '}', formValues[p]);
                                    }
                                }
                                if (replaced !== '') {
                                    condition.path = JSON.parse(replaced);
                                }
                                if (!this.evaluator.exec(response.result, condition)) {
                                    failedConditions.push(this.language.getLabel(condition.message));
                                }
                            }
                            if (failedConditions.length > 0) {
                                const config = new MatSnackBarConfig();
                                config.horizontalPosition = 'right';
                                config.verticalPosition = 'top';
                                config.panelClass = ['alert', 'alert-danger'];
                                config.data = {
                                    messages: failedConditions
                                };
                                this.alert.openFromComponent(ToastComponent, config);
                                return of(data);
                            }
                        }
                        if (typeof action.validation !== 'undefined') {
                            validation = this.getArrayPath.get(response.result, action.validation.path);
                        }
                        for (const responseRow of response.result.data) {
                            const firstRow = parentForm.get(action.target.formArray).at(0);
                            if (typeof this.rowTemplate === 'undefined') {
                                this.rowTemplate = firstRow;
                            }
                            let emptyControls = 0;
                            // count how many controls have empty value
                            for (const control in firstRow.controls) {
                                if (!firstRow.controls[control].value
                                    || firstRow.controls[control].value === '0.00'
                                    || firstRow.controls[control].value === '0') {
                                    emptyControls++;
                                }
                            }
                            if (emptyControls === Object.keys(firstRow.controls).length) {
                                // if all first row controls have empty value, remove it
                                parentForm.get(action.target.formArray).removeAt(0);
                            }
                            const newRow = this.cloner.clone(this.rowTemplate);
                            // if adding more than one row add them each a group unique identifier
                            newRow.groupUid = groupUid;
                            if (rowCounter === 0) {
                                newRow.startGroupClass = 'groupStart';
                            }
                            newRow.reset();
                            for (const control in action.target.map) {
                                if (newRow.get(control)) {
                                    let value;
                                    const definition = action.target.map[control];
                                    if (Array.isArray(definition)) {
                                        // if this control is directly mapped to response property, get it
                                        value = this.getArrayPath.get(responseRow, definition);
                                    }
                                    else {
                                        if (typeof definition.path !== 'undefined') {
                                            // if this control is directly mapped to a response property, but
                                            // it contains a map of values that vary by other control's value
                                            // get the map
                                            const valueList = this.getArrayPath.get(responseRow, definition.path);
                                            // get the value of the other control and extract the proper value
                                            if (typeof definition.variesByControl !== 'undefined') {
                                                const variesByValue = parentForm.get(definition.variesByControl).value;
                                                if (typeof variesByValue === 'object') {
                                                    value = valueList[variesByValue.value];
                                                }
                                                else if (variesByValue) {
                                                    value = valueList[variesByValue];
                                                }
                                                else {
                                                    value = definition.default;
                                                }
                                            }
                                        }
                                        if (typeof definition.expression !== 'undefined') {
                                            // if the control value is a math expression
                                            // extract it's components
                                            value = this.evaluateExpression(definition.expression, definition.precision, {
                                                self: newRow,
                                                form: parentForm,
                                                dataSource: response.result.data
                                            });
                                        }
                                    }
                                    newRow
                                        .get(control)
                                        .setValue(value);
                                }
                            }
                            if (typeof validation !== 'undefined') {
                                for (const validator of validation) {
                                    const item = newRow.get(action.validation.map.items).value;
                                    for (let property of validator.change) {
                                        if (validator.items.indexOf(item) >= 0) {
                                            if (typeof action.validation.map[property] !== 'undefined') {
                                                property = action.validation.map[property];
                                            }
                                            newRow.get(property).enable({ onlySelf: true });
                                        }
                                    }
                                    for (const property in validator.check) {
                                        if (validator.items.indexOf(item) >= 0) {
                                            let mappedProperty;
                                            if (typeof action.validation.map[property] !== 'undefined') {
                                                mappedProperty = action.validation.map[property];
                                            }
                                            else {
                                                mappedProperty = property;
                                            }
                                            const validationFilter = {
                                                controlName: action.validation.map.items,
                                                controlValues: validator.items,
                                            };
                                            newRow.get(mappedProperty).addValidators([
                                                CustomValidators['formArray' + validator.rule](mappedProperty, validator.check[property], validationFilter, validator.deviation)
                                            ]);
                                        }
                                    }
                                }
                            }
                            parentForm
                                .get(action.target.formArray)
                                .push(newRow);
                            rowCounter++;
                        }
                    }
                    parentForm.get(this.data.name).reset();
                }));
            }
            else {
                const parentFormParent = parentForm.parent;
                let newRow;
                if (action.duplicate) {
                    const rows = parentFormParent.controls;
                    const prevRowIndex = rows.indexOf(state.control.parent);
                    newRow = this.cloner.clone(parentFormParent.controls[prevRowIndex], true);
                    parentFormParent.insert(prevRowIndex + 1, newRow);
                }
                else {
                    let prevRow;
                    if (action.prepend) {
                        prevRow = parentFormParent.at(0);
                    }
                    else {
                        prevRow = parentFormParent.at(parentFormParent.length - 1);
                    }
                    let emptyControls = 0;
                    // count how many controls have empty value
                    for (const control in prevRow.controls) {
                        if (!prevRow.controls[control].value
                            || prevRow.controls[control].value === '0.00'
                            || prevRow.controls[control].value === '0') {
                            emptyControls++;
                        }
                    }
                    if (emptyControls === Object.keys(prevRow.controls).length) {
                        // if all last row controls have empty value, don't add new row
                        return of(data);
                    }
                    if (typeof this.rowTemplate === 'undefined') {
                        this.rowTemplate = prevRow;
                    }
                    newRow = this.cloner.clone(this.rowTemplate);
                    newRow.reset();
                    for (let i = 0; i < action.count; i++) {
                        parentFormParent.controls.map((item) => {
                            const addControl = item.get('add');
                            let channelName;
                            if (addControl.def?.control?.data.channel) {
                                channelName = addControl.def.control.data.channel;
                            }
                            if (addControl.def?.channel) {
                                channelName = addControl.def.channel;
                            }
                            if (channelName) {
                                this.comm.resetChannels(new Set([channelName]));
                            }
                            addControl.disable();
                        });
                        if (action.prepend) {
                            parentFormParent.insert(0, newRow);
                        }
                        else {
                            parentFormParent.push(newRow);
                        }
                    }
                }
                const removeControl = newRow.get('remove');
                if (removeControl) {
                    if (typeof action.removable !== 'undefined' && !action.removable) {
                        removeControl.disable();
                    }
                    else {
                        removeControl.enable();
                    }
                }
                parentForm.root.markAllAsTouched();
                return of(data);
            }
        };
    }
    prepSourcePath(path, form, state) {
        const newPath = JSON.parse(JSON.stringify(path));
        for (const segment in newPath) {
            if (typeof newPath[segment] === 'string'
                && newPath[segment].startsWith(':')) {
                // if value is ':any' look for it in state
                const key = newPath[segment].replace(':', '');
                newPath[segment] = state[key];
            }
        }
        const result = [];
        for (const segment in newPath) {
            if (Array.isArray(newPath[segment])) {
                // if path segment is another path
                // get its value
                let segmentValue = this.getControlByPath.get(form, newPath[segment]);
                if (segmentValue == null) {
                    segmentValue = this.getArrayPath.get(form.dataObject, newPath[segment]);
                }
                if (Array.isArray(segmentValue)) {
                    // if multiple path with each value replacing the segment
                    for (const value of segmentValue) {
                        const resultPath = JSON.parse(JSON.stringify(newPath));
                        resultPath[segment] = value;
                        result.push(resultPath);
                    }
                }
                else {
                    // if single value return path with the segment
                    // replaced by the value
                    const resultPath = JSON.parse(JSON.stringify(newPath));
                    resultPath[segment] = segmentValue;
                    result.push(resultPath);
                }
                break;
            }
        }
        if (result.length > 0) {
            return result;
        }
        return [path];
    }
    modifyDataSourceIndependantField(state, map, parentForm, data) {
        let target;
        switch (map.type) {
            case 'calculate':
                target = this.getControlByPath.get(parentForm, map.target, false);
                const value = this.evaluateExpression(map.expression, map.precision, {
                    form: parentForm,
                    dataSource: state.dataObject
                }, (target instanceof AbstractControl));
                if (Array.isArray(value)) {
                    if (target instanceof AbstractControl) {
                        target.setValue(+value[0]);
                    }
                    else {
                        for (const i in target) {
                            if (value.length > 1) {
                                target[i].setValue(+value[i]);
                            }
                            else {
                                target[i].setValue(+value[0]);
                            }
                        }
                    }
                }
                else {
                    target.setValue(+value);
                }
                break;
            case 'set':
                target = this.getControlByPath.get(parentForm, map.target, false);
                if (typeof map.value !== 'undefined') {
                    target.setValue(map.value);
                }
                else if (typeof map.path === 'undefined' && state.value) {
                    target.setValue(state.value);
                }
                else {
                    let input = state.dataObject;
                    if (map.scope) {
                        switch (map.scope) {
                            case 'state':
                                input = state;
                                break;
                            case 'data':
                                input = data;
                                break;
                        }
                    }
                    let newValue = this.getArrayPath.get(input, map.path);
                    const text = map.textPath ?
                        this.getArrayPath.get(input, map.textPath)
                        : newValue;
                    if (map.autoComplete) {
                        target.setValue({
                            text,
                            value: newValue
                        });
                    }
                    else {
                        if (newValue
                            && typeof (newValue) === 'string'
                            && (target.def?.inputType === 'number'
                                || (target.def?.type === 'action'
                                    && target.def?.control?.data?.inputType === 'number'))) {
                            newValue = Number(newValue.replace(/\s/g, ''));
                        }
                        target.setValue(newValue);
                    }
                }
                break;
        }
    }
    modifyFields(state, action, parentForm) {
        return (data) => {
            if (typeof action.condition !== 'undefined') {
                if (!this.evalConditions(state, data, action, parentForm)) {
                    return of(data);
                }
            }
            if (!parentForm) {
                parentForm = state.parentForm;
            }
            if (typeof action.dataSource !== 'undefined') {
                const dataService = this.api.getService(action.dataSource.service);
                const params = this.prepDataSourceParams(action.dataSource.params, state, parentForm);
                return dataService[action.dataSource.method](params)
                    .pipe(take$1(1))
                    .pipe(tap((response) => {
                    for (const map of action.map) {
                        if (map.type === 'setFromDataSource') {
                            const source = this.prepSourcePath(map.source, parentForm, state);
                            const target = this.getControlByPath.get(parentForm, map.target, false);
                            if (Array.isArray(source)) {
                                // if we have multiple sources (like when source is located in FormArray)
                                // loop through them and set each value
                                // IMPORTANT: target must also select the same
                                // FormArray the source is based on
                                // tslint:disable-next-line: forin
                                for (const i in source) {
                                    const value = this.getArrayPath.get(response.result.data, source[i]);
                                    if (typeof value !== 'undefined') {
                                        if (Array.isArray(value)) {
                                            target[i].setValue(value[0]);
                                        }
                                        else {
                                            target.setValue(value);
                                        }
                                    }
                                }
                            }
                        }
                        this.modifyDataSourceIndependantField(state, map, parentForm, data);
                    }
                }));
            }
            else {
                for (const map of action.map) {
                    this.modifyDataSourceIndependantField(state, map, parentForm, data);
                }
                return of(data);
            }
        };
    }
    copyToClipboard(state, action, parentForm) {
        return (data) => {
            let textToCopy;
            let scope = state;
            if (action.scope) {
                switch (action.scope) {
                    case 'parentForm':
                        scope = parentForm;
                        break;
                    case 'data':
                        scope = data;
                        break;
                }
            }
            if (scope === 'parentForm') {
                const target = this.getControlByPath.get(parentForm, action.target, false);
                textToCopy = target.getRawValue();
            }
            else {
                textToCopy = this.getArrayPath.get(scope, action.path);
            }
            if (typeof action.condition !== 'undefined') {
                if (this.evalConditions(state, data, action, parentForm)) {
                    this.clipboard.copy(textToCopy);
                }
            }
            else {
                this.clipboard.copy(textToCopy);
            }
            console.log(textToCopy);
            return of(data);
        };
    }
    removeRow(state, action, parentForm) {
        return (data) => {
            const formGroup = state.control.parent;
            const formArray = formGroup.parent;
            const rowsToRemove = [];
            if (typeof this.rowTemplate === 'undefined') {
                const firstRow = formArray.at(0);
                this.rowTemplate = firstRow;
            }
            for (const idx in formArray.controls) {
                if (typeof formGroup.groupUid === 'undefined') {
                    if (formArray.controls[idx] === formGroup) {
                        rowsToRemove.push(idx);
                    }
                }
                else {
                    if (formArray.controls[idx].groupUid === formGroup.groupUid) {
                        rowsToRemove.push(idx);
                    }
                }
            }
            for (const idx of rowsToRemove.reverse()) {
                formArray.removeAt(idx);
            }
            if (formArray.controls.length === 0) {
                const newEmptyRow = this.cloner.clone(this.rowTemplate);
                // tslint:disable-next-line: forin
                newEmptyRow.reset();
                formArray.push(newEmptyRow);
            }
            let addControl;
            if (action.reverse) {
                addControl = formArray.controls[0].get('add');
            }
            else {
                addControl = formArray.controls[formArray.controls.length - 1].get('add');
            }
            if (addControl) {
                addControl.enable();
            }
            return of(data);
        };
    }
    validate(state, action, parentForm) {
        return (data) => {
            const target = this.getControlByPath.get(parentForm, action.target, false);
            target.markAsTouched();
            return of(data);
        };
    }
    closeModal(state, action) {
        return (data) => {
            const dialogRef = this.session.getGlobalVar('modalRef');
            const observable = dialogRef.afterClosed().pipe(switchMap$1(() => of(data)));
            dialogRef.close();
            return observable;
        };
    }
    closeOverlay(state, action) {
        return (data) => {
            const ref = this.overlayService.getOverlayRef(action.overlayId);
            const observable = ref?.detachments().pipe(switchMap$1(() => of(data)));
            if (observable) {
                ref.detach();
                return observable;
            }
            else {
                return of(null);
            }
        };
    }
    enableFields(state, action, parentForm) {
        return of([])
            .pipe(switchMap$1(() => {
            for (const controlPath of action.fields) {
                const control = this.getControlByPath.get(parentForm, controlPath, false);
                if (Array.isArray(control)) {
                    for (const c of control) {
                        c.enable();
                    }
                }
                else {
                    control.enable();
                }
            }
            return of([]);
        }));
    }
    scrollIntoView(state, action) {
        return (data) => {
            setTimeout(() => {
                const scrollableContainer = this.document.querySelector(`.${action.scopeClass}`);
                let lastChild;
                if (typeof action.path !== 'undefined') {
                    lastChild = document.getElementById(this.getArrayPath.get(state, action.path));
                }
                else {
                    const children = scrollableContainer.querySelectorAll(`.${action.lastElement}`);
                    lastChild = children.item(children.length - 1);
                }
                lastChild.scrollIntoView({
                    behavior: action.behavior || 'smooth',
                    block: action.block || 'start',
                    inline: action.inline || 'nearest'
                });
            }, 0);
            return of(data);
        };
    }
    reloadApp(state, action) {
        return (data) => {
            if (typeof action.url !== 'undefined') {
                window.location.href = action.url;
            }
            else {
                window.location.reload();
            }
            return EMPTY;
        };
    }
    // TODO decide if we should make separate action component for
    // each different component or group them some how
    // tree list actions
    addNode(state, action) {
        return (data) => {
            if (typeof this.parentComponent !== 'undefined') {
                let parent = this.parentComponent;
                // find the nearest parent that has removeNode method
                while (typeof parent !== 'undefined'
                    && typeof parent.addNode === 'undefined') {
                    parent = parent.parentComponent;
                }
                parent.addNode(this.data.node, action.propsToKeep, action.addChild);
            }
            return of(data);
        };
    }
    removeNode(state, action) {
        return (data) => {
            if (typeof this.parentComponent !== 'undefined') {
                let parent = this.parentComponent;
                // find the nearest parent that has removeNode method
                while (typeof parent !== 'undefined'
                    && typeof parent.removeNode === 'undefined') {
                    parent = parent.parentComponent;
                }
                parent.removeNode(this.data.node);
            }
            return of(data);
        };
    }
    // Remove extracted rows in grid list component
    removeGridExtractedRow(state, action) {
        return (data) => {
            if (typeof this.parentComponent !== 'undefined') {
                this.parentComponent.removeExtractedRow(this.data.dataObject, action.path);
            }
            return of(data);
        };
    }
    removeFromStorageArray(state, action) {
        return (data) => {
            function execute(that) {
                let scope;
                switch (action.scope) {
                    case 'state':
                        scope = state;
                        break;
                    case 'data':
                        scope = data;
                        break;
                }
                let storageArray = that.state.get(action.key);
                const removeId = that.getArrayPath.get(scope, action.removeIdPath);
                storageArray = storageArray.filter(item => {
                    if (typeof item === 'object') {
                        return item[action.removeIdPath[action.removeIdPath.length - 1]] !== removeId;
                    }
                    else {
                        return item !== removeId;
                    }
                });
                that.state.set(action.key, storageArray);
            }
            if (typeof action.condition !== 'undefined') {
                if (this.evalConditions(state, data, action)) {
                    execute(this);
                }
            }
            else {
                execute(this);
            }
            return of(data);
        };
    }
    removeExpansionPanel(state, action) {
        return (data) => {
            if (typeof this.parentComponent !== 'undefined') {
                let parent = this.parentComponent;
                // find the nearest parent that has removePanel method
                while (typeof parent !== 'undefined'
                    && typeof parent.removePanel === 'undefined') {
                    parent = parent.parentComponent;
                }
                parent.removePanel(state.dataObject);
            }
            return of(data);
        };
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.breakpointObserver.ngOnDestroy();
    }
}
ActionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionComponent, deps: [{ token: DOCUMENT }, { token: ApiService }, { token: LibrariesService }, { token: i3$3.MatDialog }, { token: i4$2.Overlay }, { token: i1$2.MatSnackBar }, { token: CloneAbstractControlService }, { token: GetArrayPathService }, { token: GetControlByPathService }, { token: SessionService }, { token: StateService }, { token: i6$2.BreakpointObserver }, { token: EvalService }, { token: LanguageService }, { token: UrlService }, { token: CommunicationService }, { token: i1.Router }, { token: OverlayService }, { token: i1.ActivatedRoute }, { token: i3.Location }, { token: HelperService }, { token: CacheService }, { token: LoaderService }, { token: i22.Clipboard }], target: i0.ɵɵFactoryTarget.Component });
ActionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ActionComponent, selector: "app-action", inputs: { data: "data", parentForm: "parentForm", parentComponent: "parentComponent", triggerChange: "triggerChange" }, ngImport: i0, template: "<app-slot\r\n  *ngIf=\"data.control\"\r\n  [items]=\"[data.control]\"\r\n  [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n  [parentForm]='parentForm'\r\n  [parentComponent]=\"parentComponent\"\r\n></app-slot>\r\n<span\r\n  *ngIf=\"!data.control\"\r\n  (click)=\"data.events.click && doAction({ event: 'click' })\"\r\n  (mouseover)=\"data.events.mouseover && doAction({ event: 'mouseover' })\"\r\n>\r\n  {{ data.dataObject | getArrayPath: data.path }}\r\n</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ActionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-action', template: "<app-slot\r\n  *ngIf=\"data.control\"\r\n  [items]=\"[data.control]\"\r\n  [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n  [parentForm]='parentForm'\r\n  [parentComponent]=\"parentComponent\"\r\n></app-slot>\r\n<span\r\n  *ngIf=\"!data.control\"\r\n  (click)=\"data.events.click && doAction({ event: 'click' })\"\r\n  (mouseover)=\"data.events.mouseover && doAction({ event: 'mouseover' })\"\r\n>\r\n  {{ data.dataObject | getArrayPath: data.path }}\r\n</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: ApiService }, { type: LibrariesService }, { type: i3$3.MatDialog }, { type: i4$2.Overlay }, { type: i1$2.MatSnackBar }, { type: CloneAbstractControlService }, { type: GetArrayPathService }, { type: GetControlByPathService }, { type: SessionService }, { type: StateService }, { type: i6$2.BreakpointObserver }, { type: EvalService }, { type: LanguageService }, { type: UrlService }, { type: CommunicationService }, { type: i1.Router }, { type: OverlayService }, { type: i1.ActivatedRoute }, { type: i3.Location }, { type: HelperService }, { type: CacheService }, { type: LoaderService }, { type: i22.Clipboard }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }], triggerChange: [{
                type: Input
            }] } });

class ChartPieComponent {
    constructor(language, getArrayPath, comm) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.comm = comm;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (typeof this.data.bars !== 'undefined') {
            const barsArray = [];
            // tslint:disable-next-line: forin
            for (const name in this.data.bars) {
                const value = this.getArrayPath.transform(this.data.value, this.data.bars[name]);
                barsArray.push({
                    name: this.language.getLabel(name),
                    value
                });
            }
            this.data.value = barsArray;
            if (this.data.mainBar) {
                const mainBarValue = this.data.value.filter(value => value.name === this.language.getLabel(this.data.mainBar));
                const otherBarValues = this.data.value.filter(value => value.name !== this.language.getLabel(this.data.mainBar));
                for (const object of otherBarValues) {
                    mainBarValue[0].value -= object.value;
                }
            }
        }
    }
    onSelect(event) {
    }
}
ChartPieComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartPieComponent, deps: [{ token: LanguageService }, { token: GetArrayPathPipe }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
ChartPieComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ChartPieComponent, selector: "app-pie", inputs: { data: "data" }, providers: [GetArrayPathPipe], ngImport: i0, template: "<div class=\"pieChart\">\r\n  <ngx-charts-pie-chart\r\n    [view]=\"data.view\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [results]=\"data.value\"\r\n    [legend]=\"data.showLegend\"\r\n    [legendTitle]=\"data.legendTitle\"\r\n    [explodeSlices]=\"data.explodeSlices\"\r\n    [labels]=\"data.showLabels\"\r\n    [legendPosition]=\"data.legendPosition\"\r\n    [doughnut]=\"data.doughnut\"\r\n    [gradient]=\"data.gradient\"\r\n    (select)=\"onSelect($event)\"\r\n  >\r\n  </ngx-charts-pie-chart>\r\n</div>\r\n", styles: [".pieChart{display:flex;justify-content:center;padding:15px}\n"], dependencies: [{ kind: "component", type: i2$1.PieChartComponent, selector: "ngx-charts-pie-chart", inputs: ["labels", "legend", "legendTitle", "legendPosition", "explodeSlices", "doughnut", "arcWidth", "gradient", "activeEntries", "tooltipDisabled", "labelFormatting", "trimLabels", "maxLabelLength", "tooltipText", "margins"], outputs: ["dblclick", "select", "activate", "deactivate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartPieComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-pie', providers: [GetArrayPathPipe], template: "<div class=\"pieChart\">\r\n  <ngx-charts-pie-chart\r\n    [view]=\"data.view\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [results]=\"data.value\"\r\n    [legend]=\"data.showLegend\"\r\n    [legendTitle]=\"data.legendTitle\"\r\n    [explodeSlices]=\"data.explodeSlices\"\r\n    [labels]=\"data.showLabels\"\r\n    [legendPosition]=\"data.legendPosition\"\r\n    [doughnut]=\"data.doughnut\"\r\n    [gradient]=\"data.gradient\"\r\n    (select)=\"onSelect($event)\"\r\n  >\r\n  </ngx-charts-pie-chart>\r\n</div>\r\n", styles: [".pieChart{display:flex;justify-content:center;padding:15px}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathPipe }, { type: CommunicationService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class DropzoneImagePreviewComponent extends NgxDropzonePreviewComponent {
    constructor(sanitizer) {
        super(sanitizer);
    }
    ngOnInit() {
        this.renderImage();
    }
    renderImage() {
        this.readFile()
            .then((img) => setTimeout(() => {
            return this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(img);
        }))
            .catch(err => console.error(err));
    }
}
DropzoneImagePreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DropzoneImagePreviewComponent, deps: [{ token: i3$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
DropzoneImagePreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: DropzoneImagePreviewComponent, selector: "app-dropzone-image-preview", providers: [
        {
            provide: NgxDropzonePreviewComponent,
            useExisting: DropzoneImagePreviewComponent
        }
    ], usesInheritance: true, ngImport: i0, template: "<img [src]=\"imageSrc\" />\r\n<ng-content select=\"ngx-dropzone-label\"></ng-content>\r\n<ngx-dropzone-remove-badge *ngIf=\"removable\" (click)=\"_remove($event)\">\r\n</ngx-dropzone-remove-badge>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$3.NgxDropzoneRemoveBadgeComponent, selector: "ngx-dropzone-remove-badge" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DropzoneImagePreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-dropzone-image-preview', providers: [
                        {
                            provide: NgxDropzonePreviewComponent,
                            useExisting: DropzoneImagePreviewComponent
                        }
                    ], template: "<img [src]=\"imageSrc\" />\r\n<ng-content select=\"ngx-dropzone-label\"></ng-content>\r\n<ngx-dropzone-remove-badge *ngIf=\"removable\" (click)=\"_remove($event)\">\r\n</ngx-dropzone-remove-badge>\r\n" }]
        }], ctorParameters: function () { return [{ type: i3$1.DomSanitizer }]; } });

class DropzoneComponent {
    constructor(language, comm) {
        this.language = language;
        this.comm = comm;
        this.files = [];
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
    }
    onSelect(event) {
        if (this.data.multiple) {
            this.files.push(...event.addedFiles);
            this.data.value = [];
        }
        else {
            this.files = event.addedFiles;
        }
        let processed = event.addedFiles.length;
        if (this.data.multiple) {
            this.data.value = [];
        }
        if (typeof this.data.change === 'function') {
            this.data.changeParams = {
                event: 'change',
                value: undefined
            };
            for (const file of event.addedFiles) {
                this.getOrientation(file, (orientation) => {
                    this.readFile(file).then(fileContents => {
                        if (typeof this.data.changeParams.value === 'undefined' && this.data.multiple) {
                            this.data.changeParams.value = [];
                        }
                        if (Array.isArray(this.data.value)
                            && Array.isArray(this.data.changeParams.value)) {
                            this.data.value.push({
                                filename: file.name,
                                content: fileContents,
                                orientation
                            });
                            this.data.changeParams.value.push({
                                filename: file.name,
                                content: fileContents,
                                orientation
                            });
                        }
                        else {
                            this.data.value = {
                                filename: file.name,
                                content: fileContents,
                                orientation
                            };
                            this.data.changeParams.value = {
                                filename: file.name,
                                content: fileContents,
                                orientation
                            };
                        }
                        processed--;
                    }).then(() => {
                        if (processed === 0) {
                            if (this.parentForm) {
                                this.parentForm.get(this.data.name).setValue(this.data.value);
                            }
                            if (typeof this.data.change === 'function') {
                                const result = this.data.change(this.data.changeParams);
                                if (result instanceof Observable) {
                                    result.pipe(take(1))
                                        .subscribe((response) => {
                                        if (typeof response.result === 'undefined') {
                                            this.files = [];
                                        }
                                        else {
                                            // tslint:disable-next-line: forin
                                            for (const i in response.result.uploaded) {
                                                const uploadedFile = this.files.filter((item) => {
                                                    return item.name === i && typeof item.remoteFilename === 'undefined';
                                                });
                                                uploadedFile[0].remoteFilename = response.result.uploaded[i].filename;
                                                uploadedFile[0].link = response.result.uploaded[i].url;
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    });
                });
            }
        }
        else if (this.parentForm instanceof UntypedFormGroup) {
            for (const file of event.addedFiles) {
                this.getOrientation(file, (orientation) => {
                    this.readFile(file).then(fileContents => {
                        if (Array.isArray(this.data.value)) {
                            this.data.value.push({
                                filename: file.name,
                                content: fileContents,
                                orientation
                            });
                        }
                        else {
                            this.data.value = {
                                filename: file.name,
                                content: fileContents,
                                orientation
                            };
                        }
                        processed--;
                    }).then(() => {
                        if (processed === 0) {
                            this.parentForm.get(this.data.name).setValue(this.data.value);
                        }
                    });
                });
            }
        }
    }
    onRemove(event) {
        this.files.splice(this.files.indexOf(event), 1);
    }
    click(event, file) {
        event.stopPropagation();
        window.open(file.link, '_blank');
    }
    async readFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = e => {
                return resolve(e.target.result);
            };
            reader.onerror = e => {
                console.error(`FileReader failed on file ${file.name}.`);
                return reject(null);
            };
            if (!file) {
                console.error('No file to read.');
                return reject(null);
            }
            reader.readAsDataURL(file);
        });
    }
    getOrientation(file, callback) {
        var reader = new FileReader();
        reader.onload = (event) => {
            if (!event.target) {
                return;
            }
            const file = event.target;
            const view = new DataView(file.result);
            if (view.getUint16(0, false) != 0xFFD8) {
                return callback(-2);
            }
            const length = view.byteLength;
            let offset = 2;
            while (offset < length) {
                if (view.getUint16(offset + 2, false) <= 8)
                    return callback(-1);
                let marker = view.getUint16(offset, false);
                offset += 2;
                if (marker == 0xFFE1) {
                    if (view.getUint32(offset += 2, false) != 0x45786966) {
                        return callback(-1);
                    }
                    let little = view.getUint16(offset += 6, false) == 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    let tags = view.getUint16(offset, little);
                    offset += 2;
                    for (let i = 0; i < tags; i++) {
                        if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                            return callback(view.getUint16(offset + (i * 12) + 8, little));
                        }
                    }
                }
                else if ((marker & 0xFF00) != 0xFF00) {
                    break;
                }
                else {
                    offset += view.getUint16(offset, false);
                }
            }
            return callback(-1);
        };
        reader.readAsArrayBuffer(file);
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
DropzoneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DropzoneComponent, deps: [{ token: LanguageService }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
DropzoneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: DropzoneComponent, selector: "app-dropzone", inputs: { data: "data", parentForm: "parentForm" }, ngImport: i0, template: "<ngx-dropzone\r\n  (change)=\"onSelect($event)\"\r\n  [multiple]=\"data.multiple\"\r\n  [expandable]=\"data.expandable\"\r\n  [accept]=\"data.accept || '*'\"\r\n  [class]=\"data.class\"\r\n  [ngClass]=\"{'single': !data.multiple}\"\r\n>\r\n  <ngx-dropzone-label>{{ language.getLabel(data.label) }}</ngx-dropzone-label>\r\n  <ng-container *ngIf=\"!data.imagePreview\">\r\n    <ngx-dropzone-preview\r\n      *ngFor=\"let f of files\"\r\n      [removable]=\"data.removable\"\r\n      (removed)=\"onRemove(f)\"\r\n    >\r\n      <ngx-dropzone-label (click)=\"click($event, f)\">{{\r\n        f.name\r\n      }}</ngx-dropzone-label>\r\n    </ngx-dropzone-preview>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.imagePreview\">\r\n    <app-dropzone-image-preview\r\n      ngProjectAs=\"app-dropzone-preview\"\r\n      *ngFor=\"let f of files\"\r\n      [file]=\"f\"\r\n      [removable]=\"data.removable\"\r\n      (removed)=\"onRemove(f)\"\r\n    >\r\n    </app-dropzone-image-preview>\r\n  </ng-container>\r\n</ngx-dropzone>\r\n", styles: ["ngx-dropzone{min-height:60px}ngx-dropzone.expandable{min-height:60px}ngx-dropzone.expandable.single ngx-dropzone-image-preview{height:auto!important}ngx-dropzone.expandable.single ngx-dropzone-image-preview ::ng-deep img{max-width:100%}ngx-dropzone ngx-dropzone-preview{min-height:45px!important;height:calc(100% - 20px)!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$3.NgxDropzoneComponent, selector: "ngx-dropzone, [ngx-dropzone]", inputs: ["accept", "disabled", "multiple", "maxFileSize", "expandable", "disableClick", "processDirectoryDrop", "id", "aria-label", "aria-labelledby", "aria-describedby"], outputs: ["change"] }, { kind: "directive", type: i4$3.NgxDropzoneLabelDirective, selector: "ngx-dropzone-label" }, { kind: "component", type: i4$3.NgxDropzonePreviewComponent, selector: "ngx-dropzone-preview", inputs: ["file", "removable"], outputs: ["removed"] }, { kind: "component", type: DropzoneImagePreviewComponent, selector: "app-dropzone-image-preview" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DropzoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-dropzone', template: "<ngx-dropzone\r\n  (change)=\"onSelect($event)\"\r\n  [multiple]=\"data.multiple\"\r\n  [expandable]=\"data.expandable\"\r\n  [accept]=\"data.accept || '*'\"\r\n  [class]=\"data.class\"\r\n  [ngClass]=\"{'single': !data.multiple}\"\r\n>\r\n  <ngx-dropzone-label>{{ language.getLabel(data.label) }}</ngx-dropzone-label>\r\n  <ng-container *ngIf=\"!data.imagePreview\">\r\n    <ngx-dropzone-preview\r\n      *ngFor=\"let f of files\"\r\n      [removable]=\"data.removable\"\r\n      (removed)=\"onRemove(f)\"\r\n    >\r\n      <ngx-dropzone-label (click)=\"click($event, f)\">{{\r\n        f.name\r\n      }}</ngx-dropzone-label>\r\n    </ngx-dropzone-preview>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.imagePreview\">\r\n    <app-dropzone-image-preview\r\n      ngProjectAs=\"app-dropzone-preview\"\r\n      *ngFor=\"let f of files\"\r\n      [file]=\"f\"\r\n      [removable]=\"data.removable\"\r\n      (removed)=\"onRemove(f)\"\r\n    >\r\n    </app-dropzone-image-preview>\r\n  </ng-container>\r\n</ngx-dropzone>\r\n", styles: ["ngx-dropzone{min-height:60px}ngx-dropzone.expandable{min-height:60px}ngx-dropzone.expandable.single ngx-dropzone-image-preview{height:auto!important}ngx-dropzone.expandable.single ngx-dropzone-image-preview ::ng-deep img{max-width:100%}ngx-dropzone ngx-dropzone-preview{min-height:45px!important;height:calc(100% - 20px)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: CommunicationService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class HtmlComponent {
    constructor(comm, sanitizer) {
        this.comm = comm;
        this.sanitizer = sanitizer;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.init();
    }
    init() {
        this.rawHTML = '';
        if (typeof this.data.dataObject !== 'undefined' && this.data.dataObject !== null) {
            this.rawHTML = this.sanitizer.bypassSecurityTrustHtml(this.data.dataObject);
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
HtmlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HtmlComponent, deps: [{ token: CommunicationService }, { token: i3$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
HtmlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: HtmlComponent, selector: "app-html", inputs: { data: "data" }, ngImport: i0, template: "<ng-container>\r\n  <div\r\n    [class]=\"data.class\"\r\n    [innerHTML]=\"rawHTML\"\r\n  ></div>\r\n</ng-container>\r\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HtmlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-html', template: "<ng-container>\r\n  <div\r\n    [class]=\"data.class\"\r\n    [innerHTML]=\"rawHTML\"\r\n  ></div>\r\n</ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: CommunicationService }, { type: i3$1.DomSanitizer }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ChartBarHorizontalStackedComponent {
    constructor(language, getArrayPath, transformService) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.transformService = transformService;
        this.data = {};
    }
    ngOnInit() {
        if (typeof this.data.bars !== 'undefined') {
            const bars = [];
            for (const bName in this.data.bars) {
                const series = [];
                // tslint:disable-next-line: forin
                for (const sName in this.data.bars[bName]) {
                    let labelValue = this.getArrayPath.transform(this.data.value, this.data.bars[bName][sName]);
                    if (!labelValue) {
                        continue;
                    }
                    if (typeof this.data.transform !== 'undefined') {
                        labelValue = this.transformService.transform(this.getArrayPath.transform(this.data.value, this.data.bars[bName][sName]), this.data.transform);
                    }
                    series.push({
                        name: this.language.getLabel(sName) + ' (' + labelValue + ')',
                        value: this.getArrayPath.transform(this.data.value, this.data.bars[bName][sName])
                    });
                }
                if (series.length > 0) {
                    bars.push({
                        name: this.language.getLabel(bName),
                        series
                    });
                }
            }
            this.data.value = bars;
        }
    }
    onSelect(data) {
    }
}
ChartBarHorizontalStackedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarHorizontalStackedComponent, deps: [{ token: LanguageService }, { token: GetArrayPathPipe }, { token: TransformService }], target: i0.ɵɵFactoryTarget.Component });
ChartBarHorizontalStackedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ChartBarHorizontalStackedComponent, selector: "app-chart-bar-horizontal-stacked", inputs: { data: "data" }, ngImport: i0, template: "<span [class]=\"data.class\">\r\n  <ngx-charts-bar-horizontal-stacked\r\n    [view]=\"data.view\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [results]=\"data.value\"\r\n    [gradient]=\"data.gradient\"\r\n    [xAxis]=\"data.showXAxis\"\r\n    [yAxis]=\"data.showYAxis\"\r\n    [legend]=\"data.showLegend\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"data.yAxisLabel\"\r\n    [barPadding]=\"data.barPadding || 8\"\r\n    (select)=\"onSelect($event)\">\r\n  </ngx-charts-bar-horizontal-stacked>\r\n</span>", styles: [":host{width:100%;height:100%;display:block}\n"], dependencies: [{ kind: "component", type: i2$1.BarHorizontalStackedComponent, selector: "ngx-charts-bar-horizontal-stacked", inputs: ["legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "tooltipDisabled", "gradient", "showGridLines", "activeEntries", "schemeType", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "barPadding", "roundDomains", "xScaleMax", "showDataLabel", "dataLabelFormatting", "noBarWhenZero", "wrapTicks"], outputs: ["activate", "deactivate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarHorizontalStackedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-chart-bar-horizontal-stacked', template: "<span [class]=\"data.class\">\r\n  <ngx-charts-bar-horizontal-stacked\r\n    [view]=\"data.view\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [results]=\"data.value\"\r\n    [gradient]=\"data.gradient\"\r\n    [xAxis]=\"data.showXAxis\"\r\n    [yAxis]=\"data.showYAxis\"\r\n    [legend]=\"data.showLegend\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"data.yAxisLabel\"\r\n    [barPadding]=\"data.barPadding || 8\"\r\n    (select)=\"onSelect($event)\">\r\n  </ngx-charts-bar-horizontal-stacked>\r\n</span>", styles: [":host{width:100%;height:100%;display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathPipe }, { type: TransformService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class AlertComponent {
    constructor(language) {
        this.language = language;
    }
    ngOnInit() {
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertComponent, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AlertComponent, selector: "app-alert", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"alert\" [class]=\"data.type\" role=\"alert\">\r\n  <mat-icon *ngIf=\"data.icon\" [ngStyle]=\"{'color': data.iconColor}\">{{ data.icon }}</mat-icon>\r\n  <span>{{ language.getLabel(data.label) }}</span>\r\n</div>\r\n", styles: [".alert{display:inline-flex;vertical-align:middle;width:100%}.alert mat-icon{margin-right:5px}.alert span{margin:auto}.alert.no-padding{padding:0}.alert.no-margin{margin:0}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-alert', template: "<div class=\"alert\" [class]=\"data.type\" role=\"alert\">\r\n  <mat-icon *ngIf=\"data.icon\" [ngStyle]=\"{'color': data.iconColor}\">{{ data.icon }}</mat-icon>\r\n  <span>{{ language.getLabel(data.label) }}</span>\r\n</div>\r\n", styles: [".alert{display:inline-flex;vertical-align:middle;width:100%}.alert mat-icon{margin-right:5px}.alert span{margin:auto}.alert.no-padding{padding:0}.alert.no-margin{margin:0}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class MultiAutocompleteComponent {
    constructor(api, getArrayPath, language) {
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.language = language;
        this.separatorKeysCodes = [COMMA];
        this.filteredItems = [];
        this.items = [];
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.options === 'undefined') {
            if (this.data.load) {
                this.load();
            }
            if (this.parentForm) {
                this.formControl = this.parentForm.controls[this.data.name];
            }
            else {
                this.formControl = new UntypedFormControl();
            }
            this.formControl.valueChanges
                .pipe(takeUntil$1(this.destroyed), debounceTime$1(500))
                .subscribe(selectedValue => {
                if (typeof selectedValue === 'object') {
                    if (Array.isArray(selectedValue)) {
                        for (const value of selectedValue) {
                            this.items.push(value);
                        }
                    }
                    else if (selectedValue !== null && selectedValue.text) {
                        this.items.push(selectedValue);
                    }
                }
                else {
                    if (selectedValue === this.lastSearch) {
                        return;
                    }
                    const search = '%' + selectedValue + '%';
                    if (selectedValue !== ''
                        && typeof selectedValue === 'string'
                        && selectedValue.length > 1) {
                        this.load(search);
                    }
                }
                this.formControl.setValue(this.items.map(item => item.value), { emitEvent: false });
            });
            if (typeof this.formControl.value === 'object' && this.formControl.value !== null) {
                // If value comes from response or is set outside of the component
                if (!Array.isArray(this.formControl.value)) {
                    this.formControl.value = [this.formControl.value];
                }
                for (const item of this.formControl.value) {
                    this.items.push(item);
                }
            }
            else {
                const val = this.data.value;
                if (val) {
                    this.formControl.setValue(val);
                }
            }
        }
    }
    load(search) {
        const dataService = this.api.getService(this.data.dataSource.service);
        let params = {
            mutations: []
        };
        if (typeof this.data.dataSource.params === 'object'
            && Object.keys(this.data.dataSource.params).length > 0) {
            params = JSON.parse(JSON.stringify({ ...this.data.dataSource.params }));
        }
        if (typeof search !== 'undefined') {
            if (typeof this.data.termKey === 'undefined') {
                this.data.termKey = 'name';
            }
            const mutation = {
                constraint: 'whereTranslation',
                params: [this.data.termKey, 'like', search]
            };
            params.mutations.push(mutation);
        }
        dataService[this.data.dataSource.method](params)
            .pipe(take(1))
            .subscribe((response) => {
            this.filteredItems = [];
            this.responseData = response.result.data;
            response.result.data.forEach((item) => {
                const value = this.getArrayPath.transform(item, this.data.dataSource.valuePath);
                let label = '';
                if (this.data.dataSource.multiLabelPath) {
                    for (const path of this.data.dataSource.multiLabelPath) {
                        const lab = this.getArrayPath.transform(item, path);
                        if (lab) {
                            label += lab + ' | ';
                        }
                    }
                }
                else {
                    label = this.getArrayPath.transform(item, this.data.dataSource.labelPath);
                }
                this.filteredItems.push({
                    value,
                    text: label
                });
            });
        });
    }
    doChange(event) {
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {
                    value: this.items.map(i => i.value)
                };
            }
            else {
                this.data.changeParams.value = this.items.map(i => i.value);
            }
            this.data.changeParams.event = 'change';
            if (this.formControl) {
                this.data.changeParams.control = this.formControl;
            }
            if (this.responseData && event) {
                this.responseData.forEach((item) => {
                    if (this.getArrayPath.transform(item, this.data.dataSource.valuePath) === event.option.value) {
                        this.data.changeParams.dataObject = item;
                    }
                });
            }
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    change(event) {
        this.items.push({
            text: event.option.viewValue,
            value: event.option.value
        });
        this.itemInput.nativeElement.value = '';
        this.doChange(event);
        // Reset formControl in order to populate the updated chip list
        this.formControl.setValue(null);
    }
    remove(itemToRemove) {
        const index = this.items.indexOf(itemToRemove);
        if (index >= 0) {
            this.items.splice(index, 1);
        }
        this.doChange();
        // Reset formControl in order to populate the updated chip list
        this.formControl.setValue(null);
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
MultiAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MultiAutocompleteComponent, deps: [{ token: ApiService }, { token: GetArrayPathPipe }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
MultiAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MultiAutocompleteComponent, selector: "app-multi-autocomplete", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "itemInput", first: true, predicate: ["itemInput"], descendants: true }], ngImport: i0, template: "<mat-form-field appearance=\"fill\" [formGroup]=\"parentForm\" *ngIf=\"parentForm\">\r\n  <mat-label>{{language.getLabel(data.label)}}</mat-label>\r\n  <mat-chip-list #chipList aria-label=\"Fruit selection\">\r\n    <mat-chip\r\n      *ngFor=\"let item of items\"\r\n      [selectable]=\"data.chips.selectable\"\r\n      [removable]=\"data.chips.removable\"\r\n      (removed)=\"remove(item)\"\r\n    >\r\n      {{ item.text }}\r\n      <mat-icon matChipRemove *ngIf=\"data.chips.removable\">cancel</mat-icon>\r\n    </mat-chip>\r\n    <input\r\n      [id]=\"data.id ? data.id : null\"\r\n      [placeholder]=\"language.getLabel(data.label)\"\r\n      name=\"{{data.name}}\"\r\n      #itemInput\r\n      [formControl]=\"formControl\"\r\n      [matAutocomplete]=\"auto\"\r\n      [matChipInputFor]=\"chipList\"\r\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\r\n    />\r\n  </mat-chip-list>\r\n  <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"change($event)\">\r\n    <mat-option *ngFor=\"let item of filteredItems\" [value]=\"item.value\">\r\n      {{ item.text }}\r\n    </mat-option>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n\r\n<mat-form-field appearance=\"fill\" *ngIf=\"!parentForm\"> </mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "component", type: i2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i12.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i12.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "component", type: i10$1.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i10$1.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i10$1.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i10$1.MatChipRemove, selector: "[matChipRemove]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MultiAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multi-autocomplete', template: "<mat-form-field appearance=\"fill\" [formGroup]=\"parentForm\" *ngIf=\"parentForm\">\r\n  <mat-label>{{language.getLabel(data.label)}}</mat-label>\r\n  <mat-chip-list #chipList aria-label=\"Fruit selection\">\r\n    <mat-chip\r\n      *ngFor=\"let item of items\"\r\n      [selectable]=\"data.chips.selectable\"\r\n      [removable]=\"data.chips.removable\"\r\n      (removed)=\"remove(item)\"\r\n    >\r\n      {{ item.text }}\r\n      <mat-icon matChipRemove *ngIf=\"data.chips.removable\">cancel</mat-icon>\r\n    </mat-chip>\r\n    <input\r\n      [id]=\"data.id ? data.id : null\"\r\n      [placeholder]=\"language.getLabel(data.label)\"\r\n      name=\"{{data.name}}\"\r\n      #itemInput\r\n      [formControl]=\"formControl\"\r\n      [matAutocomplete]=\"auto\"\r\n      [matChipInputFor]=\"chipList\"\r\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\r\n    />\r\n  </mat-chip-list>\r\n  <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"change($event)\">\r\n    <mat-option *ngFor=\"let item of filteredItems\" [value]=\"item.value\">\r\n      {{ item.text }}\r\n    </mat-option>\r\n  </mat-autocomplete>\r\n</mat-form-field>\r\n\r\n<mat-form-field appearance=\"fill\" *ngIf=\"!parentForm\"> </mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: GetArrayPathPipe }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], itemInput: [{
                type: ViewChild,
                args: ['itemInput']
            }] } });

class DownloadComponent {
    constructor(api, file) {
        this.api = api;
        this.file = file;
    }
    ngOnInit() {
        this.filename = this.data.file.filename;
    }
    download() {
        const parsed = this.data.file.url_params.method.split('.');
        const method = parsed[2];
        const serviceName = parsed[1].charAt(0).toUpperCase() +
            parsed[1].slice(1) + 'Service';
        const service = this.api.getService(serviceName);
        service[method](this.data.file.url_params.params)
            .pipe(take(1))
            .subscribe((data) => {
            this.file.download(data);
        });
    }
}
DownloadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DownloadComponent, deps: [{ token: ApiService }, { token: FileService }], target: i0.ɵɵFactoryTarget.Component });
DownloadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: DownloadComponent, selector: "app-download", inputs: { data: "data" }, ngImport: i0, template: "<app-button [data]=\"data\" (click)=\"download()\">{{filename}}</app-button>", styles: [""], dependencies: [{ kind: "component", type: ButtonComponent, selector: "app-button", inputs: ["data", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DownloadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-download', template: "<app-button [data]=\"data\" (click)=\"download()\">{{filename}}</app-button>" }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: FileService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class CkeditorComponent {
    constructor(dialog, language, zone, platformId) {
        this.dialog = dialog;
        this.language = language;
        this.zone = zone;
        this.platformId = platformId;
        this.config = {
            removePlugins: ['Markdown'],
            toolbar: [
                '|', 'undo', 'redo',
                '|', 'bold', 'italic', 'underline', 'strikethrough', 'link',
                '|', 'outdent', 'indent',
                '|', 'alignment',
                '|', 'fontSize', 'fontColor', 'fontBackgroundColor',
                '|', 'selectAll', 'removeFormat',
                '|', 'numberedList', 'bulletedList', 'horizontalLine',
                '|', 'insertTable', 'imageManager', 'mediaEmbed', 'specialCharacters',
                '|', 'findAndReplace', 'sourceEditing'
            ],
            image: {
                toolbar: [
                    'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                    '|', 'linkImage', 'toggleImageCaption', 'imageTextAlternative', 'resizeImage'
                ],
                styles: {
                    options: [
                        { name: 'alignLeft', className: 'float-left' },
                        { name: 'alignCenter', className: 'mx-auto' },
                        { name: 'alignRight', className: 'float-right' }
                    ]
                }
            },
            table: {
                contentToolbar: ['tableRow',
                    'tableColumn',
                    'mergeTableCells',
                    'tableCellProperties',
                    'tableProperties'
                ]
            },
            mediaEmbed: {
                previewsInData: true
            },
        };
        this.active = false;
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            import('ckeditor').then((i) => { this.ckeditor = i.default; });
        }
        if (this.data.markdown) {
            this.config.removePlugins.splice(this.config.removePlugins.indexOf('Markdown'), 1);
        }
    }
    onReady(editor) {
        if (this.data.markdown) { }
        editor.on('openImageManager', () => {
            this.zone.run(() => {
                this.data.gallery.data.itemClick = this.insertImage.bind(this);
                const params = {
                    width: '80vw',
                    data: {
                        title: this.data.dialogTitle,
                        items: [this.data.gallery],
                        close: this.data.dialogClose
                    }
                };
                this.dialogRef = this.dialog.open(SlotDialogComponent, params);
            });
        });
    }
    onFocus() {
        this.active = true;
    }
    onBlur() {
        this.active = false;
    }
    getEditor() {
        return this.editorComponent.editorInstance;
    }
    insertImage(url) {
        this.getEditor().execute('insertImage', {
            source: url
        });
        this.dialogRef.close();
    }
}
CkeditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CkeditorComponent, deps: [{ token: i3$3.MatDialog }, { token: LanguageService }, { token: i0.NgZone }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
CkeditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CkeditorComponent, selector: "app-ckeditor", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "editorComponent", first: true, predicate: ["editor"], descendants: true }], ngImport: i0, template: "<ng-container [formGroup]=\"parentForm\">\r\n  <div class=\"label text-left\" [ngClass]=\"{'active': active}\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  </div>\r\n  <ckeditor\r\n    *ngIf=\"ckeditor\"\r\n    #editor\r\n    class=\"editor\"\r\n    [ngClass]=\"{'active': active}\"\r\n    [editor]=\"ckeditor\"\r\n    [data]=\"data.value\"\r\n    [config]=\"config\"\r\n    (ready)=\"onReady($event)\"\r\n    (focus)=\"onFocus()\"\r\n    (blur)=\"onBlur()\"\r\n    [formControlName]=\"data.name\"\r\n  ></ckeditor>\r\n</ng-container>\r\n", styles: [".label{font-size:75%;color:#0000008a}::ng-deep .ck-editor__editable_inline{min-height:300px}::ng-deep .ck-source-editing-area textarea{left:0}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "component", type: i6$3.CKEditorComponent, selector: "ckeditor", inputs: ["config", "data", "tagName", "disabled", "editor", "watchdog"], outputs: ["ready", "change", "blur", "focus", "error"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CkeditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ckeditor', template: "<ng-container [formGroup]=\"parentForm\">\r\n  <div class=\"label text-left\" [ngClass]=\"{'active': active}\">\r\n    <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  </div>\r\n  <ckeditor\r\n    *ngIf=\"ckeditor\"\r\n    #editor\r\n    class=\"editor\"\r\n    [ngClass]=\"{'active': active}\"\r\n    [editor]=\"ckeditor\"\r\n    [data]=\"data.value\"\r\n    [config]=\"config\"\r\n    (ready)=\"onReady($event)\"\r\n    (focus)=\"onFocus()\"\r\n    (blur)=\"onBlur()\"\r\n    [formControlName]=\"data.name\"\r\n  ></ckeditor>\r\n</ng-container>\r\n", styles: [".label{font-size:75%;color:#0000008a}::ng-deep .ck-editor__editable_inline{min-height:300px}::ng-deep .ck-source-editing-area textarea{left:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i3$3.MatDialog }, { type: LanguageService }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], editorComponent: [{
                type: ViewChild,
                args: ['editor']
            }] } });

class CustomDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek() {
        return 1;
    }
    parse(value, parseFormat) {
        console.log(value, this.locale);
        const date = value.split('/');
        if (date.length == 3 && !this.locale.endsWith('US')) {
            return new Date(+date[2], +date[1] - 1, +date[0]);
        }
    }
}
CustomDateAdapter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomDateAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CustomDateAdapter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomDateAdapter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CustomDateAdapter, decorators: [{
            type: Injectable
        }] });

class LinkComponent {
    constructor(language, api, getArrayPath) {
        this.language = language;
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.external = false;
    }
    ngOnInit() {
        if (typeof this.data.base !== 'undefined') {
            this[this.data.base]();
        }
        let url;
        if (this.data.dataObject) {
            url = this.getArrayPath.get(this.data.dataObject, this.data.url);
            if (this.data.urlPrefix) {
                url = this.data.urlPrefix + url;
            }
        }
        if (typeof this.data.url !== 'undefined'
            && ((typeof this.data.url === 'string' && this.data.url.indexOf('://') > 0)
                || this.data.url.indexOf('tel:') >= 0
                || this.data.url.indexOf('mailto:') >= 0)) {
            this.external = true;
        }
        else if (typeof url === 'string'
            &&
                (url.indexOf('://') > 0
                    || url.indexOf('tel:') >= 0
                    || url.indexOf('mailto:') >= 0)) {
            this.external = true;
            this.data.url = this.getArrayPath.get(this.data.dataObject, this.data.url);
            if (this.data.urlPrefix) {
                this.data.url = this.data.urlPrefix + this.data.url;
            }
        }
    }
    onEvent($event, type) {
        if (typeof this.data[type] === 'function') {
            $event.preventDefault();
            if (this.data.stopPropagation) {
                $event.stopPropagation();
            }
            const paramsName = `${type}Params`;
            if (!this.data[paramsName]) {
                this.data[paramsName] = {};
                this.data[paramsName].event = type;
                this.data[paramsName].$event = $event;
                // Attach $event.target (the button that was clicked) to the action state
                if ($event.target.closest('a')) {
                    this.data[paramsName].target = $event.target.closest('a');
                }
                else {
                    this.data[paramsName].target = $event.target;
                }
                if (this.data.dataObject) {
                    this.data[paramsName].dataObject = this.data.dataObject;
                }
                if (this.parentComponent) {
                    this.data[paramsName].parentComponent = this.parentComponent;
                }
            }
            const result = this.data[type](this.data[paramsName]);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    apiAccessPointHost() {
        // TODO should be able to select the access point to use
        // Default access point used for now
        const config = this.api.getService('ConfigService').getAccessPoint();
        let apiAccessPointUrl = config.url.protocol + '://';
        apiAccessPointUrl += config.url.hostname;
        if (typeof this.data.url === 'string') {
            this.data.url = apiAccessPointUrl + this.data.url;
        }
    }
}
LinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LinkComponent, deps: [{ token: LanguageService }, { token: ApiService }, { token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Component });
LinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: LinkComponent, selector: "app-link", inputs: { data: "data", parentComponent: "parentComponent" }, ngImport: i0, template: "<a\r\n  *ngIf=\"!external\"\r\n  [class]=\"data.class\"\r\n  [routerLink]=\"data.dataObject | link: data.url\"\r\n  [attr.target]=\"data.target\"\r\n  (click)=\"onEvent($event, 'click')\"\r\n  (mouseover)=\"onEvent($event, 'mouseover')\"\r\n>\r\n  <ng-container *ngIf=\"!data.path\">\r\n    <ng-container *ngIf=\"data.text\">\r\n      {{ data.text }}\r\n    </ng-container>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.path && !data.components\">\r\n    {{ data.dataObject | getArrayPath: data.path }}\r\n  </ng-container>\r\n  <app-slot\r\n    *ngIf=\"data.components\"\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n    >\r\n  </app-slot>\r\n</a>\r\n<a\r\n  *ngIf=\"external\"\r\n  [class]=\"data.class\"\r\n  [href]=\"data.url\"\r\n  [attr.target]=\"data.target\"\r\n>\r\n  <ng-container *ngIf=\"!data.path\">\r\n    <ng-container *ngIf=\"data.text\">\r\n      {{ data.text }}\r\n    </ng-container>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.path && !data.components\">\r\n    {{ data.dataObject | getArrayPath: data.path }}\r\n  </ng-container>\r\n  <app-slot\r\n    *ngIf=\"data.components\"\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n  ></app-slot>\r\n</a>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: LinkPipe, name: "link" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-link', template: "<a\r\n  *ngIf=\"!external\"\r\n  [class]=\"data.class\"\r\n  [routerLink]=\"data.dataObject | link: data.url\"\r\n  [attr.target]=\"data.target\"\r\n  (click)=\"onEvent($event, 'click')\"\r\n  (mouseover)=\"onEvent($event, 'mouseover')\"\r\n>\r\n  <ng-container *ngIf=\"!data.path\">\r\n    <ng-container *ngIf=\"data.text\">\r\n      {{ data.text }}\r\n    </ng-container>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.path && !data.components\">\r\n    {{ data.dataObject | getArrayPath: data.path }}\r\n  </ng-container>\r\n  <app-slot\r\n    *ngIf=\"data.components\"\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n    >\r\n  </app-slot>\r\n</a>\r\n<a\r\n  *ngIf=\"external\"\r\n  [class]=\"data.class\"\r\n  [href]=\"data.url\"\r\n  [attr.target]=\"data.target\"\r\n>\r\n  <ng-container *ngIf=\"!data.path\">\r\n    <ng-container *ngIf=\"data.text\">\r\n      {{ data.text }}\r\n    </ng-container>\r\n    <ng-container *ngIf=\"data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.path && !data.components\">\r\n    {{ data.dataObject | getArrayPath: data.path }}\r\n  </ng-container>\r\n  <app-slot\r\n    *ngIf=\"data.components\"\r\n    [items]=\"data.components\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n  ></app-slot>\r\n</a>\r\n" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ApiService }, { type: GetArrayPathService }]; }, propDecorators: { data: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }] } });

class TimepickerComponent {
    constructor(language) {
        this.language = language;
        this.opened = false;
    }
    ngOnInit() {
    }
    open() {
        this.opened = true;
    }
    close() {
        this.opened = false;
    }
}
TimepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimepickerComponent, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
TimepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TimepickerComponent, selector: "app-timepicker", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "picker", first: true, predicate: ["picker"], descendants: true }], ngImport: i0, template: "<mat-form-field appearance=\"fill\" *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [formControlName]=\"data.name\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    [readonly]=\"data.inputDisabled\"\r\n    [format]=\"data.format\"\r\n    [ngxTimepicker]=\"picker\"\r\n  />\r\n  <button\r\n    mat-icon-button\r\n    [ngClass]=\"{ open: opened }\"\r\n    type=\"button\"\r\n    matSuffix\r\n    (click)=\"picker.open()\"\r\n  >\r\n    <mat-icon>schedule</mat-icon>\r\n  </button>\r\n  <ngx-material-timepicker\r\n    #picker\r\n    [enableKeyboardInput]=\"data.enableKeyboardInput\"\r\n    (opened)=\"open()\"\r\n    (closed)=\"close()\"\r\n  ></ngx-material-timepicker>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}::ng-deep .mat-form-field-suffix .mat-icon{font-size:100%;font-weight:700}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i10.MatLabel, selector: "mat-label" }, { kind: "directive", type: i10.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i12$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8$1.NgxMaterialTimepickerComponent, selector: "ngx-material-timepicker", inputs: ["ESC", "hoursOnly", "ngxMaterialTimepickerTheme", "format", "minutesGap", "cancelBtnTmpl", "editableHintTmpl", "confirmBtnTmpl", "enableKeyboardInput", "preventOverlayClick", "disableAnimation", "appendToInput", "defaultTime", "timepickerClass", "theme", "min", "max"], outputs: ["timeSet", "opened", "closed", "hourSelected", "timeChanged"] }, { kind: "directive", type: i8$1.TimepickerDirective, selector: "[ngxTimepicker]", inputs: ["format", "value", "min", "max", "ngxTimepicker", "disabled", "disableClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-timepicker', template: "<mat-form-field appearance=\"fill\" *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n  <mat-label>{{ language.getLabel(data.label) }}</mat-label>\r\n  <input\r\n    matInput\r\n    [formControlName]=\"data.name\"\r\n    [placeholder]=\"language.getLabel(data.placeholder)\"\r\n    [readonly]=\"data.inputDisabled\"\r\n    [format]=\"data.format\"\r\n    [ngxTimepicker]=\"picker\"\r\n  />\r\n  <button\r\n    mat-icon-button\r\n    [ngClass]=\"{ open: opened }\"\r\n    type=\"button\"\r\n    matSuffix\r\n    (click)=\"picker.open()\"\r\n  >\r\n    <mat-icon>schedule</mat-icon>\r\n  </button>\r\n  <ngx-material-timepicker\r\n    #picker\r\n    [enableKeyboardInput]=\"data.enableKeyboardInput\"\r\n    (opened)=\"open()\"\r\n    (closed)=\"close()\"\r\n  ></ngx-material-timepicker>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}::ng-deep .mat-form-field-suffix .mat-icon{font-size:100%;font-weight:700}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], picker: [{
                type: ViewChild,
                args: ['picker']
            }] } });

class HorizontalLineComponent {
    constructor() { }
    ngOnInit() {
    }
}
HorizontalLineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalLineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HorizontalLineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: HorizontalLineComponent, selector: "app-horizontal-line", inputs: { data: "data" }, ngImport: i0, template: "<hr [class]=\"data.class\" />", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalLineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-horizontal-line', template: "<hr [class]=\"data.class\" />" }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class HeadingComponent extends BaseComponent {
    constructor() {
        super();
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
HeadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HeadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: HeadingComponent, selector: "app-heading", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<ng-template #contents let-data=\"data\">\r\n  <ng-container *ngIf=\"data.label\">\r\n    {{ language.getLabel(data.label) }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.value\">\r\n    {{ data.value }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.valuePath\">\r\n    {{ data.dataObject | getArrayPath : data.valuePath }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.sections\">\r\n    <span *ngFor=\"let section of data.sections\" [class]=\"section.class\">\r\n      <ng-container *ngIf=\"section.label\">\r\n        {{ language.getLabel(section.label) }}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"section.value\">\r\n        {{ section.value }}\r\n      </ng-container>\r\n    </span>\r\n  </ng-container>\r\n  <!-- DEPRECATED -->\r\n  <ng-container *ngIf=\"data.startingSpan && data.endingSpan\">\r\n    <span [class]=\"data.startingSpan.class\">{{ data.startingSpan.value }}&nbsp;</span>\r\n    <span [class]=\"data.endingSpan.class\">{{ data.endingSpan.value }}</span>\r\n    <span [class]=\"data.startingSpan.class\" *ngIf=\"data.startingSpan.label\">{{ language.getLabel(data.startingSpan.label) }}&nbsp;</span>\r\n    <span [class]=\"data.endingSpan.class\" *ngIf=\"data.endingSpan.label\">{{ language.getLabel(data.endingSpan.label) }}</span>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.subtitle\">\r\n    <span [class]=\"data.subtitleClass\">{{ language.getLabel(data.subtitle) }}</span>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<h1 *ngIf=\"data.level === 1\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h1>\r\n<h2 *ngIf=\"data.level === 2\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h2>\r\n<h3 *ngIf=\"data.level === 3\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h3>\r\n<h4 *ngIf=\"data.level === 4\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h4>\r\n<h5 *ngIf=\"data.level === 5\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h5>\r\n<h6 *ngIf=\"data.level === 6\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h6>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HeadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-heading', template: "<ng-template #contents let-data=\"data\">\r\n  <ng-container *ngIf=\"data.label\">\r\n    {{ language.getLabel(data.label) }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.value\">\r\n    {{ data.value }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.valuePath\">\r\n    {{ data.dataObject | getArrayPath : data.valuePath }}\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.sections\">\r\n    <span *ngFor=\"let section of data.sections\" [class]=\"section.class\">\r\n      <ng-container *ngIf=\"section.label\">\r\n        {{ language.getLabel(section.label) }}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"section.value\">\r\n        {{ section.value }}\r\n      </ng-container>\r\n    </span>\r\n  </ng-container>\r\n  <!-- DEPRECATED -->\r\n  <ng-container *ngIf=\"data.startingSpan && data.endingSpan\">\r\n    <span [class]=\"data.startingSpan.class\">{{ data.startingSpan.value }}&nbsp;</span>\r\n    <span [class]=\"data.endingSpan.class\">{{ data.endingSpan.value }}</span>\r\n    <span [class]=\"data.startingSpan.class\" *ngIf=\"data.startingSpan.label\">{{ language.getLabel(data.startingSpan.label) }}&nbsp;</span>\r\n    <span [class]=\"data.endingSpan.class\" *ngIf=\"data.endingSpan.label\">{{ language.getLabel(data.endingSpan.label) }}</span>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.subtitle\">\r\n    <span [class]=\"data.subtitleClass\">{{ language.getLabel(data.subtitle) }}</span>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<h1 *ngIf=\"data.level === 1\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h1>\r\n<h2 *ngIf=\"data.level === 2\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h2>\r\n<h3 *ngIf=\"data.level === 3\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h3>\r\n<h4 *ngIf=\"data.level === 4\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h4>\r\n<h5 *ngIf=\"data.level === 5\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h5>\r\n<h6 *ngIf=\"data.level === 6\" [class]=\"data.class\">\r\n  <ng-container *ngTemplateOutlet=\"contents; context: { data: data }\"></ng-container>\r\n</h6>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class CardComponent {
    constructor(language) {
        this.language = language;
    }
    ngOnInit() {
    }
}
CardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardComponent, deps: [{ token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
CardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CardComponent, selector: "app-card", inputs: { data: "data" }, ngImport: i0, template: "<div *ngIf=\"data\" class=\"row\" [class]=\"data.rowClass\">\r\n  <div [class]=\"data.gridColClass\" [routerLink]=\"data.dataObject | link: data.link\">\r\n    <mat-card>\r\n      <app-slot\r\n        *ngIf=\"data.image\"\r\n        [items]=\"[data.image]\"\r\n        [componentValue]=\"data.dataObject\"\r\n      ></app-slot>\r\n      <mat-card-content *ngIf=\"data.content\">\r\n        <app-slot\r\n          [items]=\"data.content\"\r\n          [componentValue]=\"data.dataObject\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-content>\r\n      <mat-card-actions *ngIf=\"data.actions\">\r\n        <app-slot\r\n          [items]=\"data.actions\"\r\n          [componentValue]=\"data.dataObject\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-actions>\r\n    </mat-card>\r\n  </div>\r\n</div>\r\n", styles: [".mat-card{padding:0;height:100%;display:flex;justify-content:space-between;flex-direction:column}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i9$1.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i9$1.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i9$1.MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "pipe", type: LinkPipe, name: "link" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-card', template: "<div *ngIf=\"data\" class=\"row\" [class]=\"data.rowClass\">\r\n  <div [class]=\"data.gridColClass\" [routerLink]=\"data.dataObject | link: data.link\">\r\n    <mat-card>\r\n      <app-slot\r\n        *ngIf=\"data.image\"\r\n        [items]=\"[data.image]\"\r\n        [componentValue]=\"data.dataObject\"\r\n      ></app-slot>\r\n      <mat-card-content *ngIf=\"data.content\">\r\n        <app-slot\r\n          [items]=\"data.content\"\r\n          [componentValue]=\"data.dataObject\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-content>\r\n      <mat-card-actions *ngIf=\"data.actions\">\r\n        <app-slot\r\n          [items]=\"data.actions\"\r\n          [componentValue]=\"data.dataObject\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-actions>\r\n    </mat-card>\r\n  </div>\r\n</div>\r\n", styles: [".mat-card{padding:0;height:100%;display:flex;justify-content:space-between;flex-direction:column}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ImageBackgroundComponent {
    constructor(getArrayPath, breakpointObserver) {
        this.getArrayPath = getArrayPath;
        this.breakpointObserver = breakpointObserver;
        this.background = '';
        this.sizeObserver = this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge
        ]);
    }
    ngOnInit() {
        let src;
        if (typeof this.data.srcPath !== 'undefined') {
            // url comes from data object
            src = this.getArrayPath.get(this.data.dataObject, this.data.srcPath);
        }
        else {
            // direct url configured
            src = this.data.src;
        }
        const srclastDotIdx = src.lastIndexOf('.');
        const srcPath = src.slice(0, srclastDotIdx);
        const srcFileExt = src.slice(srclastDotIdx);
        // prepare fallback image
        let srcFallback;
        if (typeof this.data.srcFallbackPath !== 'undefined') {
            // url comes from data object
            srcFallback = this.getArrayPath.get(this.data.dataObject, this.data.srcFallbackPath);
        }
        else if (this.data.srcFallback) {
            // direct url configured
            srcFallback = this.data.srcFallback;
        }
        let srcFallbackPath;
        let srcFallbackFileExt;
        if (typeof srcFallback !== 'undefined') {
            const srcFallbacklastDotIdx = srcFallback.lastIndexOf('.');
            srcFallbackPath = srcFallback.slice(0, srcFallbacklastDotIdx);
            srcFallbackFileExt = srcFallback.slice(srcFallbacklastDotIdx);
        }
        this.sizeObserver
            .pipe(take$1(1)).subscribe(size => {
            // (max-width: 599.98px)
            if (size.breakpoints[Breakpoints.XSmall]) {
                src = srcPath + '_xsmall' + srcFileExt;
                if (typeof srcFallback !== 'undefined') {
                    srcFallback = srcFallbackPath + '_xsmall' + srcFallbackFileExt;
                }
            }
            // (min-width: 600px) and (max-width: 959.98px)
            if (size.breakpoints[Breakpoints.Small]) {
                src = srcPath + '_small' + srcFileExt;
                if (typeof srcFallback !== 'undefined') {
                    srcFallback = srcFallbackPath + '_small' + srcFallbackFileExt;
                }
            }
            // (min-width: 960px) and (max-width: 1279.98px)
            if (size.breakpoints[Breakpoints.Medium]) {
                src = srcPath + '_medium' + srcFileExt;
                if (typeof srcFallback !== 'undefined') {
                    srcFallback = srcFallbackPath + '_medium' + srcFallbackFileExt;
                }
            }
            // (min-width: 1280px) and (max-width: 1919.98px)
            if (size.breakpoints[Breakpoints.Large]) {
                src = srcPath + '_large' + srcFileExt;
                if (typeof srcFallback !== 'undefined') {
                    srcFallback = srcFallbackPath + '_large' + srcFallbackFileExt;
                }
            }
            // (min-width: 1920px)
            if (size.breakpoints[Breakpoints.XLarge]) {
                src = srcPath + '_xlarge' + srcFileExt;
                if (typeof srcFallback !== 'undefined') {
                    srcFallback = srcFallbackPath + '_xlarge' + srcFallbackFileExt;
                }
            }
            if (typeof this.data.overlay !== 'undefined') {
                this.background += this.data.overlay + ', ';
            }
            this.background += 'url(' + src + ')';
            if (typeof srcFallback !== 'undefined') {
                this.background += ',url(' + srcFallback + ')';
            }
        });
    }
    ngOnDestroy() {
        this.breakpointObserver.ngOnDestroy();
    }
}
ImageBackgroundComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageBackgroundComponent, deps: [{ token: GetArrayPathService }, { token: i6$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component });
ImageBackgroundComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ImageBackgroundComponent, selector: "app-image-background", inputs: { data: "data" }, ngImport: i0, template: "<div [class]=\"data.class\" [style.background-image]=\"background\">\r\n  <app-slot *ngIf=\"data.components\" [items]=\"data.components\"></app-slot>\r\n</div>\r\n", styles: [".cover{background-repeat:no-repeat;background-size:cover;background-position:center center}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageBackgroundComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-image-background', template: "<div [class]=\"data.class\" [style.background-image]=\"background\">\r\n  <app-slot *ngIf=\"data.components\" [items]=\"data.components\"></app-slot>\r\n</div>\r\n", styles: [".cover{background-repeat:no-repeat;background-size:cover;background-position:center center}\n"] }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }, { type: i6$2.BreakpointObserver }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class SliderRangeComponent {
    constructor(language, api, comm, getArrayPath, platformId) {
        this.language = language;
        this.api = api;
        this.comm = comm;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
        this.destroyed = new Subject();
        this.options = {};
        this.isBrowser = true;
        if (!isPlatformBrowser(this.platformId)) {
            this.isBrowser = false;
        }
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (this.parentForm) {
            this.formControl = this.parentForm.get(this.data.name);
        }
        else {
            this.formControl = new FormControl();
        }
        if (typeof this.data.dataSource !== 'undefined') {
            this.api.callServiceMethod(this.data.dataSource)
                .pipe(take(1)).subscribe((response) => {
                let data;
                if (this.data.dataSource.path !== 'undefined') {
                    data = this.getArrayPath.transform(response.result.data, this.data.dataSource.path);
                }
                else {
                    data = response.result.data;
                }
                this.setOptions(data);
            });
        }
        else if (typeof this.data.dataSource === 'undefined') {
            this.setOptions(this.data);
        }
        if (this.formControl.value) {
            const split = this.formControl.value.split('..');
            if (split.length === 2) {
                this.data.min = split[0];
                this.data.max = split[1];
                this.formControl.setValue({
                    min: parseFloat(split[0]),
                    max: parseFloat(split[1])
                });
            }
        }
    }
    setOptions(data) {
        this.options = data.options;
        this.options.translate = (value, label) => {
            let newLabel = '';
            if (data.labels?.floor && label === LabelType.Floor) {
                newLabel = this.language.getLabel(data.labels.floor) + ' ';
            }
            if (data.labels?.low && label === LabelType.Low) {
                newLabel = this.language.getLabel(data.labels.low) + ' ';
            }
            if (data.labels?.high && label === LabelType.High) {
                newLabel = this.language.getLabel(data.labels.high) + ' ';
            }
            if (data.labels?.ceil && label === LabelType.Ceil) {
                newLabel = this.language.getLabel(data.labels.ceil) + ' ';
            }
            if (data.labels?.prefix) {
                newLabel += this.language.getLabel(data.labels.prefix);
            }
            newLabel += value;
            if (data.labels?.suffix) {
                newLabel += ' ' + this.language.getLabel(data.labels.suffix);
            }
            return newLabel;
        };
        this.options.combineLabels = (minValue, maxValue) => {
            let glue = ' - ';
            if (data.labels?.low && data.labels?.high) {
                glue = ' ';
            }
            return [minValue, maxValue].join(glue);
        };
    }
    change(changeContext) {
        this.formControl.setValue({
            min: changeContext.value,
            max: changeContext.highValue,
        });
        if (typeof this.data.change === 'function') {
            if (!this.data.changeParams) {
                this.data.changeParams = {};
            }
            this.data.changeParams.value = {
                min: changeContext.value,
                max: changeContext.highValue,
            };
            this.data.changeParams.event = 'change';
            const result = this.data.change(this.data.changeParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
SliderRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SliderRangeComponent, deps: [{ token: LanguageService }, { token: ApiService }, { token: CommunicationService }, { token: GetArrayPathPipe }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
SliderRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SliderRangeComponent, selector: "app-slider-range", inputs: { data: "data", parentForm: "parentForm" }, providers: [GetArrayPathPipe], ngImport: i0, template: "<ng-container *ngIf=\"isBrowser\">\r\n    <ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n        <input type=\"hidden\" [formControlName]=\"data.name\"/>\r\n    </ng-container>\r\n    <div class=\"custom-slider\">\r\n        <ngx-slider \r\n            [(value)]=\"data.min\" \r\n            [(highValue)]=\"data.max\" \r\n            [options]=\"options\"\r\n            (userChangeEnd)=\"change($event)\"\r\n        ></ngx-slider>\r\n    </div>\r\n</ng-container>", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i7.ɵa, selector: "ngx-slider", inputs: ["value", "highValue", "options", "manualRefresh", "triggerFocus"], outputs: ["valueChange", "highValueChange", "userChangeStart", "userChange", "userChangeEnd"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SliderRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-slider-range', providers: [GetArrayPathPipe], template: "<ng-container *ngIf=\"isBrowser\">\r\n    <ng-container *ngIf=\"parentForm\" [formGroup]=\"parentForm\">\r\n        <input type=\"hidden\" [formControlName]=\"data.name\"/>\r\n    </ng-container>\r\n    <div class=\"custom-slider\">\r\n        <ngx-slider \r\n            [(value)]=\"data.min\" \r\n            [(highValue)]=\"data.max\" \r\n            [options]=\"options\"\r\n            (userChangeEnd)=\"change($event)\"\r\n        ></ngx-slider>\r\n    </div>\r\n</ng-container>" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ApiService }, { type: CommunicationService }, { type: GetArrayPathPipe }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }] } });

class ComboSeriesVerticalComponent {
    constructor() {
        this.type = 'standard';
        this.tooltipDisabled = false;
        this.animations = true;
        this.noBarWhenZero = true;
        this.select = new EventEmitter();
        this.activate = new EventEmitter();
        this.deactivate = new EventEmitter();
        this.bandwidth = new EventEmitter();
        this.orientation = BarOrientation.Vertical;
        this.tooltipPlacement = PlacementTypes.Top;
        this.tooltipType = StyleTypes.tooltip;
    }
    ngOnChanges(changes) {
        this.update();
    }
    update() {
        let width;
        if (this.series.length) {
            width = this.xScale.bandwidth();
            this.bandwidth.emit(width);
        }
        let d0 = 0;
        let total;
        if (this.type === 'normalized') {
            total = this.series.map(d => d.value).reduce((sum, d) => sum + d, 0);
        }
        this.bars = this.series.map((d, index) => {
            let value = d.value;
            const label = d.name;
            const formattedLabel = formatLabel(label);
            const roundEdges = this.type === 'standard';
            const bar = {
                value,
                label,
                roundEdges,
                data: d,
                width,
                formattedLabel,
                height: 0,
                x: 0,
                y: 0
            };
            if (this.type === 'standard') {
                bar.height = Math.abs(this.yScale(value) - this.yScale(0));
                bar.x = this.xScale(label);
                if (value < 0) {
                    bar.y = this.yScale(0);
                }
                else {
                    bar.y = this.yScale(value);
                }
            }
            else if (this.type === 'stacked') {
                const offset0 = d0;
                const offset1 = offset0 + value;
                d0 += value;
                bar.height = this.yScale(offset0) - this.yScale(offset1);
                bar.x = 0;
                bar.y = this.yScale(offset1);
                bar.offset0 = offset0;
                bar.offset1 = offset1;
            }
            else if (this.type === 'normalized') {
                let offset0 = d0;
                let offset1 = offset0 + value;
                d0 += value;
                if (total > 0) {
                    offset0 = (offset0 * 100) / total;
                    offset1 = (offset1 * 100) / total;
                }
                else {
                    offset0 = 0;
                    offset1 = 0;
                }
                bar.height = this.yScale(offset0) - this.yScale(offset1);
                bar.x = 0;
                bar.y = this.yScale(offset1);
                bar.offset0 = offset0;
                bar.offset1 = offset1;
                value = (offset1 - offset0).toFixed(2) + '%';
            }
            if (this.colors.scaleType === 'ordinal') {
                bar.color = this.colors.getColor(label);
            }
            else {
                if (this.type === 'standard') {
                    bar.color = this.colors.getColor(value);
                    bar.gradientStops = this.colors.getLinearGradientStops(value);
                }
                else {
                    bar.color = this.colors.getColor(bar.offset1);
                    bar.gradientStops = this.colors.getLinearGradientStops(bar.offset1, bar.offset0);
                }
            }
            let tooltipLabel = formattedLabel;
            if (this.seriesName) {
                tooltipLabel = `${this.seriesName} • ${formattedLabel}`;
            }
            this.getSeriesTooltips(this.seriesLine, index);
            const lineValue = this.seriesLine[0].series[index].value;
            bar.tooltipText = `
        <span class="tooltip-label">${tooltipLabel}</span>
        <span class="tooltip-val"> Y1 - ${value.toLocaleString()} • Y2 - ${lineValue.toLocaleString()}%</span>
      `;
            return bar;
        });
    }
    getSeriesTooltips(seriesLine, index) {
        return seriesLine.map(d => {
            return d.series[index];
        });
    }
    isActive(entry) {
        if (!this.activeEntries)
            return false;
        const item = this.activeEntries.find(d => {
            return entry.name === d.name && entry.series === d.series;
        });
        return item !== undefined;
    }
    onClick(data) {
        this.select.emit(data);
    }
    trackBy(index, bar) {
        return bar.label;
    }
}
ComboSeriesVerticalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboSeriesVerticalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ComboSeriesVerticalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ComboSeriesVerticalComponent, selector: "g[ngx-combo-charts-series-vertical]", inputs: { dims: "dims", type: "type", series: "series", seriesLine: "seriesLine", xScale: "xScale", yScale: "yScale", colors: "colors", tooltipDisabled: "tooltipDisabled", gradient: "gradient", activeEntries: "activeEntries", seriesName: "seriesName", animations: "animations", noBarWhenZero: "noBarWhenZero" }, outputs: { select: "select", activate: "activate", deactivate: "deactivate", bandwidth: "bandwidth" }, usesOnChanges: true, ngImport: i0, template: `
    <svg:g
      ngx-charts-bar
      *ngFor="let bar of bars; trackBy: trackBy"
      [@animationState]="'active'"
      [width]="bar.width"
      [height]="bar.height"
      [x]="bar.x"
      [y]="bar.y"
      [fill]="bar.color"
      [stops]="bar.gradientStops"
      [data]="bar.data"
      [orientation]="orientation"
      [roundEdges]="bar.roundEdges"
      [gradient]="gradient"
      [isActive]="isActive(bar.data)"
      [animations]="animations"
      [noBarWhenZero]="noBarWhenZero"
      (select)="onClick($event)"
      (activate)="activate.emit($event)"
      (deactivate)="deactivate.emit($event)"
      ngx-tooltip
      [tooltipDisabled]="tooltipDisabled"
      [tooltipPlacement]="tooltipPlacement"
      [tooltipType]="tooltipType"
      [tooltipTitle]="bar.tooltipText"
    ></svg:g>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.TooltipDirective, selector: "[ngx-tooltip]", inputs: ["tooltipCssClass", "tooltipTitle", "tooltipAppendToBody", "tooltipSpacing", "tooltipDisabled", "tooltipShowCaret", "tooltipPlacement", "tooltipAlignment", "tooltipType", "tooltipCloseOnClickOutside", "tooltipCloseOnMouseLeave", "tooltipHideTimeout", "tooltipShowTimeout", "tooltipTemplate", "tooltipShowEvent", "tooltipContext", "tooltipImmediateExit"], outputs: ["show", "hide"] }, { kind: "component", type: i2$1.BarComponent, selector: "g[ngx-charts-bar]", inputs: ["fill", "data", "width", "height", "x", "y", "orientation", "roundEdges", "gradient", "offset", "isActive", "stops", "animations", "ariaLabel", "noBarWhenZero"], outputs: ["select", "activate", "deactivate"] }], animations: [
        trigger('animationState', [
            transition('* => void', [
                style({
                    opacity: 1,
                    transform: '*'
                }),
                animate(500, style({ opacity: 0, transform: 'scale(0)' }))
            ])
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboSeriesVerticalComponent, decorators: [{
            type: Component,
            args: [{
                    // tslint:disable-next-line: component-selector
                    selector: 'g[ngx-combo-charts-series-vertical]',
                    template: `
    <svg:g
      ngx-charts-bar
      *ngFor="let bar of bars; trackBy: trackBy"
      [@animationState]="'active'"
      [width]="bar.width"
      [height]="bar.height"
      [x]="bar.x"
      [y]="bar.y"
      [fill]="bar.color"
      [stops]="bar.gradientStops"
      [data]="bar.data"
      [orientation]="orientation"
      [roundEdges]="bar.roundEdges"
      [gradient]="gradient"
      [isActive]="isActive(bar.data)"
      [animations]="animations"
      [noBarWhenZero]="noBarWhenZero"
      (select)="onClick($event)"
      (activate)="activate.emit($event)"
      (deactivate)="deactivate.emit($event)"
      ngx-tooltip
      [tooltipDisabled]="tooltipDisabled"
      [tooltipPlacement]="tooltipPlacement"
      [tooltipType]="tooltipType"
      [tooltipTitle]="bar.tooltipText"
    ></svg:g>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [
                        trigger('animationState', [
                            transition('* => void', [
                                style({
                                    opacity: 1,
                                    transform: '*'
                                }),
                                animate(500, style({ opacity: 0, transform: 'scale(0)' }))
                            ])
                        ])
                    ]
                }]
        }], propDecorators: { dims: [{
                type: Input
            }], type: [{
                type: Input
            }], series: [{
                type: Input
            }], seriesLine: [{
                type: Input
            }], xScale: [{
                type: Input
            }], yScale: [{
                type: Input
            }], colors: [{
                type: Input
            }], tooltipDisabled: [{
                type: Input
            }], gradient: [{
                type: Input
            }], activeEntries: [{
                type: Input
            }], seriesName: [{
                type: Input
            }], animations: [{
                type: Input
            }], noBarWhenZero: [{
                type: Input
            }], select: [{
                type: Output
            }], activate: [{
                type: Output
            }], deactivate: [{
                type: Output
            }], bandwidth: [{
                type: Output
            }] } });

class ComboChartComponent extends BaseChartComponent {
    constructor() {
        super(...arguments);
        this.curve = curveLinear;
        this.legend = false;
        this.legendTitle = 'Legend';
        this.legendPosition = LegendPosition.Right;
        this.tooltipDisabled = true;
        this.showGridLines = true;
        this.activeEntries = [];
        this.roundDomains = false;
        this.autoScale = false;
        this.animations = true;
        this.noBarWhenZero = true;
        this.yScaleMax = 100;
        this.yRightScaleMax = 100;
        this.activate = new EventEmitter();
        this.deactivate = new EventEmitter();
        this.margin = [10, 20, 10, 20];
        this.xAxisHeight = 0;
        this.yAxisWidth = 0;
        this.scaleType = ScaleType.Linear;
        this.yOrientLeft = Orientation.Left;
        this.yOrientRight = Orientation.Right;
        this.legendSpacing = 0;
        this.barPadding = 0;
    }
    trackBy(index, item) {
        return item.name;
    }
    update() {
        super.update();
        this.dims = calculateViewDimensions({
            width: this.width,
            height: this.height,
            margins: this.margin,
            showXAxis: this.xAxis,
            showYAxis: this.yAxis,
            xAxisHeight: this.xAxisHeight,
            yAxisWidth: this.yAxisWidth,
            showXLabel: this.showXAxisLabel,
            showYLabel: this.showYAxisLabel,
            showLegend: this.legend,
            legendType: this.schemeType,
            legendPosition: this.legendPosition,
        });
        const xDomain = this.getXDomain().length;
        this.barPadding = (this.dims.width / xDomain) - 5;
        if (!this.yAxis) {
            this.legendSpacing = 0;
        }
        else if (this.showYAxisLabel && this.yAxis) {
            this.legendSpacing = 100;
        }
        else {
            this.legendSpacing = 40;
        }
        this.xScale = this.getXScale();
        this.yScale = this.getYScale();
        // line chart
        this.xDomainLine = this.getXDomainLine();
        if (this.filteredDomain) {
            this.xDomainLine = this.filteredDomain;
        }
        this.yDomainLine = this.getYDomainLine();
        this.seriesDomain = this.getSeriesDomain();
        this.scaleLines();
        this.setColors();
        this.legendOptions = this.getLegendOptions();
        this.transform = `translate(${this.dims.xOffset} , ${this.margin[0]})`;
    }
    deactivateAll() {
        this.activeEntries = [...this.activeEntries];
        for (const entry of this.activeEntries) {
            this.deactivate.emit({ value: entry, entries: [] });
        }
        this.activeEntries = [];
    }
    hideCircles() {
        this.hoveredVertical = null;
        this.deactivateAll();
    }
    updateHoveredVertical(item) {
        this.hoveredVertical = item.value;
        this.deactivateAll();
    }
    updateDomain(domain) {
        this.filteredDomain = domain;
        this.xDomainLine = this.filteredDomain;
        this.xScaleLine = this.getXScaleLine(this.xDomainLine, this.dims.width);
    }
    scaleLines() {
        this.xScaleLine = this.getXScaleLine(this.xDomainLine, this.dims.width);
        this.yScaleLine = this.getYScaleLine(this.yDomainLine, this.dims.height);
    }
    getSeriesDomain() {
        this.combinedSeries = this.lineChart.slice(0);
        this.combinedSeries.push({
            name: this.yAxisLabel,
            series: this.results,
        });
        return this.combinedSeries.map((d) => d.name);
    }
    isDate(value) {
        if (value instanceof Date) {
            return true;
        }
        return false;
    }
    getScaleType(values) {
        let date = true;
        let num = true;
        for (const value of values) {
            if (!this.isDate(value)) {
                date = false;
            }
            if (typeof value !== 'number') {
                num = false;
            }
        }
        if (date) {
            return ScaleType.Time;
        }
        if (num) {
            return ScaleType.Linear;
        }
        return ScaleType.Ordinal;
    }
    getXDomainLine() {
        let values = [];
        for (const results of this.lineChart) {
            for (const d of results.series) {
                if (!values.includes(d.name)) {
                    values.push(d.name);
                }
            }
        }
        this.scaleType = this.getScaleType(values);
        let domain = [];
        if (this.scaleType === 'time') {
            const min = Math.min(...values);
            const max = Math.max(...values);
            domain = [min, max];
        }
        else if (this.scaleType === 'linear') {
            values = values.map((v) => Number(v));
            const min = Math.min(...values);
            const max = Math.max(...values);
            domain = [min, max];
        }
        else {
            domain = values;
        }
        this.xSet = values;
        return domain;
    }
    getYDomainLine() {
        const domain = [];
        for (const results of this.lineChart) {
            for (const d of results.series) {
                if (domain.indexOf(d.value) < 0) {
                    domain.push(d.value);
                }
                if (d.min !== undefined) {
                    if (domain.indexOf(d.min) < 0) {
                        domain.push(d.min);
                    }
                }
                if (d.max !== undefined) {
                    if (domain.indexOf(d.max) < 0) {
                        domain.push(d.max);
                    }
                }
            }
        }
        let min = Math.min(...domain);
        const max = Math.max(...domain);
        if (this.yRightAxisScaleFactor) {
            const minMax = this.yRightAxisScaleFactor(min, max);
            return [Math.min(0, minMax.min), minMax.max];
        }
        else {
            min = Math.min(0, min);
            // Originally this.yRightScaleMax was max
            return [min, this.yRightScaleMax];
        }
    }
    getXScaleLine(domain, width) {
        let scale;
        if (this.bandwidth === undefined) {
            this.bandwidth = width - this.barPadding;
        }
        const offset = Math.floor((width +
            this.barPadding -
            (this.bandwidth + this.barPadding) * domain.length) /
            2);
        if (this.scaleType === 'time') {
            scale = scaleTime().range([0, width]).domain(domain);
        }
        else if (this.scaleType === 'linear') {
            scale = scaleLinear().range([0, width]).domain(domain);
            if (this.roundDomains) {
                scale = scale.nice();
            }
        }
        else if (this.scaleType === 'ordinal') {
            scale = scalePoint()
                .range([
                offset + this.bandwidth / 2,
                width - offset - this.bandwidth / 2,
            ])
                .domain(domain);
        }
        return scale;
    }
    getYScaleLine(domain, height) {
        const scale = scaleLinear().range([height, 0]).domain(domain);
        return this.roundDomains ? scale.nice() : scale;
    }
    getXScale() {
        this.xDomain = this.getXDomain();
        const spacing = this.xDomain.length / (this.dims.width / this.barPadding + 1);
        return scaleBand()
            .range([0, this.dims.width])
            .paddingInner(spacing)
            .domain(this.xDomain);
    }
    getYScale() {
        this.yDomain = this.getYDomain();
        const scale = scaleLinear()
            .range([this.dims.height, 0])
            .domain(this.yDomain);
        return this.roundDomains ? scale.nice() : scale;
    }
    getXDomain() {
        return this.results.map((d) => d.name);
    }
    getYDomain() {
        const values = this.results.map((d) => d.value);
        const min = Math.min(0, ...values);
        const max = Math.max(...values);
        if (this.yLeftAxisScaleFactor) {
            const minMax = this.yLeftAxisScaleFactor(min, max);
            return [Math.min(0, minMax.min), minMax.max];
        }
        else {
            // Originally this.yScaleMax was max
            return [min, this.yScaleMax];
        }
    }
    onClick(data) {
        this.select.emit(data);
    }
    setColors() {
        let domain;
        if (this.schemeType === 'ordinal') {
            domain = this.xDomain;
        }
        else {
            domain = this.yDomain;
        }
        this.colors = new ColorHelper(this.scheme, this.schemeType, domain, this.customColors);
        this.colorsLine = new ColorHelper(this.colorSchemeLine, this.schemeType, domain, this.customColors);
    }
    getLegendOptions() {
        const opts = {
            scaleType: this.schemeType,
            colors: undefined,
            domain: [],
            title: undefined,
            position: this.legendPosition,
        };
        if (opts.scaleType === 'ordinal') {
            opts.domain = this.seriesDomain;
            opts.colors = this.colorsLine;
            opts.title = this.legendTitle;
        }
        else {
            opts.domain = this.seriesDomain;
            opts.colors = this.colors.scale;
        }
        return opts;
    }
    updateLineWidth(width) {
        this.bandwidth = width;
        this.scaleLines();
    }
    updateYAxisWidth({ width }) {
        this.yAxisWidth = width + 20;
        this.update();
    }
    updateXAxisHeight({ height }) {
        this.xAxisHeight = height;
        this.update();
    }
    onActivate(item) {
        const idx = this.activeEntries.findIndex((d) => {
            return (d.name === item.name &&
                d.value === item.value &&
                d.series === item.series);
        });
        if (idx > -1) {
            return;
        }
        this.activeEntries = [item, ...this.activeEntries];
        this.activate.emit({ value: item, entries: this.activeEntries });
    }
    onDeactivate(item) {
        const idx = this.activeEntries.findIndex((d) => {
            return (d.name === item.name &&
                d.value === item.value &&
                d.series === item.series);
        });
        this.activeEntries.splice(idx, 1);
        this.activeEntries = [...this.activeEntries];
        this.deactivate.emit({ value: item, entries: this.activeEntries });
    }
    percentRightTickFormatting(value) {
        return value.toLocaleString() + '%';
    }
    yAxisLeftTickFormatting(value) {
        return '';
    }
}
ComboChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboChartComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
ComboChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ComboChartComponent, selector: "combo-chart-component", inputs: { data: "data", curve: "curve", legend: "legend", legendTitle: "legendTitle", legendPosition: "legendPosition", xAxis: "xAxis", yAxis: "yAxis", showXAxisLabel: "showXAxisLabel", showYAxisLabel: "showYAxisLabel", showRightYAxisLabel: "showRightYAxisLabel", xAxisLabel: "xAxisLabel", yAxisLabel: "yAxisLabel", yAxisLabelRight: "yAxisLabelRight", tooltipDisabled: "tooltipDisabled", gradient: "gradient", showGridLines: "showGridLines", activeEntries: "activeEntries", schemeType: "schemeType", xAxisTickFormatting: "xAxisTickFormatting", yAxisTickFormatting: "yAxisTickFormatting", yRightAxisTickFormatting: "yRightAxisTickFormatting", roundDomains: "roundDomains", colorSchemeLine: "colorSchemeLine", autoScale: "autoScale", lineChart: "lineChart", yLeftAxisScaleFactor: "yLeftAxisScaleFactor", yRightAxisScaleFactor: "yRightAxisScaleFactor", rangeFillOpacity: "rangeFillOpacity", animations: "animations", noBarWhenZero: "noBarWhenZero", yScaleMax: "yScaleMax", yRightScaleMax: "yRightScaleMax" }, outputs: { activate: "activate", deactivate: "deactivate" }, host: { listeners: { "mouseleave": "hideCircles()" } }, queries: [{ propertyName: "tooltipTemplate", first: true, predicate: ["tooltipTemplate"], descendants: true }, { propertyName: "seriesTooltipTemplate", first: true, predicate: ["seriesTooltipTemplate"], descendants: true }], viewQueries: [{ propertyName: "lineSeriesComponent", first: true, predicate: LineSeriesComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<ngx-charts-chart\r\n  [view]=\"[width + legendSpacing, height]\"\r\n  [showLegend]=\"legend\"\r\n  [legendOptions]=\"legendOptions\"\r\n  [activeEntries]=\"activeEntries\"\r\n  [animations]=\"animations\"\r\n  (legendLabelClick)=\"onClick($event)\"\r\n  (legendLabelActivate)=\"onActivate($event)\"\r\n  (legendLabelDeactivate)=\"onDeactivate($event)\"\r\n>\r\n  <svg:g [attr.transform]=\"transform\" class=\"bar-chart chart\">\r\n    <svg:g\r\n      ngx-charts-x-axis\r\n      *ngIf=\"xAxis\"\r\n      [xScale]=\"xScale\"\r\n      [dims]=\"dims\"\r\n      [showLabel]=\"showXAxisLabel\"\r\n      [labelText]=\"xAxisLabel\"\r\n      [tickFormatting]=\"xAxisTickFormatting\"\r\n      (dimensionsChanged)=\"updateXAxisHeight($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-charts-y-axis\r\n      *ngIf=\"yAxis\"\r\n      [yScale]=\"yScale\"\r\n      [dims]=\"dims\"\r\n      [yOrient]=\"yOrientLeft\"\r\n      [showGridLines]=\"showGridLines\"\r\n      [showLabel]=\"showYAxisLabel\"\r\n      [labelText]=\"yAxisLabel\"\r\n      [tickFormatting]=\"yAxisLeftTickFormatting\"\r\n      (dimensionsChanged)=\"updateYAxisWidth($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-charts-y-axis\r\n      *ngIf=\"yAxis\"\r\n      [yScale]=\"yScaleLine\"\r\n      [dims]=\"dims\"\r\n      [yOrient]=\"yOrientRight\"\r\n      [showGridLines]=\"showGridLines\"\r\n      [showLabel]=\"showRightYAxisLabel\"\r\n      [labelText]=\"yAxisLabelRight\"\r\n      [tickFormatting]=\"percentRightTickFormatting\"\r\n      (dimensionsChanged)=\"updateYAxisWidth($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-combo-charts-series-vertical\r\n      [xScale]=\"xScale\"\r\n      [yScale]=\"yScale\"\r\n      [colors]=\"colors\"\r\n      [series]=\"results\"\r\n      [seriesLine]=\"lineChart\"\r\n      [dims]=\"dims\"\r\n      [gradient]=\"gradient\"\r\n      [tooltipDisabled]=\"true\"\r\n      [activeEntries]=\"activeEntries\"\r\n      [animations]=\"animations\"\r\n      [noBarWhenZero]=\"noBarWhenZero\"\r\n      (activate)=\"onActivate($event)\"\r\n      (deactivate)=\"onDeactivate($event)\"\r\n      (bandwidth)=\"updateLineWidth($event)\"\r\n      (select)=\"onClick($event)\"\r\n    ></svg:g>\r\n  </svg:g>\r\n  <svg:g [attr.transform]=\"transform\" class=\"line-chart chart\">\r\n    <svg:g>\r\n      <svg:g *ngFor=\"let series of lineChart; trackBy: trackBy\">\r\n        <svg:g\r\n          ngx-charts-line-series\r\n          [xScale]=\"xScaleLine\"\r\n          [yScale]=\"yScaleLine\"\r\n          [colors]=\"colorsLine\"\r\n          [data]=\"series\"\r\n          [activeEntries]=\"activeEntries\"\r\n          [scaleType]=\"scaleType\"\r\n          [curve]=\"curve\"\r\n          [rangeFillOpacity]=\"rangeFillOpacity\"\r\n          [animations]=\"animations\"\r\n        />\r\n      </svg:g>\r\n\r\n      <svg:g\r\n        ngx-charts-tooltip-area\r\n        *ngIf=\"!tooltipDisabled\"\r\n        [dims]=\"dims\"\r\n        [xSet]=\"xSet\"\r\n        [xScale]=\"xScaleLine\"\r\n        [yScale]=\"yScaleLine\"\r\n        [results]=\"combinedSeries\"\r\n        [colors]=\"colorsLine\"\r\n        [tooltipDisabled]=\"tooltipDisabled\"\r\n        (hover)=\"updateHoveredVertical($event)\"\r\n      />\r\n\r\n      <svg:g *ngFor=\"let series of lineChart\">\r\n        <svg:g\r\n          ngx-charts-circle-series\r\n          [xScale]=\"xScaleLine\"\r\n          [yScale]=\"yScaleLine\"\r\n          [colors]=\"colorsLine\"\r\n          [data]=\"series\"\r\n          [scaleType]=\"scaleType\"\r\n          [visibleValue]=\"hoveredVertical\"\r\n          [activeEntries]=\"activeEntries\"\r\n          [tooltipDisabled]=\"tooltipDisabled\"\r\n          (select)=\"onClick($event)\"\r\n          (activate)=\"onActivate($event)\"\r\n          (deactivate)=\"onDeactivate($event)\"\r\n        />\r\n      </svg:g>\r\n    </svg:g>\r\n  </svg:g>\r\n</ngx-charts-chart>", styles: [".ngx-charts{float:left;overflow:visible}.ngx-charts .circle,.ngx-charts .bar,.ngx-charts .arc{cursor:pointer}.ngx-charts .bar.active,.ngx-charts .bar:hover,.ngx-charts .cell.active,.ngx-charts .cell:hover,.ngx-charts .arc.active,.ngx-charts .arc:hover,.ngx-charts .card.active,.ngx-charts .card:hover{opacity:.8;transition:opacity .1s ease-in-out}.ngx-charts .bar:focus,.ngx-charts .cell:focus,.ngx-charts .arc:focus,.ngx-charts .card:focus{outline:none}.ngx-charts .bar.hidden,.ngx-charts .cell.hidden,.ngx-charts .arc.hidden,.ngx-charts .card.hidden{display:none}.ngx-charts g:focus{outline:none}.ngx-charts .line-series.inactive,.ngx-charts .line-series-range.inactive,.ngx-charts .area-series.inactive{transition:opacity .1s ease-in-out;opacity:.2}.ngx-charts .line-highlight{display:none}.ngx-charts .line-highlight.active{display:block}.ngx-charts .area{opacity:.6}.ngx-charts .circle:hover{cursor:pointer}.ngx-charts .label{font-size:12px;font-weight:400}.ngx-charts .tooltip-anchor{fill:#000}.ngx-charts .gridline-path{stroke:#ddd;stroke-width:1;fill:none}.ngx-charts .grid-panel rect{fill:none}.ngx-charts .grid-panel.odd rect{fill:#0000000d}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.XAxisComponent, selector: "g[ngx-charts-x-axis]", inputs: ["xScale", "dims", "trimTicks", "rotateTicks", "maxTickLength", "tickFormatting", "showGridLines", "showLabel", "labelText", "ticks", "xAxisTickCount", "xOrient", "xAxisOffset", "wrapTicks"], outputs: ["dimensionsChanged"] }, { kind: "component", type: i2$1.YAxisComponent, selector: "g[ngx-charts-y-axis]", inputs: ["yScale", "dims", "trimTicks", "maxTickLength", "tickFormatting", "ticks", "showGridLines", "showLabel", "labelText", "yAxisTickCount", "yOrient", "referenceLines", "showRefLines", "showRefLabels", "yAxisOffset", "wrapTicks"], outputs: ["dimensionsChanged"] }, { kind: "component", type: i2$1.TooltipArea, selector: "g[ngx-charts-tooltip-area]", inputs: ["dims", "xSet", "xScale", "yScale", "results", "colors", "showPercentage", "tooltipDisabled", "tooltipTemplate"], outputs: ["hover"] }, { kind: "component", type: i2$1.ChartComponent, selector: "ngx-charts-chart", inputs: ["view", "showLegend", "legendOptions", "legendType", "activeEntries", "animations"], outputs: ["legendLabelClick", "legendLabelActivate", "legendLabelDeactivate"] }, { kind: "component", type: i2$1.CircleSeriesComponent, selector: "g[ngx-charts-circle-series]", inputs: ["data", "type", "xScale", "yScale", "colors", "scaleType", "visibleValue", "activeEntries", "tooltipDisabled", "tooltipTemplate"], outputs: ["select", "activate", "deactivate"] }, { kind: "component", type: i2$1.LineSeriesComponent, selector: "g[ngx-charts-line-series]", inputs: ["data", "xScale", "yScale", "colors", "scaleType", "curve", "activeEntries", "rangeFillOpacity", "hasRange", "animations"] }, { kind: "component", type: ComboSeriesVerticalComponent, selector: "g[ngx-combo-charts-series-vertical]", inputs: ["dims", "type", "series", "seriesLine", "xScale", "yScale", "colors", "tooltipDisabled", "gradient", "activeEntries", "seriesName", "animations", "noBarWhenZero"], outputs: ["select", "activate", "deactivate", "bandwidth"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'combo-chart-component', encapsulation: ViewEncapsulation.None, template: "<ngx-charts-chart\r\n  [view]=\"[width + legendSpacing, height]\"\r\n  [showLegend]=\"legend\"\r\n  [legendOptions]=\"legendOptions\"\r\n  [activeEntries]=\"activeEntries\"\r\n  [animations]=\"animations\"\r\n  (legendLabelClick)=\"onClick($event)\"\r\n  (legendLabelActivate)=\"onActivate($event)\"\r\n  (legendLabelDeactivate)=\"onDeactivate($event)\"\r\n>\r\n  <svg:g [attr.transform]=\"transform\" class=\"bar-chart chart\">\r\n    <svg:g\r\n      ngx-charts-x-axis\r\n      *ngIf=\"xAxis\"\r\n      [xScale]=\"xScale\"\r\n      [dims]=\"dims\"\r\n      [showLabel]=\"showXAxisLabel\"\r\n      [labelText]=\"xAxisLabel\"\r\n      [tickFormatting]=\"xAxisTickFormatting\"\r\n      (dimensionsChanged)=\"updateXAxisHeight($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-charts-y-axis\r\n      *ngIf=\"yAxis\"\r\n      [yScale]=\"yScale\"\r\n      [dims]=\"dims\"\r\n      [yOrient]=\"yOrientLeft\"\r\n      [showGridLines]=\"showGridLines\"\r\n      [showLabel]=\"showYAxisLabel\"\r\n      [labelText]=\"yAxisLabel\"\r\n      [tickFormatting]=\"yAxisLeftTickFormatting\"\r\n      (dimensionsChanged)=\"updateYAxisWidth($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-charts-y-axis\r\n      *ngIf=\"yAxis\"\r\n      [yScale]=\"yScaleLine\"\r\n      [dims]=\"dims\"\r\n      [yOrient]=\"yOrientRight\"\r\n      [showGridLines]=\"showGridLines\"\r\n      [showLabel]=\"showRightYAxisLabel\"\r\n      [labelText]=\"yAxisLabelRight\"\r\n      [tickFormatting]=\"percentRightTickFormatting\"\r\n      (dimensionsChanged)=\"updateYAxisWidth($event)\"\r\n    ></svg:g>\r\n    <svg:g\r\n      ngx-combo-charts-series-vertical\r\n      [xScale]=\"xScale\"\r\n      [yScale]=\"yScale\"\r\n      [colors]=\"colors\"\r\n      [series]=\"results\"\r\n      [seriesLine]=\"lineChart\"\r\n      [dims]=\"dims\"\r\n      [gradient]=\"gradient\"\r\n      [tooltipDisabled]=\"true\"\r\n      [activeEntries]=\"activeEntries\"\r\n      [animations]=\"animations\"\r\n      [noBarWhenZero]=\"noBarWhenZero\"\r\n      (activate)=\"onActivate($event)\"\r\n      (deactivate)=\"onDeactivate($event)\"\r\n      (bandwidth)=\"updateLineWidth($event)\"\r\n      (select)=\"onClick($event)\"\r\n    ></svg:g>\r\n  </svg:g>\r\n  <svg:g [attr.transform]=\"transform\" class=\"line-chart chart\">\r\n    <svg:g>\r\n      <svg:g *ngFor=\"let series of lineChart; trackBy: trackBy\">\r\n        <svg:g\r\n          ngx-charts-line-series\r\n          [xScale]=\"xScaleLine\"\r\n          [yScale]=\"yScaleLine\"\r\n          [colors]=\"colorsLine\"\r\n          [data]=\"series\"\r\n          [activeEntries]=\"activeEntries\"\r\n          [scaleType]=\"scaleType\"\r\n          [curve]=\"curve\"\r\n          [rangeFillOpacity]=\"rangeFillOpacity\"\r\n          [animations]=\"animations\"\r\n        />\r\n      </svg:g>\r\n\r\n      <svg:g\r\n        ngx-charts-tooltip-area\r\n        *ngIf=\"!tooltipDisabled\"\r\n        [dims]=\"dims\"\r\n        [xSet]=\"xSet\"\r\n        [xScale]=\"xScaleLine\"\r\n        [yScale]=\"yScaleLine\"\r\n        [results]=\"combinedSeries\"\r\n        [colors]=\"colorsLine\"\r\n        [tooltipDisabled]=\"tooltipDisabled\"\r\n        (hover)=\"updateHoveredVertical($event)\"\r\n      />\r\n\r\n      <svg:g *ngFor=\"let series of lineChart\">\r\n        <svg:g\r\n          ngx-charts-circle-series\r\n          [xScale]=\"xScaleLine\"\r\n          [yScale]=\"yScaleLine\"\r\n          [colors]=\"colorsLine\"\r\n          [data]=\"series\"\r\n          [scaleType]=\"scaleType\"\r\n          [visibleValue]=\"hoveredVertical\"\r\n          [activeEntries]=\"activeEntries\"\r\n          [tooltipDisabled]=\"tooltipDisabled\"\r\n          (select)=\"onClick($event)\"\r\n          (activate)=\"onActivate($event)\"\r\n          (deactivate)=\"onDeactivate($event)\"\r\n        />\r\n      </svg:g>\r\n    </svg:g>\r\n  </svg:g>\r\n</ngx-charts-chart>", styles: [".ngx-charts{float:left;overflow:visible}.ngx-charts .circle,.ngx-charts .bar,.ngx-charts .arc{cursor:pointer}.ngx-charts .bar.active,.ngx-charts .bar:hover,.ngx-charts .cell.active,.ngx-charts .cell:hover,.ngx-charts .arc.active,.ngx-charts .arc:hover,.ngx-charts .card.active,.ngx-charts .card:hover{opacity:.8;transition:opacity .1s ease-in-out}.ngx-charts .bar:focus,.ngx-charts .cell:focus,.ngx-charts .arc:focus,.ngx-charts .card:focus{outline:none}.ngx-charts .bar.hidden,.ngx-charts .cell.hidden,.ngx-charts .arc.hidden,.ngx-charts .card.hidden{display:none}.ngx-charts g:focus{outline:none}.ngx-charts .line-series.inactive,.ngx-charts .line-series-range.inactive,.ngx-charts .area-series.inactive{transition:opacity .1s ease-in-out;opacity:.2}.ngx-charts .line-highlight{display:none}.ngx-charts .line-highlight.active{display:block}.ngx-charts .area{opacity:.6}.ngx-charts .circle:hover{cursor:pointer}.ngx-charts .label{font-size:12px;font-weight:400}.ngx-charts .tooltip-anchor{fill:#000}.ngx-charts .gridline-path{stroke:#ddd;stroke-width:1;fill:none}.ngx-charts .grid-panel rect{fill:none}.ngx-charts .grid-panel.odd rect{fill:#0000000d}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], curve: [{
                type: Input
            }], legend: [{
                type: Input
            }], legendTitle: [{
                type: Input
            }], legendPosition: [{
                type: Input
            }], xAxis: [{
                type: Input
            }], yAxis: [{
                type: Input
            }], showXAxisLabel: [{
                type: Input
            }], showYAxisLabel: [{
                type: Input
            }], showRightYAxisLabel: [{
                type: Input
            }], xAxisLabel: [{
                type: Input
            }], yAxisLabel: [{
                type: Input
            }], yAxisLabelRight: [{
                type: Input
            }], tooltipDisabled: [{
                type: Input
            }], gradient: [{
                type: Input
            }], showGridLines: [{
                type: Input
            }], activeEntries: [{
                type: Input
            }], schemeType: [{
                type: Input
            }], xAxisTickFormatting: [{
                type: Input
            }], yAxisTickFormatting: [{
                type: Input
            }], yRightAxisTickFormatting: [{
                type: Input
            }], roundDomains: [{
                type: Input
            }], colorSchemeLine: [{
                type: Input
            }], autoScale: [{
                type: Input
            }], lineChart: [{
                type: Input
            }], yLeftAxisScaleFactor: [{
                type: Input
            }], yRightAxisScaleFactor: [{
                type: Input
            }], rangeFillOpacity: [{
                type: Input
            }], animations: [{
                type: Input
            }], noBarWhenZero: [{
                type: Input
            }], yScaleMax: [{
                type: Input
            }], yRightScaleMax: [{
                type: Input
            }], activate: [{
                type: Output
            }], deactivate: [{
                type: Output
            }], tooltipTemplate: [{
                type: ContentChild,
                args: ['tooltipTemplate']
            }], seriesTooltipTemplate: [{
                type: ContentChild,
                args: ['seriesTooltipTemplate']
            }], lineSeriesComponent: [{
                type: ViewChild,
                args: [LineSeriesComponent]
            }], hideCircles: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class ChartBarLinesComponent {
    constructor(getArrayPath, langService) {
        this.getArrayPath = getArrayPath;
        this.langService = langService;
    }
    ngOnInit() {
        this.initChart();
    }
    initChart() {
        if (typeof this.data.barsPath !== 'undefined') {
            const barsArray = [];
            const barsObject = this.getArrayPath.get(this.data.value, this.data.barsPath);
            for (const key of Object.keys(barsObject)) {
                const label = key;
                barsArray.push({
                    name: label,
                    value: barsObject[key]
                });
            }
            this.data.barChart = barsArray;
        }
        if (typeof this.data.linesPath !== 'undefined') {
            const linesArray = [];
            for (const line of this.data.linesPath) {
                const series = [];
                const lineObject = this.getArrayPath.get(this.data.value, line.path);
                for (const key of Object.keys(lineObject)) {
                    const label = key;
                    series.push({
                        name: label,
                        value: lineObject[key]
                    });
                }
                linesArray.push({
                    name: this.langService.getLabel(line.name),
                    series
                });
            }
            this.data.lineChartSeries = linesArray;
        }
    }
    yAxisTickFormatting(value) {
        return '';
    }
    percentTickFormatting(value) {
        return value.toLocaleString() + '%';
    }
    yRightAxisTickFormatting(value) {
        return this.percentTickFormatting(value);
    }
}
ChartBarLinesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarLinesComponent, deps: [{ token: GetArrayPathService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
ChartBarLinesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ChartBarLinesComponent, selector: "app-chart-bar-lines", inputs: { data: "data" }, ngImport: i0, template: "<div #containerRef [class]=\"data.class\">\r\n  <combo-chart-component\r\n    [view]=\"[containerRef.offsetWidth, containerRef.offsetHeight]\"\r\n    [showGridLines]=\"data.showGridLines\"\r\n    [scheme]=\"data.comboBarScheme\"\r\n    [colorSchemeLine]=\"data.lineChartScheme\"\r\n    [results]=\"data.barChart\"\r\n    [animations]=\"data.animations\"\r\n    [lineChart]=\"data.lineChartSeries\"\r\n    [gradient]=\"data.gradient\"\r\n    [xAxis]=\"data.showXAxis\"\r\n    [yAxis]=\"data.showYAxis\"\r\n    [legend]=\"data.showLegend\"\r\n    [legendTitle]=\"data.legendTitle\"\r\n    [legendPosition]=\"data.legendPosition\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [showRightYAxisLabel]=\"data.showRightYAxisLabel\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"langService.getLabel(data.yAxisLabel)\"\r\n    [yAxisLabelRight]=\"data.yAxisLabelRight\"\r\n    [yScaleMax]=\"100\"\r\n    [yRightScaleMax]=\"100\"\r\n    [tooltipDisabled]=\"false\"\r\n  >\r\n  </combo-chart-component>\r\n</div>\r\n\r\n\r\n\r\n", styles: [""], dependencies: [{ kind: "component", type: ComboChartComponent, selector: "combo-chart-component", inputs: ["data", "curve", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showXAxisLabel", "showYAxisLabel", "showRightYAxisLabel", "xAxisLabel", "yAxisLabel", "yAxisLabelRight", "tooltipDisabled", "gradient", "showGridLines", "activeEntries", "schemeType", "xAxisTickFormatting", "yAxisTickFormatting", "yRightAxisTickFormatting", "roundDomains", "colorSchemeLine", "autoScale", "lineChart", "yLeftAxisScaleFactor", "yRightAxisScaleFactor", "rangeFillOpacity", "animations", "noBarWhenZero", "yScaleMax", "yRightScaleMax"], outputs: ["activate", "deactivate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartBarLinesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-chart-bar-lines', template: "<div #containerRef [class]=\"data.class\">\r\n  <combo-chart-component\r\n    [view]=\"[containerRef.offsetWidth, containerRef.offsetHeight]\"\r\n    [showGridLines]=\"data.showGridLines\"\r\n    [scheme]=\"data.comboBarScheme\"\r\n    [colorSchemeLine]=\"data.lineChartScheme\"\r\n    [results]=\"data.barChart\"\r\n    [animations]=\"data.animations\"\r\n    [lineChart]=\"data.lineChartSeries\"\r\n    [gradient]=\"data.gradient\"\r\n    [xAxis]=\"data.showXAxis\"\r\n    [yAxis]=\"data.showYAxis\"\r\n    [legend]=\"data.showLegend\"\r\n    [legendTitle]=\"data.legendTitle\"\r\n    [legendPosition]=\"data.legendPosition\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [showRightYAxisLabel]=\"data.showRightYAxisLabel\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"langService.getLabel(data.yAxisLabel)\"\r\n    [yAxisLabelRight]=\"data.yAxisLabelRight\"\r\n    [yScaleMax]=\"100\"\r\n    [yRightScaleMax]=\"100\"\r\n    [tooltipDisabled]=\"false\"\r\n  >\r\n  </combo-chart-component>\r\n</div>\r\n\r\n\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ComboChartModule {
    constructor() {
    }
}
ComboChartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboChartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ComboChartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ComboChartModule, declarations: [ComboChartComponent, ComboSeriesVerticalComponent], imports: [CommonModule,
        NgxChartsModule], exports: [ComboChartComponent,
        ComboSeriesVerticalComponent] });
ComboChartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboChartModule, imports: [CommonModule,
        NgxChartsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ComboChartModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ComboChartComponent, ComboSeriesVerticalComponent],
                    imports: [
                        CommonModule,
                        NgxChartsModule,
                    ],
                    exports: [
                        ComboChartComponent,
                        ComboSeriesVerticalComponent,
                    ]
                }]
        }], ctorParameters: function () { return []; } });

class ChartPolarComponent {
    constructor(getArrayPath, langService) {
        this.getArrayPath = getArrayPath;
        this.langService = langService;
    }
    ngOnInit() {
        this.initChart();
    }
    yAxisTickFormatting(value) {
        return this.percentTickFormatting(value);
    }
    percentTickFormatting(value) {
        return value.toLocaleString() + '%';
    }
    initChart() {
        if (typeof this.data.resultsPath !== 'undefined') {
            const resultsArray = [];
            for (const line of this.data.resultsPath) {
                const series = [];
                const lineObject = this.getArrayPath.get(this.data.dataObject, line.path);
                for (const key of Object.keys(lineObject)) {
                    const label = key;
                    series.push({
                        name: label,
                        value: lineObject[key]
                    });
                }
                resultsArray.push({
                    name: this.langService.getLabel(line.name),
                    series
                });
            }
            this.data.results = resultsArray;
        }
    }
}
ChartPolarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartPolarComponent, deps: [{ token: GetArrayPathService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
ChartPolarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ChartPolarComponent, selector: "app-chart-polar", inputs: { data: "data" }, ngImport: i0, template: "<div #containerRef [class]=\"data.class\">\r\n  <ngx-charts-polar-chart\r\n    [view]=\"[containerRef.offsetWidth, containerRef.offsetHeight]\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [legend]=\"data.legend\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [xAxis]=\"data.xAxis\"\r\n    [yAxis]=\"data.yAxis\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"data.yAxisLabel\"\r\n    [results]=\"data.results\"\r\n    [showGridLines]=\"data.showGridLines\"\r\n    [tooltipDisabled]=\"data.tooltipDisabled\">\r\n  </ngx-charts-polar-chart>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "component", type: i2$1.PolarChartComponent, selector: "ngx-charts-polar-chart", inputs: ["legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "autoScale", "showGridLines", "curve", "activeEntries", "schemeType", "rangeFillOpacity", "trimYAxisTicks", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "roundDomains", "tooltipDisabled", "showSeriesOnHover", "gradient", "yAxisMinScale", "labelTrim", "labelTrimSize", "wrapTicks"], outputs: ["activate", "deactivate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ChartPolarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-chart-polar', template: "<div #containerRef [class]=\"data.class\">\r\n  <ngx-charts-polar-chart\r\n    [view]=\"[containerRef.offsetWidth, containerRef.offsetHeight]\"\r\n    [scheme]=\"data.colorScheme\"\r\n    [legend]=\"data.legend\"\r\n    [showXAxisLabel]=\"data.showXAxisLabel\"\r\n    [showYAxisLabel]=\"data.showYAxisLabel\"\r\n    [xAxis]=\"data.xAxis\"\r\n    [yAxis]=\"data.yAxis\"\r\n    [xAxisLabel]=\"data.xAxisLabel\"\r\n    [yAxisLabel]=\"data.yAxisLabel\"\r\n    [results]=\"data.results\"\r\n    [showGridLines]=\"data.showGridLines\"\r\n    [tooltipDisabled]=\"data.tooltipDisabled\">\r\n  </ngx-charts-polar-chart>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class VideoComponent extends BaseComponent {
    constructor(route, getArrayPath) {
        super();
        this.route = route;
        this.getArrayPath = getArrayPath;
        this.loaded = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.src = this.data.src;
        if (typeof this.data.src === 'object' && this.data.src !== null) {
            if (Array.isArray(this.data.src)) {
                this.src = this.getArrayPath.get(this.data.dataObject, this.data.src);
            }
            else {
                let params = { ...this.data.src.params };
                if (typeof this.data.src.params !== 'undefined') {
                    this.route.params.pipe(take$1(1)).subscribe(urlParams => {
                        let stringParams = JSON.stringify(this.data.src.params);
                        for (const key of Object.keys(urlParams)) {
                            const search = ':' + key;
                            stringParams = stringParams.replace(new RegExp(search, 'g'), urlParams[key]);
                        }
                        params = JSON.parse(stringParams);
                    });
                }
                let src = this.data.src.filepath;
                // tslint:disable-next-line: forin
                for (const i in params) {
                    src = src.replace('{' + i + '}', params[i]);
                }
                this.src = src;
            }
        }
        if (typeof this.data.dataSource !== 'undefined') {
            this.load();
        }
    }
    timeupdate(event) {
        if (typeof this.data.timeUpdate === 'function') {
            if (!this.data.timeUpdateParams) {
                this.data.timeUpdateParams = {
                    timeStamp: event.timeStamp
                };
            }
            else {
                this.data.timeUpdateParams.timeStamp = event.timeStamp;
            }
            this.data.timeUpdateParams.event = 'timeUpdate';
            const result = this.data.timeUpdate(this.data.timeUpdateParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    ended(event) {
        if (typeof this.data.ended === 'function') {
            if (!this.data.endedParams) {
                this.data.endedParams = {
                    timeStamp: event.timeStamp
                };
            }
            else {
                this.data.endedParams.timeStamp = event.timeStamp;
            }
            this.data.endedParams.event = 'ended';
            const result = this.data.ended(this.data.endedParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    loadedData(event) {
        this.loaded = true;
    }
}
VideoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VideoComponent, deps: [{ token: i1.ActivatedRoute }, { token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Component });
VideoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VideoComponent, selector: "app-video", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<video\r\n  #video\r\n  [class]=\"data.class\"\r\n  [autoplay]=\"data.autoplay\"\r\n  [muted]=\"data.muted\"\r\n  [loop]=\"data.loop\"\r\n  [controls]=\"data.controls\"\r\n  (ended)=\"ended($event)\"\r\n  (timeupdate)=\"timeupdate($event)\"\r\n  (loadeddata)=\"loadedData($event)\"\r\n  [ngClass]=\"{ isOnBackground: this.data.isBackground }\"\r\n>\r\n  <source [src]=\"src\" [type]=\"data.mimeType\" />\r\n</video>\r\n<div class=\"w-100 d-flex justify-content-center align-items-center\">\r\n  <div class=\"loader\" *ngIf=\"!loaded\">\r\n    <app-loader [data]=\"{ diameter: 60 }\"></app-loader>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"data.header\" class=\"header\" [class]=\"data.headerClass\">\r\n  <app-slot\r\n    [items]=\"data.header\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.headerPath\"\r\n  ></app-slot>\r\n</div>\r\n<div *ngIf=\"data.contentVisible && data.content\" class=\"content\" [class]=\"data.contentClass\">\r\n  <app-slot\r\n    [items]=\"data.content\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.contentPath\"\r\n  ></app-slot>\r\n</div>\r\n", styles: [":host{position:relative}:host .header{position:fixed;top:0;right:0;left:0;z-index:1}:host .isOnBackground{position:fixed;right:0;bottom:0;width:100%;height:100%}:host video{max-width:100%}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: LoaderComponent, selector: "app-loader", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VideoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-video', template: "<video\r\n  #video\r\n  [class]=\"data.class\"\r\n  [autoplay]=\"data.autoplay\"\r\n  [muted]=\"data.muted\"\r\n  [loop]=\"data.loop\"\r\n  [controls]=\"data.controls\"\r\n  (ended)=\"ended($event)\"\r\n  (timeupdate)=\"timeupdate($event)\"\r\n  (loadeddata)=\"loadedData($event)\"\r\n  [ngClass]=\"{ isOnBackground: this.data.isBackground }\"\r\n>\r\n  <source [src]=\"src\" [type]=\"data.mimeType\" />\r\n</video>\r\n<div class=\"w-100 d-flex justify-content-center align-items-center\">\r\n  <div class=\"loader\" *ngIf=\"!loaded\">\r\n    <app-loader [data]=\"{ diameter: 60 }\"></app-loader>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"data.header\" class=\"header\" [class]=\"data.headerClass\">\r\n  <app-slot\r\n    [items]=\"data.header\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.headerPath\"\r\n  ></app-slot>\r\n</div>\r\n<div *ngIf=\"data.contentVisible && data.content\" class=\"content\" [class]=\"data.contentClass\">\r\n  <app-slot\r\n    [items]=\"data.content\"\r\n    [componentValue]=\"data.dataObject | getArrayPath: data.contentPath\"\r\n  ></app-slot>\r\n</div>\r\n", styles: [":host{position:relative}:host .header{position:fixed;top:0;right:0;left:0;z-index:1}:host .isOnBackground{position:fixed;right:0;bottom:0;width:100%;height:100%}:host video{max-width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: GetArrayPathService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class LoaderModule {
}
LoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: LoaderModule, declarations: [LoaderComponent], imports: [CommonModule,
        MatDialogModule,
        MatProgressSpinnerModule], exports: [LoaderComponent] });
LoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderModule, imports: [CommonModule,
        MatDialogModule,
        MatProgressSpinnerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoaderComponent],
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [LoaderComponent]
                }]
        }] });

class PrimitiveModule {
    constructor(routing) {
        routing.mapComponent('ButtonComponent', ButtonComponent);
        routing.mapComponent('SelectComponent', SelectComponent);
        routing.mapComponent('CheckboxComponent', CheckboxComponent);
        routing.mapComponent('SlideToggleComponent', SlideToggleComponent);
        routing.mapComponent('AutocompleteComponent', AutocompleteComponent);
        routing.mapComponent('MultiAutocompleteComponent', MultiAutocompleteComponent);
        routing.mapComponent('InputComponent', InputComponent);
        routing.mapComponent('DatepickerComponent', DatepickerComponent);
        routing.mapComponent('DaterangeComponent', DaterangeComponent);
        routing.mapComponent('RadiobuttonComponent', RadiobuttonComponent);
        routing.mapComponent('SliderComponent', SliderComponent);
        routing.mapComponent('SliderRangeComponent', SliderRangeComponent);
        routing.mapComponent('ChartBarHorizontalComponent', ChartBarHorizontalComponent);
        routing.mapComponent('ChartBarHorizontalStackedComponent', ChartBarHorizontalStackedComponent);
        routing.mapComponent('ChartPieComponent', ChartPieComponent);
        routing.mapComponent('ColorboxComponent', ColorboxComponent);
        routing.mapComponent('ActionComponent', ActionComponent);
        routing.mapComponent('DropzoneComponent', DropzoneComponent);
        routing.mapComponent('HtmlComponent', HtmlComponent);
        routing.mapComponent('AlertComponent', AlertComponent);
        routing.mapComponent('DownloadComponent', DownloadComponent);
        routing.mapComponent('CkeditorComponent', CkeditorComponent);
        routing.mapComponent('LinkComponent', LinkComponent);
        routing.mapComponent('ImageComponent', ImageComponent);
        routing.mapComponent('ImageBackgroundComponent', ImageBackgroundComponent);
        routing.mapComponent('TimepickerComponent', TimepickerComponent);
        routing.mapComponent('HorizontalLineComponent', HorizontalLineComponent);
        routing.mapComponent('HeadingComponent', HeadingComponent);
        routing.mapComponent('CardComponent', CardComponent);
        routing.mapComponent('ChartBarLinesComponent', ChartBarLinesComponent);
        routing.mapComponent('ChartPolarComponent', ChartPolarComponent);
        routing.mapComponent('IconComponent', IconComponent);
        routing.mapComponent('VideoComponent', VideoComponent);
    }
}
PrimitiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PrimitiveModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
PrimitiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: PrimitiveModule, declarations: [ButtonComponent,
        SelectComponent,
        CheckboxComponent,
        SlideToggleComponent,
        AutocompleteComponent,
        InputComponent,
        DatepickerComponent,
        DaterangeComponent,
        RadiobuttonComponent,
        SliderComponent,
        SliderRangeComponent,
        ChartBarHorizontalComponent,
        ChartPieComponent,
        ColorboxComponent,
        ActionComponent,
        DropzoneComponent,
        HtmlComponent,
        ChartBarHorizontalStackedComponent,
        AlertComponent,
        MultiAutocompleteComponent,
        DownloadComponent,
        CkeditorComponent,
        ImageComponent,
        ImageBackgroundComponent,
        LinkComponent,
        TimepickerComponent,
        DropzoneImagePreviewComponent,
        HorizontalLineComponent,
        HeadingComponent,
        CardComponent,
        IconComponent,
        ChartBarLinesComponent,
        ChartPolarComponent,
        VideoComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatBadgeModule,
        MatIconModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatRadioModule,
        MatInputModule,
        MatSliderModule,
        NgxChartsModule,
        PipesModule,
        SlotModule,
        NgxDropzoneModule,
        MatChipsModule,
        NgxPrintModule,
        MatDialogModule,
        MatCardModule,
        CKEditorModule,
        NgxMaterialTimepickerModule,
        NgxSliderModule,
        ComboChartModule,
        LoaderModule,
        InputMaskModule,
        CustomRouterLinkDirective], exports: [ButtonComponent,
        SelectComponent,
        CheckboxComponent,
        SlideToggleComponent,
        AutocompleteComponent,
        MultiAutocompleteComponent,
        InputComponent,
        DatepickerComponent,
        DaterangeComponent,
        RadiobuttonComponent,
        SliderComponent,
        SliderRangeComponent,
        ChartBarHorizontalComponent,
        ChartPieComponent,
        ColorboxComponent,
        ActionComponent,
        DropzoneComponent,
        HtmlComponent,
        ImageComponent,
        ImageBackgroundComponent,
        AlertComponent,
        DownloadComponent,
        CkeditorComponent,
        TimepickerComponent,
        HorizontalLineComponent,
        HeadingComponent,
        CardComponent,
        ChartBarLinesComponent,
        ChartPolarComponent,
        IconComponent,
        VideoComponent,
        LinkComponent] });
PrimitiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PrimitiveModule, providers: [
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter
        }
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatBadgeModule,
        MatIconModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatRadioModule,
        MatInputModule,
        MatSliderModule,
        NgxChartsModule,
        PipesModule,
        SlotModule,
        NgxDropzoneModule,
        MatChipsModule,
        NgxPrintModule,
        MatDialogModule,
        MatCardModule,
        CKEditorModule,
        NgxMaterialTimepickerModule,
        NgxSliderModule,
        ComboChartModule,
        LoaderModule,
        InputMaskModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PrimitiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ButtonComponent,
                        SelectComponent,
                        CheckboxComponent,
                        SlideToggleComponent,
                        AutocompleteComponent,
                        InputComponent,
                        DatepickerComponent,
                        DaterangeComponent,
                        RadiobuttonComponent,
                        SliderComponent,
                        SliderRangeComponent,
                        ChartBarHorizontalComponent,
                        ChartPieComponent,
                        ColorboxComponent,
                        ActionComponent,
                        DropzoneComponent,
                        HtmlComponent,
                        ChartBarHorizontalStackedComponent,
                        AlertComponent,
                        MultiAutocompleteComponent,
                        DownloadComponent,
                        CkeditorComponent,
                        ImageComponent,
                        ImageBackgroundComponent,
                        LinkComponent,
                        TimepickerComponent,
                        DropzoneImagePreviewComponent,
                        HorizontalLineComponent,
                        HeadingComponent,
                        CardComponent,
                        IconComponent,
                        ChartBarLinesComponent,
                        ChartPolarComponent,
                        VideoComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatButtonModule,
                        MatBadgeModule,
                        MatIconModule,
                        MatSelectModule,
                        NgxMatSelectSearchModule,
                        MatCheckboxModule,
                        MatSlideToggleModule,
                        MatAutocompleteModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        MatFormFieldModule,
                        MatRadioModule,
                        MatInputModule,
                        MatSliderModule,
                        NgxChartsModule,
                        PipesModule,
                        SlotModule,
                        NgxDropzoneModule,
                        MatChipsModule,
                        NgxPrintModule,
                        MatDialogModule,
                        MatCardModule,
                        CKEditorModule,
                        NgxMaterialTimepickerModule,
                        NgxSliderModule,
                        ComboChartModule,
                        LoaderModule,
                        InputMaskModule,
                        CustomRouterLinkDirective
                    ],
                    exports: [
                        ButtonComponent,
                        SelectComponent,
                        CheckboxComponent,
                        SlideToggleComponent,
                        AutocompleteComponent,
                        MultiAutocompleteComponent,
                        InputComponent,
                        DatepickerComponent,
                        DaterangeComponent,
                        RadiobuttonComponent,
                        SliderComponent,
                        SliderRangeComponent,
                        ChartBarHorizontalComponent,
                        ChartPieComponent,
                        ColorboxComponent,
                        ActionComponent,
                        DropzoneComponent,
                        HtmlComponent,
                        ImageComponent,
                        ImageBackgroundComponent,
                        AlertComponent,
                        DownloadComponent,
                        CkeditorComponent,
                        TimepickerComponent,
                        HorizontalLineComponent,
                        HeadingComponent,
                        CardComponent,
                        ChartBarLinesComponent,
                        ChartPolarComponent,
                        IconComponent,
                        VideoComponent,
                        LinkComponent
                    ],
                    providers: [
                        {
                            provide: DateAdapter,
                            useClass: CustomDateAdapter
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

class AddressAutocompleteModule {
    constructor(routing) {
        routing.mapComponent('AddressAutocompleteComponent', AddressAutocompleteComponent);
    }
}
AddressAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
AddressAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteModule, declarations: [AddressAutocompleteComponent], imports: [CommonModule,
        GoogleMapsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        PrimitiveModule,
        ReactiveFormsModule], exports: [AddressAutocompleteComponent] });
AddressAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteModule, imports: [CommonModule,
        GoogleMapsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        PrimitiveModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AddressAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AddressAutocompleteComponent],
                    imports: [
                        CommonModule,
                        GoogleMapsModule,
                        HttpClientModule,
                        HttpClientJsonpModule,
                        PrimitiveModule,
                        ReactiveFormsModule
                    ],
                    exports: [AddressAutocompleteComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var addressAutocomplete_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   AddressAutocompleteModule: AddressAutocompleteModule
});

class AlertDialogComponent {
    constructor(data, language) {
        this.data = data;
        this.language = language;
    }
    ngOnInit() {
        if (!this.data.cancel_button_color) {
            this.data.cancel_button_color = 'primary';
        }
        if (!this.data.button_color) {
            this.data.button_color = 'warn';
        }
        if (typeof this.data.close === 'undefined') {
            this.data.close = true;
        }
    }
}
AlertDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
AlertDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AlertDialogComponent, selector: "app-alert-dialog", ngImport: i0, template: "<h2 matDialogTitle>{{ language.getLabel(data.title) }}</h2>\r\n<mat-dialog-content>\r\n  <p>{{ data.text }}</p>\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"end\">\r\n  <button mat-button matDialogClose=\"cancel\" color=\"{{this.data.cancel_button_color}}\">\r\n    <ng-container *ngIf=\"data.cancel_button && data.close\">\r\n      {{language.getLabel(data.cancel_button)}}\r\n    </ng-container>\r\n    \r\n    <ng-container *ngIf=\"!data.cancel_button && data.close\">\r\n      {{language.getLabel('App_cancel')}}\r\n    </ng-container>\r\n  </button>\r\n  <button \r\n    *ngIf=\"data.button\" \r\n    mat-button \r\n    matDialogClose=\"confirm\" \r\n    color=\"{{data.button_color}}\"\r\n  >{{ language.getLabel(data.button) }}</button>\r\n</mat-dialog-actions>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$3.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i3$3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i3$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i3$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-alert-dialog', template: "<h2 matDialogTitle>{{ language.getLabel(data.title) }}</h2>\r\n<mat-dialog-content>\r\n  <p>{{ data.text }}</p>\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"end\">\r\n  <button mat-button matDialogClose=\"cancel\" color=\"{{this.data.cancel_button_color}}\">\r\n    <ng-container *ngIf=\"data.cancel_button && data.close\">\r\n      {{language.getLabel(data.cancel_button)}}\r\n    </ng-container>\r\n    \r\n    <ng-container *ngIf=\"!data.cancel_button && data.close\">\r\n      {{language.getLabel('App_cancel')}}\r\n    </ng-container>\r\n  </button>\r\n  <button \r\n    *ngIf=\"data.button\" \r\n    mat-button \r\n    matDialogClose=\"confirm\" \r\n    color=\"{{data.button_color}}\"\r\n  >{{ language.getLabel(data.button) }}</button>\r\n</mat-dialog-actions>\r\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: LanguageService }]; } });

class AlertDialogModule {
}
AlertDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlertDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogModule, declarations: [AlertDialogComponent], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule], exports: [AlertDialogComponent] });
AlertDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogModule, imports: [CommonModule,
        MatDialogModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AlertDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AlertDialogComponent
                    ],
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule
                    ],
                    exports: [AlertDialogComponent]
                }]
        }] });

class BreadcrumbsComponent {
    constructor(api, comm, route, arrayPath, language) {
        this.api = api;
        this.comm = comm;
        this.route = route;
        this.arrayPath = arrayPath;
        this.language = language;
        this.destroyed = new Subject$1();
        this.breadCrumbs = [];
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (this.data.dataSource) {
            this.urlParams = JSON.parse(JSON.stringify(this.data.dataSource.params));
            this.route.params.pipe(takeUntil(this.destroyed)).subscribe(params => {
                let replaced = JSON.stringify(this.urlParams);
                for (const key of Object.keys(params)) {
                    const search = ':' + key;
                    replaced = replaced.replace(new RegExp(search, 'g'), params[key]);
                }
                this.load(replaced);
            });
        }
        else {
            if (!this.data.startingBreadCrumbs) {
                this.data.startingBreadCrumbs = [];
            }
            this.addInlineBreadcrumbs(this.data.startingBreadCrumbs, null);
        }
    }
    load(replacedParams) {
        const dataSource = { ...this.data.dataSource };
        dataSource.params = JSON.parse(replacedParams);
        this.api.callServiceMethod(dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            this.breadCrumbs = [];
            const items = this.arrayPath.get(response.result.data, this.data.itemsPath);
            if (this.data.startingBreadCrumbs) {
                const startingItem = this.arrayPath.get(response.result.data, this.data.startingItemsPath);
                this.addInlineBreadcrumbs(this.data.startingBreadCrumbs, startingItem);
            }
            this.addBreadcrumbs(items);
            if (this.data.endingBreadCrumbs) {
                const endingItem = this.arrayPath.get(response.result.data, this.data.endingItemsPath);
                this.addInlineBreadcrumbs(this.data.endingBreadCrumbs, endingItem);
            }
        });
    }
    loadFromExternal(params) {
        const items = this.arrayPath.get(params, this.data.itemsPath);
        if (!params.doNotResetExistingBreadcrumbs) {
            this.breadCrumbs = [];
        }
        if (this.data.startingBreadCrumbs) {
            this.addInlineBreadcrumbs(this.data.startingBreadCrumbs, null);
        }
        this.addBreadcrumbs(items);
    }
    loadInlineFromExternal(params) {
        if (!params.doNotResetExistingBreadcrumbs) {
            this.breadCrumbs = [];
        }
        this.addInlineBreadcrumbs(params.breadCrumbs, params.item);
    }
    addBreadcrumbs(items) {
        (items).forEach(item => {
            if (Array.isArray(item)) {
                item.forEach(i => {
                    this.breadCrumbs.push({
                        label: this.arrayPath.get(i, this.data.labelPath),
                        url: this.data.baseBreadCrumbPath + this.arrayPath.get(i, this.data.slugPath)
                    });
                });
            }
            else {
                this.breadCrumbs.push({
                    label: this.arrayPath.get(item, this.data.labelPath),
                    url: this.data.baseBreadCrumbPath + this.arrayPath.get(item, this.data.slugPath)
                });
            }
        });
    }
    addInlineBreadcrumbs(inlineBreadCrumbs, item) {
        if (inlineBreadCrumbs) {
            inlineBreadCrumbs.forEach(bc => {
                const label = bc.hasOwnProperty('labelPath') ?
                    this.arrayPath.get(item, bc.labelPath) :
                    this.language.getLabel(bc.label);
                const url = bc.hasOwnProperty('urlPath') ?
                    bc.urlPath.slice(0, 1) + this.arrayPath.get(item, bc.urlPath.slice(1)) :
                    bc.url;
                this.breadCrumbs.push({
                    label,
                    url
                });
            });
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
BreadcrumbsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsComponent, deps: [{ token: ApiService }, { token: CommunicationService }, { token: i1.ActivatedRoute }, { token: GetArrayPathService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BreadcrumbsComponent, selector: "ng-component", inputs: { data: "data" }, ngImport: i0, template: "<nav [class]=\"data.navClasses\">\r\n  <ul class=\"breadcrumb-menu-wrapper\" [class]=\"data.breadCrumbUlClasses\">\r\n    <li *ngFor=\"let bc of breadCrumbs; let i=index\"\r\n        [class]=\"data.breadCrumbClasses\">\r\n      <a [routerLink]=\"bc.url ? [bc.url] : null\">{{ bc.label }}</a>\r\n      <app-icon\r\n        *ngIf=\"i !== breadCrumbs.length - 1\"\r\n        [data]=\"{\r\n          icon: data.separatorIcon\r\n        }\"\r\n      ></app-icon>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n", styles: [".breadcrumb-menu-wrapper{display:flex;flex-direction:row;align-items:center}.breadcrumb-menu-wrapper li{list-style:none;display:flex;align-items:center}.breadcrumb-menu-wrapper li a{color:inherit}.breadcrumb-menu-wrapper li app-icon{display:flex}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: IconComponent, selector: "app-icon", inputs: ["data"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsComponent, decorators: [{
            type: Component,
            args: [{ template: "<nav [class]=\"data.navClasses\">\r\n  <ul class=\"breadcrumb-menu-wrapper\" [class]=\"data.breadCrumbUlClasses\">\r\n    <li *ngFor=\"let bc of breadCrumbs; let i=index\"\r\n        [class]=\"data.breadCrumbClasses\">\r\n      <a [routerLink]=\"bc.url ? [bc.url] : null\">{{ bc.label }}</a>\r\n      <app-icon\r\n        *ngIf=\"i !== breadCrumbs.length - 1\"\r\n        [data]=\"{\r\n          icon: data.separatorIcon\r\n        }\"\r\n      ></app-icon>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n", styles: [".breadcrumb-menu-wrapper{display:flex;flex-direction:row;align-items:center}.breadcrumb-menu-wrapper li{list-style:none;display:flex;align-items:center}.breadcrumb-menu-wrapper li a{color:inherit}.breadcrumb-menu-wrapper li app-icon{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: CommunicationService }, { type: i1.ActivatedRoute }, { type: GetArrayPathService }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class BreadcrumbsModule {
    constructor(routing) {
        routing.mapComponent('BreadcrumbsComponent', BreadcrumbsComponent);
    }
}
BreadcrumbsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
BreadcrumbsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsModule, declarations: [BreadcrumbsComponent], imports: [CommonModule,
        RouterModule,
        PrimitiveModule,
        CustomRouterLinkDirective] });
BreadcrumbsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsModule, imports: [CommonModule,
        RouterModule,
        PrimitiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BreadcrumbsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BreadcrumbsComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        PrimitiveModule,
                        CustomRouterLinkDirective
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var breadcrumbs_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   BreadcrumbsModule: BreadcrumbsModule
});

SwiperCore.use([Autoplay, Pagination, Navigation, Thumbs, Zoom]);
class CarouselComponent {
    constructor(api, language, getArrayPath, zone, route, breakpointObserver, comm, platformId) {
        this.api = api;
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.zone = zone;
        this.route = route;
        this.breakpointObserver = breakpointObserver;
        this.comm = comm;
        this.platformId = platformId;
        this.urlKey = 'original';
        this.urlKeyWebp = 'webp';
        this.mainBannerConfig = {};
        this.thumbnails = {};
        this.singleSlideWidth = 24;
        /* Subject that emits when the component has been destroyed. */
        this.destroyed = new Subject();
        this.showLoadingIcon = false;
        this.loading = false;
        this.isBrowser = true;
    }
    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            this.isBrowser = false;
            return;
        }
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => {
                this.comm.processMessage(message, this);
            });
        }
        let lastMatch = null;
        if (typeof this.data.breakpoints !== 'undefined') {
            const observe = [];
            for (const width in this.data.breakpoints) {
                observe.push(width);
            }
            if (observe.length > 0) {
                this.breakpointObserver.observe(observe.map((i) => {
                    return '(min-width: ' + i + 'px)';
                }))
                    .pipe(takeUntil(this.destroyed)).subscribe((size) => {
                    if (size.matches) {
                        // tslint:disable-next-line: forin
                        for (const width in this.data.breakpoints) {
                            if (size.breakpoints['(min-width: ' + width + 'px)']) {
                                this.singleSlideWidth = 24 / this.data.breakpoints[width]
                                    .slidesPerView;
                                lastMatch = width;
                            }
                        }
                    }
                    else {
                        this.singleSlideWidth = 24 / this.data.slidesPerView;
                    }
                    if (typeof this.data.dataSource?.params !== 'undefined'
                        && lastMatch !== null
                        && typeof this.data.dataSource.params[lastMatch] !== 'undefined') {
                        if (this.data.dataSource.params[lastMatch] !== false) {
                            this.load(lastMatch);
                        }
                    }
                    else {
                        this.load();
                    }
                });
            }
            else {
                this.load();
            }
        }
        if (typeof this.data.slideImageSize !== 'undefined') {
            this.urlKey = this.data.slideImageSize + '_' + this.urlKey;
            this.urlKeyWebp = this.data.slideImageSize + '_' + this.urlKeyWebp;
        }
        if (this.data.initialSlide && this.data.thumbs) {
            console.warn('You cannot use thumbnails and attribute "initialSlide" simultaneously!');
        }
        this.thumbnails = this.data.thumbnails;
        // Stringify all specific properties
        for (const [key, value] of Object.entries(this.data)) {
            this.mainBannerConfig[key] = value;
        }
        if (typeof this.data.breakpoints === 'undefined') {
            this.load();
        }
    }
    load(width) {
        if (this.data.dataObject) {
            this.image = this.data.dataObject;
            if (typeof this.data.path !== 'undefined') {
                this.image = this.getArrayPath.transform(this.data.dataObject, this.data.path);
            }
            if (this.mainBannerConfig.loop) {
                if (this.mainBannerConfig.slidesPerView !== 'auto'
                    && this.mainBannerConfig.slidesPerView >= this.image.length) {
                    this.mainBannerConfig.loop = false;
                }
                else {
                    this.mainBannerConfig.loopedSlides = this.image.length;
                }
            }
        }
        else if (this.data.dataSource) {
            this.loading = true;
            let params = {};
            // load options if datasource is provided
            if (typeof this.data.dataSource.params !== 'undefined') {
                if (typeof width !== 'undefined' && typeof this.data.dataSource.params[width] !== 'undefined') {
                    if (typeof this.data.dataSource.params[width] === 'object') {
                        params = { ...this.data.dataSource.params[width] };
                    }
                }
                else {
                    params = { ...this.data.dataSource.params };
                }
            }
            this.route.params
                .pipe(takeUntil(this.destroyed))
                .subscribe(urlParams => {
                const stringParams = JSON.stringify(params);
                let replaced = stringParams;
                for (const key of Object.keys(urlParams)) {
                    const search = ':' + key;
                    replaced = replaced.replace(new RegExp(search, 'g'), urlParams[key]);
                }
                if (replaced !== '') {
                    params = { ...JSON.parse(replaced) };
                }
            });
            const dataService = this.api.getService(this.data.dataSource.service);
            dataService[this.data.dataSource.method](params)
                .pipe(take$1(1))
                .subscribe((response) => {
                this.image = this.getArrayPath.transform(response.result.data, this.data.dataSource.path);
                if (this.mainBannerConfig.loop && typeof this.image !== 'undefined') {
                    if (this.mainBannerConfig.slidesPerView !== 'auto'
                        && this.mainBannerConfig.slidesPerView >= this.image.length) {
                        this.mainBannerConfig.loop = false;
                    }
                    else {
                        this.mainBannerConfig.loopedSlides = this.image.length;
                    }
                }
                this.loading = false;
            });
        }
    }
    isExternal(itemUrl) {
        if (typeof itemUrl !== "undefined" &&
            itemUrl !== null &&
            ((typeof itemUrl === "string" && itemUrl.indexOf("://") > 0) ||
                itemUrl.indexOf("tel:") >= 0 ||
                itemUrl.indexOf("mailto:") >= 0)) {
            return true;
        }
        return false;
    }
    isObject(imageUrl) {
        return typeof (imageUrl) === 'object';
    }
    click(index) {
        this.zone.run(() => {
            if (typeof this.data.click === 'function') {
                if (!this.data.clickParams) {
                    this.data.clickParams = {};
                    this.data.clickParams.event = 'click';
                    if (Array.isArray(this.image) &&
                        typeof this.image[index || 0].slug !== 'undefined') {
                        this.data.clickParams.slug = this.image[index || 0].slug;
                    }
                    else if (Array.isArray(this.image) &&
                        typeof this.image[index || 0].type !== 'undefined') {
                        this.data.clickParams.type = this.image[index || 0].type;
                    }
                }
                const result = this.data.click(this.data.clickParams);
                this.data.clickParams = null;
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.breakpointObserver.ngOnDestroy();
    }
}
CarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CarouselComponent, deps: [{ token: ApiService }, { token: LanguageService }, { token: GetArrayPathPipe }, { token: i0.NgZone }, { token: i1.ActivatedRoute }, { token: i6$2.BreakpointObserver }, { token: CommunicationService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
CarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CarouselComponent, selector: "app-carousel", inputs: { data: "data" }, providers: [GetArrayPathPipe], ngImport: i0, template: "<ng-container *ngIf=\"isBrowser\">\r\n  <!-- If we want loading bar before when loading -->\r\n  <div *ngIf=\"data.progressBar && loading\" class=\"loadingContainer\">\r\n    <!-- <mat-icon class=\"loadingIcon\">{{data.loadingIcon}}</mat-icon> -->\r\n    <div class=\"loadingComponent\">\r\n      <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"image && image.length > 1\">\r\n    <swiper\r\n      mainSwiper\r\n      [config]=\"mainBannerConfig\"\r\n      [thumbs]=\"{ swiper: thumbsSwiper }\"\r\n      [parallax]=\"data.parallax\">\r\n      <ng-container *ngIf=\"!data.parallax\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image; let i = index\">\r\n          <!-- If sliding html items -->\r\n          <ng-container *ngIf=\"!item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <!-- <ng-container *ngIf=\"data.parallax && data.content && data.parallaxOnImage\">\r\n                <div class=\"swiper-zoom-container parallax-content {{data.parallaxContentClass}}\">\r\n                    <app-slot\r\n                      [items]=\"data.content.components\"\r\n                      [componentValue]=\"item | getArrayPath: data.content.path\"\r\n                      style=\"display: block; width: 100%; height: 100%\"\r\n                    ></app-slot>\r\n                </div>\r\n              </ng-container> -->\r\n              <ng-container *ngIf=\"!isObject(item.url)\">\r\n                <app-video\r\n                  *ngIf=\"item.type === 'video'\"\r\n                  (click)=\"click(i)\"\r\n                  [data]=\"{\r\n                    dataObject: item,\r\n                    loop: data.loopVideo,\r\n                    autoplay: data.autoplayVideo,\r\n                    src: item.url,\r\n                    controls: data.controlsVideo,\r\n                    muted: data.mutedVideo,\r\n                    mimeType: 'video/mp4'\r\n                  }\">\r\n                </app-video>\r\n                <img *ngIf=\"item.type == 'image'\" (click)=\"click(i)\" [src]=\"item.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.url[urlKey].endsWith('.jpg') ||\r\n                      item.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img (click)=\"click(i)\" [src]=\"item.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- If sliding images -->\r\n          <ng-container *ngIf=\"item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <a *ngIf=\"!isExternal(item.url)\" [routerLink]=\"item.url\">\r\n                <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                  <app-video\r\n                    *ngIf=\"item.file.type === 'video'\"\r\n                    (click)=\"click()\"\r\n                    [data]=\"{\r\n                      dataObject: item,\r\n                      loop: data.loopVideo,\r\n                      autoplay: data.autoplayVideo,\r\n                      src: item.file.url,\r\n                      controls: data.controlsVideo,\r\n                      muted: data.mutedVideo,\r\n                      mimeType: 'video/mp4'\r\n                    }\"></app-video>\r\n                  <img\r\n                    *ngIf=\"item.file.type === 'image'\"\r\n                    (click)=\"click()\"\r\n                    [src]=\"item.file.url\" />\r\n                </ng-container>\r\n                <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                  <picture>\r\n                    <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                    <source\r\n                      *ngIf=\"\r\n                        item.file.url[urlKey].endsWith('.jpg') ||\r\n                        item.file.url[urlKey].endsWith('.jpeg')\r\n                      \"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/jpeg\" />\r\n                    <source\r\n                      *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/png\" />\r\n                    <img (click)=\"click()\" [src]=\"item.file.url[urlKey]\" />\r\n                  </picture>\r\n                </ng-container>\r\n              </a>\r\n              <a *ngIf=\"isExternal(item.url)\" href=\"{{ item.url }}\">\r\n                <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                  <app-video\r\n                    *ngIf=\"item.file.type === 'video'\"\r\n                    (click)=\"click(i)\"\r\n                    [data]=\"{\r\n                      dataObject: item,\r\n                      loop: data.loopVideo,\r\n                      autoplay: data.autoplayVideo,\r\n                      src: item.file.url,\r\n                      controls: data.controlsVideo,\r\n                      muted: data.mutedVideo,\r\n                      mimeType: 'video/mp4'\r\n                    }\"></app-video>\r\n                  <img\r\n                    *ngIf=\"item.file.type === 'image'\"\r\n                    (click)=\"click(i)\"\r\n                    [src]=\"item.file.url\" />\r\n                </ng-container>\r\n                <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                  <picture>\r\n                    <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                    <source\r\n                      *ngIf=\"\r\n                        item.file.url[urlKey].endsWith('.jpg') ||\r\n                        item.file.url[urlKey].endsWith('.jpeg')\r\n                      \"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/jpeg\" />\r\n                    <source\r\n                      *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/png\" />\r\n                    <img (click)=\"click(i)\" [src]=\"item.file.url[urlKey]\" />\r\n                  </picture>\r\n                </ng-container>\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"data.parallax && data.content\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image; let i = index\">\r\n          <div class=\"swiper-zoom-container\" (click)=\"click(i)\">\r\n            <app-slot\r\n              [items]=\"data.content.components\"\r\n              [componentValue]=\"item | getArrayPath : data.content.path\"\r\n              style=\"display: block; width: 100%; height: 100%\"></app-slot>\r\n          </div>\r\n        </ng-template>\r\n      </ng-container>\r\n    </swiper>\r\n    <ng-container *ngIf=\"data.thumbs && !data.parallax\">\r\n      <swiper thumbsSwiper [config]=\"thumbnails\" (swiper)=\"thumbsSwiper = $event\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image\">\r\n          <ng-container *ngIf=\"!item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <ng-container *ngIf=\"!isObject(item.url)\">\r\n                <img\r\n                  *ngIf=\"item.type === 'video' && data.videoThumbnailUrl\"\r\n                  [src]=\"data.videoThumbnailUrl\" />\r\n                <img *ngIf=\"item.type === 'image'\" [src]=\"item.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.url[urlKey].endsWith('.jpg') ||\r\n                      item.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img [src]=\"item.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                <img\r\n                  *ngIf=\"item.type === 'video' && data.videoThumbnailUrl\"\r\n                  [src]=\"data.videoThumbnailUrl\" />\r\n                <img *ngIf=\"item.type === 'image'\" [src]=\"item.file.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.file.url[urlKey].endsWith('.jpg') ||\r\n                      item.file.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.file.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.file.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img [src]=\"item.file.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n      </swiper>\r\n    </ng-container>\r\n  </ng-container>\r\n  \r\n  <ng-container *ngIf=\"image && image.length == 1\">\r\n    <div\r\n      *ngFor=\"let item of image; let i = index\"\r\n      class=\"single-slide p-0\"\r\n      [class]=\"'col-' + singleSlideWidth\">\r\n      <ng-container *ngIf=\"data.content\">\r\n        <div class=\"swiper-zoom-container parallax-content\">\r\n          <app-slot\r\n            [items]=\"data.content.components\"\r\n            [componentValue]=\"item | getArrayPath : data.content.path\"\r\n            style=\"display: block; width: 100%; height: 100%\"></app-slot>\r\n        </div>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"item.file\">\r\n        <a *ngIf=\"!isExternal(item.url)\" [routerLink]=\"item.url\">\r\n          <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n            <app-video\r\n              *ngIf=\"item.file.type === 'video'\"\r\n              (click)=\"click()\"\r\n              [data]=\"{\r\n                dataObject: item,\r\n                loop: data.loopVideo,\r\n                autoplay: data.autoplayVideo,\r\n                src: item.file.url,\r\n                controls: data.controlsVideo,\r\n                muted: data.mutedVideo,\r\n                mimeType: 'video/mp4'\r\n              }\"></app-video>\r\n            <img\r\n              *ngIf=\"item.file.type === 'image'\"\r\n              (click)=\"click(i)\"\r\n              [src]=\"item.file.url\"\r\n              class=\"w-100\" />\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isObject(item.file.url)\">\r\n            <picture class=\"w-100\">\r\n              <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n              <source\r\n                *ngIf=\"\r\n                  item.file.url[urlKey].endsWith('.jpg') ||\r\n                  item.file.url[urlKey].endsWith('.jpeg')\r\n                \"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/jpeg\" />\r\n              <source\r\n                *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/png\" />\r\n              <img (click)=\"click(i)\" [src]=\"item.file.url[urlKey]\" />\r\n            </picture>\r\n          </ng-container>\r\n        </a>\r\n        <a *ngIf=\"isExternal(item.url)\" href=\"{{ item.url }}\">\r\n          <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n            <app-video\r\n              *ngIf=\"item.type === 'video'\"\r\n              (click)=\"click()\"\r\n              [data]=\"{\r\n                dataObject: item,\r\n                loop: data.loopVideo,\r\n                autoplay: data.autoplayVideo,\r\n                src: item.file.url,\r\n                controls: data.controlsVideo,\r\n                muted: data.mutedVideo,\r\n                mimeType: 'video/mp4'\r\n              }\"></app-video>\r\n            <img\r\n              *ngIf=\"item.file.type === 'image'\"\r\n              (click)=\"click(i)\"\r\n              [src]=\"item.file.url\"\r\n              class=\"w-100\" \r\n            />\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isObject(item.file.url)\">\r\n            <picture>\r\n              <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n              <source\r\n                *ngIf=\"\r\n                  item.file.url[urlKey].endsWith('.jpg') ||\r\n                  item.file.url[urlKey].endsWith('.jpeg')\r\n                \"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/jpeg\" />\r\n              <source\r\n                *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/png\" />\r\n              <img (click)=\"click()\" [src]=\"item.file.url[urlKey]\" />\r\n            </picture>\r\n          </ng-container>\r\n        </a>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"!item.file\">\r\n        <ng-container *ngIf=\"!isObject(item.url)\">\r\n          <app-video\r\n            *ngIf=\"item.type === 'video'\"\r\n            (click)=\"click(i)\"\r\n            [data]=\"{\r\n              dataObject: item,\r\n              loop: data.loopVideo,\r\n              autoplay: data.autoplayVideo,\r\n              src: item.url,\r\n              controls: data.controlsVideo,\r\n              muted: data.mutedVideo,\r\n              mimeType: 'video/mp4'\r\n            }\">\r\n          </app-video>\r\n          <img\r\n            *ngIf=\"item.type === 'image'\"\r\n            (click)=\"click(i)\"\r\n            [src]=\"item.url\"\r\n            class=\"w-100\" />\r\n        </ng-container>\r\n        <ng-container *ngIf=\"isObject(item.url)\">\r\n          <picture class=\"w-100\">\r\n            <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n            <source\r\n              *ngIf=\"\r\n                item.url[urlKey].endsWith('.jpg') || item.url[urlKey].endsWith('.jpeg')\r\n              \"\r\n              srcset=\"{{item.url[urlKey]}}\"\r\n              type=\"image/jpeg\" />\r\n            <source\r\n              *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n              srcset=\"{{item.url[urlKey]}}\"\r\n              type=\"image/png\" />\r\n            <img (click)=\"click(i)\" [src]=\"item.url[urlKey]\" />\r\n          </picture>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>\r\n", styles: ["@font-face{font-family:swiper-icons;src:url(data:application/font-woff;charset=utf-8;base64,\\ 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) format(\"woff\");font-weight:400;font-style:normal}:root{--swiper-theme-color: #007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-cube-shadow{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper:before{content:\"\";flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper:before{width:100%;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-pagination-fraction,.swiper-pagination-custom,.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));height:8px;height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));display:inline-block;border-radius:50%;background:#000;background:var(--swiper-pagination-bullet-inactive-color, #000);opacity:.2;opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;opacity:var(--swiper-pagination-bullet-opacity, 1);background:#007aff;background:var(--swiper-pagination-color, var(--swiper-theme-color))}.swiper-vertical>.swiper-pagination-bullets,.swiper-pagination-vertical.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;display:block}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px;margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translate(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:#007aff;background:var(--swiper-pagination-color, var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-vertical>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}:root{--swiper-navigation-size: 44px}.swiper-button-prev,.swiper-button-next{position:absolute;top:50%;width:27px;width:calc(var(--swiper-navigation-size) / 44 * 27);height:44px;height:var(--swiper-navigation-size);margin-top:-22px;margin-top:calc(0px - var(--swiper-navigation-size) / 2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#007aff;color:var(--swiper-navigation-color, var(--swiper-theme-color))}.swiper-button-prev.swiper-button-disabled,.swiper-button-next.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev.swiper-button-hidden,.swiper-button-next.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-prev,.swiper-navigation-disabled .swiper-button-next{display:none!important}.swiper-button-prev:after,.swiper-button-next:after{font-family:swiper-icons;font-size:44px;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-feature-settings:;font-variant:normal;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:\"prev\"}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:\"next\"}.swiper-button-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>img,.swiper-zoom-container>svg,.swiper-zoom-container>canvas{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-grid .swiper-slide{padding:5px;margin:0!important;opacity:.4}.swiper-slide img,.single-slide img{width:100%;cursor:pointer}.swiper-slide-thumb-active{opacity:1!important}.loadingContainer{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center;height:400px}.loadingContainer .loadingComponent{width:30%}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i8$2.SwiperComponent, selector: "swiper, [swiper]", inputs: ["enabled", "on", "direction", "touchEventsTarget", "initialSlide", "speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "width", "height", "preventInteractionOnTransition", "userAgent", "url", "edgeSwipeDetection", "edgeSwipeThreshold", "freeMode", "autoHeight", "setWrapperSize", "virtualTranslate", "effect", "breakpoints", "spaceBetween", "slidesPerView", "maxBackfaceHiddenSlides", "grid", "slidesPerGroup", "slidesPerGroupSkip", "centeredSlides", "centeredSlidesBounds", "slidesOffsetBefore", "slidesOffsetAfter", "normalizeSlideIndex", "centerInsufficientSlides", "watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "shortSwipes", "longSwipes", "longSwipesRatio", "longSwipesMs", "followFinger", "allowTouchMove", "threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "resistance", "resistanceRatio", "watchSlidesProgress", "grabCursor", "preventClicks", "preventClicksPropagation", "slideToClickedSlide", "preloadImages", "updateOnImagesReady", "loop", "loopAdditionalSlides", "loopedSlides", "loopedSlidesLimit", "loopFillGroupWithBlank", "loopPreventsSlide", "rewind", "allowSlidePrev", "allowSlideNext", "swipeHandler", "noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideBlankClass", "slideActiveClass", "slideDuplicateActiveClass", "slideVisibleClass", "slideDuplicateClass", "slideNextClass", "slideDuplicateNextClass", "slidePrevClass", "slideDuplicatePrevClass", "wrapperClass", "runCallbacksOnInit", "observeParents", "observeSlideChildren", "a11y", "autoplay", "controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "lazy", "mousewheel", "parallax", "thumbs", "zoom", "slidesPerGroupAuto", "class", "id", "navigation", "pagination", "scrollbar", "virtual", "config"], outputs: ["_beforeBreakpoint", "_containerClasses", "_slideClass", "_swiper", "activeIndexChange", "afterInit", "autoplay", "autoplayStart", "autoplayStop", "autoplayPause", "autoplayResume", "beforeDestroy", "beforeInit", "beforeLoopFix", "beforeResize", "beforeSlideChangeStart", "beforeTransitionStart", "breakpoint", "changeDirection", "click", "doubleTap", "doubleClick", "destroy", "fromEdge", "hashChange", "hashSet", "imagesReady", "init", "keyPress", "lazyImageLoad", "lazyImageReady", "loopFix", "momentumBounce", "navigationHide", "navigationShow", "navigationPrev", "navigationNext", "observerUpdate", "orientationchange", "paginationHide", "paginationRender", "paginationShow", "paginationUpdate", "progress", "reachBeginning", "reachEnd", "realIndexChange", "resize", "scroll", "scrollbarDragEnd", "scrollbarDragMove", "scrollbarDragStart", "setTransition", "setTranslate", "slideChange", "slideChangeTransitionEnd", "slideChangeTransitionStart", "slideNextTransitionEnd", "slideNextTransitionStart", "slidePrevTransitionEnd", "slidePrevTransitionStart", "slideResetTransitionStart", "slideResetTransitionEnd", "sliderMove", "sliderFirstMove", "slidesLengthChange", "slidesGridLengthChange", "snapGridLengthChange", "snapIndexChange", "tap", "toEdge", "touchEnd", "touchMove", "touchMoveOpposite", "touchStart", "transitionEnd", "transitionStart", "update", "zoomChange", "swiper", "lock", "unlock"] }, { kind: "directive", type: i8$2.SwiperSlideDirective, selector: "ng-template[swiperSlide]", inputs: ["virtualIndex", "class", "ngClass", "data-swiper-autoplay", "zoom"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i10$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: VideoComponent, selector: "app-video", inputs: ["data"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-carousel', encapsulation: ViewEncapsulation.None, providers: [GetArrayPathPipe], template: "<ng-container *ngIf=\"isBrowser\">\r\n  <!-- If we want loading bar before when loading -->\r\n  <div *ngIf=\"data.progressBar && loading\" class=\"loadingContainer\">\r\n    <!-- <mat-icon class=\"loadingIcon\">{{data.loadingIcon}}</mat-icon> -->\r\n    <div class=\"loadingComponent\">\r\n      <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"image && image.length > 1\">\r\n    <swiper\r\n      mainSwiper\r\n      [config]=\"mainBannerConfig\"\r\n      [thumbs]=\"{ swiper: thumbsSwiper }\"\r\n      [parallax]=\"data.parallax\">\r\n      <ng-container *ngIf=\"!data.parallax\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image; let i = index\">\r\n          <!-- If sliding html items -->\r\n          <ng-container *ngIf=\"!item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <!-- <ng-container *ngIf=\"data.parallax && data.content && data.parallaxOnImage\">\r\n                <div class=\"swiper-zoom-container parallax-content {{data.parallaxContentClass}}\">\r\n                    <app-slot\r\n                      [items]=\"data.content.components\"\r\n                      [componentValue]=\"item | getArrayPath: data.content.path\"\r\n                      style=\"display: block; width: 100%; height: 100%\"\r\n                    ></app-slot>\r\n                </div>\r\n              </ng-container> -->\r\n              <ng-container *ngIf=\"!isObject(item.url)\">\r\n                <app-video\r\n                  *ngIf=\"item.type === 'video'\"\r\n                  (click)=\"click(i)\"\r\n                  [data]=\"{\r\n                    dataObject: item,\r\n                    loop: data.loopVideo,\r\n                    autoplay: data.autoplayVideo,\r\n                    src: item.url,\r\n                    controls: data.controlsVideo,\r\n                    muted: data.mutedVideo,\r\n                    mimeType: 'video/mp4'\r\n                  }\">\r\n                </app-video>\r\n                <img *ngIf=\"item.type == 'image'\" (click)=\"click(i)\" [src]=\"item.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.url[urlKey].endsWith('.jpg') ||\r\n                      item.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img (click)=\"click(i)\" [src]=\"item.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- If sliding images -->\r\n          <ng-container *ngIf=\"item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <a *ngIf=\"!isExternal(item.url)\" [routerLink]=\"item.url\">\r\n                <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                  <app-video\r\n                    *ngIf=\"item.file.type === 'video'\"\r\n                    (click)=\"click()\"\r\n                    [data]=\"{\r\n                      dataObject: item,\r\n                      loop: data.loopVideo,\r\n                      autoplay: data.autoplayVideo,\r\n                      src: item.file.url,\r\n                      controls: data.controlsVideo,\r\n                      muted: data.mutedVideo,\r\n                      mimeType: 'video/mp4'\r\n                    }\"></app-video>\r\n                  <img\r\n                    *ngIf=\"item.file.type === 'image'\"\r\n                    (click)=\"click()\"\r\n                    [src]=\"item.file.url\" />\r\n                </ng-container>\r\n                <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                  <picture>\r\n                    <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                    <source\r\n                      *ngIf=\"\r\n                        item.file.url[urlKey].endsWith('.jpg') ||\r\n                        item.file.url[urlKey].endsWith('.jpeg')\r\n                      \"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/jpeg\" />\r\n                    <source\r\n                      *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/png\" />\r\n                    <img (click)=\"click()\" [src]=\"item.file.url[urlKey]\" />\r\n                  </picture>\r\n                </ng-container>\r\n              </a>\r\n              <a *ngIf=\"isExternal(item.url)\" href=\"{{ item.url }}\">\r\n                <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                  <app-video\r\n                    *ngIf=\"item.file.type === 'video'\"\r\n                    (click)=\"click(i)\"\r\n                    [data]=\"{\r\n                      dataObject: item,\r\n                      loop: data.loopVideo,\r\n                      autoplay: data.autoplayVideo,\r\n                      src: item.file.url,\r\n                      controls: data.controlsVideo,\r\n                      muted: data.mutedVideo,\r\n                      mimeType: 'video/mp4'\r\n                    }\"></app-video>\r\n                  <img\r\n                    *ngIf=\"item.file.type === 'image'\"\r\n                    (click)=\"click(i)\"\r\n                    [src]=\"item.file.url\" />\r\n                </ng-container>\r\n                <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                  <picture>\r\n                    <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                    <source\r\n                      *ngIf=\"\r\n                        item.file.url[urlKey].endsWith('.jpg') ||\r\n                        item.file.url[urlKey].endsWith('.jpeg')\r\n                      \"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/jpeg\" />\r\n                    <source\r\n                      *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                      srcset=\"{{item.file.url[urlKey]}}\"\r\n                      type=\"image/png\" />\r\n                    <img (click)=\"click(i)\" [src]=\"item.file.url[urlKey]\" />\r\n                  </picture>\r\n                </ng-container>\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"data.parallax && data.content\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image; let i = index\">\r\n          <div class=\"swiper-zoom-container\" (click)=\"click(i)\">\r\n            <app-slot\r\n              [items]=\"data.content.components\"\r\n              [componentValue]=\"item | getArrayPath : data.content.path\"\r\n              style=\"display: block; width: 100%; height: 100%\"></app-slot>\r\n          </div>\r\n        </ng-template>\r\n      </ng-container>\r\n    </swiper>\r\n    <ng-container *ngIf=\"data.thumbs && !data.parallax\">\r\n      <swiper thumbsSwiper [config]=\"thumbnails\" (swiper)=\"thumbsSwiper = $event\">\r\n        <ng-template swiperSlide *ngFor=\"let item of image\">\r\n          <ng-container *ngIf=\"!item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <ng-container *ngIf=\"!isObject(item.url)\">\r\n                <img\r\n                  *ngIf=\"item.type === 'video' && data.videoThumbnailUrl\"\r\n                  [src]=\"data.videoThumbnailUrl\" />\r\n                <img *ngIf=\"item.type === 'image'\" [src]=\"item.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.url[urlKey].endsWith('.jpg') ||\r\n                      item.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img [src]=\"item.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"item.file\">\r\n            <div class=\"swiper-zoom-container\">\r\n              <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n                <img\r\n                  *ngIf=\"item.type === 'video' && data.videoThumbnailUrl\"\r\n                  [src]=\"data.videoThumbnailUrl\" />\r\n                <img *ngIf=\"item.type === 'image'\" [src]=\"item.file.url\" />\r\n              </ng-container>\r\n              <ng-container *ngIf=\"isObject(item.file.url)\">\r\n                <picture>\r\n                  <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n                  <source\r\n                    *ngIf=\"\r\n                      item.file.url[urlKey].endsWith('.jpg') ||\r\n                      item.file.url[urlKey].endsWith('.jpeg')\r\n                    \"\r\n                    srcset=\"{{item.file.url[urlKey]}}\"\r\n                    type=\"image/jpeg\" />\r\n                  <source\r\n                    *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                    srcset=\"{{item.file.url[urlKey]}}\"\r\n                    type=\"image/png\" />\r\n                  <img [src]=\"item.file.url[urlKey]\" />\r\n                </picture>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n      </swiper>\r\n    </ng-container>\r\n  </ng-container>\r\n  \r\n  <ng-container *ngIf=\"image && image.length == 1\">\r\n    <div\r\n      *ngFor=\"let item of image; let i = index\"\r\n      class=\"single-slide p-0\"\r\n      [class]=\"'col-' + singleSlideWidth\">\r\n      <ng-container *ngIf=\"data.content\">\r\n        <div class=\"swiper-zoom-container parallax-content\">\r\n          <app-slot\r\n            [items]=\"data.content.components\"\r\n            [componentValue]=\"item | getArrayPath : data.content.path\"\r\n            style=\"display: block; width: 100%; height: 100%\"></app-slot>\r\n        </div>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"item.file\">\r\n        <a *ngIf=\"!isExternal(item.url)\" [routerLink]=\"item.url\">\r\n          <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n            <app-video\r\n              *ngIf=\"item.file.type === 'video'\"\r\n              (click)=\"click()\"\r\n              [data]=\"{\r\n                dataObject: item,\r\n                loop: data.loopVideo,\r\n                autoplay: data.autoplayVideo,\r\n                src: item.file.url,\r\n                controls: data.controlsVideo,\r\n                muted: data.mutedVideo,\r\n                mimeType: 'video/mp4'\r\n              }\"></app-video>\r\n            <img\r\n              *ngIf=\"item.file.type === 'image'\"\r\n              (click)=\"click(i)\"\r\n              [src]=\"item.file.url\"\r\n              class=\"w-100\" />\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isObject(item.file.url)\">\r\n            <picture class=\"w-100\">\r\n              <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n              <source\r\n                *ngIf=\"\r\n                  item.file.url[urlKey].endsWith('.jpg') ||\r\n                  item.file.url[urlKey].endsWith('.jpeg')\r\n                \"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/jpeg\" />\r\n              <source\r\n                *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/png\" />\r\n              <img (click)=\"click(i)\" [src]=\"item.file.url[urlKey]\" />\r\n            </picture>\r\n          </ng-container>\r\n        </a>\r\n        <a *ngIf=\"isExternal(item.url)\" href=\"{{ item.url }}\">\r\n          <ng-container *ngIf=\"!isObject(item.file.url)\">\r\n            <app-video\r\n              *ngIf=\"item.type === 'video'\"\r\n              (click)=\"click()\"\r\n              [data]=\"{\r\n                dataObject: item,\r\n                loop: data.loopVideo,\r\n                autoplay: data.autoplayVideo,\r\n                src: item.file.url,\r\n                controls: data.controlsVideo,\r\n                muted: data.mutedVideo,\r\n                mimeType: 'video/mp4'\r\n              }\"></app-video>\r\n            <img\r\n              *ngIf=\"item.file.type === 'image'\"\r\n              (click)=\"click(i)\"\r\n              [src]=\"item.file.url\"\r\n              class=\"w-100\" \r\n            />\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isObject(item.file.url)\">\r\n            <picture>\r\n              <source srcset=\"{{item.file.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n              <source\r\n                *ngIf=\"\r\n                  item.file.url[urlKey].endsWith('.jpg') ||\r\n                  item.file.url[urlKey].endsWith('.jpeg')\r\n                \"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/jpeg\" />\r\n              <source\r\n                *ngIf=\"item.file.url[urlKey].endsWith('.png')\"\r\n                srcset=\"{{item.file.url[urlKey]}}\"\r\n                type=\"image/png\" />\r\n              <img (click)=\"click()\" [src]=\"item.file.url[urlKey]\" />\r\n            </picture>\r\n          </ng-container>\r\n        </a>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"!item.file\">\r\n        <ng-container *ngIf=\"!isObject(item.url)\">\r\n          <app-video\r\n            *ngIf=\"item.type === 'video'\"\r\n            (click)=\"click(i)\"\r\n            [data]=\"{\r\n              dataObject: item,\r\n              loop: data.loopVideo,\r\n              autoplay: data.autoplayVideo,\r\n              src: item.url,\r\n              controls: data.controlsVideo,\r\n              muted: data.mutedVideo,\r\n              mimeType: 'video/mp4'\r\n            }\">\r\n          </app-video>\r\n          <img\r\n            *ngIf=\"item.type === 'image'\"\r\n            (click)=\"click(i)\"\r\n            [src]=\"item.url\"\r\n            class=\"w-100\" />\r\n        </ng-container>\r\n        <ng-container *ngIf=\"isObject(item.url)\">\r\n          <picture class=\"w-100\">\r\n            <source srcset=\"{{item.url[urlKeyWebp]}}\" type=\"image/webp\" />\r\n            <source\r\n              *ngIf=\"\r\n                item.url[urlKey].endsWith('.jpg') || item.url[urlKey].endsWith('.jpeg')\r\n              \"\r\n              srcset=\"{{item.url[urlKey]}}\"\r\n              type=\"image/jpeg\" />\r\n            <source\r\n              *ngIf=\"item.url[urlKey].endsWith('.png')\"\r\n              srcset=\"{{item.url[urlKey]}}\"\r\n              type=\"image/png\" />\r\n            <img (click)=\"click(i)\" [src]=\"item.url[urlKey]\" />\r\n          </picture>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>\r\n", styles: ["@font-face{font-family:swiper-icons;src:url(data:application/font-woff;charset=utf-8;base64,\\ d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA) format(\"woff\");font-weight:400;font-style:normal}:root{--swiper-theme-color: #007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-cube-shadow{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper:before{content:\"\";flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper:before{width:100%;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-pagination-fraction,.swiper-pagination-custom,.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));height:8px;height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));display:inline-block;border-radius:50%;background:#000;background:var(--swiper-pagination-bullet-inactive-color, #000);opacity:.2;opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;opacity:var(--swiper-pagination-bullet-opacity, 1);background:#007aff;background:var(--swiper-pagination-color, var(--swiper-theme-color))}.swiper-vertical>.swiper-pagination-bullets,.swiper-pagination-vertical.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;display:block}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px;margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translate(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:#007aff;background:var(--swiper-pagination-color, var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-vertical>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}:root{--swiper-navigation-size: 44px}.swiper-button-prev,.swiper-button-next{position:absolute;top:50%;width:27px;width:calc(var(--swiper-navigation-size) / 44 * 27);height:44px;height:var(--swiper-navigation-size);margin-top:-22px;margin-top:calc(0px - var(--swiper-navigation-size) / 2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#007aff;color:var(--swiper-navigation-color, var(--swiper-theme-color))}.swiper-button-prev.swiper-button-disabled,.swiper-button-next.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev.swiper-button-hidden,.swiper-button-next.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-prev,.swiper-navigation-disabled .swiper-button-next{display:none!important}.swiper-button-prev:after,.swiper-button-next:after{font-family:swiper-icons;font-size:44px;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-feature-settings:;font-variant:normal;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:\"prev\"}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:\"next\"}.swiper-button-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>img,.swiper-zoom-container>svg,.swiper-zoom-container>canvas{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-grid .swiper-slide{padding:5px;margin:0!important;opacity:.4}.swiper-slide img,.single-slide img{width:100%;cursor:pointer}.swiper-slide-thumb-active{opacity:1!important}.loadingContainer{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center;height:400px}.loadingContainer .loadingComponent{width:30%}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: LanguageService }, { type: GetArrayPathPipe }, { type: i0.NgZone }, { type: i1.ActivatedRoute }, { type: i6$2.BreakpointObserver }, { type: CommunicationService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class CarouselModule {
    constructor(routing) {
        routing.mapComponent('CarouselComponent', CarouselComponent);
    }
}
CarouselModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CarouselModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
CarouselModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent], imports: [CommonModule,
        FormsModule,
        SwiperModule,
        SlotModule,
        MatCardModule,
        PipesModule,
        MatIconModule,
        MatProgressBarModule,
        PrimitiveModule,
        RouterModule] });
CarouselModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CarouselModule, imports: [CommonModule,
        FormsModule,
        SwiperModule,
        SlotModule,
        MatCardModule,
        PipesModule,
        MatIconModule,
        MatProgressBarModule,
        PrimitiveModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CarouselComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        SwiperModule,
                        SlotModule,
                        MatCardModule,
                        PipesModule,
                        MatIconModule,
                        MatProgressBarModule,
                        PrimitiveModule,
                        RouterModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var carousel_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   CarouselModule: CarouselModule
});

class CustomFormControl extends UntypedFormControl {
}

class GetFieldComponent {
    transform(fieldType) {
        const typeMap = {
            hidden: 'InputComponent',
            textarea: 'InputComponent',
            dateRange: 'DaterangeComponent',
            datePicker: 'DatepickerComponent',
            'multi-autocomplete': 'MultiAutocompleteComponent',
            radio: 'RadiobuttonComponent',
            timePicker: 'TimepickerComponent',
            slidetoggle: 'SlideToggleComponent'
        };
        let component;
        if (typeof typeMap[fieldType] === 'undefined') {
            component = (fieldType.charAt(0).toUpperCase()
                + fieldType.slice(1)
                + 'Component');
        }
        else {
            component = typeMap[fieldType];
        }
        return component;
    }
}
GetFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
GetFieldComponent.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GetFieldComponent, name: "getFieldComponent" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GetFieldComponent, decorators: [{
            type: Pipe,
            args: [{
                    name: "getFieldComponent"
                }]
        }] });

class FormComponent extends BaseComponent {
    constructor(route, router, getArrayPath, join, evaluator, alert, dialog, zone, state, session, cloner, permissionService, location, injector, getArrayPathService, getControlByPath, recaptcha, googleTranslateService, helper, cache, customValidators, transformData, relDate) {
        super();
        this.route = route;
        this.router = router;
        this.getArrayPath = getArrayPath;
        this.join = join;
        this.evaluator = evaluator;
        this.alert = alert;
        this.dialog = dialog;
        this.zone = zone;
        this.state = state;
        this.session = session;
        this.cloner = cloner;
        this.permissionService = permissionService;
        this.location = location;
        this.injector = injector;
        this.getArrayPathService = getArrayPathService;
        this.getControlByPath = getControlByPath;
        this.recaptcha = recaptcha;
        this.googleTranslateService = googleTranslateService;
        this.helper = helper;
        this.cache = cache;
        this.customValidators = customValidators;
        this.transformData = transformData;
        this.relDate = relDate;
        this.formData = new UntypedFormGroup({});
        this.extractedFields = {};
        this.fieldGroups = {};
        this.formArrays = {};
        this.initialFieldValues = {
            checkbox: false
        };
        this.dragPlaceholderHeight = 60;
        this.initialized = false;
    }
    getFormArrayItemName(formArray) {
        return 'formArray'
            + formArray.charAt(0).toUpperCase()
            + formArray.slice(1)
            + 'Item';
    }
    getInitialValue(field) {
        let initialValue = '';
        if (typeof this.initialFieldValues[field.type] !== 'undefined') {
            initialValue = this.initialFieldValues[field.type];
        }
        return initialValue;
    }
    ngOnInit() {
        // execute before init event handler if form is in action
        if (typeof this.data.beforeInit === 'function') {
            this.data.beforeInitParams = {
                event: 'beforeInit'
            };
            if (this.data.dataObject) {
                this.data.beforeInitParams.dataObject = this.data.dataObject;
            }
            const result = this.data.beforeInit(this.data.beforeInitParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
        this.rows = JSON.parse(JSON.stringify(this.data.rows));
        const languages = this.state.get('languages.all');
        this.languages = Object.keys(languages);
        this.translatableFields = {};
        if (typeof this.data.dataSource !== 'undefined') {
            if (this.data.reloadsWithUrl) {
                // Refresh data if query params or url param has been changed
                combineLatest([
                    this.route.queryParams.pipe(startWith(null)),
                    this.route.params.pipe(startWith(null))
                ]).pipe(takeUntil(this.destroyed), debounceTime(0))
                    .subscribe((params) => {
                    if (this.urlParams
                        && JSON.stringify(this.urlParams) !== JSON.stringify(params)) {
                        this.load();
                        this.urlParams = params;
                    }
                    else if (typeof this.urlParams === 'undefined') {
                        this.urlParams = params;
                    }
                });
            }
        }
        this.init();
        super.ngOnInit();
        // execute last
        setTimeout(() => {
            if (this.data.loadOnInit !== false) {
                this.load();
            }
            // execute init event handler if form is in action
            if (typeof this.data.init === 'function') {
                this.data.initParams = {
                    event: 'init'
                };
                if (this.data.dataObject) {
                    this.data.initParams.dataObject = this.data.dataObject;
                }
                const result = this.data.init(this.data.initParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
            // Listen for value changes and execute valueChanges event on change
            if (typeof this.data.valueChanges === 'function') {
                this.formData.valueChanges
                    .pipe(takeUntil(this.destroyed), debounceTime(500))
                    .subscribe(value => {
                    if (typeof this.data.valueChanges === 'function') {
                        this.data.valueChangesParams = {
                            event: 'valueChanges'
                        };
                        this.data.valueChangesParams.dataObject = value;
                    }
                    const result = this.data.valueChanges(this.data.valueChangesParams);
                    if (result instanceof Observable) {
                        result.pipe(take$1(1)).subscribe();
                    }
                });
            }
        });
        this.registerInParent();
    }
    init(reinit = false) {
        let prevValues;
        if (reinit) {
            this.fieldGroups = {};
            this.formArrays = {};
            this.translatableFields = undefined;
            this.extractedFields = undefined;
            const tmpRows = JSON.parse(JSON.stringify(this.rows));
            this.rows = null;
            this.rows = tmpRows;
            prevValues = this.formData.value;
            for (const control in this.formData.controls) {
                this.formData.removeControl(control);
            }
            ;
        }
        const validators = this.validateControl(this.data);
        this.formData.setValidators(validators[0]);
        this.formData.setAsyncValidators(validators[1]);
        // TODO figure out how not to duplicate if already exists
        if (!this.initialized
            && (typeof this.data.validStatus === 'function'
                || typeof this.data.invalidStatus === 'function')) {
            this.formData.statusChanges
                .pipe(takeUntil(this.destroyed))
                .subscribe(newStatus => {
                if (newStatus === 'VALID' && typeof this.data.validStatus === 'function') {
                    this.data.validStatusParams = {
                        event: 'validStatus',
                        formValue: this.formData.value
                    };
                    if (this.data.dataObject) {
                        this.data.validStatusParams.dataObject = this.data.dataObject;
                    }
                    const result = this.data.validStatus(this.data.validStatusParams);
                    if (result instanceof Observable) {
                        result.pipe(take$1(1)).subscribe(() => { });
                    }
                }
                if (newStatus === 'INVALID' && typeof this.data.invalidStatus === 'function') {
                    this.data.invalidStatusParams = {
                        event: 'invalidStatus',
                        formValue: this.formData.value
                    };
                    if (this.data.dataObject) {
                        this.data.invalidStatusParams.dataObject = this.data.dataObject;
                    }
                    const result = this.data.invalidStatus(this.data.invalidStatusParams);
                    if (result instanceof Observable) {
                        result.pipe(take$1(1)).subscribe(() => { });
                    }
                }
            });
        }
        this.rows.forEach((row) => {
            if (row.formArray) {
                if (typeof row.dragPlaceholderHeight !== 'undefined') {
                    this.dragPlaceholderHeight = row.dragPlaceholderHeight;
                }
                if (typeof this.formData.controls[row.formArray] === 'undefined') {
                    this.formData.addControl(row.formArray, new UntypedFormArray([]));
                }
            }
            row.cols.forEach((col) => {
                if (typeof col.fields !== 'undefined') {
                    col.fields.forEach((field) => {
                        if (!('extractPath' in field) && !this.isFieldVisible(field)) {
                            return;
                        }
                        if (typeof field.disabled !== 'undefined' && field.disabled === 'invalid') {
                            field.disabled = this.formData.invalid;
                            if (field.type === 'submit') {
                                field.buttonData.disabled = field.disabled;
                            }
                            this.formData.statusChanges
                                .pipe(takeUntil(this.destroyed))
                                .subscribe(newStatus => {
                                // TODO works inconsistently
                                // figure out a way to work with the field control
                                // rather than the field definition
                                field.disabled = newStatus === 'INVALID';
                                if (field.type === 'submit') {
                                    field.buttonData.disabled = field.disabled;
                                }
                            });
                        }
                        if (!this.permissionService.checkPermissions(field)) {
                            return;
                        }
                        if (row.formArray) {
                            field.formArray = row.formArray;
                            field.formGroup = this.getFormArrayItemName(row.formArray);
                        }
                        if ('translatable' in field
                            && field.translatable) {
                            // default header tabs position is above
                            if (field.translatable === true) {
                                field.translatable = 'above';
                            }
                            this.translatableFields[field.name] = {};
                            this.languages.forEach((lang) => {
                                const fieldName = 'translations-' + lang + '-' + field.name;
                                const transField = Object.assign({}, field);
                                transField.name = fieldName;
                                this.translatableFields[field.name][lang] = transField;
                                this.hasTranslatable = true;
                                if (transField.formGroup) {
                                    if (typeof this.fieldGroups[transField.formGroup] === 'undefined') {
                                        // if formGroup attribute is present initiate form group
                                        // with the formGroup attribute value as name
                                        this.fieldGroups[transField.formGroup] = new UntypedFormGroup({});
                                        this.formData.addControl(transField.formGroup, this.fieldGroups[transField.formGroup]);
                                    }
                                    // if field is part of a group add it to the Form Group control
                                    // and refresh the control
                                    const control = new CustomFormControl({
                                        value: this.getInitialValue(transField),
                                        disabled: (transField.disabled)
                                    }, ...this.validateControl(transField));
                                    control.def = JSON.parse(JSON.stringify(transField));
                                    this.fieldGroups[transField.formGroup].addControl(fieldName, control);
                                    this.formData.setControl(transField.formGroup, this.fieldGroups[transField.formGroup]);
                                }
                                else {
                                    this.formData.addControl(fieldName, new UntypedFormControl({
                                        value: this.getInitialValue(transField),
                                        disabled: transField.disabled
                                    }, ...this.validateControl(transField)));
                                    this.formData.get(fieldName).def = JSON.parse(JSON.stringify(transField));
                                }
                            });
                        }
                        else {
                            const testField = field;
                            if (!testField.extractPath) {
                                if (field.formGroup) {
                                    if (typeof this.fieldGroups[field.formGroup] === 'undefined') {
                                        // if formGroup attribute is present initiate form group
                                        // with the formGroup attribute value as name
                                        this.fieldGroups[field.formGroup] = new UntypedFormGroup({});
                                        this.formData.addControl(field.formGroup, this.fieldGroups[field.formGroup]);
                                    }
                                    // if field is part of a group add it to the Form Group control
                                    // and refresh the control
                                    if (field.type === 'dateRange') {
                                        this.fieldGroups[field.formGroup].addControl(field.name + '_from', new UntypedFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field)));
                                        this.fieldGroups[field.formGroup].addControl(field.name + '_to', new UntypedFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field)));
                                    }
                                    else {
                                        const control = new CustomFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field));
                                        control.def = JSON.parse(JSON.stringify(field));
                                        this.fieldGroups[field.formGroup].addControl(field.name, control);
                                    }
                                    this.formData.setControl(field.formGroup, this.fieldGroups[field.formGroup]);
                                }
                                else {
                                    if (field.type === 'dateRange') {
                                        this.formData.addControl(field.name + '_from', new UntypedFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field)));
                                        this.formData.addControl(field.name + '_to', new UntypedFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field)));
                                    }
                                    else {
                                        const control = new CustomFormControl({
                                            value: this.getInitialValue(field),
                                            disabled: (field.disabled)
                                        }, ...this.validateControl(field));
                                        control.def = JSON.parse(JSON.stringify(field));
                                        this.formData.addControl(field.name, control);
                                    }
                                }
                                switch (field.name) {
                                    case 'cancel':
                                        if ('buttonData' in field) {
                                            field.buttonData.click = function () {
                                                this.location.back();
                                            }.bind(this);
                                        }
                                        break;
                                }
                            }
                        }
                        if ('dataSource' in field
                            && field.dataSource
                            && ['multi-autocomplete', 'autocomplete', 'select'].indexOf(field.type) < 0) {
                            if (typeof field.dataSource.params === 'undefined') {
                                field.dataSource.params = {};
                            }
                            const dataService = this.api.getService(field.dataSource.service);
                            dataService[field.dataSource.method](field.dataSource.params)
                                .pipe(take$1(1))
                                .subscribe((response) => {
                                switch (field.type) {
                                    default:
                                        field.value = this.getArrayPath.transform(response.result.data, field.dataSource.valuePath);
                                        break;
                                }
                            });
                        }
                        if (typeof this.data.dataSource === 'undefined'
                            && typeof this.data.dataObject === 'undefined'
                            && typeof field.valuePath !== 'undefined'
                            && !('dataSource' in field)) {
                            const storage = this[field.valuePath[0]];
                            if (storage) {
                                const path = [...field.valuePath];
                                path.shift();
                                const value = storage.get(path.join('.'));
                                // transform the value
                                if (field.formGroup) {
                                    if (typeof field.transform !== 'undefined') {
                                        this.formData.get(field.formGroup).get(field.name)
                                            .setValue(this.transformData.transform(value, field.transform));
                                    }
                                    else {
                                        this.formData.get(field.formGroup).get(field.name).setValue(value);
                                    }
                                }
                                else {
                                    if (typeof field.transform !== 'undefined') {
                                        this.formData.get(field.name).setValue(this.transformData.transform(value, field.transform));
                                    }
                                    else {
                                        this.formData.get(field.name).setValue(value);
                                    }
                                }
                            }
                        }
                        if (field.value || field.value === 0) {
                            // If the field has default value that comes from the url or directly
                            // from the config json
                            this.route.params
                                .pipe(take$1(1))
                                .subscribe(urlParams => {
                                let formGroup;
                                if (field.formGroup) {
                                    formGroup = this.formData.get(field.formGroup);
                                }
                                else {
                                    formGroup = this.formData;
                                }
                                if (typeof field.value === 'string' && field.value.startsWith(':')) {
                                    const key = field.value.replace(':', '');
                                    if (urlParams[key]) {
                                        if ((field.type === 'select'
                                            && field.multiple)
                                            || (field.type === 'action'
                                                && field.control.component === 'SelectComponent'
                                                && field.control.data.multiple)) {
                                            formGroup.get(field.name).setValue(urlParams[key].split(','));
                                        }
                                        else if (field.type === 'dateRange'
                                            || (field.type === 'action'
                                                && field.control.component === 'DaterangeComponent')) {
                                            const split = urlParams[key].split('..');
                                            if (split[0]) {
                                                try {
                                                    formGroup.get(field.name + '_from').setValue(formatDate(split[0], 'yyyy-MM-dd', 'en-GB'));
                                                }
                                                catch (error) {
                                                    formGroup.get(field.name + '_from').setValue(formatDate(this.relDate.parse(split[0]), 'yyyy-MM-dd', 'en-GB'));
                                                }
                                            }
                                            if (split[1]) {
                                                try {
                                                    formGroup.get(field.name + '_to').setValue(formatDate(split[1], 'yyyy-MM-dd', 'en-GB'));
                                                }
                                                catch (error) {
                                                    formGroup.get(field.name + '_to').setValue(formatDate(this.relDate.parse(split[1]), 'yyyy-MM-dd', 'en-GB'));
                                                }
                                            }
                                        }
                                        else {
                                            if (!isNaN(+urlParams[key])) {
                                                formGroup.get(field.name).setValue(+urlParams[key]);
                                            }
                                            else {
                                                formGroup.get(field.name).setValue(urlParams[key]);
                                            }
                                        }
                                    }
                                    else {
                                        if ((field.type === 'select'
                                            && field.multiple)
                                            || (field.type === 'action'
                                                && field.control.component === 'SelectComponent'
                                                && field.control.data.multiple)) {
                                            formGroup.get(field.name).setValue([]);
                                        }
                                        else if (field.type === 'dateRange'
                                            || (field.type === 'action'
                                                && field.control.component === 'DaterangeComponent')) {
                                            formGroup.get(field.name + '_from').setValue('');
                                            formGroup.get(field.name + '_to').setValue('');
                                        }
                                        else {
                                            formGroup.get(field.name).setValue('');
                                        }
                                    }
                                }
                                else {
                                    if (field.type === 'dateRange'
                                        || (field.type === 'action'
                                            && field.control.component === 'DaterangeComponent')) {
                                        formGroup.get(field.name + '_from').setValue(field.value[0]);
                                        formGroup.get(field.name + '_to').setValue(field.value[1]);
                                    }
                                    else {
                                        formGroup.get(field.name).setValue(field.value);
                                    }
                                }
                            });
                        }
                    });
                }
            });
            if (row.formArray) {
                this.formArrays[row.formArray] = this.formData.get(row.formArray);
                // tslint:disable-next-line: no-string-literal
                this.formArrays[row.formArray]['name'] = row.formArray;
                const formArrayItemName = this.getFormArrayItemName(row.formArray);
                this.formArrays[row.formArray].push(this.fieldGroups[formArrayItemName]);
                delete this.fieldGroups[formArrayItemName];
                this.formData.removeControl(formArrayItemName);
            }
        });
        if (reinit && prevValues) {
            this.load();
            this.formData.patchValue(prevValues);
        }
        this.initialized = true;
    }
    prepareFormResult(res) {
        this.data.dataObject = res;
        // Clear out form arrays on reload
        for (const fa in this.formArrays) {
            while (this.formArrays[fa].length > 1) {
                this.formArrays[fa].removeAt(-1);
            }
        }
        this.rows.forEach((row) => {
            if (row.formArray) {
                let resultArray;
                if (typeof row.path !== 'undefined') {
                    resultArray = this.getArrayPathService.get(res, row.path);
                }
                else if (typeof res[row.formArray] !== 'undefined') {
                    resultArray = res[row.formArray];
                }
                if (typeof resultArray !== 'undefined') {
                    // If the row is form array find all matched elements in the
                    // response and set the values
                    const formArray = this.formArrays[row.formArray];
                    let lastGroupUid = 0;
                    // tslint:disable-next-line: forin
                    for (const index in resultArray) {
                        const clonedControl = this.cloner
                            .clone(formArray.at(0));
                        // tslint:disable-next-line: no-string-literal
                        clonedControl['dataObject'] = resultArray[index];
                        if (row.groupBy) {
                            // if formArray rows need to be group by a value to be removed
                            // together set the group id
                            // tslint:disable-next-line: no-string-literal
                            clonedControl['groupUid'] = this.getArrayPath.transform(resultArray[index], row.groupBy);
                            // tslint:disable-next-line: no-string-literal
                            if (lastGroupUid !== clonedControl['groupUid']) {
                                // tslint:disable-next-line: no-string-literal
                                clonedControl['startGroupClass'] = 'groupStart';
                            }
                            // tslint:disable-next-line: no-string-literal
                            lastGroupUid = clonedControl['groupUid'];
                        }
                        formArray.push(clonedControl);
                        // tslint:disable-next-line:forin
                        for (const fieldName in clonedControl.controls) {
                            clonedControl.controls[fieldName]['dataObject'] = { ...resultArray[index] };
                            if (fieldName.startsWith('translations')) {
                                const parseFieldName = fieldName.split('-');
                                const locale = parseFieldName[1];
                                const prop = parseFieldName[2];
                                const translation = resultArray[index].translations
                                    .find(item => item.locale === locale);
                                if (typeof translation !== 'undefined'
                                    && typeof translation[prop] !== 'undefined') {
                                    clonedControl.controls[fieldName].setValue(translation[prop]);
                                }
                            }
                            else {
                                let currentField;
                                row.cols.forEach((col) => {
                                    if (typeof col.fields !== 'undefined') {
                                        col.fields.forEach((field) => {
                                            if (!this.isFieldVisible(field)) {
                                                return;
                                            }
                                            if (field.name === fieldName) {
                                                currentField = field;
                                                return;
                                            }
                                        });
                                    }
                                });
                                if (typeof currentField !== 'undefined') {
                                    if (currentField.type === 'select'
                                        && typeof currentField.optionsPath !== 'undefined') {
                                        // if field is select and options path is specified
                                        // population field options
                                        currentField.options = this.getArrayPath.transform(resultArray[index], currentField.optionsPath);
                                    }
                                    if (typeof currentField.validation?.condition !== 'undefined') {
                                        // if validation has condition clear validators and
                                        // reevaluate in the context of the FormArray
                                        clonedControl.controls[fieldName].clearValidators();
                                        const validators = this.validateControl(currentField, resultArray[index]);
                                        clonedControl.controls[fieldName].setValidators(validators[0]);
                                        clonedControl.controls[fieldName].setAsyncValidators(validators[1]);
                                    }
                                    this.setFieldValue(currentField, resultArray[index], clonedControl.controls[fieldName]);
                                }
                            }
                        }
                    }
                    formArray.controls.map((item, i) => {
                        const addControl = item.get('add');
                        if (addControl) {
                            if (addControl.def?.events?.click?.addRows?.duplicate
                                || (Array.isArray(addControl.def?.events?.click)
                                    && addControl.def?.events?.click?.find((item) => {
                                        return item.action === 'addRows';
                                    }))) {
                                return;
                            }
                            if (addControl.def?.events?.click?.addRows?.prepend === true) {
                                if (i > 1) {
                                    addControl.disable();
                                }
                                else {
                                    addControl.enable();
                                }
                            }
                            else {
                                if (i < formArray.length - 1) {
                                    addControl.disable();
                                }
                            }
                        }
                    });
                    if (formArray.length > 1) {
                        formArray.removeAt(0);
                    }
                }
            }
            else {
                row.cols.forEach((col) => {
                    if (typeof col.fields !== 'undefined') {
                        col.fields.forEach((field) => {
                            const originalField = field;
                            field = this.parseFieldLabel(field, res);
                            if (!this.permissionService.checkPermissions(field)) {
                                return;
                            }
                            if ('translatable' in field
                                && field.translatable
                                && typeof res.translations !== 'undefined') {
                                if (!this.isFieldVisible(field))
                                    return;
                                res.translations.forEach((translation) => {
                                    const fieldName = 'translations-' + translation.locale + '-' + field.name;
                                    if (field.formGroup) {
                                        this.formData
                                            .get(field.formGroup)
                                            .get(fieldName)
                                            .setValue(translation[field.name]);
                                    }
                                    else {
                                        this.formData.get(fieldName).setValue(translation[field.name]);
                                    }
                                });
                            }
                            else {
                                const extField = field;
                                if (extField.extractPath) {
                                    // if fields needs to extract data from response to generate constrols
                                    // find data in response
                                    const extractedFieldsData = this.getArrayPath.transform(res, extField.extractPath);
                                    // for each data item generate id based on extractPath
                                    let fieldId = this.join.transform(extField.extractPath);
                                    if (fieldId === '') {
                                        fieldId = field.name;
                                    }
                                    extField.id = fieldId;
                                    originalField.id = fieldId;
                                    this.extractedFields[fieldId] = [];
                                    if (extField.formGroup
                                        && typeof this.fieldGroups[field.formGroup] === 'undefined') {
                                        // if formGroup attribute is present initiate form group
                                        // with the formGroup attribute value as name
                                        this.fieldGroups[field.formGroup] = new UntypedFormGroup({});
                                        this.formData.addControl(extField.formGroup, this.fieldGroups[field.formGroup]);
                                    }
                                    let i = 1;
                                    for (const extractedField of extractedFieldsData) {
                                        if (!this.isFieldVisible(field, extractedField))
                                            continue;
                                        // clone field config
                                        const clonedField = JSON.parse(JSON.stringify(field));
                                        if (clonedField.conditionalAttrs) {
                                            for (const attrSet of clonedField.conditionalAttrs) {
                                                if (attrSet.condition) {
                                                    if (this.evaluator.exec(extractedField, attrSet.condition)) {
                                                        delete attrSet.condition;
                                                        Object.assign(clonedField, attrSet);
                                                    }
                                                }
                                                else {
                                                    throw new Error('Each conditionalAttrs object needs to contain' +
                                                        'at least one condition');
                                                }
                                            }
                                            delete clonedField.conditionalAttrs;
                                        }
                                        if (extractedFieldsData.length === i
                                            && 'dataSource' in clonedField
                                            && typeof clonedField.dataSource !== 'undefined'
                                            && typeof clonedField.dataSource.params !== 'undefined'
                                            && typeof clonedField.dataSource.params.batch !== 'undefined') {
                                            clonedField.dataSource.params.batch.stage = 'finish';
                                        }
                                        // remove extractPath as this field is the result of the extraction
                                        delete clonedField.extractPath;
                                        // extract name, label and placeholder from response
                                        clonedField.name = this.getArrayPath.transform(extractedField, clonedField.name);
                                        if (typeof clonedField.label === 'string'
                                            || Array.isArray(clonedField.label)) {
                                            clonedField.label = this.getArrayPath.transform(extractedField, clonedField.label);
                                        }
                                        if (typeof clonedField.placeholder === 'string'
                                            || Array.isArray(clonedField.placeholder)) {
                                            clonedField.placeholder = this.getArrayPath.transform(extractedField, clonedField.placeholder);
                                        }
                                        if ('suffixText' in clonedField
                                            && typeof clonedField.suffixTextPath !== 'undefined') {
                                            // extract field options of suffixTextPath is specified
                                            clonedField.suffixText = this.getArrayPath.transform(extractedField, clonedField.suffixTextPath);
                                        }
                                        // add form control based on extracted field
                                        if (extField.formGroup) {
                                            // if field is part of a group add it to the Form Group control
                                            // and refresh the control
                                            const formState = {
                                                value: this.getInitialValue(extField),
                                                disabled: extField.disabled
                                            };
                                            switch (typeof clonedField.disabled) {
                                                case 'object':
                                                    formState.disabled = this.evaluator.exec(extractedField, clonedField.disabled);
                                                    break;
                                                case 'boolean':
                                                    formState.disabled = clonedField.disabled;
                                                    break;
                                            }
                                            const control = new CustomFormControl(formState, ...this.validateControl(clonedField, extractedField));
                                            if (clonedField.draggable) {
                                                control.order = i;
                                            }
                                            this.fieldGroups[extField.formGroup].addControl(clonedField.name, control);
                                            this.formData.setControl(extField.formGroup, this.fieldGroups[extField.formGroup]);
                                        }
                                        else {
                                            this.formData.addControl(clonedField.name, new UntypedFormControl({
                                                value: this.getInitialValue(clonedField),
                                                disabled: (clonedField.disabled)
                                            }, ...this.validateControl(clonedField, extractedField)));
                                        }
                                        clonedField.dataObject = extractedField;
                                        // store extracted field for template rendering
                                        this.extractedFields[fieldId].push(clonedField);
                                        this.setFieldValue(clonedField, extractedField);
                                        i++;
                                    }
                                }
                                else {
                                    if (!this.isFieldVisible(field)) {
                                        const parentControl = this.getFieldControl(field, true);
                                        if (parentControl instanceof FormGroup) {
                                            const control = parentControl.get(field.name);
                                            if (this.compareFieldWithDef(field, control.def)) {
                                                parentControl.removeControl(field.name);
                                            }
                                        }
                                        return;
                                    }
                                    this.setFieldValue(field, res);
                                }
                            }
                        });
                    }
                });
            }
        });
        // execute loaded event handler if form is in action
        if (typeof this.data.loaded === 'function') {
            this.data.loadedParams = {
                event: 'loaded',
                parentForm: this.formData
            };
            if (this.data.dataObject) {
                this.data.loadedParams.dataObject = this.data.dataObject;
            }
            const result = this.data.loaded(this.data.loadedParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    load(dataSourceParamsToAdd) {
        this.route.paramMap
            .pipe(take$1(1))
            .subscribe(params => {
            // TODO should be removed and hidden input should be used for id
            this.id = +params.get('id');
            if (this.id > 0) {
                this.formData.addControl('id', new UntypedFormControl(''));
                this.formData.get('id').setValue(this.id);
            }
            // END
            if (typeof this.data.dataSource !== 'undefined') {
                if (['state', 'session', 'cache'].indexOf(this.data.dataSource.service) >= 0) {
                    // Use state, session or cache service for dataSource
                    let stateServicePath = [];
                    stateServicePath.push(this.data.dataSource.service);
                    if (this.data.dataSource.path) {
                        stateServicePath.push(this.data.dataSource.path);
                    }
                    const stateObject = this.getArrayPath.transform(null, stateServicePath);
                    if (typeof stateObject !== 'undefined' && stateObject !== '') {
                        this.prepareFormResult(stateObject);
                    }
                }
                else {
                    // Use SDK service
                    const dataService = this.api.getService(this.data.dataSource.service);
                    // If params has dynamic params from route url - search and replace them
                    const parsedParams = {};
                    params.keys.forEach((param) => {
                        if (param.indexOf('.') >= 0) {
                            // if key is dot notation use it as destination path
                            this.helper.setObjectPath(param, params.get(param), parsedParams);
                        }
                    });
                    // parse data source params and replace any url params that are mapped
                    let dataSourceParams;
                    if (typeof this.data.dataSource.params !== 'undefined') {
                        let paramStr = JSON.stringify(this.data.dataSource.params);
                        if (typeof this.data.dataSource.params === 'object') {
                            const pattern = /\"(:[\w-]+?)\"/g;
                            let placeholder;
                            // tslint:disable-next-line: no-conditional-assignment
                            while ((placeholder = pattern.exec(paramStr)) !== null) {
                                const param = placeholder[1].replace(':', '');
                                const search = placeholder[1];
                                if (typeof parsedParams[param] === 'object') {
                                    // if value to be set is an object
                                    // remote the quotes around the placeholder (:something)
                                    const searchParam = `\"${search}\"`;
                                    let parsedParamsStr = JSON.stringify(parsedParams[param]);
                                    paramStr = paramStr.replace(new RegExp(searchParam, 'g'), parsedParamsStr);
                                }
                                if (param) {
                                    paramStr = paramStr.replace(search, params.get(param));
                                }
                            }
                            // if values from internal storage should be passed
                            const internalStorageValues = /{([\w-]+)\.([\w.-]+)}/gm;
                            let internalStorageMatch;
                            // tslint:disable-next-line: no-conditional-assignment
                            while ((internalStorageMatch = internalStorageValues.exec(paramStr)) !== null) {
                                const statePath = [];
                                let paramValuePath;
                                if (internalStorageMatch.index === internalStorageValues.lastIndex) {
                                    internalStorageValues.lastIndex++;
                                }
                                // Always skip first iteration as it will return the whole object param
                                internalStorageMatch.forEach((match, groupIndex) => {
                                    if (groupIndex !== 0) {
                                        statePath.push(match);
                                    }
                                    else {
                                        paramValuePath = match;
                                    }
                                });
                                if (statePath.length) {
                                    const pathValue = this.getArrayPathService.get(undefined, statePath);
                                    paramStr = paramStr.replace(new RegExp(paramValuePath, 'g'), pathValue);
                                }
                            }
                        }
                        dataSourceParams = JSON.parse(paramStr);
                    }
                    else {
                        dataSourceParams = {};
                    }
                    if (typeof dataSourceParamsToAdd !== 'undefined') {
                        dataSourceParams = Object.assign(dataSourceParams, dataSourceParamsToAdd);
                    }
                    dataService[this.data.dataSource.method](dataSourceParams)
                        .pipe(take$1(1), catchError$1(err => {
                        if (typeof this.data.dataSourceError === 'function') {
                            if (typeof this.data.dataSourceErrorParams === 'undefined') {
                                this.data.dataSourceErrorParams = {
                                    event: 'dataSourceError'
                                };
                            }
                            this.data.dataSourceErrorParams.event = 'dataSourceError';
                            if (err instanceof JsonRpcError) {
                                this.data.dataSourceErrorParams.errorMessage = err
                                    .message;
                            }
                            const result = this.data.dataSourceError(this.data.dataSourceErrorParams);
                            if (result instanceof Observable) {
                                result.pipe(take$1(1)).subscribe();
                            }
                            return throwError(() => err);
                        }
                    }))
                        .subscribe((response) => {
                        this.prepareFormResult(response.result.data);
                    });
                }
            }
            else if (typeof this.data.dataObject !== 'undefined') {
                if (typeof this.data.path !== 'undefined') {
                    this.data.dataObject = this.getArrayPathService.get(this.data.dataObject, this.data.path);
                }
                for (const r in this.rows) {
                    if (typeof this.rows[r] !== 'undefined') {
                        const row = this.rows[r];
                        for (const col of row.cols) {
                            if (typeof col.fields !== 'undefined') {
                                for (const field of col.fields) {
                                    if (!this.permissionService.checkPermissions(field) || !this.isFieldVisible(field)) {
                                        let parentControl;
                                        if (field.formGroup) {
                                            if (field.formArray) {
                                                parentControl = this.formData
                                                    .get(field.formArray)
                                                    .get(field.formGroup);
                                            }
                                            else {
                                                parentControl = this.formData
                                                    .get(field.formGroup);
                                            }
                                        }
                                        else {
                                            parentControl = this.formData;
                                        }
                                        parentControl.removeControl(field.name);
                                        continue;
                                    }
                                    if ('translatable' in field
                                        && field.translatable
                                        && typeof this.data.dataObject.translations !== 'undefined') {
                                        this.data.dataObject.translations.forEach((translation) => {
                                            const fieldName = 'translations-' + translation.locale + '-' + field.name;
                                            this.formData.get(fieldName).setValue(translation[field.name]);
                                        });
                                    }
                                    else {
                                        this.setFieldValue(field, this.data.dataObject);
                                    }
                                }
                            }
                        }
                    }
                }
                // listen for changes and update the dataObject
                this.formData.valueChanges
                    .pipe(takeUntil(this.destroyed), startWith(this.formData.getRawValue()))
                    .subscribe(value => {
                    for (const r in this.rows) {
                        if (typeof this.rows[r] !== 'undefined') {
                            const row = this.rows[r];
                            for (const col of row.cols) {
                                {
                                    if (typeof col.fields !== 'undefined') {
                                        for (const field of col.fields) {
                                            if ('translatable' in field
                                                && field.translatable) {
                                                for (const lang of this.languages) {
                                                    const fieldName = 'translations-' + lang + '-' + field.name;
                                                    if (typeof this.data.dataObject.translations === 'undefined') {
                                                        this.data.dataObject.translations = [];
                                                    }
                                                    let foundTranslation = false;
                                                    for (const translation of this.data.dataObject.translations) {
                                                        if (translation.locale === lang) {
                                                            translation[field.name] = value[fieldName];
                                                            foundTranslation = true;
                                                        }
                                                    }
                                                    if (!foundTranslation) {
                                                        const translation = {
                                                            locale: lang
                                                        };
                                                        translation[field.name] = value[fieldName];
                                                        this.data.dataObject.translations.push(translation);
                                                    }
                                                }
                                            }
                                            else {
                                                if (field.valuePath
                                                    && typeof value[field.name] === 'object'
                                                    && value[field.name] !== null) {
                                                    this.data.dataObject[field.name] = this.getArrayPath.transform(value[field.name], field.valuePath);
                                                }
                                                else {
                                                    this.data.dataObject[field.name] = value[field.name];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
        });
    }
    async addRecaptcha(params) {
        if (this.data.recaptcha) {
            await this.recaptcha.execute(this.data.recaptcha)
                .pipe(take$1(1))
                .toPromise()
                .then(token => {
                params.rcToken = token;
            }, error => {
                console.log('recaptcha error:');
                console.log(error);
            });
        }
    }
    registerInParent() {
        if (typeof this.parentComponent !== 'undefined'
            && typeof this.parentComponent.registerForm === 'function') {
            this.parentComponent.registerForm(this.formData, this);
        }
    }
    setFieldValue(field, data, fieldControl) {
        let value;
        if (field.type === 'action'
            && typeof data !== 'undefined'
            && typeof field.formArray === 'undefined') {
            field.dataObject = data;
            this.triggerActionChange = Math.random();
        }
        if (field.valuePath) {
            if (field.valueFilter) {
                // if value filter is present
                let values = this.getArrayPath.transform(data, field.valueFilter.path);
                // and the path specified leads to an array
                if (Array.isArray(values)) {
                    // filter array values by specified condition
                    values = values.filter((item) => {
                        return this.evaluator.exec(item, {
                            path: field.valueFilter.property,
                            op: field.valueFilter.op,
                            value: field.valueFilter.value,
                            any: false
                        });
                    });
                    // select value from filtered array of values
                    value = this.getArrayPath.transform(values, field.valuePath);
                }
            }
            else {
                if (field.type === 'dateRange') {
                    value = {
                        from: this.getArrayPath.transform(data, field.valuePath.from),
                        to: this.getArrayPath.transform(data, field.valuePath.to)
                    };
                }
                else {
                    value = this.getArrayPath.transform(data, field.valuePath);
                }
            }
        }
        else {
            if (typeof data === 'undefined' || typeof data[field.name] === 'undefined') {
                return;
            }
            if (field.type === 'dateRange') {
                value = {
                    from: data[field.name + '_from'],
                    to: data[field.name + '_to']
                };
            }
            else {
                value = data[field.name];
            }
        }
        if (typeof value === 'undefined') {
            return;
        }
        // select or select in action
        if (((field.type === 'select'
            && field.multiple === false)
            || (field.type === 'action'
                && field.control.component === 'SelectComponent'
                && field.control.data.multiple === false))
            && Array.isArray(value)) {
            value = value[0];
        }
        // date or time picker
        if (['datePicker', 'timePicker'].indexOf(field.type) >= 0 && value) {
            value = new Date(value);
            if (field.type === 'datePicker' && field.pick === 'year') {
                value = new DatePipe(this.language.getFullLocale()).transform(value, 'yyyy');
            }
            if (field.type === 'timePicker') {
                if (value.toString() !== 'Invalid Date') {
                    value = new DatePipe(this.language.getFullLocale()).transform(value, 'HH:mm');
                }
            }
        }
        if (field.type === 'input' && field.inputType === 'time') {
            const date = new Date(value);
            if (date.toString() !== 'Invalid Date') {
                value = new DatePipe(this.language.getFullLocale()).transform(date, 'HH:mm');
            }
        }
        // autocomplete or (multi)autocomplete in action
        if (field.type === 'autocomplete'
            || field.type === 'multi-autocomplete'
            || (field.type === 'action'
                && ['AutocompleteComponent', 'MultiAutocompleteComponent']
                    .indexOf(field.control.component) >= 0)) {
            let label = '';
            if (field.multiLabelPath) {
                const multiLabelArray = [];
                if (field.multiLabelPathPrefix) {
                    multiLabelArray.push(field.multiLabelPathPrefix);
                }
                for (const path of field.multiLabelPath) {
                    const lab = this.getArrayPath.transform(data, path);
                    if (lab) {
                        multiLabelArray.push(lab);
                    }
                    else {
                        console.warn('Did not find path: ' + path);
                    }
                }
                if (typeof field.multiLabelPathGlue === 'undefined') {
                    field.multiLabelPathGlue = ' | ';
                }
                label = multiLabelArray.join(field.multiLabelPathGlue);
            }
            else {
                label = this.getArrayPath.transform(data, field.labelPath);
            }
            if (Array.isArray(label) && Array.isArray(value)) {
                const valArray = [];
                for (const i in label) {
                    if (label[i]) {
                        valArray.push({
                            text: label[i],
                            value: value[i]
                        });
                    }
                }
                if (valArray.length > 1) {
                    value = valArray;
                }
                else {
                    value = valArray[0];
                }
            }
            else if (label === null && value === null) {
                value = null;
            }
            else {
                value = {
                    text: label,
                    value
                };
            }
        }
        if (typeof fieldControl === 'undefined') {
            fieldControl = this.getFieldControl(field);
        }
        if (field.type === 'dateRange') {
            for (const i of ['from', 'to']) {
                fieldControl[i].setValue(value[i]);
            }
        }
        else {
            if (typeof field.transform !== 'undefined') {
                fieldControl.setValue(this.transformData.transform(value, field.transform));
            }
            else {
                fieldControl.setValue(value);
            }
        }
    }
    getFieldControl(field, getParent = false) {
        let fieldControl;
        if (field.type === 'dateRange') {
            fieldControl = {
                from: null,
                to: null
            };
            for (const i of ['from', 'to']) {
                if (typeof fieldControl[i] === 'undefined') {
                    if (field.formGroup) {
                        if (field.formArray) {
                            fieldControl[i] = this.formData
                                .get(field.formArray)
                                .get(field.formGroup)
                                .get(field.name + '_' + i);
                        }
                        else {
                            fieldControl[i] = this.formData
                                .get(field.formGroup)
                                .get(String(field.name + '_' + i));
                        }
                    }
                    else {
                        fieldControl[i] = this.formData.get(field.name + '_' + i);
                    }
                }
            }
            if (getParent) {
                return fieldControl?.from.parent;
            }
            else {
                return fieldControl;
            }
        }
        else {
            if (field.formGroup) {
                if (field.formArray) {
                    fieldControl = this.formData
                        .get(field.formArray)
                        .get(field.formGroup)
                        .get(field.name);
                }
                else {
                    fieldControl = this.formData
                        .get(field.formGroup)
                        .get(String(field.name));
                }
            }
            else {
                fieldControl = this.formData.get(field.name);
            }
            if (getParent) {
                return fieldControl?.parent;
            }
            else {
                return fieldControl;
            }
        }
    }
    validateControl(element, data) {
        const validatorsList = [];
        const asyncValidatorList = [];
        if (Array.isArray(element.validation) && data) {
            element.validation = this.getArrayPathService.get(data, element.validation);
        }
        if (typeof element.validation !== 'undefined' && 'rules' in element.validation) {
            element.validation.rules.forEach((rule) => {
                let applyRule = true;
                if (!Array.isArray(element.validation)
                    && typeof element.validation.condition !== 'undefined') {
                    let key = typeof rule === 'string' ? rule : String(Object.keys(rule));
                    if (Array.isArray(element.validation.condition)) {
                        const condition = element.validation.condition.find((i) => i.rule === key);
                        if (condition) {
                            applyRule = this.evaluator.exec(data, condition);
                        }
                    }
                    else {
                        /** @deprecated remove after 01.09.2024 */
                        if (typeof element.validation.condition[key] !== 'undefined') {
                            applyRule = this.evaluator.exec(data, element.validation.condition[key]);
                        }
                    }
                }
                if (applyRule) {
                    // required validation for translatable fields should be skipped
                    // as it depends on a backend setting
                    if ('translatable' in element && element.translatable && rule === 'required') {
                        const requiredLanguages = this.state.get('languages.required');
                        requiredLanguages.forEach((language) => {
                            if (element.name.indexOf('-' + language + '-') > 0) {
                                validatorsList.push(Validators.required);
                            }
                        });
                        return;
                    }
                    switch (typeof rule) {
                        case 'string':
                            validatorsList.push(Validators[rule]);
                            break;
                        case 'object':
                            const validator = String(Object.keys(rule));
                            if (Validators[validator]) {
                                validatorsList.push(Validators[validator](rule[validator]));
                            }
                            else {
                                if (validator.startsWith('async')) {
                                    asyncValidatorList.push(this.customValidators[validator](rule[validator])
                                        .bind(this.customValidators));
                                }
                                else {
                                    validatorsList.push(this.customValidators[validator](rule[validator])
                                        .bind(this.customValidators));
                                }
                            }
                            break;
                    }
                }
            });
        }
        return [validatorsList, asyncValidatorList];
    }
    replaceValidators(params) {
        let control;
        if (params.formGroup) {
            control = this.getControlByPath.get(this.formData.get(params.formGroup), [params.fieldName], false);
        }
        else if (params.formArray) {
            control = this.getControlByPath.get(this.formData.get(params.formArray), params.fieldName, false);
        }
        else {
            control = this.getControlByPath.get(this.formData, [params.fieldName], false);
        }
        if (Array.isArray(control)) {
            control.forEach(c => {
                c.validation = params.validation;
                const validators = this.validateControl(c);
                c.setValidators(validators[0]);
                c.setAsyncValidators(validators[1]);
                c.updateValueAndValidity();
            });
        }
        else {
            control.validation = params.validation;
            const validators = this.validateControl(control);
            control.setValidators(validators[0]);
            control.setAsyncValidators(validators[1]);
            control.updateValueAndValidity();
        }
    }
    hasErrors(fieldName, fieldGroup = null, fieldType = null) {
        let field;
        if (fieldName !== null) {
            if (fieldType === 'dateRange') {
                return (this.hasErrors(fieldName + '_from', fieldGroup)
                    || this.hasErrors(fieldName + '_to', fieldGroup));
            }
            if (fieldGroup && typeof fieldGroup === 'object') {
                field = fieldGroup.get(fieldName);
            }
            else if (typeof fieldGroup === 'string') {
                field = this.formData.get(fieldGroup).get(String(fieldName));
            }
            else {
                field = this.formData.get(fieldName);
            }
        }
        else {
            if (typeof fieldGroup === 'object') {
                field = fieldGroup;
            }
            else {
                field = this.formData.get(fieldGroup);
            }
        }
        return field.invalid && (field.touched || field.dirty);
    }
    getErrors(fieldName, fieldGroup = null, fieldType = null) {
        if (fieldType === 'dateRange') {
            return Object.assign(this.getErrors(fieldName + '_from') || {}, this.getErrors(fieldName + '_to') || {});
        }
        let field;
        if (fieldGroup && typeof fieldGroup === 'object') {
            field = fieldGroup.get(fieldName);
        }
        else if (typeof fieldGroup === 'string') {
            field = this.formData.get(fieldGroup).get(String(fieldName));
        }
        else {
            field = this.formData.get(fieldName);
        }
        return field.errors;
    }
    queryStrToObj(str) {
        const obj = {};
        const params = str.split('&');
        for (const i in params) {
            if (params[i]) {
                const param = params[i].split('=');
                obj[param[0]] = param[1];
            }
        }
        return obj;
    }
    onSubmit(event) {
        if (!this.formData.valid) {
            this.formData.markAllAsTouched();
            // Scroll to the first invalid field
            // alert-danger - the div with the error message
            // mat-badge-warn - if field is translatable
            setTimeout(() => {
                const firstInvalidControl = this.form.nativeElement.querySelector('.mat-badge-warn')
                    || this.form.nativeElement.querySelector('.alert-danger');
                if (!firstInvalidControl) {
                    return;
                }
                firstInvalidControl.parentNode.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            });
            return;
        }
        if (this.data.confirmDialog) {
            const submitObject = Object.assign({}, this.formData.getRawValue());
            const alertDialog = this.dialog.open(AlertDialogComponent, {
                data: {
                    title: this.language.getLabel(this.data.confirmDialog.title, submitObject),
                    text: this.language.getLabel(this.data.confirmDialog.text, submitObject),
                    button: this.language.getLabel(this.data.label)
                }
            });
            alertDialog.afterClosed().pipe(take$1(1)).subscribe({
                next: (result) => {
                    if (result === 'confirm') {
                        this.doSubmit(event);
                    }
                }
            });
        }
        else {
            this.doSubmit(event);
        }
    }
    async doSubmit(event) {
        /*
          If field is autoTranslate - translate the field if the other
          field(the different language) is empty
        */
        for (const control of Object.values(this.formData.controls)) {
            if (control instanceof FormGroup) {
                for (const innerControl of Object.values(control.controls)) {
                    if (innerControl.def?.translatable
                        && innerControl.def?.autoTranslate) {
                        await this.autoTranslateField({
                            control: innerControl,
                            controlName: innerControl.def?.name
                        });
                    }
                }
            }
            else if (control instanceof FormArray) {
                for (const innerFormGroup of control.controls) {
                    for (const innerControl of Object.values(innerFormGroup.controls)) {
                        if (innerControl.def?.translatable
                            && innerControl.def?.autoTranslate) {
                            await this.autoTranslateField({
                                control: innerControl,
                                controlName: innerControl.def?.name
                            });
                        }
                    }
                }
            }
            else if (control.def?.translatable
                && control.def?.autoTranslate) {
                await this.autoTranslateField({
                    control,
                    controlName: control.def?.name
                });
            }
        }
        const submitObject = Object.assign({}, this.formData.getRawValue());
        Object.keys(this.formData.getRawValue()).forEach((key) => {
            if (Array.isArray(submitObject[key])) {
                // if there are any form arrays
                for (const row in submitObject[key]) {
                    if (typeof submitObject[key][row] === 'object') {
                        let emptyProps = 0;
                        // count how many properties are empty
                        for (const prop in submitObject[key][row]) {
                            if (typeof submitObject[key][row][prop] !== 'undefined') {
                                const control = this.formData
                                    .get(key).get(row).get(prop);
                                if (control.def && control.def.dontSubmitIfEmpty) {
                                    if (control.value === null || control.value === '') {
                                        delete submitObject[key][row][prop];
                                        emptyProps++;
                                    }
                                }
                                if (control.def
                                    && control.def.dontSubmit) {
                                    delete submitObject[key][row][prop];
                                    emptyProps++;
                                }
                                else if (!submitObject[key][row][prop]
                                    || ['0.00', '0'].indexOf(submitObject[key][row][prop]) >= 0) {
                                    if (prop.startsWith('translations')) {
                                        // remove empty translations properties from submit structure
                                        delete submitObject[key][row][prop];
                                    }
                                    emptyProps++;
                                }
                                else if (this.hasTranslatable && prop.startsWith('translations')) {
                                    if (typeof submitObject[key][row].translations === 'undefined') {
                                        submitObject[key][row].translations = {};
                                    }
                                    const split = prop.split('-');
                                    if (typeof submitObject[key][row].translations[split[1]] === 'undefined') {
                                        submitObject[key][row].translations[split[1]] = {};
                                    }
                                    submitObject[key][row]
                                        .translations[split[1]][split[2]] = submitObject[key][row][prop];
                                    delete submitObject[key][row][prop];
                                }
                                else if (
                                // TODO check if field type is autocomplete
                                typeof submitObject[key][row][prop] === 'object'
                                    && typeof submitObject[key][row][prop].value !== 'undefined'
                                    && typeof submitObject[key][row][prop].text !== 'undefined') {
                                    submitObject[key][row][prop] = submitObject[key][row][prop].value;
                                }
                            }
                        }
                        if (emptyProps === Object.keys(this.formData.getRawValue()[key][row]).length) {
                            // if all row properties have empty values, remove it
                            submitObject[key].splice(row, 1);
                        }
                    }
                }
            }
            else if (typeof submitObject[key] === 'object'
                && submitObject[key] !== null) {
                if (typeof submitObject[key].value !== 'undefined'
                    && this.formData.get(key).get('value') === null) {
                    submitObject[key] = submitObject[key].value;
                }
                else {
                    // if form group with controls
                    let result = [];
                    Object.keys(submitObject[key]).forEach((k) => {
                        const control = this.formData.get(key).get(k);
                        if (control !== null) {
                            if (control.def) {
                                // if control def defines a custom data structure to submit
                                if (control.def.submits) {
                                    let submits = JSON.stringify(control.def.submits);
                                    let val;
                                    // if innerObject is Object with value (autocomplete)
                                    // take the value
                                    const innerObj = submitObject[key][k];
                                    if (innerObj !== '' && !innerObj.value) {
                                        val = JSON.stringify(submitObject[key][k]);
                                    }
                                    else if (innerObj !== '' && innerObj.value) {
                                        val = JSON.stringify(submitObject[key][k].value);
                                    }
                                    else {
                                        delete submitObject[key][k];
                                    }
                                    if (typeof val !== 'undefined') {
                                        // if the property contains only {value}
                                        submits = submits.replace(/\"\{value\}\"/g, val);
                                        // if the property contains not only {value}
                                        submits = submits.replace(/\{value\}/g, val);
                                        if (control.def.flattenGroup) {
                                            result = result.concat(JSON.parse(submits));
                                        }
                                        else {
                                            submitObject[key][k] = JSON.parse(submits);
                                        }
                                    }
                                }
                                else if (control.def.dontSubmitIfEmpty) {
                                    if (control.value === null || control.value === '') {
                                        delete submitObject[key][k];
                                    }
                                }
                                else if (control.def.dontSubmit) {
                                    delete submitObject[key][k];
                                }
                            }
                            else if (typeof control.order !== 'undefined'
                                && control.order !== null
                                && typeof submitObject[key][k] !== 'undefined') {
                                // if control has order index pass it with the selected value(s)
                                submitObject[key][k] = {
                                    order: control.order,
                                    value: submitObject[key][k]
                                };
                            }
                        }
                    });
                    if (result.length > 0) {
                        submitObject[key] = result;
                    }
                }
            }
            else {
                const control = this.formData.get(key);
                if (control.def && control.def.dontSubmitIfEmpty) {
                    if (control.value === null || control.value === '') {
                        delete (submitObject[key]);
                    }
                }
                if (control.def && control.def.dontSubmit) {
                    delete (submitObject[key]);
                }
            }
            if (this.hasTranslatable) {
                if (key.startsWith('translations')) {
                    if (this.formData.value[key]) {
                        if (typeof submitObject.translations === 'undefined') {
                            submitObject.translations = {};
                        }
                        const split = key.split('-');
                        if (typeof submitObject.translations[split[1]] === 'undefined') {
                            submitObject.translations[split[1]] = {};
                        }
                        submitObject.translations[split[1]][split[2]] = this.formData.getRawValue()[key];
                    }
                    delete submitObject[key];
                }
            }
        });
        let params;
        // execute onSubmit event handler if form is in action
        if (typeof this.data.onSubmit === 'function') {
            this.data.onSubmitParams = {
                payload: { ...submitObject },
                event: 'onSubmit'
            };
            if (this.data.dataObject) {
                this.data.onSubmitParams.dataObject = this.data.dataObject;
            }
            const result = this.data.onSubmit(this.data.onSubmitParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
        if (typeof this.data.submit === 'undefined') {
            params = submitObject;
            return;
        }
        else if (typeof this.data.submit.params !== 'undefined') {
            let submitParams = this.data.submit.params;
            submitParams = this.api.prepServiceCallParams(submitParams);
            params = this.helper.mergeDeep(submitParams, submitObject);
            // TODO make deep merge for multiple levels
            // params = { ...submitParams, ...submitObject };
        }
        else {
            params = submitObject;
        }
        await this.addRecaptcha(params);
        try {
            // if api service found
            const dataService = this.api.getService(this.data.submit.service);
            dataService[this.data.submit.method](params)
                .pipe(take$1(1), catchError$1((error, caught) => {
                if (typeof this.data.submitError === 'function') {
                    this.data.submitErrorParams = { ...error };
                    this.data.submitErrorParams.payload = { ...params };
                    this.data.submitErrorParams.event = 'submitError';
                    this.data.submitErrorParams.target = event?.target;
                    if (this.data.dataObject) {
                        this.data.submitErrorParams.dataObject = this.data.dataObject;
                    }
                    const result = this.data.submitError(this.data.submitErrorParams);
                    return of();
                }
                throw error;
            }))
                .subscribe((response) => {
                if (this.data.success) {
                    if (this.data.success.execute) {
                        this.injector.get(executables[this.data.success.execute.service])[this.data.success.execute.method](response, this.data.success.execute.params);
                    }
                    if (this.data.success.callParent) {
                        this.parentComponent[this.data.success.callParent]();
                    }
                    if (this.data.success.redirect) {
                        switch (this.data.success.redirect) {
                            case 'lastUrl':
                                const lastUrl = this.session.get('lastUrl');
                                let parsedUrl = decodeURI(lastUrl[0]).split('?');
                                if (parsedUrl[1]) {
                                    const queryParams = this.queryStrToObj(parsedUrl[1]);
                                    this.router.navigate([parsedUrl[0]], { queryParams });
                                }
                                else {
                                    const route = this.helper.urlToRoute(parsedUrl[0]);
                                    this.router.navigate(route);
                                }
                                break;
                            default:
                                // check for and replace parameter placeholder from the response
                                const responseParamsRegex = /{(.*?)}/g;
                                const responseParams = this.data.success.redirect
                                    .match(responseParamsRegex);
                                let redirect = this.data.success.redirect;
                                if (responseParams) {
                                    for (const placeholder of responseParams) {
                                        const param = placeholder.replace('{', '').replace('}', '');
                                        redirect = redirect.replace(placeholder, response.result[param]);
                                    }
                                }
                                // TODO: check for and replace parameter placeholder from the url
                                // const urlParamsRegex = /:(.*?)?(\/|$)/g;
                                const urlParams = this.route.snapshot.params;
                                for (const key of Object.keys(urlParams)) {
                                    if (typeof urlParams[key] !== 'undefined') {
                                        const paramRgx = new RegExp(`:${key}`);
                                        redirect = redirect.replace(paramRgx, urlParams[key]);
                                    }
                                }
                                redirect = redirect.replace(/\/:.+/, '');
                                this.router.navigate([redirect]);
                                break;
                        }
                    }
                    if (this.data.success.message) {
                        const config = new MatSnackBarConfig();
                        config.horizontalPosition = 'right';
                        config.verticalPosition = 'top';
                        config.panelClass = ['alert', 'alert-success'];
                        if (this.data.success.duration) {
                            config.duration = this.data.success.duration;
                        }
                        config.data = { messages: [this.data.success.message] };
                        this.zone.run(() => this.alert.openFromComponent(ToastComponent, config));
                    }
                }
                // execute submitSuccess event handler if form is in action
                if (typeof this.data.submitSuccess === 'function') {
                    this.data.submitSuccessParams = { ...response.result };
                    this.data.submitSuccessParams.payload = { ...params };
                    this.data.submitSuccessParams.event = 'submitSuccess';
                    this.data.submitSuccessParams.target = event?.target;
                    if (this.data.dataObject) {
                        this.data.submitSuccessParams.dataObject = this.data.dataObject;
                    }
                    const result = this.data.submitSuccess(this.data.submitSuccessParams);
                    if (result instanceof Observable) {
                        result.pipe(take$1(1)).subscribe(() => {
                            if (this.data.resetOnSubmit) {
                                this.resetForm();
                            }
                        });
                    }
                    else {
                        if (this.data.resetOnSubmit) {
                            this.resetForm();
                        }
                    }
                }
            });
        }
        catch (error) {
            // if api service is not found, try to find an executable one
            this.injector.get(executables[this.data.submit.service])[this.data.submit.method](params);
            if (typeof this.data.submitSuccess === 'function') {
                this.data.submitSuccessParams = {
                    event: 'submitSuccess',
                    payload: { ...params }
                };
                this.data.submitSuccessParams.target = event?.target;
                if (this.data.dataObject) {
                    this.data.submitSuccessParams.dataObject = this.data.dataObject;
                }
                const result = this.data.submitSuccess(this.data.submitSuccessParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe(() => {
                        if (this.data.resetOnSubmit) {
                            this.resetForm();
                        }
                    });
                }
                else {
                    if (this.data.resetOnSubmit) {
                        this.resetForm();
                    }
                }
            }
        }
    }
    getRowHeight(row) {
        if (typeof row.height !== 'undefined') {
            const height = row.height.join('');
            return height;
        }
    }
    printError(error, label) {
        let params = {};
        if (typeof error.value === 'object') {
            params = error.value;
        }
        else {
            params[error.key] = error.value;
        }
        return this.language.getLabel(label, params);
    }
    /**
     * Checks if object A contains object B
     * @param a object
     * @param b object
     * @returns boolean
     */
    compareFieldWithDef(a, b) {
        for (let key in b) {
            if ((key in a)) {
                const valOfA = a[key];
                const valOfB = b[key];
                if (valOfB !== '{value}') {
                    if (typeof valOfA === 'object') {
                        if (typeof valOfB === 'object') {
                            let result = this.compareFieldWithDef(valOfA, valOfB);
                            if (!result) {
                                return false;
                            }
                        }
                        else {
                            return false;
                        }
                    }
                    else if (valOfA !== valOfB) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    areControlsExisting(field, formGroup) {
        if ('translatable' in field
            && field.translatable) {
            let existing = 0;
            for (const lang of this.languages) {
                const fieldName = 'translations-' + lang + '-' + field.name;
                if (formGroup.get(fieldName)) {
                    existing++;
                }
            }
            return existing === this.languages.length;
        }
        else {
            let formControl;
            if (field.type === 'dateRange') {
                formControl = formGroup.get(field.name + '_from');
            }
            else {
                formControl = formGroup.get(field.name);
            }
            return !!formControl && this.compareFieldWithDef(field, formControl.def);
        }
    }
    drop(event, row) {
        if (row.draggable && row.formArray) {
            const formArray = this.formData.get(row.formArray);
            moveItemInArray(formArray.controls, event.previousIndex, event.currentIndex);
        }
    }
    extractedFieldDrop(event, field) {
        if (typeof field.formGroup !== 'undefined') {
            const formGroup = this.formData.get(field.formGroup);
            const controls = formGroup.controls;
            for (const i in controls) {
                if (event.previousIndex > event.currentIndex) {
                    // moving up
                    if (controls[i].order === event.previousIndex) {
                        controls[i].order = event.currentIndex;
                        // source item
                    }
                    else if (controls[i].order >= event.currentIndex
                        && controls[i].order < event.previousIndex) {
                        // target item
                        controls[i].order++;
                    }
                }
                else {
                    // moving down
                    if (controls[i].order === event.previousIndex) {
                        controls[i].order = event.currentIndex;
                        // source item
                    }
                    else if (controls[i].order > event.previousIndex
                        && controls[i].order <= event.currentIndex) {
                        // target item
                        controls[i].order--;
                    }
                }
            }
            moveItemInArray(this.extractedFields[event.item.data.id], event.previousIndex, event.currentIndex);
        }
    }
    resetForm() {
        const resetFormData = {};
        this.rows.forEach(row => {
            row.cols.forEach(col => {
                col.fields.forEach(field => {
                    if (!this.isFieldVisible(field)) {
                        return;
                    }
                    if (typeof field.valuePath !== 'undefined') {
                        resetFormData[field.name] = this.getArrayPathService.get(this.data.dataObject, field.valuePath);
                    }
                });
            });
        });
        this.formData.reset(resetFormData);
        this.data.submitSuccessParams = null;
    }
    removeControl(controlPath) {
        const clonedPath = [...controlPath];
        const controlName = clonedPath.pop();
        const formGroup = this.getControlByPath.get(this.formData, clonedPath, false);
        formGroup.removeControl(controlName);
    }
    isFieldVisible(field, dataObject = null) {
        if (typeof field.condition === 'undefined') {
            return true;
        }
        let conditions = [];
        if (!Array.isArray(field.condition)) {
            conditions.push(field.condition);
        }
        else {
            conditions = field.condition;
        }
        const conditionData = [];
        const conditionValueData = [];
        for (const condition of conditions) {
            let conditionScope = this.formData.value;
            if (typeof condition.scope !== 'undefined') {
                switch (condition.scope) {
                    case 'dataObject':
                        const scope = (dataObject) ?? this.data.dataObject;
                        if (typeof scope === 'undefined')
                            return true;
                        conditionScope = scope;
                        break;
                    case 'storage':
                        conditionScope = null;
                        break;
                }
            }
            conditionData.push(conditionScope);
            let conditionValueScope = this.formData.value;
            if (typeof condition.valueScope !== 'undefined') {
                switch (condition.valueScope) {
                    case 'dataObject':
                        const scope = (dataObject) ?? this.data.dataObject;
                        if (typeof scope === 'undefined')
                            return true;
                        conditionValueScope = scope;
                        break;
                    case 'storage':
                        conditionValueScope = null;
                        break;
                }
            }
            conditionValueData.push(conditionValueScope);
        }
        if (this.evaluator.exec(conditionData, conditions, conditionValueData)) {
            return true;
        }
        else {
            return false;
        }
    }
    async autoTranslateField({ control, controlName }) {
        const translateRegex = new RegExp(`(translations-)(${this.languages.join('|')})(-\\w+)`, 'g');
        const parent = control.parent;
        const match = controlName
            .matchAll(translateRegex)
            .next()
            .value;
        const sourceLang = match[2];
        const sourceValue = control.value;
        if (!sourceValue) {
            return;
        }
        const otherLangs = this.languages.filter(lang => lang !== sourceLang);
        await Promise.all(otherLangs.map(async (otherLang) => {
            const otherField = controlName.replace(translateRegex, `$1${otherLang}$3`);
            if (parent.get(otherField).value) {
                return Promise.resolve();
            }
            try {
                const result = await lastValueFrom(this.googleTranslateService.translate(sourceLang, otherLang, sourceValue));
                parent.get(otherField).setValue(result);
            }
            catch (error) {
                console.log('Error translating', error);
            }
        }));
    }
    parseFieldLabel(field, data) {
        field = JSON.parse(JSON.stringify(field));
        if (typeof field.labelPath !== 'undefined') {
            field.label = this.getArrayPathService.get(data, field.labelPath);
        }
        if (typeof field.label !== 'undefined' && field.label) {
            field.label = this.getLabel(field.label, data);
        }
        if (typeof field.placeholder !== 'undefined' && field.placeholder) {
            field.placeholder = this.getLabel(field.placeholder, data);
        }
        return field;
    }
    ngOnDestroy() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.resetChannels(new Set([this.data.channel]));
        }
        super.ngOnDestroy();
    }
    isDefined(variable) {
        return typeof variable !== 'undefined';
    }
    isVisible(obj, dataObject) {
        return !this.isDefined(obj.visible) ||
            (this.isDefined(obj.visible) && execute.call(this, obj, dataObject));
        function execute(obj, dataObject) {
            let conditions = [];
            let evalData = [];
            let evalValueData = [];
            if (Array.isArray(obj.visible)) {
                conditions = obj.visible;
            }
            else {
                conditions.push(obj.visible);
            }
            for (const visible of conditions) {
                switch (visible.scope) {
                    case "lastUrl":
                        evalData.push(this.session.get("lastUrl")[0]);
                        break;
                    case "urlParams":
                        evalData.push(this.route.snapshot.params);
                        break;
                    case "state":
                        evalData.push(this.state);
                        break;
                    case "data":
                        evalData.push(this.data);
                        break;
                    case "storage":
                        evalData.push(null);
                        break;
                    case "parentForm":
                        evalData.push(this.parentForm.getRawValue());
                        break;
                    default:
                        evalData.push(dataObject);
                }
                if (typeof visible.valueScope !== "undefined") {
                    switch (visible.valueScope) {
                        case "lastUrl":
                            evalValueData.push(this.session.get("lastUrl")[0]);
                            break;
                        case "urlParams":
                            evalValueData.push(this.route.snapshot.params);
                            break;
                        case "state":
                            evalValueData.push(this.state);
                            break;
                        case "data":
                            evalValueData.push(this.data);
                            break;
                        case "storage":
                            evalValueData.push(null);
                            break;
                        case "parentForm":
                            evalValueData.push(this.parentForm.getRawValue());
                            break;
                        case "dataObject":
                            evalValueData.push(dataObject);
                            break;
                    }
                }
            }
            return this.evaluator.exec(evalData, conditions, evalValueData);
        }
    }
}
FormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FormComponent, deps: [{ token: i1.ActivatedRoute }, { token: i1.Router }, { token: GetArrayPathPipe }, { token: JoinPipe }, { token: EvalService }, { token: i1$2.MatSnackBar }, { token: i3$3.MatDialog }, { token: i0.NgZone }, { token: StateService }, { token: SessionService }, { token: CloneAbstractControlService }, { token: PermissionsService }, { token: i3.Location }, { token: i0.Injector }, { token: GetArrayPathService }, { token: GetControlByPathService }, { token: i14$1.ReCaptchaV3Service }, { token: GoogleTranslateService }, { token: HelperService }, { token: CacheService }, { token: CustomValidators }, { token: TransformService }, { token: RelativeDateService }], target: i0.ɵɵFactoryTarget.Component });
FormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FormComponent, selector: "app-form", inputs: { data: "data", parentComponent: "parentComponent" }, providers: [GetArrayPathPipe, JoinPipe, CustomValidators], viewQueries: [{ propertyName: "form", first: true, predicate: ["form"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div [class]=\"data.class\" [ngClass]=\"{ formWrapper: !data.inline }\">\r\n  <div class=\"formTitle\" *ngIf=\"data.label\">\r\n    {{ getLabel(data.label, data) }}\r\n  </div>\r\n  <form\r\n    [formGroup]=\"formData\"\r\n    [class]=\"data.formTagClass\"\r\n    (ngSubmit)=\"onSubmit($event)\"\r\n    #form>\r\n    <div *ngIf=\"id\">\r\n      <input type=\"hidden\" formControlName=\"id\" />\r\n    </div>\r\n    <div class=\"row {{ row.class }}\" *ngFor=\"let row of rows\">\r\n      <ng-container *ngIf=\"row.formArray\">\r\n        <div *ngIf=\"row.label\" class=\"col-24 rowTitle\">\r\n          {{ getLabel(row.label, data) }}\r\n        </div>\r\n        <div class=\"col-24\" cdkDropList (cdkDropListDropped)=\"drop($event, row)\">\r\n          <div\r\n            class=\"row {{ row.itemClass }} {{ controlArray.startGroupClass }}\"\r\n            [ngClass]=\"{ expandable: row.expandable }\"\r\n            *ngFor=\"\r\n              let controlArray of formData.get(row.formArray)['controls'];\r\n              let i = index\r\n            \"\r\n            cdkDrag\r\n            [cdkDragDisabled]=\"!row.draggable\"\r\n            [cdkDragData]=\"controlArray\"\r\n            [@toggle]=\"{\r\n              value: !controlArray.isOpen && row.expandable ? 'closed' : 'open',\r\n              params: {\r\n                collapsedHeight: row.collapsedHeight\r\n              }\r\n            }\">\r\n            <!-- drag and drop placeholder template -->\r\n            <div\r\n              *cdkDragPlaceholder\r\n              class=\"drag-placeholder\"\r\n              [ngStyle]=\"{\r\n                'height.px': dragPlaceholderHeight\r\n              }\"></div>\r\n            <!-- If the row is array and can be multiplied -->\r\n            <div\r\n              *ngFor=\"let col of row.cols\"\r\n              class=\"col\"\r\n              [class]=\"col.class\"\r\n              [ngStyle]=\"{ height: getRowHeight(row) }\"\r\n              [hidden]=\"\r\n                controlArray.get(row.hideIfEmpty) &&\r\n                !controlArray.get(row.hideIfEmpty).value\r\n              \">\r\n              <app-slot\r\n                *ngIf=\"col.components\"\r\n                [items]=\"col.components\"\r\n                [componentValue]=\"controlArray.dataObject | getArrayPath : col.path\"\r\n                [parentForm]=\"formData\"></app-slot>\r\n              <ng-template\r\n                #fieldsTpl\r\n                let-field=\"field\"\r\n                let-break=\"break\"\r\n                let-formData=\"formData\">\r\n                <ng-container *ngIf=\"!field.extractPath\">\r\n                  <div\r\n                    class=\"input-error-div input-holder\"\r\n                    *ngIf=\"\r\n                      field.type !== 'submit' &&\r\n                      field.type !== 'button' &&\r\n                      !field.translatable &&\r\n                      permissionService.checkPermissions(field)\r\n                    \">\r\n                    <app-slot\r\n                      *ngIf=\"\r\n                        (field.type !== 'hidden' &&\r\n                          (field.type | getFieldComponent) !== 'ActionComponent') ||\r\n                        ((field.type | getFieldComponent) === 'ActionComponent' &&\r\n                          (field.control.component !== 'ButtonComponent' ||\r\n                            (field.control.component === 'ButtonComponent' &&\r\n                              !formData.controls[field.name]?.disabled)))\r\n                      \"\r\n                      [items]=\"[\r\n                        {\r\n                          component: (field.type | getFieldComponent),\r\n                          data: parseFieldLabel(field, controlArray.dataObject)\r\n                        }\r\n                      ]\"\r\n                      [componentValue]=\"controlArray.dataObject | getArrayPath : col.path\"\r\n                      [parentForm]=\"formData\"></app-slot>\r\n                    <div\r\n                      *ngIf=\"\r\n                        hasErrors(field.name, formData) && field.validation?.messages\r\n                      \"\r\n                      class=\"alert alert-danger width-50\">\r\n                      <mat-error\r\n                        *ngFor=\"let error of formData.get(field.name).errors | keyvalue\">\r\n                        {{\r\n                          printError(error, field.validation.messages[$any(error.key)])\r\n                        }}\r\n                      </mat-error>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"field.extractPath && break != 'true'\">\r\n                  <ng-container *ngFor=\"let extField of extractedFields[field.id]\">\r\n                    <ng-container *ngIf=\"extField.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: extField,\r\n                            break: 'true',\r\n                            formData: formData.controls[extField.formGroup]\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"!extField.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: extField,\r\n                            break: 'true',\r\n                            formData: formData\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                </ng-container>\r\n\r\n                <mat-tab-group\r\n                  dynamicHeight\r\n                  *ngIf=\"field.translatable\"\r\n                  [headerPosition]=\"field.translatable\">\r\n                  <mat-tab *ngFor=\"let languageKey of languages\">\r\n                    <ng-template matTabLabel>\r\n                      <span\r\n                        *ngIf=\"\r\n                          hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          )\r\n                        \"\r\n                        matBadge=\"!\"\r\n                        matBadgeColor=\"warn\"\r\n                        matBadgeSize=\"small\"\r\n                        matBadgeOverlap=\"false\"\r\n                        matBadgePosition=\"above before\">\r\n                        {{ languageKey }}</span\r\n                      >\r\n                      <span\r\n                        *ngIf=\"\r\n                          !hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          )\r\n                        \">\r\n                        {{ languageKey }}</span\r\n                      >\r\n                    </ng-template>\r\n                    <div\r\n                      class=\"input-error-div input-holder\"\r\n                      *ngIf=\"\r\n                        field.translatable && permissionService.checkPermissions(field)\r\n                      \">\r\n                      <br *ngIf=\"field.translatable === 'above'\" />\r\n                      <app-input\r\n                        *ngIf=\"field.type == 'input' || field.type == 'textarea'\"\r\n                        [parentForm]=\"formData\"\r\n                        [data]=\"translatableFields[field.name][languageKey]\"></app-input>\r\n                      <app-ckeditor\r\n                        *ngIf=\"field.type == 'ckeditor'\"\r\n                        [parentForm]=\"formData\"\r\n                        [data]=\"\r\n                          translatableFields[field.name][languageKey]\r\n                        \"></app-ckeditor>\r\n\r\n                      <div\r\n                        *ngIf=\"\r\n                          hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          ) &&\r\n                          translatableFields[field.name][languageKey].validation?.messages\r\n                        \"\r\n                        class=\"alert alert-danger width-50\">\r\n                        <mat-error\r\n                          *ngFor=\"\r\n                            let error of formData.get(\r\n                              translatableFields[field.name][languageKey].name\r\n                            ).errors | keyvalue\r\n                          \">\r\n                          {{\r\n                            printError(error, field.validation.messages[$any(error.key)])\r\n                          }}\r\n                        </mat-error>\r\n                      </div>\r\n                    </div>\r\n                  </mat-tab>\r\n                </mat-tab-group>\r\n\r\n                <!-- Submit -->\r\n                <ng-container\r\n                  *ngIf=\"\r\n                    (field.type == 'submit' &&\r\n                      permissionService.checkPermissions(field)) ||\r\n                    (field.type == 'button' && !formData.controls[field.name]?.disabled)\r\n                  \">\r\n                  <app-button\r\n                    [data]=\"field.buttonData\"\r\n                    [parentForm]=\"formData\"></app-button>\r\n                </ng-container>\r\n              </ng-template>\r\n              <ng-container *ngIf=\"col.fields\">\r\n                <ng-container *ngFor=\"let field of col.fields\">\r\n                  <ng-container *ngIf=\"areControlsExisting(field, controlArray)\">\r\n                    <ng-container *ngIf=\"field.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: parseFieldLabel(field, controlArray.dataObject),\r\n                            formData: controlArray\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"!field.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: parseFieldLabel(field, controlArray.dataObject),\r\n                            formData: formData\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n            <!-- Button that expands the row if expandable-->\r\n            <button\r\n              *ngIf=\"row.expandable\"\r\n              type=\"button\"\r\n              class=\"expandToggle\"\r\n              mat-button\r\n              color=\"primary\"\r\n              (click)=\"\r\n                controlArray.isOpen && row.expandable\r\n                  ? (controlArray.isOpen = false)\r\n                  : (controlArray.isOpen = true)\r\n              \">\r\n              <mat-icon\r\n                [ngStyle]=\"{\r\n                  transform: controlArray.isOpen ? 'rotate(90deg)' : 'rotate(270deg)'\r\n                }\">\r\n                arrow_back_ios_new\r\n              </mat-icon>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"!row.formArray && isVisible(row, data)\">\r\n        <!-- If the row consist of static fields -->\r\n        <div *ngIf=\"row.label\" class=\"rowTitle\">\r\n          {{ getLabel(row.label, data) }}\r\n        </div>\r\n        <div\r\n          *ngFor=\"let col of row.cols\"\r\n          class=\"col\"\r\n          [class]=\"col.class\"\r\n          [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n          <ng-container *ngIf=\"isVisible(col, data)\">\r\n            <div class=\"colTitle\" *ngIf=\"col.label\">\r\n              {{ getLabel(col.label, data) }}\r\n            </div>\r\n            <app-slot\r\n              *ngIf=\"col.components\"\r\n              [detectChanges]=\"true\"\r\n              [items]=\"col.components\"\r\n              [componentValue]=\"data.dataObject | getArrayPath : col.path\"\r\n              [parentForm]=\"formData\"></app-slot>\r\n            <ng-container *ngIf=\"col.fields\">\r\n              <ng-container *ngFor=\"let field of col.fields\">\r\n                <ng-template\r\n                  #fieldsTpl\r\n                  let-field=\"field\"\r\n                  let-break=\"break\"\r\n                  let-formData=\"formData\">\r\n                  <ng-container *ngIf=\"!field.extractPath\">\r\n                    <div\r\n                      class=\"input-error-div input-holder\"\r\n                      [class]=\"field.containerClass\"\r\n                      *ngIf=\"\r\n                        field.type !== 'submit' &&\r\n                        field.type !== 'button' &&\r\n                        !field.translatable &&\r\n                        permissionService.checkPermissions(field)\r\n                      \">\r\n                      <app-slot\r\n                        *ngIf=\"\r\n                          (field.type !== 'hidden' &&\r\n                            (field.type | getFieldComponent) !== 'ActionComponent') ||\r\n                          ((field.type | getFieldComponent) === 'ActionComponent' &&\r\n                            (field.control.component !== 'ButtonComponent' ||\r\n                              (field.control.component === 'ButtonComponent' &&\r\n                                !formData.controls[field.name]?.disabled)))\r\n                        \"\r\n                        [items]=\"[\r\n                          {\r\n                            component: (field.type | getFieldComponent),\r\n                            data: field\r\n                          }\r\n                        ]\"\r\n                        [componentValue]=\"data.dataObject | getArrayPath : col.path\"\r\n                        [parentForm]=\"formData\"></app-slot>\r\n                      <div\r\n                        *ngIf=\"\r\n                          ((field.buttonData && !field.buttonData.link) ||\r\n                            !field.buttonData) &&\r\n                          hasErrors(field.name, field.formGroup, field.type) &&\r\n                          field.validation?.messages\r\n                        \"\r\n                        class=\"alert alert-danger width-50\">\r\n                        <mat-error\r\n                          *ngFor=\"\r\n                            let error of getErrors(\r\n                              field.name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            ) | keyvalue\r\n                          \">\r\n                          {{\r\n                            printError(error, field.validation.messages[$any(error.key)])\r\n                          }}\r\n                        </mat-error>\r\n                      </div>\r\n                    </div>\r\n                  </ng-container>\r\n                  <ng-container *ngIf=\"field.extractPath && break != 'true'\">\r\n                    <ng-container *ngFor=\"let extField of extractedFields[field.id]\">\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              break: 'true',\r\n                              formData: formData.controls[extField.name]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                      <ng-container *ngIf=\"!extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              break: 'true',\r\n                              formData: formData\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </ng-container>\r\n                  </ng-container>\r\n\r\n                  <mat-tab-group\r\n                    dynamicHeight\r\n                    *ngIf=\"field.translatable\"\r\n                    [headerPosition]=\"field.translatable\">\r\n                    <mat-tab *ngFor=\"let languageKey of languages\">\r\n                      <ng-template matTabLabel>\r\n                        <span\r\n                          *ngIf=\"\r\n                            hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            )\r\n                          \"\r\n                          matBadge=\"!\"\r\n                          matBadgeColor=\"warn\"\r\n                          matBadgeSize=\"small\"\r\n                          matBadgeOverlap=\"false\"\r\n                          matBadgePosition=\"above before\">\r\n                          {{ languageKey }}</span\r\n                        >\r\n                        <span\r\n                          *ngIf=\"\r\n                            !hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            )\r\n                          \">\r\n                          {{ languageKey }}</span\r\n                        >\r\n                      </ng-template>\r\n                      <div\r\n                        class=\"input-error-div input-holder\"\r\n                        *ngIf=\"\r\n                          field.translatable && permissionService.checkPermissions(field)\r\n                        \">\r\n                        <br *ngIf=\"field.translatable === 'above'\" />\r\n                        <app-input\r\n                          *ngIf=\"field.type == 'input' || field.type == 'textarea'\"\r\n                          [parentForm]=\"formData\"\r\n                          [data]=\"\r\n                            translatableFields[field.name][languageKey]\r\n                          \"></app-input>\r\n                        <app-ckeditor\r\n                          *ngIf=\"field.type == 'ckeditor'\"\r\n                          [data]=\"translatableFields[field.name][languageKey]\"\r\n                          [parentForm]=\"formData\"></app-ckeditor>\r\n\r\n                        <div\r\n                          *ngIf=\"\r\n                            hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            ) &&\r\n                            translatableFields[field.name][languageKey].validation\r\n                              ?.messages\r\n                          \"\r\n                          class=\"alert alert-danger width-50\">\r\n                          <mat-error\r\n                            *ngFor=\"\r\n                              let error of formData.get(\r\n                                translatableFields[field.name][languageKey].name\r\n                              ).errors | keyvalue\r\n                            \">\r\n                            {{\r\n                              printError(\r\n                                error,\r\n                                field.validation.messages[$any(error.key)]\r\n                              )\r\n                            }}\r\n                          </mat-error>\r\n                        </div>\r\n                      </div>\r\n                    </mat-tab>\r\n                  </mat-tab-group>\r\n\r\n                  <!-- Submit -->\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      (field.type == 'submit' &&\r\n                        permissionService.checkPermissions(field)) ||\r\n                      (field.type == 'button' && !formData.controls[field.name]?.disabled)\r\n                    \">\r\n                    <div\r\n                      *ngIf=\"hasErrors(null, formData) && data.validation?.messages\"\r\n                      class=\"alert width-50\">\r\n                      <mat-error *ngFor=\"let error of formData.errors | keyvalue\">\r\n                        {{ printError(error, data.validation.messages[$any(error.key)]) }}\r\n                      </mat-error>\r\n                    </div>\r\n\r\n                    <app-button\r\n                      [data]=\"field.buttonData\"\r\n                      [parentForm]=\"formData\"></app-button>\r\n                  </ng-container>\r\n                </ng-template>\r\n\r\n                <ng-container *ngIf=\"field.draggable && field.extractPath\">\r\n                  <div\r\n                    cdkDropList\r\n                    [class]=\"field.dropListClass\"\r\n                    (cdkDropListDropped)=\"extractedFieldDrop($event, field)\">\r\n                    <div\r\n                      cdkDrag\r\n                      [class]=\"field.dragItemClass\"\r\n                      [cdkDragData]=\"field\"\r\n                      *ngFor=\"let extField of extractedFields[field.id]\">\r\n                      <!-- drag and drop placeholder template -->\r\n                      <div *cdkDragPlaceholder class=\"drag-field-placeholder\"></div>\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              formData: formData.controls[extField.formGroup]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"!field.draggable && field.extractPath\">\r\n                  <div [class]=\"field.rowClass\">\r\n                    <div\r\n                      *ngFor=\"let extField of extractedFields[field.id]\"\r\n                      [class]=\"field.itemClass\">\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              formData: formData.controls[extField.formGroup]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n\r\n                <ng-container *ngIf=\"!field.extractPath\">\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      field.formGroup &&\r\n                      areControlsExisting(field, formData.controls[field.formGroup])\r\n                    \">\r\n                    <ng-template\r\n                      *ngTemplateOutlet=\"\r\n                        fieldsTpl;\r\n                        context: {\r\n                          field: field,\r\n                          formData: formData.controls[field.formGroup]\r\n                        }\r\n                      \"></ng-template>\r\n                  </ng-container>\r\n                  <ng-container\r\n                    *ngIf=\"!field.formGroup && areControlsExisting(field, formData)\">\r\n                    <ng-template\r\n                      *ngTemplateOutlet=\"\r\n                        fieldsTpl;\r\n                        context: { field: field, formData: formData }\r\n                      \"></ng-template>\r\n                  </ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </form>\r\n</div>\r\n", styles: ["app-radiobutton{display:flex}.center-submit-button{text-align:center}.input-error-div{text-align:center;flex-grow:1;display:inline}.formWrapper{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.formWrapper .formTitle{width:100%;height:50px;line-height:50px;padding-left:25px;background:grey;margin-top:20px;background:rgba(0,0,0,.03);color:#0000008a}.formWrapper .width100{width:100%}.formWrapper .width100 .justifyRight{display:flex;justify-content:flex-end}.formWrapper .width100 .justifyLeft{display:flex;justify-content:flex-start}.formWrapper .width100 .justifyCenter{display:flex;justify-content:center}.formWrapper form{padding:15px;background:#ffffff}.rowTitle{height:40px;line-height:40px;text-align:center;margin-bottom:20px;border-bottom:1px solid rgba(0,0,0,.03);color:#0000008a}.colTitle{margin-bottom:10px}.expandable{overflow:hidden;position:relative;padding-bottom:31px}.expandable .expandToggle{position:absolute;width:100%;bottom:-5px;z-index:1;background-color:#fff}.expandable .expandToggle .mat-icon{font-size:30px;height:30px;width:30px}.drag-placeholder,.drag-field-placeholder{border:3px dotted grey}.drag-field-placeholder{height:60px}.row .groupStart:not(:first-child){padding-top:20px}.columns{-moz-columns:2;columns:2}::ng-deep .mat-tab-group .mat-tab-header .mat-tab-label{min-width:80px}@media only screen and (max-width: 576px){.formWrapper .formTitle{margin-top:0}}@media only screen and (max-width: 767px){.columns{-moz-columns:1;columns:1}.arrayRow{border-top:2px solid;padding-bottom:10px;padding-top:10px}}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i10.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "directive", type: i5$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: ButtonComponent, selector: "app-button", inputs: ["data", "parentForm", "parentComponent"] }, { kind: "component", type: InputComponent, selector: "app-input", inputs: ["data", "parentForm"] }, { kind: "component", type: CkeditorComponent, selector: "app-ckeditor", inputs: ["data", "parentForm"] }, { kind: "component", type: i6$4.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "directive", type: i6$4.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { kind: "component", type: i6$4.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "directive", type: i14.MatBadge, selector: "[matBadge]", inputs: ["matBadgeDisabled", "matBadgeColor", "matBadgeOverlap", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "directive", type: i11$2.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i11$2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i11$2.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "pipe", type: i3.KeyValuePipe, name: "keyvalue" }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: GetFieldComponent, name: "getFieldComponent" }], animations: [
        trigger('toggle', [
            state('open', style({
                height: '*'
            })),
            state('closed', style({
                height: '{{collapsedHeight}}px'
            }), { params: { collapsedHeight: 185 } }),
            transition('open => closed', [
                animate('0.2s')
            ]),
            transition('closed => open', [
                animate('0.2s')
            ])
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-form', providers: [GetArrayPathPipe, JoinPipe, CustomValidators], animations: [
                        trigger('toggle', [
                            state('open', style({
                                height: '*'
                            })),
                            state('closed', style({
                                height: '{{collapsedHeight}}px'
                            }), { params: { collapsedHeight: 185 } }),
                            transition('open => closed', [
                                animate('0.2s')
                            ]),
                            transition('closed => open', [
                                animate('0.2s')
                            ])
                        ])
                    ], template: "<div [class]=\"data.class\" [ngClass]=\"{ formWrapper: !data.inline }\">\r\n  <div class=\"formTitle\" *ngIf=\"data.label\">\r\n    {{ getLabel(data.label, data) }}\r\n  </div>\r\n  <form\r\n    [formGroup]=\"formData\"\r\n    [class]=\"data.formTagClass\"\r\n    (ngSubmit)=\"onSubmit($event)\"\r\n    #form>\r\n    <div *ngIf=\"id\">\r\n      <input type=\"hidden\" formControlName=\"id\" />\r\n    </div>\r\n    <div class=\"row {{ row.class }}\" *ngFor=\"let row of rows\">\r\n      <ng-container *ngIf=\"row.formArray\">\r\n        <div *ngIf=\"row.label\" class=\"col-24 rowTitle\">\r\n          {{ getLabel(row.label, data) }}\r\n        </div>\r\n        <div class=\"col-24\" cdkDropList (cdkDropListDropped)=\"drop($event, row)\">\r\n          <div\r\n            class=\"row {{ row.itemClass }} {{ controlArray.startGroupClass }}\"\r\n            [ngClass]=\"{ expandable: row.expandable }\"\r\n            *ngFor=\"\r\n              let controlArray of formData.get(row.formArray)['controls'];\r\n              let i = index\r\n            \"\r\n            cdkDrag\r\n            [cdkDragDisabled]=\"!row.draggable\"\r\n            [cdkDragData]=\"controlArray\"\r\n            [@toggle]=\"{\r\n              value: !controlArray.isOpen && row.expandable ? 'closed' : 'open',\r\n              params: {\r\n                collapsedHeight: row.collapsedHeight\r\n              }\r\n            }\">\r\n            <!-- drag and drop placeholder template -->\r\n            <div\r\n              *cdkDragPlaceholder\r\n              class=\"drag-placeholder\"\r\n              [ngStyle]=\"{\r\n                'height.px': dragPlaceholderHeight\r\n              }\"></div>\r\n            <!-- If the row is array and can be multiplied -->\r\n            <div\r\n              *ngFor=\"let col of row.cols\"\r\n              class=\"col\"\r\n              [class]=\"col.class\"\r\n              [ngStyle]=\"{ height: getRowHeight(row) }\"\r\n              [hidden]=\"\r\n                controlArray.get(row.hideIfEmpty) &&\r\n                !controlArray.get(row.hideIfEmpty).value\r\n              \">\r\n              <app-slot\r\n                *ngIf=\"col.components\"\r\n                [items]=\"col.components\"\r\n                [componentValue]=\"controlArray.dataObject | getArrayPath : col.path\"\r\n                [parentForm]=\"formData\"></app-slot>\r\n              <ng-template\r\n                #fieldsTpl\r\n                let-field=\"field\"\r\n                let-break=\"break\"\r\n                let-formData=\"formData\">\r\n                <ng-container *ngIf=\"!field.extractPath\">\r\n                  <div\r\n                    class=\"input-error-div input-holder\"\r\n                    *ngIf=\"\r\n                      field.type !== 'submit' &&\r\n                      field.type !== 'button' &&\r\n                      !field.translatable &&\r\n                      permissionService.checkPermissions(field)\r\n                    \">\r\n                    <app-slot\r\n                      *ngIf=\"\r\n                        (field.type !== 'hidden' &&\r\n                          (field.type | getFieldComponent) !== 'ActionComponent') ||\r\n                        ((field.type | getFieldComponent) === 'ActionComponent' &&\r\n                          (field.control.component !== 'ButtonComponent' ||\r\n                            (field.control.component === 'ButtonComponent' &&\r\n                              !formData.controls[field.name]?.disabled)))\r\n                      \"\r\n                      [items]=\"[\r\n                        {\r\n                          component: (field.type | getFieldComponent),\r\n                          data: parseFieldLabel(field, controlArray.dataObject)\r\n                        }\r\n                      ]\"\r\n                      [componentValue]=\"controlArray.dataObject | getArrayPath : col.path\"\r\n                      [parentForm]=\"formData\"></app-slot>\r\n                    <div\r\n                      *ngIf=\"\r\n                        hasErrors(field.name, formData) && field.validation?.messages\r\n                      \"\r\n                      class=\"alert alert-danger width-50\">\r\n                      <mat-error\r\n                        *ngFor=\"let error of formData.get(field.name).errors | keyvalue\">\r\n                        {{\r\n                          printError(error, field.validation.messages[$any(error.key)])\r\n                        }}\r\n                      </mat-error>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"field.extractPath && break != 'true'\">\r\n                  <ng-container *ngFor=\"let extField of extractedFields[field.id]\">\r\n                    <ng-container *ngIf=\"extField.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: extField,\r\n                            break: 'true',\r\n                            formData: formData.controls[extField.formGroup]\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"!extField.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: extField,\r\n                            break: 'true',\r\n                            formData: formData\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                </ng-container>\r\n\r\n                <mat-tab-group\r\n                  dynamicHeight\r\n                  *ngIf=\"field.translatable\"\r\n                  [headerPosition]=\"field.translatable\">\r\n                  <mat-tab *ngFor=\"let languageKey of languages\">\r\n                    <ng-template matTabLabel>\r\n                      <span\r\n                        *ngIf=\"\r\n                          hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          )\r\n                        \"\r\n                        matBadge=\"!\"\r\n                        matBadgeColor=\"warn\"\r\n                        matBadgeSize=\"small\"\r\n                        matBadgeOverlap=\"false\"\r\n                        matBadgePosition=\"above before\">\r\n                        {{ languageKey }}</span\r\n                      >\r\n                      <span\r\n                        *ngIf=\"\r\n                          !hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          )\r\n                        \">\r\n                        {{ languageKey }}</span\r\n                      >\r\n                    </ng-template>\r\n                    <div\r\n                      class=\"input-error-div input-holder\"\r\n                      *ngIf=\"\r\n                        field.translatable && permissionService.checkPermissions(field)\r\n                      \">\r\n                      <br *ngIf=\"field.translatable === 'above'\" />\r\n                      <app-input\r\n                        *ngIf=\"field.type == 'input' || field.type == 'textarea'\"\r\n                        [parentForm]=\"formData\"\r\n                        [data]=\"translatableFields[field.name][languageKey]\"></app-input>\r\n                      <app-ckeditor\r\n                        *ngIf=\"field.type == 'ckeditor'\"\r\n                        [parentForm]=\"formData\"\r\n                        [data]=\"\r\n                          translatableFields[field.name][languageKey]\r\n                        \"></app-ckeditor>\r\n\r\n                      <div\r\n                        *ngIf=\"\r\n                          hasErrors(\r\n                            translatableFields[field.name][languageKey].name,\r\n                            formData\r\n                          ) &&\r\n                          translatableFields[field.name][languageKey].validation?.messages\r\n                        \"\r\n                        class=\"alert alert-danger width-50\">\r\n                        <mat-error\r\n                          *ngFor=\"\r\n                            let error of formData.get(\r\n                              translatableFields[field.name][languageKey].name\r\n                            ).errors | keyvalue\r\n                          \">\r\n                          {{\r\n                            printError(error, field.validation.messages[$any(error.key)])\r\n                          }}\r\n                        </mat-error>\r\n                      </div>\r\n                    </div>\r\n                  </mat-tab>\r\n                </mat-tab-group>\r\n\r\n                <!-- Submit -->\r\n                <ng-container\r\n                  *ngIf=\"\r\n                    (field.type == 'submit' &&\r\n                      permissionService.checkPermissions(field)) ||\r\n                    (field.type == 'button' && !formData.controls[field.name]?.disabled)\r\n                  \">\r\n                  <app-button\r\n                    [data]=\"field.buttonData\"\r\n                    [parentForm]=\"formData\"></app-button>\r\n                </ng-container>\r\n              </ng-template>\r\n              <ng-container *ngIf=\"col.fields\">\r\n                <ng-container *ngFor=\"let field of col.fields\">\r\n                  <ng-container *ngIf=\"areControlsExisting(field, controlArray)\">\r\n                    <ng-container *ngIf=\"field.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: parseFieldLabel(field, controlArray.dataObject),\r\n                            formData: controlArray\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"!field.formGroup\">\r\n                      <ng-template\r\n                        *ngTemplateOutlet=\"\r\n                          fieldsTpl;\r\n                          context: {\r\n                            field: parseFieldLabel(field, controlArray.dataObject),\r\n                            formData: formData\r\n                          }\r\n                        \"></ng-template>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n            <!-- Button that expands the row if expandable-->\r\n            <button\r\n              *ngIf=\"row.expandable\"\r\n              type=\"button\"\r\n              class=\"expandToggle\"\r\n              mat-button\r\n              color=\"primary\"\r\n              (click)=\"\r\n                controlArray.isOpen && row.expandable\r\n                  ? (controlArray.isOpen = false)\r\n                  : (controlArray.isOpen = true)\r\n              \">\r\n              <mat-icon\r\n                [ngStyle]=\"{\r\n                  transform: controlArray.isOpen ? 'rotate(90deg)' : 'rotate(270deg)'\r\n                }\">\r\n                arrow_back_ios_new\r\n              </mat-icon>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"!row.formArray && isVisible(row, data)\">\r\n        <!-- If the row consist of static fields -->\r\n        <div *ngIf=\"row.label\" class=\"rowTitle\">\r\n          {{ getLabel(row.label, data) }}\r\n        </div>\r\n        <div\r\n          *ngFor=\"let col of row.cols\"\r\n          class=\"col\"\r\n          [class]=\"col.class\"\r\n          [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n          <ng-container *ngIf=\"isVisible(col, data)\">\r\n            <div class=\"colTitle\" *ngIf=\"col.label\">\r\n              {{ getLabel(col.label, data) }}\r\n            </div>\r\n            <app-slot\r\n              *ngIf=\"col.components\"\r\n              [detectChanges]=\"true\"\r\n              [items]=\"col.components\"\r\n              [componentValue]=\"data.dataObject | getArrayPath : col.path\"\r\n              [parentForm]=\"formData\"></app-slot>\r\n            <ng-container *ngIf=\"col.fields\">\r\n              <ng-container *ngFor=\"let field of col.fields\">\r\n                <ng-template\r\n                  #fieldsTpl\r\n                  let-field=\"field\"\r\n                  let-break=\"break\"\r\n                  let-formData=\"formData\">\r\n                  <ng-container *ngIf=\"!field.extractPath\">\r\n                    <div\r\n                      class=\"input-error-div input-holder\"\r\n                      [class]=\"field.containerClass\"\r\n                      *ngIf=\"\r\n                        field.type !== 'submit' &&\r\n                        field.type !== 'button' &&\r\n                        !field.translatable &&\r\n                        permissionService.checkPermissions(field)\r\n                      \">\r\n                      <app-slot\r\n                        *ngIf=\"\r\n                          (field.type !== 'hidden' &&\r\n                            (field.type | getFieldComponent) !== 'ActionComponent') ||\r\n                          ((field.type | getFieldComponent) === 'ActionComponent' &&\r\n                            (field.control.component !== 'ButtonComponent' ||\r\n                              (field.control.component === 'ButtonComponent' &&\r\n                                !formData.controls[field.name]?.disabled)))\r\n                        \"\r\n                        [items]=\"[\r\n                          {\r\n                            component: (field.type | getFieldComponent),\r\n                            data: field\r\n                          }\r\n                        ]\"\r\n                        [componentValue]=\"data.dataObject | getArrayPath : col.path\"\r\n                        [parentForm]=\"formData\"></app-slot>\r\n                      <div\r\n                        *ngIf=\"\r\n                          ((field.buttonData && !field.buttonData.link) ||\r\n                            !field.buttonData) &&\r\n                          hasErrors(field.name, field.formGroup, field.type) &&\r\n                          field.validation?.messages\r\n                        \"\r\n                        class=\"alert alert-danger width-50\">\r\n                        <mat-error\r\n                          *ngFor=\"\r\n                            let error of getErrors(\r\n                              field.name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            ) | keyvalue\r\n                          \">\r\n                          {{\r\n                            printError(error, field.validation.messages[$any(error.key)])\r\n                          }}\r\n                        </mat-error>\r\n                      </div>\r\n                    </div>\r\n                  </ng-container>\r\n                  <ng-container *ngIf=\"field.extractPath && break != 'true'\">\r\n                    <ng-container *ngFor=\"let extField of extractedFields[field.id]\">\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              break: 'true',\r\n                              formData: formData.controls[extField.name]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                      <ng-container *ngIf=\"!extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              break: 'true',\r\n                              formData: formData\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </ng-container>\r\n                  </ng-container>\r\n\r\n                  <mat-tab-group\r\n                    dynamicHeight\r\n                    *ngIf=\"field.translatable\"\r\n                    [headerPosition]=\"field.translatable\">\r\n                    <mat-tab *ngFor=\"let languageKey of languages\">\r\n                      <ng-template matTabLabel>\r\n                        <span\r\n                          *ngIf=\"\r\n                            hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            )\r\n                          \"\r\n                          matBadge=\"!\"\r\n                          matBadgeColor=\"warn\"\r\n                          matBadgeSize=\"small\"\r\n                          matBadgeOverlap=\"false\"\r\n                          matBadgePosition=\"above before\">\r\n                          {{ languageKey }}</span\r\n                        >\r\n                        <span\r\n                          *ngIf=\"\r\n                            !hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            )\r\n                          \">\r\n                          {{ languageKey }}</span\r\n                        >\r\n                      </ng-template>\r\n                      <div\r\n                        class=\"input-error-div input-holder\"\r\n                        *ngIf=\"\r\n                          field.translatable && permissionService.checkPermissions(field)\r\n                        \">\r\n                        <br *ngIf=\"field.translatable === 'above'\" />\r\n                        <app-input\r\n                          *ngIf=\"field.type == 'input' || field.type == 'textarea'\"\r\n                          [parentForm]=\"formData\"\r\n                          [data]=\"\r\n                            translatableFields[field.name][languageKey]\r\n                          \"></app-input>\r\n                        <app-ckeditor\r\n                          *ngIf=\"field.type == 'ckeditor'\"\r\n                          [data]=\"translatableFields[field.name][languageKey]\"\r\n                          [parentForm]=\"formData\"></app-ckeditor>\r\n\r\n                        <div\r\n                          *ngIf=\"\r\n                            hasErrors(\r\n                              translatableFields[field.name][languageKey].name,\r\n                              field.formGroup,\r\n                              field.type\r\n                            ) &&\r\n                            translatableFields[field.name][languageKey].validation\r\n                              ?.messages\r\n                          \"\r\n                          class=\"alert alert-danger width-50\">\r\n                          <mat-error\r\n                            *ngFor=\"\r\n                              let error of formData.get(\r\n                                translatableFields[field.name][languageKey].name\r\n                              ).errors | keyvalue\r\n                            \">\r\n                            {{\r\n                              printError(\r\n                                error,\r\n                                field.validation.messages[$any(error.key)]\r\n                              )\r\n                            }}\r\n                          </mat-error>\r\n                        </div>\r\n                      </div>\r\n                    </mat-tab>\r\n                  </mat-tab-group>\r\n\r\n                  <!-- Submit -->\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      (field.type == 'submit' &&\r\n                        permissionService.checkPermissions(field)) ||\r\n                      (field.type == 'button' && !formData.controls[field.name]?.disabled)\r\n                    \">\r\n                    <div\r\n                      *ngIf=\"hasErrors(null, formData) && data.validation?.messages\"\r\n                      class=\"alert width-50\">\r\n                      <mat-error *ngFor=\"let error of formData.errors | keyvalue\">\r\n                        {{ printError(error, data.validation.messages[$any(error.key)]) }}\r\n                      </mat-error>\r\n                    </div>\r\n\r\n                    <app-button\r\n                      [data]=\"field.buttonData\"\r\n                      [parentForm]=\"formData\"></app-button>\r\n                  </ng-container>\r\n                </ng-template>\r\n\r\n                <ng-container *ngIf=\"field.draggable && field.extractPath\">\r\n                  <div\r\n                    cdkDropList\r\n                    [class]=\"field.dropListClass\"\r\n                    (cdkDropListDropped)=\"extractedFieldDrop($event, field)\">\r\n                    <div\r\n                      cdkDrag\r\n                      [class]=\"field.dragItemClass\"\r\n                      [cdkDragData]=\"field\"\r\n                      *ngFor=\"let extField of extractedFields[field.id]\">\r\n                      <!-- drag and drop placeholder template -->\r\n                      <div *cdkDragPlaceholder class=\"drag-field-placeholder\"></div>\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              formData: formData.controls[extField.formGroup]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"!field.draggable && field.extractPath\">\r\n                  <div [class]=\"field.rowClass\">\r\n                    <div\r\n                      *ngFor=\"let extField of extractedFields[field.id]\"\r\n                      [class]=\"field.itemClass\">\r\n                      <ng-container *ngIf=\"extField.formGroup\">\r\n                        <ng-template\r\n                          *ngTemplateOutlet=\"\r\n                            fieldsTpl;\r\n                            context: {\r\n                              field: extField,\r\n                              formData: formData.controls[extField.formGroup]\r\n                            }\r\n                          \"></ng-template>\r\n                      </ng-container>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n\r\n                <ng-container *ngIf=\"!field.extractPath\">\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      field.formGroup &&\r\n                      areControlsExisting(field, formData.controls[field.formGroup])\r\n                    \">\r\n                    <ng-template\r\n                      *ngTemplateOutlet=\"\r\n                        fieldsTpl;\r\n                        context: {\r\n                          field: field,\r\n                          formData: formData.controls[field.formGroup]\r\n                        }\r\n                      \"></ng-template>\r\n                  </ng-container>\r\n                  <ng-container\r\n                    *ngIf=\"!field.formGroup && areControlsExisting(field, formData)\">\r\n                    <ng-template\r\n                      *ngTemplateOutlet=\"\r\n                        fieldsTpl;\r\n                        context: { field: field, formData: formData }\r\n                      \"></ng-template>\r\n                  </ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </form>\r\n</div>\r\n", styles: ["app-radiobutton{display:flex}.center-submit-button{text-align:center}.input-error-div{text-align:center;flex-grow:1;display:inline}.formWrapper{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.formWrapper .formTitle{width:100%;height:50px;line-height:50px;padding-left:25px;background:grey;margin-top:20px;background:rgba(0,0,0,.03);color:#0000008a}.formWrapper .width100{width:100%}.formWrapper .width100 .justifyRight{display:flex;justify-content:flex-end}.formWrapper .width100 .justifyLeft{display:flex;justify-content:flex-start}.formWrapper .width100 .justifyCenter{display:flex;justify-content:center}.formWrapper form{padding:15px;background:#ffffff}.rowTitle{height:40px;line-height:40px;text-align:center;margin-bottom:20px;border-bottom:1px solid rgba(0,0,0,.03);color:#0000008a}.colTitle{margin-bottom:10px}.expandable{overflow:hidden;position:relative;padding-bottom:31px}.expandable .expandToggle{position:absolute;width:100%;bottom:-5px;z-index:1;background-color:#fff}.expandable .expandToggle .mat-icon{font-size:30px;height:30px;width:30px}.drag-placeholder,.drag-field-placeholder{border:3px dotted grey}.drag-field-placeholder{height:60px}.row .groupStart:not(:first-child){padding-top:20px}.columns{-moz-columns:2;columns:2}::ng-deep .mat-tab-group .mat-tab-header .mat-tab-label{min-width:80px}@media only screen and (max-width: 576px){.formWrapper .formTitle{margin-top:0}}@media only screen and (max-width: 767px){.columns{-moz-columns:1;columns:1}.arrayRow{border-top:2px solid;padding-bottom:10px;padding-top:10px}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: i1.Router }, { type: GetArrayPathPipe }, { type: JoinPipe }, { type: EvalService }, { type: i1$2.MatSnackBar }, { type: i3$3.MatDialog }, { type: i0.NgZone }, { type: StateService }, { type: SessionService }, { type: CloneAbstractControlService }, { type: PermissionsService }, { type: i3.Location }, { type: i0.Injector }, { type: GetArrayPathService }, { type: GetControlByPathService }, { type: i14$1.ReCaptchaV3Service }, { type: GoogleTranslateService }, { type: HelperService }, { type: CacheService }, { type: CustomValidators }, { type: TransformService }, { type: RelativeDateService }]; }, propDecorators: { data: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }], form: [{
                type: ViewChild,
                args: ['form', { static: true }]
            }] } });

class MapComponent {
    constructor(language, httpClient, route, api, getArrayPath, comm, state, platformId) {
        this.language = language;
        this.httpClient = httpClient;
        this.route = route;
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.comm = comm;
        this.state = state;
        this.platformId = platformId;
        this.apiLoaded = false;
        // public markers = [];
        // stores drawn shapes to use with events and form
        this.shapes = [];
        this.markerPositions = [];
        this.drawingModesArray = [];
        this.drawnFigures = [];
        this.loadedFigures = [];
        this.internalChange = false;
        this.destroyed = new Subject();
        this.listeners = [];
        this.customDrawElements = [];
    }
    ngOnInit() {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        const apiLoaded = new Promise((resolve) => {
            if (this.apiLoaded) {
                resolve(true);
            }
            this.apiLoadedProxy = new Proxy(this, {
                set(target, prop, value) {
                    if (prop === 'apiLoaded') {
                        target[prop] = value;
                        if (target[prop]) {
                            setTimeout(() => resolve(target[prop]), 0);
                        }
                    }
                    return true;
                }
            });
        });
        if (typeof this.parentForm !== 'undefined') {
            // if in form load from input
            this.parentForm.get(this.data.name).valueChanges
                .pipe(takeUntil(this.destroyed))
                .subscribe(value => {
                // if input value change initiats from inside the component don't
                // render shapes as they will be doubled
                apiLoaded.then(() => {
                    if (this.internalChange === false) {
                        const shapes = JSON.parse(value);
                        this.bounds = new google.maps.LatLngBounds();
                        for (const shape of shapes) {
                            this.renderShape(shape);
                            if (shape.address && this.data.autocomplete) {
                                setTimeout(() => {
                                    this.autoCompleteInput.value = shape.address;
                                }, 0);
                            }
                        }
                        if (Array.isArray(this.data.customDraw)
                            && this.data.customDraw.length > 0
                            && (this.drawnFigures.length === 0
                                || this.data.multiple
                                || (this.data.multiple
                                    && this.data.customDraw.find((button) => button.overlayType === 'marker')))) {
                            this.initCustomDraw();
                        }
                        this.fitToBounds();
                    }
                    else {
                        this.internalChange = false;
                    }
                });
            });
        }
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            const environment = this.api.getEnv();
            const selectedLanguage = this.state.get('language');
            const fullLocale = this.state
                .get('languages.full_locale_map.' + selectedLanguage)
                .split('-');
            this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key='
                + environment.mapApiToken + '&region=' + fullLocale[1] + '&language='
                + fullLocale[0] + '&libraries=places,drawing', 'callback')
                .pipe(take$1(1), catchError$1(() => of(false)))
                .subscribe(() => {
                if (typeof this.data.clustering !== 'undefined' && this.data.clustering) {
                    // If it needed to cluster the markers, this library needs to be loaded before init
                    this.httpClient.jsonp('https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js', 'callback')
                        .pipe(take$1(1), catchError$1(() => of(false)))
                        .subscribe(() => {
                        this.setupMap();
                    });
                }
                else {
                    this.setupMap();
                }
            });
        }
        else {
            this.setupMap();
        }
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (typeof this.data.dataSource !== 'undefined') {
            const paramObservables = [];
            // if dataSource set
            if (this.data.reloadsWithQuery) {
                // reload if query string changes if configured
                paramObservables.push(this.route.queryParams);
            }
            if (this.data.reloadsWithUrl) {
                // reload if url params change if configured
                paramObservables.push(this.route.params);
            }
            combineLatest(paramObservables).pipe(takeUntil(this.destroyed), debounceTime(0)).subscribe((urlParams) => {
                if (this.urlParams && this.urlParams !== urlParams) {
                    this.load();
                }
                this.urlParams = urlParams;
            });
            // initial load
            if (this.data.loadOnInit) {
                apiLoaded.then(() => this.load());
            }
        }
        // execute init event handler if such exists
        if (typeof this.data.init === 'function') {
            this.data.initParams = {
                event: 'init'
            };
            if (this.data.dataObject) {
                this.data.initParams.dataObject = this.data.dataObject;
            }
            const result = this.data.init(this.data.initParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    setupMap() {
        this.apiLoadedProxy.apiLoaded = true;
        setTimeout(() => {
            if (this.data.autocomplete) {
                this.initAutocomplete();
            }
            if (this.data.drawOnMap) {
                if (typeof this.data.customDelete !== 'undefined'
                    && this.drawnFigures.length > 0) {
                    this.initCustomDelete();
                }
                if (Array.isArray(this.data.customDraw)
                    && this.data.customDraw.length > 0
                    && this.drawnFigures.length === 0) {
                    this.initCustomDraw();
                }
                this.initDrawingManager(this.gMap);
            }
            if (this.data.dataObject && this.data.dataObject.location) {
                this.getLocation(this.data.dataObject.location);
            }
        }, 0);
    }
    initAutocomplete() {
        const autoCompleteOptions = {
            fields: ['place_id', 'address_components', 'geometry', 'name']
        };
        if (typeof this.data.searchByCountries !== 'undefined') {
            autoCompleteOptions.componentRestrictions = {
                country: this.data.searchByCountries
            };
        }
        this.autoCompleteInput = document.getElementById('autocomplete');
        this.autocomplete = new google.maps.places.Autocomplete(this.autoCompleteInput, autoCompleteOptions);
        google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
            const place = this.autocomplete.getPlace();
            const myLatlng = place.geometry.location;
            this.gMap.googleMap.panTo(myLatlng);
            if (this.data.pinOnSearch) {
                const marker = new google.maps.Marker({
                    position: myLatlng,
                    title: place.name
                });
                marker.setMap(this.gMap.googleMap);
                if (this.data.drawOnMap) {
                    this.storeShape({
                        type: 'marker',
                        overlay: marker
                    });
                }
            }
            if (this.data.loadAddress) {
                // TODO handle all shapes
                const selectedLanguage = this.state.get('language');
                let otherLanguages = Object.keys(this.state.get('languages.all'));
                otherLanguages.splice(otherLanguages.indexOf(selectedLanguage), 1);
                this.getAddress(myLatlng, selectedLanguage, otherLanguages);
            }
        });
        return true;
    }
    initDrawingManager(mapEl) {
        if (typeof this.data.drawingModes !== 'undefined'
            && this.data.drawingModes.length > 0) {
            for (const drawingMode of this.data.drawingModes) {
                this.drawingModesArray.push(drawingMode);
            }
        }
        // Creating drawing manager tool bar
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER,
                drawingModes: this.drawingModesArray,
            },
            markerOptions: {
                icon: this.data.drawingManagerMarkerIcon
            },
            circleOptions: this.data.drawingManagerCircleOptions
        });
        this.drawingManager.setOptions({
            drawingControl: Array.isArray(this.data.drawingModes)
                && this.data.drawingModes.length > 0
        });
        this.drawingManager.setMap(mapEl.googleMap);
        if (typeof this.data.startDrawingMode !== 'undefined') {
            this.drawingManager.setDrawingMode(this.data.startDrawingMode);
        }
        if (this.data.shapes) {
            // load shapes from url if configured
            this.route.params
                .pipe(takeUntil(this.destroyed))
                .subscribe(urlParams => {
                const param = this.data.shapes.replace(':', '');
                // this.deleteAllShapes(true, false);
                if (typeof urlParams[param] !== 'undefined') {
                    if (urlParams[param].length >= 6) {
                        const shape = {
                            type: 'polygon',
                            drawParams: []
                        };
                        let point;
                        const coordinates = urlParams[param].split(',');
                        for (const index in coordinates) {
                            if (parseInt(index, 10) % 2 === 0) {
                                point = {};
                                point.lat = parseFloat(coordinates[index]);
                            }
                            else {
                                point.lng = parseFloat(coordinates[index]);
                                shape.drawParams.push(point);
                            }
                        }
                        this.bounds = new google.maps.LatLngBounds();
                        this.renderShape(shape);
                        this.fitToBounds();
                    }
                }
            });
        }
        google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
            this.storeShape(event);
            if (this.data.autocomplete || this.data.loadAddress) {
                // TODO handle all shapes
                const selectedLanguage = this.state.get('language');
                let otherLanguages = Object.keys(this.state.get('languages.all'));
                otherLanguages.splice(otherLanguages.indexOf(selectedLanguage), 1);
                this.getAddress(event.overlay.getPosition(), selectedLanguage, otherLanguages);
            }
            if (!this.data.loadAddress) {
                // if there is no need to wait for an address to be geocoded
                // execute drawFinished event handler if map is in action component
                this.handleDrawFinished();
            }
        });
    }
    attachAddress(destinationObject, addresses) {
        if (typeof this.data.loadAddress === 'object'
            && Object.keys(this.data.loadAddress).length > 0) {
            destinationObject.address = {};
            for (const locale in addresses) {
                const address = addresses[locale];
                if (this.data.loadAddress.full) {
                    if (!destinationObject.address.full) {
                        destinationObject.address.full = {};
                    }
                    destinationObject.address.full[locale] = address.results[0].formatted_address;
                }
                if (typeof this.data.loadAddress.components === 'object'
                    && Object.keys(this.data.loadAddress.components).length > 0) {
                    if (!destinationObject.address.components) {
                        destinationObject.address.components = {};
                    }
                    for (const addressComponent of address.results[0].address_components) {
                        for (const component in this.data.loadAddress.components) {
                            const type = this.data.loadAddress.components[component];
                            if (!destinationObject.address.components[component]) {
                                destinationObject.address.components[component] = [];
                            }
                            if (addressComponent.types.includes(type)) {
                                destinationObject
                                    .address
                                    .components[component]
                                    .push({
                                    locale,
                                    text: addressComponent.long_name
                                });
                            }
                        }
                    }
                }
            }
        }
    }
    handleDrawFinished(addresses) {
        if (typeof this.data.customDelete !== 'undefined') {
            this.initCustomDelete();
            if (!this.data.multiple) {
                this.drawingManager.setMap(null);
                this.customDrawElements.forEach(el => {
                    el.classList.add('d-none');
                });
                if (typeof this.customCancelDraw !== 'undefined') {
                    this.customCancelDraw.classList.add('d-none');
                }
            }
            else {
                this.customDrawElements.forEach(el => {
                    el.classList.remove('d-none');
                });
                if (typeof this.customCancelDraw !== 'undefined') {
                    this.customCancelDraw.classList.add('d-none');
                }
            }
        }
        if (typeof this.data.drawFinished === 'function') {
            this.data.drawFinishedParams = {
                event: 'drawFinished',
                shapes: {}
            };
            for (const s of this.shapes) {
                if (typeof this.data.drawFinishedParams.shapes[s.type] === 'undefined') {
                    this.data.drawFinishedParams.shapes[s.type] = [];
                }
                this.data.drawFinishedParams.shapes[s.type].push(Object.values(s.drawParams));
            }
            if (addresses) {
                this.attachAddress(this.data.drawFinishedParams, addresses);
            }
            if (this.data.dataObject) {
                this.data.drawFinishedParams.dataObject = this.data.dataObject;
            }
            const result = this.data.drawFinished(this.data.drawFinishedParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    load() {
        this.deleteAllShapes(false, false);
        this.markerPositions = [];
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            if (typeof this.data.customDelete !== 'undefined'
                && this.drawnFigures.length > 0) {
                this.initCustomDelete();
            }
            if (Array.isArray(this.data.customDraw)
                && this.data.customDraw.length > 0
                && (this.drawnFigures.length === 0
                    || this.data.multiple
                    || (!this.data.multiple
                        && this.data.customDraw.find((button) => button.overlayType === 'marker')))) {
                this.initCustomDraw();
            }
            const items = this.getArrayPath.get(response.result.data, this.data.dataSource.path);
            this.bounds = new google.maps.LatLngBounds();
            if (Array.isArray(items)) {
                let i = 0;
                for (let shapes of items) {
                    if (typeof shapes === 'string') {
                        shapes = JSON.parse(shapes);
                    }
                    for (const shape of shapes) {
                        shape.value = this.getArrayPath.get(response.result.data[i], this.data.markersValuePath);
                        i++;
                        this.renderShape(shape, false);
                    }
                }
                this.fitToBounds();
            }
            if (this.drawnFigures.length > 0) {
                this.customDrawElements.forEach(el => {
                    el.classList.add('d-none');
                });
            }
            if (typeof this.data.loaded === 'function') {
                if (!this.data.loadedParams) {
                    this.data.loadedParams = {};
                }
                this.data.loadedParams.event = 'loaded';
                this.data.loadedParams.dataObject = response.result.data;
                const result = this.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
    }
    storeShape(shape) {
        const shapeHandlers = {
            marker: (event) => {
                return {
                    type: event.type,
                    drawParams: {
                        lat: event.overlay.position.lat(),
                        lng: event.overlay.position.lng()
                    }
                };
            },
            circle: (event) => {
                const center = event.overlay.getCenter();
                return {
                    type: event.type,
                    drawParams: {
                        lat: center.lat(),
                        lng: center.lng(),
                        radius: event.overlay.getRadius()
                    }
                };
            },
            polygon: (event) => {
                const polygonPoints = event.overlay.getPath().getArray();
                const firstAndLastPoint = event.overlay.getPath().getArray()[0];
                const polygonCoordinates = [];
                for (const point of polygonPoints) {
                    const currentPoint = {
                        lat: point.lat(),
                        lng: point.lng()
                    };
                    polygonCoordinates.push(currentPoint);
                }
                // the last point of polygon should be always the same as the first point
                polygonCoordinates.push({
                    lat: firstAndLastPoint.lat(),
                    lng: firstAndLastPoint.lng()
                });
                return {
                    type: event.type,
                    drawParams: polygonCoordinates
                };
            },
            rectangle: (event) => {
                const rectangleBounds = event.overlay.getBounds();
                const north = rectangleBounds.getNorthEast().lat();
                const south = rectangleBounds.getSouthWest().lat();
                const east = rectangleBounds.getNorthEast().lng();
                const west = rectangleBounds.getSouthWest().lng();
                return {
                    type: event.type,
                    drawParams: {
                        north,
                        south,
                        east,
                        west
                    }
                };
            }
        };
        if (!this.data.multiple && this.drawnFigures.length > 0) {
            this.drawnFigures[0].overlay.setMap(null);
            this.drawnFigures = [];
            this.shapes = [];
        }
        this.drawnFigures.push(shape);
        this.shapes.push(shapeHandlers[shape.type](shape));
        this.internalChange = true;
        if (typeof this.parentForm !== 'undefined') {
            this.parentForm.get(this.data.name).setValue(JSON.stringify(this.shapes));
        }
    }
    renderShape(shape, drawn = true) {
        const shapeRenderers = {
            marker: (marker) => {
                if (typeof this.data.clustering !== 'undefined' && this.data.clustering) {
                    marker.drawParams.value = shape.value;
                    this.markerPositions.push(marker.drawParams);
                    this.bounds.extend(marker.drawParams);
                }
                else {
                    const mrkr = new google.maps.Marker({
                        position: marker.drawParams,
                        map: this.gMap.googleMap,
                        icon: this.data.markersIcon
                    });
                    const listener = google.maps.event.addListener(mrkr, 'click', this.markerOnClick.bind(this, { value: shape.value }));
                    this.listeners.push(listener);
                    this.bounds.extend(mrkr.getPosition());
                    // this.drawnFigures.push({ overlay: mrkr });
                    return mrkr;
                }
            },
            circle: (circle) => {
                const cl = new google.maps.Circle({
                    center: {
                        lat: circle.drawParams.lat,
                        lng: circle.drawParams.lng
                    },
                    radius: circle.drawParams.radius,
                    map: this.gMap.googleMap
                });
                this.bounds.union(cl.getBounds());
                // this.drawnFigures.push({ overlay: cl });
                return cl;
            },
            polygon: (polygon) => {
                const poly = new google.maps.Polygon({
                    paths: polygon.drawParams,
                    map: this.gMap.googleMap
                });
                poly.getPaths()
                    .forEach((path) => path.forEach((point) => this.bounds.extend(point)));
                // this.drawnFigures.push({ overlay: poly });
                return poly;
            },
            rectangle: (rectangle) => {
                // TODO implement
                // new rect =
            },
        };
        const overlay = shapeRenderers[shape.type](shape);
        if (drawn) {
            this.drawnFigures.push({ overlay });
        }
        else {
            this.loadedFigures.push({ overlay });
        }
    }
    initCustomDelete() {
        if (!this.customDeleteElement) {
            this.customDeleteElement = this.buildControlDiv('delete', this.data.customDelete.title, this.data.customDelete.icon);
            const pos = this.getPosition(this.data.customDelete.controlPosition);
            this.gMap.googleMap.controls[pos].push(this.customDeleteElement);
            const l = this.customDeleteElement.addEventListener('click', () => {
                this.deleteAllShapes();
                if (typeof this.customDeleteElement !== 'undefined') {
                    this.customDeleteElement.classList.add('d-none');
                }
                if (typeof this.customCancelDraw !== 'undefined') {
                    this.customCancelDraw.classList.add('d-none');
                }
                if (typeof this.customDrawElements !== 'undefined') {
                    this.customDrawElements.forEach(el => {
                        el.classList.remove('d-none');
                    });
                }
                this.initCustomDraw();
            });
        }
        else {
            this.customDeleteElement.classList.remove('d-none');
        }
    }
    initCustomDraw() {
        if (this.customDrawElements.length > 0) {
            this.drawingManager.setMap(null);
            return;
        }
        for (const customDraw of this.data.customDraw) {
            if (this.drawnFigures.length === 0
                || (customDraw.overlayType === 'marker'
                    && !this.data.customDelete))
                renderCustomDraw.call(this, customDraw.title, customDraw.icon, customDraw.overlayType, customDraw.controlPosition);
        }
        function renderCustomDraw(title, icon, overlayType, controlPosition) {
            const controlDiv = this.buildControlDiv.call(this, 'draw', title, icon);
            const drawingMode = this.getDrawingMode(overlayType);
            const position = this.getPosition(controlPosition);
            this.customDrawElements.push(controlDiv);
            this.gMap.googleMap.controls[position]
                .push(controlDiv);
            const l = controlDiv.addEventListener('click', () => {
                this.drawingManager.setMap(this.gMap.googleMap);
                this.drawingManager.setDrawingMode(drawingMode);
                this.customDrawElements.forEach(el => {
                    el.classList.add('d-none');
                });
                if (typeof this.data.customCancelDraw !== 'undefined') {
                    this.initCustomCancelDraw();
                }
            });
            this.listeners.push(l);
        }
    }
    initCustomCancelDraw() {
        if (!this.customCancelDraw) {
            const controlDiv = this.buildControlDiv('cancel', this.data.customCancelDraw.title, this.data.customCancelDraw.icon);
            const position = this.getPosition(this.data.customCancelDraw.controlPosition);
            this.customCancelDraw = controlDiv;
            this.gMap.googleMap.controls[position]
                .push(controlDiv);
            this.customDrawElements.forEach(el => {
                el.classList.add('d-none');
            });
            const l = controlDiv.addEventListener('click', () => {
                // this.deleteAllShapes();
                // this.drawingManager.setDrawingMode(null);
                // this.drawingManager.setMap(null);
                this.customDrawElements.forEach(el => {
                    el.classList.remove('d-none');
                });
                this.initCustomDraw();
                this.customCancelDraw.classList.add('d-none');
            });
        }
        else {
            this.customCancelDraw.classList.remove('d-none');
        }
    }
    deleteAllShapes(drawn = true, fireEvent = true) {
        let prop = 'loadedFigures';
        if (drawn) {
            prop = 'drawnFigures';
            this.shapes = [];
        }
        this[prop].forEach((value) => {
            if (typeof value.overlay !== 'undefined') {
                value.overlay.setMap(null);
            }
            this.internalChange = true;
            if (typeof this.parentForm !== 'undefined') {
                this.parentForm.get(this.data.name).setValue('');
            }
        });
        this[prop] = [];
        // execute deleteDraw event handler if map is in action
        if (fireEvent && typeof this.data.deleteDraw === 'function') {
            this.data.deleteDrawParams = {
                event: 'deleteDraw',
                shapes: {}
            };
            this.data.deleteDrawParams.shapes = {};
            for (const s of this.shapes) {
                if (typeof this.data.deleteDrawParams.shapes[s.type] === 'undefined') {
                    this.data.deleteDrawParams.shapes[s.type] = [];
                }
                this.data.deleteDrawParams.shapes[s.type].push(Object.values(s.drawParams));
            }
            this.data.deleteDrawParams.event = 'deleteDraw';
            if (this.data.dataObject) {
                this.data.deleteDrawParams.dataObject = this.data.dataObject;
            }
            const result = this.data.deleteDraw(this.data.deleteDrawParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    getAddress(latLng, selectedLanguage, otherLanguages, addresses) {
        const geocoder = new google.maps.Geocoder();
        return geocoder.geocode({ 'location': latLng, language: selectedLanguage }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    return results[0].formatted_address;
                }
                else {
                    console.log('No results found');
                }
            }
            else {
                console.log('Geocoder failed due to: ' + status);
            }
        }).then((address) => {
            if (this.data.autocomplete && !addresses) {
                this.autoCompleteInput.value = address.results[0].formatted_address;
            }
            if (this.data.loadAddress) {
                if (!addresses) {
                    addresses = {};
                }
                addresses[selectedLanguage] = address;
                if (typeof otherLanguages !== 'undefined' && otherLanguages.length > 0) {
                    const language = otherLanguages.shift();
                    this.getAddress(latLng, language, otherLanguages, addresses);
                }
                else {
                    // at the end of the getAddress language chain
                    // execute drawFinished event handler if map is in action component
                    this.handleDrawFinished(addresses);
                    // this.initCustomDelete();
                }
            }
        });
    }
    getLocation(location) {
        const locationItems = JSON.parse(location);
        this.deleteAllShapes(false, false);
        this.bounds = new google.maps.LatLngBounds();
        for (const shape of locationItems) {
            this.renderShape(shape, true);
        }
        this.fitToBounds();
    }
    fitToBounds() {
        this.gMap.googleMap.fitBounds(this.bounds, 100);
        if (this.gMap.googleMap.getZoom() > 16) {
            this.gMap.googleMap.setZoom(16);
        }
    }
    markerOnClick(marker) {
        if (typeof this.data.markerClick === 'function') {
            if (!this.data.markerParams) {
                this.data.markerParams = {};
            }
            this.data.markerParams.event = 'markerClick';
            this.data.markerParams.value = marker.value;
            const result = this.data.markerClick(this.data.markerParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    openInfoWindow(marker, content) {
        this.infoContent = content;
        this.infoWindow.open(marker);
    }
    getPosition(position) {
        let p;
        switch (position) {
            case 'top-center': {
                p = google.maps.ControlPosition.TOP_CENTER;
                break;
            }
            case 'left-center': {
                p = google.maps.ControlPosition.LEFT_CENTER;
                break;
            }
            case 'right-center': {
                p = google.maps.ControlPosition.RIGHT_CENTER;
                break;
            }
            case 'bottom-center': {
                p = google.maps.ControlPosition.BOTTOM_CENTER;
                break;
            }
        }
        return p;
    }
    getDrawingMode(type) {
        let drawingMode;
        switch (type) {
            case 'polygon': {
                drawingMode = google.maps.drawing.OverlayType.POLYGON;
                break;
            }
            case 'circle': {
                drawingMode = google.maps.drawing.OverlayType.CIRCLE;
                break;
            }
            case 'marker': {
                drawingMode = google.maps.drawing.OverlayType.MARKER;
                break;
            }
            case 'polyline': {
                drawingMode = google.maps.drawing.OverlayType.POLYLINE;
                break;
            }
            case 'rectangle': {
                drawingMode = google.maps.drawing.OverlayType.RECTANGLE;
                break;
            }
        }
        return drawingMode;
    }
    buildControlDiv(type, title, icon) {
        const classType = type.slice(0, 1).toUpperCase() + type.slice(1);
        const controlDiv = document.createElement('div');
        controlDiv.classList.add(`custom${classType}`);
        controlDiv.setAttribute('id', `custom${classType}`);
        const borderChild = document.createElement('div');
        borderChild.setAttribute('id', 'borderChild');
        const contentChild = document.createElement('div');
        contentChild.setAttribute('id', 'contentChild');
        const span = document.createElement('span');
        span.textContent = this.language.getLabel(title);
        const image = document.createElement('i');
        image.classList.add('material-icons');
        image.textContent = icon;
        contentChild.appendChild(image);
        contentChild.appendChild(span);
        borderChild.appendChild(contentChild);
        controlDiv.appendChild(borderChild);
        return controlDiv;
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        for (const listener of this.listeners) {
            google.maps.event.removeListener(listener);
        }
    }
}
MapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapComponent, deps: [{ token: LanguageService }, { token: i1$1.HttpClient }, { token: i1.ActivatedRoute }, { token: ApiService }, { token: GetArrayPathService }, { token: CommunicationService }, { token: StateService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
MapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MapComponent, selector: "app-map", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "infoWindow", first: true, predicate: MapInfoWindow, descendants: true }, { propertyName: "gMap", first: true, predicate: ["googleMap"], descendants: true }], ngImport: i0, template: "<div id=\"pac-container\" *ngIf=\"data.autocomplete\">\r\n  <input\r\n    id=\"autocomplete\"\r\n    type=\"text\"\r\n    [placeholder]=\"language.getLabel(data.autocompletePlaceholder)\"\r\n  />\r\n</div>\r\n<google-map\r\n  [ngClass]=\"{ sized: data.options.width || data.options.height }\"\r\n  [ngStyle]=\"{\r\n    width: data.options.width || 'auto',\r\n    height: data.options.height || 'auto'\r\n  }\"\r\n  id=\"map\"\r\n  [options]=\"data.options\"\r\n  #googleMap\r\n  *ngIf=\"apiLoaded\"\r\n>\r\n  <!-- <map-marker\r\n    #markerEl=\"mapMarker\"\r\n    width=\"100%\"\r\n    *ngFor=\"let marker of markers\"\r\n    [position]=\"marker.position\"\r\n    [label]=\"marker.label\"\r\n    [title]=\"marker.title\"\r\n    [icon]=\"marker.icon\"\r\n    (mapClick)=\"openInfoWindow(markerEl, marker)\"\r\n  >\r\n  </map-marker>\r\n  <ng-container *ngIf=\"data.shape == 'polygon'\">\r\n    <map-polygon [paths]=\"data.coordinates\"></map-polygon>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.shape == 'rectangle'\">\r\n    <map-rectangle [bounds]=\"data.coordinates\"></map-rectangle>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.shape == 'circle'\">\r\n    <map-circle\r\n      [center]=\"data.coordinates.circleCenter\"\r\n      [radius]=\"data.coordinates.circleRadius\"\r\n    >\r\n    </map-circle>\r\n  </ng-container> -->\r\n  <map-marker-clusterer *ngIf=\"data.clustering\" [imagePath]=\"data.markerClustererImagePath\">\r\n    <map-marker\r\n      *ngFor=\"let markerPosition of markerPositions\"\r\n      [position]=\"markerPosition\"\r\n      [options]=\"{ icon: data.markersIcon }\"\r\n      (mapClick)=\"markerOnClick(markerPosition)\"\r\n    >\r\n    </map-marker>\r\n  </map-marker-clusterer>\r\n  <map-info-window>\r\n    <ng-container *ngIf=\"infoContent\">\r\n      {{ infoContent.title }}\r\n\r\n      <!--Render html elements in info window-->\r\n      <ng-container *ngIf=\"infoContent.html\">\r\n        <app-html [innerHTML]=\"infoContent.infoWindowDescription\"></app-html>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"!infoContent.html && infoContent.infoWindowDescription\">\r\n        {{ infoContent.infoWindowDescription }}\r\n      </ng-container>\r\n\r\n      <!--Visualize image in info window if there is any-->\r\n      <ng-container *ngIf=\"infoContent.infoWindowImage\">\r\n        <img\r\n          [title]=\"infoContent.infoWindowImage.title\"\r\n          [src]=\"infoContent.infoWindowImage.url\"\r\n        />\r\n      </ng-container>\r\n    </ng-container>\r\n  </map-info-window>\r\n</google-map>\r\n", styles: ["#autocomplete{width:100%;margin-bottom:10px}.sized{display:block}::ng-deep .map-container{width:100%!important;height:100%!important}::ng-deep #customDelete,::ng-deep #customCancel,::ng-deep .customDraw{margin-left:13px}::ng-deep #customDelete #borderChild,::ng-deep #customCancel #borderChild,::ng-deep .customDraw #borderChild{min-width:44px;min-height:48px;display:flex;flex-direction:column;justify-content:center;align-items:center;background:none padding-box rgb(255,255,255);border:1px solid #ccc;margin:4px 0 0 -6px;cursor:pointer;border-radius:0 3px 3px 0}::ng-deep #customDelete #borderChild :hover,::ng-deep #customCancel #borderChild :hover,::ng-deep .customDraw #borderChild :hover{background:none padding-box rgb(235,235,235)}::ng-deep #customDelete #contentChild,::ng-deep #customCancel #contentChild,::ng-deep .customDraw #contentChild{font-size:12px;padding:5px 8px;display:flex;flex-direction:column;justify-content:center;align-items:center}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i9$2.GoogleMap, selector: "google-map", inputs: ["height", "width", "mapTypeId", "center", "zoom", "options"], outputs: ["mapInitialized", "authFailure", "boundsChanged", "centerChanged", "mapClick", "mapDblclick", "mapDrag", "mapDragend", "mapDragstart", "headingChanged", "idle", "maptypeidChanged", "mapMousemove", "mapMouseout", "mapMouseover", "projectionChanged", "mapRightclick", "tilesloaded", "tiltChanged", "zoomChanged"], exportAs: ["googleMap"] }, { kind: "directive", type: i9$2.MapInfoWindow, selector: "map-info-window", inputs: ["options", "position"], outputs: ["closeclick", "contentChanged", "domready", "positionChanged", "zindexChanged"], exportAs: ["mapInfoWindow"] }, { kind: "directive", type: i9$2.MapMarker, selector: "map-marker", inputs: ["title", "position", "label", "clickable", "options", "icon", "visible"], outputs: ["animationChanged", "mapClick", "clickableChanged", "cursorChanged", "mapDblclick", "mapDrag", "mapDragend", "draggableChanged", "mapDragstart", "flatChanged", "iconChanged", "mapMousedown", "mapMouseout", "mapMouseover", "mapMouseup", "positionChanged", "mapRightclick", "shapeChanged", "titleChanged", "visibleChanged", "zindexChanged"], exportAs: ["mapMarker"] }, { kind: "component", type: i9$2.MapMarkerClusterer, selector: "map-marker-clusterer", inputs: ["ariaLabelFn", "averageCenter", "batchSize", "batchSizeIE", "calculator", "clusterClass", "enableRetinaIcons", "gridSize", "ignoreHidden", "imageExtension", "imagePath", "imageSizes", "maxZoom", "minimumClusterSize", "styles", "title", "zIndex", "zoomOnClick", "options"], outputs: ["clusteringbegin", "clusteringend", "clusterClick"], exportAs: ["mapMarkerClusterer"] }, { kind: "component", type: HtmlComponent, selector: "app-html", inputs: ["data"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-map', template: "<div id=\"pac-container\" *ngIf=\"data.autocomplete\">\r\n  <input\r\n    id=\"autocomplete\"\r\n    type=\"text\"\r\n    [placeholder]=\"language.getLabel(data.autocompletePlaceholder)\"\r\n  />\r\n</div>\r\n<google-map\r\n  [ngClass]=\"{ sized: data.options.width || data.options.height }\"\r\n  [ngStyle]=\"{\r\n    width: data.options.width || 'auto',\r\n    height: data.options.height || 'auto'\r\n  }\"\r\n  id=\"map\"\r\n  [options]=\"data.options\"\r\n  #googleMap\r\n  *ngIf=\"apiLoaded\"\r\n>\r\n  <!-- <map-marker\r\n    #markerEl=\"mapMarker\"\r\n    width=\"100%\"\r\n    *ngFor=\"let marker of markers\"\r\n    [position]=\"marker.position\"\r\n    [label]=\"marker.label\"\r\n    [title]=\"marker.title\"\r\n    [icon]=\"marker.icon\"\r\n    (mapClick)=\"openInfoWindow(markerEl, marker)\"\r\n  >\r\n  </map-marker>\r\n  <ng-container *ngIf=\"data.shape == 'polygon'\">\r\n    <map-polygon [paths]=\"data.coordinates\"></map-polygon>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.shape == 'rectangle'\">\r\n    <map-rectangle [bounds]=\"data.coordinates\"></map-rectangle>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.shape == 'circle'\">\r\n    <map-circle\r\n      [center]=\"data.coordinates.circleCenter\"\r\n      [radius]=\"data.coordinates.circleRadius\"\r\n    >\r\n    </map-circle>\r\n  </ng-container> -->\r\n  <map-marker-clusterer *ngIf=\"data.clustering\" [imagePath]=\"data.markerClustererImagePath\">\r\n    <map-marker\r\n      *ngFor=\"let markerPosition of markerPositions\"\r\n      [position]=\"markerPosition\"\r\n      [options]=\"{ icon: data.markersIcon }\"\r\n      (mapClick)=\"markerOnClick(markerPosition)\"\r\n    >\r\n    </map-marker>\r\n  </map-marker-clusterer>\r\n  <map-info-window>\r\n    <ng-container *ngIf=\"infoContent\">\r\n      {{ infoContent.title }}\r\n\r\n      <!--Render html elements in info window-->\r\n      <ng-container *ngIf=\"infoContent.html\">\r\n        <app-html [innerHTML]=\"infoContent.infoWindowDescription\"></app-html>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"!infoContent.html && infoContent.infoWindowDescription\">\r\n        {{ infoContent.infoWindowDescription }}\r\n      </ng-container>\r\n\r\n      <!--Visualize image in info window if there is any-->\r\n      <ng-container *ngIf=\"infoContent.infoWindowImage\">\r\n        <img\r\n          [title]=\"infoContent.infoWindowImage.title\"\r\n          [src]=\"infoContent.infoWindowImage.url\"\r\n        />\r\n      </ng-container>\r\n    </ng-container>\r\n  </map-info-window>\r\n</google-map>\r\n", styles: ["#autocomplete{width:100%;margin-bottom:10px}.sized{display:block}::ng-deep .map-container{width:100%!important;height:100%!important}::ng-deep #customDelete,::ng-deep #customCancel,::ng-deep .customDraw{margin-left:13px}::ng-deep #customDelete #borderChild,::ng-deep #customCancel #borderChild,::ng-deep .customDraw #borderChild{min-width:44px;min-height:48px;display:flex;flex-direction:column;justify-content:center;align-items:center;background:none padding-box rgb(255,255,255);border:1px solid #ccc;margin:4px 0 0 -6px;cursor:pointer;border-radius:0 3px 3px 0}::ng-deep #customDelete #borderChild :hover,::ng-deep #customCancel #borderChild :hover,::ng-deep .customDraw #borderChild :hover{background:none padding-box rgb(235,235,235)}::ng-deep #customDelete #contentChild,::ng-deep #customCancel #contentChild,::ng-deep .customDraw #contentChild{font-size:12px;padding:5px 8px;display:flex;flex-direction:column;justify-content:center;align-items:center}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i1$1.HttpClient }, { type: i1.ActivatedRoute }, { type: ApiService }, { type: GetArrayPathService }, { type: CommunicationService }, { type: StateService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], infoWindow: [{
                type: ViewChild,
                args: [MapInfoWindow]
            }], gMap: [{
                type: ViewChild,
                args: ['googleMap', { static: false }]
            }] } });

class MapModule {
    constructor(routing) {
        routing.mapComponent('MapComponent', MapComponent);
    }
}
MapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
MapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: MapModule, declarations: [MapComponent], imports: [CommonModule,
        GoogleMapsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        PrimitiveModule,
        ReactiveFormsModule], exports: [MapComponent] });
MapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapModule, imports: [CommonModule,
        GoogleMapsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        PrimitiveModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapComponent],
                    imports: [
                        CommonModule,
                        GoogleMapsModule,
                        HttpClientModule,
                        HttpClientJsonpModule,
                        PrimitiveModule,
                        ReactiveFormsModule
                    ],
                    exports: [MapComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var map_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   MapModule: MapModule
});

class FormModule {
    constructor(routing) {
        routing.mapComponent('FormComponent', FormComponent);
    }
}
FormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FormModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
FormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: FormModule, declarations: [FormComponent, GetFieldComponent], imports: [CommonModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSliderModule,
        MapModule,
        AddressAutocompleteModule,
        MatSlideToggleModule,
        MatGridListModule,
        ReactiveFormsModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        SlotModule,
        PrimitiveModule,
        PipesModule,
        MatTabsModule,
        MatBadgeModule,
        MatDialogModule,
        DragDropModule] });
FormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FormModule, imports: [CommonModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSliderModule,
        MapModule,
        AddressAutocompleteModule,
        MatSlideToggleModule,
        MatGridListModule,
        ReactiveFormsModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        SlotModule,
        PrimitiveModule,
        PipesModule,
        MatTabsModule,
        MatBadgeModule,
        MatDialogModule,
        DragDropModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormComponent, GetFieldComponent],
                    imports: [
                        CommonModule,
                        MatAutocompleteModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatSliderModule,
                        MapModule,
                        AddressAutocompleteModule,
                        MatSlideToggleModule,
                        MatGridListModule,
                        ReactiveFormsModule,
                        FormsModule,
                        MatButtonModule,
                        MatIconModule,
                        SlotModule,
                        PrimitiveModule,
                        PipesModule,
                        MatTabsModule,
                        MatBadgeModule,
                        MatDialogModule,
                        DragDropModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var form_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   FormModule: FormModule
});

class GalleryComponent {
    constructor(language, api, dialog, route) {
        this.language = language;
        this.api = api;
        this.dialog = dialog;
        this.route = route;
        this.items = [];
        this.imageDisplaySize = '';
        this.dropzoneConfig = {
            label: 'App_upload_image',
            removable: false,
            multiple: false,
            expandable: false,
            change: null
        };
        this.dropzoneConfig.change = this.uploadImage.bind(this);
    }
    callDataService(dataServiceConfig, successCallback, params) {
        if (typeof this.data.uploadClass === 'undefined') {
            this.data.uploadClass = 'col-lg-24 col-xl-4 pt-3';
        }
        if (typeof this.data.contentClass === 'undefined') {
            this.data.contentClass = 'col-lg-24 col-xl-20';
        }
        if (typeof this.data.contentItemClass === 'undefined') {
            this.data.contentItemClass = 'col-xs-24 col-sm-6 col-md-8 col-lg-4 pt-3';
        }
        this.route.paramMap
            .pipe(take$1(1))
            .subscribe(routeParams => {
            // parse data source params and replace any url params that are mapped
            let dataServiceParams = {};
            if (typeof dataServiceConfig.params !== 'undefined') {
                let paramStr = JSON.stringify(dataServiceConfig.params);
                const pattern = /\"(:[\w-]+?)\"/g;
                let placeholder;
                // tslint:disable-next-line: no-conditional-assignment
                while ((placeholder = pattern.exec(paramStr)) !== null) {
                    const param = placeholder[1].replace(':', '');
                    if (param) {
                        const search = placeholder[1];
                        paramStr = paramStr.replace(search, routeParams.get(param));
                    }
                }
                if (typeof params !== 'undefined') {
                    dataServiceParams = Object.assign(params, JSON.parse(paramStr));
                }
                else {
                    dataServiceParams = JSON.parse(paramStr);
                }
            }
            else if (typeof params !== 'undefined') {
                dataServiceParams = params;
            }
            const dataService = this.api.getService(dataServiceConfig.service);
            dataService[dataServiceConfig.method](dataServiceParams)
                .pipe(take$1(1))
                .subscribe(successCallback);
        });
    }
    ngOnInit() {
        if (typeof this.data.imageDisplaySize !== 'undefined') {
            this.imageDisplaySize = this.data.imageDisplaySize + '_';
        }
        if (typeof this.data.dropzone !== 'undefined') {
            this.dropzoneConfig = Object.assign(this.dropzoneConfig, this.data.dropzone);
        }
        this.callDataService(this.data.dataSource, (response) => {
            this.items = response.result.data;
            // execute init event handler if form is in action
            if (typeof this.data.init === 'function') {
                this.data.initParams = {
                    event: 'init'
                };
                if (this.items) {
                    this.data.initParams.dataObject = this.items;
                    this.data.initParams.imageCount = this.items.length;
                }
                const result = this.data.init(this.data.initParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
    }
    uploadImage(params) {
        this.callDataService(this.data.upload, (response) => {
            if (typeof response.error !== 'undefined') {
                if (typeof this.data.uploadError === 'function') {
                    this.data.uploadErrorParams = {
                        event: 'uploadError'
                    };
                    const result = this.data.uploadError(this.data.uploadErrorParams);
                    if (result instanceof Observable) {
                        result.pipe(take$1(1)).subscribe();
                    }
                }
                return of([]);
            }
            if (typeof response.result.data !== 'undefined') {
                this.items.unshift(...response.result.data);
            }
            else if (response.result.status === 'success') {
                this.items.unshift(response.result.url);
            }
            // execute uploadSuccess event handler if form is in action
            if (typeof this.data.uploadSuccess === 'function') {
                this.data.uploadSuccessParams = {
                    event: 'uploadSuccess'
                };
                if (this.items) {
                    this.data.uploadSuccessParams.dataObject = this.items;
                    this.data.uploadSuccessParams.imageCount = this.items.length;
                }
                const result = this.data.uploadSuccess(this.data.uploadSuccessParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        }, {
            file: params.value
        });
        return of([]);
    }
    isObject(item) {
        return (typeof item === 'object');
    }
    deleteImage(item) {
        const alertDialog = this.dialog.open(AlertDialogComponent, {
            data: {
                title: this.language.getLabel('App_delete_confirm_title'),
                text: this.language.getLabel('App_delete_confirm_text'),
                button: this.language.getLabel('App_delete')
            }
        });
        alertDialog.afterClosed().pipe(take$1(1)).subscribe({
            next: (result) => {
                if (result === 'confirm') {
                    const params = {};
                    if (typeof item === 'string') {
                        params.url = encodeURI(item);
                    }
                    if (typeof item === 'object') {
                        params.id = [item.id];
                    }
                    this.callDataService(this.data.delete, (rs) => {
                        if (rs.result.status === 'success') {
                            this.items = this.items.filter((e) => {
                                return e !== item;
                            });
                            // execute deleteSuccess event handler if form is in action
                            if (typeof this.data.deleteSuccess === 'function') {
                                this.data.deleteSuccessParams = {
                                    event: 'deleteSuccess'
                                };
                                if (this.items) {
                                    this.data.deleteSuccessParams.dataObject = this.items;
                                    this.data.deleteSuccessParams.imageCount = this.items.length;
                                }
                                const eResult = this.data.deleteSuccess(this.data.deleteSuccessParams);
                                if (eResult instanceof Observable) {
                                    eResult.pipe(take$1(1)).subscribe();
                                }
                            }
                        }
                    }, params);
                }
            }
        });
    }
    entered(event) {
        if (this.data.draggable) {
            const dropList = event.container;
            const dragIndex = event.item.data;
            const dropIndex = dropList.data;
            const container = dropList.element.nativeElement;
            const element = container.querySelector('.cdk-drag-placeholder');
            container.removeChild(element);
            container.parentElement.insertBefore(element, container);
            moveItemInArray(this.items, dragIndex, dropIndex);
        }
    }
    dropped() {
        if (this.data.reorder) {
            const images = [];
            for (const image of this.items) {
                images.push({
                    id: image.id
                });
            }
            this.callDataService(this.data.reorder, (rs) => { }, { images });
        }
    }
}
GalleryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GalleryComponent, deps: [{ token: LanguageService }, { token: ApiService }, { token: i3$3.MatDialog }, { token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
GalleryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: GalleryComponent, selector: "app-gallery", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"row mx-0\">\r\n  <div *ngIf=\"this.data.upload\" [class]=\"data.uploadClass\">\r\n    <app-dropzone [data]=\"dropzoneConfig\"></app-dropzone>\r\n  </div>\r\n  <div [class]=\"data.contentClass\">\r\n    <div class=\"row pb-1\" cdkDropListGroup>\r\n      <div\r\n        cdkDropList\r\n        [cdkDropListData]=\"i\"\r\n        [class]=\"data.contentItemClass\"\r\n        *ngFor=\"let item of items; let i = index\"\r\n      >\r\n        <div class=\"dotted\" *ngIf=\"data.draggable\"></div>\r\n        <div\r\n          cdkDrag\r\n          [cdkDragData]=\"i\"\r\n          (cdkDragEntered)=\"entered($event)\"\r\n          (cdkDragDropped)=\"dropped()\"\r\n          [cdkDragDisabled]=\"!data.draggable\"\r\n        >\r\n          <div *cdkDragPlaceholder></div>\r\n          <mat-card [ngClass]=\"{ clickable: data.itemClick }\">\r\n            <ng-container *ngIf=\"!item.type || item.type === 'image'\">\r\n              <ng-container *ngIf=\"!isObject(item)\">\r\n                <img\r\n                  mat-card-image\r\n                  [src]=\"item\"\r\n                  (click)=\"data.itemClick ? data.itemClick(item) : ''\"\r\n                />\r\n              </ng-container>\r\n              <picture mat-card-image *ngIf=\"isObject(item)\">\r\n                <source srcset=\"{{item.url.webp}}\" type=\"image/webp\" />\r\n                <source\r\n                  *ngIf=\"\r\n                    item.url[imageDisplaySize + 'original'].endsWith('.jpg') ||\r\n                    item.url[imageDisplaySize + 'original'].endsWith('.jpeg')\r\n                  \"\r\n                  srcset=\"{{item.url[imageDisplaySize + 'original']}}\"\r\n                  type=\"image/jpeg\"\r\n                />\r\n                <source\r\n                  *ngIf=\"item.url[imageDisplaySize + 'original'].endsWith('.png')\"\r\n                  srcset=\"{{item.url[imageDisplaySize + 'original']}}\"\r\n                  type=\"image/png\"\r\n                />\r\n                <img\r\n                  [src]=\"item.url[imageDisplaySize + 'original']\"\r\n                  (click)=\"data.itemClick ? data.itemClick(item) : ''\"\r\n                />\r\n              </picture>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"item.type === 'video'\">\r\n              <app-video [data]=\"{\r\n                'src': {'filepath': item.url}, \r\n                'mimeType': 'video/mp4',\r\n                'autoplay': false,\r\n                'muted': false,\r\n                'controls': true\r\n              }\"></app-video>\r\n            </ng-container>\r\n            <div *ngIf=\"data.draggable\" class=\"drag-handle\" cdkDragHandle>\r\n              <mat-icon>open_with</mat-icon>\r\n            </div>\r\n            <mat-card-content *ngIf=\"data.content\" class=\"mt-auto\">\r\n              <app-slot\r\n                [items]=\"data.content\"\r\n                [componentValue]=\"item\"\r\n              ></app-slot>\r\n            </mat-card-content>\r\n            <mat-card-actions *ngIf=\"this.data.delete\" class=\"text-center\">\r\n              <button\r\n                mat-flat-button\r\n                color=\"primary\"\r\n                (click)=\"deleteImage(item)\"\r\n              >\r\n                {{ language.getLabel(\"App_delete\") }}\r\n              </button>\r\n            </mat-card-actions>\r\n          </mat-card>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".cdk-drop-list{min-height:180px}.cdk-drop-list .cdk-drag{height:100%}.cdk-drop-list .dotted{position:absolute;inset:16px 15px 0;border:3px dotted grey;border-radius:4px}.drag-handle{position:absolute;top:5px;right:5px;background:rgba(82,82,82,.45);color:#fff;cursor:move;border-radius:50%;z-index:1;padding:3px;height:30px;width:30px}.drag-handle .mat-icon{height:24px;width:24px;font-size:24px}.mat-card{box-shadow:0 2px 5px -1px #0003,0 1px 5px #00000024,0 1px 8px #0000001f;height:100%;display:flex;justify-content:space-between;flex-direction:column}.mat-card.clickable{cursor:pointer}.mat-card picture{border-radius:4px}.mat-card picture img{width:100%;border-radius:4px}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: DropzoneComponent, selector: "app-dropzone", inputs: ["data", "parentForm"] }, { kind: "component", type: VideoComponent, selector: "app-video", inputs: ["data"] }, { kind: "component", type: i9$1.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i9$1.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i9$1.MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { kind: "directive", type: i9$1.MatCardImage, selector: "[mat-card-image], [matCardImage]" }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i11$2.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i11$2.CdkDropListGroup, selector: "[cdkDropListGroup]", inputs: ["cdkDropListGroupDisabled"], exportAs: ["cdkDropListGroup"] }, { kind: "directive", type: i11$2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i11$2.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "directive", type: i11$2.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GalleryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-gallery', template: "<div class=\"row mx-0\">\r\n  <div *ngIf=\"this.data.upload\" [class]=\"data.uploadClass\">\r\n    <app-dropzone [data]=\"dropzoneConfig\"></app-dropzone>\r\n  </div>\r\n  <div [class]=\"data.contentClass\">\r\n    <div class=\"row pb-1\" cdkDropListGroup>\r\n      <div\r\n        cdkDropList\r\n        [cdkDropListData]=\"i\"\r\n        [class]=\"data.contentItemClass\"\r\n        *ngFor=\"let item of items; let i = index\"\r\n      >\r\n        <div class=\"dotted\" *ngIf=\"data.draggable\"></div>\r\n        <div\r\n          cdkDrag\r\n          [cdkDragData]=\"i\"\r\n          (cdkDragEntered)=\"entered($event)\"\r\n          (cdkDragDropped)=\"dropped()\"\r\n          [cdkDragDisabled]=\"!data.draggable\"\r\n        >\r\n          <div *cdkDragPlaceholder></div>\r\n          <mat-card [ngClass]=\"{ clickable: data.itemClick }\">\r\n            <ng-container *ngIf=\"!item.type || item.type === 'image'\">\r\n              <ng-container *ngIf=\"!isObject(item)\">\r\n                <img\r\n                  mat-card-image\r\n                  [src]=\"item\"\r\n                  (click)=\"data.itemClick ? data.itemClick(item) : ''\"\r\n                />\r\n              </ng-container>\r\n              <picture mat-card-image *ngIf=\"isObject(item)\">\r\n                <source srcset=\"{{item.url.webp}}\" type=\"image/webp\" />\r\n                <source\r\n                  *ngIf=\"\r\n                    item.url[imageDisplaySize + 'original'].endsWith('.jpg') ||\r\n                    item.url[imageDisplaySize + 'original'].endsWith('.jpeg')\r\n                  \"\r\n                  srcset=\"{{item.url[imageDisplaySize + 'original']}}\"\r\n                  type=\"image/jpeg\"\r\n                />\r\n                <source\r\n                  *ngIf=\"item.url[imageDisplaySize + 'original'].endsWith('.png')\"\r\n                  srcset=\"{{item.url[imageDisplaySize + 'original']}}\"\r\n                  type=\"image/png\"\r\n                />\r\n                <img\r\n                  [src]=\"item.url[imageDisplaySize + 'original']\"\r\n                  (click)=\"data.itemClick ? data.itemClick(item) : ''\"\r\n                />\r\n              </picture>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"item.type === 'video'\">\r\n              <app-video [data]=\"{\r\n                'src': {'filepath': item.url}, \r\n                'mimeType': 'video/mp4',\r\n                'autoplay': false,\r\n                'muted': false,\r\n                'controls': true\r\n              }\"></app-video>\r\n            </ng-container>\r\n            <div *ngIf=\"data.draggable\" class=\"drag-handle\" cdkDragHandle>\r\n              <mat-icon>open_with</mat-icon>\r\n            </div>\r\n            <mat-card-content *ngIf=\"data.content\" class=\"mt-auto\">\r\n              <app-slot\r\n                [items]=\"data.content\"\r\n                [componentValue]=\"item\"\r\n              ></app-slot>\r\n            </mat-card-content>\r\n            <mat-card-actions *ngIf=\"this.data.delete\" class=\"text-center\">\r\n              <button\r\n                mat-flat-button\r\n                color=\"primary\"\r\n                (click)=\"deleteImage(item)\"\r\n              >\r\n                {{ language.getLabel(\"App_delete\") }}\r\n              </button>\r\n            </mat-card-actions>\r\n          </mat-card>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".cdk-drop-list{min-height:180px}.cdk-drop-list .cdk-drag{height:100%}.cdk-drop-list .dotted{position:absolute;inset:16px 15px 0;border:3px dotted grey;border-radius:4px}.drag-handle{position:absolute;top:5px;right:5px;background:rgba(82,82,82,.45);color:#fff;cursor:move;border-radius:50%;z-index:1;padding:3px;height:30px;width:30px}.drag-handle .mat-icon{height:24px;width:24px;font-size:24px}.mat-card{box-shadow:0 2px 5px -1px #0003,0 1px 5px #00000024,0 1px 8px #0000001f;height:100%;display:flex;justify-content:space-between;flex-direction:column}.mat-card.clickable{cursor:pointer}.mat-card picture{border-radius:4px}.mat-card picture img{width:100%;border-radius:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: ApiService }, { type: i3$3.MatDialog }, { type: i1.ActivatedRoute }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class GalleryModule {
    constructor(routing) {
        routing.mapComponent('GalleryComponent', GalleryComponent);
    }
}
GalleryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GalleryModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
GalleryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GalleryModule, declarations: [GalleryComponent], imports: [CommonModule,
        SlotModule,
        PrimitiveModule,
        MatCardModule,
        MatButtonModule,
        DragDropModule,
        MatIconModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule] });
GalleryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GalleryModule, imports: [CommonModule,
        SlotModule,
        PrimitiveModule,
        MatCardModule,
        MatButtonModule,
        DragDropModule,
        MatIconModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GalleryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GalleryComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PrimitiveModule,
                        MatCardModule,
                        MatButtonModule,
                        DragDropModule,
                        MatIconModule,
                        FormsModule,
                        MatInputModule,
                        MatFormFieldModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var gallery_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   GalleryModule: GalleryModule
});

class BlankComponent {
    constructor(route, comm) {
        this.route = route;
        this.comm = comm;
    }
    ngOnInit() {
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.slots = data.slots;
        });
    }
    ngOnDestroy() {
        this.comm.resetChannels();
    }
}
BlankComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BlankComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
BlankComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BlankComponent, selector: "app-blank", ngImport: i0, template: "<app-slot [items]=\"slots.main\" [detectChanges]=\"true\"></app-slot>\r\n", styles: [""], dependencies: [{ kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BlankComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-blank', template: "<app-slot [items]=\"slots.main\" [detectChanges]=\"true\"></app-slot>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }]; } });

class BaseLayoutComponent {
    constructor(route, comm, meta, title, language, eventBus, getArrayPath, platformId) {
        this.route = route;
        this.comm = comm;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.eventBus = eventBus;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
        this.destroyed = new Subject();
        this.isBrowser = false;
        this.isBrowser = !isPlatformServer(this.platformId);
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.data = data;
            if (typeof data.channel !== 'undefined') {
                this.comm.getChannel(data.channel)
                    .pipe(takeUntil(this.destroyed))
                    .subscribe((message) => this.comm.processMessage(message, this));
            }
            else {
                // Trigger update meta when no dynamic data needed
                this.updateMeta();
            }
        });
        // Update meta data on page initial load after labels are loaded
        this.eventBus.on('labelsLoaded')
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.updateMeta());
    }
    updateMeta() {
        /** @deprecated use this.data.meta */
        if (typeof this.data.metaTitle !== 'undefined') {
            const title = this.language.getLabel(this.data.metaTitle);
            this.title.setTitle(title);
        }
        /** @deprecated use this.data.meta */
        if (typeof this.data.metaDescription !== 'undefined') {
            const description = this.language.getLabel(this.data.metaDescription);
            this.meta.updateTag({ name: 'description', content: description });
        }
        if (typeof this.data.meta !== 'undefined') {
            let meta;
            if (Array.isArray(this.data.meta)) {
                meta = JSON.parse(JSON.stringify(this.data.meta));
            }
            else {
                meta = [JSON.parse(JSON.stringify(this.data.meta))];
            }
            for (const tag of meta) {
                if (typeof tag.content === 'object' && tag.content !== null) {
                    if (typeof this.metaData === 'undefined')
                        return;
                    tag.content.data = this.metaData;
                    tag.content = this.language.getLabel(tag.content);
                }
                if (typeof tag.content === 'string') {
                    tag.content = this.language.getLabel(tag.content);
                }
                if (Array.isArray(tag.content)) {
                    tag.content = this.getArrayPath.get(this.metaData, tag.content);
                }
                if (tag.name === 'title') {
                    this.title.setTitle(tag.content);
                }
                else {
                    this.meta.updateTag(tag);
                }
            }
        }
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.comm.resetChannels();
    }
}
BaseLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaseLayoutComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: EventBusService }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
BaseLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BaseLayoutComponent, selector: "app-base-layout", inputs: { data: "data" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BaseLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-base-layout', template: '' }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: EventBusService }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class CenterScreenComponent extends BaseLayoutComponent {
    constructor(route, comm, eventBus, meta, title, language, state, getArrayPath, platformId) {
        super(route, comm, meta, title, language, eventBus, getArrayPath, platformId);
        this.route = route;
        this.comm = comm;
        this.eventBus = eventBus;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.state = state;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
        this.logo = true;
    }
    ngOnInit() {
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.slots = data.slots;
            if (typeof data.logo !== 'undefined') {
                this.logo = data.logo;
            }
            if (typeof data.class !== 'undefined') {
                this.class = data.class;
            }
            if (typeof data.wrapperClass !== 'undefined') {
                this.wrapperClass = data.wrapperClass;
            }
            if (typeof data.logoWrapperClass !== 'undefined') {
                this.logoWrapperClass = data.logoWrapperClass;
            }
        });
    }
    ngOnDestroy() {
        this.comm.resetChannels();
    }
}
CenterScreenComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenterScreenComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: EventBusService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: StateService }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
CenterScreenComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CenterScreenComponent, selector: "app-center-screen", usesInheritance: true, ngImport: i0, template: "<div\r\n  class=\"h-100 row justify-content-center no-gutters\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <div class=\"d-flex flex-column align-content-center\" [class]=\"class\">\r\n    <div class=\"wrapper my-auto text-center\" [class]=\"wrapperClass\">\r\n      <div [class]=\"logoWrapperClass\">\r\n        <a [routerLink]=\"['']\">\r\n          <img\r\n            *ngIf=\"logo\"\r\n            class=\"mainLogo p-3\"\r\n            src=\"assets/img/{{ state.get('dark_logo') }}\"\r\n          />\r\n        </a>\r\n      </div>\r\n      <app-slot\r\n        [items]=\"slots.main\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".wrapper{background-color:#fff;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.wrapper .mainLogo{max-width:60%}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenterScreenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-center-screen', template: "<div\r\n  class=\"h-100 row justify-content-center no-gutters\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <div class=\"d-flex flex-column align-content-center\" [class]=\"class\">\r\n    <div class=\"wrapper my-auto text-center\" [class]=\"wrapperClass\">\r\n      <div [class]=\"logoWrapperClass\">\r\n        <a [routerLink]=\"['']\">\r\n          <img\r\n            *ngIf=\"logo\"\r\n            class=\"mainLogo p-3\"\r\n            src=\"assets/img/{{ state.get('dark_logo') }}\"\r\n          />\r\n        </a>\r\n      </div>\r\n      <app-slot\r\n        [items]=\"slots.main\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".wrapper{background-color:#fff;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.wrapper .mainLogo{max-width:60%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: EventBusService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: StateService }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class StretchMenuComponent extends BaseLayoutComponent {
    constructor(route, comm, meta, title, language, eventBus, getArrayPath, platformId) {
        super(route, comm, meta, title, language, eventBus, getArrayPath, platformId);
        this.route = route;
        this.comm = comm;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.eventBus = eventBus;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
    }
    ngOnInit() {
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.contentClass = data.contentClass;
            this.slots = data.slots;
        });
    }
    ngOnDestroy() {
        this.comm.resetChannels();
    }
}
StretchMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StretchMenuComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: EventBusService }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
StretchMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: StretchMenuComponent, selector: "app-stretch-menu", usesInheritance: true, ngImport: i0, template: "<div\r\n  class=\"page\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <app-slot\r\n    *ngIf=\"slots.top\"\r\n    [items]=\"slots.top\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.left\"\r\n    [items]=\"slots.left\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.subtop\"\r\n    [items]=\"slots.subtop\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n    class=\"shadowed\"></app-slot>\r\n  <mat-sidenav-container>\r\n    <mat-sidenav-content>\r\n      <div class=\"content\" [class]=\"contentClass\">\r\n        <app-slot\r\n          [items]=\"slots.main\"\r\n          [componentValue]=\"data.dataObject\"\r\n          [detectChanges]=\"true\"></app-slot>\r\n      </div>\r\n    </mat-sidenav-content>\r\n  </mat-sidenav-container>\r\n  <app-slot\r\n    *ngIf=\"slots.bottom\"\r\n    [items]=\"slots.bottom\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n", styles: [".page{display:flex;flex-direction:column;position:absolute;inset:0}.page mat-sidenav-container{flex:1}.page .main-toolbar app-header{width:100%}.page .shadowed{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.page .content{padding-left:1.5rem;padding-right:1.5rem}@media only screen and (max-width: 576px){.page .content{padding-left:0;padding-right:0}}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i9$3.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }, { kind: "component", type: i9$3.MatSidenavContent, selector: "mat-sidenav-content" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StretchMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-stretch-menu', template: "<div\r\n  class=\"page\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <app-slot\r\n    *ngIf=\"slots.top\"\r\n    [items]=\"slots.top\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.left\"\r\n    [items]=\"slots.left\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.subtop\"\r\n    [items]=\"slots.subtop\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n    class=\"shadowed\"></app-slot>\r\n  <mat-sidenav-container>\r\n    <mat-sidenav-content>\r\n      <div class=\"content\" [class]=\"contentClass\">\r\n        <app-slot\r\n          [items]=\"slots.main\"\r\n          [componentValue]=\"data.dataObject\"\r\n          [detectChanges]=\"true\"></app-slot>\r\n      </div>\r\n    </mat-sidenav-content>\r\n  </mat-sidenav-container>\r\n  <app-slot\r\n    *ngIf=\"slots.bottom\"\r\n    [items]=\"slots.bottom\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n", styles: [".page{display:flex;flex-direction:column;position:absolute;inset:0}.page mat-sidenav-container{flex:1}.page .main-toolbar app-header{width:100%}.page .shadowed{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.page .content{padding-left:1.5rem;padding-right:1.5rem}@media only screen and (max-width: 576px){.page .content{padding-left:0;padding-right:0}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: EventBusService }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class StretchSidenavComponent extends BaseLayoutComponent {
    constructor(route, comm, meta, title, language, eventBus, media, changeDetectorRef, getArrayPath, platformId) {
        super(route, comm, meta, title, language, eventBus, getArrayPath, platformId);
        this.route = route;
        this.comm = comm;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.eventBus = eventBus;
        this.media = media;
        this.changeDetectorRef = changeDetectorRef;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
        this.destroyed$ = new Subject();
        this.opened = {
            left: false,
            right: false
        };
        this.eventBus.on('toggleSidenav')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((data) => {
            if (this.opened[data.side]) {
                this.opened[data.side] = false;
            }
            else {
                this.opened[data.side] = true;
            }
        });
    }
    ngOnInit() {
        this.mobileQuery = this.media.matchMedia('(max-width: 599px)');
        this.mobileQueryListener = () => this.changeDetectorRef.detectChanges();
        this.mobileQuery.addEventListener('change', this.mobileQueryListener);
        this.route.data.pipe(take(1)).subscribe(data => {
            this.contentClass = data.contentClass;
            this.slots = data.slots;
        });
    }
    ngOnDestroy() {
        this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
        this.comm.resetChannels();
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
StretchSidenavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StretchSidenavComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: EventBusService }, { token: i6$2.MediaMatcher }, { token: i0.ChangeDetectorRef }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
StretchSidenavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: StretchSidenavComponent, selector: "app-stretch-sidenav", usesInheritance: true, ngImport: i0, template: "<div class=\"page\" style=\"visibility: hidden\" [ngStyle]=\"{ 'visibility': !isBrowser ? 'hidden': 'visible' }\">\r\n  <app-slot\r\n    *ngIf=\"slots.top\"\r\n    [items]=\"slots.top\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.subtop\"\r\n    [items]=\"slots.subtop\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n    class=\"shadowed\"></app-slot>\r\n  <mat-sidenav-container>\r\n    <mat-sidenav\r\n      *ngIf=\"slots.left\"\r\n      #leftnav\r\n      [(opened)]=\"opened.left\"\r\n      [mode]=\"mobileQuery.matches ? 'over' : 'push'\"\r\n      fixedTopGap=\"56\">\r\n      <app-slot\r\n        [items]=\"slots.left\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </mat-sidenav>\r\n    <mat-sidenav\r\n      *ngIf=\"slots.right\"\r\n      #rightnav\r\n      [(opened)]=\"opened.right\"\r\n      mode=\"over\"\r\n      fixedTopGap=\"56\"\r\n      position=\"end\">\r\n      <app-slot\r\n        [items]=\"slots.right\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </mat-sidenav>\r\n    <mat-sidenav-content>\r\n      <div class=\"content\" [class]=\"contentClass\">\r\n        <app-slot\r\n          [items]=\"slots.main\"\r\n          [componentValue]=\"data.dataObject\"\r\n          [detectChanges]=\"true\"></app-slot>\r\n      </div>\r\n    </mat-sidenav-content>\r\n  </mat-sidenav-container>\r\n  <app-slot\r\n    *ngIf=\"slots.bottom\"\r\n    [items]=\"slots.bottom\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n", styles: [".page{display:flex;flex-direction:column;position:absolute;inset:0}.page mat-sidenav-container{flex:1}.page .main-toolbar app-header{width:100%}.page .shadowed{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.page .content{padding-left:1.5rem;padding-right:1.5rem}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i9$3.MatSidenav, selector: "mat-sidenav", inputs: ["fixedInViewport", "fixedTopGap", "fixedBottomGap"], exportAs: ["matSidenav"] }, { kind: "component", type: i9$3.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }, { kind: "component", type: i9$3.MatSidenavContent, selector: "mat-sidenav-content" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StretchSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-stretch-sidenav', template: "<div class=\"page\" style=\"visibility: hidden\" [ngStyle]=\"{ 'visibility': !isBrowser ? 'hidden': 'visible' }\">\r\n  <app-slot\r\n    *ngIf=\"slots.top\"\r\n    [items]=\"slots.top\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.subtop\"\r\n    [items]=\"slots.subtop\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n    class=\"shadowed\"></app-slot>\r\n  <mat-sidenav-container>\r\n    <mat-sidenav\r\n      *ngIf=\"slots.left\"\r\n      #leftnav\r\n      [(opened)]=\"opened.left\"\r\n      [mode]=\"mobileQuery.matches ? 'over' : 'push'\"\r\n      fixedTopGap=\"56\">\r\n      <app-slot\r\n        [items]=\"slots.left\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </mat-sidenav>\r\n    <mat-sidenav\r\n      *ngIf=\"slots.right\"\r\n      #rightnav\r\n      [(opened)]=\"opened.right\"\r\n      mode=\"over\"\r\n      fixedTopGap=\"56\"\r\n      position=\"end\">\r\n      <app-slot\r\n        [items]=\"slots.right\"\r\n        [componentValue]=\"data.dataObject\"\r\n        [detectChanges]=\"true\"></app-slot>\r\n    </mat-sidenav>\r\n    <mat-sidenav-content>\r\n      <div class=\"content\" [class]=\"contentClass\">\r\n        <app-slot\r\n          [items]=\"slots.main\"\r\n          [componentValue]=\"data.dataObject\"\r\n          [detectChanges]=\"true\"></app-slot>\r\n      </div>\r\n    </mat-sidenav-content>\r\n  </mat-sidenav-container>\r\n  <app-slot\r\n    *ngIf=\"slots.bottom\"\r\n    [items]=\"slots.bottom\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n", styles: [".page{display:flex;flex-direction:column;position:absolute;inset:0}.page mat-sidenav-container{flex:1}.page .main-toolbar app-header{width:100%}.page .shadowed{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.page .content{padding-left:1.5rem;padding-right:1.5rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: EventBusService }, { type: i6$2.MediaMatcher }, { type: i0.ChangeDetectorRef }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class TopnavComponent {
    constructor(state, router, eventBus, language, permissions, api) {
        this.state = state;
        this.router = router;
        this.eventBus = eventBus;
        this.language = language;
        this.permissions = permissions;
        this.api = api;
        this.user = this.api.getService('UserService');
    }
    logout() {
        this.user.logout()
            .pipe(take$1(1))
            .subscribe((data) => {
            this.permissions.checkSession();
            this.state.set('auth', 'false');
            this.router.navigate(['login']);
        }, (err) => {
            this.permissions.checkSession();
            this.state.set('auth', 'false');
            this.router.navigate(['login']);
        });
    }
    toggle(side) {
        this.eventBus.fire(new Event('toggleSidenav', { side }));
    }
}
TopnavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TopnavComponent, deps: [{ token: StateService }, { token: i1.Router }, { token: EventBusService }, { token: LanguageService }, { token: PermissionsService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Component });
TopnavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TopnavComponent, selector: "app-topnav", inputs: { data: "data" }, ngImport: i0, template: "<mat-toolbar color=\"primary\">\r\n  <button *ngIf=\"data.hasLeft\" mat-icon-button (click)=\"toggle('left')\">\r\n    <mat-icon>menu</mat-icon>\r\n  </button>\r\n  <div class=\"navbar-brand\">\r\n    <a class=\"navbar-item\" [routerLink]=\"['']\">\r\n      <img class=\"mainLogo\" src=\"assets/img/{{state.get('light_logo')}}\" />\r\n    </a>\r\n  </div>\r\n  <!-- This fills the remaining space of the current row -->\r\n  <span class=\"example-fill-remaining-space\"></span>\r\n  <mat-menu #appMenu=\"matMenu\">\r\n    <button mat-menu-item [routerLink]=\"'/users/profile'\">{{language.getLabel('Access_users_profile')}}</button>\r\n    <button mat-menu-item (click)=\"logout()\">{{language.getLabel('App_logout')}}</button>\r\n  </mat-menu>\r\n\r\n  <button mat-icon-button [matMenuTriggerFor]=\"appMenu\">\r\n    <mat-icon>more_vert</mat-icon>\r\n  </button>\r\n  <button *ngIf=\"data.hasRight\" mat-icon-button (click)=\"toggle('right')\">\r\n    <mat-icon>menu</mat-icon>\r\n  </button>\r\n</mat-toolbar>\r\n", styles: [".mainLogo{width:216px;margin-top:0}.mat-toolbar{height:auto}.example-fill-remaining-space{flex:1 1 auto}mat-toolbar h1{margin-left:8px}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i8$3.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i8$3.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i8$3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i11$3.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TopnavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-topnav', template: "<mat-toolbar color=\"primary\">\r\n  <button *ngIf=\"data.hasLeft\" mat-icon-button (click)=\"toggle('left')\">\r\n    <mat-icon>menu</mat-icon>\r\n  </button>\r\n  <div class=\"navbar-brand\">\r\n    <a class=\"navbar-item\" [routerLink]=\"['']\">\r\n      <img class=\"mainLogo\" src=\"assets/img/{{state.get('light_logo')}}\" />\r\n    </a>\r\n  </div>\r\n  <!-- This fills the remaining space of the current row -->\r\n  <span class=\"example-fill-remaining-space\"></span>\r\n  <mat-menu #appMenu=\"matMenu\">\r\n    <button mat-menu-item [routerLink]=\"'/users/profile'\">{{language.getLabel('Access_users_profile')}}</button>\r\n    <button mat-menu-item (click)=\"logout()\">{{language.getLabel('App_logout')}}</button>\r\n  </mat-menu>\r\n\r\n  <button mat-icon-button [matMenuTriggerFor]=\"appMenu\">\r\n    <mat-icon>more_vert</mat-icon>\r\n  </button>\r\n  <button *ngIf=\"data.hasRight\" mat-icon-button (click)=\"toggle('right')\">\r\n    <mat-icon>menu</mat-icon>\r\n  </button>\r\n</mat-toolbar>\r\n", styles: [".mainLogo{width:216px;margin-top:0}.mat-toolbar{height:auto}.example-fill-remaining-space{flex:1 1 auto}mat-toolbar h1{margin-left:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: StateService }, { type: i1.Router }, { type: EventBusService }, { type: LanguageService }, { type: PermissionsService }, { type: ApiService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class TopnavModule {
    constructor(routing) {
        routing.mapComponent('TopnavComponent', TopnavComponent);
    }
}
TopnavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TopnavModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
TopnavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TopnavModule, declarations: [TopnavComponent], imports: [CommonModule, i1.RouterModule, MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        CustomRouterLinkDirective] });
TopnavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TopnavModule, imports: [CommonModule,
        RouterModule.forChild([]),
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TopnavModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TopnavComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        MatMenuModule,
                        MatButtonModule,
                        MatIconModule,
                        MatToolbarModule,
                        CustomRouterLinkDirective
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var topnav_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   TopnavModule: TopnavModule
});

class SidenavComponent {
    constructor() { }
}
SidenavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidenavComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SidenavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SidenavComponent, selector: "app-sidenav", inputs: { data: "data" }, ngImport: i0, template: "<mat-nav-list>\r\n  <a *ngFor=\"let item of data.items\" mat-list-item [routerLink]=\"item.link\">{{\r\n    item.name\r\n  }}</a>\r\n</mat-nav-list>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i3$4.MatNavList, selector: "mat-nav-list", inputs: ["disableRipple", "disabled"], exportAs: ["matNavList"] }, { kind: "component", type: i3$4.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-sidenav', template: "<mat-nav-list>\r\n  <a *ngFor=\"let item of data.items\" mat-list-item [routerLink]=\"item.link\">{{\r\n    item.name\r\n  }}</a>\r\n</mat-nav-list>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class SidenavModule {
    constructor(routing) {
        routing.mapComponent('SidenavComponent', SidenavComponent);
    }
}
SidenavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidenavModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
SidenavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SidenavModule, declarations: [SidenavComponent], imports: [CommonModule, i1.RouterModule, MatListModule,
        MatSidenavModule,
        CustomRouterLinkDirective] });
SidenavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidenavModule, imports: [CommonModule,
        RouterModule.forChild([]),
        MatListModule,
        MatSidenavModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidenavModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SidenavComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        MatListModule,
                        MatSidenavModule,
                        CustomRouterLinkDirective
                    ],
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var sidenav_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   SidenavModule: SidenavModule
});

class CenteredHeaderMainFooterComponent extends BaseLayoutComponent {
    constructor(route, comm, meta, title, language, eventBus, getArrayPath, platformId) {
        super(route, comm, meta, title, language, eventBus, getArrayPath, platformId);
        this.route = route;
        this.comm = comm;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.eventBus = eventBus;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
    }
    ngOnInit() {
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.slots = data.slots;
            this.classes = data.classes;
            if (typeof data.class !== 'undefined') {
                this.class = data.class;
            }
        });
    }
}
CenteredHeaderMainFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenteredHeaderMainFooterComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: EventBusService }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
CenteredHeaderMainFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CenteredHeaderMainFooterComponent, selector: "app-centered-header-main-footer", usesInheritance: true, ngImport: i0, template: "<div\r\n  class=\"page\"\r\n  [class]=\"class\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <app-slot\r\n    *ngIf=\"slots.header\"\r\n    [class]=\"classes?.header\"\r\n    [items]=\"slots.header\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.menu\"\r\n    [class]=\"classes?.menu\"\r\n    [items]=\"slots.menu\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.main\"\r\n    [class]=\"classes?.main\"\r\n    [items]=\"slots.main\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.footer\"\r\n    [class]=\"classes?.footer\"\r\n    [items]=\"slots.footer\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenteredHeaderMainFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-centered-header-main-footer', template: "<div\r\n  class=\"page\"\r\n  [class]=\"class\"\r\n  style=\"visibility: hidden\"\r\n  [ngStyle]=\"{ visibility: !isBrowser ? 'hidden' : 'visible' }\"\r\n>\r\n  <app-slot\r\n    *ngIf=\"slots.header\"\r\n    [class]=\"classes?.header\"\r\n    [items]=\"slots.header\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.menu\"\r\n    [class]=\"classes?.menu\"\r\n    [items]=\"slots.menu\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.main\"\r\n    [class]=\"classes?.main\"\r\n    [items]=\"slots.main\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n  <app-slot\r\n    *ngIf=\"slots.footer\"\r\n    [class]=\"classes?.footer\"\r\n    [items]=\"slots.footer\"\r\n    [componentValue]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"></app-slot>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: EventBusService }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class CenterHeaderMainFooterSidenavComponent extends BaseLayoutComponent {
    constructor(route, comm, eventBus, meta, title, language, getArrayPath, platformId) {
        super(route, comm, meta, title, language, eventBus, getArrayPath, platformId);
        this.route = route;
        this.comm = comm;
        this.eventBus = eventBus;
        this.meta = meta;
        this.title = title;
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.platformId = platformId;
        this.autosize = true;
        this.mode = {
            start: 'side',
            end: 'side'
        };
        this.eagerLoad = {
            start: false,
            end: false
        };
        this.channels = {
            start: new Set(),
            end: new Set()
        };
        this.styleTag = this.buildStyleElement();
    }
    ngOnInit() {
        this.route.data.pipe(take$1(1)).subscribe(data => {
            this.slots = data.slots;
            if (typeof data.autosize !== 'undefined') {
                this.autosize = data.autosize;
            }
            if (typeof data.mode?.start !== 'undefined') {
                this.mode.start = data.mode.start;
            }
            if (typeof data.mode?.end !== 'undefined') {
                this.mode.end = data.mode.end;
            }
            if (typeof data.eagerLoad?.start !== 'undefined') {
                this.eagerLoad.start = data.eagerLoad.start;
            }
            if (typeof data.eagerLoad?.end !== 'undefined') {
                this.eagerLoad.end = data.eagerLoad.end;
            }
        });
    }
    sidenav(params) {
        if (typeof this.slots[params.side] !== 'undefined'
            && !this[params.side].opened) {
            this.channelListener = this.eventBus.on('newChannelRegistered')
                .pipe(takeUntil(this.destroyed))
                .subscribe((channelUid) => {
                this.channels[params.side].add(channelUid);
            });
        }
        this[params.side][params.method]();
    }
    opened(side, event) {
        if (this.mode[side] === 'over') {
            document.body.appendChild(this.styleTag);
        }
    }
    closed(side, event) {
        if (this.mode[side] === 'over') {
            document.body.removeChild(this.styleTag);
        }
        this.channelListener.unsubscribe();
        this.comm.resetChannels(this.channels[side]);
    }
    buildStyleElement() {
        const style = document.createElement('style');
        style.textContent = `
			body {
				overflow: hidden !important;
			}
		`;
        return (style);
    }
}
CenterHeaderMainFooterSidenavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenterHeaderMainFooterSidenavComponent, deps: [{ token: i1.ActivatedRoute }, { token: CommunicationService }, { token: EventBusService }, { token: i3$1.Meta }, { token: i3$1.Title }, { token: LanguageService }, { token: GetArrayPathService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
CenterHeaderMainFooterSidenavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CenterHeaderMainFooterSidenavComponent, selector: "app-center-header-main-footer-sidenav", viewQueries: [{ propertyName: "start", first: true, predicate: ["start"], descendants: true }, { propertyName: "end", first: true, predicate: ["end"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-drawer-container\r\n  [autosize]=\"autosize\"\r\n  [class]=\"data.drawerClass\"\r\n  style=\"visibility: hidden\" \r\n  [ngStyle]=\"{ 'visibility': !isBrowser ? 'hidden': 'visible' }\"\r\n  >\r\n  <mat-drawer\r\n    #start\r\n    *ngIf=\"slots.start\"\r\n    [mode]=\"mode.start\"\r\n    (opened)=\"opened('start', $event)\"\r\n    (closed)=\"closed('start', $event)\">\r\n    <app-slot\r\n      *ngIf=\"start.opened || eagerLoad.start\"\r\n      [items]=\"slots.start\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </mat-drawer>\r\n  <mat-drawer\r\n    #end\r\n    *ngIf=\"slots.end\"\r\n    [mode]=\"mode.end\"\r\n    position=\"end\"\r\n    (opened)=\"opened('end', $event)\"\r\n    (closed)=\"closed('end', $event)\">\r\n    <app-slot\r\n      *ngIf=\"end.opened || eagerLoad.end\"\r\n      [items]=\"slots.end\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </mat-drawer>\r\n  <div class=\"page\">\r\n    <app-slot\r\n      *ngIf=\"slots.header\"\r\n      [items]=\"slots.header\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.menu\"\r\n      [items]=\"slots.menu\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.main\"\r\n      [items]=\"slots.main\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"\r\n      class=\"main\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.footer\"\r\n      [items]=\"slots.footer\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </div>\r\n</mat-drawer-container>\r\n", styles: [".mat-drawer-container{height:100%}.mat-drawer-container .page{display:flex;flex-direction:column;position:absolute;inset:0}.mat-drawer-container .page .main{flex:1}.mat-drawer-container .mat-drawer{max-width:25%}.mat-drawer-container .mat-drawer.mat-drawer-over{background-color:transparent;box-shadow:none;bottom:auto;max-height:100%;position:fixed}@media only screen and (max-width: 991px){.mat-drawer{max-width:33%}}@media only screen and (max-width: 767px){.mat-drawer{max-width:50%}}@media only screen and (max-width: 577px){.mat-drawer{max-width:100%}}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i9$3.MatDrawer, selector: "mat-drawer", inputs: ["position", "mode", "disableClose", "autoFocus", "opened"], outputs: ["openedChange", "opened", "openedStart", "closed", "closedStart", "positionChanged"], exportAs: ["matDrawer"] }, { kind: "component", type: i9$3.MatDrawerContainer, selector: "mat-drawer-container", inputs: ["autosize", "hasBackdrop"], outputs: ["backdropClick"], exportAs: ["matDrawerContainer"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CenterHeaderMainFooterSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-center-header-main-footer-sidenav', template: "<mat-drawer-container\r\n  [autosize]=\"autosize\"\r\n  [class]=\"data.drawerClass\"\r\n  style=\"visibility: hidden\" \r\n  [ngStyle]=\"{ 'visibility': !isBrowser ? 'hidden': 'visible' }\"\r\n  >\r\n  <mat-drawer\r\n    #start\r\n    *ngIf=\"slots.start\"\r\n    [mode]=\"mode.start\"\r\n    (opened)=\"opened('start', $event)\"\r\n    (closed)=\"closed('start', $event)\">\r\n    <app-slot\r\n      *ngIf=\"start.opened || eagerLoad.start\"\r\n      [items]=\"slots.start\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </mat-drawer>\r\n  <mat-drawer\r\n    #end\r\n    *ngIf=\"slots.end\"\r\n    [mode]=\"mode.end\"\r\n    position=\"end\"\r\n    (opened)=\"opened('end', $event)\"\r\n    (closed)=\"closed('end', $event)\">\r\n    <app-slot\r\n      *ngIf=\"end.opened || eagerLoad.end\"\r\n      [items]=\"slots.end\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </mat-drawer>\r\n  <div class=\"page\">\r\n    <app-slot\r\n      *ngIf=\"slots.header\"\r\n      [items]=\"slots.header\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.menu\"\r\n      [items]=\"slots.menu\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.main\"\r\n      [items]=\"slots.main\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"\r\n      class=\"main\"></app-slot>\r\n    <app-slot\r\n      *ngIf=\"slots.footer\"\r\n      [items]=\"slots.footer\"\r\n      [componentValue]=\"data.dataObject\"\r\n      [detectChanges]=\"true\"></app-slot>\r\n  </div>\r\n</mat-drawer-container>\r\n", styles: [".mat-drawer-container{height:100%}.mat-drawer-container .page{display:flex;flex-direction:column;position:absolute;inset:0}.mat-drawer-container .page .main{flex:1}.mat-drawer-container .mat-drawer{max-width:25%}.mat-drawer-container .mat-drawer.mat-drawer-over{background-color:transparent;box-shadow:none;bottom:auto;max-height:100%;position:fixed}@media only screen and (max-width: 991px){.mat-drawer{max-width:33%}}@media only screen and (max-width: 767px){.mat-drawer{max-width:50%}}@media only screen and (max-width: 577px){.mat-drawer{max-width:100%}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: CommunicationService }, { type: EventBusService }, { type: i3$1.Meta }, { type: i3$1.Title }, { type: LanguageService }, { type: GetArrayPathService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { start: [{
                type: ViewChild,
                args: ['start']
            }], end: [{
                type: ViewChild,
                args: ['end']
            }] } });

class LayoutsModule {
    constructor(routing) {
        routing.mapComponent('BlankComponent', BlankComponent);
        routing.mapComponent('CenterScreenComponent', CenterScreenComponent);
        routing.mapComponent('StretchMenuComponent', StretchMenuComponent);
        routing.mapComponent('StretchSidenavComponent', StretchSidenavComponent);
        routing.mapComponent('CenteredHeaderMainFooterComponent', CenteredHeaderMainFooterComponent);
        routing.mapComponent('CenterHeaderMainFooterSidenavComponent', CenterHeaderMainFooterSidenavComponent);
    }
}
LayoutsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LayoutsModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
LayoutsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: LayoutsModule, declarations: [BlankComponent,
        CenterScreenComponent,
        StretchMenuComponent,
        StretchSidenavComponent,
        CenteredHeaderMainFooterComponent,
        CenterHeaderMainFooterSidenavComponent], imports: [CommonModule,
        SlotModule,
        // AppRoutingModule,
        MatIconModule,
        MatSidenavModule,
        TopnavModule,
        SidenavModule,
        RouterModule,
        CustomRouterLinkDirective], exports: [BlankComponent,
        CenterScreenComponent,
        StretchMenuComponent,
        StretchSidenavComponent,
        CenteredHeaderMainFooterComponent,
        CenterHeaderMainFooterSidenavComponent] });
LayoutsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LayoutsModule, imports: [CommonModule,
        SlotModule,
        // AppRoutingModule,
        MatIconModule,
        MatSidenavModule,
        TopnavModule,
        SidenavModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LayoutsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BlankComponent,
                        CenterScreenComponent,
                        StretchMenuComponent,
                        StretchSidenavComponent,
                        CenteredHeaderMainFooterComponent,
                        CenterHeaderMainFooterSidenavComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule,
                        // AppRoutingModule,
                        MatIconModule,
                        MatSidenavModule,
                        TopnavModule,
                        SidenavModule,
                        RouterModule,
                        CustomRouterLinkDirective
                    ],
                    exports: [
                        BlankComponent,
                        CenterScreenComponent,
                        StretchMenuComponent,
                        StretchSidenavComponent,
                        CenteredHeaderMainFooterComponent,
                        CenterHeaderMainFooterSidenavComponent
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

class CardListComponent {
    constructor(api, query, router, route, breakpointObserver, comm, evaluator, getArrayPath, getArrayPathPipe, scroll, paginatorIntl, language) {
        this.api = api;
        this.query = query;
        this.router = router;
        this.route = route;
        this.breakpointObserver = breakpointObserver;
        this.comm = comm;
        this.evaluator = evaluator;
        this.getArrayPath = getArrayPath;
        this.getArrayPathPipe = getArrayPathPipe;
        this.scroll = scroll;
        this.paginatorIntl = paginatorIntl;
        this.language = language;
        this.items = [];
        this.page = {
            size: 0,
            length: 0
        };
        this.loading = false;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.breakpointObserver.observe([
            '(min-width: 992px)'
        ])
            .pipe(takeUntil(this.destroyed)).subscribe((size) => {
            if (size.matches) {
                if (typeof this.data.listCondition !== 'undefined') {
                    const result = this.getArrayPath.get(null, this.data.listCondition.path);
                    if (result instanceof Observable) {
                        const that = this;
                        result.pipe(takeUntil(this.destroyed), map(data => {
                            return this.evaluator.exec(data, this.data.listCondition.condition);
                        }), filter((data) => data), tap(() => {
                            that.data.display = 'list';
                        })).subscribe(() => { });
                    }
                    else if (this.evaluator.exec(null, this.data.listCondition)) {
                        this.data.display = 'list';
                    }
                }
            }
            else if (typeof this.data.display === 'undefined') {
                this.data.display = 'grid';
            }
        });
        if (typeof this.data.dataSource !== 'undefined') {
            if (this.data.reloadsWithUrl) {
                // Refresh data if query params or url param has been changed
                combineLatest([
                    this.route.queryParams.pipe(startWith(null)),
                    this.route.params.pipe(startWith(null))
                ]).pipe(takeUntil(this.destroyed), debounceTime(0))
                    .subscribe((params) => {
                    const urlParams = JSON.parse(JSON.stringify(params));
                    this.query.updateQueryUrl(this.route.snapshot);
                    if (typeof this.paginator !== 'undefined'
                        && (typeof urlParams[0].page === 'undefined' || !urlParams[0].page)) {
                        urlParams[0].page = '1';
                        this.paginator.firstPage();
                    }
                    if (this.urlParams
                        && JSON.stringify(this.urlParams) !== JSON.stringify(urlParams)) {
                        this.load();
                        this.changeDisplay();
                    }
                    this.urlParams = urlParams;
                });
            }
            this.load();
        }
        // execute init event handler if such exists
        if (typeof this.data.init === 'function') {
            if (!this.data.initParams) {
                this.data.initParams = {};
            }
            this.data.initParams.event = 'init';
            if (this.data.dataObject) {
                this.data.initParams.dataObject = this.data.dataObject;
            }
            const result = this.data.init(this.data.initParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    changeDisplay() {
        this.breakpointObserver.observe([
            '(min-width: 992px)'
        ])
            .pipe(take$1(1)).subscribe((size) => {
            if (size.matches) {
                if (typeof this.data.listCondition !== 'undefined') {
                    const result = this.getArrayPath.get(null, this.data.listCondition.path);
                    if (result instanceof Observable) {
                        const that = this;
                        result.pipe(takeUntil(this.destroyed), map(data => {
                            return this.evaluator.exec(data, this.data.listCondition.condition);
                        }), filter((data) => data), tap(() => {
                            that.data.display = 'list';
                        })).subscribe(() => { });
                    }
                    else if (this.evaluator.exec(null, this.data.listCondition)) {
                        this.data.display = 'list';
                    }
                }
            }
            else if (typeof this.data.display === 'undefined') {
                this.data.display = 'grid';
            }
        });
    }
    load(params) {
        this.loading = true;
        let dataSource = this.data.dataSource;
        if (typeof params !== 'undefined') {
            dataSource = JSON.parse(JSON.stringify(this.data.dataSource));
            dataSource.params = params;
        }
        this.api.callServiceMethod(dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            if (this.data.itemsPerPageLabel) {
                this.paginatorIntl.itemsPerPageLabel = this.language.getLabel(this.data.itemsPerPageLabel);
            }
            if (typeof this.data.dataSource.path !== 'undefined') {
                this.items = this.getArrayPathPipe.transform(response.result.data, this.data.dataSource.path);
            }
            else {
                this.items = response.result.data;
            }
            if (response.result.meta) {
                this.page.length = response.result.meta.total;
                this.page.size = response.result.meta.per_page;
            }
            if (this.data.scrollToElement) {
                this.scroll.scrollToElement(this.data.scrollToElement);
            }
            this.loading = false;
            if (typeof this.data.loaded === 'function') {
                this.data.dataObject = response.result.data;
                this.data.loadedParams = {};
                this.data.loadedParams.event = 'loaded';
                if (this.data.dataObject) {
                    this.data.loadedParams.dataObject = this.data.dataObject;
                }
                const result = this.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
    }
    handlePaginator(e) {
        const page = e.pageIndex + 1;
        this.router.navigate([], { queryParams: { page }, queryParamsHandling: 'merge' })
            .then(() => {
            this.query.updateQueryUrl(this.route.snapshot);
        });
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.breakpointObserver.ngOnDestroy();
    }
}
CardListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardListComponent, deps: [{ token: ApiService }, { token: QueryService }, { token: i1.Router }, { token: i1.ActivatedRoute }, { token: i6$2.BreakpointObserver }, { token: CommunicationService }, { token: EvalService }, { token: GetArrayPathService }, { token: GetArrayPathPipe }, { token: ScrollService }, { token: i10$3.MatPaginatorIntl }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
CardListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CardListComponent, selector: "app-card-list", inputs: { data: "data" }, providers: [GetArrayPathPipe], viewQueries: [{ propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }], ngImport: i0, template: "<div *ngIf=\"data.showLoading && loading\" class=\"loading\">\r\n  <app-loader [data]=\"{\r\n    diameter: 50\r\n  }\"></app-loader>\r\n</div>\r\n<!-- grid -->\r\n<div [id]=\"data.id ? data.id : ''\" *ngIf=\"data.display === 'grid'\" class=\"row\" [class]=\"data.gridRowClass\">\r\n  <div\r\n    *ngFor=\"let item of items\"\r\n    [class]=\"data.gridColClass\"\r\n    [routerLink]=\"item | link: data.link\"\r\n  >\r\n    <mat-card>\r\n      <app-slot\r\n        *ngIf=\"data.image\"\r\n        [items]=\"[data.image.component]\"\r\n        [componentValue]=\"item | getArrayPath: data.image.path\"\r\n      ></app-slot>\r\n      <mat-card-content *ngIf=\"data.content\">\r\n        <app-slot\r\n          [items]=\"[data.content.component]\"\r\n          [componentValue]=\"item | getArrayPath: data.content.path\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-content>\r\n      <mat-card-actions *ngIf=\"data.actions\">\r\n        <app-slot\r\n          [items]=\"data.actions.components\"\r\n          [componentValue]=\"item | getArrayPath: data.actions.path\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-actions>\r\n    </mat-card>\r\n  </div>\r\n  <div \r\n    *ngIf=\"data.components\"\r\n    [class]=\"data.gridColClass\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n    ></app-slot>\r\n  </div>\r\n</div>\r\n\r\n<!-- list -->\r\n<ng-container *ngIf=\"data.display === 'list'\">\r\n  <div [id]=\"data.id ? data.id : ''\" class=\"row\" *ngFor=\"let item of items\" [class]=\"data.listRowClass\">\r\n    <div [class]=\"data.listColClass\" [routerLink]=\"item | link: data.link\">\r\n      <mat-card>\r\n        <mat-card-title-group class=\"row no-gutters\">\r\n          <app-slot\r\n            *ngIf=\"data.image\"\r\n            [items]=\"[data.image.component]\"\r\n            [componentValue]=\"item | getArrayPath: data.image.path\"\r\n            class=\"col\"\r\n          ></app-slot>\r\n          <mat-card-content *ngIf=\"data.content\" class=\"col pl-2 list-content\">\r\n            <app-slot\r\n              [items]=\"[data.content.component]\"\r\n              [componentValue]=\"item | getArrayPath: data.content.path\"\r\n              style=\"display: block; width: 100%; height: 100%\"\r\n            ></app-slot>\r\n          </mat-card-content>\r\n        </mat-card-title-group>\r\n        <mat-card-actions *ngIf=\"data.actions\">\r\n          <app-slot\r\n            [items]=\"data.actions.components\"\r\n            [componentValue]=\"item | getArrayPath: data.actions.path\"\r\n            style=\"display: block; width: 100%; height: 100%\"\r\n          ></app-slot>\r\n        </mat-card-actions>\r\n      </mat-card>\r\n    </div>\r\n  </div>\r\n  <div \r\n    *ngIf=\"data.components\"\r\n    [class]=\"data.listColClass\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n    ></app-slot>\r\n  </div>\r\n</ng-container>\r\n\r\n<mat-paginator\r\n  *ngIf=\"page.size\"\r\n  showFirstLastButtons\r\n  [length]=\"page.length\"\r\n  [pageSize]=\"page.size\"\r\n  (page)=\"handlePaginator($event)\"\r\n>\r\n</mat-paginator>\r\n", styles: [".loading{position:absolute;inset:0;background-color:#ffffff4d;z-index:5000;display:flex;justify-content:center;padding-top:5%}.mat-card{box-shadow:0 2px 5px -1px #0003,0 1px 5px #00000024,0 1px 8px #0000001f;height:100%;display:flex;justify-content:space-between;flex-direction:column}.list-content{margin-bottom:0}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i9$1.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "component", type: i9$1.MatCardTitleGroup, selector: "mat-card-title-group" }, { kind: "directive", type: i9$1.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i9$1.MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { kind: "component", type: i10$3.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: LoaderComponent, selector: "app-loader", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: LinkPipe, name: "link" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-card-list', providers: [GetArrayPathPipe], template: "<div *ngIf=\"data.showLoading && loading\" class=\"loading\">\r\n  <app-loader [data]=\"{\r\n    diameter: 50\r\n  }\"></app-loader>\r\n</div>\r\n<!-- grid -->\r\n<div [id]=\"data.id ? data.id : ''\" *ngIf=\"data.display === 'grid'\" class=\"row\" [class]=\"data.gridRowClass\">\r\n  <div\r\n    *ngFor=\"let item of items\"\r\n    [class]=\"data.gridColClass\"\r\n    [routerLink]=\"item | link: data.link\"\r\n  >\r\n    <mat-card>\r\n      <app-slot\r\n        *ngIf=\"data.image\"\r\n        [items]=\"[data.image.component]\"\r\n        [componentValue]=\"item | getArrayPath: data.image.path\"\r\n      ></app-slot>\r\n      <mat-card-content *ngIf=\"data.content\">\r\n        <app-slot\r\n          [items]=\"[data.content.component]\"\r\n          [componentValue]=\"item | getArrayPath: data.content.path\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-content>\r\n      <mat-card-actions *ngIf=\"data.actions\">\r\n        <app-slot\r\n          [items]=\"data.actions.components\"\r\n          [componentValue]=\"item | getArrayPath: data.actions.path\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </mat-card-actions>\r\n    </mat-card>\r\n  </div>\r\n  <div \r\n    *ngIf=\"data.components\"\r\n    [class]=\"data.gridColClass\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n    ></app-slot>\r\n  </div>\r\n</div>\r\n\r\n<!-- list -->\r\n<ng-container *ngIf=\"data.display === 'list'\">\r\n  <div [id]=\"data.id ? data.id : ''\" class=\"row\" *ngFor=\"let item of items\" [class]=\"data.listRowClass\">\r\n    <div [class]=\"data.listColClass\" [routerLink]=\"item | link: data.link\">\r\n      <mat-card>\r\n        <mat-card-title-group class=\"row no-gutters\">\r\n          <app-slot\r\n            *ngIf=\"data.image\"\r\n            [items]=\"[data.image.component]\"\r\n            [componentValue]=\"item | getArrayPath: data.image.path\"\r\n            class=\"col\"\r\n          ></app-slot>\r\n          <mat-card-content *ngIf=\"data.content\" class=\"col pl-2 list-content\">\r\n            <app-slot\r\n              [items]=\"[data.content.component]\"\r\n              [componentValue]=\"item | getArrayPath: data.content.path\"\r\n              style=\"display: block; width: 100%; height: 100%\"\r\n            ></app-slot>\r\n          </mat-card-content>\r\n        </mat-card-title-group>\r\n        <mat-card-actions *ngIf=\"data.actions\">\r\n          <app-slot\r\n            [items]=\"data.actions.components\"\r\n            [componentValue]=\"item | getArrayPath: data.actions.path\"\r\n            style=\"display: block; width: 100%; height: 100%\"\r\n          ></app-slot>\r\n        </mat-card-actions>\r\n      </mat-card>\r\n    </div>\r\n  </div>\r\n  <div \r\n    *ngIf=\"data.components\"\r\n    [class]=\"data.listColClass\"\r\n  >\r\n    <app-slot\r\n      *ngIf=\"data.components\"\r\n      [items]=\"data.components\"\r\n    ></app-slot>\r\n  </div>\r\n</ng-container>\r\n\r\n<mat-paginator\r\n  *ngIf=\"page.size\"\r\n  showFirstLastButtons\r\n  [length]=\"page.length\"\r\n  [pageSize]=\"page.size\"\r\n  (page)=\"handlePaginator($event)\"\r\n>\r\n</mat-paginator>\r\n", styles: [".loading{position:absolute;inset:0;background-color:#ffffff4d;z-index:5000;display:flex;justify-content:center;padding-top:5%}.mat-card{box-shadow:0 2px 5px -1px #0003,0 1px 5px #00000024,0 1px 8px #0000001f;height:100%;display:flex;justify-content:space-between;flex-direction:column}.list-content{margin-bottom:0}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: QueryService }, { type: i1.Router }, { type: i1.ActivatedRoute }, { type: i6$2.BreakpointObserver }, { type: CommunicationService }, { type: EvalService }, { type: GetArrayPathService }, { type: GetArrayPathPipe }, { type: ScrollService }, { type: i10$3.MatPaginatorIntl }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }] } });

class CardListModule {
    constructor(routing) {
        routing.mapComponent('CardListComponent', CardListComponent);
    }
}
CardListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardListModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
CardListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: CardListModule, declarations: [CardListComponent], imports: [CommonModule, i1.RouterModule, SlotModule,
        MatCardModule,
        MatDividerModule,
        MatPaginatorModule,
        PipesModule,
        PrimitiveModule,
        CustomRouterLinkDirective,
        LoaderModule] });
CardListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardListModule, imports: [CommonModule,
        RouterModule.forChild([]),
        SlotModule,
        MatCardModule,
        MatDividerModule,
        MatPaginatorModule,
        PipesModule,
        PrimitiveModule,
        LoaderModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CardListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CardListComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        SlotModule,
                        MatCardModule,
                        MatDividerModule,
                        MatPaginatorModule,
                        PipesModule,
                        PrimitiveModule,
                        CustomRouterLinkDirective,
                        LoaderModule,
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var cardList_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   CardListModule: CardListModule
});

class GridListComponent extends BaseComponent {
    constructor(route, getArrayPath, getArrayPathService, transformData, evaluator, state, helper, session) {
        super();
        this.route = route;
        this.getArrayPath = getArrayPath;
        this.getArrayPathService = getArrayPathService;
        this.transformData = transformData;
        this.evaluator = evaluator;
        this.state = state;
        this.helper = helper;
        this.session = session;
        this.grid = { rows: [] };
        this.hiddenElements = {};
        this.pauseInterval = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.bindScrollTop();
        this.selfRef = this;
        if (this.data.reloadsWithUrl) {
            // Trigger load if query params or url param has been changed
            combineLatest([
                this.route.queryParams.pipe(startWith(null)),
                this.route.params.pipe(startWith(null))
            ]).pipe(takeUntil(this.destroyed), debounceTime(0)).subscribe((urlParams) => {
                if (this.urlParams && this.urlParams !== urlParams) {
                    this.load();
                }
                this.urlParams = urlParams;
            });
        }
        if (typeof this.data.loadOnInit === 'undefined' || this.data.loadOnInit) {
            this.load();
        }
        else {
            this.buildGrid();
        }
        // execute init event handler if form is in action
        if (typeof this.data.init === 'function') {
            this.data.initParams = {
                event: 'init'
            };
            if (this.data.dataObject) {
                this.data.initParams.dataObject = this.data.dataObject;
            }
            const result = this.data.init(this.data.initParams);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    load(overrideDataSource) {
        if (typeof this.data.dataSource !== 'undefined') {
            let dataSource = JSON.parse(JSON.stringify(this.data.dataSource));
            if (typeof overrideDataSource !== 'undefined') {
                dataSource = this.helper.mergeDeep(dataSource, overrideDataSource);
            }
            let trigger;
            if (typeof dataSource.interval === 'number'
                && !isPlatformServer(this.platformId)) {
                if (typeof dataSource.immediately) {
                    trigger = timer(0, dataSource.interval);
                }
                else {
                    trigger = interval(dataSource.interval);
                }
            }
            else {
                trigger = of(1);
            }
            if (this.trigger) {
                this.trigger.unsubscribe();
            }
            this.trigger = trigger.pipe(takeUntil(this.destroyed), switchMap(value => this.pauseInterval ? EMPTY : of(value))).subscribe(() => {
                this.api.callServiceMethod(dataSource, this.data.dataObject)
                    .pipe(take$1(1), catchError$1(err => {
                    if (typeof this.data.dataSourceError === 'function') {
                        if (typeof this.data.dataSourceErrorParams === 'undefined') {
                            this.data.dataSourceErrorParams = {
                                event: 'dataSourceError'
                            };
                        }
                        this.data.dataSourceErrorParams.event = 'dataSourceError';
                        this.data.dataSourceErrorParams.errorMessage = err
                            .message;
                        const result = this.data.dataSourceError(this.data.dataSourceErrorParams);
                        if (result instanceof Observable) {
                            result.pipe(take$1(1)).subscribe();
                        }
                        return throwError(() => err);
                    }
                }))
                    .subscribe({
                    next: (response) => {
                        if (typeof dataSource.path !== 'undefined') {
                            const dataObject = this.getArrayPathService.get(response.result.data, dataSource.path) || [];
                            if (dataSource.append) {
                                if (Array.isArray(this.data.dataObject) && Array.isArray(dataObject)) {
                                    this.data.dataObject = this.data.dataObject.concat(dataObject);
                                }
                                else if (typeof this.data.dataObject === 'object') {
                                    this.data.dataObject = { ...this.data.dataObject, ...dataObject };
                                }
                            }
                            else {
                                this.data.dataObject = dataObject;
                            }
                        }
                        else {
                            if (dataSource.append) {
                                if (Array.isArray(this.data.dataObject) && Array.isArray(response.result.data)) {
                                    this.data.dataObject = this.data.dataObject.concat(response.result.data);
                                }
                                else if (typeof this.data.dataObject === 'object') {
                                    this.data.dataObject = { ...this.data.dataObject, ...response.result.data };
                                }
                            }
                            else {
                                this.data.dataObject = response.result.data;
                            }
                        }
                        // execute loaded event handler if form is in action
                        if (typeof this.data.loaded === 'function') {
                            this.data.loadedParams = {
                                event: 'loaded'
                            };
                            this.data.loadedParams.event = 'loaded';
                            if (this.data.dataObject) {
                                this.data.loadedParams.dataObject = this.data.dataObject;
                            }
                            const result = this.data.loaded(this.data.loadedParams);
                            if (result instanceof Observable) {
                                result.pipe(take$1(1)).subscribe();
                            }
                        }
                    },
                    error: (err) => { },
                    complete: () => {
                        this.buildGrid();
                    }
                });
                if (dataSource.interval && dataSource.intervalLoader === false) {
                    dataSource.params.noLoader = true;
                }
            });
        }
        else {
            this.buildGrid();
        }
    }
    buildGrid() {
        this.grid = {
            rows: this.data.rows
        };
        if (this.data.dataObject) {
            this.grid.dataObject = this.data.dataObject;
        }
    }
    getRowHeight(row) {
        if (typeof row.height !== 'undefined') {
            const height = row.height.join('');
            return height;
        }
    }
    getClass(def, data) {
        let classes = [];
        if (typeof def.class !== 'undefined') {
            classes = def.class.split(' ').filter(n => n !== '');
        }
        if (data && typeof def.conditionalClasses !== 'undefined') {
            for (const condition of def.conditionalClasses) {
                let conditionData;
                let valueData;
                switch (condition.scope) {
                    case 'storage':
                        conditionData = null;
                        break;
                    default:
                        conditionData = data;
                }
                switch (condition.valueScope) {
                    case 'storage':
                        valueData = null;
                        break;
                    default:
                        valueData = data;
                }
                if (this.evaluator.exec(conditionData, condition, valueData)) {
                    classes.push(...condition.class.split(' ').filter(n => n !== ''));
                }
            }
        }
        return classes;
    }
    isArray(obj) {
        return Array.isArray(obj);
    }
    isDefined(variable) {
        return typeof variable !== 'undefined';
    }
    isVisible(obj, dataObject, key) {
        return !this.isDefined(obj.visible) ||
            (this.isDefined(obj.visible) && execute.call(this, obj, dataObject));
        function execute(obj, dataObject) {
            let conditions = [];
            let evalData = [];
            let evalValueData = [];
            if (Array.isArray(obj.visible)) {
                conditions = JSON.parse(JSON.stringify(obj.visible));
            }
            else {
                conditions.push(JSON.parse(JSON.stringify(obj.visible)));
            }
            for (const visible of conditions) {
                // if the key used in the path, replace it with the supplied key
                const keyIdx = visible.path.indexOf('{key}');
                if (keyIdx >= 0) {
                    visible.path[keyIdx] = key;
                }
                switch (visible.scope) {
                    case "lastUrl":
                        evalData.push(this.session.get("lastUrl")[0]);
                        break;
                    case "urlParams":
                        evalData.push(this.route.snapshot.params);
                        break;
                    case "state":
                        evalData.push(this.state);
                        break;
                    case "data":
                        evalData.push(this.data);
                        break;
                    case "storage":
                        evalData.push(null);
                        break;
                    case "parentForm":
                        evalData.push(this.parentForm.getRawValue());
                        break;
                    default:
                        evalData.push(dataObject);
                }
                if (typeof visible.valueScope !== "undefined") {
                    switch (visible.valueScope) {
                        case "lastUrl":
                            evalValueData.push(this.session.get("lastUrl")[0]);
                            break;
                        case "urlParams":
                            evalValueData.push(this.route.snapshot.params);
                            break;
                        case "state":
                            evalValueData.push(this.state);
                            break;
                        case "data":
                            evalValueData.push(this.data);
                            break;
                        case "storage":
                            evalValueData.push(null);
                            break;
                        case "parentForm":
                            evalValueData.push(this.parentForm.getRawValue());
                            break;
                        case "dataObject":
                            evalValueData.push(dataObject);
                            break;
                    }
                }
            }
            return this.evaluator.exec(evalData, conditions, evalValueData);
        }
    }
    getIcon(col, data) {
        let iconPath = '';
        if (typeof col.iconDir !== 'undefined') {
            iconPath += col.iconDir;
            if (!iconPath.endsWith('/')) {
                iconPath += '/';
            }
        }
        if (Array.isArray(col.icon)) {
            iconPath += this.getArrayPath.transform(data, col.icon);
        }
        else {
            iconPath += col.icon;
        }
        if (typeof col.iconExt !== 'undefined') {
            iconPath += '.' + col.iconExt;
        }
        return iconPath;
    }
    toggle(elem, firstVisible) {
        if (typeof this.hiddenElements[elem] === 'undefined' && firstVisible) {
            this.hiddenElements[elem] = !firstVisible;
        }
        else {
            this.hiddenElements[elem] = !this.hiddenElements[elem];
        }
    }
    removeExtractedRow(row, extractedPath, compareKey = 'id') {
        const allElements = this.getArrayPathService.get(this.grid.dataObject, extractedPath);
        for (const el in allElements) {
            if (allElements[el][compareKey] === row[compareKey]) {
                delete allElements[el];
            }
        }
    }
    extractTrackBy(index, item) {
        return JSON.stringify(item.value);
    }
    noSort() {
        return 0;
    }
    ngOnDestroy() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.resetChannels(new Set([this.data.channel]));
        }
        super.ngOnDestroy();
    }
}
GridListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GridListComponent, deps: [{ token: i1.ActivatedRoute }, { token: GetArrayPathPipe }, { token: GetArrayPathService }, { token: TransformService }, { token: EvalService }, { token: StateService }, { token: HelperService }, { token: SessionService }], target: i0.ɵɵFactoryTarget.Component });
GridListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: GridListComponent, selector: "app-grid-list", inputs: { data: "data", parentForm: "parentForm", parentComponent: "parentComponent" }, usesInheritance: true, ngImport: i0, template: "<!-- cell content template -->\r\n<ng-template\r\n  #contentTpl\r\n  let-data=\"data\"\r\n  let-index=\"index\"\r\n  let-col=\"col\"\r\n  let-extract=\"extract\"\r\n  let-key=\"key\">\r\n  <!--If component is configured-->\r\n  <!--If one component occupies entire column-->\r\n  <app-slot\r\n    *ngIf=\"col.component\"\r\n    [items]=\"[col]\"\r\n    [componentValue]=\"data | getArrayPath : col.path\"\r\n    [parentForm]=\"parentForm\"\r\n    [detectChanges]=\"true\"\r\n    [parentComponent]=\"selfRef\"\r\n    [ngClass]=\"{\r\n      'd-block': col.slotCovers !== false,\r\n      'h-100': col.slotCovers !== false,\r\n      'w-100': col.slotCovers !== false\r\n    }\"></app-slot>\r\n  <!--If array of component(s) specified-->\r\n  <app-slot\r\n    *ngIf=\"col.components\"\r\n    [items]=\"col.components\"\r\n    [componentValue]=\"data | getArrayPath : col.path\"\r\n    [parentForm]=\"parentForm\"\r\n    [detectChanges]=\"true\"\r\n    [parentComponent]=\"selfRef\"\r\n    [ngClass]=\"{\r\n      'd-block': col.slotCovers !== false,\r\n      'h-100': col.slotCovers !== false,\r\n      'w-100': col.slotCovers !== false\r\n    }\"></app-slot>\r\n  <ng-container *ngIf=\"!col.component && !col.components\">\r\n    <!-- with tooltip -->\r\n    <span\r\n      *ngIf=\"\r\n        col.tooltip &&\r\n        col.tooltip.content != '' &&\r\n        (data | tooltipContent : col.tooltip.content)\r\n      \"\r\n      [matTooltip]=\"data | tooltipContent : col.tooltip.content : col.tooltip.format\"\r\n      [ngStyle]=\"{ 'background-color': col.tooltip.backgroundColor }\">\r\n      <!-- extracted from response label -->\r\n      <ng-container *ngIf=\"col.label && extract\">\r\n        {{ data | getArrayPath : col.label }}\r\n      </ng-container>\r\n      <!-- label -->\r\n      <ng-container *ngIf=\"col.label && !extract\">\r\n        {{ getLabel(col.label, data) }}\r\n      </ng-container>\r\n      <!-- content from response path -->\r\n      <ng-container *ngIf=\"col.path\">\r\n        <ng-container *ngIf=\"!col.transform\">\r\n          <span\r\n            *ngIf=\"col.html; else text\"\r\n            [innerHTML]=\"data | getArrayPath : col.path\"></span>\r\n          <ng-template #text>\r\n            {{ data | getArrayPath : col.path }}\r\n          </ng-template>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"col.transform\">\r\n          <span\r\n            *ngIf=\"col.html; else text\"\r\n            [innerHTML]=\"\r\n              transformData.transform(data | getArrayPath : col.path, col.transform)\r\n            \"></span>\r\n          <ng-template #text>\r\n            {{ transformData.transform(data | getArrayPath : col.path, col.transform) }}\r\n          </ng-template>\r\n        </ng-container>\r\n      </ng-container>\r\n      <!-- content from multiple response paths -->\r\n      <ng-container *ngIf=\"col.multipath\">\r\n        <ng-container *ngFor=\"let path of col.multipath; let isLast = last\">\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            {{ data | getArrayPath : path }}\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            {{ transformData.transform(data | getArrayPath : path, col.transform) }}\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"col.multipathGlue && !isLast && (data | getArrayPath : path)\"\r\n            >{{ col.multipathGlue }}</ng-container\r\n          >\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value\">\r\n        <ng-container *ngSwitch=\"col.value\">\r\n          <ng-container *ngSwitchCase=\"'index'\">\r\n            {{ index }}\r\n          </ng-container>\r\n          <ng-container *ngSwitchCase=\"'key'\">\r\n            {{ key }}\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </span>\r\n    <!-- without tooltip -->\r\n    <ng-container\r\n      *ngIf=\"\r\n        !col.tooltip ||\r\n        (col.tooltip &&\r\n          (col.tooltip.content == '' || !(data | tooltipContent : col.tooltip.content)))\r\n      \">\r\n      <!-- extracted from response label -->\r\n      <ng-container *ngIf=\"col.label && extract\">\r\n        <ng-container *ngIf=\"col.staticLabel\">\r\n          {{ getLabel(col.label, data) }}\r\n        </ng-container>\r\n        <ng-container *ngIf=\"!col.staticLabel\">\r\n          {{ data | getArrayPath : col.label }}\r\n        </ng-container>\r\n      </ng-container>\r\n      <!-- label -->\r\n      <ng-container *ngIf=\"col.label && !extract\">\r\n        {{ getLabel(col.label, data) }}\r\n      </ng-container>\r\n      <!-- content from response path -->\r\n      <ng-container *ngIf=\"col.path\">\r\n        <ng-container *ngIf=\"col.extract; else elseBlock\">\r\n          <ng-container\r\n            *ngFor=\"let item of data | getArrayPath : col.extract; index as i\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                (col.condition && evaluator.exec(item, col.condition)) || !col.condition\r\n              \">\r\n              <img\r\n                *ngIf=\"col.icon && col.iconPosition === 'before'\"\r\n                class=\"icon\"\r\n                [src]=\"getIcon(col, item)\" />\r\n              <span\r\n                *ngIf=\"col.html; else text\"\r\n                [innerHTML]=\"item | getArrayPath : col.path\"></span>\r\n              <ng-template #text>\r\n                {{ item | getArrayPath : col.path }}\r\n              </ng-template>\r\n              <img\r\n                *ngIf=\"col.icon && col.iconPosition === 'after'\"\r\n                class=\"icon\"\r\n                [src]=\"getIcon(col, item)\" />\r\n            </ng-container>\r\n          </ng-container>\r\n        </ng-container>\r\n        <ng-template #elseBlock>\r\n          <img\r\n            *ngIf=\"col.icon && col.iconPosition === 'before'\"\r\n            class=\"icon\"\r\n            [src]=\"getIcon(col, data)\" />\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            <span\r\n              *ngIf=\"col.html; else text\"\r\n              [innerHTML]=\"data | getArrayPath : col.path\"></span>\r\n            <ng-template #text>\r\n              {{ data | getArrayPath : col.path }}\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            <span\r\n              *ngIf=\"col.html; else text\"\r\n              [innerHTML]=\"transformData.transform(data, col)\"></span>\r\n            <ng-template #text>\r\n              {{ transformData.transform(data, col) }}\r\n            </ng-template>\r\n          </ng-container>\r\n          <img\r\n            *ngIf=\"col.icon && col.iconPosition === 'after'\"\r\n            class=\"icon\"\r\n            [src]=\"getIcon(col, data)\" />\r\n        </ng-template>\r\n      </ng-container>\r\n      <!-- content from multiple response paths -->\r\n      <ng-container *ngIf=\"col.multipath\">\r\n        <ng-container *ngFor=\"let path of col.multipath; let isLast = last\">\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            {{ data | getArrayPath : path }}\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            {{ transformData.transform(data | getArrayPath : path, col.transform) }}\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"col.multipathGlue && !isLast && (data | getArrayPath : path)\"\r\n            >{{ col.multipathGlue }}</ng-container\r\n          >\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value === 'index'\">\r\n        {{ index }}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value === 'key'\">\r\n        {{ key }}\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n<div [class]=\"data.class\" [id]=\"data.id ? data.id : ''\">\r\n  <ng-container *ngFor=\"let row of grid.rows\">\r\n    <!-- extracted from response rows as columns -->\r\n    <ng-container *ngIf=\"row.extractAsCols && isVisible(row, grid.dataObject)\">\r\n      <div class=\"row\" [class]=\"row.class\" [id]=\"row.id ? row.id : ''\">\r\n        <ng-container\r\n          *ngFor=\"\r\n            let extracted of grid.dataObject | getArrayPath : row.path | keyvalue : noSort;\r\n            trackBy: extractTrackBy;\r\n          \">\r\n          <div\r\n            *ngFor=\"let col of row.extractAsCols\"\r\n            [class]=\"col.class\"\r\n            [class]=\"getClass(col, extracted)\"\r\n            [ngStyle]=\"{ height: getRowHeight(row) }\"\r\n            [id]=\"col.id ? (extracted.value | getArrayPath : col.id) : ''\">\r\n            <ng-container *ngIf=\"isVisible(col, extracted.value)\">\r\n              <app-link\r\n                *ngIf=\"col.linkPath\"\r\n                [data]=\"{\r\n                  url: extracted.value | getArrayPath : col.linkPath,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <app-link\r\n                *ngIf=\"col.link\"\r\n                [data]=\"{\r\n                  url: col.link,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <ng-container *ngIf=\"!col.linkPath && !col.link\">\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"\r\n                    contentTpl;\r\n                    context: {\r\n                      data: extracted.value,\r\n                      col: col,\r\n                      extract: true,\r\n                      key: extracted.key\r\n                    }\r\n                  \"></ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <!--  extracted from response rows as rows -->\r\n    <ng-container *ngIf=\"row.extract && isVisible(row, grid.dataObject)\">\r\n      <div\r\n        *ngFor=\"\r\n          let extracted of grid.dataObject | getArrayPath : row.path | keyvalue : noSort;\r\n          trackBy: extractTrackBy;\r\n          let i = index\r\n        \"\r\n        class=\"row\"\r\n        [class]=\"getClass(row, extracted.value)\"\r\n        [id]=\"row.id ? row.id : ''\">\r\n        <ng-container *ngFor=\"let col of row.extract\">\r\n          <ng-container *ngIf=\"isVisible(col, extracted.value, extracted.key)\">\r\n            <div\r\n              [id]=\"col.id ? (extracted.value | getArrayPath : col.id) : ''\"\r\n              [class]=\"getClass(col, extracted.value)\"\r\n              [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n              <app-link\r\n                *ngIf=\"col.linkPath\"\r\n                [data]=\"{\r\n                  url: extracted.value | getArrayPath : col.linkPath,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <ng-container *ngIf=\"!col.linkPath\">\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: extracted.value | getArrayPath : col.link,\r\n                    label: extracted.value | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <ng-container *ngIf=\"!col.link\">\r\n                  <ng-container\r\n                    *ngTemplateOutlet=\"\r\n                      contentTpl;\r\n                      context: {\r\n                        data: extracted.value,\r\n                        index: i + 1,\r\n                        col: col,\r\n                        extract: true,\r\n                        key: extracted.key\r\n                      }\r\n                    \"></ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <!-- rows defined in routing -->\r\n    <ng-container *ngIf=\"!row.extract\">\r\n      <div\r\n        class=\"row\"\r\n        *ngIf=\"isVisible(row, grid.dataObject)\"\r\n        [class]=\"getClass(row, grid.dataObject)\"\r\n        [id]=\"row.id ? row.id : ''\">\r\n        <ng-container *ngFor=\"let col of row.cols\">\r\n          <div\r\n            *ngIf=\"isVisible(col, grid.dataObject)\"\r\n            [class]=\"getClass(col, grid.dataObject)\"\r\n            [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n            <!--If toggle element-->\r\n            <ng-container *ngIf=\"col.toggle\">\r\n              <h4\r\n                (click)=\"toggle(col.toggle, col.visible)\"\r\n                *ngIf=\"col.label && (col.data || col.component)\"\r\n                class=\"pointer\">\r\n                {{ getLabel(col.label, grid.dataObject) }}\r\n                <span\r\n                  class=\"material-icons float-right\"\r\n                  *ngIf=\"\r\n                    (!isDefined(hiddenElements[col.toggle]) && col.visible) ||\r\n                    hiddenElements[col.toggle]\r\n                  \">\r\n                  keyboard_arrow_down\r\n                </span>\r\n                <span\r\n                  class=\"material-icons float-right\"\r\n                  *ngIf=\"\r\n                    isDefined(hiddenElements[col.toggle]) && !hiddenElements[col.toggle]\r\n                  \">\r\n                  keyboard_arrow_up\r\n                </span>\r\n              </h4>\r\n            </ng-container>\r\n            <!--If toggle element doesn't exist-->\r\n            <ng-container *ngIf=\"!col.toggle\">\r\n              <h4 *ngIf=\"col.label && (col.data || col.component)\">\r\n                {{ getLabel(col.label, grid.dataObject) }}\r\n              </h4>\r\n            </ng-container>\r\n            <!--If component is not configured-->\r\n            <!-- DEPRECATED -->\r\n            <div\r\n              class=\"list\"\r\n              *ngIf=\"!col.components && !col.component && !col.toggle && col.data\">\r\n              <!--Show all rows in given object-->\r\n              <ng-container *ngIf=\"col.extractedData\">\r\n                <div\r\n                  *ngFor=\"let extracted of grid.dataObject | getArrayPath : col.path\"\r\n                  class=\"row\"\r\n                  [class]=\"col.extractedData.class\"\r\n                  [id]=\"row.id ? row.id : ''\">\r\n                  <div *ngIf=\"col.extractedData.label\" class=\"col-auto\">\r\n                    {{ extracted | getArrayPath : col.extractedData.label }}:\r\n                  </div>\r\n                  <div *ngIf=\"!col.extractedData.multipath\" class=\"col text-right value\">\r\n                    {{ extracted | getArrayPath : col.extractedData.path }}\r\n                  </div>\r\n                  <div *ngIf=\"col.extractedData.multipath\" class=\"col text-right value\">\r\n                    <ng-container *ngFor=\"let path of col.extractedData.multipath\">\r\n                      {{ extracted | getArrayPath : path }}\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n\r\n              <!--Show only configured rows in given object-->\r\n              <ng-container *ngIf=\"col.data\">\r\n                <div\r\n                  *ngFor=\"let source of col.data\"\r\n                  class=\"row\"\r\n                  [class]=\"source.class\"\r\n                  [id]=\"row.id ? row.id : ''\">\r\n                  <img *ngIf=\"source.image\" src=\"assets/img/{{ source.image }}\" />\r\n                  <div *ngIf=\"source.label\" class=\"col-auto\">\r\n                    <strong>{{ language.getLabel(source.label) }}:</strong>\r\n                  </div>\r\n                  <div\r\n                    *ngIf=\"!source.multipath && source.path\"\r\n                    class=\"col text-right value\">\r\n                    <ng-container *ngIf=\"!source.transform\">\r\n                      {{ grid.dataObject | getArrayPath : source.path }}\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"source.transform\">\r\n                      {{ transformData.transform(grid.dataObject, source.transform) }}\r\n                    </ng-container>\r\n                  </div>\r\n                  <div *ngIf=\"source.multipath\" class=\"col text-right value\">\r\n                    <ng-container *ngFor=\"let path of source.multipath\">\r\n                      <ng-container *ngIf=\"!source.transform\">\r\n                        {{ grid.dataObject | getArrayPath : path }}\r\n                      </ng-container>\r\n                      <ng-container *ngIf=\"source.transform\">\r\n                        {{\r\n                          transformData.transform(\r\n                            grid.dataObject | getArrayPath : path,\r\n                            source.transform\r\n                          )\r\n                        }}\r\n                      </ng-container>\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <!-- DEPRECATED END -->\r\n            <ng-container *ngIf=\"col.components || col.component || !col.data\">\r\n              <ng-container *ngIf=\"col.path\">\r\n                <app-link\r\n                  *ngIf=\"col.linkPath\"\r\n                  [data]=\"{\r\n                    url: grid.dataObject | getArrayPath : col.linkPath,\r\n                    label: grid.dataObject | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: col.link,\r\n                    label: grid.dataObject | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"col.label\">\r\n                <app-link\r\n                  *ngIf=\"col.linkPath\"\r\n                  [data]=\"{\r\n                    url: grid.dataObject | getArrayPath : col.linkPath,\r\n                    label: col.label,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: col.link,\r\n                    label: col.label,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"!col.linkPath && !col.link\">\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"\r\n                    contentTpl;\r\n                    context: {\r\n                      data: grid.dataObject,\r\n                      col: col,\r\n                      extract: false\r\n                    }\r\n                  \"></ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [".gridHolder{font-size:14px;padding-left:1rem;padding-right:1rem;margin-bottom:20px;background:#fff}.gridHolder img{max-width:100%}.gridHolder .gridContainer{margin-top:15px;padding:20px}.gridHolder .total{font-weight:700;border-top:1px solid #dedede;margin-top:10px;padding-top:10px}.gridHolder .total:last-child{padding-bottom:10px}.gridHolder h4{border-bottom:1px solid #dedede;padding-bottom:10px}.gridHolder .value{white-space:nowrap}.list{line-height:28px;margin-bottom:10px}.height120{height:120px}.height80{height:80px}.mainData{font-size:16px;line-height:24px}.flexContainer{display:flex;align-items:center;justify-content:center}.borderBottom{border-bottom:1px solid #dedede;line-height:28px}.marginBottom20{margin-bottom:20px}.marginTop20{margin-top:20px}.pointer{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: i11$4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: LinkComponent, selector: "app-link", inputs: ["data", "parentComponent"] }, { kind: "pipe", type: i3.KeyValuePipe, name: "keyvalue" }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: TooltipContentPipe, name: "tooltipContent" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GridListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-grid-list', template: "<!-- cell content template -->\r\n<ng-template\r\n  #contentTpl\r\n  let-data=\"data\"\r\n  let-index=\"index\"\r\n  let-col=\"col\"\r\n  let-extract=\"extract\"\r\n  let-key=\"key\">\r\n  <!--If component is configured-->\r\n  <!--If one component occupies entire column-->\r\n  <app-slot\r\n    *ngIf=\"col.component\"\r\n    [items]=\"[col]\"\r\n    [componentValue]=\"data | getArrayPath : col.path\"\r\n    [parentForm]=\"parentForm\"\r\n    [detectChanges]=\"true\"\r\n    [parentComponent]=\"selfRef\"\r\n    [ngClass]=\"{\r\n      'd-block': col.slotCovers !== false,\r\n      'h-100': col.slotCovers !== false,\r\n      'w-100': col.slotCovers !== false\r\n    }\"></app-slot>\r\n  <!--If array of component(s) specified-->\r\n  <app-slot\r\n    *ngIf=\"col.components\"\r\n    [items]=\"col.components\"\r\n    [componentValue]=\"data | getArrayPath : col.path\"\r\n    [parentForm]=\"parentForm\"\r\n    [detectChanges]=\"true\"\r\n    [parentComponent]=\"selfRef\"\r\n    [ngClass]=\"{\r\n      'd-block': col.slotCovers !== false,\r\n      'h-100': col.slotCovers !== false,\r\n      'w-100': col.slotCovers !== false\r\n    }\"></app-slot>\r\n  <ng-container *ngIf=\"!col.component && !col.components\">\r\n    <!-- with tooltip -->\r\n    <span\r\n      *ngIf=\"\r\n        col.tooltip &&\r\n        col.tooltip.content != '' &&\r\n        (data | tooltipContent : col.tooltip.content)\r\n      \"\r\n      [matTooltip]=\"data | tooltipContent : col.tooltip.content : col.tooltip.format\"\r\n      [ngStyle]=\"{ 'background-color': col.tooltip.backgroundColor }\">\r\n      <!-- extracted from response label -->\r\n      <ng-container *ngIf=\"col.label && extract\">\r\n        {{ data | getArrayPath : col.label }}\r\n      </ng-container>\r\n      <!-- label -->\r\n      <ng-container *ngIf=\"col.label && !extract\">\r\n        {{ getLabel(col.label, data) }}\r\n      </ng-container>\r\n      <!-- content from response path -->\r\n      <ng-container *ngIf=\"col.path\">\r\n        <ng-container *ngIf=\"!col.transform\">\r\n          <span\r\n            *ngIf=\"col.html; else text\"\r\n            [innerHTML]=\"data | getArrayPath : col.path\"></span>\r\n          <ng-template #text>\r\n            {{ data | getArrayPath : col.path }}\r\n          </ng-template>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"col.transform\">\r\n          <span\r\n            *ngIf=\"col.html; else text\"\r\n            [innerHTML]=\"\r\n              transformData.transform(data | getArrayPath : col.path, col.transform)\r\n            \"></span>\r\n          <ng-template #text>\r\n            {{ transformData.transform(data | getArrayPath : col.path, col.transform) }}\r\n          </ng-template>\r\n        </ng-container>\r\n      </ng-container>\r\n      <!-- content from multiple response paths -->\r\n      <ng-container *ngIf=\"col.multipath\">\r\n        <ng-container *ngFor=\"let path of col.multipath; let isLast = last\">\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            {{ data | getArrayPath : path }}\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            {{ transformData.transform(data | getArrayPath : path, col.transform) }}\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"col.multipathGlue && !isLast && (data | getArrayPath : path)\"\r\n            >{{ col.multipathGlue }}</ng-container\r\n          >\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value\">\r\n        <ng-container *ngSwitch=\"col.value\">\r\n          <ng-container *ngSwitchCase=\"'index'\">\r\n            {{ index }}\r\n          </ng-container>\r\n          <ng-container *ngSwitchCase=\"'key'\">\r\n            {{ key }}\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </span>\r\n    <!-- without tooltip -->\r\n    <ng-container\r\n      *ngIf=\"\r\n        !col.tooltip ||\r\n        (col.tooltip &&\r\n          (col.tooltip.content == '' || !(data | tooltipContent : col.tooltip.content)))\r\n      \">\r\n      <!-- extracted from response label -->\r\n      <ng-container *ngIf=\"col.label && extract\">\r\n        <ng-container *ngIf=\"col.staticLabel\">\r\n          {{ getLabel(col.label, data) }}\r\n        </ng-container>\r\n        <ng-container *ngIf=\"!col.staticLabel\">\r\n          {{ data | getArrayPath : col.label }}\r\n        </ng-container>\r\n      </ng-container>\r\n      <!-- label -->\r\n      <ng-container *ngIf=\"col.label && !extract\">\r\n        {{ getLabel(col.label, data) }}\r\n      </ng-container>\r\n      <!-- content from response path -->\r\n      <ng-container *ngIf=\"col.path\">\r\n        <ng-container *ngIf=\"col.extract; else elseBlock\">\r\n          <ng-container\r\n            *ngFor=\"let item of data | getArrayPath : col.extract; index as i\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                (col.condition && evaluator.exec(item, col.condition)) || !col.condition\r\n              \">\r\n              <img\r\n                *ngIf=\"col.icon && col.iconPosition === 'before'\"\r\n                class=\"icon\"\r\n                [src]=\"getIcon(col, item)\" />\r\n              <span\r\n                *ngIf=\"col.html; else text\"\r\n                [innerHTML]=\"item | getArrayPath : col.path\"></span>\r\n              <ng-template #text>\r\n                {{ item | getArrayPath : col.path }}\r\n              </ng-template>\r\n              <img\r\n                *ngIf=\"col.icon && col.iconPosition === 'after'\"\r\n                class=\"icon\"\r\n                [src]=\"getIcon(col, item)\" />\r\n            </ng-container>\r\n          </ng-container>\r\n        </ng-container>\r\n        <ng-template #elseBlock>\r\n          <img\r\n            *ngIf=\"col.icon && col.iconPosition === 'before'\"\r\n            class=\"icon\"\r\n            [src]=\"getIcon(col, data)\" />\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            <span\r\n              *ngIf=\"col.html; else text\"\r\n              [innerHTML]=\"data | getArrayPath : col.path\"></span>\r\n            <ng-template #text>\r\n              {{ data | getArrayPath : col.path }}\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            <span\r\n              *ngIf=\"col.html; else text\"\r\n              [innerHTML]=\"transformData.transform(data, col)\"></span>\r\n            <ng-template #text>\r\n              {{ transformData.transform(data, col) }}\r\n            </ng-template>\r\n          </ng-container>\r\n          <img\r\n            *ngIf=\"col.icon && col.iconPosition === 'after'\"\r\n            class=\"icon\"\r\n            [src]=\"getIcon(col, data)\" />\r\n        </ng-template>\r\n      </ng-container>\r\n      <!-- content from multiple response paths -->\r\n      <ng-container *ngIf=\"col.multipath\">\r\n        <ng-container *ngFor=\"let path of col.multipath; let isLast = last\">\r\n          <ng-container *ngIf=\"!col.transform\">\r\n            {{ data | getArrayPath : path }}\r\n          </ng-container>\r\n          <ng-container *ngIf=\"col.transform\">\r\n            {{ transformData.transform(data | getArrayPath : path, col.transform) }}\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"col.multipathGlue && !isLast && (data | getArrayPath : path)\"\r\n            >{{ col.multipathGlue }}</ng-container\r\n          >\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value === 'index'\">\r\n        {{ index }}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"col.value === 'key'\">\r\n        {{ key }}\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n<div [class]=\"data.class\" [id]=\"data.id ? data.id : ''\">\r\n  <ng-container *ngFor=\"let row of grid.rows\">\r\n    <!-- extracted from response rows as columns -->\r\n    <ng-container *ngIf=\"row.extractAsCols && isVisible(row, grid.dataObject)\">\r\n      <div class=\"row\" [class]=\"row.class\" [id]=\"row.id ? row.id : ''\">\r\n        <ng-container\r\n          *ngFor=\"\r\n            let extracted of grid.dataObject | getArrayPath : row.path | keyvalue : noSort;\r\n            trackBy: extractTrackBy;\r\n          \">\r\n          <div\r\n            *ngFor=\"let col of row.extractAsCols\"\r\n            [class]=\"col.class\"\r\n            [class]=\"getClass(col, extracted)\"\r\n            [ngStyle]=\"{ height: getRowHeight(row) }\"\r\n            [id]=\"col.id ? (extracted.value | getArrayPath : col.id) : ''\">\r\n            <ng-container *ngIf=\"isVisible(col, extracted.value)\">\r\n              <app-link\r\n                *ngIf=\"col.linkPath\"\r\n                [data]=\"{\r\n                  url: extracted.value | getArrayPath : col.linkPath,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <app-link\r\n                *ngIf=\"col.link\"\r\n                [data]=\"{\r\n                  url: col.link,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <ng-container *ngIf=\"!col.linkPath && !col.link\">\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"\r\n                    contentTpl;\r\n                    context: {\r\n                      data: extracted.value,\r\n                      col: col,\r\n                      extract: true,\r\n                      key: extracted.key\r\n                    }\r\n                  \"></ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <!--  extracted from response rows as rows -->\r\n    <ng-container *ngIf=\"row.extract && isVisible(row, grid.dataObject)\">\r\n      <div\r\n        *ngFor=\"\r\n          let extracted of grid.dataObject | getArrayPath : row.path | keyvalue : noSort;\r\n          trackBy: extractTrackBy;\r\n          let i = index\r\n        \"\r\n        class=\"row\"\r\n        [class]=\"getClass(row, extracted.value)\"\r\n        [id]=\"row.id ? row.id : ''\">\r\n        <ng-container *ngFor=\"let col of row.extract\">\r\n          <ng-container *ngIf=\"isVisible(col, extracted.value, extracted.key)\">\r\n            <div\r\n              [id]=\"col.id ? (extracted.value | getArrayPath : col.id) : ''\"\r\n              [class]=\"getClass(col, extracted.value)\"\r\n              [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n              <app-link\r\n                *ngIf=\"col.linkPath\"\r\n                [data]=\"{\r\n                  url: extracted.value | getArrayPath : col.linkPath,\r\n                  label: extracted.value | getArrayPath : col.path,\r\n                  components: col.components\r\n                }\"></app-link>\r\n              <ng-container *ngIf=\"!col.linkPath\">\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: extracted.value | getArrayPath : col.link,\r\n                    label: extracted.value | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <ng-container *ngIf=\"!col.link\">\r\n                  <ng-container\r\n                    *ngTemplateOutlet=\"\r\n                      contentTpl;\r\n                      context: {\r\n                        data: extracted.value,\r\n                        index: i + 1,\r\n                        col: col,\r\n                        extract: true,\r\n                        key: extracted.key\r\n                      }\r\n                    \"></ng-container>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <!-- rows defined in routing -->\r\n    <ng-container *ngIf=\"!row.extract\">\r\n      <div\r\n        class=\"row\"\r\n        *ngIf=\"isVisible(row, grid.dataObject)\"\r\n        [class]=\"getClass(row, grid.dataObject)\"\r\n        [id]=\"row.id ? row.id : ''\">\r\n        <ng-container *ngFor=\"let col of row.cols\">\r\n          <div\r\n            *ngIf=\"isVisible(col, grid.dataObject)\"\r\n            [class]=\"getClass(col, grid.dataObject)\"\r\n            [ngStyle]=\"{ height: getRowHeight(row) }\">\r\n            <!--If toggle element-->\r\n            <ng-container *ngIf=\"col.toggle\">\r\n              <h4\r\n                (click)=\"toggle(col.toggle, col.visible)\"\r\n                *ngIf=\"col.label && (col.data || col.component)\"\r\n                class=\"pointer\">\r\n                {{ getLabel(col.label, grid.dataObject) }}\r\n                <span\r\n                  class=\"material-icons float-right\"\r\n                  *ngIf=\"\r\n                    (!isDefined(hiddenElements[col.toggle]) && col.visible) ||\r\n                    hiddenElements[col.toggle]\r\n                  \">\r\n                  keyboard_arrow_down\r\n                </span>\r\n                <span\r\n                  class=\"material-icons float-right\"\r\n                  *ngIf=\"\r\n                    isDefined(hiddenElements[col.toggle]) && !hiddenElements[col.toggle]\r\n                  \">\r\n                  keyboard_arrow_up\r\n                </span>\r\n              </h4>\r\n            </ng-container>\r\n            <!--If toggle element doesn't exist-->\r\n            <ng-container *ngIf=\"!col.toggle\">\r\n              <h4 *ngIf=\"col.label && (col.data || col.component)\">\r\n                {{ getLabel(col.label, grid.dataObject) }}\r\n              </h4>\r\n            </ng-container>\r\n            <!--If component is not configured-->\r\n            <!-- DEPRECATED -->\r\n            <div\r\n              class=\"list\"\r\n              *ngIf=\"!col.components && !col.component && !col.toggle && col.data\">\r\n              <!--Show all rows in given object-->\r\n              <ng-container *ngIf=\"col.extractedData\">\r\n                <div\r\n                  *ngFor=\"let extracted of grid.dataObject | getArrayPath : col.path\"\r\n                  class=\"row\"\r\n                  [class]=\"col.extractedData.class\"\r\n                  [id]=\"row.id ? row.id : ''\">\r\n                  <div *ngIf=\"col.extractedData.label\" class=\"col-auto\">\r\n                    {{ extracted | getArrayPath : col.extractedData.label }}:\r\n                  </div>\r\n                  <div *ngIf=\"!col.extractedData.multipath\" class=\"col text-right value\">\r\n                    {{ extracted | getArrayPath : col.extractedData.path }}\r\n                  </div>\r\n                  <div *ngIf=\"col.extractedData.multipath\" class=\"col text-right value\">\r\n                    <ng-container *ngFor=\"let path of col.extractedData.multipath\">\r\n                      {{ extracted | getArrayPath : path }}\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n\r\n              <!--Show only configured rows in given object-->\r\n              <ng-container *ngIf=\"col.data\">\r\n                <div\r\n                  *ngFor=\"let source of col.data\"\r\n                  class=\"row\"\r\n                  [class]=\"source.class\"\r\n                  [id]=\"row.id ? row.id : ''\">\r\n                  <img *ngIf=\"source.image\" src=\"assets/img/{{ source.image }}\" />\r\n                  <div *ngIf=\"source.label\" class=\"col-auto\">\r\n                    <strong>{{ language.getLabel(source.label) }}:</strong>\r\n                  </div>\r\n                  <div\r\n                    *ngIf=\"!source.multipath && source.path\"\r\n                    class=\"col text-right value\">\r\n                    <ng-container *ngIf=\"!source.transform\">\r\n                      {{ grid.dataObject | getArrayPath : source.path }}\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"source.transform\">\r\n                      {{ transformData.transform(grid.dataObject, source.transform) }}\r\n                    </ng-container>\r\n                  </div>\r\n                  <div *ngIf=\"source.multipath\" class=\"col text-right value\">\r\n                    <ng-container *ngFor=\"let path of source.multipath\">\r\n                      <ng-container *ngIf=\"!source.transform\">\r\n                        {{ grid.dataObject | getArrayPath : path }}\r\n                      </ng-container>\r\n                      <ng-container *ngIf=\"source.transform\">\r\n                        {{\r\n                          transformData.transform(\r\n                            grid.dataObject | getArrayPath : path,\r\n                            source.transform\r\n                          )\r\n                        }}\r\n                      </ng-container>\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <!-- DEPRECATED END -->\r\n            <ng-container *ngIf=\"col.components || col.component || !col.data\">\r\n              <ng-container *ngIf=\"col.path\">\r\n                <app-link\r\n                  *ngIf=\"col.linkPath\"\r\n                  [data]=\"{\r\n                    url: grid.dataObject | getArrayPath : col.linkPath,\r\n                    label: grid.dataObject | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: col.link,\r\n                    label: grid.dataObject | getArrayPath : col.path,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"col.label\">\r\n                <app-link\r\n                  *ngIf=\"col.linkPath\"\r\n                  [data]=\"{\r\n                    url: grid.dataObject | getArrayPath : col.linkPath,\r\n                    label: col.label,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n                <app-link\r\n                  *ngIf=\"col.link\"\r\n                  [data]=\"{\r\n                    url: col.link,\r\n                    label: col.label,\r\n                    components: col.components\r\n                  }\"></app-link>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"!col.linkPath && !col.link\">\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"\r\n                    contentTpl;\r\n                    context: {\r\n                      data: grid.dataObject,\r\n                      col: col,\r\n                      extract: false\r\n                    }\r\n                  \"></ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [".gridHolder{font-size:14px;padding-left:1rem;padding-right:1rem;margin-bottom:20px;background:#fff}.gridHolder img{max-width:100%}.gridHolder .gridContainer{margin-top:15px;padding:20px}.gridHolder .total{font-weight:700;border-top:1px solid #dedede;margin-top:10px;padding-top:10px}.gridHolder .total:last-child{padding-bottom:10px}.gridHolder h4{border-bottom:1px solid #dedede;padding-bottom:10px}.gridHolder .value{white-space:nowrap}.list{line-height:28px;margin-bottom:10px}.height120{height:120px}.height80{height:80px}.mainData{font-size:16px;line-height:24px}.flexContainer{display:flex;align-items:center;justify-content:center}.borderBottom{border-bottom:1px solid #dedede;line-height:28px}.marginBottom20{margin-bottom:20px}.marginTop20{margin-top:20px}.pointer{cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: GetArrayPathPipe }, { type: GetArrayPathService }, { type: TransformService }, { type: EvalService }, { type: StateService }, { type: HelperService }, { type: SessionService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], parentComponent: [{
                type: Input
            }] } });

class GridListModule {
    constructor(routing) {
        routing.mapComponent('GridListComponent', GridListComponent);
    }
}
GridListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GridListModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
GridListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GridListModule, declarations: [GridListComponent], imports: [CommonModule,
        SlotModule,
        PipesModule,
        MatTooltipModule,
        PrimitiveModule], exports: [GridListComponent] });
GridListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GridListModule, imports: [CommonModule,
        SlotModule,
        PipesModule,
        MatTooltipModule,
        PrimitiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GridListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GridListComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule,
                        MatTooltipModule,
                        PrimitiveModule
                    ],
                    exports: [GridListComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var gridList_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   GridListModule: GridListModule
});

class TableListComponent {
    constructor(api, dialog, eventBus, language, permissionSevice, query, router, getArrayPath, transformData, route, evaluator, comm, helper) {
        this.api = api;
        this.dialog = dialog;
        this.eventBus = eventBus;
        this.language = language;
        this.permissionSevice = permissionSevice;
        this.query = query;
        this.router = router;
        this.getArrayPath = getArrayPath;
        this.transformData = transformData;
        this.route = route;
        this.evaluator = evaluator;
        this.comm = comm;
        this.helper = helper;
        this.subsc = [];
        this.willLoad = false;
        this.loading = false;
        this.cols = [];
        this.pageIndex = 1;
        this.rowSelection = [];
        this.checkbox = {};
        this.listedColumns = [];
        this.actionColAppended = false;
        this.destroyed = new Subject();
        this.query = query;
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.addToActionBar();
        // Refresh data if query params or url param has been changed
        combineLatest([
            this.route.queryParams.pipe(startWith(null)),
            this.route.params.pipe(startWith(null))
        ]).pipe(takeUntil(this.destroyed), debounceTime(0))
            .subscribe((params) => {
            const urlParams = JSON.parse(JSON.stringify(params));
            if (typeof this.paginator !== 'undefined'
                && (typeof urlParams[0].page === 'undefined' || !urlParams[0].page)) {
                urlParams[0].page = '1';
                this.paginator.firstPage();
            }
            if (this.urlParams
                && JSON.stringify(this.urlParams) !== JSON.stringify(urlParams)) {
                this.addToActionBar(true);
                this.load();
            }
            this.urlParams = urlParams;
        });
        if (this.data.loadOnInit === false && Object.keys(this.query.queryUrl).length === 0) {
            return;
        }
        this.load();
    }
    addToActionBar(update = false) {
        if (update) {
            this.eventBus.fire(new Event('emptyActionBar', true));
            for (const sub of this.subsc) {
                sub.unsubscribe();
            }
        }
        if (typeof this.data.actions !== "undefined") {
            this.data.actions.forEach((action, key) => {
                if (!this.permissionSevice.checkPermissions(action)) {
                    this.data.actions[key].denied = true;
                }
                else {
                    this.data.actions[key].denied = false;
                }
            });
            for (const action of this.data.actions) {
                if (action.actionBar && !action.denied) {
                    // register action in action bar(s)
                    if (typeof action.mutationIndex !== 'undefined'
                        && typeof this.data.dataSource.params !== 'undefined'
                        && typeof this.data.dataSource.params.mutations !== 'undefined') {
                        action.actionBar.data.value
                            = this.data.dataSource.params.mutations[action.mutationIndex];
                    }
                    action.event = action.id + '_tableList_' + this.data.instanceId;
                    this.eventBus.fire(new Event('addToActionBar', action));
                    this.subsc.push(this.eventBus.on(action.event)
                        .pipe(takeUntil(this.destroyed))
                        .subscribe((actionData) => {
                        if (typeof this[actionData.id] !== 'undefined') {
                            this[actionData.id](actionData);
                        }
                    }));
                }
            }
        }
    }
    load(queryParams = null, page = null) {
        this.willLoad = true;
        this.query.updateQueryUrl(this.route.snapshot);
        this.cols = [];
        if (typeof this.data.listedColumns !== 'undefined') {
            this.listedColumns = [...this.data.listedColumns];
            this.listedColumns.forEach((item, key) => {
                this.cols.push(item.label || item.id);
            });
        }
        if (this.data.selectable) {
            this.cols.unshift('select');
        }
        // prepare actions
        if (this.cols.indexOf('action') <= 0 && this.data.actions) {
            this.actionColAppended = true;
            this.cols.push('action');
        }
        if (!page && typeof this.route.snapshot.queryParams.page !== 'undefined') {
            // Set paging to query if comes from url
            page = this.route.snapshot.queryParams.page;
        }
        let params = {};
        if (!queryParams) {
            queryParams = this.query.prepareParams();
        }
        if (typeof this.data?.dataSource?.conditionalParams !== 'undefined') {
            const conditionalParams = JSON.parse(JSON.stringify(this.data.dataSource.conditionalParams));
            for (const item of conditionalParams) {
                if (item.condition) {
                    if (this.evaluator.exec(this.data.dataObject, item.condition)) {
                        delete item.condition;
                        Object.assign(params, item);
                    }
                }
                else {
                    throw new Error('Each conditionalParams object needs to contain' +
                        'at least one condition');
                }
            }
        }
        if (typeof this.data?.dataSource?.params !== 'undefined') {
            params = { ...this.data.dataSource.params, ...params };
            // If params has dynamic params from route url - search and replace them
            const parsedParams = {};
            for (const param in this.route.snapshot?.params) {
                if (param.indexOf('.') >= 0) {
                    // if key is dot notation use it as destination path
                    this.helper.setObjectPath(param, this.route.snapshot?.params[param], parsedParams);
                }
                else {
                    parsedParams[param] = this.route.snapshot?.params[param];
                }
            }
            const stringParams = JSON.stringify(params);
            let replaced = stringParams;
            for (const key of Object.keys(parsedParams)) {
                let search = ':' + key;
                let value;
                if (typeof parsedParams[key] === 'object') {
                    search = `\"${search}\"`;
                    value = JSON.stringify(parsedParams[key]);
                }
                else {
                    value = parsedParams[key];
                }
                replaced = replaced.replace(new RegExp(search, 'g'), value);
            }
            if (typeof this.parentForm !== 'undefined') {
                // let replaced = JSON.stringify(params);
                const rootForm = this.parentForm.root;
                const formValues = rootForm.getRawValue();
                for (const p in formValues) {
                    if (typeof formValues[p] !== 'undefined') {
                        replaced = replaced.replace('{' + p + '}', formValues[p]);
                    }
                }
            }
            // match dot notation placeholders and process them as paths
            const dotNotRegex = /{[\w.-]+}/g;
            const matches = stringParams.match(dotNotRegex);
            if (Array.isArray(matches)) {
                for (const match of matches) {
                    let value;
                    const path = match.replace('{', '').replace('}', '').split('.');
                    switch (path[0]) {
                        case 'route':
                        case 'state':
                        case 'session':
                        case 'cache':
                            value = this.getArrayPath.get(null, path);
                            break;
                        default:
                            value = this.getArrayPath.get(this.data.dataObject, path);
                            break;
                    }
                    if (typeof value === 'object') {
                        replaced = replaced.replace(`\"${match}\"`, JSON.stringify(value));
                    }
                    else {
                        replaced = replaced.replace(match, value);
                    }
                }
            }
            if (replaced !== '') {
                params = { ...JSON.parse(replaced) };
            }
            for (const param in params) {
                if (params[param]) {
                    if (typeof params[param] === "string" &&
                        params[param].startsWith(":")) {
                        // remove any remaining placeholders
                        delete params[param];
                    }
                    if (param.indexOf(".") >= 0) {
                        // if key is still a dot notation use it as destination path
                        this.helper.setObjectPath(param, params[param], params);
                        delete params[param];
                    }
                }
            }
            if (Object.keys(queryParams).length > 0) {
                if (typeof params.mutations !== 'undefined'
                    && typeof queryParams.mutations !== 'undefined') {
                    const cloned = [...params.mutations];
                    params = { ...params, ...queryParams };
                    params.mutations = this.query.mergeMutations(cloned, queryParams.mutations);
                }
                else {
                    params = { ...params, ...queryParams };
                }
            }
        }
        else if (Object.keys(queryParams).length > 0) {
            params = { ...params, ...queryParams };
        }
        let apiSource;
        if (this.data.dataSource) {
            this.loading = true;
            this.dataService = this.api.getService(this.data.dataSource.service);
        }
        apiSource = (this.dataService &&
            this.dataService[this.data.dataSource.method](params, page)) || of(null);
        // apiSource - data for the table comes from an api call
        // this.data.dataObject - data for the table comes from parent component
        apiSource.pipe(combineLatestWith(of(this.data.dataObject).pipe(map(data => {
            return {
                result: {
                    data
                }
            };
        }))), take$1(1), map(res => {
            if (res[0]) {
                return res[0];
            }
            else {
                return res[1];
            }
        }))
            .subscribe((response) => {
            const rowKey = this.data.dataSource?.rowsResponseKey ||
                this.data.rowsResponseKey;
            if (typeof rowKey !== 'undefined') {
                this.rows = response.result.data[rowKey];
            }
            else {
                this.rows = response.result.data;
            }
            // Add extracted columns directly to the table columns in header and rows;
            if (typeof this.data.extractedColumns !== 'undefined'
                && typeof this.rows[0] !== 'undefined') {
                /* Define empty columns on every request
                /* so they can be updated from the response
                */
                const cols = [];
                const listedCols = [];
                // Loop through the configuration of the columns for extraction
                for (const extracted of this.data.extractedColumns) {
                    const extractedPath = this.getArrayPath.get(this.rows[0], extracted.extract);
                    // tslint:disable-next-line: forin
                    for (const col in extractedPath) {
                        if (!isNaN(Number(col))) {
                            throw new Error('Extract must be an object not an array');
                        }
                        const path = [];
                        let components = [];
                        let extractPath;
                        if (typeof extracted.extract === 'string') {
                            extractPath = [extracted.extract];
                        }
                        else {
                            extractPath = extracted.extract;
                        }
                        if (extracted.path !== '') {
                            // if path is specified use it in extracted column path
                            path.push(...extracted.extract, col, extracted.path);
                            if (extracted.components) {
                                components = [...extracted.components];
                            }
                        }
                        else {
                            // if path is not specified extracted column path should also be empty
                            // so that it will receive the entire row
                            if (extracted.components) {
                                // if extracted column should render components, add the column
                                // path to the component path so it can find its value
                                for (const component of extracted.components) {
                                    const clonedComponent = JSON.parse(JSON.stringify(component));
                                    if (typeof clonedComponent.data.path === 'string') {
                                        clonedComponent.data.path = [clonedComponent.data.path];
                                    }
                                    clonedComponent.data.path = [
                                        ...extracted.extract,
                                        col,
                                        ...clonedComponent.data.path
                                    ];
                                    // if component has actions walk them and adjust paths
                                    if (clonedComponent.data.events) {
                                        const events = clonedComponent.data.events;
                                        // tslint:disable-next-line: forin
                                        for (const event in events) {
                                            // tslint:disable-next-line: forin
                                            for (const action in events[event]) {
                                                if (typeof events[event][action].path === 'undefined') {
                                                    events[event][action].path = [
                                                        ...extracted.extract,
                                                        col
                                                    ];
                                                }
                                                else {
                                                    if (typeof events[event][action].path === 'string') {
                                                        events[event][action].path = [events[event][action].path];
                                                    }
                                                    events[event][action].path = [
                                                        ...extracted.extract,
                                                        col,
                                                        ...events[event][action].path
                                                    ];
                                                }
                                                if (typeof events[event][action].params !== 'undefined') {
                                                    // tslint:disable-next-line: forin
                                                    for (const param in events[event][action].params) {
                                                        if (events[event][action].params[param] === '{column}') {
                                                            events[event][action].params[param] = col;
                                                        }
                                                        if (typeof events[event][action].params[param] === 'object'
                                                            && typeof events[event][action].params[param]['{column}'] !== 'undefined') {
                                                            events[event][action].params[param][col] =
                                                                events[event][action].params[param]['{column}'];
                                                            delete events[event][action].params[param]['{column}'];
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    components.push(clonedComponent);
                                }
                            }
                        }
                        // add extracted column to table columns
                        const listedCol = {
                            path,
                            label: col,
                            sort: extracted.sort,
                            extract: true
                        };
                        if (components.length > 0) {
                            listedCol.components = components;
                        }
                        listedCols.push(listedCol);
                        cols.push(col);
                    }
                }
                this.cols = [...this.cols, ...cols];
                this.listedColumns = [...this.listedColumns, ...listedCols];
            }
            // tslint:disable-next-line: forin
            for (const i in this.rows) {
                this.rowSelection[i] = false;
                this.checkbox[i] = {
                    color: 'primary',
                    checked: false,
                    indeterminate: false,
                    disabled: false
                };
            }
            if (response.result.meta) {
                this.length = response.result.meta.total;
                this.pageSize = response.result.meta.per_page;
            }
            this.applyFilter([]);
            this.loading = false;
            if (typeof this.data.loaded === 'function') {
                if (!this.data.loadedParams) {
                    this.data.loadedParams = {};
                }
                this.data.loadedParams.event = 'loaded';
                this.data.loadedParams.dataObject = response.result.data;
                const result = this.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take$1(1)).subscribe();
                }
            }
        });
    }
    rowNgClass(row) {
        const classes = [];
        if (row && typeof this.data.rowConditionalClasses !== 'undefined') {
            for (const condition of this.data.rowConditionalClasses) {
                if (this.evaluator.exec(row, condition)) {
                    classes.push(condition.class);
                }
            }
        }
        return classes;
    }
    sort(column = null, clear = false) {
        if (column) {
            this.query.updateQueryUrl(this.route.snapshot);
            const mutations = [];
            const params = [];
            params.push(column.path);
            if (!clear) {
                params.push([this.query.getSortDirection(column.path, column)]);
            }
            mutations.push({
                constraint: column.constraint,
                params
            });
            const queryParams = this.query.prepareQueryParams('sort', { mutations });
            this.router.navigate([], {
                queryParams
            }).then(() => {
                this.query.updateQueryUrl(this.route.snapshot);
            });
        }
        else {
            this.router.navigate([]).then(() => {
                this.query.updateQueryUrl(this.route.snapshot);
            });
        }
    }
    selectRow(index) {
        if (this.rowSelection[index] === true) {
            this.rowSelection[index] = false;
        }
        else {
            this.rowSelection[index] = true;
        }
    }
    selectAllRows(params) {
        // tslint:disable-next-line: forin
        for (const i in this.rowSelection) {
            this.rowSelection[i] = params.checked;
            this.checkbox[i].checked = params.checked;
        }
    }
    reset() {
        const queryParams = this.query.prepareQueryParams('mutate');
        this.router.navigate([], { queryParams })
            .then(() => {
            this.query.updateQueryUrl(this.route.snapshot);
        });
    }
    mutate(params) {
        if (typeof params.actionParams !== 'undefined'
            && Object.keys(params.actionParams).length > 0) {
            const queryParams = this.query.prepareQueryParams(params.id, params.actionParams);
            if (queryParams[params.id] !== '') {
                this.router.navigate([], {
                    queryParams
                }).then(() => {
                    this.query.updateQueryUrl(this.route.snapshot);
                });
            }
        }
    }
    delete(params, rowIndex) {
        if (typeof rowIndex !== 'undefined' || this.rowSelection.indexOf(true) >= 0) {
            const alertDialog = this.dialog.open(AlertDialogComponent, {
                data: {
                    title: this.language.getLabel(params.confirmDialog.title),
                    text: this.language.getLabel(params.confirmDialog.text),
                    button: this.language.getLabel(params.label)
                }
            });
            alertDialog.afterClosed().pipe(take$1(1)).subscribe((result) => {
                if (result === 'confirm') {
                    if (typeof rowIndex !== 'undefined') {
                        this.api.getService(params.apiCall.service)[params.apiCall.method]({
                            id: this.rows[rowIndex].id
                        })
                            .pipe(take$1(1))
                            .subscribe(() => {
                            this.rows.splice(rowIndex, 1);
                            this.table.renderRows();
                        });
                    }
                    else {
                        const selectedRows = this.rowSelection.filter(val => val === true);
                        if (selectedRows.length > 0) {
                            let i = 1;
                            const firstIndex = this.rowSelection.indexOf(true);
                            while (this.rowSelection.indexOf(true) >= 0) {
                                const index = this.rowSelection.indexOf(true);
                                if (i === 1 && selectedRows.length > 1) {
                                    this.api.getService(params.apiCall.service)[params.apiCall.method]({
                                        id: this.rows[index].id,
                                        batch: {
                                            name: 'delete'
                                        }
                                    });
                                }
                                else if (i === selectedRows.length && selectedRows.length > 1) {
                                    this.api.getService(params.apiCall.service)[params.apiCall.method]({
                                        id: this.rows[index].id,
                                        batch: {
                                            name: 'delete',
                                            stage: 'finish'
                                        }
                                    })
                                        .pipe(take$1(1))
                                        .subscribe(() => {
                                        this.rows.splice(firstIndex, selectedRows.length);
                                        this.table.renderRows();
                                    });
                                }
                                else if (i > 1 && i !== selectedRows.length) {
                                    this.api.getService(params.apiCall.service)[params.apiCall.method]({
                                        id: this.rows[index].id,
                                        batch: {
                                            name: 'delete'
                                        }
                                    });
                                }
                                else {
                                    this.api.getService(params.apiCall.service)[params.apiCall.method]({
                                        id: this.rows[index].id
                                    }).pipe(take$1(1))
                                        .subscribe(() => {
                                        this.rows.splice(firstIndex, selectedRows.length);
                                        this.table.renderRows();
                                    });
                                }
                                this.rowSelection[index] = false;
                                this.checkbox[index].checked = false;
                                i++;
                            }
                        }
                    }
                }
            });
        }
    }
    apiCall(params) {
        const alertDialog = this.dialog.open(AlertDialogComponent, {
            data: {
                title: this.language.getLabel(params.confirmDialog.title),
                text: this.language.getLabel(params.confirmDialog.text),
                button: this.language.getLabel(params.label)
            }
        });
        alertDialog.afterClosed().pipe(take$1(1)).subscribe((result) => {
            this.api
                .getService(params.apiCall.service)[params.apiCall.method](params.apiCall.params)
                .pipe(take$1(1))
                .subscribe();
        });
    }
    rowClick(event) {
        const target = event.target;
        const row = target.closest('tr');
        const rowClick = row.getElementsByClassName('on-row-click');
        if (rowClick.length > 0) {
            const clickTarget = rowClick[0];
            clickTarget.click();
        }
    }
    handlePaginator(e) {
        const page = e.pageIndex + 1;
        this.router.navigate([], { queryParams: { page }, queryParamsHandling: 'merge' })
            .then(() => {
            this.query.updateQueryUrl(this.route.snapshot);
        });
    }
    applyFilter(paramsArray) {
        if (typeof paramsArray === 'undefined' ||
            !paramsArray.length) {
            this.filteredRows = this.rows;
            return;
        }
        this.filteredRows = this.rows.filter(row => {
            const isFound = [];
            for (const params of paramsArray) {
                const prop = params.data;
                const op = params.op;
                const value = params.value;
                const path = params.path || [];
                if (row.hasOwnProperty(prop) &&
                    this.evaluator.exec(row[prop], {
                        op,
                        value,
                        path
                    })) {
                    isFound.push(true);
                }
                else {
                    isFound.push(false);
                }
            }
            return isFound.indexOf(false) === -1;
        });
    }
    selectedRow(param) {
        const key = Object.keys(param)[0];
        this.rowSelection = this.filteredRows.filter(r => {
            return r[key] === param[key];
        });
    }
    deleteByObjectId({ id }) {
        this.rows = this.rows.filter(r => {
            return r.id !== id;
        });
        this.filteredRows = this.filteredRows.filter(r => {
            return r.id !== id;
        });
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
TableListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TableListComponent, deps: [{ token: ApiService }, { token: i3$3.MatDialog }, { token: EventBusService }, { token: LanguageService }, { token: PermissionsService }, { token: QueryService }, { token: i1.Router }, { token: GetArrayPathService }, { token: TransformService }, { token: i1.ActivatedRoute }, { token: EvalService }, { token: CommunicationService }, { token: HelperService }], target: i0.ɵɵFactoryTarget.Component });
TableListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TableListComponent, selector: "app-table-list", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "table", first: true, predicate: MatTable, descendants: true }, { propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }], ngImport: i0, template: "<div class=\"mat-elevation-z8\" *ngIf=\"willLoad\" [id]=\"data.id\" [class]=\"data.class\">\r\n  <div class=\"responsiveTable\">\r\n    <div *ngIf=\"data.showLoading && loading\" class=\"loading\">\r\n      <app-loader></app-loader>\r\n    </div>\r\n    <table class=\"table-list\" mat-table [dataSource]=\"filteredRows\" matSort>\r\n      <ng-container matColumnDef=\"select\">\r\n        <th mat-header-cell *matHeaderCellDef></th>\r\n        <td mat-cell *matCellDef=\"let item; let index = index\">\r\n          <app-checkbox\r\n            [data]=\"checkbox[index]\"\r\n            (click)=\"selectRow(index)\"\r\n          ></app-checkbox>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <ng-container\r\n        [matColumnDef]=\"column.label || column.id\"\r\n        *ngFor=\"let column of listedColumns\"\r\n        [sticky]=\"column.sticky || null\"\r\n      >\r\n        <th\r\n          mat-header-cell\r\n          *matHeaderCellDef\r\n          mat-sort-header\r\n          [class]=\"column.class\"\r\n        >\r\n          <span *ngIf=\"!column.sort\">{{\r\n            language.getLabel(column.label)\r\n          }}</span>\r\n          <a\r\n            *ngIf=\"column.sort\"\r\n            (click)=\"sort(column.sort)\"\r\n            href=\"javascript:void(0)\"\r\n          >\r\n            <mat-icon\r\n              class=\"sortIcon\"\r\n              *ngIf=\"\r\n                query.getCurrentSortDir(column.sort.path) == 'desc'\r\n              \"\r\n              >arrow_drop_down</mat-icon\r\n            >\r\n            <mat-icon\r\n              class=\"sortIcon\"\r\n              *ngIf=\"\r\n                query.getCurrentSortDir(column.sort.path) == 'asc'\r\n              \"\r\n              >arrow_drop_up</mat-icon\r\n            >\r\n            {{ language.getLabel(column.label) }}\r\n          </a>\r\n          <a\r\n            *ngIf=\"\r\n              column.sort &&\r\n              query.getCurrentSortDir(column.sort.path) != null\r\n            \"\r\n            (click)=\"sort(column.sort, true)\"\r\n            href=\"javascript:void(0)\"\r\n          >\r\n            <mat-icon class=\"sortIcon\">clear</mat-icon>\r\n          </a>\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let item\" [class]=\"column.class\">\r\n          <!-- If column contains component(s) -->\r\n          <ng-container *ngIf=\"\r\n            column.components\r\n            && (\r\n              (column.condition && evaluator.exec(item, column.condition))\r\n              || !column.condition\r\n            )\">\r\n            <app-slot\r\n              [items]=\"column.components\"\r\n              [componentValue]=\"item | getArrayPath: column.path\"\r\n              [parentForm]=\"parentForm\"\r\n              style=\"display: block; width: 100%; height: 100%\"\r\n            ></app-slot>\r\n          </ng-container>\r\n          <!--If the column contains just a value-->\r\n          <ng-container\r\n            *ngIf=\"\r\n              !column.components &&\r\n              !column.link &&\r\n              !column.externalLink &&\r\n              !column.download\r\n            \"\r\n          >\r\n            <!-- content from multiple response paths -->\r\n            <ng-container *ngIf=\"column.multipath\">\r\n              <ng-container *ngFor=\"let path of column.multipath; let isLast = last\">\r\n                <span *ngIf=\"!column.transform\">\r\n                  {{ item | getArrayPath: path }}\r\n                </span>\r\n                <span *ngIf=\"column.transform\">\r\n                  {{\r\n                    transformData.transform(\r\n                      item | getArrayPath: path,\r\n                      column.transform\r\n                    )\r\n                  }}\r\n                </span>\r\n                <ng-container\r\n                *ngIf=\"column.multipathGlue && !isLast && (item | getArrayPath : path)\"\r\n                >{{ column.multipathGlue }}</ng-container\r\n              >\r\n              </ng-container>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"!column.multipath\">\r\n              <ng-container *ngIf=\"column.html\">\r\n                <div\r\n                  class=\"html-preview\"\r\n                  [innerHTML]=\"item | getArrayPath: column.path | safeHtml\"\r\n                ></div>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"!column.html\">\r\n                <span *ngIf=\"!column.transform\">{{\r\n                  item | getArrayPath: column.path\r\n                }}</span>\r\n                <span *ngIf=\"column.transform\">{{\r\n                  transformData.transform(\r\n                    item | getArrayPath: column.path,\r\n                    column.transform\r\n                  )\r\n                }}</span>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n          <!--If the column has action and the action is link-->\r\n          <a\r\n            *ngIf=\"column.link && !column.components\"\r\n            [routerLink]=\"item | link: column.link\"\r\n          >\r\n            <span *ngIf=\"!column.transform\">{{\r\n              item | getArrayPath: column.path\r\n            }}</span>\r\n            <span *ngIf=\"column.transform\">{{\r\n              transformData.transform(\r\n                item | getArrayPath: column.path,\r\n                column.transform\r\n              )\r\n            }}</span>\r\n          </a>\r\n          <a\r\n            *ngIf=\"column.externalLink && !column.components\"\r\n            [href]=\"item | link: column.externalLink\"\r\n          >\r\n            <span *ngIf=\"!column.transform\">{{\r\n              item | getArrayPath: column.path\r\n            }}</span>\r\n            <span *ngIf=\"column.transform\">{{\r\n              transformData.transform(\r\n                item | getArrayPath: column.path,\r\n                column.transform\r\n              )\r\n            }}</span>\r\n          </a>\r\n          <ng-container *ngIf=\"column.download\">\r\n            <app-download [data]=\"item\"></app-download>\r\n          </ng-container>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"actionColAppended\" matColumnDef=\"action\">\r\n        <th mat-header-cell class=\"last-table-header\" *matHeaderCellDef></th>\r\n        <td\r\n          mat-cell\r\n          *matCellDef=\"let item; let index = index\"\r\n          class=\"action-link\"\r\n        >\r\n          <ng-container *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[item | link: action.link, item.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <span *ngIf=\"action.id == 'delete'\">\r\n                <button\r\n                  [attr.alt]=\"language.getLabel('App_delete')\"\r\n                  [attr.title]=\"language.getLabel('App_delete')\"\r\n                  mat-icon-button\r\n                  (click)=\"delete(action, index)\"\r\n                >\r\n                  <mat-icon class=\"delete-icon\">{{\r\n                    language.getLabel(\"delete\")\r\n                  }}</mat-icon>\r\n                </button>\r\n              </span>\r\n            </ng-container>\r\n          </ng-container>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"cols\"></tr>\r\n      <tr\r\n        class=\"users-table-rows\"\r\n        mat-row\r\n        *matRowDef=\"let row; columns: cols\"\r\n        (click)=\"rowClick($event)\"\r\n        [class]=\"rowNgClass(row)\"\r\n      ></tr>\r\n    </table>\r\n  </div>\r\n  <mat-paginator\r\n    *ngIf=\"pageSize\"\r\n    showFirstLastButtons\r\n    [length]=\"length\"\r\n    [pageSize]=\"pageSize\"\r\n    (page)=\"handlePaginator($event)\"\r\n  >\r\n  </mat-paginator>\r\n</div>\r\n", styles: ["@import\"https://fonts.googleapis.com/icon?family=Material+Icons\";.mat-elevation-z8{margin-top:15px}.mat-elevation-z8 .role-heading{text-align:center}.mat-elevation-z8 .example-header{display:flex;justify-content:space-between}.mat-elevation-z8 .responsiveTable{display:block;width:100%;overflow:auto}.mat-elevation-z8 .responsiveTable .mat-column-select{min-width:20px;width:20px}.mat-elevation-z8 .responsiveTable .mat-header-cell{font-size:15px}.mat-elevation-z8 .responsiveTable .mat-header-cell,.mat-elevation-z8 .responsiveTable .mat-cell{min-width:80px;box-sizing:border-box}.mat-elevation-z8 .responsiveTable .mat-header-cell:not(:first-of-type),.mat-elevation-z8 .responsiveTable .mat-cell:not(:first-of-type){padding-left:5px;padding-right:5px}.mat-elevation-z8 .responsiveTable .mat-header-cell.mat-column-action,.mat-elevation-z8 .responsiveTable .mat-cell.mat-column-action{min-width:auto;text-align:right}.mat-elevation-z8 .responsiveTable .mat-table{width:100%}.mat-elevation-z8 .responsiveTable .mat-table .edit-icon,.mat-elevation-z8 .responsiveTable .mat-table .delete-icon,.mat-elevation-z8 .responsiveTable .mat-table .list-icon{color:#000000de}.mat-elevation-z8 .responsiveTable .mat-table .perm-identity-icon{color:#1b69a8}.mat-elevation-z8 .responsiveTable .mat-table .sortIcon{position:relative;top:8px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth200{min-width:200px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth150{min-width:150px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth100{min-width:100px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth80{min-width:80px}.mat-elevation-z8 .responsiveTable .mat-table ::ng-deep .row-icon{min-width:48px;width:48px}.mat-elevation-z8 .responsiveTable .loading{position:absolute;inset:0;background-color:#ffffff4d;z-index:5000;display:flex;justify-content:center;padding-top:8px}.mat-elevation-z8 .last-table-header{text-align:end}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: CheckboxComponent, selector: "app-checkbox", inputs: ["data", "parentForm"] }, { kind: "component", type: DownloadComponent, selector: "app-download", inputs: ["data"] }, { kind: "component", type: i16$1.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i16$1.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i16$1.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i16$1.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i16$1.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i16$1.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i16$1.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i16$1.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i16$1.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i16$1.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i10$3.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: LoaderComponent, selector: "app-loader", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: LinkPipe, name: "link" }, { kind: "pipe", type: SafeHtmlPipe, name: "safeHtml" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TableListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-table-list', template: "<div class=\"mat-elevation-z8\" *ngIf=\"willLoad\" [id]=\"data.id\" [class]=\"data.class\">\r\n  <div class=\"responsiveTable\">\r\n    <div *ngIf=\"data.showLoading && loading\" class=\"loading\">\r\n      <app-loader></app-loader>\r\n    </div>\r\n    <table class=\"table-list\" mat-table [dataSource]=\"filteredRows\" matSort>\r\n      <ng-container matColumnDef=\"select\">\r\n        <th mat-header-cell *matHeaderCellDef></th>\r\n        <td mat-cell *matCellDef=\"let item; let index = index\">\r\n          <app-checkbox\r\n            [data]=\"checkbox[index]\"\r\n            (click)=\"selectRow(index)\"\r\n          ></app-checkbox>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <ng-container\r\n        [matColumnDef]=\"column.label || column.id\"\r\n        *ngFor=\"let column of listedColumns\"\r\n        [sticky]=\"column.sticky || null\"\r\n      >\r\n        <th\r\n          mat-header-cell\r\n          *matHeaderCellDef\r\n          mat-sort-header\r\n          [class]=\"column.class\"\r\n        >\r\n          <span *ngIf=\"!column.sort\">{{\r\n            language.getLabel(column.label)\r\n          }}</span>\r\n          <a\r\n            *ngIf=\"column.sort\"\r\n            (click)=\"sort(column.sort)\"\r\n            href=\"javascript:void(0)\"\r\n          >\r\n            <mat-icon\r\n              class=\"sortIcon\"\r\n              *ngIf=\"\r\n                query.getCurrentSortDir(column.sort.path) == 'desc'\r\n              \"\r\n              >arrow_drop_down</mat-icon\r\n            >\r\n            <mat-icon\r\n              class=\"sortIcon\"\r\n              *ngIf=\"\r\n                query.getCurrentSortDir(column.sort.path) == 'asc'\r\n              \"\r\n              >arrow_drop_up</mat-icon\r\n            >\r\n            {{ language.getLabel(column.label) }}\r\n          </a>\r\n          <a\r\n            *ngIf=\"\r\n              column.sort &&\r\n              query.getCurrentSortDir(column.sort.path) != null\r\n            \"\r\n            (click)=\"sort(column.sort, true)\"\r\n            href=\"javascript:void(0)\"\r\n          >\r\n            <mat-icon class=\"sortIcon\">clear</mat-icon>\r\n          </a>\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let item\" [class]=\"column.class\">\r\n          <!-- If column contains component(s) -->\r\n          <ng-container *ngIf=\"\r\n            column.components\r\n            && (\r\n              (column.condition && evaluator.exec(item, column.condition))\r\n              || !column.condition\r\n            )\">\r\n            <app-slot\r\n              [items]=\"column.components\"\r\n              [componentValue]=\"item | getArrayPath: column.path\"\r\n              [parentForm]=\"parentForm\"\r\n              style=\"display: block; width: 100%; height: 100%\"\r\n            ></app-slot>\r\n          </ng-container>\r\n          <!--If the column contains just a value-->\r\n          <ng-container\r\n            *ngIf=\"\r\n              !column.components &&\r\n              !column.link &&\r\n              !column.externalLink &&\r\n              !column.download\r\n            \"\r\n          >\r\n            <!-- content from multiple response paths -->\r\n            <ng-container *ngIf=\"column.multipath\">\r\n              <ng-container *ngFor=\"let path of column.multipath; let isLast = last\">\r\n                <span *ngIf=\"!column.transform\">\r\n                  {{ item | getArrayPath: path }}\r\n                </span>\r\n                <span *ngIf=\"column.transform\">\r\n                  {{\r\n                    transformData.transform(\r\n                      item | getArrayPath: path,\r\n                      column.transform\r\n                    )\r\n                  }}\r\n                </span>\r\n                <ng-container\r\n                *ngIf=\"column.multipathGlue && !isLast && (item | getArrayPath : path)\"\r\n                >{{ column.multipathGlue }}</ng-container\r\n              >\r\n              </ng-container>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"!column.multipath\">\r\n              <ng-container *ngIf=\"column.html\">\r\n                <div\r\n                  class=\"html-preview\"\r\n                  [innerHTML]=\"item | getArrayPath: column.path | safeHtml\"\r\n                ></div>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"!column.html\">\r\n                <span *ngIf=\"!column.transform\">{{\r\n                  item | getArrayPath: column.path\r\n                }}</span>\r\n                <span *ngIf=\"column.transform\">{{\r\n                  transformData.transform(\r\n                    item | getArrayPath: column.path,\r\n                    column.transform\r\n                  )\r\n                }}</span>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n          <!--If the column has action and the action is link-->\r\n          <a\r\n            *ngIf=\"column.link && !column.components\"\r\n            [routerLink]=\"item | link: column.link\"\r\n          >\r\n            <span *ngIf=\"!column.transform\">{{\r\n              item | getArrayPath: column.path\r\n            }}</span>\r\n            <span *ngIf=\"column.transform\">{{\r\n              transformData.transform(\r\n                item | getArrayPath: column.path,\r\n                column.transform\r\n              )\r\n            }}</span>\r\n          </a>\r\n          <a\r\n            *ngIf=\"column.externalLink && !column.components\"\r\n            [href]=\"item | link: column.externalLink\"\r\n          >\r\n            <span *ngIf=\"!column.transform\">{{\r\n              item | getArrayPath: column.path\r\n            }}</span>\r\n            <span *ngIf=\"column.transform\">{{\r\n              transformData.transform(\r\n                item | getArrayPath: column.path,\r\n                column.transform\r\n              )\r\n            }}</span>\r\n          </a>\r\n          <ng-container *ngIf=\"column.download\">\r\n            <app-download [data]=\"item\"></app-download>\r\n          </ng-container>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"actionColAppended\" matColumnDef=\"action\">\r\n        <th mat-header-cell class=\"last-table-header\" *matHeaderCellDef></th>\r\n        <td\r\n          mat-cell\r\n          *matCellDef=\"let item; let index = index\"\r\n          class=\"action-link\"\r\n        >\r\n          <ng-container *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[item | link: action.link, item.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <span *ngIf=\"action.id == 'delete'\">\r\n                <button\r\n                  [attr.alt]=\"language.getLabel('App_delete')\"\r\n                  [attr.title]=\"language.getLabel('App_delete')\"\r\n                  mat-icon-button\r\n                  (click)=\"delete(action, index)\"\r\n                >\r\n                  <mat-icon class=\"delete-icon\">{{\r\n                    language.getLabel(\"delete\")\r\n                  }}</mat-icon>\r\n                </button>\r\n              </span>\r\n            </ng-container>\r\n          </ng-container>\r\n        </td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"cols\"></tr>\r\n      <tr\r\n        class=\"users-table-rows\"\r\n        mat-row\r\n        *matRowDef=\"let row; columns: cols\"\r\n        (click)=\"rowClick($event)\"\r\n        [class]=\"rowNgClass(row)\"\r\n      ></tr>\r\n    </table>\r\n  </div>\r\n  <mat-paginator\r\n    *ngIf=\"pageSize\"\r\n    showFirstLastButtons\r\n    [length]=\"length\"\r\n    [pageSize]=\"pageSize\"\r\n    (page)=\"handlePaginator($event)\"\r\n  >\r\n  </mat-paginator>\r\n</div>\r\n", styles: ["@import\"https://fonts.googleapis.com/icon?family=Material+Icons\";.mat-elevation-z8{margin-top:15px}.mat-elevation-z8 .role-heading{text-align:center}.mat-elevation-z8 .example-header{display:flex;justify-content:space-between}.mat-elevation-z8 .responsiveTable{display:block;width:100%;overflow:auto}.mat-elevation-z8 .responsiveTable .mat-column-select{min-width:20px;width:20px}.mat-elevation-z8 .responsiveTable .mat-header-cell{font-size:15px}.mat-elevation-z8 .responsiveTable .mat-header-cell,.mat-elevation-z8 .responsiveTable .mat-cell{min-width:80px;box-sizing:border-box}.mat-elevation-z8 .responsiveTable .mat-header-cell:not(:first-of-type),.mat-elevation-z8 .responsiveTable .mat-cell:not(:first-of-type){padding-left:5px;padding-right:5px}.mat-elevation-z8 .responsiveTable .mat-header-cell.mat-column-action,.mat-elevation-z8 .responsiveTable .mat-cell.mat-column-action{min-width:auto;text-align:right}.mat-elevation-z8 .responsiveTable .mat-table{width:100%}.mat-elevation-z8 .responsiveTable .mat-table .edit-icon,.mat-elevation-z8 .responsiveTable .mat-table .delete-icon,.mat-elevation-z8 .responsiveTable .mat-table .list-icon{color:#000000de}.mat-elevation-z8 .responsiveTable .mat-table .perm-identity-icon{color:#1b69a8}.mat-elevation-z8 .responsiveTable .mat-table .sortIcon{position:relative;top:8px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth200{min-width:200px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth150{min-width:150px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth100{min-width:100px}.mat-elevation-z8 .responsiveTable .mat-table .minWidth80{min-width:80px}.mat-elevation-z8 .responsiveTable .mat-table ::ng-deep .row-icon{min-width:48px;width:48px}.mat-elevation-z8 .responsiveTable .loading{position:absolute;inset:0;background-color:#ffffff4d;z-index:5000;display:flex;justify-content:center;padding-top:8px}.mat-elevation-z8 .last-table-header{text-align:end}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: i3$3.MatDialog }, { type: EventBusService }, { type: LanguageService }, { type: PermissionsService }, { type: QueryService }, { type: i1.Router }, { type: GetArrayPathService }, { type: TransformService }, { type: i1.ActivatedRoute }, { type: EvalService }, { type: CommunicationService }, { type: HelperService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], table: [{
                type: ViewChild,
                args: [MatTable]
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }] } });

class TableListModule {
    constructor(routing) {
        routing.mapComponent('TableListComponent', TableListComponent);
    }
}
TableListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TableListModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
TableListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TableListModule, declarations: [TableListComponent], imports: [CommonModule, i1.RouterModule, PrimitiveModule,
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        PipesModule,
        SlotModule,
        CustomRouterLinkDirective,
        LoaderModule] });
TableListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TableListModule, imports: [CommonModule,
        RouterModule.forChild([]),
        PrimitiveModule,
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        PipesModule,
        SlotModule,
        LoaderModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TableListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TableListComponent],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        PrimitiveModule,
                        MatTableModule,
                        MatIconModule,
                        MatButtonModule,
                        MatPaginatorModule,
                        MatSlideToggleModule,
                        PipesModule,
                        SlotModule,
                        CustomRouterLinkDirective,
                        LoaderModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var tableList_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   TableListModule: TableListModule
});

const dragConfig = {
    pointerDirectionChangeThreshold: 10
};
class TreeListComponent {
    constructor(api, dialog, eventBus, router, permissionService, comm, language, query, transformData, route, getArrayPath, cdRef, platformId) {
        this.api = api;
        this.dialog = dialog;
        this.eventBus = eventBus;
        this.router = router;
        this.permissionService = permissionService;
        this.comm = comm;
        this.language = language;
        this.query = query;
        this.transformData = transformData;
        this.route = route;
        this.getArrayPath = getArrayPath;
        this.cdRef = cdRef;
        this.platformId = platformId;
        this.destroyed$ = new Subject();
        this.willLoad = false;
        this.buttons = [];
        this.minListHeight = 0;
        this.nextInternalId = 0;
        this.formsRegister = [];
        this.dragging = false;
        this.dragPlaceholderOffsetStep = 40;
        this.dragPlaceholderOffset = 0;
        this.dragPlaceholderHeight = 60;
        this.pauseInterval = false;
        this.treeControl = new FlatTreeControl(node => node.level, node => node.expandable);
        this.transformer = (node, level) => {
            if (typeof node.internalId === 'undefined' || node.internalId === null) {
                if (node.id) {
                    node.internalId = node.id;
                    if (this.nextInternalId < node.id + 1) {
                        this.nextInternalId = node.id + 1;
                    }
                }
                else {
                    node.internalId = this.nextInternalId++;
                }
            }
            if (typeof node.internalParent === 'undefined' || node.internalParent === null) {
                node.internalParent = node.parent_id;
            }
            if (typeof node.children === 'undefined') {
                node.children = [];
            }
            node.expandable = !!node.children && node.children.length > 0;
            node.level = level;
            return node;
        };
        this.hasChild = (_, node) => node.expandable;
        this.query = query;
        this.treeFlattener = new MatTreeFlattener(this.transformer, node => node.level, node => node.expandable, node => node.children);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    }
    ngOnInit() {
        this.selfRef = this;
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed$))
                .subscribe((message) => {
                this.comm.processMessage(message, this);
            });
        }
        this.query.updateQueryUrl(this.route.snapshot);
        if (typeof this.data.actions !== 'undefined') {
            this.data.actions.forEach((action, key) => {
                if (!this.permissionService.checkPermissions(action)) {
                    this.data.actions[key].denied = true;
                }
                else {
                    this.data.actions[key].denied = false;
                }
            });
        }
        if (typeof this.data.padding === 'undefined') {
            this.data.padding = 40;
        }
        if (this.data.actions) {
            for (const action of this.data.actions) {
                if (action.actionBar && this.permissionService.checkPermissions(action)) {
                    // register action in action bar(s)
                    if (typeof action.mutationIndex !== 'undefined'
                        && typeof this.data.dataSource.params !== 'undefined'
                        && typeof this.data.dataSource.params.mutations !== 'undefined') {
                        action.actionBar.data.value
                            = this.data.dataSource.params.mutations[action.mutationIndex];
                    }
                    action.event = action.id + '_TreeList_' + this.data.instanceId;
                    this.eventBus.fire(new Event('addToActionBar', action));
                    this.eventBus.on(action.event)
                        .pipe(takeUntil$1(this.destroyed$))
                        .subscribe((actionData) => {
                        if (typeof this[actionData.id] !== 'undefined') {
                            this[actionData.id](actionData);
                        }
                    });
                }
            }
        }
        if (this.data.loadOnInit === false && Object.keys(this.query.queryUrl).length === 0) {
            return;
        }
        this.load();
        if (typeof this.data.submit !== 'undefined') {
            this.buttons = [{
                    color: 'primary',
                    type: 'mat-flat-button',
                    label: this.language.getLabel('App_cancel'),
                    class: ''
                },
                {
                    color: 'primary',
                    type: 'mat-flat-button',
                    label: this.language.getLabel('App_submit'),
                    class: 'ml-1',
                    click: this.submit.bind(this)
                }];
        }
        // Refresh data if url param has been changed
        this.route.params.pipe(takeUntil$1(this.destroyed$)).subscribe(params => {
            if (this.urlParams && this.urlParams !== params) {
                this.load();
            }
            this.urlParams = params;
        });
    }
    load(queryParams = null, page = null) {
        this.willLoad = true;
        // prepare actions
        if (!page && typeof this.route.snapshot.queryParams.page !== 'undefined') {
            // Set paging to query if comes from url
            page = this.route.snapshot.queryParams.page;
        }
        let params = {};
        if (!queryParams) {
            queryParams = this.query.prepareParams();
        }
        if (typeof this.data.dataSource.params !== 'undefined') {
            params = { ...this.data.dataSource.params };
            // If params has dynamic params from route url - search and replace them
            this.route.params.pipe(take(1)).subscribe(urlParams => {
                this.urlParams = urlParams;
                const stringParams = JSON.stringify(params);
                let replaced = stringParams;
                for (const key of Object.keys(urlParams)) {
                    const search = ':' + key;
                    replaced = replaced.replace(new RegExp(search, 'g'), urlParams[key]);
                }
                if (replaced !== '') {
                    params = { ...JSON.parse(replaced) };
                }
            });
            if (Object.keys(queryParams).length > 0) {
                if (typeof params.mutations !== 'undefined'
                    && typeof queryParams.mutations !== 'undefined') {
                    const cloned = [...params.mutations];
                    params = { ...params, ...queryParams };
                    params.mutations = this.query.mergeMutations(cloned, queryParams.mutations);
                }
                else {
                    params = { ...params, ...queryParams };
                }
            }
        }
        else if (Object.keys(queryParams).length > 0) {
            params = queryParams;
        }
        let trigger;
        if (typeof this.data.dataSource.interval === 'number'
            && !isPlatformServer(this.platformId)) {
            if (typeof this.data.dataSource.immediately) {
                trigger = timer(0, this.data.dataSource.interval);
            }
            else {
                trigger = interval(this.data.dataSource.interval);
            }
        }
        else {
            trigger = of(1);
        }
        if (this.trigger) {
            this.trigger.unsubscribe();
        }
        this.trigger = trigger.pipe(takeUntil$1(this.destroyed$), switchMap(value => this.pauseInterval ? EMPTY : of(value))).subscribe(() => {
            const dataSource = JSON.parse(JSON.stringify(this.data.dataSource));
            const dataService = this.api.getService(dataSource.service);
            dataService[dataSource.method](params, page)
                .pipe(take(1))
                .subscribe((response) => {
                if (typeof dataSource.path !== 'undefined') {
                    this.dataSource.data = this.getArrayPath.get(response.result.data, dataSource.path);
                }
                else {
                    this.dataSource.data = response.result.data;
                }
                if (dataSource.ifEmptyAddItem && this.dataSource.data.length <= 0) {
                    this.dataSource.data = [{}];
                }
                if (typeof this.data.selected !== 'undefined') {
                    if (typeof this.data.selected.value === 'string'
                        && this.data.selected.value.indexOf(':') === 0) {
                        this.route.params.pipe(take(1)).subscribe(urlParams => {
                            const selectedValue = urlParams[this.data.selected.value.replace(':', '')];
                            this.getTreeSelection(selectedValue);
                        });
                    }
                    else {
                        this.getTreeSelection(this.data.selected.value);
                    }
                }
                // execute loaded event handler if form is in action
                if (typeof this.data.loaded === 'function') {
                    const loadedParams = {
                        event: 'loaded'
                    };
                    loadedParams.event = 'loaded';
                    if (this.dataSource.data) {
                        loadedParams.dataObject = this.dataSource.data;
                    }
                    const result = this.data.loaded(loadedParams);
                    if (result instanceof Observable) {
                        result.pipe(take(1)).subscribe();
                    }
                }
            });
            if (dataSource.interval && dataSource.intervalLoader === false) {
                dataSource.params.noLoader = true;
            }
        });
    }
    getTreeSelection(selectedValue, selection = [], i = 0) {
        const node = this.treeControl.dataNodes.filter(item => {
            return String(item[this.data.selected.property]) === String(selectedValue);
        });
        if (i > 0) {
            this.treeControl.expansionModel.select(node[0]);
        }
        if (node[0].internalParent !== null) {
            i++;
            this.getTreeSelection(node[0].internalParent, selection, i);
        }
    }
    isNodeSelected(node) {
        if (typeof this.data.selected !== 'undefined') {
            if (typeof this.data.selected.value === 'string'
                && this.data.selected.value.indexOf(':') === 0) {
                const value = this.urlParams[this.data.selected.value.replace(':', '')];
                return String(node[this.data.selected.property]) === String(value);
            }
            else {
                return String(node[this.data.selected.property]) === String(this.data.selected.value);
            }
        }
        return false;
    }
    makeEmptyNode(node, propsToKeep) {
        const emptyNode = {};
        for (const prop in node) {
            if (typeof node[prop] !== 'undefined') {
                switch (prop) {
                    case 'expandable':
                        emptyNode[prop] = false;
                        break;
                    default:
                        if (propsToKeep.indexOf(prop) >= 0) {
                            emptyNode[prop] = node[prop];
                            break;
                        }
                        if (typeof node[prop] === 'object') {
                            if (Array.isArray(node[prop])) {
                                emptyNode[prop] = [];
                                break;
                            }
                            if (node[prop] === null) {
                                emptyNode[prop] = null;
                                break;
                            }
                            emptyNode[prop] = {};
                        }
                        emptyNode[prop] = null;
                        break;
                }
            }
        }
        emptyNode.internalId = this.nextInternalId++;
        return emptyNode;
    }
    findNodeRecursive(tree, node, compare = ['id', 'id']) {
        let foundNode = tree.find(n => n[compare[0]] === node[compare[1]]);
        if (typeof foundNode === 'undefined') {
            const expandables = tree.filter(n => n.children.length > 0);
            for (const expandable of expandables) {
                foundNode = this.findNodeRecursive(expandable.children, node, compare);
                if (typeof foundNode !== 'undefined') {
                    break;
                }
            }
        }
        return foundNode;
    }
    rebuild(data) {
        this.minListHeight = this.dropListRef.nativeElement.offsetHeight;
        this.formsRegister = [];
        this.dataSource.data = [];
        this.dataSource.data = data;
        setTimeout(() => {
            this.minListHeight = 0;
        }, 0);
    }
    addNode(node, propsToKeep = [], addChild = false) {
        const newNode = this.makeEmptyNode(node, propsToKeep);
        const data = this.dataSource.data;
        if (addChild) {
            // add child node
            if (typeof node.internalId !== 'undefined' && node.internalId !== null) {
                newNode.internalParent = node.internalId;
            }
            else {
                newNode.internalParent = node.id;
            }
            newNode.parent_id = node.id;
            node.children.push(newNode);
            // make parent expandable and expand
            node.expandable = true;
            this.treeControl.expansionModel.select(node);
        }
        else {
            if (node.parent_id) {
                // find parent
                const parent = this.findNodeRecursive(data, node, ['id', 'parent_id']);
                // add sibling at next position in the parent
                parent.children.splice(parent.children.indexOf(node) + 1, 0, newNode);
            }
            else if (typeof node.internalParent !== 'undefined'
                && node.internalParent !== null
                && node.internalParent !== '') {
                const parent = this.findNodeRecursive(data, node, ['internalId', 'internalParent']);
                newNode.internalParent = parent.internalId;
                parent.children.splice(parent.children.indexOf(node) + 1, 0, newNode);
            }
            else {
                const position = data.indexOf(node);
                if (position >= 0) {
                    // add root level sibling at next position
                    data.splice(position + 1, 0, newNode);
                }
                else {
                    // add root level sibling at the end
                    data.push(newNode);
                }
            }
        }
        this.rebuild(data);
    }
    removeNode(node) {
        const data = this.dataSource.data;
        if (node.parent_id) {
            const parent = this.findNodeRecursive(data, node, ['id', 'parent_id']);
            parent.children.splice(parent.children.indexOf(node), 1);
            if (parent.children.length <= 0) {
                parent.expandable = false;
            }
        }
        else if (typeof node.internalParent !== 'undefined'
            && node.internalParent !== null
            && node.internalParent !== '') {
            const parent = this.findNodeRecursive(data, node, ['internalId', 'internalParent']);
            parent.children.splice(parent.children.indexOf(node), 1);
            if (parent.children.length <= 0) {
                parent.expandable = false;
            }
        }
        else {
            data.splice(data.indexOf(node), 1);
        }
        this.rebuild(data);
    }
    mutate(params) {
        if (typeof params.actionParams !== 'undefined'
            && Object.keys(params.actionParams).length > 0) {
            const queryParams = this.query.prepareQueryParams(params.id, params.actionParams);
            if (queryParams[params.id] !== '') {
                this.router.navigate([], {
                    queryParams
                }).then(() => {
                    this.query.updateQueryUrl(this.route.snapshot);
                    this.load();
                });
            }
        }
    }
    delete(params, id) {
        const alertDialog = this.dialog.open(AlertDialogComponent, {
            data: {
                title: this.language.getLabel(params.confirmDialog.title),
                text: this.language.getLabel(params.confirmDialog.text),
                button: this.language.getLabel(params.label)
            }
        });
        alertDialog.afterClosed().pipe(take(1)).subscribe((result) => {
            if (result === 'confirm') {
                this.api.getService(params.apiCall.service)[params.apiCall.method]({
                    id
                })
                    .pipe(take(1))
                    .subscribe(() => {
                    this.load();
                });
            }
        });
    }
    dragStarted(event) {
        if (!this.data.draggable) {
            return;
        }
        this.dragging = true;
        this.draggingNode = event.source.data;
        this.dragPlaceholderHeight = event.source.element.nativeElement.offsetHeight;
        if (event.source.data.expandable) {
            this.treeControl.expansionModel.deselect(event.source.data);
        }
    }
    dragMoved(event) {
        this.dragDirection = event.delta.y;
    }
    dragEnded(event) {
        if (!this.data.draggable) {
            return;
        }
        this.dragPlaceholderOffset = 0;
        this.dragging = false;
    }
    hover(node) {
        if (!this.data.draggable && node !== this.draggingNode) {
            return;
        }
        if (this.dragging) {
            if (node.level > 0) {
                this.dragPlaceholderOffset = (node.level * this.dragPlaceholderOffsetStep) + this.dragPlaceholderOffsetStep;
            }
            else {
                this.dragPlaceholderOffset = 0;
            }
            switch (this.dragDirection) {
                case 1:
                    if (node.expandable && this.treeControl.isExpanded(node)) {
                        this.dragPlaceholderOffset = ((node.level + 1) * this.dragPlaceholderOffsetStep) + this.dragPlaceholderOffsetStep;
                    }
                    break;
            }
            this.dragLastHoveredNode = node;
        }
    }
    hoverEnd() { }
    drop(event) {
        if (!this.data.draggable
            || !this.dragLastHoveredNode) {
            return;
        }
        const data = this.dataSource.data;
        // remove node from old index
        if (event.item.data.internalParent) {
            // when node is a child
            const parent = this.findNodeRecursive(data, event.item.data, ['internalId', 'internalParent']);
            const removeAtIdx = parent.children
                .findIndex(n => n.internalId === event.item.data.internalId);
            parent.children.splice(removeAtIdx, 1);
        }
        else {
            // when root node
            const removeAtIdx = data.findIndex(n => n.internalId === event.item.data.internalId);
            data.splice(removeAtIdx, 1);
        }
        // insert node at new position
        switch (this.dragDirection) {
            case -1:
                // when dragging up
                if (this.dragLastHoveredNode.internalParent) {
                    // insert after child node
                    const parent = this.findNodeRecursive(data, this.dragLastHoveredNode, ['internalId', 'internalParent']);
                    const insertAtIdx = parent.children
                        .findIndex(n => n.internalId === this.dragLastHoveredNode.internalId);
                    event.item.data.internalParent = parent.internalId;
                    parent.children.splice(insertAtIdx, 0, event.item.data);
                }
                else {
                    // insert after root node
                    const insertAtIdx = data
                        .findIndex(n => n.internalId === this.dragLastHoveredNode.internalId);
                    event.item.data.internalParent = null;
                    data.splice(insertAtIdx, 0, event.item.data);
                }
                break;
            case 1:
                // when dragging down
                if (this.dragLastHoveredNode.expandable
                    && this.treeControl.isExpanded(this.dragLastHoveredNode)) {
                    // insert into expanded last hovered node
                    event.item.data.internalParent = this.dragLastHoveredNode.internalId;
                    this.dragLastHoveredNode.children.splice(0, 0, event.item.data);
                }
                else {
                    if (this.dragLastHoveredNode.internalParent) {
                        // insert after child node
                        const parent = this.findNodeRecursive(data, this.dragLastHoveredNode, ['internalId', 'internalParent']);
                        const insertAtIdx = parent.children
                            .findIndex(n => n.internalId === this.dragLastHoveredNode.internalId) + 1;
                        event.item.data.internalParent = parent.internalId;
                        parent.children.splice(insertAtIdx, 0, event.item.data);
                    }
                    else {
                        // insert after root node
                        const insertAtIdx = data
                            .findIndex(n => n.internalId === this.dragLastHoveredNode.internalId) + 1;
                        event.item.data.internalParent = null;
                        data.splice(insertAtIdx, 0, event.item.data);
                    }
                }
                break;
        }
        this.dragLastHoveredNode = null;
        this.rebuild(data);
    }
    registerForm(form, component) {
        this.formsRegister.push(form);
    }
    submit() {
        // validate registered forms if any
        let invalid = false;
        for (const form of this.formsRegister) {
            if (!form.valid) {
                invalid = true;
                form.markAllAsTouched();
            }
        }
        if (invalid) {
            return;
        }
        if (this.data.submit) {
            // submit
            let params;
            if (typeof this.data.submit.params !== 'undefined') {
                // If params has dynamic params from route url - search and replace them
                this.route.params.pipe(take(1)).subscribe(urlParams => {
                    this.urlParams = urlParams;
                    const stringParams = JSON.stringify(this.data.submit.params);
                    let replaced = stringParams;
                    for (const key of Object.keys(urlParams)) {
                        const search = ':' + key;
                        replaced = replaced.replace(new RegExp(search, 'g'), urlParams[key]);
                    }
                    if (replaced !== '') {
                        params = { ...JSON.parse(replaced) };
                    }
                });
                params.items = this.dataSource.data;
            }
            else {
                params = { items: this.dataSource.data };
            }
            const dataService = this.api.getService(this.data.submit.service);
            dataService[this.data.submit.method](params)
                .pipe(take(1))
                .subscribe((response) => {
            });
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
TreeListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TreeListComponent, deps: [{ token: ApiService }, { token: i3$3.MatDialog }, { token: EventBusService }, { token: i1.Router }, { token: PermissionsService }, { token: CommunicationService }, { token: LanguageService }, { token: QueryService }, { token: TransformService }, { token: i1.ActivatedRoute }, { token: GetArrayPathService }, { token: i0.ChangeDetectorRef }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
TreeListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TreeListComponent, selector: "app-tree-list", inputs: { data: "data", parentForm: "parentForm" }, providers: [GetArrayPathPipe, { provide: CDK_DRAG_CONFIG, useValue: dragConfig }], viewQueries: [{ propertyName: "dropListRef", first: true, predicate: ["dropList"], descendants: true }], ngImport: i0, template: "<div\r\n  #dropList\r\n  [ngStyle]=\"{ 'min-height.px': minListHeight }\"\r\n  class=\"mat-elevation-z8\"\r\n>\r\n  <mat-tree\r\n    [dataSource]=\"dataSource\"\r\n    [treeControl]=\"treeControl\"\r\n    cdkDropList\r\n    (cdkDropListDropped)=\"drop($event)\"\r\n  >\r\n    <!-- This is the tree node template for leaf nodes -->\r\n    <mat-tree-node\r\n      *matTreeNodeDef=\"let node\"\r\n      matTreeNodePadding\r\n      [matTreeNodePaddingIndent]=\"data.padding\"\r\n      [ngClass]=\"{ selected: isNodeSelected(node) }\"\r\n      cdkDrag\r\n      [cdkDragDisabled]=\"!data.draggable\"\r\n      [cdkDragData]=\"node\"\r\n      (cdkDragStarted)=\"dragStarted($event)\"\r\n      (cdkDragMoved)=\"dragMoved($event)\"\r\n      (cdkDragEnded)=\"dragEnded($event)\"\r\n      (mouseenter)=\"hover(node)\"\r\n      (mouseleave)=\"hoverEnd()\"\r\n      cdkDragLockAxis=\"y\"\r\n    >\r\n      <div class=\"node-content\">\r\n        <!-- use a disabled button to provide padding for tree leaf -->\r\n        <button mat-icon-button disabled *ngIf=\"data.btnPaddingEnabled\"></button>\r\n        <ng-container *ngIf=\"!data.components\">\r\n          <div *ngIf=\"!data.link\">{{ node.title }}</div>\r\n          <a\r\n            *ngIf=\"data.link && !data.queryParams\"\r\n            [routerLink]=\"node | link: data.link\"\r\n          >\r\n            {{ node.title }}\r\n          </a>\r\n        </ng-container>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"node\"\r\n          [parentForm]=\"parentForm\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n        <div class=\"treeActions\" *ngIf=\"data.actions\">\r\n          <span *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[action.link, node.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <button\r\n                [attr.alt]=\"language.getLabel('App_delete')\"\r\n                [attr.title]=\"language.getLabel('App_delete')\"\r\n                *ngIf=\"action.id == 'delete'\"\r\n                mat-icon-button\r\n                (click)=\"delete(action, node.id)\"\r\n              >\r\n                <mat-icon class=\"delete-icon\">{{\r\n                  language.getLabel(\"delete\")\r\n                }}</mat-icon>\r\n              </button>\r\n              <app-slot\r\n                *ngIf=\"action.component\"\r\n                [items]=\"[action]\"\r\n                [componentValue]=\"node | getArrayPath: action.path\"\r\n                [parentForm]=\"parentForm\"\r\n                style=\"display: block; width: 100%; height: 100%\"\r\n              ></app-slot>\r\n            </ng-container>\r\n          </span>\r\n        </div>\r\n        <!-- drag and drop placeholder template -->\r\n        <div\r\n          *cdkDragPlaceholder\r\n          class=\"drag-placeholder\"\r\n          [ngStyle]=\"{\r\n            'margin-left.px': dragPlaceholderOffset,\r\n            'height.px': dragPlaceholderHeight\r\n          }\"\r\n        ></div>\r\n      </div>\r\n    </mat-tree-node>\r\n    <!-- This is the tree node template for expandable nodes -->\r\n    <mat-tree-node\r\n      *matTreeNodeDef=\"let node; when: hasChild\"\r\n      matTreeNodePadding\r\n      [matTreeNodePaddingIndent]=\"data.padding\"\r\n      [ngClass]=\"{ selected: isNodeSelected(node) }\"\r\n      cdkDrag\r\n      [cdkDragDisabled]=\"!data.draggable\"\r\n      [cdkDragData]=\"node\"\r\n      (cdkDragStarted)=\"dragStarted($event)\"\r\n      (cdkDragMoved)=\"dragMoved($event)\"\r\n      (cdkDragEnded)=\"dragEnded($event)\"\r\n      (mouseenter)=\"hover(node)\"\r\n      (mouseleave)=\"hoverEnd()\"\r\n      cdkDragLockAxis=\"y\"\r\n    >\r\n      <div class=\"node-content\">\r\n        <button\r\n          mat-icon-button\r\n          matTreeNodeToggle\r\n          [attr.aria-label]=\"'Toggle ' + node.name\"\r\n        >\r\n          <mat-icon class=\"mat-icon-rtl-mirror\">\r\n            {{ treeControl.isExpanded(node) ? \"expand_more\" : \"chevron_right\" }}\r\n          </mat-icon>\r\n        </button>\r\n        <ng-container *ngIf=\"!data.components\">\r\n          <div *ngIf=\"!data.link\">{{ node.title }}</div>\r\n          <div *ngIf=\"data.link && data.noActionForExpandable\">{{ node.title }}</div>\r\n          <a\r\n            *ngIf=\"data.link && !data.queryParams && !data.noActionForExpandable\"\r\n            [routerLink]=\"node | link: data.link\"\r\n          >\r\n            {{ node.title }}\r\n          </a>\r\n        </ng-container>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"node\"\r\n          [parentForm]=\"parentForm\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n        <div class=\"treeActions\">\r\n          <span *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied && !data.noActionForExpandable\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[action.link, node.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <button\r\n                [attr.alt]=\"language.getLabel('App_delete')\"\r\n                [attr.title]=\"language.getLabel('App_delete')\"\r\n                *ngIf=\"action.id == 'delete'\"\r\n                mat-icon-button\r\n                (click)=\"delete(action, node.id)\"\r\n              >\r\n                <mat-icon class=\"delete-icon\">{{\r\n                  language.getLabel(\"delete\")\r\n                }}</mat-icon>\r\n              </button>\r\n              <app-slot\r\n                *ngIf=\"action.component\"\r\n                [items]=\"[action]\"\r\n                [componentValue]=\"node | getArrayPath: action.path\"\r\n                [parentForm]=\"parentForm\"\r\n                style=\"display: block; width: 100%; height: 100%\"\r\n              ></app-slot>\r\n            </ng-container>\r\n          </span>\r\n        </div>\r\n        <div\r\n          *cdkDragPlaceholder\r\n          class=\"drag-placeholder\"\r\n          [ngStyle]=\"{\r\n            'margin-left.px': dragPlaceholderOffset,\r\n            'height.px': dragPlaceholderHeight\r\n          }\"\r\n        ></div>\r\n      </div>\r\n    </mat-tree-node>\r\n  </mat-tree>\r\n  <div class=\"row\" *ngIf=\"data.submit\">\r\n    <div class=\"col text-center\">\r\n      <app-button [data]=\"button\" *ngFor=\"let button of buttons\"></app-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".mat-elevation-z8{margin-top:15px}mat-tree .mat-tree-node{border-bottom-color:#0000001f;border-bottom-width:1px;border-bottom-style:solid;background-color:#e9e9e9}mat-tree .mat-tree-node .node-content{display:flex;align-items:center;min-height:48px;flex:1;background-color:#fff}mat-tree .edit-icon{color:#000000de}mat-tree .delete-icon{color:#000000de}mat-tree .list-icon{color:#000000de}mat-tree .treeActions{display:flex;margin-left:auto;order:2}mat-tree .drag-placeholder{border:3px dotted grey}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: ButtonComponent, selector: "app-button", inputs: ["data", "parentForm", "parentComponent"] }, { kind: "directive", type: i13$1.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { kind: "directive", type: i13$1.MatTreeNodePadding, selector: "[matTreeNodePadding]", inputs: ["matTreeNodePadding", "matTreeNodePaddingIndent"] }, { kind: "directive", type: i13$1.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { kind: "component", type: i13$1.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { kind: "directive", type: i13$1.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "directive", type: i11$2.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i11$2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i11$2.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }, { kind: "pipe", type: LinkPipe, name: "link" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TreeListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-tree-list', providers: [GetArrayPathPipe, { provide: CDK_DRAG_CONFIG, useValue: dragConfig }], template: "<div\r\n  #dropList\r\n  [ngStyle]=\"{ 'min-height.px': minListHeight }\"\r\n  class=\"mat-elevation-z8\"\r\n>\r\n  <mat-tree\r\n    [dataSource]=\"dataSource\"\r\n    [treeControl]=\"treeControl\"\r\n    cdkDropList\r\n    (cdkDropListDropped)=\"drop($event)\"\r\n  >\r\n    <!-- This is the tree node template for leaf nodes -->\r\n    <mat-tree-node\r\n      *matTreeNodeDef=\"let node\"\r\n      matTreeNodePadding\r\n      [matTreeNodePaddingIndent]=\"data.padding\"\r\n      [ngClass]=\"{ selected: isNodeSelected(node) }\"\r\n      cdkDrag\r\n      [cdkDragDisabled]=\"!data.draggable\"\r\n      [cdkDragData]=\"node\"\r\n      (cdkDragStarted)=\"dragStarted($event)\"\r\n      (cdkDragMoved)=\"dragMoved($event)\"\r\n      (cdkDragEnded)=\"dragEnded($event)\"\r\n      (mouseenter)=\"hover(node)\"\r\n      (mouseleave)=\"hoverEnd()\"\r\n      cdkDragLockAxis=\"y\"\r\n    >\r\n      <div class=\"node-content\">\r\n        <!-- use a disabled button to provide padding for tree leaf -->\r\n        <button mat-icon-button disabled *ngIf=\"data.btnPaddingEnabled\"></button>\r\n        <ng-container *ngIf=\"!data.components\">\r\n          <div *ngIf=\"!data.link\">{{ node.title }}</div>\r\n          <a\r\n            *ngIf=\"data.link && !data.queryParams\"\r\n            [routerLink]=\"node | link: data.link\"\r\n          >\r\n            {{ node.title }}\r\n          </a>\r\n        </ng-container>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"node\"\r\n          [parentForm]=\"parentForm\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n        <div class=\"treeActions\" *ngIf=\"data.actions\">\r\n          <span *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[action.link, node.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <button\r\n                [attr.alt]=\"language.getLabel('App_delete')\"\r\n                [attr.title]=\"language.getLabel('App_delete')\"\r\n                *ngIf=\"action.id == 'delete'\"\r\n                mat-icon-button\r\n                (click)=\"delete(action, node.id)\"\r\n              >\r\n                <mat-icon class=\"delete-icon\">{{\r\n                  language.getLabel(\"delete\")\r\n                }}</mat-icon>\r\n              </button>\r\n              <app-slot\r\n                *ngIf=\"action.component\"\r\n                [items]=\"[action]\"\r\n                [componentValue]=\"node | getArrayPath: action.path\"\r\n                [parentForm]=\"parentForm\"\r\n                style=\"display: block; width: 100%; height: 100%\"\r\n              ></app-slot>\r\n            </ng-container>\r\n          </span>\r\n        </div>\r\n        <!-- drag and drop placeholder template -->\r\n        <div\r\n          *cdkDragPlaceholder\r\n          class=\"drag-placeholder\"\r\n          [ngStyle]=\"{\r\n            'margin-left.px': dragPlaceholderOffset,\r\n            'height.px': dragPlaceholderHeight\r\n          }\"\r\n        ></div>\r\n      </div>\r\n    </mat-tree-node>\r\n    <!-- This is the tree node template for expandable nodes -->\r\n    <mat-tree-node\r\n      *matTreeNodeDef=\"let node; when: hasChild\"\r\n      matTreeNodePadding\r\n      [matTreeNodePaddingIndent]=\"data.padding\"\r\n      [ngClass]=\"{ selected: isNodeSelected(node) }\"\r\n      cdkDrag\r\n      [cdkDragDisabled]=\"!data.draggable\"\r\n      [cdkDragData]=\"node\"\r\n      (cdkDragStarted)=\"dragStarted($event)\"\r\n      (cdkDragMoved)=\"dragMoved($event)\"\r\n      (cdkDragEnded)=\"dragEnded($event)\"\r\n      (mouseenter)=\"hover(node)\"\r\n      (mouseleave)=\"hoverEnd()\"\r\n      cdkDragLockAxis=\"y\"\r\n    >\r\n      <div class=\"node-content\">\r\n        <button\r\n          mat-icon-button\r\n          matTreeNodeToggle\r\n          [attr.aria-label]=\"'Toggle ' + node.name\"\r\n        >\r\n          <mat-icon class=\"mat-icon-rtl-mirror\">\r\n            {{ treeControl.isExpanded(node) ? \"expand_more\" : \"chevron_right\" }}\r\n          </mat-icon>\r\n        </button>\r\n        <ng-container *ngIf=\"!data.components\">\r\n          <div *ngIf=\"!data.link\">{{ node.title }}</div>\r\n          <div *ngIf=\"data.link && data.noActionForExpandable\">{{ node.title }}</div>\r\n          <a\r\n            *ngIf=\"data.link && !data.queryParams && !data.noActionForExpandable\"\r\n            [routerLink]=\"node | link: data.link\"\r\n          >\r\n            {{ node.title }}\r\n          </a>\r\n        </ng-container>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"node\"\r\n          [parentForm]=\"parentForm\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n        <div class=\"treeActions\">\r\n          <span *ngFor=\"let action of data.actions\">\r\n            <ng-container *ngIf=\"!action.denied && !data.noActionForExpandable\">\r\n              <a\r\n                *ngIf=\"action.link && action.id != 'delete'\"\r\n                [routerLink]=\"[action.link, node.id]\"\r\n              >\r\n                <button\r\n                  mat-icon-button\r\n                  [attr.alt]=\"language.getLabel(action.name)\"\r\n                  [attr.title]=\"language.getLabel(action.name)\"\r\n                >\r\n                  <mat-icon [ngClass]=\"action.id + '-icon'\">{{\r\n                    action.id\r\n                  }}</mat-icon>\r\n                </button>\r\n              </a>\r\n              <button\r\n                [attr.alt]=\"language.getLabel('App_delete')\"\r\n                [attr.title]=\"language.getLabel('App_delete')\"\r\n                *ngIf=\"action.id == 'delete'\"\r\n                mat-icon-button\r\n                (click)=\"delete(action, node.id)\"\r\n              >\r\n                <mat-icon class=\"delete-icon\">{{\r\n                  language.getLabel(\"delete\")\r\n                }}</mat-icon>\r\n              </button>\r\n              <app-slot\r\n                *ngIf=\"action.component\"\r\n                [items]=\"[action]\"\r\n                [componentValue]=\"node | getArrayPath: action.path\"\r\n                [parentForm]=\"parentForm\"\r\n                style=\"display: block; width: 100%; height: 100%\"\r\n              ></app-slot>\r\n            </ng-container>\r\n          </span>\r\n        </div>\r\n        <div\r\n          *cdkDragPlaceholder\r\n          class=\"drag-placeholder\"\r\n          [ngStyle]=\"{\r\n            'margin-left.px': dragPlaceholderOffset,\r\n            'height.px': dragPlaceholderHeight\r\n          }\"\r\n        ></div>\r\n      </div>\r\n    </mat-tree-node>\r\n  </mat-tree>\r\n  <div class=\"row\" *ngIf=\"data.submit\">\r\n    <div class=\"col text-center\">\r\n      <app-button [data]=\"button\" *ngFor=\"let button of buttons\"></app-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".mat-elevation-z8{margin-top:15px}mat-tree .mat-tree-node{border-bottom-color:#0000001f;border-bottom-width:1px;border-bottom-style:solid;background-color:#e9e9e9}mat-tree .mat-tree-node .node-content{display:flex;align-items:center;min-height:48px;flex:1;background-color:#fff}mat-tree .edit-icon{color:#000000de}mat-tree .delete-icon{color:#000000de}mat-tree .list-icon{color:#000000de}mat-tree .treeActions{display:flex;margin-left:auto;order:2}mat-tree .drag-placeholder{border:3px dotted grey}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: i3$3.MatDialog }, { type: EventBusService }, { type: i1.Router }, { type: PermissionsService }, { type: CommunicationService }, { type: LanguageService }, { type: QueryService }, { type: TransformService }, { type: i1.ActivatedRoute }, { type: GetArrayPathService }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], dropListRef: [{
                type: ViewChild,
                args: ['dropList']
            }] } });

class TreeListModule {
    constructor(routing) {
        routing.mapComponent('TreeListComponent', TreeListComponent);
    }
}
TreeListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TreeListModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
TreeListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TreeListModule, declarations: [TreeListComponent], imports: [CommonModule, i1.RouterModule, PrimitiveModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        PipesModule,
        SlotModule,
        DragDropModule,
        CustomRouterLinkDirective] });
TreeListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TreeListModule, imports: [CommonModule,
        RouterModule.forChild([]),
        PrimitiveModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        PipesModule,
        SlotModule,
        DragDropModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TreeListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TreeListComponent],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        PrimitiveModule,
                        MatTreeModule,
                        MatIconModule,
                        MatButtonModule,
                        MatPaginatorModule,
                        MatSlideToggleModule,
                        PipesModule,
                        SlotModule,
                        DragDropModule,
                        CustomRouterLinkDirective
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var treeList_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   TreeListModule: TreeListModule
});

class LogoutComponent extends BaseComponent {
    constructor(router, permissions, cache) {
        super();
        this.router = router;
        this.permissions = permissions;
        this.cache = cache;
    }
    ngOnInit() {
        // TODO remove once apiCall is not used anymore
        if (this.data.apiCall) {
            this.data.dataSource = this.data.apiCall;
        }
        super.ngOnInit();
        let loadedCallback;
        if (typeof this.data.loaded === 'function') {
            const that = this;
            loadedCallback = (response) => {
                this.permissions.checkSession();
                this.cache.set('auth', false);
                let loadedParams = {
                    event: 'loaded',
                    dataObject: response.data
                };
                const result = that.data.loaded(loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            };
        }
        else {
            loadedCallback = () => {
                this.permissions.checkSession();
                this.cache.set('auth', false);
            };
        }
        const errorCallback = () => {
            this.permissions.checkSession();
            this.cache.set('auth', false);
        };
        this.load(loadedCallback, errorCallback);
        if (typeof this.data.delay === 'undefined') {
            this.data.delay = 5;
        }
        this.countdown = interval(1000)
            .pipe(map$1(i => this.data.delay - i), take(this.data.delay + 1));
        this.countdown.pipe(takeUntil$1(this.destroyed)).subscribe({
            complete: () => {
                this.router.navigateByUrl(decodeURI(this.data.redirectTo));
            }
        });
    }
}
LogoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LogoutComponent, deps: [{ token: i1.Router }, { token: PermissionsService }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Component });
LogoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: LogoutComponent, selector: "app-logout", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<p [innerHtml]=\"language.getLabel('App_logging_out_message')\"></p>\r\n<p *ngIf=\"countdown | async as timeLeft\">\r\n  {{ language.getLabel(\"App_logging_out_countdown\", [timeLeft]) }}\r\n</p>\r\n", styles: ["p{margin:0 1rem;font-size:1.5rem}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LogoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-logout', template: "<p [innerHtml]=\"language.getLabel('App_logging_out_message')\"></p>\r\n<p *ngIf=\"countdown | async as timeLeft\">\r\n  {{ language.getLabel(\"App_logging_out_countdown\", [timeLeft]) }}\r\n</p>\r\n", styles: ["p{margin:0 1rem;font-size:1.5rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: PermissionsService }, { type: CacheService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class LogoutModule {
    constructor(routing) {
        routing.mapComponent('LogoutComponent', LogoutComponent);
    }
}
LogoutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LogoutModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
LogoutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: LogoutModule, declarations: [LogoutComponent], imports: [CommonModule] });
LogoutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LogoutModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LogoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        LogoutComponent
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var logout_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   LogoutModule: LogoutModule
});

class MenuPanelComponent {
    constructor(scrollService) {
        this.scrollService = scrollService;
    }
    ngOnInit() {
        if (typeof this.data.xPosition === 'undefined') {
            this.data.xPosition = 'after';
        }
        if (typeof this.data.class !== 'undefined') {
            this.menu.overlayPanelClass = this.data.class;
        }
    }
}
MenuPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuPanelComponent, deps: [{ token: ScrollService }], target: i0.ɵɵFactoryTarget.Component });
MenuPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MenuPanelComponent, selector: "app-menu-panel", inputs: { data: "data", parentItem: "parentItem", menuItems: "menuItems" }, providers: [LinkPipe], viewQueries: [{ propertyName: "menu", first: true, predicate: ["menu"], descendants: true, static: true }], ngImport: i0, template: "<mat-menu #menu overlapTrigger=\"false\" [xPosition]=\"data.xPosition\" [class]=\"data.class\">\r\n  <ng-container *ngFor=\"let menuItem of menuItems[parentItem.id]\">\r\n    <ng-container *ngIf=\"menuItems[menuItem.id]\">\r\n      <!-- HAS SUB MENU -->\r\n      <button\r\n        mat-menu-item\r\n        [routerLink]=\"menuItem.url\"\r\n        [matMenuTriggerFor]=\"innerPanel.menu\"\r\n      >\r\n        {{ menuItem.title }}\r\n      </button>\r\n      <app-menu-panel\r\n        #innerPanel\r\n        [data]=\"{\r\n          link: data.link,\r\n          class: data.class,\r\n          xPosition: data.xPosition,\r\n          scrollToElement: data.scrollToElement\r\n        }\"\r\n        [menuItems]=\"menuItems\"\r\n        [parentItem]=\"menuItem\"\r\n      ></app-menu-panel>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!menuItems[menuItem.id]\">\r\n      <!-- NO SUB MENU -->\r\n      <ng-container *ngIf=\"!data.scrollToElement\">\r\n        <button mat-menu-item [routerLink]=\"menuItem.url\">\r\n          {{ menuItem.title }}\r\n        </button>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"data.scrollToElement\">\r\n        <button mat-menu-item (click)=\"scrollService.scrollToElement(menuItem.url)\">\r\n          {{ menuItem.title }}\r\n        </button>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</mat-menu>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i8$3.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i8$3.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i8$3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: MenuPanelComponent, selector: "app-menu-panel", inputs: ["data", "parentItem", "menuItems"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-menu-panel', providers: [LinkPipe], template: "<mat-menu #menu overlapTrigger=\"false\" [xPosition]=\"data.xPosition\" [class]=\"data.class\">\r\n  <ng-container *ngFor=\"let menuItem of menuItems[parentItem.id]\">\r\n    <ng-container *ngIf=\"menuItems[menuItem.id]\">\r\n      <!-- HAS SUB MENU -->\r\n      <button\r\n        mat-menu-item\r\n        [routerLink]=\"menuItem.url\"\r\n        [matMenuTriggerFor]=\"innerPanel.menu\"\r\n      >\r\n        {{ menuItem.title }}\r\n      </button>\r\n      <app-menu-panel\r\n        #innerPanel\r\n        [data]=\"{\r\n          link: data.link,\r\n          class: data.class,\r\n          xPosition: data.xPosition,\r\n          scrollToElement: data.scrollToElement\r\n        }\"\r\n        [menuItems]=\"menuItems\"\r\n        [parentItem]=\"menuItem\"\r\n      ></app-menu-panel>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!menuItems[menuItem.id]\">\r\n      <!-- NO SUB MENU -->\r\n      <ng-container *ngIf=\"!data.scrollToElement\">\r\n        <button mat-menu-item [routerLink]=\"menuItem.url\">\r\n          {{ menuItem.title }}\r\n        </button>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"data.scrollToElement\">\r\n        <button mat-menu-item (click)=\"scrollService.scrollToElement(menuItem.url)\">\r\n          {{ menuItem.title }}\r\n        </button>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</mat-menu>\r\n" }]
        }], ctorParameters: function () { return [{ type: ScrollService }]; }, propDecorators: { data: [{
                type: Input
            }], parentItem: [{
                type: Input
            }], menuItems: [{
                type: Input
            }], menu: [{
                type: ViewChild,
                args: ['menu', { static: true }]
            }] } });

class MenuComponent {
    constructor(api, eventBus, router, permissionSevice, link, getArrayPath, scrollService, urlSerializer) {
        this.api = api;
        this.eventBus = eventBus;
        this.router = router;
        this.permissionSevice = permissionSevice;
        this.link = link;
        this.getArrayPath = getArrayPath;
        this.scrollService = scrollService;
        this.urlSerializer = urlSerializer;
        this.topId = 0;
        this.destroyed$ = new Subject();
    }
    ngOnInit() {
        if (typeof this.menuItems === 'undefined') {
            this.menuItems = {};
            this.menuItems[this.topId] = [];
            const dataService = this.api.getService(this.data.dataSource.service);
            dataService[this.data.dataSource.method](this.data.dataSource.params)
                .pipe(take(1))
                .subscribe((response) => {
                for (const item of response.result.data.items) {
                    let canShow = true;
                    const routerData = this.router.config.filter(object => (typeof item.url === 'string'
                        && object.path === item.url.substr(1)));
                    if (typeof routerData[0] !== 'undefined'
                        && typeof routerData[0].requiredPermissions !== 'undefined'
                        && this.permissionSevice.checkPermissions(routerData[0]) === false) {
                        canShow = false;
                    }
                    if (response.result.data.items.filter((i) => {
                        return item.parent_id != null
                            && i.id === item.parent_id;
                    }).length > 0) {
                        if (canShow) {
                            if (this.data.icon && Array.isArray(this.data.icon)) {
                                item.icon = this.getArrayPath.get(item, this.data.icon);
                                // TODO currently only material icons are supported
                                // handle svgs and urls to images
                            }
                            if (!this.menuItems[item.parent_id]) {
                                this.menuItems[item.parent_id] = [];
                            }
                            item.url = this.getRouterLink(item);
                            this.menuItems[item.parent_id].push(item);
                        }
                    }
                    else {
                        if (canShow) {
                            if (this.data.icon && Array.isArray(this.data.icon)) {
                                item.icon = this.getArrayPath.get(item, this.data.icon);
                                // TODO currently only material icons are supported
                                // handle svgs and urls to images
                            }
                            item.url = this.getRouterLink(item);
                            this.menuItems[0].push(item);
                        }
                    }
                }
            });
        }
        this.eventBus.on('toggleSidenav')
            .pipe(takeUntil$1(this.destroyed$))
            .subscribe((data) => {
            this.triggers.forEach(trigger => {
                trigger.openMenu();
            });
        });
    }
    getRouterLink(item) {
        if (item.url) {
            if (item.url === '#') {
                return [];
            }
            let route;
            if (item.url.includes(';')) {
                const urlTree = this.urlSerializer.parse(item.url);
                route = ['/'];
                for (const segment of urlTree.root.children.primary.segments) {
                    route.push(segment.path);
                    if (item.category_id) {
                        route.push(item.category_id);
                    }
                    route.push(segment.parameters);
                }
            }
            else {
                route = item.url;
                if (item.category_id) {
                    route += '/' + item.category_id;
                }
            }
            return route;
        }
        else if (typeof this.data.link !== 'undefined') {
            return this.link.transform(item, this.data.link);
        }
    }
    openMenu() {
        this.triggers.forEach(trigger => {
            trigger.openMenu();
        });
    }
    closeMenu() {
        this.triggers.forEach(trigger => {
            trigger.closeMenu();
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
MenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuComponent, deps: [{ token: ApiService }, { token: EventBusService }, { token: i1.Router }, { token: PermissionsService }, { token: LinkPipe }, { token: GetArrayPathService }, { token: ScrollService }, { token: i1.UrlSerializer }], target: i0.ɵɵFactoryTarget.Component });
MenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MenuComponent, selector: "app-menu", inputs: { data: "data", menuItems: "menuItems", topId: "topId" }, providers: [LinkPipe], viewQueries: [{ propertyName: "triggers", predicate: MatMenuTrigger, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"menuItems[topId]\">\r\n  <!-- HAS SUB MENU -->\r\n  <ng-container *ngIf=\"data.hover\">\r\n    <!-- OPEN ON HOVER -->\r\n    <button\r\n      class=\"hover-trigger\"\r\n      *ngIf=\"data.item.title && !data.item.only_icon\"\r\n      mat-button\r\n      [routerLink]=\"getRouterLink(data.item)\"\r\n      (mouseenter)=\"openMenu()\">\r\n      <mat-icon *ngIf=\"data.item.icon\">{{ data.item.icon }}</mat-icon>\r\n      <span *ngIf=\"data.item.title\">{{ data.item.title }}</span>\r\n      <span class=\"trigger\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n    </button>\r\n    <button\r\n      class=\"hover-trigger\"\r\n      *ngIf=\"data.item.only_icon\"\r\n      mat-icon-button\r\n      [routerLink]=\"getRouterLink(data.item)\"\r\n      (mouseenter)=\"openMenu()\">\r\n      <mat-icon *ngIf=\"data.item.icon\">{{ data.item.icon }}</mat-icon>\r\n      <span class=\"trigger\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!data.hover\">\r\n    <!-- OPEN ON CLICK -->\r\n    <button *ngIf=\"data.item\" mat-button [matMenuTriggerFor]=\"panel.menu\">\r\n      {{ data.item.title }}\r\n    </button>\r\n    <button\r\n      *ngIf=\"data.icon\"\r\n      [ngClass]=\"{ hamburger: data.hamburger }\"\r\n      mat-icon-button\r\n      [matMenuTriggerFor]=\"panel.menu\">\r\n      <mat-icon>{{ data.icon }}</mat-icon>\r\n    </button>\r\n    <span *ngIf=\"!data.item && !data.icon\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n  </ng-container>\r\n\r\n  <!-- SUB MENU PANEL -->\r\n  <app-menu-panel\r\n    #panel\r\n    [data]=\"{\r\n      link: data.link,\r\n      class: data.class,\r\n      xPosition: data.xPosition,\r\n      scrollToElement: data.scrollToElement\r\n    }\"\r\n    [menuItems]=\"menuItems\"\r\n    [parentItem]=\"{ id: topId }\"></app-menu-panel>\r\n</ng-container>\r\n\r\n<!-- NO SUB MENU -->\r\n<ng-container *ngIf=\"!data.scrollToElement\">\r\n  <button\r\n    *ngIf=\"data.item && !menuItems[topId]\"\r\n    mat-button\r\n    [routerLink]=\"data.item.url\">\r\n    <mat-icon *ngIf=\"data.icon\">{{ data.icon }}</mat-icon>\r\n    <span *ngIf=\"data.item.title\">{{ data.item.title }}</span>\r\n  </button>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.scrollToElement\">\r\n  <button\r\n    *ngIf=\"data.item && !menuItems[topId]\"\r\n    mat-button\r\n    (click)=\"scrollService.scrollToElement(data.item.url)\">\r\n    {{ data.item.title }}\r\n  </button>\r\n</ng-container>\r\n", styles: ["button{height:100%}button.hover-trigger{z-index:999}button.hover-trigger .trigger{position:absolute;left:0;bottom:0;visibility:hidden}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i8$3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i4.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: MenuPanelComponent, selector: "app-menu-panel", inputs: ["data", "parentItem", "menuItems"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-menu', providers: [LinkPipe], template: "<ng-container *ngIf=\"menuItems[topId]\">\r\n  <!-- HAS SUB MENU -->\r\n  <ng-container *ngIf=\"data.hover\">\r\n    <!-- OPEN ON HOVER -->\r\n    <button\r\n      class=\"hover-trigger\"\r\n      *ngIf=\"data.item.title && !data.item.only_icon\"\r\n      mat-button\r\n      [routerLink]=\"getRouterLink(data.item)\"\r\n      (mouseenter)=\"openMenu()\">\r\n      <mat-icon *ngIf=\"data.item.icon\">{{ data.item.icon }}</mat-icon>\r\n      <span *ngIf=\"data.item.title\">{{ data.item.title }}</span>\r\n      <span class=\"trigger\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n    </button>\r\n    <button\r\n      class=\"hover-trigger\"\r\n      *ngIf=\"data.item.only_icon\"\r\n      mat-icon-button\r\n      [routerLink]=\"getRouterLink(data.item)\"\r\n      (mouseenter)=\"openMenu()\">\r\n      <mat-icon *ngIf=\"data.item.icon\">{{ data.item.icon }}</mat-icon>\r\n      <span class=\"trigger\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"!data.hover\">\r\n    <!-- OPEN ON CLICK -->\r\n    <button *ngIf=\"data.item\" mat-button [matMenuTriggerFor]=\"panel.menu\">\r\n      {{ data.item.title }}\r\n    </button>\r\n    <button\r\n      *ngIf=\"data.icon\"\r\n      [ngClass]=\"{ hamburger: data.hamburger }\"\r\n      mat-icon-button\r\n      [matMenuTriggerFor]=\"panel.menu\">\r\n      <mat-icon>{{ data.icon }}</mat-icon>\r\n    </button>\r\n    <span *ngIf=\"!data.item && !data.icon\" [matMenuTriggerFor]=\"panel.menu\"></span>\r\n  </ng-container>\r\n\r\n  <!-- SUB MENU PANEL -->\r\n  <app-menu-panel\r\n    #panel\r\n    [data]=\"{\r\n      link: data.link,\r\n      class: data.class,\r\n      xPosition: data.xPosition,\r\n      scrollToElement: data.scrollToElement\r\n    }\"\r\n    [menuItems]=\"menuItems\"\r\n    [parentItem]=\"{ id: topId }\"></app-menu-panel>\r\n</ng-container>\r\n\r\n<!-- NO SUB MENU -->\r\n<ng-container *ngIf=\"!data.scrollToElement\">\r\n  <button\r\n    *ngIf=\"data.item && !menuItems[topId]\"\r\n    mat-button\r\n    [routerLink]=\"data.item.url\">\r\n    <mat-icon *ngIf=\"data.icon\">{{ data.icon }}</mat-icon>\r\n    <span *ngIf=\"data.item.title\">{{ data.item.title }}</span>\r\n  </button>\r\n</ng-container>\r\n<ng-container *ngIf=\"data.scrollToElement\">\r\n  <button\r\n    *ngIf=\"data.item && !menuItems[topId]\"\r\n    mat-button\r\n    (click)=\"scrollService.scrollToElement(data.item.url)\">\r\n    {{ data.item.title }}\r\n  </button>\r\n</ng-container>\r\n", styles: ["button{height:100%}button.hover-trigger{z-index:999}button.hover-trigger .trigger{position:absolute;left:0;bottom:0;visibility:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: EventBusService }, { type: i1.Router }, { type: PermissionsService }, { type: LinkPipe }, { type: GetArrayPathService }, { type: ScrollService }, { type: i1.UrlSerializer }]; }, propDecorators: { data: [{
                type: Input
            }], menuItems: [{
                type: Input
            }], topId: [{
                type: Input
            }], triggers: [{
                type: ViewChildren,
                args: [MatMenuTrigger]
            }] } });

class HorizontalMenuComponent {
    constructor(api, router, permissionSevice, comm, getArrayPath, breakpointObserver, urlSerializer, link) {
        this.api = api;
        this.router = router;
        this.permissionSevice = permissionSevice;
        this.comm = comm;
        this.getArrayPath = getArrayPath;
        this.breakpointObserver = breakpointObserver;
        this.urlSerializer = urlSerializer;
        this.link = link;
        this.destroyed = new Subject();
        this.breakpointObserver.observe([
            '(min-width: 992px)'
        ])
            .pipe(takeUntil(this.destroyed)).subscribe(size => {
            if (size.matches) {
                this.hamburger = false;
            }
            else {
                this.hamburger = true;
            }
        });
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.load();
    }
    load() {
        this.menuItems = { 0: [] };
        if (typeof this.data.xPosition === 'undefined') {
            this.data.xPosition = 'after';
        }
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            for (const item of response.result.data.items) {
                item.hasChildren = !!response.result.data.items.find(i => {
                    return i.parent_id === item.id;
                });
                let canShow = true;
                const routerData = this.router.config.filter(object => (typeof item.url === 'string'
                    && object.path === item.url.substr(1)));
                if (typeof routerData[0] !== 'undefined'
                    && typeof routerData[0].requiredPermissions !== 'undefined'
                    && this.permissionSevice.checkPermissions(routerData[0]) === false) {
                    canShow = false;
                }
                if (response.result.data.items.filter((i) => {
                    return item.parent_id != null
                        && i.id === item.parent_id;
                }).length > 0) {
                    if (canShow) {
                        if (this.data.icon && Array.isArray(this.data.icon)) {
                            item.icon = this.getArrayPath.get(item, this.data.icon);
                            // TODO currently only material icons are supported
                            // handle svgs and urls to images
                        }
                        if (!this.menuItems[item.parent_id]) {
                            this.menuItems[item.parent_id] = [];
                        }
                        item.url = this.getRouterLink(item);
                        this.menuItems[item.parent_id].push(item);
                    }
                }
                else {
                    if (canShow) {
                        if (this.data.icon && Array.isArray(this.data.icon)) {
                            item.icon = this.getArrayPath.get(item, this.data.icon);
                            // TODO currently only material icons are supported
                            // handle svgs and urls to images
                        }
                        item.url = this.getRouterLink(item);
                        this.menuItems[0].push(item);
                    }
                }
            }
            for (const id in this.menuItems) {
                this.menuItems[id] = this.menuItems[id].filter(menuItem => {
                    if (menuItem.hasChildren) {
                        if (typeof this.menuItems[menuItem.id] !== 'undefined') {
                            return true;
                        }
                        return false;
                    }
                    return true;
                });
            }
        });
    }
    getRouterLink(item) {
        if (item.url) {
            if (item.url === '#') {
                return [];
            }
            let route;
            if (item.url.includes(';')) {
                const urlTree = this.urlSerializer.parse(item.url);
                route = ['/'];
                for (const segment of urlTree.root.children.primary.segments) {
                    route.push(segment.path);
                    route.push(segment.parameters);
                }
            }
            else {
                route = item.url;
            }
            return route;
        }
        else if (typeof this.data.link !== 'undefined') {
            return this.link.transform(item, this.data.link);
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.breakpointObserver.ngOnDestroy();
    }
}
HorizontalMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuComponent, deps: [{ token: ApiService }, { token: i1.Router }, { token: PermissionsService }, { token: CommunicationService }, { token: GetArrayPathService }, { token: i6$2.BreakpointObserver }, { token: i1.UrlSerializer }, { token: LinkPipe }], target: i0.ɵɵFactoryTarget.Component });
HorizontalMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: HorizontalMenuComponent, selector: "app-horizontal-menu", inputs: { data: "data" }, providers: [LinkPipe], ngImport: i0, template: "<ng-container *ngIf=\"!hamburger\">\r\n  <!-- REGULAR MENU -->\r\n  <ng-container *ngFor=\"let item of menuItems[0]\">\r\n    <app-menu\r\n      [data]=\"{\r\n        item: item, \r\n        link: data.link, \r\n        hover: true, \r\n        class: data.class, \r\n        scrollToElement: data.scrollToElement,\r\n        xPosition: data.xPosition\r\n      }\"\r\n      [menuItems]=\"menuItems\"\r\n      [topId]=\"item.id\"\r\n    ></app-menu>\r\n  </ng-container>\r\n</ng-container>\r\n<ng-container *ngIf=\"hamburger\">\r\n  <!-- HAMBURGER MENU (WHEN <= Medium Breakpoint) -->\r\n  <app-menu\r\n    [data]=\"{\r\n      icon: 'menu',\r\n      link: data.link,\r\n      hamburger: true,\r\n      class: data.class,\r\n      xPosition: 'before',\r\n      scrollToElement: data.scrollToElement\r\n    }\"\r\n    [menuItems]=\"menuItems\"\r\n  ></app-menu>\r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MenuComponent, selector: "app-menu", inputs: ["data", "menuItems", "topId"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-horizontal-menu', providers: [LinkPipe], template: "<ng-container *ngIf=\"!hamburger\">\r\n  <!-- REGULAR MENU -->\r\n  <ng-container *ngFor=\"let item of menuItems[0]\">\r\n    <app-menu\r\n      [data]=\"{\r\n        item: item, \r\n        link: data.link, \r\n        hover: true, \r\n        class: data.class, \r\n        scrollToElement: data.scrollToElement,\r\n        xPosition: data.xPosition\r\n      }\"\r\n      [menuItems]=\"menuItems\"\r\n      [topId]=\"item.id\"\r\n    ></app-menu>\r\n  </ng-container>\r\n</ng-container>\r\n<ng-container *ngIf=\"hamburger\">\r\n  <!-- HAMBURGER MENU (WHEN <= Medium Breakpoint) -->\r\n  <app-menu\r\n    [data]=\"{\r\n      icon: 'menu',\r\n      link: data.link,\r\n      hamburger: true,\r\n      class: data.class,\r\n      xPosition: 'before',\r\n      scrollToElement: data.scrollToElement\r\n    }\"\r\n    [menuItems]=\"menuItems\"\r\n  ></app-menu>\r\n</ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: i1.Router }, { type: PermissionsService }, { type: CommunicationService }, { type: GetArrayPathService }, { type: i6$2.BreakpointObserver }, { type: i1.UrlSerializer }, { type: LinkPipe }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class MenuModule {
    constructor(routing) {
        routing.mapComponent('MenuComponent', MenuComponent);
    }
}
MenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
MenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: MenuModule, declarations: [MenuComponent, MenuPanelComponent], imports: [CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        PrimitiveModule,
        PipesModule,
        RouterModule,
        CustomRouterLinkDirective], exports: [MenuComponent] });
MenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuModule, imports: [CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        PrimitiveModule,
        PipesModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MenuComponent, MenuPanelComponent],
                    imports: [
                        CommonModule,
                        MatMenuModule,
                        MatButtonModule,
                        MatIconModule,
                        PrimitiveModule,
                        PipesModule,
                        RouterModule,
                        CustomRouterLinkDirective
                    ],
                    exports: [MenuComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var menu_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   MenuModule: MenuModule
});

class HorizontalMenuModule {
    constructor(routing) {
        routing.mapComponent('HorizontalMenuComponent', HorizontalMenuComponent);
    }
}
HorizontalMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
HorizontalMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuModule, declarations: [HorizontalMenuComponent], imports: [CommonModule,
        MenuModule] });
HorizontalMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuModule, imports: [CommonModule,
        MenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HorizontalMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HorizontalMenuComponent],
                    imports: [
                        CommonModule,
                        MenuModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var horizontalMenu_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   HorizontalMenuModule: HorizontalMenuModule
});

class MobileMenuComponent {
    constructor(api, storage, router, getArrayPath, language, route, link) {
        this.api = api;
        this.storage = storage;
        this.router = router;
        this.getArrayPath = getArrayPath;
        this.language = language;
        this.route = route;
        this.link = link;
        this.menu = [];
        this.innerMenu = [];
        this.isInnerOpened = false;
        this.selectedIndex = -1;
    }
    ngOnInit() {
        this.loadMenu();
    }
    loadMenu() {
        this.api
            .callServiceMethod(this.data.dataSource)
            .pipe(take(1))
            .subscribe((response) => {
            this.data.progressBar = false;
            const langId = this.storage.get('langs')[this.storage.get('language')];
            const items = this.getArrayPath.get(response.result.data, this.data.responsePath || 'items');
            this.menu = items.map((item) => {
                const name = this.getArrayPath.get(item, this.data.mainMenuTextPath);
                if (typeof name === 'object') {
                    item.title = name[langId];
                }
                else {
                    item.title = name;
                }
                return item;
            });
            const id = this.route.snapshot.paramMap.get('id');
            if (id) {
                this.openMenuFromOutside(id);
                setTimeout(() => {
                    const activeItem = document.querySelector('.active');
                    if (activeItem) {
                        activeItem.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        });
                    }
                });
            }
        });
    }
    openCategory(categoryCode) {
        this.innerMenu = this.getMenuTitle(this.menu.find(m => m.code === categoryCode).children);
        this.isInnerOpened = true;
        this.selectedIndex = this.menu.findIndex((m) => {
            return m.code === categoryCode;
        });
    }
    openInnerItem(index) {
        this.innerMenu = this.getMenuTitle(this.innerMenu[index].children);
    }
    redirectTo(item) {
        let url;
        if (item.url) {
            url = item.url;
        }
        else {
            url = this.link.transform(item, this.data.urlPath);
        }
        this.router.navigateByUrl(url);
    }
    goBack() {
        const parentId = this.innerMenu[0].item.parent;
        this.menu.forEach(m => {
            this.getParentMenu(m, this.menu, parentId);
        });
    }
    getCategory(item) {
        if (item.hasOwnProperty('category_entity')) {
            return this.getCategory(item.category_entity);
        }
        else {
            return item.id;
        }
    }
    openMenuFromOutside(id) {
        const category = this.menu.find(m => m.id === id)?.code;
        // if id is from main menu - open that category
        // Otherwise open inner menu
        if (category) {
            this.openCategory(category);
        }
        else {
            this.menu.forEach(menu => {
                this.getMenu(menu, this.menu, id);
            });
        }
    }
    getMenu(menu, parentMenu, id) {
        if (menu.item?.id === id) {
            this.innerMenu = this.getMenuTitle(parentMenu.children);
            this.isInnerOpened = true;
            this.selectedIndex = this.menu.findIndex(m => {
                return m.id === this.getCategory(this.innerMenu[0].item);
            });
            return;
        }
        else {
            return this.getMenuTitle(menu.children)
                .forEach(child => {
                this.getMenu(child, menu, id);
            });
        }
    }
    getParentMenu(menu, parentMenu, parentId) {
        if (menu.item?.id === parentId) {
            this.innerMenu = this.getMenuTitle(parentMenu.children);
            this.isInnerOpened = true;
            return;
        }
        else {
            menu.children.forEach(child => {
                this.getParentMenu(child, menu, parentId);
            });
        }
    }
    isBelowTop() {
        const parentId = this.innerMenu[0]?.item?.parent;
        if (!parentId) {
            return false;
        }
        return this.menu.findIndex(m => m.id === parentId) === -1;
    }
    getMenuTitle(menu) {
        const langId = this.storage.get('langs')[this.storage.get('language')];
        return menu.map(m => {
            const name = this.getArrayPath.get(m.item, this.data.innerMenuTextPath);
            if (typeof name === 'object') {
                m.title = name[langId];
            }
            else {
                m.title = name;
            }
            return m;
        });
    }
}
MobileMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuComponent, deps: [{ token: ApiService }, { token: StateService }, { token: i1.Router }, { token: GetArrayPathService }, { token: LanguageService }, { token: i1.ActivatedRoute }, { token: LinkPipe }], target: i0.ɵɵFactoryTarget.Component });
MobileMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MobileMenuComponent, selector: "app-mobile-menu", inputs: { data: "data" }, ngImport: i0, template: "<div *ngIf=\"data.progressBar\" class=\"loadingContainer\">\r\n  <!-- <mat-icon class=\"loadingIcon\">{{data.loadingIcon}}</mat-icon> -->\r\n  <div class=\"loadingComponent\">\r\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n  </div>\r\n</div>\r\n<nav class=\"row no-gutters\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{'inner-open': isInnerOpened}\">\r\n  <div [@openInnerMenu]=\"isInnerOpened ? 'opened' : 'closed'\"\r\n      class=\"main-menu\"\r\n      [ngClass]=\"{ 'col-8 inner-opened': isInnerOpened, 'col-24': !isInnerOpened }\">\r\n    <div\r\n        class=\"d-flex justify-content-start align-items-center background-primary-dark\"\r\n        [ngClass]=\"{ 'justify-content-center flex-column': isInnerOpened,\r\n                      'justify-content-start flex-row': !isInnerOpened,\r\n                      'active': i === selectedIndex}\"\r\n        *ngFor=\"let item of menu; let i=index\"\r\n        (click)=\"openCategory(item.code)\"\r\n        @openMainMenu\r\n        >\r\n      <span class=\"d-flex justify-content-center align-items-center category-image\">\r\n        <span class=\"w-100 h-100 d-flex justify-content-center align-items-center\">\r\n          <img\r\n            *ngIf=\"!(item | getArrayPath: data.mainMenuItemsImagePath).endsWith('svg')\"\r\n            class=\"mw-100\"\r\n            [src]=\"item | getArrayPath: data.mainMenuItemsImagePath\" alt=\"Category Image\">\r\n          <app-html\r\n            *ngIf=\"(item | getArrayPath: data.mainMenuItemsImagePath).endsWith('svg')\"\r\n            [data]=\"{ dataObject: item.svg }\">\r\n          </app-html>\r\n        </span>\r\n      </span>\r\n      <span class=\"text-center item-title\">{{ item.title }}</span>\r\n      <app-icon class=\"ml-auto\"\r\n                [ngClass]=\"{'d-none': isInnerOpened, 'd-block': !isInnerOpened}\"\r\n                [data]=\"{ icon: data.mainMenuRightIcon }\">\r\n      </app-icon>\r\n    </div>\r\n  </div>\r\n    <div  class=\"col-16 d-flex flex-column justify-content-start align-items-center sub-menu\"\r\n          *ngIf=\"isInnerOpened\">\r\n    <div class=\"d-flex flex-row justify-content-between align-items-center border-bottom border-dark back\"\r\n         *ngIf=\"isBelowTop()\">\r\n      <app-icon\r\n        [data]=\"{ icon: data.backIcon }\"\r\n        (click)=\"goBack()\"\r\n      ></app-icon>\r\n      <span>{{ language.getLabel(data.backButtonText) }}</span>\r\n    </div>\r\n    <div\r\n      @slideInnerMenu\r\n      class=\"d-flex flex-row justify-content-between align-items-center\"\r\n      *ngFor=\"let item of innerMenu; let i=index\"\r\n      (click)=\"item.children.length === 0 ?\r\n           redirectTo(item.item)\r\n        :  openInnerItem(i)\"\r\n    >\r\n      <span>{{ item.title }}</span>\r\n      <app-icon\r\n        [data]=\"{ icon: data.subMenuRightIcon }\"\r\n      ></app-icon>\r\n    </div>\r\n  </div>\r\n</nav>\r\n\r\n", styles: [":host .main-menu>*{margin-bottom:.75rem;gap:.625rem}:host .main-menu .category-image{max-width:100%}:host .main-menu .category-image img{overflow:visible}.loadingContainer{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center;height:400px;z-index:10000}.loadingContainer .loadingComponent{width:30%}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: HtmlComponent, selector: "app-html", inputs: ["data"] }, { kind: "component", type: IconComponent, selector: "app-icon", inputs: ["data"] }, { kind: "component", type: i10$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }], animations: [
        trigger('openMainMenu', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.2s')
            ])
        ]),
        trigger('openInnerMenu', [
            state('closed', style({
                'max-width': '100%'
            })),
            state('opened', style({
                'max-width': '33.3333%',
                transform: 'translateX(0)'
            })),
            transition('closed=>opened', [
                style({ width: '100%', transform: 'translateX(-100%)' }),
                animate('0.2s')
            ])
        ]),
        trigger('slideInnerMenu', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('0.2s')
            ])
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-mobile-menu', animations: [
                        trigger('openMainMenu', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate('0.2s')
                            ])
                        ]),
                        trigger('openInnerMenu', [
                            state('closed', style({
                                'max-width': '100%'
                            })),
                            state('opened', style({
                                'max-width': '33.3333%',
                                transform: 'translateX(0)'
                            })),
                            transition('closed=>opened', [
                                style({ width: '100%', transform: 'translateX(-100%)' }),
                                animate('0.2s')
                            ])
                        ]),
                        trigger('slideInnerMenu', [
                            transition(':enter', [
                                style({ transform: 'translateX(100%)', opacity: 0 }),
                                animate('0.2s')
                            ])
                        ])
                    ], template: "<div *ngIf=\"data.progressBar\" class=\"loadingContainer\">\r\n  <!-- <mat-icon class=\"loadingIcon\">{{data.loadingIcon}}</mat-icon> -->\r\n  <div class=\"loadingComponent\">\r\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n  </div>\r\n</div>\r\n<nav class=\"row no-gutters\"\r\n    [class]=\"data.class\"\r\n    [ngClass]=\"{'inner-open': isInnerOpened}\">\r\n  <div [@openInnerMenu]=\"isInnerOpened ? 'opened' : 'closed'\"\r\n      class=\"main-menu\"\r\n      [ngClass]=\"{ 'col-8 inner-opened': isInnerOpened, 'col-24': !isInnerOpened }\">\r\n    <div\r\n        class=\"d-flex justify-content-start align-items-center background-primary-dark\"\r\n        [ngClass]=\"{ 'justify-content-center flex-column': isInnerOpened,\r\n                      'justify-content-start flex-row': !isInnerOpened,\r\n                      'active': i === selectedIndex}\"\r\n        *ngFor=\"let item of menu; let i=index\"\r\n        (click)=\"openCategory(item.code)\"\r\n        @openMainMenu\r\n        >\r\n      <span class=\"d-flex justify-content-center align-items-center category-image\">\r\n        <span class=\"w-100 h-100 d-flex justify-content-center align-items-center\">\r\n          <img\r\n            *ngIf=\"!(item | getArrayPath: data.mainMenuItemsImagePath).endsWith('svg')\"\r\n            class=\"mw-100\"\r\n            [src]=\"item | getArrayPath: data.mainMenuItemsImagePath\" alt=\"Category Image\">\r\n          <app-html\r\n            *ngIf=\"(item | getArrayPath: data.mainMenuItemsImagePath).endsWith('svg')\"\r\n            [data]=\"{ dataObject: item.svg }\">\r\n          </app-html>\r\n        </span>\r\n      </span>\r\n      <span class=\"text-center item-title\">{{ item.title }}</span>\r\n      <app-icon class=\"ml-auto\"\r\n                [ngClass]=\"{'d-none': isInnerOpened, 'd-block': !isInnerOpened}\"\r\n                [data]=\"{ icon: data.mainMenuRightIcon }\">\r\n      </app-icon>\r\n    </div>\r\n  </div>\r\n    <div  class=\"col-16 d-flex flex-column justify-content-start align-items-center sub-menu\"\r\n          *ngIf=\"isInnerOpened\">\r\n    <div class=\"d-flex flex-row justify-content-between align-items-center border-bottom border-dark back\"\r\n         *ngIf=\"isBelowTop()\">\r\n      <app-icon\r\n        [data]=\"{ icon: data.backIcon }\"\r\n        (click)=\"goBack()\"\r\n      ></app-icon>\r\n      <span>{{ language.getLabel(data.backButtonText) }}</span>\r\n    </div>\r\n    <div\r\n      @slideInnerMenu\r\n      class=\"d-flex flex-row justify-content-between align-items-center\"\r\n      *ngFor=\"let item of innerMenu; let i=index\"\r\n      (click)=\"item.children.length === 0 ?\r\n           redirectTo(item.item)\r\n        :  openInnerItem(i)\"\r\n    >\r\n      <span>{{ item.title }}</span>\r\n      <app-icon\r\n        [data]=\"{ icon: data.subMenuRightIcon }\"\r\n      ></app-icon>\r\n    </div>\r\n  </div>\r\n</nav>\r\n\r\n", styles: [":host .main-menu>*{margin-bottom:.75rem;gap:.625rem}:host .main-menu .category-image{max-width:100%}:host .main-menu .category-image img{overflow:visible}.loadingContainer{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center;height:400px;z-index:10000}.loadingContainer .loadingComponent{width:30%}\n"] }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: StateService }, { type: i1.Router }, { type: GetArrayPathService }, { type: LanguageService }, { type: i1.ActivatedRoute }, { type: LinkPipe }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class MobileMenuModule {
    constructor(routing) {
        routing.mapComponent('MobileMenuComponent', MobileMenuComponent);
    }
}
MobileMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
MobileMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuModule, declarations: [MobileMenuComponent], imports: [CommonModule,
        PrimitiveModule,
        PipesModule,
        MatProgressBarModule], exports: [MobileMenuComponent] });
MobileMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuModule, imports: [CommonModule,
        PrimitiveModule,
        PipesModule,
        MatProgressBarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MobileMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MobileMenuComponent
                    ],
                    imports: [
                        CommonModule,
                        PrimitiveModule,
                        PipesModule,
                        MatProgressBarModule
                    ],
                    exports: [MobileMenuComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var mobileMenu_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   MobileMenuModule: MobileMenuModule
});

class OverlayModule {
    constructor(routing) {
        routing.mapComponent('OverlayComponent', OverlayComponent);
    }
}
OverlayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
OverlayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: OverlayModule, declarations: [OverlayComponent], imports: [CommonModule,
        SlotModule,
        PipesModule] });
OverlayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayModule, imports: [CommonModule,
        SlotModule,
        PipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OverlayModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OverlayComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var overlay_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   OverlayModule: OverlayModule
});

class CountdownComponent extends BaseComponent {
    constructor(ngZone, cd, getArrayPath, session) {
        super();
        this.ngZone = ngZone;
        this.cd = cd;
        this.getArrayPath = getArrayPath;
        this.session = session;
        this.separationTime = {};
        this.destroyed = new Subject();
    }
    ngOnInit() {
        super.ngOnInit();
        if (typeof this.data.duration !== 'undefined') {
            if (Array.isArray(this.data.duration)
                && typeof this.data.dataObject === 'object') {
                this.data.duration = this.getArrayPath.get(this.data.dataObject, this.data.duration);
            }
            if (this.data.persist) {
                const key = this.getPersistKey();
                this.data.durationInSeconds = this.session.get(key);
            }
            if (typeof this.data.duration == 'number' && !this.data.durationInSeconds) {
                this.data.durationInSeconds = this.data.duration;
                if (typeof this.data.durationUnit !== 'undefined') {
                    switch (this.data.durationUnit) {
                        case 'min':
                            this.data.durationInSeconds = this.data.duration * 60;
                            break;
                        case 'hour':
                            this.data.durationInSeconds = this.data.duration * 60 * 60;
                            break;
                        case 'day':
                            this.data.durationInSeconds = this.data.duration * 60 * 60 * 24;
                            break;
                    }
                }
            }
        }
        this.init();
    }
    init() {
        this.calculateEndDate();
        this.startCountdown();
        let loadedCallback;
        if (typeof this.data.loaded === 'function') {
            const that = this;
            loadedCallback = function (dataObject) {
                this.data.loadedParams = {
                    event: 'loaded',
                    dataObject: dataObject
                };
                const result = that.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            };
        }
    }
    calculateEndDate() {
        const now = new Date().getTime();
        this.endDate = new Date(now + this.data.durationInSeconds * 1000);
    }
    startCountdown() {
        this.calculateRemainingTime();
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.ngZone.runOutsideAngular(() => {
            this.timer = setInterval(() => {
                this.calculateRemainingTime();
                this.cd.detectChanges();
            }, 1000);
        });
    }
    calculateRemainingTime() {
        const now = new Date().getTime();
        const endTime = this.endDate.getTime();
        this.remainingTime = Math.round(Math.max(0, endTime - now) / 1000);
        if (this.data.persist) {
            const key = this.getPersistKey();
            if (this.remainingTime === 0) {
                this.session.remove(key);
            }
            else {
                this.session.set(key, this.remainingTime);
            }
        }
        if (this.remainingTime === 0) {
            this.stopCountdown();
        }
        if (this.data.separation) {
            this.calculateDaysHoursMinutesSeconds();
        }
    }
    calculateDaysHoursMinutesSeconds() {
        this.days = Math.floor(this.remainingTime / (24 * 60 * 60));
        this.remainingTime %= 24 * 60 * 60;
        this.hours = Math.floor(this.remainingTime / (60 * 60));
        this.remainingTime %= 60 * 60;
        this.minutes = Math.floor(this.remainingTime / (60));
        this.remainingTime %= 60;
        this.seconds = this.remainingTime;
        this.separationTime = {
            days: this.days.toString().padStart(2, '0'),
            hours: this.hours.toString().padStart(2, '0'),
            minutes: this.minutes.toString().padStart(2, '0'),
            seconds: this.seconds.toString().padStart(2, '0')
        };
    }
    stopCountdown() {
        this.ngZone.run(() => {
            clearInterval(this.timer);
            if (typeof this.data.finished === 'function') {
                if (typeof this.data.finishedParams === 'undefined') {
                    this.data.finishedParams = {};
                }
                this.data.finishedParams.event = 'finished';
                const result = this.data.finished(this.data.finishedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            }
        });
    }
    formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    getPersistKey() {
        let key;
        if (Array.isArray(this.data.persist)) {
            const keySegments = [];
            for (const item of this.data.persist) {
                if (Array.isArray(item)) {
                    keySegments.push(this.getArrayPath.get(this.data.dataObject, item));
                }
                else {
                    keySegments.push(item);
                }
            }
            key = keySegments.join('.');
        }
        else {
            key = this.data.persist;
        }
        return key;
    }
    ngOnDestroy() {
        clearInterval(this.timer);
        this.resetChannels();
        super.ngOnDestroy();
    }
}
CountdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CountdownComponent, deps: [{ token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: GetArrayPathService }, { token: SessionService }], target: i0.ɵɵFactoryTarget.Component });
CountdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: CountdownComponent, selector: "app-countdown", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"remainingTime > 0\" [class]=\"data.class\">\r\n  <ng-container *ngIf=\"!data.separation\">\r\n    <div *ngIf=\"!this.data.durationInterval\">\r\n      <span class=\"label\">{{ language.getLabel(this.data.durationLabel) }} </span>\r\n      <span class=\"time\">{{ formatTime(remainingTime) }}</span>\r\n    </div>\r\n    <div *ngIf=\"this.data.durationInterval\">\r\n      <span class=\"label\">{{ language.getLabel(this.data.durationLabel) }} </span>\r\n      <span class=\"time\">\r\n        {{ formatTime(remainingTime) }}\r\n        {{ language.getLabel(this.data.durationInterval) }}\r\n      </span>\r\n    </div>\r\n    <div *ngIf=\"remainingTime === 0\">\r\n      <p>{{ language.getLabel(this.data.expiredLabel) }}</p>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.separation\">\r\n    <div [class]=\"data.rowClass\">\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.days }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.daysLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.hours }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.hoursLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.minutes }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.minutesLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.seconds }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.secondsLabel) }}</span>\r\n      </div>\r\n      <div *ngIf=\"remainingTime === 0\">\r\n        <p>{{ language.getLabel(this.data.expiredLabel) }}</p>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CountdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-countdown', template: "<div *ngIf=\"remainingTime > 0\" [class]=\"data.class\">\r\n  <ng-container *ngIf=\"!data.separation\">\r\n    <div *ngIf=\"!this.data.durationInterval\">\r\n      <span class=\"label\">{{ language.getLabel(this.data.durationLabel) }} </span>\r\n      <span class=\"time\">{{ formatTime(remainingTime) }}</span>\r\n    </div>\r\n    <div *ngIf=\"this.data.durationInterval\">\r\n      <span class=\"label\">{{ language.getLabel(this.data.durationLabel) }} </span>\r\n      <span class=\"time\">\r\n        {{ formatTime(remainingTime) }}\r\n        {{ language.getLabel(this.data.durationInterval) }}\r\n      </span>\r\n    </div>\r\n    <div *ngIf=\"remainingTime === 0\">\r\n      <p>{{ language.getLabel(this.data.expiredLabel) }}</p>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"data.separation\">\r\n    <div [class]=\"data.rowClass\">\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.days }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.daysLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.hours }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.hoursLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.minutes }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.minutesLabel) }}</span>\r\n      </div>\r\n      <div [class]=\"data.colClass\">\r\n        <span>{{ separationTime.seconds }}</span>\r\n        <br />\r\n        <span>{{ language.getLabel(this.data.secondsLabel) }}</span>\r\n      </div>\r\n      <div *ngIf=\"remainingTime === 0\">\r\n        <p>{{ language.getLabel(this.data.expiredLabel) }}</p>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: GetArrayPathService }, { type: SessionService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class CountDownModule {
    constructor(routing) {
        routing.mapComponent('CountdownComponent', CountdownComponent);
    }
}
CountDownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CountDownModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
CountDownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: CountDownModule, declarations: [CountdownComponent], imports: [CommonModule,
        SlotModule] });
CountDownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CountDownModule, imports: [CommonModule,
        SlotModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: CountDownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CountdownComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var countdown_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   CountDownModule: CountDownModule
});

class ProgressBarComponent {
    constructor(comm, api, getArrayPath) {
        this.comm = comm;
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.milestones = [];
        this.milestoneIcon = 'trip_origin';
        this.direction = 'horizontal';
        this.progress = 0;
        this.barClass = '';
        this.length = 0;
        this.barStyle = 'solid';
        this.destroyed = new Subject();
    }
    ngOnInit() {
        this.handleInput();
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        if (typeof this.data.dataSource !== 'undefined') {
            this.load();
        }
    }
    handleInput() {
        if (typeof this.data.direction !== 'undefined') {
            this.direction = this.data.direction;
        }
        if (typeof this.data.milestones !== 'undefined') {
            this.milestones = this.data.milestones;
        }
        else if (typeof this.data.milestonesPath !== 'undefined') {
            this.milestones = this.getArrayPath.get(this.data.dataObject, this.data.milestonesPath);
        }
        if (typeof this.data.milestoneMap !== 'undefined' &&
            typeof this.milestones !== 'undefined') {
            this.milestones = this.milestones.map((milestone) => {
                const mapped = {
                    index: this.getArrayPath.get(milestone, this.data.milestoneMap.index),
                    length: this.getArrayPath.get(milestone, this.data.milestoneMap.length),
                };
                return mapped;
            });
        }
        if (typeof this.data.length !== 'undefined') {
            this.length = this.data.length;
        }
        else if (typeof this.milestones !== 'undefined') {
            let length = 0;
            this.milestones.forEach(item => length += item.length);
            this.length = length;
        }
        if (typeof this.data.progress !== 'undefined') {
            this.progress = this.data.progress / this.length * 100;
        }
        else if (typeof this.data.progressPath !== 'undefined') {
            const progress = this.getArrayPath.get(this.data.dataObject, this.data.progressPath);
            if (Array.isArray(progress)) {
                setTimeout(() => {
                    let newProgress = 0;
                    progress.forEach((i) => newProgress += i);
                    this.progress = newProgress;
                }, 0);
            }
            else if (typeof progress !== 'undefined') {
                setTimeout(() => this.progress = progress, 0);
            }
        }
        if (typeof this.data.barStyle !== 'undefined') {
            this.barStyle = this.data.barStyle;
        }
        if (typeof this.data.milestoneIcon !== 'undefined') {
            this.milestoneIcon = this.data.milestoneIcon;
        }
        if (typeof this.data.barClass === 'undefined') {
            this.barClass = this.barStyle;
        }
        else {
            this.barClass += ' ' + this.data.barClass;
        }
        if (this.progress >= this.length) {
            this.progressBarStatus('Full');
        }
        else {
            this.progressBarStatus('Partial');
        }
    }
    load() {
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            this.data.dataObject = response.result.data;
        });
    }
    incrementProgress() {
        this.setProgress(this.progress + 1);
    }
    decrementProgress() {
        this.setProgress(this.progress - 1);
    }
    setProgress(progress) {
        if (progress < 0) {
            progress = 0;
        }
        else if (progress > this.length) {
            progress = this.length;
        }
        this.progress = progress;
    }
    getMilestonePosition(milestone) {
        const prev = this.milestones.filter(item => item.index < milestone.index);
        let length = milestone.length;
        prev.forEach(item => length += item.length);
        const position = length / this.length * 100;
        milestone.position = position;
        return this[this.direction + 'XY'](position);
    }
    getPosition(position, type = 'XY') {
        if (position >= this.length) {
            position = this.length;
            this.progressBarStatus('Full');
        }
        else {
            this.progressBarStatus('Partial');
        }
        position = position / this.length * 100;
        const result = this[this.direction + type](position);
        return result;
    }
    horizontalXY(position) {
        return {
            left: (position > 50) ? null : position + '%',
            right: (position > 50) ? (100 - position) + '%' : null
        };
    }
    verticalXY(position) {
        return {
            top: (position > 50) ? null : position + '%',
            bottom: (position > 50) ? (100 - position) + '%' : null
        };
    }
    horizontalDIM(position) {
        return {
            width: position + '%'
        };
    }
    verticalDIM(position) {
        return {
            height: position + '%'
        };
    }
    progressBarStatus(status) {
        if (typeof this.data[`progressBar${status}`] === 'function') {
            if (!this.data[`progressBar${status}Params`]) {
                this.data[`progressBar${status}Params`] = {};
            }
            this.data[`progressBar${status}Params`].event = `progressBar${status}`;
            const result = this.data[`progressBar${status}`](this.data[`progressBar${status}Params`]);
            if (result instanceof Observable) {
                result.pipe(take$1(1)).subscribe();
            }
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
ProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarComponent, deps: [{ token: CommunicationService }, { token: ApiService }, { token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Component });
ProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ProgressBarComponent, selector: "app-progress-bar", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"bar-container d-flex align-items-center\" [class]=\"data.containerClass\">\r\n  <div class=\"milestone first big\"\r\n       [class]=\"data.milestonesClass\"\r\n       [ngClass]=\"{ completed: progress > 0 || data.isFirstCompleted }\"\r\n  >\r\n    <mat-icon>{{ milestoneIcon }}</mat-icon>\r\n    <div class=\"background\"></div>\r\n  </div>\r\n  <div\r\n    *ngFor=\"let milestone of milestones; let last = last\"\r\n    class=\"milestone\"\r\n    [class]=\"data.milestonesClass\"\r\n    [ngStyle]=\"getMilestonePosition(milestone)\"\r\n    [ngClass]=\"{\r\n      completed: (progress / length) * 100 >= milestone.position,\r\n      last: last,\r\n      big: (progress / length) * 100 === milestone.position || milestone.big\r\n    }\"\r\n  >\r\n    <mat-icon>{{ milestoneIcon }}</mat-icon>\r\n    <div class=\"background\"></div>\r\n  </div>\r\n  <div class=\"progress-label\" [ngStyle]=\"getPosition(progress)\">\r\n    <span *ngIf=\"!data.progressComponents\">\r\n      {{ progress }}/{{ length }}\r\n    </span>\r\n    <ng-container *ngIf=\"data.progressComponents\">\r\n      <app-slot\r\n        [items]=\"data.progressComponents\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"bar\" [class]=\"barClass\">\r\n    <div class=\"fill\" [ngStyle]=\"getPosition(progress, 'DIM')\"></div>\r\n  </div>\r\n</div>\r\n", styles: [".bar-container{width:100%;position:relative;height:60px}.bar-container .milestone{position:absolute;height:30px;line-height:33px}.bar-container .milestone .mat-icon{width:15px;height:15px;font-size:15px;position:relative;z-index:1}.bar-container .milestone.big .mat-icon{width:30px;height:30px;font-size:30px}.bar-container .milestone .background{position:absolute;inset:7%;z-index:0}.bar-container .milestone.first{left:0}.bar-container .milestone.last{right:0}.bar-container .milestone.first.big .mat-icon,.bar-container .milestone.last.big .mat-icon{width:30px;height:30px;font-size:30px}.bar-container .progress-label{position:absolute;bottom:42px}.bar-container .bar{margin-left:3px;margin-right:3px;width:100%;height:3px}.bar-container .bar .fill{width:0;height:100%;transition:all .3s linear}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-progress-bar', template: "<div class=\"bar-container d-flex align-items-center\" [class]=\"data.containerClass\">\r\n  <div class=\"milestone first big\"\r\n       [class]=\"data.milestonesClass\"\r\n       [ngClass]=\"{ completed: progress > 0 || data.isFirstCompleted }\"\r\n  >\r\n    <mat-icon>{{ milestoneIcon }}</mat-icon>\r\n    <div class=\"background\"></div>\r\n  </div>\r\n  <div\r\n    *ngFor=\"let milestone of milestones; let last = last\"\r\n    class=\"milestone\"\r\n    [class]=\"data.milestonesClass\"\r\n    [ngStyle]=\"getMilestonePosition(milestone)\"\r\n    [ngClass]=\"{\r\n      completed: (progress / length) * 100 >= milestone.position,\r\n      last: last,\r\n      big: (progress / length) * 100 === milestone.position || milestone.big\r\n    }\"\r\n  >\r\n    <mat-icon>{{ milestoneIcon }}</mat-icon>\r\n    <div class=\"background\"></div>\r\n  </div>\r\n  <div class=\"progress-label\" [ngStyle]=\"getPosition(progress)\">\r\n    <span *ngIf=\"!data.progressComponents\">\r\n      {{ progress }}/{{ length }}\r\n    </span>\r\n    <ng-container *ngIf=\"data.progressComponents\">\r\n      <app-slot\r\n        [items]=\"data.progressComponents\"\r\n        class=\"w-100\"\r\n      ></app-slot>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"bar\" [class]=\"barClass\">\r\n    <div class=\"fill\" [ngStyle]=\"getPosition(progress, 'DIM')\"></div>\r\n  </div>\r\n</div>\r\n", styles: [".bar-container{width:100%;position:relative;height:60px}.bar-container .milestone{position:absolute;height:30px;line-height:33px}.bar-container .milestone .mat-icon{width:15px;height:15px;font-size:15px;position:relative;z-index:1}.bar-container .milestone.big .mat-icon{width:30px;height:30px;font-size:30px}.bar-container .milestone .background{position:absolute;inset:7%;z-index:0}.bar-container .milestone.first{left:0}.bar-container .milestone.last{right:0}.bar-container .milestone.first.big .mat-icon,.bar-container .milestone.last.big .mat-icon{width:30px;height:30px;font-size:30px}.bar-container .progress-label{position:absolute;bottom:42px}.bar-container .bar{margin-left:3px;margin-right:3px;width:100%;height:3px}.bar-container .bar .fill{width:0;height:100%;transition:all .3s linear}\n"] }]
        }], ctorParameters: function () { return [{ type: CommunicationService }, { type: ApiService }, { type: GetArrayPathService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ProgressBarModule {
    constructor(routing) {
        routing.mapComponent('ProgressBarComponent', ProgressBarComponent);
    }
}
ProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
ProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarModule, declarations: [ProgressBarComponent], imports: [CommonModule,
        MatIconModule,
        SlotModule] });
ProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarModule, imports: [CommonModule,
        MatIconModule,
        SlotModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ProgressBarComponent
                    ],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        SlotModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var progressBar_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   ProgressBarModule: ProgressBarModule
});

class SlotDialogModule {
}
SlotDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SlotDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogModule, declarations: [SlotDialogComponent], imports: [CommonModule,
        SlotModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule], exports: [SlotDialogComponent] });
SlotDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogModule, imports: [CommonModule,
        SlotModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SlotDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SlotDialogComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule
                    ],
                    exports: [SlotDialogComponent]
                }]
        }] });

class StepperComponent {
    constructor(permissionService, comm, api, getArrayPath, evaluator, language, breakpointObserver) {
        this.permissionService = permissionService;
        this.comm = comm;
        this.api = api;
        this.getArrayPath = getArrayPath;
        this.evaluator = evaluator;
        this.language = language;
        this.breakpointObserver = breakpointObserver;
        this.completed = [];
        this.steps = [];
        this.destroyed = new Subject();
    }
    ngOnInit() {
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.selfRef = this;
        this.orientation = this.data.orientation;
        if (typeof this.data.orientationBreakpoints === 'object') {
            const breakpointToObserve = [];
            for (let key in this.data.orientationBreakpoints) {
                breakpointToObserve.push(Breakpoints[key]);
            }
            this.sizeObserver = this.breakpointObserver.observe(breakpointToObserve);
            this.sizeObserver
                .pipe(takeUntil$1(this.destroyed)).subscribe(size => {
                for (let br of Object.keys(this.data.orientationBreakpoints)) {
                    if (size.breakpoints[Breakpoints[br]]) {
                        this.orientation = this.data.orientationBreakpoints[br];
                        break;
                    }
                    else {
                        this.orientation = this.data.orientation;
                    }
                }
            });
        }
        if (typeof this.data.dataSource !== 'undefined') {
            this.load();
        }
        else {
            let i = 0;
            const steps = [];
            for (const step of this.data.steps) {
                let render = true;
                if (typeof step.condition !== 'undefined' && step.condition.scope !== 'data') {
                    render = this.evaluator.exec(null, step.condition);
                }
                if (render) {
                    steps.push(step);
                }
                else {
                    continue;
                }
                this.completed[i] = typeof step.completed === 'boolean' ? step.completed : false;
                i++;
            }
            this.steps = steps;
        }
    }
    load() {
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take(1), finalize$1(() => {
            this.nextStep();
        }))
            .subscribe((response) => {
            this.data.dataObject = response.result.data;
            let i = 0;
            const steps = [];
            for (const step of this.data.steps) {
                let render = true;
                if (typeof step.condition !== 'undefined' && step.condition.scope === 'data') {
                    render = this.evaluator.exec(this.data.dataObject, step.condition);
                }
                if (render) {
                    steps.push(step);
                }
                else {
                    continue;
                }
                if (typeof step.completed === 'object') {
                    if (Array.isArray(step.completed) && typeof step.completed[0] !== 'object') {
                        this.completed[i] = this.getArrayPath.get(this.data.dataObject, step.completed);
                    }
                    else {
                        this.completed[i] = this.evaluator.exec(this.data.dataObject, step.completed);
                    }
                }
                i++;
            }
            this.steps = steps;
            // execute loaded event handler if stepper is in an action
            if (typeof this.data.loaded === 'function') {
                if (!this.data.loadedParams) {
                    this.data.loadedParams = {};
                    this.data.loadedParams.event = 'loaded';
                    if (this.data.dataObject) {
                        this.data.loadedParams.dataObject = this.data.dataObject;
                    }
                }
                const result = this.data.loaded(this.data.loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            }
        });
    }
    evalStepsCompletion() {
        let i = 0;
        for (const step of this.data.steps) {
            if (typeof step.completed === 'object') {
                if (Array.isArray(step.completed) && typeof step.completed[0] !== 'object') {
                    this.completed[i] = this.getArrayPath.get(this.data.dataObject, step.completed);
                }
                else {
                    this.completed[i] = this.evaluator.exec(this.data.dataObject, step.completed);
                }
            }
            i++;
        }
        this.nextStep();
    }
    nextStep() {
        setTimeout(() => {
            if (this.data.linear) {
                while (this.stepper.selected.completed
                    && this.stepper.selected !== this.stepper.steps.last) {
                    this.stepper.next();
                }
            }
            else {
                this.stepper.next();
            }
        });
    }
    prevStep() {
        this.stepper.previous();
    }
    isLazy(step) {
        if (typeof step.lazy === 'undefined') {
            return true;
        }
        else {
            return step.lazy;
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        this.breakpointObserver.ngOnDestroy();
    }
}
StepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StepperComponent, deps: [{ token: PermissionsService }, { token: CommunicationService }, { token: ApiService }, { token: GetArrayPathService }, { token: EvalService }, { token: LanguageService }, { token: i6$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component });
StepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: StepperComponent, selector: "app-stepper", inputs: { data: "data" }, viewQueries: [{ propertyName: "stepper", first: true, predicate: ["stepper"], descendants: true, static: true }], ngImport: i0, template: "<mat-stepper\r\n  [class]=\"data.class\"\r\n  #stepper\r\n  [orientation]=\"orientation\"\r\n  [linear]=\"data.linear\"\r\n  [labelPosition]=\"data.labelPosition || 'end'\"\r\n>\r\n  <ng-container *ngFor=\"let step of steps; let i = index\">\r\n    <mat-step\r\n      [completed]=\"completed[i]\"\r\n      [editable]=\"step.editable\"\r\n      [state]=\"step.state\"\r\n      [class]=\"step.class\"\r\n    >\r\n      <ng-template matStepLabel *ngIf=\"step.label || step.labelComponents\">\r\n        {{ language.getLabel(step.label) }}\r\n        <app-slot\r\n          *ngIf=\"step.labelComponents\"\r\n          [items]=\"step.labelComponents\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"isLazy(step)\" matStepContent>\r\n        <app-slot\r\n          *ngIf=\"stepper.selectedIndex === i\"\r\n          [items]=\"step.components\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-template>\r\n      <ng-container *ngIf=\"!isLazy(step)\">\r\n        <app-slot\r\n          [items]=\"step.components\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-container>\r\n    </mat-step>\r\n  </ng-container>\r\n</mat-stepper>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: i10$4.MatStep, selector: "mat-step", inputs: ["color"], exportAs: ["matStep"] }, { kind: "directive", type: i10$4.MatStepLabel, selector: "[matStepLabel]" }, { kind: "component", type: i10$4.MatStepper, selector: "mat-stepper, mat-vertical-stepper, mat-horizontal-stepper, [matStepper]", inputs: ["selectedIndex", "disableRipple", "color", "labelPosition", "headerPosition", "animationDuration"], outputs: ["animationDone"], exportAs: ["matStepper", "matVerticalStepper", "matHorizontalStepper"] }, { kind: "directive", type: i10$4.MatStepContent, selector: "ng-template[matStepContent]" }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-stepper', template: "<mat-stepper\r\n  [class]=\"data.class\"\r\n  #stepper\r\n  [orientation]=\"orientation\"\r\n  [linear]=\"data.linear\"\r\n  [labelPosition]=\"data.labelPosition || 'end'\"\r\n>\r\n  <ng-container *ngFor=\"let step of steps; let i = index\">\r\n    <mat-step\r\n      [completed]=\"completed[i]\"\r\n      [editable]=\"step.editable\"\r\n      [state]=\"step.state\"\r\n      [class]=\"step.class\"\r\n    >\r\n      <ng-template matStepLabel *ngIf=\"step.label || step.labelComponents\">\r\n        {{ language.getLabel(step.label) }}\r\n        <app-slot\r\n          *ngIf=\"step.labelComponents\"\r\n          [items]=\"step.labelComponents\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-template>\r\n      <ng-template *ngIf=\"isLazy(step)\" matStepContent>\r\n        <app-slot\r\n          *ngIf=\"stepper.selectedIndex === i\"\r\n          [items]=\"step.components\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-template>\r\n      <ng-container *ngIf=\"!isLazy(step)\">\r\n        <app-slot\r\n          [items]=\"step.components\"\r\n          [componentValue]=\"data.dataObject | getArrayPath: data.path\"\r\n          [parentComponent]=\"selfRef\"\r\n          style=\"display: block; width: 100%; height: 100%\"\r\n        ></app-slot>\r\n      </ng-container>\r\n    </mat-step>\r\n  </ng-container>\r\n</mat-stepper>\r\n" }]
        }], ctorParameters: function () { return [{ type: PermissionsService }, { type: CommunicationService }, { type: ApiService }, { type: GetArrayPathService }, { type: EvalService }, { type: LanguageService }, { type: i6$2.BreakpointObserver }]; }, propDecorators: { data: [{
                type: Input
            }], stepper: [{
                type: ViewChild,
                args: ['stepper', { static: true }]
            }] } });

class StepperModule {
    constructor(routing) {
        routing.mapComponent('StepperComponent', StepperComponent);
    }
}
StepperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StepperModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
StepperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: StepperModule, declarations: [StepperComponent], imports: [CommonModule,
        SlotModule,
        PipesModule,
        CdkStepperModule,
        MatStepperModule] });
StepperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StepperModule, imports: [CommonModule,
        SlotModule,
        PipesModule,
        CdkStepperModule,
        MatStepperModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: StepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        StepperComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule,
                        CdkStepperModule,
                        MatStepperModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var stepper_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   StepperModule: StepperModule
});

class TabbedComponent {
    constructor(language, getArrayPath, cdRef, location) {
        this.language = language;
        this.getArrayPath = getArrayPath;
        this.cdRef = cdRef;
        this.location = location;
        this.formsData = [];
        this.forms = [];
        this.formsState = [];
        this.destroyed = new Subject();
    }
    ngOnInit() {
        this.selfRef = this;
    }
    registerForm(form, formComponent) {
        if (typeof this.data.singleSubmit === 'undefined') {
            this.data.singleSubmit = true;
        }
        this.formsData.push(form);
        this.formsState.push(form.value);
        const tab = this.formsData.length - 1;
        form.valueChanges.pipe(takeUntil$1(this.destroyed)).subscribe(change => {
            if (typeof this.data.tabs[tab].reload !== 'undefined') {
                const oldValue = this.getArrayPath.get(this.formsState[tab], this.data.tabs[tab].reload.onChangePath);
                const newValue = this.getArrayPath.get(change, this.data.tabs[tab].reload.onChangePath);
                if (oldValue !== newValue) {
                    const paramsToAdd = {};
                    for (const key in this.data.tabs[tab].reload.addParams) {
                        if (this.data.tabs[tab].reload.addParams[key]) {
                            paramsToAdd[key] = this.getArrayPath.get(change, this.data.tabs[tab].reload.addParams[key]);
                        }
                    }
                    const formKey = this.data.tabs[tab].reload.tab - 1;
                    this.forms[formKey].load(paramsToAdd);
                }
                this.formsState[tab] = change;
            }
        });
        this.forms.push(formComponent);
        if (typeof this.buttons === 'undefined') {
            // if forms are registered add submit and cancel button
            this.buttons = [{
                    color: 'primary',
                    type: 'mat-flat-button',
                    label: this.language.getLabel('App_cancel'),
                    class: '',
                    click: function () {
                        this.location.back();
                    }.bind(this)
                },
                {
                    color: 'primary',
                    type: 'mat-flat-button',
                    label: this.language.getLabel('App_submit'),
                    class: 'ml-1',
                    click: this.submit.bind(this)
                }];
            this.cdRef.detectChanges();
        }
    }
    submit() {
        if (typeof this.data.submit === 'undefined') {
            // submit all registered forms seperately to their own submits
            // TODO figure out a way to make a batch jsonrpc request
            const formStatus = new Array(this.forms.length).fill(false);
            let i = 0;
            for (const form of this.forms) {
                form.data.submitSuccess = (params) => {
                    formStatus[i] = params;
                    if (formStatus.every(status => status)) {
                        if (typeof this.data.submitSuccess === 'function') {
                            if (!this.data.submitSuccessParams) {
                                this.data.submitSuccessParams = { forms: formStatus };
                                this.data.submitSuccessParams.event = 'submitSuccess';
                                if (this.data.dataObject) {
                                    this.data.submitSuccessParams.dataObject = this.data.dataObject;
                                }
                            }
                            const result = this.data.submitSuccess(this.data.submitSuccessParams);
                        }
                    }
                    i++;
                };
                form.onSubmit();
            }
        }
        else {
            // TODO: submit all forms as one to the submit of the tabbed component
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
TabbedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TabbedComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }, { token: i0.ChangeDetectorRef }, { token: i3.Location }], target: i0.ɵɵFactoryTarget.Component });
TabbedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TabbedComponent, selector: "app-tabbed", inputs: { data: "data" }, ngImport: i0, template: "<div [class]=\"data.class\" [ngClass]=\"{ 'mat-elevation-z8': !data.inline }\">\r\n  <mat-tab-group dynamicHeight [headerPosition]=\"data.headerPosition\">\r\n    <ng-container *ngFor=\"let tab of data.tabs\">\r\n      <mat-tab *ngIf=\"tab.lazyLoad\" [bodyClass]=\"tab.class\">\r\n        <ng-template matTabLabel>\r\n          <span\r\n            *ngIf=\"tab.errors\"\r\n            matBadge=\"!\"\r\n            matBadgeColor=\"warn\"\r\n            matBadgeSize=\"small\"\r\n            matBadgeOverlap=\"false\"\r\n            matBadgePosition=\"above before\"\r\n          >\r\n            {{ language.getLabel(tab.title) }}\r\n          </span>\r\n          <span *ngIf=\"true\">{{ language.getLabel(tab.title) }}</span>\r\n        </ng-template>\r\n        <ng-template matTabContent>\r\n          <app-slot\r\n            [items]=\"tab.components\"\r\n            [componentValue]=\"tab.dataObject | getArrayPath: tab.path\"\r\n            [parentComponent]=\"selfRef\"\r\n          ></app-slot>\r\n        </ng-template>\r\n      </mat-tab>\r\n      <mat-tab *ngIf=\"!tab.lazyLoad\" [bodyClass]=\"tab.class\">\r\n        <ng-template matTabLabel>\r\n          <span\r\n            *ngIf=\"tab.errors\"\r\n            matBadge=\"!\"\r\n            matBadgeColor=\"warn\"\r\n            matBadgeSize=\"small\"\r\n            matBadgeOverlap=\"false\"\r\n            matBadgePosition=\"above before\"\r\n          >\r\n            {{ language.getLabel(tab.title) }}\r\n          </span>\r\n          <span *ngIf=\"true\">{{ language.getLabel(tab.title) }}</span>\r\n        </ng-template>\r\n        <app-slot\r\n          [items]=\"tab.components\"\r\n          [componentValue]=\"tab.dataObject | getArrayPath: tab.path\"\r\n          [parentComponent]=\"selfRef\"\r\n        ></app-slot>\r\n      </mat-tab>\r\n    </ng-container>\r\n  </mat-tab-group>\r\n  <div class=\"row pb-1\" *ngIf=\"data.singleSubmit\">\r\n    <div class=\"col text-center\">\r\n      <app-button [data]=\"button\" *ngFor=\"let button of buttons\"></app-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".mat-elevation-z8{margin-top:15px}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: ButtonComponent, selector: "app-button", inputs: ["data", "parentForm", "parentComponent"] }, { kind: "component", type: i6$4.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "directive", type: i6$4.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { kind: "component", type: i6$4.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "directive", type: i6$4.MatTabContent, selector: "[matTabContent]" }, { kind: "directive", type: i14.MatBadge, selector: "[matBadge]", inputs: ["matBadgeDisabled", "matBadgeColor", "matBadgeOverlap", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TabbedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-tabbed', template: "<div [class]=\"data.class\" [ngClass]=\"{ 'mat-elevation-z8': !data.inline }\">\r\n  <mat-tab-group dynamicHeight [headerPosition]=\"data.headerPosition\">\r\n    <ng-container *ngFor=\"let tab of data.tabs\">\r\n      <mat-tab *ngIf=\"tab.lazyLoad\" [bodyClass]=\"tab.class\">\r\n        <ng-template matTabLabel>\r\n          <span\r\n            *ngIf=\"tab.errors\"\r\n            matBadge=\"!\"\r\n            matBadgeColor=\"warn\"\r\n            matBadgeSize=\"small\"\r\n            matBadgeOverlap=\"false\"\r\n            matBadgePosition=\"above before\"\r\n          >\r\n            {{ language.getLabel(tab.title) }}\r\n          </span>\r\n          <span *ngIf=\"true\">{{ language.getLabel(tab.title) }}</span>\r\n        </ng-template>\r\n        <ng-template matTabContent>\r\n          <app-slot\r\n            [items]=\"tab.components\"\r\n            [componentValue]=\"tab.dataObject | getArrayPath: tab.path\"\r\n            [parentComponent]=\"selfRef\"\r\n          ></app-slot>\r\n        </ng-template>\r\n      </mat-tab>\r\n      <mat-tab *ngIf=\"!tab.lazyLoad\" [bodyClass]=\"tab.class\">\r\n        <ng-template matTabLabel>\r\n          <span\r\n            *ngIf=\"tab.errors\"\r\n            matBadge=\"!\"\r\n            matBadgeColor=\"warn\"\r\n            matBadgeSize=\"small\"\r\n            matBadgeOverlap=\"false\"\r\n            matBadgePosition=\"above before\"\r\n          >\r\n            {{ language.getLabel(tab.title) }}\r\n          </span>\r\n          <span *ngIf=\"true\">{{ language.getLabel(tab.title) }}</span>\r\n        </ng-template>\r\n        <app-slot\r\n          [items]=\"tab.components\"\r\n          [componentValue]=\"tab.dataObject | getArrayPath: tab.path\"\r\n          [parentComponent]=\"selfRef\"\r\n        ></app-slot>\r\n      </mat-tab>\r\n    </ng-container>\r\n  </mat-tab-group>\r\n  <div class=\"row pb-1\" *ngIf=\"data.singleSubmit\">\r\n    <div class=\"col text-center\">\r\n      <app-button [data]=\"button\" *ngFor=\"let button of buttons\"></app-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".mat-elevation-z8{margin-top:15px}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }, { type: i0.ChangeDetectorRef }, { type: i3.Location }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class TabbedModule {
    constructor(routing) {
        routing.mapComponent('TabbedComponent', TabbedComponent);
    }
}
TabbedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TabbedModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
TabbedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TabbedModule, declarations: [TabbedComponent], imports: [CommonModule,
        SlotModule,
        PipesModule,
        PrimitiveModule,
        MatTabsModule,
        MatBadgeModule] });
TabbedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TabbedModule, imports: [CommonModule,
        SlotModule,
        PipesModule,
        PrimitiveModule,
        MatTabsModule,
        MatBadgeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TabbedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TabbedComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule,
                        PrimitiveModule,
                        MatTabsModule,
                        MatBadgeModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var tabbed_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   TabbedModule: TabbedModule
});

class ToastModule {
}
ToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ToastModule, declarations: [ToastComponent], imports: [CommonModule,
        MatSnackBarModule,
        MatButtonModule,
        MatIconModule] });
ToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ToastModule, imports: [CommonModule,
        MatSnackBarModule,
        MatButtonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ToastComponent
                    ],
                    imports: [
                        CommonModule,
                        MatSnackBarModule,
                        MatButtonModule,
                        MatIconModule
                    ]
                }]
        }] });

class ProgressCircleComponent {
    constructor(language, arrayPathService) {
        this.language = language;
        this.arrayPathService = arrayPathService;
        this.percent = 0;
        this.progress = [-90, 0];
        this.showPercent = true;
    }
    ngOnInit() {
        if (typeof this.data.showPercent !== 'undefined') {
            this.showPercent = this.data.showPercent;
        }
        if (typeof this.data.currentPath !== 'undefined') {
            this.data.current = this.arrayPathService.get(this.data.dataObject, this.data.currentPath);
        }
        this.percent = this.data.current / this.data.max * 100;
    }
}
ProgressCircleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleComponent, deps: [{ token: LanguageService }, { token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Component });
ProgressCircleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ProgressCircleComponent, selector: "app-progress-circle", inputs: { data: "data" }, ngImport: i0, template: "<div class=\"complete-circle\">\r\n  <div class=\"inner-circle\">\r\n    <span *ngIf=\"showPercent && !data.label\">\r\n      {{ percent }}%\r\n    </span>\r\n    <span *ngIf=\"!showPercent && data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </span>\r\n    <div class=\"spinner\">\r\n      <mat-progress-spinner\r\n        [value]=\"percent\"\r\n        [mode]=\"data.mode\"\r\n        [strokeWidth]=\"data.strokeWidth\"\r\n      ></mat-progress-spinner>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host .complete-circle{width:100%;width:var(--progress-circle-width, 100%);height:100%;height:var(--progress-circle-height, 100%);border:1px solid var(--primary-lighter-color);border-radius:50%}:host .complete-circle .inner-circle{width:100%;height:100%;position:relative}:host .complete-circle .inner-circle span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:10}:host .complete-circle .inner-circle .spinner{position:absolute;width:100%;width:var(--progress-circle-width, 100%);height:100%;height:var(--progress-circle-height, 100%);inset:0;z-index:5}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner{width:100%!important;height:100%!important}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner svg{width:100%!important;width:var(--progress-circle-width, 100%)!important;height:100%!important;height:var(--progress-circle-height, 100%)!important}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner circle{stroke:var(--progress-circle-outer)}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-progress-circle', template: "<div class=\"complete-circle\">\r\n  <div class=\"inner-circle\">\r\n    <span *ngIf=\"showPercent && !data.label\">\r\n      {{ percent }}%\r\n    </span>\r\n    <span *ngIf=\"!showPercent && data.label\">\r\n      {{ language.getLabel(data.label) }}\r\n    </span>\r\n    <div class=\"spinner\">\r\n      <mat-progress-spinner\r\n        [value]=\"percent\"\r\n        [mode]=\"data.mode\"\r\n        [strokeWidth]=\"data.strokeWidth\"\r\n      ></mat-progress-spinner>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host .complete-circle{width:100%;width:var(--progress-circle-width, 100%);height:100%;height:var(--progress-circle-height, 100%);border:1px solid var(--primary-lighter-color);border-radius:50%}:host .complete-circle .inner-circle{width:100%;height:100%;position:relative}:host .complete-circle .inner-circle span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:10}:host .complete-circle .inner-circle .spinner{position:absolute;width:100%;width:var(--progress-circle-width, 100%);height:100%;height:var(--progress-circle-height, 100%);inset:0;z-index:5}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner{width:100%!important;height:100%!important}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner svg{width:100%!important;width:var(--progress-circle-width, 100%)!important;height:100%!important;height:var(--progress-circle-height, 100%)!important}:host .complete-circle .inner-circle .spinner ::ng-deep .mat-progress-spinner circle{stroke:var(--progress-circle-outer)}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class ProgressCircleModule {
    constructor(routing) {
        routing.mapComponent('ProgressCircleComponent', ProgressCircleComponent);
    }
}
ProgressCircleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
ProgressCircleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleModule, declarations: [ProgressCircleComponent], imports: [CommonModule,
        MatProgressSpinnerModule], exports: [ProgressCircleComponent] });
ProgressCircleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleModule, imports: [CommonModule,
        MatProgressSpinnerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressCircleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ProgressCircleComponent
                    ],
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [
                        ProgressCircleComponent
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var progressCircle_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   ProgressCircleModule: ProgressCircleModule
});

class PinComponent {
    constructor(comm, language) {
        this.comm = comm;
        this.language = language;
        /** Subject that emits when the component has been destroyed. */
        this.destroyed = new Subject();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        if (typeof this.parentForm !== 'undefined') {
            this.formControl = this.parentForm.get(String(this.data.name));
        }
        else {
            this.formControl = new FormControl();
        }
        if (typeof this.data.channel !== 'undefined') {
            this.comm.getChannel(this.data.channel)
                .pipe(takeUntil$1(this.destroyed))
                .subscribe((message) => this.comm.processMessage(message, this));
        }
        this.digits = Array.from({ length: this.data.pinLength }, (_, i) => i);
        this.data.value = Array(this.data.pinLength).fill('');
    }
    /** Function to set the pin length from outside */
    setPinLength(length) {
        this.data.pinLength = length;
        this.digits = Array.from({ length: this.data.pinLength }, (_, i) => i);
        this.data.value = Array(this.data.pinLength).fill('');
    }
    onInput(event, index) {
        if (typeof this.data.onInput === 'function') {
            if (!this.data.onInputParams) {
                this.data.onInputParams = {};
            }
            this.data.onInputParams.event = 'onInput';
            this.data.onInputParams.value = this.formControl.value;
            const result = this.data.onInput(this.data.onInputParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
        const inputElement = event.target;
        const inputValue = inputElement.value;
        const isDigit = /^\d$/.test(inputValue);
        /** if the input has value and pressing some number, replace current value whit the new one.  */
        if (inputValue.length > 1) {
            const lastChar = inputValue[inputValue.length - 1];
            const isLastCharDigit = /^\d$/.test(lastChar);
            if (isLastCharDigit) {
                inputElement.value = lastChar;
                this.data.value.splice(index, 1, lastChar);
                this.focusNextInput(inputElement);
            }
            return;
        }
        if (!isDigit) {
            inputElement.value = '';
            return;
        }
        this.data.value.splice(index, 1, inputValue);
        if (index < this.data.pinLength - 1) {
            this.focusNextInput(inputElement);
        }
        else {
            this.formControl.setValue(this.data.value.join(''));
            if (typeof this.data.inputFinished === 'function') {
                if (!this.data.inputFinishedParams) {
                    this.data.inputFinishedParams = {};
                }
                this.data.inputFinishedParams.event = 'inputFinished';
                this.data.inputFinishedParams.value = this.formControl.value;
                const result = this.data.inputFinished(this.data.inputFinishedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            }
        }
    }
    onKeyDown(event, index) {
        const inputElement = event.target;
        const inputValue = inputElement.value;
        const currentInput = this.digitInput.nativeElement.parentElement.children[index];
        // if the user is trying to delete
        if (event.keyCode === 8 || event.keyCode === 46) {
            if (inputValue === '') {
                this.focusPreviousInput(currentInput);
            }
            else {
                this.data.value.splice(index, 1, '');
                this.formControl.setValue(this.data.value.join(''));
            }
        }
    }
    onFocus(event, index) {
        event.preventDefault();
    }
    focusNextInput(inputElement) {
        const nextInput = inputElement.nextElementSibling;
        if (nextInput) {
            nextInput.focus();
        }
    }
    focusPreviousInput(inputElement) {
        const previousInput = inputElement.previousElementSibling;
        if (previousInput) {
            previousInput.focus();
        }
    }
    resetPin() {
        this.inputs.forEach(input => {
            input.nativeElement.value = '';
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
PinComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PinComponent, deps: [{ token: CommunicationService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
PinComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PinComponent, selector: "app-pin", inputs: { data: "data", parentForm: "parentForm" }, viewQueries: [{ propertyName: "digitInput", first: true, predicate: ["digitInput"], descendants: true }, { propertyName: "inputs", predicate: ["digitInput"], descendants: true }], ngImport: i0, template: "\r\n<div [class]=\"data.class\" appearance=\"fill\">\r\n  <input\r\n    #digitInput\r\n    *ngFor=\"let digit of digits; let i = index\"\r\n    [type]=\"data.inputType\"\r\n    (focus)=\"onFocus($event, i)\"\r\n    (input)=\"onInput($event, i)\"\r\n    (keydown)=\"onKeyDown($event, i)\"\r\n    name=\"no-name\"\r\n    inputmode=\"numeric\"\r\n    [attr.maxlength]=\"1\"\r\n  />\r\n</div>\r\n", styles: ["div{display:flex;gap:5px}div input{width:30px;text-align:center;font-size:16px;border:1px solid #ccc;padding:5px}div input::-webkit-outer-spin-button,div input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}div input[type=number]{-moz-appearance:textfield}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PinComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-pin', template: "\r\n<div [class]=\"data.class\" appearance=\"fill\">\r\n  <input\r\n    #digitInput\r\n    *ngFor=\"let digit of digits; let i = index\"\r\n    [type]=\"data.inputType\"\r\n    (focus)=\"onFocus($event, i)\"\r\n    (input)=\"onInput($event, i)\"\r\n    (keydown)=\"onKeyDown($event, i)\"\r\n    name=\"no-name\"\r\n    inputmode=\"numeric\"\r\n    [attr.maxlength]=\"1\"\r\n  />\r\n</div>\r\n", styles: ["div{display:flex;gap:5px}div input{width:30px;text-align:center;font-size:16px;border:1px solid #ccc;padding:5px}div input::-webkit-outer-spin-button,div input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}div input[type=number]{-moz-appearance:textfield}\n"] }]
        }], ctorParameters: function () { return [{ type: CommunicationService }, { type: LanguageService }]; }, propDecorators: { data: [{
                type: Input
            }], parentForm: [{
                type: Input
            }], digitInput: [{
                type: ViewChild,
                args: ['digitInput']
            }], inputs: [{
                type: ViewChildren,
                args: ['digitInput']
            }] } });

class PinModule {
    constructor(routing) {
        routing.mapComponent('PinComponent', PinComponent);
    }
}
PinModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PinModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
PinModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: PinModule, declarations: [PinComponent], imports: [CommonModule,
        SlotModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule] });
PinModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PinModule, imports: [CommonModule,
        SlotModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PinModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PinComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule,
                        MatInputModule,
                        MatFormFieldModule,
                        ReactiveFormsModule,
                        FormsModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var pin_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   PinModule: PinModule
});

class FacebookLoginComponent {
    constructor(language, authService, loginService, api, router, cache) {
        this.language = language;
        this.authService = authService;
        this.loginService = loginService;
        this.api = api;
        this.router = router;
        this.cache = cache;
    }
    ngOnInit() {
    }
    signInWithFB() {
        this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then(result => {
            const dataService = this.api.getService(this.data.dataSource.service);
            dataService[this.data.dataSource.method]({ authToken: result.authToken })
                .pipe(take(1))
                .subscribe((response) => {
                // Set data in cache
                if (typeof response.result.email !== 'undefined') {
                    const userRegistration = {};
                    userRegistration.email = response.result.email;
                    userRegistration.first_name = response.result.first_name;
                    userRegistration.last_name = response.result.last_name;
                    this.cache.set('userRegistration', userRegistration);
                }
                // Redirect
                if (typeof response.result.redirect !== 'undefined') {
                    this.router.navigate([response.result.redirect]);
                }
                else {
                    this.loginService.login(response, {
                        redirect: this.data.redirectTo
                    });
                }
            });
        });
    }
}
FacebookLoginComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginComponent, deps: [{ token: LanguageService }, { token: i2$2.SocialAuthService }, { token: LoginService }, { token: ApiService }, { token: i1.Router }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Component });
FacebookLoginComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FacebookLoginComponent, selector: "app-facebook-login", inputs: { data: "data" }, ngImport: i0, template: "<app-button\r\n      class=\"fbLoginButton\"\r\n      [data]=\"data.buttonData\"\r\n      (click)=\"signInWithFB()\"\r\n    >\r\n</app-button>", styles: [""], dependencies: [{ kind: "component", type: ButtonComponent, selector: "app-button", inputs: ["data", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-facebook-login', template: "<app-button\r\n      class=\"fbLoginButton\"\r\n      [data]=\"data.buttonData\"\r\n      (click)=\"signInWithFB()\"\r\n    >\r\n</app-button>" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: i2$2.SocialAuthService }, { type: LoginService }, { type: ApiService }, { type: i1.Router }, { type: CacheService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

function fbLoginProvider(api) {
    const fbLoginOptions = {
        scope: 'email',
        return_scopes: true,
        enable_profile_selector: true
    };
    return {
        autoLogin: false,
        providers: [
            {
                id: FacebookLoginProvider.PROVIDER_ID,
                provider: new FacebookLoginProvider(api.getEnv().facebookLoginConfig.appId, fbLoginOptions)
            }
        ],
        onError: (err) => {
            console.error(err);
        }
    };
}
;
class FacebookLoginModule {
    constructor(routing) {
        routing.mapComponent('FacebookLoginComponent', FacebookLoginComponent);
    }
}
FacebookLoginModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
FacebookLoginModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginModule, declarations: [FacebookLoginComponent], imports: [CommonModule,
        SlotModule,
        MatButtonModule,
        PrimitiveModule,
        SocialLoginModule], exports: [FacebookLoginComponent] });
FacebookLoginModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginModule, providers: [
        {
            provide: 'SocialAuthServiceConfig',
            useFactory: fbLoginProvider,
            deps: [ApiService]
        }
    ], imports: [CommonModule,
        SlotModule,
        MatButtonModule,
        PrimitiveModule,
        SocialLoginModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FacebookLoginModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FacebookLoginComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        MatButtonModule,
                        PrimitiveModule,
                        SocialLoginModule
                    ],
                    providers: [
                        {
                            provide: 'SocialAuthServiceConfig',
                            useFactory: fbLoginProvider,
                            deps: [ApiService]
                        }
                    ],
                    exports: [FacebookLoginComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var facebookLogin_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   FacebookLoginModule: FacebookLoginModule
});

class GoogleLoginComponent {
    constructor(language, loginService, api, zone, router, cache) {
        this.language = language;
        this.loginService = loginService;
        this.api = api;
        this.zone = zone;
        this.router = router;
        this.cache = cache;
        this.destroyed = new Subject();
    }
    ngOnInit() {
        const signInJS = document.createElement('script');
        signInJS.async = true;
        signInJS.src = 'https://accounts.google.com/gsi/client';
        signInJS.onload = () => {
            google.accounts.id.initialize({
                client_id: this.api.getEnv().googleLoginConfig.appId,
                callback: this.handleCredentialResponse.bind(this),
                auto_select: false,
                cancel_on_tap_outside: true,
                prompt_parent_id: 'google-button',
                itp_support: true
            });
            google.accounts.id.renderButton(document.getElementById('google-button'), {
                theme: this.data.buttonData.theme,
                type: this.data.buttonData.type,
                shape: this.data.buttonData.shape,
                size: this.data.buttonData.size,
                width: this.data.buttonData.width,
                logo_alignment: this.data.buttonData.logo_alignment,
                text: this.data.buttonData.text, //signin_with, signup_with, signin, continue_with
            });
            google.accounts.id.prompt((notification) => {
            });
            this.tokenClient = google.accounts.oauth2.initTokenClient({
                client_id: this.api.getEnv().googleLoginConfig.appId,
                scope: 'email',
                prompt: '',
                callback: (tokenResponse) => {
                    if (!tokenResponse.error) {
                        this.zone.run(() => this.login(tokenResponse));
                    }
                    else {
                        console.log(tokenResponse);
                    }
                },
            });
        };
        document.head.appendChild(signInJS);
    }
    async handleCredentialResponse(response) {
        // Login response from Google.
        this.tokenClient.requestAccessToken();
    }
    login(response) {
        const dataService = this.api.getService(this.data.dataSource.service);
        dataService[this.data.dataSource.method]({ authToken: response.access_token })
            .pipe(take(1))
            .subscribe((response) => {
            // Set data in cache
            if (typeof response.result.email !== 'undefined') {
                const userRegistration = {};
                userRegistration.email = response.result.email;
                userRegistration.first_name = response.result.first_name;
                userRegistration.last_name = response.result.last_name;
                this.cache.set('userRegistration', userRegistration);
            }
            // Redirect
            if (typeof response.result.redirect !== 'undefined') {
                this.router.navigate([response.result.redirect]);
            }
            else {
                this.loginService.login(response, {
                    redirect: this.data.redirectTo
                });
            }
        });
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
GoogleLoginComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginComponent, deps: [{ token: LanguageService }, { token: LoginService }, { token: ApiService }, { token: i0.NgZone }, { token: i1.Router }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Component });
GoogleLoginComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: GoogleLoginComponent, selector: "app-google-login", inputs: { data: "data" }, ngImport: i0, template: "<div \r\n     [class]=\"data.class\" \r\n     id=\"google-button\"\r\n></div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-google-login', template: "<div \r\n     [class]=\"data.class\" \r\n     id=\"google-button\"\r\n></div>" }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: LoginService }, { type: ApiService }, { type: i0.NgZone }, { type: i1.Router }, { type: CacheService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class GoogleLoginModule {
    constructor(routing) {
        routing.mapComponent('GoogleLoginComponent', GoogleLoginComponent);
    }
}
GoogleLoginModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
GoogleLoginModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginModule, declarations: [GoogleLoginComponent], imports: [CommonModule,
        SlotModule,
        MatButtonModule,
        PrimitiveModule], exports: [GoogleLoginComponent] });
GoogleLoginModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginModule, imports: [CommonModule,
        SlotModule,
        MatButtonModule,
        PrimitiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GoogleLoginModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GoogleLoginComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        MatButtonModule,
                        PrimitiveModule
                    ],
                    exports: [GoogleLoginComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var googleLogin_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   GoogleLoginModule: GoogleLoginModule
});

class SocialSharingComponent {
    constructor(language, getArrayPath) {
        this.language = language;
        this.getArrayPath = getArrayPath;
    }
    ngOnInit() { }
}
SocialSharingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingComponent, deps: [{ token: LanguageService }, { token: GetArrayPathPipe }], target: i0.ɵɵFactoryTarget.Component });
SocialSharingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SocialSharingComponent, selector: "app-social-sharing", inputs: { data: "data" }, ngImport: i0, template: "        \r\n<share-button \r\n    *ngFor=\"let button of data.buttons\"\r\n    [button]=\"button.name\" \r\n    [theme]=\"button.theme\" \r\n    [icon]=\"button.icon\"\r\n    [text]=\"language.getLabel(button.text)\"\r\n    [class]=\"button.class\"\r\n    [showText]=\"!!button.text\"\r\n></share-button>\r\n", styles: [".sb-default .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color);--sb-border-radius: 4px;--sb-overflow: hidden}.sb-default .sb-wrapper.sb-show-icon.sb-show-text{--sb-text-padding: 0 1em 0 0}.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text{filter:none}.sb-circles-dark .sb-wrapper,.sb-circles-light .sb-wrapper{--sb-color: #fff;--sb-background: transparent;--sb-min-width: fit-content;--sb-height: fit-content;--sb-icon-size: 1.4em}.sb-circles-dark .sb-wrapper:active .sb-icon,.sb-circles-light .sb-wrapper:active .sb-icon{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.sb-circles-dark .sb-wrapper .sb-icon,.sb-circles-light .sb-wrapper .sb-icon{background-color:var(--button-color);box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;width:2.5em;min-height:2.5em;border-radius:50%;transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow .28s cubic-bezier(.4,0,.2,1)}.sb-circles-dark .sb-wrapper .sb-text,.sb-circles-light .sb-wrapper .sb-text{color:var(--button-color);font-size:.8em;margin-top:5px;border-radius:1em;width:100%;height:1.8em;line-height:1.8em;padding:0;transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow .28s cubic-bezier(.4,0,.2,1)}.sb-circles-dark .sb-wrapper .sb-content,.sb-circles-light .sb-wrapper .sb-content{align-items:center;flex-direction:column}.sb-circles-dark .sb-wrapper .sb-icon{background-color:var(--button-color)}.sb-circles-dark .sb-wrapper .sb-text,.sb-circles-light .sb-wrapper .sb-icon,.sb-circles-light .sb-wrapper .sb-text{color:var(--button-color)}.sb-circles-light .sb-wrapper .sb-icon{background:radial-gradient(ellipse farthest-corner at center,white 30%,#f2f2f2 100%)}.sb-classic-light .sb-wrapper,.sb-classic-dark .sb-wrapper{--sb-icon-size: 1.1em;--sb-border-radius: .2em}.sb-classic-light .sb-wrapper:active,.sb-classic-dark .sb-wrapper:active{--sb-box-shadow: 0 0 4px 2px rgba(0, 0, 0, .3) inset;position:relative;top:1px}.sb-classic-light .sb-wrapper .sb-icon,.sb-classic-dark .sb-wrapper .sb-icon{pointer-events:none;min-width:2em}.sb-classic-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color);--sb-border: 1px solid rgba(0, 0, 0, .2);--sb-text-shadow: 0 1px 0 rgba(0, 0, 0, .2);--sb-box-shadow: 0 0 1px 2px rgba(255, 255, 255, .2) inset, 0 1px 0 rgba(0, 0, 0, .3)}.sb-classic-dark .sb-wrapper .sb-text{background:rgba(0,0,0,.1)}.sb-classic-light .sb-wrapper{background-image:linear-gradient(to bottom,#fcfcfc,#ddd);--sb-color: var(--button-color);--sb-background: #ddd;--sb-border: 1px solid #b7b7b7;--sb-text-shadow: 0 1px 0 rgba(255, 255, 255, .8);--sb-box-shadow: 0 0 1px 1px rgba(255, 255, 255, .8) inset, 0 1px 0 rgba(0, 0, 0, .3)}.sb-classic-light .sb-wrapper:hover{background-color:#f7f7f7;background-image:linear-gradient(to bottom,white,#f7f7f7)}.sb-classic-light .sb-wrapper.sb-show-text .sb-icon{box-shadow:1px 0 #84848480,2px 0 #ffffff80}.sb-material-light .sb-wrapper,.sb-material-dark .sb-wrapper{font-family:Roboto,sans-serif;--sb-border-radius: 2px;--sb-transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow .28s cubic-bezier(.4, 0, .2, 1);--sb-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)}.sb-material-light .sb-wrapper:active,.sb-material-dark .sb-wrapper:active{--sb-box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12)}.sb-material-light .sb-wrapper.sb-show-icon.sb-show-text,.sb-material-dark .sb-wrapper.sb-show-icon.sb-show-text{--sb-padding: 0 0 0 .3em;--sb-text-padding: 0 1em 0 0}.sb-material-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color)}.sb-material-light .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff}.sb-modern-dark .sb-wrapper,.sb-modern-light .sb-wrapper{--sb-border-radius: 3px;--sb-transition: box-shadow ease-in .15s, transform ease-in .15s;--sb-box-shadow: 0 .1em .5em rgba(165, 165, 165, .6)}.sb-modern-dark .sb-wrapper:active,.sb-modern-light .sb-wrapper:active{--sb-box-shadow: 0 .4em 1em rgba(165, 165, 165, .9)}.sb-modern-dark .sb-wrapper .sb-icon,.sb-modern-light .sb-wrapper .sb-icon{min-width:2em}.sb-modern-dark .sb-wrapper.sb-show-text,.sb-modern-light .sb-wrapper.sb-show-text{padding:0}.sb-modern-dark .sb-wrapper.sb-show-text .sb-icon,.sb-modern-light .sb-wrapper.sb-show-text .sb-icon{box-shadow:1px 0 1px -1px #0000004d}.sb-modern-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color)}.sb-modern-dark .sb-wrapper .sb-text,.sb-modern-dark .sb-wrapper .sb-count{background:rgba(0,0,0,.1)}.sb-modern-dark .sb-wrapper.sb-show-text .sb-text{border-bottom-right-radius:3px;border-top-right-radius:3px}.sb-modern-light .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff}.sb-outline .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff;--sb-border-radius: .2em;--sb-border: 2px solid;--sb-transition: .3s;--sb-line-height: 1}.sb-outline .sb-wrapper:hover{--sb-color: #fff;--sb-box-shadow: inset 0 0 0 2em var(--button-color)}.sb-outline .sb-wrapper.sb-show-icon.sb-show-text{--sb-text-padding: 0 1em 0 0}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i4$4.ShareButton, selector: "share-button", inputs: ["button", "url", "title", "description", "image", "tags", "autoSetMeta", "showIcon", "showText", "text", "icon", "theme", "disabled"], outputs: ["opened", "closed"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-social-sharing', encapsulation: ViewEncapsulation.None, template: "        \r\n<share-button \r\n    *ngFor=\"let button of data.buttons\"\r\n    [button]=\"button.name\" \r\n    [theme]=\"button.theme\" \r\n    [icon]=\"button.icon\"\r\n    [text]=\"language.getLabel(button.text)\"\r\n    [class]=\"button.class\"\r\n    [showText]=\"!!button.text\"\r\n></share-button>\r\n", styles: [".sb-default .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color);--sb-border-radius: 4px;--sb-overflow: hidden}.sb-default .sb-wrapper.sb-show-icon.sb-show-text{--sb-text-padding: 0 1em 0 0}.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text{filter:none}.sb-circles-dark .sb-wrapper,.sb-circles-light .sb-wrapper{--sb-color: #fff;--sb-background: transparent;--sb-min-width: fit-content;--sb-height: fit-content;--sb-icon-size: 1.4em}.sb-circles-dark .sb-wrapper:active .sb-icon,.sb-circles-light .sb-wrapper:active .sb-icon{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.sb-circles-dark .sb-wrapper .sb-icon,.sb-circles-light .sb-wrapper .sb-icon{background-color:var(--button-color);box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;width:2.5em;min-height:2.5em;border-radius:50%;transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow .28s cubic-bezier(.4,0,.2,1)}.sb-circles-dark .sb-wrapper .sb-text,.sb-circles-light .sb-wrapper .sb-text{color:var(--button-color);font-size:.8em;margin-top:5px;border-radius:1em;width:100%;height:1.8em;line-height:1.8em;padding:0;transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow .28s cubic-bezier(.4,0,.2,1)}.sb-circles-dark .sb-wrapper .sb-content,.sb-circles-light .sb-wrapper .sb-content{align-items:center;flex-direction:column}.sb-circles-dark .sb-wrapper .sb-icon{background-color:var(--button-color)}.sb-circles-dark .sb-wrapper .sb-text,.sb-circles-light .sb-wrapper .sb-icon,.sb-circles-light .sb-wrapper .sb-text{color:var(--button-color)}.sb-circles-light .sb-wrapper .sb-icon{background:radial-gradient(ellipse farthest-corner at center,white 30%,#f2f2f2 100%)}.sb-classic-light .sb-wrapper,.sb-classic-dark .sb-wrapper{--sb-icon-size: 1.1em;--sb-border-radius: .2em}.sb-classic-light .sb-wrapper:active,.sb-classic-dark .sb-wrapper:active{--sb-box-shadow: 0 0 4px 2px rgba(0, 0, 0, .3) inset;position:relative;top:1px}.sb-classic-light .sb-wrapper .sb-icon,.sb-classic-dark .sb-wrapper .sb-icon{pointer-events:none;min-width:2em}.sb-classic-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color);--sb-border: 1px solid rgba(0, 0, 0, .2);--sb-text-shadow: 0 1px 0 rgba(0, 0, 0, .2);--sb-box-shadow: 0 0 1px 2px rgba(255, 255, 255, .2) inset, 0 1px 0 rgba(0, 0, 0, .3)}.sb-classic-dark .sb-wrapper .sb-text{background:rgba(0,0,0,.1)}.sb-classic-light .sb-wrapper{background-image:linear-gradient(to bottom,#fcfcfc,#ddd);--sb-color: var(--button-color);--sb-background: #ddd;--sb-border: 1px solid #b7b7b7;--sb-text-shadow: 0 1px 0 rgba(255, 255, 255, .8);--sb-box-shadow: 0 0 1px 1px rgba(255, 255, 255, .8) inset, 0 1px 0 rgba(0, 0, 0, .3)}.sb-classic-light .sb-wrapper:hover{background-color:#f7f7f7;background-image:linear-gradient(to bottom,white,#f7f7f7)}.sb-classic-light .sb-wrapper.sb-show-text .sb-icon{box-shadow:1px 0 #84848480,2px 0 #ffffff80}.sb-material-light .sb-wrapper,.sb-material-dark .sb-wrapper{font-family:Roboto,sans-serif;--sb-border-radius: 2px;--sb-transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow .28s cubic-bezier(.4, 0, .2, 1);--sb-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)}.sb-material-light .sb-wrapper:active,.sb-material-dark .sb-wrapper:active{--sb-box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12)}.sb-material-light .sb-wrapper.sb-show-icon.sb-show-text,.sb-material-dark .sb-wrapper.sb-show-icon.sb-show-text{--sb-padding: 0 0 0 .3em;--sb-text-padding: 0 1em 0 0}.sb-material-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color)}.sb-material-light .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff}.sb-modern-dark .sb-wrapper,.sb-modern-light .sb-wrapper{--sb-border-radius: 3px;--sb-transition: box-shadow ease-in .15s, transform ease-in .15s;--sb-box-shadow: 0 .1em .5em rgba(165, 165, 165, .6)}.sb-modern-dark .sb-wrapper:active,.sb-modern-light .sb-wrapper:active{--sb-box-shadow: 0 .4em 1em rgba(165, 165, 165, .9)}.sb-modern-dark .sb-wrapper .sb-icon,.sb-modern-light .sb-wrapper .sb-icon{min-width:2em}.sb-modern-dark .sb-wrapper.sb-show-text,.sb-modern-light .sb-wrapper.sb-show-text{padding:0}.sb-modern-dark .sb-wrapper.sb-show-text .sb-icon,.sb-modern-light .sb-wrapper.sb-show-text .sb-icon{box-shadow:1px 0 1px -1px #0000004d}.sb-modern-dark .sb-wrapper{--sb-color: #fff;--sb-background: var(--button-color)}.sb-modern-dark .sb-wrapper .sb-text,.sb-modern-dark .sb-wrapper .sb-count{background:rgba(0,0,0,.1)}.sb-modern-dark .sb-wrapper.sb-show-text .sb-text{border-bottom-right-radius:3px;border-top-right-radius:3px}.sb-modern-light .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff}.sb-outline .sb-wrapper{--sb-color: var(--button-color);--sb-background: #fff;--sb-border-radius: .2em;--sb-border: 2px solid;--sb-transition: .3s;--sb-line-height: 1}.sb-outline .sb-wrapper:hover{--sb-color: #fff;--sb-box-shadow: inset 0 0 0 2em var(--button-color)}.sb-outline .sb-wrapper.sb-show-icon.sb-show-text{--sb-text-padding: 0 1em 0 0}\n"] }]
        }], ctorParameters: function () { return [{ type: LanguageService }, { type: GetArrayPathPipe }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class SocialSharingModule {
    constructor(routing) {
        routing.mapComponent('SocialSharingComponent', SocialSharingComponent);
    }
}
SocialSharingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
SocialSharingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingModule, declarations: [SocialSharingComponent], imports: [CommonModule,
        SlotModule,
        ShareButtonModule,
        ShareButtonsModule,
        ShareIconsModule,
        PipesModule], exports: [SocialSharingComponent] });
SocialSharingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingModule, imports: [CommonModule,
        SlotModule,
        ShareButtonModule,
        ShareButtonsModule,
        ShareIconsModule,
        PipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SocialSharingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SocialSharingComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        ShareButtonModule,
                        ShareButtonsModule,
                        ShareIconsModule,
                        PipesModule
                    ],
                    exports: [SocialSharingComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var socialSharing_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   SocialSharingModule: SocialSharingModule
});

class RemoteSlotComponent extends BaseComponent {
    constructor(route) {
        super();
        this.route = route;
        this.items = [];
    }
    ngOnInit() {
        super.ngOnInit();
        this.bindScrollTop();
        if (this.data.reloadsWithUrl) {
            // Trigger load if query params or url param has been changed
            combineLatest([
                this.route.queryParams.pipe(startWith(null)),
                this.route.params.pipe(startWith(null))
            ]).pipe(takeUntil(this.destroyed), debounceTime(0)).subscribe((params) => {
                const urlParams = JSON.parse(JSON.stringify(params));
                if (this.urlParams
                    && JSON.stringify(this.urlParams) !== JSON.stringify(urlParams)) {
                    super.load(this.setSlotConfig.bind(this));
                }
                this.urlParams = urlParams;
            });
        }
        super.load(this.setSlotConfig.bind(this));
    }
    load(params) {
        super.load(undefined, undefined, params);
    }
    setSlotConfig(response) {
        if (typeof response.slotConfig !== 'undefined') {
            this.resetChannels(new Set([this.data.channel]));
            this.data = Object.assign(this.data, response.slotConfig);
            if (typeof response.slotConfig.channel !== 'undefined') {
                this.subscribeToCommChannel();
            }
        }
    }
}
RemoteSlotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotComponent, deps: [{ token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
RemoteSlotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: RemoteSlotComponent, selector: "app-remote-slot", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<app-slot\r\n    *ngIf=\"data.dataObject\"\r\n    [items]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n></app-slot>", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-remote-slot', template: "<app-slot\r\n    *ngIf=\"data.dataObject\"\r\n    [items]=\"data.dataObject\"\r\n    [detectChanges]=\"true\"\r\n></app-slot>" }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class RemoteSlotModule {
    constructor(routing) {
        routing.mapComponent('RemoteSlotComponent', RemoteSlotComponent);
    }
}
RemoteSlotModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
RemoteSlotModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotModule, declarations: [RemoteSlotComponent], imports: [CommonModule,
        SlotModule], exports: [RemoteSlotComponent] });
RemoteSlotModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotModule, imports: [CommonModule,
        SlotModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RemoteSlotModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RemoteSlotComponent],
                    imports: [
                        CommonModule,
                        SlotModule
                    ],
                    exports: [
                        RemoteSlotComponent
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var remoteSlot_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   RemoteSlotModule: RemoteSlotModule
});

class MenuNodeComponent extends BaseComponent {
    constructor() {
        super();
        this.opened = false;
    }
    ngOnInit() {
    }
    closeMenu() {
        this.opened = false;
    }
    toggle() {
        if (!this.opened) {
            this.opened = true;
        }
        else {
            this.opened = false;
        }
    }
}
MenuNodeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuNodeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MenuNodeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MenuNodeComponent, selector: "app-menu-node", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"data.children.length > 0\">\r\n  <ul class=\"dropdownMenu ul-level-{{data.depth + 2}}\"  [ngClass]=\"{'d-flex': opened}\">\r\n    <li *ngFor=\"let item of data.children\" class=\"li-level-{{ data.depth + 2 }}\">\r\n      <span class=\"mainMenuImage\" *ngIf=\"data.imagePath\">\r\n        <img\r\n          *ngIf=\"(item | getArrayPath: data.imagePath) && !(item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n          class=\"mw-100\"\r\n          [src]=\"item | getArrayPath: data.imagePath\">\r\n        <app-html\r\n          *ngIf=\"(item | getArrayPath: data.imagePath) && (item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n          [data]=\"{ dataObject: item.svg }\">\r\n        </app-html>\r\n      </span>\r\n      <ng-container *ngIf=\"!getRouterLink(item).startsWith('#')\">\r\n        <a [routerLink]=\"getRouterLink(item)\">\r\n          <p>{{item.title}}</p>\r\n        </a>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"getRouterLink(item).startsWith('#')\">\r\n        <a (click)=\"scroll.scrollToElement(item.url); closeMenu()\">\r\n          <p>{{item.title}}</p>\r\n        </a>\r\n      </ng-container>\r\n      <app-menu-node \r\n        [data]=\"{\r\n          link: data.link, \r\n          title: item.title, \r\n          children: item.children, \r\n          url: item.url,\r\n          depth: item.depth,\r\n          imagePath: item.imagePath,\r\n          svg: item.svg\r\n        }\">\r\n      </app-menu-node>\r\n    </li>\r\n  </ul>\r\n</ng-container>", styles: [".mainMenu{display:flex;list-style:none;padding:0;margin:0}.dropdownMenu{display:none;list-style:none;padding:0;margin:0;transition:all 1s ease-in-out}.li-level-1:hover ::ng-deep .dropdownMenu{display:block!important;position:absolute;z-index:50}@media screen and (max-width: 769px){.mainMenu{display:none;flex-direction:column;position:absolute}}@media screen and (min-width: 770px){.burg{display:none}}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: HtmlComponent, selector: "app-html", inputs: ["data"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: MenuNodeComponent, selector: "app-menu-node", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MenuNodeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-menu-node', template: "<ng-container *ngIf=\"data.children.length > 0\">\r\n  <ul class=\"dropdownMenu ul-level-{{data.depth + 2}}\"  [ngClass]=\"{'d-flex': opened}\">\r\n    <li *ngFor=\"let item of data.children\" class=\"li-level-{{ data.depth + 2 }}\">\r\n      <span class=\"mainMenuImage\" *ngIf=\"data.imagePath\">\r\n        <img\r\n          *ngIf=\"(item | getArrayPath: data.imagePath) && !(item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n          class=\"mw-100\"\r\n          [src]=\"item | getArrayPath: data.imagePath\">\r\n        <app-html\r\n          *ngIf=\"(item | getArrayPath: data.imagePath) && (item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n          [data]=\"{ dataObject: item.svg }\">\r\n        </app-html>\r\n      </span>\r\n      <ng-container *ngIf=\"!getRouterLink(item).startsWith('#')\">\r\n        <a [routerLink]=\"getRouterLink(item)\">\r\n          <p>{{item.title}}</p>\r\n        </a>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"getRouterLink(item).startsWith('#')\">\r\n        <a (click)=\"scroll.scrollToElement(item.url); closeMenu()\">\r\n          <p>{{item.title}}</p>\r\n        </a>\r\n      </ng-container>\r\n      <app-menu-node \r\n        [data]=\"{\r\n          link: data.link, \r\n          title: item.title, \r\n          children: item.children, \r\n          url: item.url,\r\n          depth: item.depth,\r\n          imagePath: item.imagePath,\r\n          svg: item.svg\r\n        }\">\r\n      </app-menu-node>\r\n    </li>\r\n  </ul>\r\n</ng-container>", styles: [".mainMenu{display:flex;list-style:none;padding:0;margin:0}.dropdownMenu{display:none;list-style:none;padding:0;margin:0;transition:all 1s ease-in-out}.li-level-1:hover ::ng-deep .dropdownMenu{display:block!important;position:absolute;z-index:50}@media screen and (max-width: 769px){.mainMenu{display:none;flex-direction:column;position:absolute}}@media screen and (min-width: 770px){.burg{display:none}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class NestedMenuComponent extends BaseComponent {
    constructor() {
        super();
        this.opened = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.load();
    }
    closeMenu() {
        this.opened = false;
    }
    toggle() {
        if (!this.opened) {
            this.opened = true;
        }
        else {
            this.opened = false;
        }
    }
}
NestedMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NestedMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: NestedMenuComponent, selector: "app-nested-menu", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: "<nav>\r\n  <ul *ngIf=\"data.dataObject\" class=\"mainMenu ul-level-1\" [ngClass]=\"{'d-flex': opened}\">\r\n    <ng-container *ngFor=\"let item of data.dataObject.items\">\r\n      <li class=\"li-level-1 px-2\">\r\n        <span class=\"mainMenuImage\" *ngIf=\"data.imagePath\">\r\n          <img\r\n            *ngIf=\"(item | getArrayPath: data.imagePath) && !(item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n            class=\"mw-100\"\r\n            [src]=\"item | getArrayPath: data.imagePath\">\r\n          <app-html\r\n            *ngIf=\"(item | getArrayPath: data.imagePath) && (item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n            [data]=\"{ dataObject: item.svg }\">\r\n          </app-html>\r\n        </span>\r\n        <ng-container *ngIf=\"!getRouterLink(item).startsWith('#')\">\r\n          <a [routerLink]=\"getRouterLink(item)\">\r\n            <p>{{item.title}}</p>\r\n          </a>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"getRouterLink(item).startsWith('#')\">\r\n          <a (click)=\"scroll.scrollToElement(item.url); closeMenu()\">\r\n            <p>{{item.title}}</p>\r\n          </a>\r\n        </ng-container>\r\n        <app-menu-node \r\n          [data]=\"{\r\n            link: data.link, \r\n            title: item.title, \r\n            children: item.children,\r\n            url: item.url,\r\n            depth: item.depth,\r\n            imagePath: item.imagePath,\r\n            svg: item.svg\r\n          }\"></app-menu-node>\r\n      </li>\r\n    </ng-container>\r\n  </ul>\r\n</nav>\r\n<a mat-icon-button (click)=\"toggle()\" class=\"burg\">\r\n  <mat-icon>menu</mat-icon>\r\n</a>", styles: [".mainMenu{display:flex;list-style:none;padding:0;margin:0}.dropdownMenu{display:none;list-style:none;padding:0;margin:0;transition:all 1s ease-in-out}.li-level-1:hover ::ng-deep .dropdownMenu{display:block!important;position:absolute;z-index:50}@media screen and (max-width: 769px){.mainMenu{display:none;flex-direction:column;position:absolute}}@media screen and (min-width: 770px){.burg{display:none}}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i1$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: HtmlComponent, selector: "app-html", inputs: ["data"] }, { kind: "directive", type: CustomRouterLinkDirective, selector: "[routerLink]" }, { kind: "component", type: MenuNodeComponent, selector: "app-menu-node", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-nested-menu', template: "<nav>\r\n  <ul *ngIf=\"data.dataObject\" class=\"mainMenu ul-level-1\" [ngClass]=\"{'d-flex': opened}\">\r\n    <ng-container *ngFor=\"let item of data.dataObject.items\">\r\n      <li class=\"li-level-1 px-2\">\r\n        <span class=\"mainMenuImage\" *ngIf=\"data.imagePath\">\r\n          <img\r\n            *ngIf=\"(item | getArrayPath: data.imagePath) && !(item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n            class=\"mw-100\"\r\n            [src]=\"item | getArrayPath: data.imagePath\">\r\n          <app-html\r\n            *ngIf=\"(item | getArrayPath: data.imagePath) && (item | getArrayPath: data.imagePath).endsWith('svg')\"\r\n            [data]=\"{ dataObject: item.svg }\">\r\n          </app-html>\r\n        </span>\r\n        <ng-container *ngIf=\"!getRouterLink(item).startsWith('#')\">\r\n          <a [routerLink]=\"getRouterLink(item)\">\r\n            <p>{{item.title}}</p>\r\n          </a>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"getRouterLink(item).startsWith('#')\">\r\n          <a (click)=\"scroll.scrollToElement(item.url); closeMenu()\">\r\n            <p>{{item.title}}</p>\r\n          </a>\r\n        </ng-container>\r\n        <app-menu-node \r\n          [data]=\"{\r\n            link: data.link, \r\n            title: item.title, \r\n            children: item.children,\r\n            url: item.url,\r\n            depth: item.depth,\r\n            imagePath: item.imagePath,\r\n            svg: item.svg\r\n          }\"></app-menu-node>\r\n      </li>\r\n    </ng-container>\r\n  </ul>\r\n</nav>\r\n<a mat-icon-button (click)=\"toggle()\" class=\"burg\">\r\n  <mat-icon>menu</mat-icon>\r\n</a>", styles: [".mainMenu{display:flex;list-style:none;padding:0;margin:0}.dropdownMenu{display:none;list-style:none;padding:0;margin:0;transition:all 1s ease-in-out}.li-level-1:hover ::ng-deep .dropdownMenu{display:block!important;position:absolute;z-index:50}@media screen and (max-width: 769px){.mainMenu{display:none;flex-direction:column;position:absolute}}@media screen and (min-width: 770px){.burg{display:none}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class NestedMenuModule {
    constructor(routing) {
        routing.mapComponent('NestedMenuComponent', NestedMenuComponent);
    }
}
NestedMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
NestedMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuModule, declarations: [NestedMenuComponent,
        MenuNodeComponent], imports: [CommonModule,
        RouterModule,
        MatIconModule,
        PrimitiveModule,
        PipesModule,
        CustomRouterLinkDirective] });
NestedMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuModule, imports: [CommonModule,
        RouterModule,
        MatIconModule,
        PrimitiveModule,
        PipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NestedMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NestedMenuComponent,
                        MenuNodeComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        MatIconModule,
                        PrimitiveModule,
                        PipesModule,
                        CustomRouterLinkDirective
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var nestedMenu_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   NestedMenuModule: NestedMenuModule
});

class TimeLineComponent {
    constructor(api, language, elementRef, breakpointObserver) {
        this.api = api;
        this.language = language;
        this.elementRef = elementRef;
        this.breakpointObserver = breakpointObserver;
        this.direction = 'vertical';
        this.isMobile = false;
    }
    ngOnInit() {
        this.sizeObserver = this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge
        ]);
        this.sizeObserver
            .pipe(take$1(1)).subscribe(size => {
            // (max-width: 599.98px)
            if (size.breakpoints[Breakpoints.XSmall]) {
                this.data.direction = 'vertical';
            }
        });
        if (typeof this.data.dataSource !== 'undefined') {
            this.load();
        }
        if (typeof this.data.direction !== 'undefined') {
            this.direction = this.data.direction;
        }
    }
    load() {
        this.api.callServiceMethod(this.data.dataSource)
            .pipe(take$1(1))
            .subscribe((response) => {
            this.data.dataObject = response.result.data;
        });
    }
    // Method to handle mouse wheel scroll
    onScroll(event) {
        if (this.direction == 'horizontal') {
            const container = this.elementRef.nativeElement.querySelector('.scroll-wrapper');
            const isEndOfContainer = container.scrollLeft + container.clientWidth === container.scrollWidth;
            const isStartOfContainer = container.scrollLeft === 0;
            const scrollAmount = event.deltaY > 0 ? 10 : -10; // Adjust the scroll amount as needed
            container.scrollLeft += scrollAmount;
            if (isEndOfContainer && event.deltaY > 0 ||
                isStartOfContainer && event.deltaY < 0) {
                window.scrollBy(0, scrollAmount);
            }
            else {
                container.scrollLeft += scrollAmount;
                event.preventDefault();
            }
        }
    }
    // Method to stop scrolling
    stopScrolling() {
        clearInterval(this.scrollInterval);
    }
    // Additional method to stop scrolling when the component is destroyed
    ngOnDestroy() {
        this.stopScrolling();
        this.breakpointObserver.ngOnDestroy();
    }
}
TimeLineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimeLineComponent, deps: [{ token: ApiService }, { token: LanguageService }, { token: i0.ElementRef }, { token: i6$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component });
TimeLineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TimeLineComponent, selector: "app-time-line", inputs: { data: "data" }, host: { listeners: { "wheel": "onScroll($event)" } }, ngImport: i0, template: "<div [class]=\"data.class\" *ngIf=\"data.direction == 'vertical'\">\r\n  <div *ngFor=\"let item of data.dataObject; let i = index\">\r\n    <div class=\"container\" [ngClass]=\"{ left: i % 2 !== 0, right: i % 2 == 0 }\">\r\n      <div class=\"content\">\r\n        <div *ngIf=\"data.titlePath\" class=\"h2\">\r\n          {{ item | getArrayPath : data.titlePath }}\r\n        </div>\r\n        <app-html\r\n          *ngIf=\"data.textPath\"\r\n          [data]=\"{\r\n            class: 'text',\r\n            dataObject: item | getArrayPath : data.textPath\r\n          }\"\r\n        >\r\n        </app-html>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"item | getArrayPath : data.path\"\r\n        ></app-slot>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div [class]=\"data.class\" *ngIf=\"data.direction == 'horizontal'\">\r\n  <div class=\"scroll-wrapper\" (wheel)=\"onScroll($event)\" (mouseout)=\"stopScrolling()\">\r\n    <div *ngFor=\"let item of data.dataObject; let i = index\">\r\n      <div class=\"container\" [ngClass]=\"{ top: i % 2 !== 0, down: i % 2 == 0 }\">\r\n        <div class=\"content\">\r\n          <div *ngIf=\"data.titlePath\" class=\"h2\">\r\n            {{ item | getArrayPath : data.titlePath }}\r\n          </div>\r\n          <app-html\r\n            *ngIf=\"data.textPath\"\r\n            [data]=\"{\r\n              class: 'text',\r\n              dataObject: item | getArrayPath : data.textPath\r\n            }\"\r\n          >\r\n          </app-html>\r\n          <app-slot\r\n            *ngIf=\"data.components\"\r\n            [items]=\"data.components\"\r\n            [componentValue]=\"item | getArrayPath : data.path\"\r\n          ></app-slot>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }, { kind: "component", type: HtmlComponent, selector: "app-html", inputs: ["data"] }, { kind: "pipe", type: GetArrayPathPipe, name: "getArrayPath" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimeLineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-time-line', template: "<div [class]=\"data.class\" *ngIf=\"data.direction == 'vertical'\">\r\n  <div *ngFor=\"let item of data.dataObject; let i = index\">\r\n    <div class=\"container\" [ngClass]=\"{ left: i % 2 !== 0, right: i % 2 == 0 }\">\r\n      <div class=\"content\">\r\n        <div *ngIf=\"data.titlePath\" class=\"h2\">\r\n          {{ item | getArrayPath : data.titlePath }}\r\n        </div>\r\n        <app-html\r\n          *ngIf=\"data.textPath\"\r\n          [data]=\"{\r\n            class: 'text',\r\n            dataObject: item | getArrayPath : data.textPath\r\n          }\"\r\n        >\r\n        </app-html>\r\n        <app-slot\r\n          *ngIf=\"data.components\"\r\n          [items]=\"data.components\"\r\n          [componentValue]=\"item | getArrayPath : data.path\"\r\n        ></app-slot>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div [class]=\"data.class\" *ngIf=\"data.direction == 'horizontal'\">\r\n  <div class=\"scroll-wrapper\" (wheel)=\"onScroll($event)\" (mouseout)=\"stopScrolling()\">\r\n    <div *ngFor=\"let item of data.dataObject; let i = index\">\r\n      <div class=\"container\" [ngClass]=\"{ top: i % 2 !== 0, down: i % 2 == 0 }\">\r\n        <div class=\"content\">\r\n          <div *ngIf=\"data.titlePath\" class=\"h2\">\r\n            {{ item | getArrayPath : data.titlePath }}\r\n          </div>\r\n          <app-html\r\n            *ngIf=\"data.textPath\"\r\n            [data]=\"{\r\n              class: 'text',\r\n              dataObject: item | getArrayPath : data.textPath\r\n            }\"\r\n          >\r\n          </app-html>\r\n          <app-slot\r\n            *ngIf=\"data.components\"\r\n            [items]=\"data.components\"\r\n            [componentValue]=\"item | getArrayPath : data.path\"\r\n          ></app-slot>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: ApiService }, { type: LanguageService }, { type: i0.ElementRef }, { type: i6$2.BreakpointObserver }]; }, propDecorators: { data: [{
                type: Input
            }], onScroll: [{
                type: HostListener,
                args: ['wheel', ['$event']]
            }] } });

class TimeLineModule {
    constructor(routing) {
        routing.mapComponent('TimeLineComponent', TimeLineComponent);
    }
}
TimeLineModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimeLineModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
TimeLineModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TimeLineModule, declarations: [TimeLineComponent], imports: [CommonModule,
        SlotModule,
        PipesModule,
        PrimitiveModule,
        MatTabsModule,
        MatBadgeModule] });
TimeLineModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimeLineModule, imports: [CommonModule,
        SlotModule,
        PipesModule,
        PrimitiveModule,
        MatTabsModule,
        MatBadgeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TimeLineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TimeLineComponent],
                    imports: [
                        CommonModule,
                        SlotModule,
                        PipesModule,
                        PrimitiveModule,
                        MatTabsModule,
                        MatBadgeModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var timeLine_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   TimeLineModule: TimeLineModule
});

class FetchDataComponent extends BaseComponent {
    constructor() {
        super();
    }
    ngOnInit() {
        super.ngOnInit();
        let loadedCallback;
        if (typeof this.data.loaded === 'function') {
            const that = this;
            loadedCallback = (response) => {
                let loadedParams = {
                    event: 'loaded',
                    dataObject: response.data
                };
                const result = that.data.loaded(loadedParams);
                if (result instanceof Observable) {
                    result.pipe(take(1)).subscribe();
                }
            };
        }
        this.load(loadedCallback);
    }
}
FetchDataComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FetchDataComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FetchDataComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FetchDataComponent, selector: "lib-fetch-data", inputs: { data: "data" }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FetchDataComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-fetch-data',
                    template: '',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class DataCallModule {
    constructor(routing) {
        routing.mapComponent('FetchDataComponent', FetchDataComponent);
    }
}
DataCallModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataCallModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
DataCallModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: DataCallModule, declarations: [FetchDataComponent], imports: [CommonModule] });
DataCallModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataCallModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataCallModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FetchDataComponent
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var fetchData_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   DataCallModule: DataCallModule
});

class IconPickerComponent {
    constructor() { }
    ngOnInit() {
        // TOOD figure out how to list all available material icons
        if (this.parentForm) {
            if (this.data.formGroup) {
                this.control = this.parentForm.get(this.data.formGroup).get(this.data.name);
            }
            else {
                this.control = this.parentForm.get(this.data.name);
            }
        }
        else {
            this.control = new FormControl();
        }
        if (this.data.value) {
            this.control.setValue(this.data.value);
        }
    }
}
IconPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconPickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: IconPickerComponent, selector: "lib-icon-picker", ngImport: i0, template: "<app-input\r\n  [data]=\"{\r\n    class: data.class,\r\n    name: data.name,\r\n    label: data.label,\r\n    prefixIcon: control.value,\r\n    type: 'input',\r\n    inputType: 'text',\r\n    value: data.value,\r\n    placeholder: data.placeholder\r\n  }\"\r\n  [parentForm]=\"parentForm\"></app-input>\r\n", styles: [""], dependencies: [{ kind: "component", type: InputComponent, selector: "app-input", inputs: ["data", "parentForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-icon-picker', template: "<app-input\r\n  [data]=\"{\r\n    class: data.class,\r\n    name: data.name,\r\n    label: data.label,\r\n    prefixIcon: control.value,\r\n    type: 'input',\r\n    inputType: 'text',\r\n    value: data.value,\r\n    placeholder: data.placeholder\r\n  }\"\r\n  [parentForm]=\"parentForm\"></app-input>\r\n" }]
        }], ctorParameters: function () { return []; } });

class IconPickerModule {
    constructor(routing) {
        routing.mapComponent('IconPickerComponent', IconPickerComponent);
    }
}
IconPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconPickerModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
IconPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: IconPickerModule, declarations: [IconPickerComponent], imports: [CommonModule,
        MatIconModule,
        PrimitiveModule], exports: [IconPickerComponent] });
IconPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconPickerModule, imports: [CommonModule,
        MatIconModule,
        PrimitiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IconPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        IconPickerComponent
                    ],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        PrimitiveModule
                    ],
                    exports: [IconPickerComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var iconPicker_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   IconPickerModule: IconPickerModule
});

class PullToRefreshComponent extends BaseComponent {
    constructor(chagneDetectorRef) {
        super();
        this.chagneDetectorRef = chagneDetectorRef;
        this.distance = 0;
        this.startScreenY = 0;
        this.previousX = 0;
        this.previousY = 0;
        this.destroy = new Subject();
        // tslint:disable-next-line:variable-name
        this._isEnable = true;
        this.isRefresh = false;
        this.isScrollTop = false;
        this.isOnScrollBottom = false;
        this.CIRCLE_OFFSET = 187;
        this.scrollPullPercent = 20;
        this.isPlayingAnimation = false;
        this.refresh = new EventEmitter();
        this.refreshCompleteSubject = new Subject();
        this.loadMore = new EventEmitter();
        this.isContainWrapper = false;
        this.touchstartEvent = (evt) => {
            this.onTouchStart(evt);
        };
        this.touchmoveEvent = (evt) => {
            this.onTouchMove(evt);
        };
        this.scrollEvent = (evt) => {
            this.onScroll(evt);
        };
        this.touchendEvent = (evt) => {
            this.onTouchEnd(evt);
        };
        this.isServer = isPlatformServer(this.platformId);
    }
    set targetElement(value) {
        if (!this.isServer) {
            this.removeEventListener();
            this._targetElement = value;
            this.ele = this._targetElement ?? this.wrapperElement.nativeElement;
            if (this._isEnable) {
                this.addEventListener();
            }
            else {
                this.removeEventListener();
            }
        }
    }
    set isEnable(value) {
        if (!this.isServer) {
            this._isEnable = value;
            if (this._isEnable) {
                this.addEventListener();
            }
            else {
                this.removeEventListener();
            }
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.bindScrollTop();
        this.components = this.data.components;
        this.loadingComponents = this.data.loadingComponents;
        this.channel = this.data.channel;
        this.doNotShowLoadIcon = !!this.data.doNotShowLoadIcon;
        this.class = this.data.class;
        this.disableLoader = !!this.data.disableLoader;
        this.spinnerSize = this.data.spinnerSize;
        this.spinnerColor = this.data.spinnerColor;
        this.customClass = this.data.customClass;
        this.dataObject = this.data.dataObject;
        this.distanceForRefresh = this.data.distanceForRefresh;
        this.scrollableContentClass = this.data.scrollableContentClass;
        this.refreshEvent = this.data.refreshEvent;
        this.refreshParams = this.data.refreshParams;
        if (!this.isServer) {
            this.refreshCompleteSubject.subscribe(() => {
                this.isPlayingAnimation = false;
                this.restoreWrapper();
                this.restoreLoadingbar();
            });
            this.ele = this._targetElement ?? this.contentContainer.nativeElement;
            if (this._isEnable) {
                this.addEventListener();
            }
            else {
                this.removeEventListener();
            }
            this.distanceForRefresh = +this.distanceForRefresh;
        }
    }
    ngOnDestroy() {
        this.removeEventListener();
        this.refreshCompleteSubject?.complete();
        this.destroy.next();
        this.destroy.complete();
    }
    onTouchMove($event) {
        if (this.isPlayingAnimation) {
            return;
        }
        else if (!this._isEnable) {
            return;
        }
        else if (!this.isContainWrapper) {
            return;
        }
        const currentScreenY = $event.touches[0].screenY;
        if (this.ele.scrollTop <= 0 && this.distance > 0) {
            this.isScrollTop = true;
        }
        else {
            this.isScrollTop = false;
        }
        let loadingbar;
        if (this.loadingbar) {
            loadingbar = this.loadingbar.nativeElement;
        }
        if (this.startScreenY > currentScreenY) {
            this.distance = 0;
        }
        else {
            this.distance = Math.abs(currentScreenY - this.startScreenY);
        }
        if (this.distance > this.distanceForRefresh) {
            this.distance = this.distanceForRefresh;
        }
        this.isRefresh = this.isScrollTop && this.distance >= this.distanceForRefresh;
        const contentContainerElement = this.contentContainer.nativeElement;
        if (typeof this.scrollableContentClass !== 'undefined') {
            const scrollableContent = this.contentContainer.nativeElement
                .querySelector(`.${this.scrollableContentClass}`);
            if (scrollableContent && scrollableContent.scrollTop > 0) {
                this.isPlayingAnimation = false;
                this.restoreWrapper();
                return;
            }
        }
        if (this.isScrollTop && this.distance >= 0) {
            contentContainerElement.style.transform = `translateY(${this.distance}px)`;
            if (loadingbar) {
                loadingbar.style.visibility = 'visible';
            }
        }
        else {
            this.restoreWrapper();
            if (loadingbar) {
                loadingbar.style.visibility = 'hidden';
            }
        }
        this.scrollPullPercent = (this.distance / this.distanceForRefresh) * 100;
        this.isRefresh = this.scrollPullPercent >= 100 && this.isScrollTop;
        if (this.scrollPullPercent < 0) {
            this.scrollPullPercent = 0;
        }
        this.drawCircle(this.scrollPullPercent);
    }
    onScroll($event) {
        if (!this._isEnable) {
            return;
        }
        const scrollX = this.ele.scrollLeft;
        const scrollY = this.ele.scrollTop;
        this.isOnScrollBottom = scrollY >= 0 &&
            scrollY > this.previousY &&
            this.ele.clientHeight + this.ele.scrollTop >= this.ele.scrollHeight * 0.85;
        this.previousX = scrollX;
        this.previousY = scrollY;
        if (this.isOnScrollBottom &&
            this.loadMoreFunction &&
            document.contains(this.wrapperElement.nativeElement)) {
            this.loadMoreFunction();
        }
    }
    onTouchStart($event) {
        this.chagneDetectorRef.detectChanges();
        if (this.isPlayingAnimation) {
            return;
        }
        const path = this.getParentElementList($event.target); // FIXME 'as'
        this.isContainWrapper = false;
        for (const item of path) {
            if (item === this.wrapperElement.nativeElement) {
                this.isContainWrapper = true;
                break;
            }
        }
        if (!this.isContainWrapper) {
            return;
        }
        else if (!this._isEnable) {
            return;
        }
        this.restoreWrapper();
        this.restoreLoadingbar();
        this.isRefresh = false;
        this.startScreenY = $event.touches[0].screenY;
        this.distance = 0;
    }
    onTouchEnd($event) {
        if (this.isPlayingAnimation) {
            return;
        }
        else if (!this.isContainWrapper) {
            return;
        }
        if (typeof this.scrollableContentClass !== 'undefined') {
            const scrollableContent = this.contentContainer.nativeElement
                .querySelector(`.${this.scrollableContentClass}`);
            if (scrollableContent && scrollableContent.scrollTop > 0) {
                this.isPlayingAnimation = false;
                this.restoreWrapper();
                return;
            }
        }
        if (this.isRefresh && document.contains(this.wrapperElement.nativeElement)) {
            this.refreshFunction();
        }
        else {
            this.restoreWrapper();
            this.restoreLoadingbar();
        }
    }
    restoreWrapper() {
        this.contentContainer.nativeElement.style.position = 'relative';
        this.contentContainer.nativeElement.style.transform = `translateY(0)`;
        // this.loadingbar.nativeElement.style.transform = `translateY(0px)`;
        this.hiddenLoadingbar();
    }
    hiddenLoadingbar() {
        if (this.loadingbar) {
            this.loadingbar.nativeElement.style.visibility = 'hidden';
        }
    }
    restoreLoadingbar() {
        this.scrollPullPercent = 0;
        this.drawCircle(0);
        if (this.loadingbar) {
            this.loadingbar.nativeElement.style.transform = `translateY(0)`;
        }
        this.hiddenLoadingbar();
    }
    refreshFunction() {
        this.isPlayingAnimation = true;
        this.refresh.emit(this.refreshCompleteSubject);
        if (typeof this.refreshEvent === 'function') {
            if (typeof this.refreshParams === 'undefined') {
                this.refreshParams = {};
            }
            this.refreshParams = {
                event: 'refreshEvent'
            };
            const result = this.refreshEvent(this.refreshParams);
            if (result instanceof Observable) {
                result.pipe(take(1)).subscribe();
            }
        }
    }
    loadMoreFunction() {
        this.loadMore.emit(true);
    }
    drawCircle(percentage) {
        const offset = this.CIRCLE_OFFSET - (this.CIRCLE_OFFSET * (Math.abs(percentage) / 100));
        if (this.circleSvgElement) {
            this.circleSvgElement.nativeElement.style.strokeDashoffset = `${offset}px`;
        }
    }
    getParentElementList(srcElement) {
        const parents = [];
        let elem = srcElement;
        while (elem?.parentElement && elem?.parentNode?.nodeName?.toLowerCase() !== 'body') {
            elem = elem.parentElement;
            parents.push(elem);
        }
        return parents;
    }
    addEventListener() {
        this.ele?.addEventListener('touchstart', this.touchstartEvent, false);
        this.ele?.addEventListener('touchmove', this.touchmoveEvent, false);
        this.ele?.addEventListener('touchend', this.touchendEvent, false);
        let scrollTarget;
        if (this.ele?.tagName === 'HTML') {
            scrollTarget = window;
        }
        else {
            scrollTarget = this.ele;
        }
        scrollTarget?.addEventListener('scroll', this.scrollEvent, false);
        PullToRefreshComponent.touchstartEventList.push(this.touchstartEvent);
        PullToRefreshComponent.touchmoveEventList.push(this.touchmoveEvent);
        PullToRefreshComponent.scrollEventList.push(this.scrollEvent);
        PullToRefreshComponent.touchendEventList.push(this.touchendEvent);
    }
    removeEventListener() {
        this.ele?.removeEventListener('touchstart', this.touchstartEvent);
        this.ele?.removeEventListener('touchmove', this.touchmoveEvent);
        this.ele?.removeEventListener('scroll', this.scrollEvent);
        this.ele?.removeEventListener('touchend', this.touchendEvent);
    }
    clearAllEvent() {
        PullToRefreshComponent.touchstartEventList.forEach((evt) => {
            this.ele?.removeEventListener('touchstart', evt);
        });
        PullToRefreshComponent.touchmoveEventList.forEach((evt) => {
            this.ele?.removeEventListener('touchmove', evt);
        });
        PullToRefreshComponent.scrollEventList.forEach((evt) => {
            this.ele?.removeEventListener('scroll', evt);
        });
        PullToRefreshComponent.touchendEventList.forEach((evt) => {
            this.ele?.removeEventListener('touchend', evt);
        });
    }
    areLoadingComponentsDefined() {
        return typeof this.loadingComponents !== 'undefined'
            && this.loadingComponents.length > 0;
    }
}
PullToRefreshComponent.touchstartEventList = [];
PullToRefreshComponent.touchmoveEventList = [];
PullToRefreshComponent.scrollEventList = [];
PullToRefreshComponent.touchendEventList = [];
PullToRefreshComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PullToRefreshComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PullToRefreshComponent, selector: "app-pull-to-refresh", inputs: { data: "data", targetElement: "targetElement", isEnable: "isEnable" }, outputs: { refresh: "refresh", loadMore: "loadMore" }, viewQueries: [{ propertyName: "wrapperElement", first: true, predicate: ["wrapper"], descendants: true, static: true }, { propertyName: "contentContainer", first: true, predicate: ["contentContainer"], descendants: true, static: true }, { propertyName: "loadingbar", first: true, predicate: ["loadingContainer"], descendants: true }, { propertyName: "circleSvgElement", first: true, predicate: ["circle"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #wrapper class=\"ngx-ptr-str-container\" [ngClass]=\"class\">\r\n  <div #loadingContainer class=\"ngx-ptr-loadingbar-container\" *ngIf=\"!disableLoader\">\r\n    <ng-container *ngIf=\"loadingComponents && loadingComponents.length > 0\">\r\n      <app-slot\r\n        #spinner\r\n        [style.opacity]=\"doNotShowLoadIcon ? '0' : '1'\"\r\n        [items]=\"loadingComponents\"\r\n        [componentValue]=\"dataObject\">\r\n      </app-slot>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"loadingComponents && loadingComponents.length === 0\">\r\n      <svg\r\n        #spinner\r\n        [style.opacity]=\"doNotShowLoadIcon ? '0' : '1'\"\r\n        [class.ngx-ptr-animation]=\"isPlayingAnimation\"\r\n        class=\"ngx-ptr-spinner\"\r\n        [attr.width]=\"spinnerSize\"\r\n        [attr.height]=\"spinnerSize\"\r\n        viewBox=\"0 0 66 66\"\r\n        xmlns=\"http://www.w3.org/2000/svg\">\r\n        <circle\r\n          #circle\r\n          [style.stroke]=\"spinnerColor\"\r\n          class=\"ngx-ptr-path\"\r\n          fill=\"none\"\r\n          stroke-width=\"6\"\r\n          stroke-linecap=\"round\"\r\n          cx=\"33\"\r\n          cy=\"33\"\r\n          r=\"30\"></circle>\r\n      </svg>\r\n    </ng-container>\r\n  </div>\r\n  <div\r\n    #contentContainer\r\n    class=\"ngx-ptr-content-container\"\r\n    [class.noLoader]=\"disableLoader\"\r\n    [ngClass]=\"customClass\">\r\n    <app-slot [items]=\"components\" [componentValue]=\"dataObject\"></app-slot>\r\n  </div>\r\n</div>\r\n", styles: [".ngx-ptr-str-container{display:block;width:100%;height:100%;min-height:100%;position:relative;overscroll-behavior-x:auto;overscroll-behavior-y:contain}.ngx-ptr-content-container{width:100%;display:block;position:relative;height:100%;overflow:auto;transition:transform .2s cubic-bezier(0,0,.2,1)}.ngx-ptr-loadingbar-container{margin-top:6px;transition:transform .2s ease-out;will-change:transform;transition:transform .2s cubic-bezier(0,0,.2,1);top:0;visibility:hidden;display:flex;z-index:9999;position:absolute;width:25%;text-align:center;justify-content:center}.ngx-ptr-spinner{pointer-events:none;will-change:transform;transform:rotate(-90deg)}.ngx-ptr-spinner .ngx-ptr-path{transition:all .2s ease-out;stroke-dasharray:187;stroke:#f7c223;stroke-dashoffset:187}.ngx-ptr-animation.ngx-ptr-spinner{animation:ngx-ptr-rotator 1.4s linear infinite}.ngx-ptr-animation .ngx-ptr-path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:ngx-ptr-dash 1.4s ease-in-out infinite,ngx-ptr-colors 5.6s ease-in-out infinite}@keyframes ngx-ptr-rotator{0%{transform:rotate(0)}to{transform:rotate(270deg)}}@keyframes ngx-ptr-dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46.75;transform:rotate(135deg)}to{stroke-dashoffset:187;transform:rotate(450deg)}}.noLoader{transform:translateY(0)!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlotComponent, selector: "app-slot", inputs: ["items", "detectChanges", "componentValue", "parentForm", "parentComponent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-pull-to-refresh', template: "<div #wrapper class=\"ngx-ptr-str-container\" [ngClass]=\"class\">\r\n  <div #loadingContainer class=\"ngx-ptr-loadingbar-container\" *ngIf=\"!disableLoader\">\r\n    <ng-container *ngIf=\"loadingComponents && loadingComponents.length > 0\">\r\n      <app-slot\r\n        #spinner\r\n        [style.opacity]=\"doNotShowLoadIcon ? '0' : '1'\"\r\n        [items]=\"loadingComponents\"\r\n        [componentValue]=\"dataObject\">\r\n      </app-slot>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"loadingComponents && loadingComponents.length === 0\">\r\n      <svg\r\n        #spinner\r\n        [style.opacity]=\"doNotShowLoadIcon ? '0' : '1'\"\r\n        [class.ngx-ptr-animation]=\"isPlayingAnimation\"\r\n        class=\"ngx-ptr-spinner\"\r\n        [attr.width]=\"spinnerSize\"\r\n        [attr.height]=\"spinnerSize\"\r\n        viewBox=\"0 0 66 66\"\r\n        xmlns=\"http://www.w3.org/2000/svg\">\r\n        <circle\r\n          #circle\r\n          [style.stroke]=\"spinnerColor\"\r\n          class=\"ngx-ptr-path\"\r\n          fill=\"none\"\r\n          stroke-width=\"6\"\r\n          stroke-linecap=\"round\"\r\n          cx=\"33\"\r\n          cy=\"33\"\r\n          r=\"30\"></circle>\r\n      </svg>\r\n    </ng-container>\r\n  </div>\r\n  <div\r\n    #contentContainer\r\n    class=\"ngx-ptr-content-container\"\r\n    [class.noLoader]=\"disableLoader\"\r\n    [ngClass]=\"customClass\">\r\n    <app-slot [items]=\"components\" [componentValue]=\"dataObject\"></app-slot>\r\n  </div>\r\n</div>\r\n", styles: [".ngx-ptr-str-container{display:block;width:100%;height:100%;min-height:100%;position:relative;overscroll-behavior-x:auto;overscroll-behavior-y:contain}.ngx-ptr-content-container{width:100%;display:block;position:relative;height:100%;overflow:auto;transition:transform .2s cubic-bezier(0,0,.2,1)}.ngx-ptr-loadingbar-container{margin-top:6px;transition:transform .2s ease-out;will-change:transform;transition:transform .2s cubic-bezier(0,0,.2,1);top:0;visibility:hidden;display:flex;z-index:9999;position:absolute;width:25%;text-align:center;justify-content:center}.ngx-ptr-spinner{pointer-events:none;will-change:transform;transform:rotate(-90deg)}.ngx-ptr-spinner .ngx-ptr-path{transition:all .2s ease-out;stroke-dasharray:187;stroke:#f7c223;stroke-dashoffset:187}.ngx-ptr-animation.ngx-ptr-spinner{animation:ngx-ptr-rotator 1.4s linear infinite}.ngx-ptr-animation .ngx-ptr-path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:ngx-ptr-dash 1.4s ease-in-out infinite,ngx-ptr-colors 5.6s ease-in-out infinite}@keyframes ngx-ptr-rotator{0%{transform:rotate(0)}to{transform:rotate(270deg)}}@keyframes ngx-ptr-dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46.75;transform:rotate(135deg)}to{stroke-dashoffset:187;transform:rotate(450deg)}}.noLoader{transform:translateY(0)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { data: [{
                type: Input
            }], targetElement: [{
                type: Input
            }], isEnable: [{
                type: Input
            }], wrapperElement: [{
                type: ViewChild,
                args: ['wrapper', { static: true }]
            }], contentContainer: [{
                type: ViewChild,
                args: ['contentContainer', { static: true }]
            }], loadingbar: [{
                type: ViewChild,
                args: ['loadingContainer']
            }], circleSvgElement: [{
                type: ViewChild,
                args: ['circle']
            }], refresh: [{
                type: Output
            }], loadMore: [{
                type: Output
            }] } });

class PullToRefreshModule {
    constructor(routing) {
        routing.mapComponent('PullToRefreshComponent', PullToRefreshComponent);
    }
}
PullToRefreshModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
PullToRefreshModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshModule, declarations: [PullToRefreshComponent], imports: [CommonModule,
        SlotModule], exports: [PullToRefreshComponent] });
PullToRefreshModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshModule, imports: [CommonModule,
        SlotModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PullToRefreshModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PullToRefreshComponent
                    ],
                    imports: [
                        CommonModule,
                        SlotModule
                    ],
                    exports: [PullToRefreshComponent]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var pullToRefresh_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   PullToRefreshModule: PullToRefreshModule
});

class PdfViewerComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
PdfViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PdfViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PdfViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PdfViewerComponent, selector: "app-pdf-viewer", inputs: { data: "data" }, ngImport: i0, template: "<ngx-extended-pdf-viewer\r\n  [src]=\"data.pdfSrc\"\r\n  [class]=\"data.class\"\r\n  [showSecondaryToolbarButton]=\"data.rightContextMenu\"\r\n></ngx-extended-pdf-viewer>", styles: [""], dependencies: [{ kind: "component", type: i1$5.NgxExtendedPdfViewerComponent, selector: "ngx-extended-pdf-viewer", inputs: ["customFindbarInputArea", "customToolbar", "customFindbar", "customFindbarButtons", "customPdfViewer", "customSecondaryToolbar", "customSidebar", "customThumbnail", "customFreeFloatingBar", "showFreeFloatingBar", "enableDragAndDrop", "formData", "disableForms", "pageViewMode", "scrollMode", "authorization", "httpHeaders", "contextMenuAllowed", "enablePrint", "delayFirstView", "showTextEditor", "showStampEditor", "showDrawEditor", "logLevel", "relativeCoordsOptions", "minifiedJSLibraries", "printResolution", "rotation", "src", "base64Src", "minHeight", "height", "useBrowserLocale", "forceUsingLegacyES5", "backgroundColor", "filenameForDownload", "ignoreKeyboard", "ignoreKeys", "acceptKeys", "imageResourcesPath", "localeFolderPath", "language", "listenToURL", "nameddest", "password", "replaceBrowserPrint", "showUnverifiedSignatures", "startTabindex", "showSidebarButton", "sidebarVisible", "activeSidebarView", "findbarVisible", "propertiesDialogVisible", "showFindButton", "showFindHighlightAll", "showFindMatchCase", "showFindCurrentPageOnly", "showFindPageRange", "showFindEntireWord", "showFindEntirePhrase", "showFindMatchDiacritics", "showFindFuzzySearch", "showFindResultsCount", "showFindMessages", "showPagingButtons", "showZoomButtons", "showPresentationModeButton", "showOpenFileButton", "showPrintButton", "showDownloadButton", "theme", "showToolbar", "showSecondaryToolbarButton", "showSinglePageModeButton", "showVerticalScrollButton", "showHorizontalScrollButton", "showWrappedScrollButton", "showInfiniteScrollButton", "showBookModeButton", "showRotateButton", "handTool", "showHandToolButton", "showScrollingButton", "showSpreadButton", "showPropertiesButton", "showBorders", "spread", "page", "pageLabel", "textLayer", "zoom", "zoomLevels", "maxZoom", "minZoom", "mobileFriendlyZoom"], outputs: ["formDataChange", "pageViewModeChange", "progress", "srcChange", "scrollModeChange", "afterPrint", "beforePrint", "currentZoomFactor", "rotationChange", "annotationLayerRendered", "annotationEditorLayerRendered", "xfaLayerRendered", "outlineLoaded", "attachmentsloaded", "layersloaded", "sidebarVisibleChange", "activeSidebarViewChange", "findbarVisibleChange", "propertiesDialogVisibleChange", "handToolChange", "spreadChange", "thumbnailDrawn", "pageChange", "pageLabelChange", "pagesLoaded", "pageRender", "pageRendered", "pdfDownloaded", "pdfLoaded", "pdfLoadingStarts", "pdfLoadingFailed", "textLayerRendered", "annotationEditorModeChanged", "updateFindMatchesCount", "updateFindState", "zoomChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PdfViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-pdf-viewer', template: "<ngx-extended-pdf-viewer\r\n  [src]=\"data.pdfSrc\"\r\n  [class]=\"data.class\"\r\n  [showSecondaryToolbarButton]=\"data.rightContextMenu\"\r\n></ngx-extended-pdf-viewer>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class ViewPdfModule {
    constructor(routing) {
        routing.mapComponent('PdfViewerComponent', PdfViewerComponent);
    }
}
ViewPdfModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ViewPdfModule, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
ViewPdfModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ViewPdfModule, declarations: [PdfViewerComponent], imports: [NgxExtendedPdfViewerModule] });
ViewPdfModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ViewPdfModule, imports: [NgxExtendedPdfViewerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ViewPdfModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PdfViewerComponent
                    ],
                    imports: [
                        NgxExtendedPdfViewerModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var pdfViewer_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   ViewPdfModule: ViewPdfModule
});

class FlixMediaComponent extends BaseComponent {
    constructor(getArrayPath) {
        super();
        this.getArrayPath = getArrayPath;
    }
    ngOnInit() {
        super.ngOnInit();
        this.load();
    }
    load() {
        this.flixScript = document.getElementById('flix-media');
        if (!this.flixScript) {
            this.flixScript = document.createElement('script');
            this.flixScript.setAttribute('id', 'flix-media');
            document.head.appendChild(this.flixScript);
        }
        for (let [key, value] of Object.entries(this.data.flixData)) {
            if (typeof value === 'string') {
                this.flixScript.setAttribute(key, value);
            }
            else if (Array.isArray(value)) {
                let newValue = this.getArrayPath.get(this.data.dataObject, value);
                this.flixScript.setAttribute(key, newValue);
            }
        }
    }
}
FlixMediaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaComponent, deps: [{ token: GetArrayPathService }], target: i0.ɵɵFactoryTarget.Component });
FlixMediaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FlixMediaComponent, selector: "lib-flix-media", usesInheritance: true, ngImport: i0, template: "<div id=\"flix-inpage\"></div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-flix-media', template: "<div id=\"flix-inpage\"></div>" }]
        }], ctorParameters: function () { return [{ type: GetArrayPathService }]; } });

class FlixMediaExternal {
    constructor(routing) {
        routing.mapComponent('FlixMediaComponent', FlixMediaComponent);
    }
}
FlixMediaExternal.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaExternal, deps: [{ token: RoutingService }], target: i0.ɵɵFactoryTarget.NgModule });
FlixMediaExternal.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaExternal });
FlixMediaExternal.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaExternal });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FlixMediaExternal, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: []
                }]
        }], ctorParameters: function () { return [{ type: RoutingService }]; } });

var flixMedia_module = /*#__PURE__*/Object.freeze({
   __proto__: null,
   FlixMediaExternal: FlixMediaExternal
});

/*
 * Public API Surface of ng-viv-ux
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionModule, ActionBarComponent, ActionBarModule, ActionComponent, AddressAutocompleteComponent, AddressAutocompleteModule, AlertComponent, AlertDialogComponent, AlertDialogModule, ApiService, AutocompleteComponent, BROWSER_STORAGE, BlankComponent, BreadcrumbsComponent, BreadcrumbsModule, BrowserStateInterceptor, ButtonComponent, CacheService, CardComponent, CardListComponent, CardListModule, CarouselComponent, CarouselModule, CenterHeaderMainFooterSidenavComponent, CenterScreenComponent, CenteredHeaderMainFooterComponent, ChartBarHorizontalComponent, ChartBarHorizontalStackedComponent, ChartBarLinesComponent, ChartPieComponent, ChartPolarComponent, CheckboxComponent, CkeditorComponent, ColorboxComponent, ComboChartComponent, ComboChartModule, ComboSeriesVerticalComponent, CommunicationService, CountDownModule, CountdownComponent, DataCallModule, DatepickerComponent, DaterangeComponent, DownloadComponent, DropzoneComponent, ErrorService, EventBusService, FacebookLoginComponent, FacebookLoginModule, FetchDataComponent, FlixMediaComponent, FlixMediaExternal, FormComponent, FormModule, GOOGLE_TRANSLATE_API_KEY, GalleryComponent, GalleryModule, GetQueryParamsAsObjectPipe, GoogleLoginComponent, GoogleLoginModule, GoogleTranslateService, GridListComponent, GridListModule, HeadingComponent, HorizontalLineComponent, HorizontalMenuComponent, HorizontalMenuModule, HotkeysService, HtmlComponent, IconComponent, IconPickerComponent, IconPickerModule, ImageBackgroundComponent, ImageComponent, InputComponent, JsonRpcError, LanguageService, LayoutsModule, LibrariesService, LinkComponent, LinkPipe, LoaderComponent, LoaderInterceptor, LoaderModule, LoaderService, LogoutComponent, LogoutModule, MapComponent, MapModule, MenuComponent, MenuModule, MenuNodeComponent, MenuPanelComponent, MobileMenuComponent, MobileMenuModule, MultiAutocompleteComponent, NestedMenuComponent, NestedMenuModule, OVERLAY_TOKEN, ObjectToQueryParamsPipe, OverlayComponent, OverlayModule, PdfViewerComponent, PermissionsService, PinComponent, PinModule, PrimitiveModule, ProgressBarComponent, ProgressBarModule, ProgressCircleComponent, ProgressCircleModule, PullToRefreshComponent, PullToRefreshModule, QueryPipesModule, RadiobuttonComponent, RelativeDateService, RemoteSlotComponent, RemoteSlotModule, RoutingService, SESSION_STORAGE, SelectComponent, ServerStateInterceptor, SessionService, SetupService, SidenavComponent, SidenavModule, SlideToggleComponent, SliderComponent, SliderRangeComponent, SlotComponent, SlotDialogComponent, SlotDialogModule, SlotDirective, SlotModule, SocialSharingComponent, SocialSharingModule, StateService, StepperComponent, StepperModule, StretchMenuComponent, StretchSidenavComponent, TabbedComponent, TabbedModule, TableListComponent, TableListModule, TimeLineComponent, TimeLineModule, TimepickerComponent, ToastComponent, ToastModule, TopnavComponent, TopnavModule, TreeListComponent, TreeListModule, VideoComponent, ViewPdfModule, normalizeCommonJSImport };
